
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("M3hWz", function(module, exports) {
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input. The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 *
 * This component is intended to be used for server side rendering only as
 * the event listeners for the input are attached via a HTML script tag.
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");




parcelRequire("42omo");


var $fwSxy = parcelRequire("fwSxy");


var $iSHbD = parcelRequire("iSHbD");


var $2wQTl = parcelRequire("2wQTl");


var $eSS4z = parcelRequire("eSS4z");

const $a560394ad49f84af$export$ed08cb5579938462 = ({ advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes, shouldFillContainer: shouldFillContainer })=>{
    const theme = (0, $eSS4z.useTheme)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRsearchInputWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            id: "ssr-search-input-popout-container",
            "data-ssr-placeholder": "search-input",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $l998X.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwSxy.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            dangerouslySetInnerHTML: {
                                __html: (0, $2wQTl.script)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};




const $3b55a543569211e8$export$fa4a5af93371d2d1 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eSS4z.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a560394ad49f84af$export$ed08cb5579938462), {
            ...props
        })
    });
};
module.exports["ProductSearchInputSkeletonInteractiveSSR"] = $3b55a543569211e8$export$fa4a5af93371d2d1;

});

parcelRegister("kysoj", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $9wGTI = parcelRequire("9wGTI");

const $9a64fd0ce05b42e8$export$3977b992ec7f3f3b = (inputRef)=>{
    if (!(0, $9wGTI.fg)('quickfind-ghosttext')) return undefined;
    let ghostText;
    const searchInput = inputRef?.current;
    if (typeof HTMLInputElement !== 'undefined' && searchInput instanceof HTMLInputElement && searchInput?.placeholder) ghostText = searchInput.placeholder;
    // If found in DOM/ref and valid, use it
    if (ghostText && ghostText.length > 0) return ghostText;
    return (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT);
};
module.exports["getPersistedGhostText"] = $9a64fd0ce05b42e8$export$3977b992ec7f3f3b;

});

parcelRegister("4jplB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $b1Jpy = parcelRequire("b1Jpy");


var $l998X = parcelRequire("l998X");





var $dpPtd = parcelRequire("dpPtd");


var $if5rb = parcelRequire("if5rb");


var $8zs3p = parcelRequire("8zs3p");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $bWLcG = parcelRequire("bWLcG");

var $ecnYn = parcelRequire("ecnYn");


var $hnvzE = parcelRequire("hnvzE");


var $gWF6I = parcelRequire("gWF6I");


var $icqFF = parcelRequire("icqFF");


var $4OGlb = parcelRequire("4OGlb");


var $1yEFx = parcelRequire("1yEFx");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $a9fb8805b1f49851$export$7640e1e223f51f1a = 'referrer';



var $hHl3d = parcelRequire("hHl3d");


var $7WbA8 = parcelRequire("7WbA8");


var $2lmJQ = parcelRequire("2lmJQ");


var $2ok43 = parcelRequire("2ok43");


var $86ob4 = parcelRequire("86ob4");


var $2OtFZ = parcelRequire("2OtFZ");


var $26jni = parcelRequire("26jni");


var $RWXHe = parcelRequire("RWXHe");


var $1XDdH = parcelRequire("1XDdH");








var $6a9Hv = parcelRequire("6a9Hv");


var $jTxSS = parcelRequire("jTxSS");


var $c6GJD = parcelRequire("c6GJD");








var $59vy4 = parcelRequire("59vy4");


var $czt8s = parcelRequire("czt8s");

var $jwO5V = parcelRequire("jwO5V");


var $iA4lt = parcelRequire("iA4lt");




var $hB77E = parcelRequire("hB77E");


var $6yNqK = parcelRequire("6yNqK");








var $dmTG5 = parcelRequire("dmTG5");


var $cFN1h = parcelRequire("cFN1h");


var $3htW4 = parcelRequire("3htW4");


var $a0M2t = parcelRequire("a0M2t");


var $bQSQw = parcelRequire("bQSQw");





var $ci6Zg = parcelRequire("ci6Zg");





var $jjjIy = parcelRequire("jjjIy");


var $elKbB = parcelRequire("elKbB");


var $fXT59 = parcelRequire("fXT59");

const $fa792d959dc8194b$export$3d3f5f86906a7f73 = (0, $elKbB.KnowledgeDiscoveryJiraSearchClassification);
const $fa792d959dc8194b$export$928cec68d7595d16 = (0, $fXT59.disposableValue)(null);


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

async function $cf5ef1e7c875b308$export$45bde04e7d1842b0(asyncFunction) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const markName = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
    performance.mark(`${markName}-start`);
    const result = await asyncFunction();
    performance.mark(`${markName}-end`);
    performance.measure(markName, `${markName}-start`, `${markName}-end`);
    const measure = performance.getEntriesByName(markName)[0];
    const duration = measure.duration;
    // Clear the marks and measure to avoid memory leaks
    performance.clearMarks(`${markName}-start`);
    performance.clearMarks(`${markName}-end`);
    performance.clearMeasures(markName);
    return {
        result: result,
        duration: duration
    };
}





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $4mft4 = parcelRequire("4mft4");

const $fa64c9b2652b82c5$var$styles = {
    quickFindPlacementContainer: "_n3td12x7 _19bvu2gc _u5f3u2gc"
};
const $fa64c9b2652b82c5$export$f7ad73a4588a04e6 = ({ thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, onMessageViewed: onMessageViewed })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $fa64c9b2652b82c5$var$styles.quickFindPlacementContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4mft4.BannerPlacement), {
            placementId: "search-page-results-quick-find",
            thirdPartyConfigs: thirdPartyConfigs,
            availableProductsOrder: availableProductsOrder,
            useOAuthHandlers: useOAuthHandlers,
            onMessageViewed: onMessageViewed
        })
    });
};



var $9wmQG = parcelRequire("9wmQG");

const $3746cfd8500fe3df$export$932440ee05101c0d = ({ success: success, attributes: attributes, resultsType: resultsType })=>({
        eventType: 'operational',
        action: success ? 'taskSuccess' : 'taskFail',
        actionSubject: 'ui',
        attributes: {
            ...attributes,
            // This edition is not exact matching the need for the AutoHots
            // A follow up is to find the current primary product edition and log that.
            // Currently we only have confluence edition in the productEdition object, so logging the entire object for now.
            edition: attributes.productEdition,
            task: 'unifiedSearch',
            capability: `quickFind_${resultsType}`,
            // Confirmed with AutoHots team this is mandatory
            // and base on "Can I log this" doc, we can log this.
            // https://hello.atlassian.net/wiki/spaces/Monitoring/pages/5816497997/Vitalstats+Onboarding+contract?focusedCommentId=5864073069
            // https://hello.atlassian.net/wiki/spaces/SECURITY/pages/236070634/Can+I+Log+This
            hostname: window.location.hostname
        }
    });


const $e1a1aba41a097938$export$2d1da932f40a427e = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, resultsType: resultsType })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: resultsType,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $7c0d6974c60a6f80$export$7254cc27399e90bd = {
    PREQUERY_ERROR: 'PREQUERY_ERROR',
    PREQUERY_LOADING: 'PREQUERY_LOADING',
    PREQUERY_NO_RESULTS: 'PREQUERY_NO_RESULTS',
    PREQUERY_RESULTS: 'PREQUERY_RESULTS',
    POSTQUERY_ERROR: 'POSTQUERY_ERROR',
    POSTQUERY_LOADING: 'POSTQUERY_LOADING',
    POSTQUERY_NO_RESULTS: 'POSTQUERY_NO_RESULTS',
    POSTQUERY_RESULTS: 'POSTQUERY_RESULTS'
};
const $7c0d6974c60a6f80$export$bbc0e9ab60a7c746 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$f33d0292f2f7a82a = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$3d387094581134ab = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$de6adf92470c6d4 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING;
};
const $7c0d6974c60a6f80$export$8984dd36dcb68400 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_ERROR;
};



var $kQT7c = parcelRequire("kQT7c");





var $jSnXV = parcelRequire("jSnXV");

const $e31678cde9628b17$export$e70e6da722faba05 = (callback, debounceTime)=>{
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const debouncedCallback = (0, $42omo.useMemo)(()=>{
        const func = ()=>{
            ref.current?.();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(func, debounceTime);
    }, [
        debounceTime
    ]);
    return debouncedCallback;
};









var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");







var $dcJ7R = parcelRequire("dcJ7R");




var $hcMBV = parcelRequire("hcMBV");


var $hWR4v = parcelRequire("hWR4v");

var $gzcCN = parcelRequire("gzcCN");


var $icWhS = parcelRequire("icWhS");

var $bloXB = parcelRequire("bloXB");

/* return.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $bbJes = parcelRequire("bbJes");





var $i7jPX = parcelRequire("i7jPX");

const $dbff52abefb1bfa8$var$styles = {
    base: "_syazazsu"
};
const $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5 = ({ size: size = 'small', label: label = '' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $dbff52abefb1bfa8$var$styles.base,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
            label: "",
            size: size,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bbJes))), {
                label: label
            })
        })
    });






var $9kYXz = parcelRequire("9kYXz");


var $3E8x9 = parcelRequire("3E8x9");


var $2waBy = parcelRequire("2waBy");


var $aRSt4 = parcelRequire("aRSt4");







const $c778002e02670657$export$6500cdbd153f3497 = (item)=>{
    return item.type === 'error';
};
const $c778002e02670657$export$6dc914a1cb2e7113 = (item)=>{
    return item.type === 'landing';
};
const $c778002e02670657$export$993e95eb6704a94c = (item)=>{
    return item.type === 'no-results';
};
const $c778002e02670657$export$9050e45a166250f = (item)=>{
    return item.type === 'heading';
};
const $c778002e02670657$export$d680994c1f15882e = (item)=>{
    return item.type === 'skeleton';
};
const $c778002e02670657$export$871ba967042323cb = (item)=>{
    return item.type === 'recent-query';
};
const $c778002e02670657$export$57fb632bdb82e6e6 = (item)=>{
    return item.type === 'autocomplete-suggestion';
};
const $c778002e02670657$export$99edcb23f38a2d86 = (item)=>{
    return item.type === 'zero-query';
};
const $c778002e02670657$export$329ac1434313f6b2 = (item)=>{
    return item.type === 'recent-activity';
};
const $c778002e02670657$export$a3a92d47cbabad1c = (item)=>{
    return item.type === 'user-document';
};
const $c778002e02670657$export$746233dd1618793c = (item)=>{
    return item.type === 'search-result';
};
const $c778002e02670657$export$bc8d42212d76a15c = (item)=>{
    return item.type === 'people-and-teams';
};
const $c778002e02670657$export$35bb43147cd35a68 = (item)=>{
    return item.type === 'filter-suggestion';
};


const $39181c35e6b4cafd$var$ItemsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $39181c35e6b4cafd$var$isItemCountable = (item)=>(0, $c778002e02670657$export$746233dd1618793c)(item) || (0, $c778002e02670657$export$a3a92d47cbabad1c)(item) || (0, $c778002e02670657$export$329ac1434313f6b2)(item) || (0, $c778002e02670657$export$bc8d42212d76a15c)(item);
const $39181c35e6b4cafd$var$isHeading = (item)=>(0, $c778002e02670657$export$9050e45a166250f)(item);
const $39181c35e6b4cafd$var$getItemsAndSectionsCount = (allItems)=>allItems.reduce(({ resultCount: resultCount, sectionCount: sectionCount }, item, currentIndex)=>{
        if ($39181c35e6b4cafd$var$isItemCountable(item)) resultCount++;
        if (currentIndex === 0 && !$39181c35e6b4cafd$var$isHeading(item)) // if the first item is not heading, we consider it in a section
        sectionCount++;
        if ($39181c35e6b4cafd$var$isHeading(item)) sectionCount++;
        return {
            resultCount: resultCount,
            sectionCount: sectionCount
        };
    }, {
        resultCount: 0,
        sectionCount: 0
    });
const $39181c35e6b4cafd$export$a511f36416966245 = ()=>{
    const ctx = (0, $42omo.useContext)($39181c35e6b4cafd$var$ItemsContext);
    if (!ctx) // We throw an error here to make sure the hook is used within the provider,
    // otherwise it would return undefined and cause runtime errors and is hard to debug
    throw new Error('useItemsAnalyticsContext must be used within ItemsAnalyticsProvider');
    return ctx;
};
const $39181c35e6b4cafd$export$5643dbed0288c870 = ({ allItems: allItems, children: children })=>{
    const invalidatedIdsRef = (0, $42omo.useRef)(new Set());
    (0, $42omo.useEffect)(()=>{
        // Reset invalidated IDs when allItems change, the items would call invalidateItem again if needed
        invalidatedIdsRef.current.clear();
    }, [
        allItems
    ]);
    const invalidateItem = (id)=>{
        invalidatedIdsRef.current.add(id);
    };
    const { resultCount: resultCount, sectionCount: sectionCount } = (0, $42omo.useMemo)(()=>$39181c35e6b4cafd$var$getItemsAndSectionsCount(allItems), [
        allItems
    ]);
    const getItemIndexes = (0, $42omo.useCallback)((id)=>{
        const item = id && !invalidatedIdsRef.current.has(id) ? allItems.find((item)=>item.id === id) : undefined;
        if (!item || !$39181c35e6b4cafd$var$isItemCountable(item)) return undefined;
        let globalIndex = -1;
        let sectionIndex = -1;
        let indexWithinSection = -1;
        let sectionId = '';
        const activeItems = allItems.filter((item)=>!invalidatedIdsRef.current.has(item.id));
        for(let i = 0; i < activeItems.length; i++)if ($39181c35e6b4cafd$var$isHeading(activeItems[i])) {
            sectionIndex++;
            indexWithinSection = -1;
            sectionId = activeItems[i].id;
        } else {
            if (i === 0) // if the first item is not heading, we consider it in a section
            sectionIndex++;
            if ($39181c35e6b4cafd$var$isItemCountable(activeItems[i])) {
                indexWithinSection++;
                globalIndex++;
            }
            if (activeItems[i].id === id) return {
                globalIndex: globalIndex,
                sectionIndex: sectionIndex,
                indexWithinSection: indexWithinSection,
                resultCount: resultCount,
                sectionCount: sectionCount,
                sectionId: sectionId
            };
        }
        // if there is no match, return undefined
        return undefined;
    }, [
        allItems,
        resultCount,
        sectionCount
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($39181c35e6b4cafd$var$ItemsContext.Provider, {
        value: {
            invalidateItem: invalidateItem,
            getItemIndexes: getItemIndexes
        },
        children: children
    });
};














var $2W0qg = parcelRequire("2W0qg");




var $26eSY = parcelRequire("26eSY");


var $9lW6K = parcelRequire("9lW6K");





var $1VHLw = parcelRequire("1VHLw");








var $jAenQ = parcelRequire("jAenQ");


var $a7nUd = parcelRequire("a7nUd");


const $2944de3e13791145$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $2944de3e13791145$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'radius.large',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
});
const $2944de3e13791145$var$resultHoveredStlyes = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $2944de3e13791145$var$keyboardHighlightedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $2944de3e13791145$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2944de3e13791145$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $2944de3e13791145$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $2944de3e13791145$var$metadataStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    font: 'font.body.small',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '13px',
    display: 'flex',
    alignItems: 'center',
    minWidth: '0'
});
const $2944de3e13791145$var$textOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $2944de3e13791145$var$rightSectionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $2944de3e13791145$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    borderRadius: 'radius.large',
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':focus': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $2944de3e13791145$var$headingStyle = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    gap: 'space.075',
    alignItems: 'center',
    maxWidth: '100%'
});
const $2944de3e13791145$export$a2def421b23768aa = ({ icon: icon, title: title, resultType: resultType, product: product, metadata: metadata = [], rightMetadata: rightMetadata, hoveredRightMetadata: hoveredRightMetadata, highlightedRightMetadata: highlightedRightMetadata, url: url, isThirdParty: isThirdParty = false, highlightedTitle: highlightedTitle, includeInAnalytics: includeInAnalytics = true, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onResultHighlighted: onResultHighlighted, titleMetadataParts: titleMetadataParts, id: id, minutesSinceActivityTimestamp: minutesSinceActivityTimestamp, connectorType: connectorType })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    const ref = (0, $42omo.useRef)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { getItemIndexes: getItemIndexes } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: (e)=>{
            /**
			 * Two different event listeners are used to handle enter key presses
			 * when the input is focused:
			 * - the onKeyDown callback on the Textfield component which uses
			 *   React's synthetic event listeners (onKeyDown)
			 * - the keyboard highlight provider's onKeydownCallback which
			 *   uses native event listeners (window.addEventListener). This one
			 *   will only be called if a search result is highlighted.
			 * Ideally there should be only one event listener however, it isn't
			 * worth the effort to refactor the keyboard highlight provider right now.
			 *
			 * Given that the keyboard highlight provider's callback uses native
			 * event listeners, it will always be called first. This is a problem
			 * because there is no way for the keyboard highlight provider to
			 * communicate that the event has been handled, resulting in a bug
			 * where we try to handle the event twice if a search result was
			 * highlighted. It must be noted that it cannot be guaranteed that
			 * the search results are still highlighted after the native event
			 * listener has executed as it could close the search dialog.
			 *
			 * To fix this, a somewhat hacky solution has been added to delay
			 * the click event in the keyboard highlight provdier by one frame
			 * in search-dialog-result/index. This allows the React synthetic
			 * event to decide if it should handle the event by checking if a
			 * search result is highlighted, otherwise it will do nothing and
			 * let the keyboard highlight provider handle the event.
			 */ requestAnimationFrame(()=>{
                if (e.key === 'Enter') ref.current?.click();
            });
        },
        // Used by KeyboardHighlightProvider to keep highlighting stable across re-orders.
        // Also enables imperative highlighting by a stable tracking id.
        //
        // NOTE: `id` alone can collide across sections (e.g. suggestion + recent query),
        // so we namespace it by `resultType`.
        navigationTrackingId: id ? `${resultType}:${id}` : null,
        onHighlightedCallback: ()=>onResultHighlighted?.({
                ...getItemIndexes(id) ?? {},
                ...(0, $dh538.fg)('qf_add_result_type_in_analytics') ? {
                    resultType: resultType
                } : {}
            })
    });
    const onClick = (0, $42omo.useCallback)((event, { isAuxClick: isAuxClick = false } = {})=>onResultClicked?.(event, {
            ...getItemIndexes(id) ?? {},
            isAuxClick: isAuxClick,
            ...(0, $dh538.fg)('qf_add_result_type_in_analytics') ? {
                resultType: resultType
            } : {}
        }), [
        onResultClicked,
        getItemIndexes,
        id,
        resultType
    ]);
    const onContextMenu = (0, $42omo.useCallback)((event)=>onResultContextMenu?.(event, {
            ...getItemIndexes(id) ?? {},
            ...(0, $dh538.fg)('qf_add_result_type_in_analytics') ? {
                resultType: resultType
            } : {}
        }), [
        onResultContextMenu,
        getItemIndexes,
        id,
        resultType
    ]);
    const metadataPartsWithTextOverflow = metadata.map((part, i)=>i === metadata.length - 1 && typeof part === 'string' ? [
            part,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$textOverflowStyles,
                as: "span",
                children: part
            })
        ] : part);
    const content = /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        ref: (node)=>{
            ref.current = node;
            setRef(node);
        },
        xcss: [
            $2944de3e13791145$var$resultStyles,
            isHovered && $2944de3e13791145$var$resultHoveredStlyes,
            isKeyboardHighlighted && $2944de3e13791145$var$keyboardHighlightedStyles
        ],
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$iconAreaStyles,
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$middleAreaStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                        xcss: $2944de3e13791145$var$headingStyle,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: [
                                    $2944de3e13791145$var$titleStyles,
                                    $2944de3e13791145$var$textOverflowStyles
                                ],
                                children: highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title
                            }),
                            titleMetadataParts && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
                                    parts: titleMetadataParts
                                })
                            })
                        ]
                    }),
                    metadata.length >= 1 && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $2944de3e13791145$var$metadataStyles
                        ],
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
                            parts: metadataPartsWithTextOverflow
                        })
                    })
                ]
            }),
            hoveredRightMetadata && isHovered ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: hoveredRightMetadata
                })
            }) : highlightedRightMetadata && isKeyboardHighlighted ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: highlightedRightMetadata
                })
            }) : rightMetadata ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: rightMetadata
                })
            }) : null
        ]
    });
    const resultWithoutAnalyticsWrapper = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$containerStyles,
        children: (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
            backgroundColor: "color.background.neutral.subtle",
            onClick: (e)=>onClick(e),
            onAuxClick: (e)=>{
                if ((0, $2OtFZ.serveEngagementTrackingImprovementsExperiment)() && (0, $1VHLw.isAuxClick)(e)) return onClick(e, {
                    isAuxClick: true
                });
            },
            onContextMenu: onContextMenu,
            children: url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                xcss: [
                    $2944de3e13791145$var$linkStyles
                ],
                rel: isThirdParty ? 'noreferrer' : '',
                target: isThirdParty ? '_blank' : undefined,
                href: url,
                testId: "search-dialog-result-link",
                children: content
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: content
            })
        }) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            onClick: (e)=>onClick(e),
            onAuxClick: (e)=>{
                if ((0, $2OtFZ.serveEngagementTrackingImprovementsExperiment)() && (0, $1VHLw.isAuxClick)(e)) return onClick(e, {
                    isAuxClick: true
                });
            },
            onContextMenu: onContextMenu,
            children: url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                xcss: $2944de3e13791145$var$linkStyles,
                rel: isThirdParty ? 'noreferrer' : '',
                target: isThirdParty ? '_blank' : undefined,
                href: url,
                testId: "search-dialog-result-link",
                children: content
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: content
            })
        })
    });
    return includeInAnalytics ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9wmQG.SearchDialogResultAnalyticsWrapper), {
        role: "listitem",
        "data-testid": "search-dialog-result",
        ref: wrapperRef,
        resultType: resultType,
        product: product,
        id: id,
        connectorType: connectorType,
        minutesSinceActivityTimestamp: minutesSinceActivityTimestamp,
        children: resultWithoutAnalyticsWrapper
    }) : resultWithoutAnalyticsWrapper;
};



var $kXlQy = parcelRequire("kXlQy");





var $Y34Hw = parcelRequire("Y34Hw");





var $1nJM3 = parcelRequire("1nJM3");


var $j4ply = parcelRequire("j4ply");


var $4VmlX = parcelRequire("4VmlX");


var $cgtv4 = parcelRequire("cgtv4");

const $3a985a01f765cd1f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    workItem: {
        id: "work_item",
        defaultMessage: "Work item"
    },
    draftLabel: {
        id: "draft_label",
        defaultMessage: "DRAFT"
    }
});



const $bfef7c7cb8b104c2$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("eOylV")).then((mod)=>({
            default: mod.HoverCard
        })));
const $bfef7c7cb8b104c2$var$labelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $bfef7c7cb8b104c2$var$Badge = ({ message: message })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            isBold: true,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...message
            })
        })
    });
};
const $bfef7c7cb8b104c2$export$934ec3855ad17df5 = (data)=>{
    if ((data?.pageStatus === 'DRAFT' || data?.blogStatus === 'DRAFT') && data?.subtype !== 'LIVE') return [
        [
            'confluence-draft',
            /*#__PURE__*/ (0, $l998X.jsx)($bfef7c7cb8b104c2$var$Badge, {
                message: (0, $3a985a01f765cd1f$export$defe85febe8b728c).draftLabel
            })
        ]
    ];
};
const $bfef7c7cb8b104c2$var$mapConfluenceActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const titleMetadataParts = $bfef7c7cb8b104c2$export$934ec3855ad17df5(activity.object.data);
    const isLiveDoc = activity.object.data?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const icon = (0, $dh538.fg)('rovo_search_confluence_icons') ? (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: activity.object.data.iconData,
        type: activity.object.type,
        isLiveDoc: isLiveDoc
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Confluence
    });
    const resultType = isLiveDoc ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $3a985a01f765cd1f$export$defe85febe8b728c).liveDoc
    }) : activity.object.type;
    const type = [
        'confluence-type',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: activity.object.type,
                defaultMessage: resultType,
                subtype: activity.object.data?.subtype
            })
        })
    ];
    const spaceName = space?.name || '';
    const metadata = [
        type,
        spaceName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    const spaceId = space?.id;
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `confluence ${activity.object.type}`,
        product: `confluence`,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    if (!title || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        titleMetadataParts: titleMetadataParts
    };
};
const $bfef7c7cb8b104c2$export$d1c859566522d367 = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const isIssue = activity.object.type === 'issue';
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: activity.object.data?.issueType?.avatar?.small,
        type: activity.object.type,
        isIssue: isIssue
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const productMetadata = 'Jira';
    const projectName = activity?.object?.data?.fieldsById?.edges?.at(0)?.node?.issue?.projectField?.project?.name ?? null;
    const issueTypeName = activity?.object?.data?.fieldsById?.edges?.at(0)?.node?.issue?.issueTypeField?.issueType?.name ?? null;
    const metadata = [
        productMetadata,
        issueTypeName,
        projectName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `jira ${activity.object.type}`,
        product: `jira`,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: webUrl,
        analyticsMetadata: analyticsMetadata,
        isJiraIssue: isIssue
    };
};
const $bfef7c7cb8b104c2$export$38a5a0823b95c5be = (activity, query)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    const data = activity.object.data;
    const { assetsLabel: title, displayTypename: displayTypename, links: links, assetsIcon: assetsIcon, schema: schema, objectType: objectType } = data;
    const url = links?.web || null;
    if (!title || !url) return undefined;
    const icon = (0, $2waBy.getAssetsEntityIcon)({
        iconUrl: assetsIcon?.url48,
        type: activity.object.type,
        size: 'small'
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    // Create metadata with object type and schema information
    const schemaName = schema?.name || objectType?.schema?.name || null;
    const productMetadata = 'Assets';
    const metadata = [
        productMetadata,
        [
            activity.object.type,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $bfef7c7cb8b104c2$var$labelContainer,
                children: displayTypename
            })
        ],
        schemaName
    ];
    // Add event type information
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `assets ${activity.object.type}`,
        product: `assets`,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapTownsquareActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons')) icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: activity.object.data.iconData,
        type: activity.object.type
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Atlas
    });
    const highlightedTitle = name && query ? (0, $bloXB.highlightMatchedText)(name, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'type',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: activity.object.type,
                defaultMessage: activity.object.type
            })
        })
    ];
    const metadata = [
        type,
        key ?? null
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `townsquare ${activity.object.type}`,
        product: `townsquare`,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    if (!name || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: name,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphDocumentActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    const product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $kQT7c.getProductFromThirdPartyId)({
        thirdPartyId: id
    });
    if (!product) return;
    const subtype = type?.category?.toLowerCase();
    const label = (0, $9kYXz.getDocumentSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...label
            })
        }) : subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
        }) : null
    ];
    const parentName = parent?.displayName ?? null;
    const metadata = [
        typeLabel,
        parentName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphRemoteLinkActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { category: category, displayName: displayName, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    let product;
    let productDisplayName = '';
    if (providerId) {
        product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $kQT7c.getProductFromThirdPartyId)({
            thirdPartyId: id
        });
        productDisplayName = (0, $Y34Hw.getProductDisplayNameFromProviderId)(thirdPartyConfigs, providerId) || '';
    }
    if (!product) return;
    const subtype = category?.toLowerCase();
    const label = (0, $9kYXz.getRemoteLinkSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: productDisplayName
        }) : null
    ];
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...label
            })
        }) : null
    ];
    const metadata = [
        productLabel,
        typeLabel
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if ((0, $hWR4v.isDocumentActivity)(activity.object)) return $bfef7c7cb8b104c2$var$mapGraphDocumentActivityToSearchResult(activity, query, thirdPartyConfigs);
    if ((0, $hWR4v.isRemoteLinkActivity)(activity.object)) return $bfef7c7cb8b104c2$var$mapGraphRemoteLinkActivityToSearchResult(activity, query, thirdPartyConfigs);
    return undefined;
};
const $bfef7c7cb8b104c2$var$mapGithubActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { displayName: displayName, url: url } = activity.object.data;
    if (!displayName || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: 'github'
    });
    const highlightedTitle = displayName && query ? (0, $bloXB.highlightMatchedText)(displayName, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'github-type',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: activity.object.type,
                defaultMessage: activity.object.type
            })
        })
    ];
    const metadata = [
        type,
        'GitHub'
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `github ${activity.object.type}`,
        product: `github`
    };
    return {
        id: id,
        icon: icon,
        title: displayName,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$export$1d02b83d52558ed = (edge, query, searchSessionId, thirdPartyConfigs, serveGithubLinksHydrationCohort)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const timestamp = activity.event.timestamp;
    let result;
    if ((0, $hWR4v.isGraphActivity)(activity.object)) result = $bfef7c7cb8b104c2$var$mapGraphActivityToSearchResult(activity, query, thirdPartyConfigs);
    else if (product === 'confluence') result = $bfef7c7cb8b104c2$var$mapConfluenceActivityToSearchResult(activity, query);
    else if (product === 'jira') result = $bfef7c7cb8b104c2$export$d1c859566522d367(activity, query);
    else if (product === 'townsquare') result = $bfef7c7cb8b104c2$var$mapTownsquareActivityToSearchResult(activity, query);
    else if (product === 'github' && serveGithubLinksHydrationCohort) result = $bfef7c7cb8b104c2$var$mapGithubActivityToSearchResult(activity, query);
    else if (product === 'assets' && (0, $dh538.fg)('assets_rovo_search_all')) result = $bfef7c7cb8b104c2$export$38a5a0823b95c5be(activity, query);
    else result = undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
};
const $bfef7c7cb8b104c2$export$8d9137fcb112aeab = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted, serveGithubLinksHydration: serveGithubLinksHydration = false })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setHoverCardOpen: setHoverCardOpen } = (0, $4VmlX.useQuickFindActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const mappedResult = $bfef7c7cb8b104c2$export$1d02b83d52558ed(result, quickFindQuery, searchSessionId, thirdPartyConfigs, serveGithubLinksHydration);
    const additionalAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            isCached: true,
            metadata: {
                ...mappedResult?.analyticsMetadata,
                connectorType: (0, $kQT7c.getResultConnectorSource)({
                    resultNodeId: result.node.object.id,
                    thirdPartyConfigs: thirdPartyConfigs,
                    productKey: mappedResult?.analyticsMetadata.product,
                    eventType: result.node.event.eventType
                })
            },
            is3pLink: (0, $1yEFx.is3pProductKeyForAnalytics)(mappedResult?.analyticsMetadata.product),
            is3pSmartLink: (0, $kQT7c.isResultSmartLink)({
                resultAri: result.node.object.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product,
                eventType: result.node.event.eventType
            })
        }), [
        mappedResult,
        result.node.object.id,
        thirdPartyConfigs,
        result.node.event.eventType
    ]);
    const onHoverCardVisibilityChange = (0, $42omo.useCallback)((isOpen)=>{
        setHoverCardOpen(result.node.object.id, isOpen);
    }, [
        setHoverCardOpen,
        result.node.object.id
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
        if ((0, $dh538.fg)('search_qf_fix_close_hover_card')) onHoverCardVisibilityChange(false);
    }, [
        additionalAnalyticsAttributes,
        onClick,
        state,
        onHoverCardVisibilityChange
    ]);
    const onResultContextMenu = (0, $42omo.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $42omo.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) {
        invalidateItem(result.node.object.id);
        return null;
    }
    const enableJiraIssueHoverCard = mappedResult.isJiraIssue && primaryProduct === (0, $1yEFx.ProductKeys).Jira && (0, $dh538.fg)('enable_hover_card_jira_issues_quick_find');
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        ...mappedResult,
        resultType: "recentActivities",
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted,
        minutesSinceActivityTimestamp: mappedResult.minutesSinceActivityTimestamp,
        connectorType: additionalAnalyticsAttributes.metadata.connectorType
    });
    return enableJiraIssueHoverCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        fallback: content,
        section: "recent-activity-hover-card",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: content,
            children: /*#__PURE__*/ (0, $l998X.jsx)($bfef7c7cb8b104c2$var$HoverCard, {
                onVisibilityChange: onHoverCardVisibilityChange,
                allowEventPropagation: true,
                url: mappedResult.url,
                actionOptions: {
                    hide: false,
                    exclude: [
                        (0, $hcMBV.CardAction).PreviewAction
                    ]
                },
                role: "dialog",
                titleId: mappedResult.title,
                label: "quick-find-smart-hover-card",
                shouldRenderToParent: true,
                children: content
            })
        })
    }) : content;
};



var $eO6NY = parcelRequire("eO6NY");


var $f8oYd = parcelRequire("f8oYd");


var $4VkIo = parcelRequire("4VkIo");


var $gGFxq = parcelRequire("gGFxq");








var $djVCD = parcelRequire("djVCD");


var $inrbX = parcelRequire("inrbX");








var $lGfXC = parcelRequire("lGfXC");


var $3CshZ = parcelRequire("3CshZ");




const $d4ba038bc3c9327c$export$c24470e080406156 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const isEnabled = (0, $dh538.fg)('rovo-search-vitalstats-quickfind-postquery-network');
    const createNetworkCallbacks = (0, $42omo.useCallback)((options)=>{
        if (!isEnabled) return undefined;
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        const taskStartAt = performance.now();
        return (0, $lGfXC.createVitalStatsNetworkCallbacks)(taskId, options.taskName, searchSessionId, fireAnalyticsEvent, taskStartAt, {
            uxTaskId: options.uxTaskId,
            isPreQuery: options.isPreQuery
        });
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent
    ]);
    return (0, $42omo.useMemo)(()=>({
            createNetworkCallbacks: createNetworkCallbacks,
            isEnabled: isEnabled
        }), [
        createNetworkCallbacks,
        isEnabled
    ]);
};









var $ja8yA = parcelRequire("ja8yA");

var $6h3V2 = parcelRequire("6h3V2");







var $cORSX = parcelRequire("cORSX");







const $198609fd26633f18$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $198609fd26633f18$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
/**
 * Event types to be included in the recent activities query.
 * Based upon the AVI actions for each product: https://bitbucket.org/atlassian/flight-deck/src/7bab054550927c3c023f2eb783ce9d2ca6279bfc/packages/integrations/worklens/contrib/
 */ const $198609fd26633f18$var$INCLUDED_EVENT_TYPES = [
    'assigned',
    'unassigned',
    'viewed',
    'updated',
    'created',
    'liked',
    'transitioned',
    'published',
    'edited',
    'commented',
    'sl-viewed',
    'sl-clicked',
    'shared',
    'exported',
    'deleted',
    'started',
    'snapshotted',
    'trashed',
    'reaction'
];
const $198609fd26633f18$var$ORS_BATCH_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $198609fd26633f18$var$GRANTED = 'granted';
const $198609fd26633f18$var$RECENT_ACTIVITIES_LIMIT = 200;
const $198609fd26633f18$var$OK_STATUS = 200;
/**
 * Returns the list of products to be included in the recent activities query based on the experiment.
 */ const $198609fd26633f18$var$getIncludedProductsBasedOnCohort = ()=>{
    if ((0, $dh538.fg)('assets_rovo_search_all')) {
        $198609fd26633f18$export$48de245659972a87.push('assets');
        $198609fd26633f18$export$742b5ce6018da1f4.push('object');
        $198609fd26633f18$export$742b5ce6018da1f4.push('object_type');
        $198609fd26633f18$export$742b5ce6018da1f4.push('schema');
    }
    return $198609fd26633f18$export$48de245659972a87;
};
const $198609fd26633f18$var$getIncludedProductsBasedOnProduct = (includedProducts, product)=>{
    /**
   * Decision on Experiment (https://hello.atlassian.net/wiki/spaces/CentAI/pages/5652280226)
   * Remove Jira from QF Recents to have better relevance and CTR.
   */ if (product === (0, $1yEFx.PrimaryProductKeys).Confluence) return includedProducts.filter((product)=>product !== (0, $1yEFx.PrimaryProductKeys).Jira);
    return includedProducts;
};
const $198609fd26633f18$var$getFilteredEventTypes = (thirdPartyConfigs)=>{
    if (thirdPartyConfigs && (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs, {
        fireExperimentExposure: false
    })) return [
        ...$198609fd26633f18$var$INCLUDED_EVENT_TYPES,
        'clicked'
    ];
    return $198609fd26633f18$var$INCLUDED_EVENT_TYPES;
};
const $198609fd26633f18$var$getFilteredProducts = (experimentConfig, primaryProduct)=>{
    const recentActivitiesProductsFromCombinedExperiment = experimentConfig?.combinedExperiment?.enabled && experimentConfig?.combinedExperiment?.uiFeatures?.recentActivitiesProducts;
    // Override filtered products if valid recentActivitiesProducts are provided
    if (Array.isArray(recentActivitiesProductsFromCombinedExperiment) && recentActivitiesProductsFromCombinedExperiment.every((p)=>$198609fd26633f18$export$48de245659972a87.includes(p))) return recentActivitiesProductsFromCombinedExperiment;
    // Get included products based on cohort
    const includedProductsBasedOnCohort = $198609fd26633f18$var$getIncludedProductsBasedOnCohort();
    // Further filter products based on primary product
    const filteredProductsBasedOnProduct = $198609fd26633f18$var$getIncludedProductsBasedOnProduct(includedProductsBasedOnCohort, primaryProduct);
    return filteredProductsBasedOnProduct;
};
const $198609fd26633f18$export$ae65634d024c5427 = async (cloudId, aggAbsoluteUrl, experimentConfig, after = '', thirdPartyConfigs, headers, primaryProduct, networkCallbacks)=>{
    const filteredProducts = $198609fd26633f18$var$getFilteredProducts(experimentConfig, primaryProduct);
    const variables = {
        filteredProducts: Array.from(new Set(filteredProducts)),
        filteredObjectTypes: Array.from(new Set($198609fd26633f18$export$742b5ce6018da1f4)),
        filteredRootContainerIds: [
            `ari:cloud:platform::site/${cloudId}`,
            `ari:cloud:townsquare::site/${cloudId}`
        ],
        itemsLimit: 200,
        after: after,
        includeJiraIssueMetadata: true,
        filteredEventTypes: $198609fd26633f18$var$getFilteredEventTypes(thirdPartyConfigs)
    };
    const serveAutorefreshCohort = (0, $c6GJD.default).getExperimentValue('quick_find_autorefresh_experiment_v3', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'autorefresh';
    const response = serveAutorefreshCohort ? await (0, $ja8yA.cachedRecentActivitiesQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers,
        onlyRefreshIfExpired: true,
        returnExpired: false,
        networkCallbacks: networkCallbacks
    }) : await (0, $ja8yA.recentActivitiesQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers,
        networkCallbacks: networkCallbacks
    });
    const edges = response.data?.activity?.myActivity?.all?.edges || [];
    return edges.map($198609fd26633f18$export$cf1f13813d90479a);
};
const $198609fd26633f18$export$9bda9a715c3ed911 = async (recentActivities, aggAbsoluteUrl, logException, headers)=>{
    const edges = $198609fd26633f18$var$sortEdgesByTimestamp(recentActivities.result.map((item)=>item.data));
    const aris = $198609fd26633f18$export$23b00b851b111052(edges);
    const jiraIssues = await $198609fd26633f18$export$c8536bbc7f06d58d(aris, aggAbsoluteUrl, logException, headers);
    const githubLinkTimestampMap = $198609fd26633f18$export$d3d43bed3553e945(edges, jiraIssues);
    const githubLinks = Array.from(githubLinkTimestampMap.keys());
    const githubResolvedResponse = await $198609fd26633f18$export$15cc24473e11647c(githubLinks, logException);
    const githubEdges = $198609fd26633f18$export$71147d03c75fd54e(githubResolvedResponse, githubLinkTimestampMap);
    return githubEdges.map($198609fd26633f18$export$cf1f13813d90479a);
};
const $198609fd26633f18$export$eeae5e9fadfd96ed = 'QuickFindRecentActivitiesJiraIssuesQuery';
const $198609fd26633f18$export$2dff6186c7d49e51 = `
    query ${$198609fd26633f18$export$eeae5e9fadfd96ed}($jira_ids: [ID!]!) {
			jira_issuesByIds(ids: $jira_ids) {
				id,
				summary,
				descriptionField {
					description,
					richText {
						adfValue {
							convertedPlainText {
								plainText
							}
						}
					}
				}
			}
		}
  `;
class $198609fd26633f18$export$7111514ace00cfa2 extends Error {
    constructor(message){
        super(message);
        this.name = 'JiraBackendApiError';
    }
}
const $198609fd26633f18$export$c8536bbc7f06d58d = async (aris, aggAbsoluteUrl, logException, headers)=>{
    const jiraIssueAris = aris.filter((ari)=>{
        try {
            const [resourceOwner, , resourceType] = (0, $6h3V2.getProductAndIDFromARI)(ari);
            return resourceOwner === (0, $hWR4v.ActivityProduct).JIRA && resourceType === 'issue';
        } catch  {
            return false;
        }
    });
    if (jiraIssueAris.length === 0) return [];
    // From https://bitbucket.org/atlassian/graphql-central-schema/src/d0613f3cd3a46e91b2e91ad919ecc4c5a47140f0/schema/jira/gira/IssueView.nadel#lines-17
    // Only fetch first 100 items for experiment
    const limitedJiraIssueAris = jiraIssueAris.slice(0, 100);
    try {
        const result = await (0, $ja8yA.fetchJiraIssuesQuery)({
            variables: {
                jira_ids: limitedJiraIssueAris
            },
            graphQuery: $198609fd26633f18$export$2dff6186c7d49e51,
            aggAbsoluteUrl: aggAbsoluteUrl,
            operationName: $198609fd26633f18$export$eeae5e9fadfd96ed,
            headers: headers
        });
        return result?.data?.jira_issuesByIds || [];
    } catch (error) {
        logException(new $198609fd26633f18$export$7111514ace00cfa2(`Failed to fetch jira issues: ${error}`));
        return [];
    }
};
const $198609fd26633f18$export$cf1f13813d90479a = (result)=>{
    const product = result.node.object.product;
    let title = '';
    const timestamp = result.node?.event?.timestamp;
    if ((0, $hWR4v.is1PActivity)(result.node.object)) {
        if (product === 'confluence') title = result.node.object.data?.title || '';
        else if (product === 'jira') {
            const key = result.node.object.data?.key;
            const summary = result.node.object.data?.fieldsById?.edges?.[0]?.node?.text;
            title = key && summary ? `${key}: ${summary}` : '';
        } else if (product === 'townsquare') title = result.node.object.data?.name || '';
    } else if ((0, $hWR4v.isGraphActivity)(result.node.object) && ((0, $hWR4v.isDocumentActivity)(result.node.object) || (0, $hWR4v.isRemoteLinkActivity)(result.node.object)) || (0, $hWR4v.isGithubActivity)(result.node.object)) title = result.node.object.data?.displayName || '';
    else if ((0, $hWR4v.isAssetsActivity)(result.node.object)) title = result.node.object.data?.assetsLabel || '';
    else title = '';
    return {
        id: result.node.object.id,
        title: title,
        data: result,
        type: 'recent-activity',
        activityTimestamp: timestamp
    };
};
const $198609fd26633f18$export$23b00b851b111052 = (edges)=>{
    let aris = [];
    edges.forEach((item)=>{
        const ari = item.node.object.id;
        if (ari && ($198609fd26633f18$var$isConfluenceResult(ari) || $198609fd26633f18$var$isJiraResult(ari))) aris.push(ari);
    });
    return aris;
};
const $198609fd26633f18$export$d3d43bed3553e945 = (edges, jiraIssuesById)=>{
    const githubLinkTimestampMap = new Map();
    jiraIssuesById.forEach((jiraIssue)=>{
        if (jiraIssue?.id) {
            const correspondingEdge = edges.find((edge)=>edge.node.object.id === jiraIssue.id);
            if (correspondingEdge) {
                const timestamp = correspondingEdge.node.event.timestamp;
                const githubLinks = $198609fd26633f18$export$4b717fa15645fa84(jiraIssue);
                githubLinks.forEach((link)=>{
                    githubLinkTimestampMap.set(link, timestamp);
                });
            }
        }
    });
    return githubLinkTimestampMap;
};
const $198609fd26633f18$export$4b717fa15645fa84 = (jiraIssue)=>{
    const githubLinks = new Set();
    const githubRegex = /https:\/\/github\.com\/[\w\-\.]+\/[\w\-\.]+(?:\/(?:issues\/\d+|pull\/\d+|commit\/[a-f0-9]+|blob\/[\w\-\.\/]+|tree\/[\w\-\.\/]+))?(?=\s|$|[^\w\-\/\.])/gi;
    const scanText = (text)=>{
        if (!text) return;
        const matches = text.match(githubRegex);
        if (matches) matches.forEach((link)=>githubLinks.add(link));
    };
    scanText(jiraIssue.summary);
    scanText(jiraIssue.descriptionField?.description);
    scanText(jiraIssue.descriptionField?.richText?.adfValue?.convertedPlainText?.plainText);
    return Array.from(githubLinks);
};
class $198609fd26633f18$export$527d28eac40c15a9 extends Error {
    constructor(message){
        super(message);
        this.name = 'OrsApiError';
    }
}
const $198609fd26633f18$export$15cc24473e11647c = async (githubLinks, logException)=>{
    if (githubLinks.length === 0) return [];
    // https://bitbucket.org/atlassian/object-resolver-service/src/178ab83b4d54575d9ff2cd1246eb83a892b4fd6a/openapi.yaml#lines-335
    // Batch requests in chunks of 50 for experiment, with a maximum of 2 batches
    const BATCH_SIZE = 50;
    const MAX_BATCHES = 2;
    const allResults = [];
    const maxLinks = BATCH_SIZE * MAX_BATCHES;
    const linksToProcess = githubLinks.slice(0, maxLinks);
    for(let i = 0; i < linksToProcess.length; i += BATCH_SIZE){
        const batch = linksToProcess.slice(i, i + BATCH_SIZE);
        const orsRequestData = batch.map((link)=>({
                resourceUrl: link
            }));
        try {
            const response = await fetch($198609fd26633f18$var$ORS_BATCH_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-product': 'JiraQuickFindRecentsForGithub' // For tracking RPM in ORS API
                },
                body: JSON.stringify(orsRequestData)
            });
            if (response === null || !response.ok) logException(new $198609fd26633f18$export$527d28eac40c15a9(`ORS API call failed: ${response.status} ${response.statusText}`));
            else {
                const batchResults = await response.json();
                allResults.push(...batchResults);
            }
        } catch (error) {
            logException(new $198609fd26633f18$export$527d28eac40c15a9(`ORS API call error: ${error}`));
        }
    }
    return allResults;
};
const $198609fd26633f18$export$71147d03c75fd54e = (githubResolvedResponse, githubLinkTimestampMap)=>{
    const edges = [];
    githubResolvedResponse.forEach((resolvedResponse)=>{
        if (resolvedResponse.status === $198609fd26633f18$var$OK_STATUS && resolvedResponse.body.meta.access === $198609fd26633f18$var$GRANTED && edges.length < $198609fd26633f18$var$RECENT_ACTIVITIES_LIMIT) {
            const originalTimestamp = githubLinkTimestampMap.get(resolvedResponse.body.data.url);
            const currentTimestamp = new Date().toISOString();
            const kebabCaseResourceType = $198609fd26633f18$var$camelToKebab(resolvedResponse.body.meta.resourceType);
            const typeMessage = kebabCaseResourceType && kebabCaseResourceType in (0, $cORSX.messages) ? (0, $cORSX.messages)[kebabCaseResourceType] : (0, $cORSX.messages).unrecognised;
            const githubEdge = {
                node: {
                    object: {
                        data: {
                            displayName: resolvedResponse.body.data.name || resolvedResponse.body.data.title,
                            url: resolvedResponse.body.data.url
                        },
                        id: (0, $a0M2t.sha256Hash)(resolvedResponse.body.data['@id']),
                        // Must hash id as it's ugc
                        type: typeMessage.defaultMessage,
                        product: 'github'
                    },
                    event: {
                        eventType: 'viewed',
                        timestamp: originalTimestamp || currentTimestamp
                    }
                },
                cursor: ''
            };
            edges.push(githubEdge);
        }
    });
    return $198609fd26633f18$var$limitToMostRecentActivities($198609fd26633f18$var$sortEdgesByTimestamp(edges), $198609fd26633f18$var$RECENT_ACTIVITIES_LIMIT);
};
const $198609fd26633f18$var$sortEdgesByTimestamp = (edges)=>{
    return edges.sort((a, b)=>{
        const timeA = new Date(a.node.event.timestamp).getTime();
        const timeB = new Date(b.node.event.timestamp).getTime();
        return timeB - timeA; // Descending order
    });
};
const $198609fd26633f18$var$limitToMostRecentActivities = (edges, limit = 200)=>{
    return edges.slice(0, limit);
};
const $198609fd26633f18$var$isJiraResult = (ari)=>{
    return ari.includes(':jira:');
};
const $198609fd26633f18$var$isConfluenceResult = (ari)=>{
    return ari.includes(':confluence:');
};
/**
 * Converts camelCase string to kebab-case
 * e.g., 'pullRequest' -> 'pull-request'
 */ const $198609fd26633f18$var$camelToKebab = (str)=>{
    return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};



var $abk4V = parcelRequire("abk4V");

var $7ULiR = parcelRequire("7ULiR");


var $joFH5 = parcelRequire("joFH5");

const $a3b72b1c5f32a0f4$var$GITHUB_CONTAINER_ID_PROD = 'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7';
const $a3b72b1c5f32a0f4$var$GITHUB_CONTAINER_ID_STAGING = '9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f';
/**
 * Checks if a service has available GitHub accounts
 * @param services - Array of services to check
 * @returns boolean - true if GitHub service has available or refreshNeeded accounts
 */ const $a3b72b1c5f32a0f4$var$hasAvailableGithubAccount = (services)=>{
    return !!services?.find((s)=>s?.service?.serviceKey === 'github')?.accounts?.some((a)=>a?.status === 'available' || a?.status === 'refreshNeeded');
};
const $a3b72b1c5f32a0f4$export$950899af45fc526 = async ({ aaid: aaid, strategy: strategy, degradationCallback: degradationCallback, cacheAnalyticsCallback: cacheAnalyticsCallback })=>{
    if (strategy === 'container-specific') {
        const targetContainerId = (0, $joFH5.getEnvironment)() === 'production' ? $a3b72b1c5f32a0f4$var$GITHUB_CONTAINER_ID_PROD : $a3b72b1c5f32a0f4$var$GITHUB_CONTAINER_ID_STAGING;
        const data = await (0, $7ULiR.fetchOutboundAuthData)({
            aaid: aaid,
            containerId: targetContainerId,
            serviceKey: 'github',
            degradationCallback: degradationCallback,
            cacheAnalyticsCallback: cacheAnalyticsCallback
        });
        return $a3b72b1c5f32a0f4$var$hasAvailableGithubAccount(data?.services);
    } else if (strategy === 'all-containers') {
        const data = await (0, $abk4V.fetchAccountsByAaId)({
            aaid: aaid,
            degradationCallback: degradationCallback,
            cacheAnalyticsCallback: cacheAnalyticsCallback
        });
        return !!data?.containers?.some((container)=>$a3b72b1c5f32a0f4$var$hasAvailableGithubAccount(container.services));
    }
    return false;
};





const $914d54e8bd9a1675$export$f7b7f83c551ecf0b = (existingItems, newItems)=>{
    const deduplicatedResults = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))([
        ...existingItems,
        ...newItems
    ], (item)=>item.id);
    // We sort to show the most recent autorefreshed results in pre-query state.
    try {
        deduplicatedResults.sort((a, b)=>new Date(b.data.node.event.timestamp).getTime() - new Date(a.data.node.event.timestamp).getTime());
    } catch  {
    // If we have an error, the results simply won't be sorted.
    }
    return deduplicatedResults;
};









var $kJsRi = parcelRequire("kJsRi");


var $4TXTZ = parcelRequire("4TXTZ");


var $9NDUe = parcelRequire("9NDUe");


var $2Gu9D = parcelRequire("2Gu9D");


var $3R0ts = parcelRequire("3R0ts");




const $33a13590dc77f914$export$caa45abe6a87e5b5 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: 'postQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });























// Default value hoisted outside to prevent recreation on every render
const $785f0e86c2e88315$var$DEFAULT_TASK_STATE = {
    id: null,
    started: false,
    completed: false,
    error: null
};
const $785f0e86c2e88315$var$VitalStatsTaskContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $785f0e86c2e88315$export$40a6847b10816750 = ({ children: children })=>{
    // Use hoisted default to prevent object recreation on every render
    const taskStateRef = (0, $42omo.useRef)($785f0e86c2e88315$var$DEFAULT_TASK_STATE);
    return /*#__PURE__*/ (0, $l998X.jsx)($785f0e86c2e88315$var$VitalStatsTaskContext.Provider, {
        value: taskStateRef,
        children: children
    });
};
const $785f0e86c2e88315$export$85fd2191723185b5 = ()=>{
    const taskStateRef = (0, $42omo.useContext)($785f0e86c2e88315$var$VitalStatsTaskContext);
    if (!taskStateRef) throw new Error('useVitalStatsTaskState must be used within QuickFindPostQueryVitalStatsProvider');
    return taskStateRef;
};


const $a755cc866a3495f8$export$3b18f7e3dc975b4 = 250;
const $a755cc866a3495f8$export$7ebf6620acc135ab = $a755cc866a3495f8$export$3b18f7e3dc975b4;
const $a755cc866a3495f8$export$9e8b58cc1c8bacd2 = ()=>{
    const debounceTimeout = (0, $j4ply.useUserShardDebounceTimeout)();
    return debounceTimeout ?? $a755cc866a3495f8$export$3b18f7e3dc975b4;
};
const $a755cc866a3495f8$export$483ef80309da5ade = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const serveUserShardModel = (0, $j4ply.useUserShardModel)();
    const { incrementQueryVersion: incrementQueryVersion } = (0, $djVCD.useSearchActions)();
    const onSearchCompleted = (0, $j4ply.useOnSearchCompleted)();
    const { fireAnalyticsEvent: fireQuickFindAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { fireAnalyticsEvent: fireVitalStatsEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const content = (0, $4VmlX.useContent)();
    const debounceTimeout = $a755cc866a3495f8$export$9e8b58cc1c8bacd2();
    // Store stable references for functions/values used in useEffect and useCallback
    // This avoids effects/callbacks re-running when analytics callbacks change,
    // while ensuring we always call the latest version via .current
    const fireVitalStatsEventRef = (0, $42omo.useRef)(fireVitalStatsEvent);
    const searchSessionIdRef = (0, $42omo.useRef)(searchSessionId);
    // State tracking for pre-query VitalStats events
    const preQueryTaskIdRef = (0, $42omo.useRef)(null);
    const preQueryTaskStartedRef = (0, $42omo.useRef)(false);
    const preQueryTaskCompletedRef = (0, $42omo.useRef)(false);
    const preQueryErrorRef = (0, $42omo.useRef)(null);
    // State tracking for post-query VitalStats events using shared context
    const postQueryTaskState = (0, $785f0e86c2e88315$export$85fd2191723185b5)();
    // Store stable reference to postQueryTaskState to avoid adding it to dependency arrays
    const postQueryTaskStateRef = (0, $42omo.useRef)(postQueryTaskState);
    // Track if we've handled cached state for this dialog session (postquery only)
    const handledCachedPostQueryStateRef = (0, $42omo.useRef)(false);
    // Track if we've handled cached state for prequery (when transitioning back from postquery)
    const handledCachedPreQueryStateRef = (0, $42omo.useRef)(false);
    // Track if we've handled initial dialog open with cached preQuery
    const handledInitialCachedPreQueryRef = (0, $42omo.useRef)(false);
    // Keep refs updated with latest values
    (0, $42omo.useEffect)(()=>{
        fireVitalStatsEventRef.current = fireVitalStatsEvent;
        searchSessionIdRef.current = searchSessionId;
        postQueryTaskStateRef.current = postQueryTaskState;
    }, [
        fireVitalStatsEvent,
        searchSessionId,
        postQueryTaskState
    ]);
    // Handle initial dialog open with cached preQuery results
    // This fires VitalStats events when dialog opens with existing preQuery data
    (0, $42omo.useEffect)(()=>{
        // Reset flag when dialog closes
        if (!quickFindOpen) {
            handledInitialCachedPreQueryRef.current = false;
            return;
        }
        // Only fire once per dialog open session
        if (handledInitialCachedPreQueryRef.current) return;
        const state = content?.state;
        // Only fire if we have preQuery results showing but no task has started yet
        // This handles the case where dialog opens with cached preQuery results
        // Skip if we came from postQuery (that case is handled by the transition-back useEffect)
        if (state === 'PREQUERY_RESULTS' && !preQueryTaskStartedRef.current && !postQueryTaskStateRef.current.current.started) {
            handledInitialCachedPreQueryRef.current = true;
            // Use existing taskId if already set (e.g., by warmup request), otherwise generate new one
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            const taskId = preQueryTaskIdRef.current;
            preQueryTaskStartedRef.current = true;
            // Fire both taskStart and taskSuccess immediately (results are cached)
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        quickFindOpen,
        content?.state
    ]);
    // Reset VitalStats state when dialog closes
    (0, $42omo.useEffect)(()=>{
        if (!quickFindOpen) {
            // Fire taskAbort if postQuery task is in progress
            if (postQueryTaskState.current.started && !postQueryTaskState.current.completed) (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskAbort)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: {
                        abortReason: 'dialog_closed_during_network'
                    }
                }));
            });
            preQueryTaskStartedRef.current = false;
            preQueryTaskIdRef.current = null;
            preQueryTaskCompletedRef.current = false;
            preQueryErrorRef.current = null;
            postQueryTaskState.current.started = false;
            postQueryTaskState.current.id = null;
            postQueryTaskState.current.completed = false;
            // NOTE: We intentionally DO NOT clear postQueryTaskState.current.error here
            // so that when the dialog reopens with cached POSTQUERY_ERROR state,
            // we can still include error details in the taskFail event
            handledCachedPostQueryStateRef.current = false; // Reset for next open
            handledCachedPreQueryStateRef.current = false; // Reset for next open
            handledInitialCachedPreQueryRef.current = false; // Reset for next open
        }
    }, [
        quickFindOpen,
        postQueryTaskState
    ]);
    // Fire taskSuccess/taskFail when content state changes
    (0, $42omo.useEffect)(()=>{
        if (!preQueryTaskStartedRef.current || preQueryTaskCompletedRef.current) // Don't fire if task hasn't started or already completed
        return;
        if (content?.state === 'PREQUERY_RESULTS') {
            // Task succeeds when PRE_QUERY results are shown
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskCompletedRef.current = true;
        } else if (content?.state === 'PREQUERY_ERROR') {
            // Include error information if available (errorName and errorMessage for debugging)
            const moreContext = preQueryErrorRef.current ? {
                errorName: preQueryErrorRef.current.name,
                errorMessage: preQueryErrorRef.current.message
            } : undefined;
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskFail)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS,
                    moreContext: moreContext
                }));
            });
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        content?.state
    ]);
    // Reset preQuery tracking when transitioning back from POSTQUERY to PREQUERY
    (0, $42omo.useEffect)(()=>{
        const state = content?.state;
        // If we're back in PREQUERY state after being in POSTQUERY, reset preQuery tracking
        // so that new preQuery VitalStats events can fire
        if (state === 'PREQUERY_RESULTS' || state === 'PREQUERY_ERROR' || state === 'PREQUERY_LOADING') // Check if we previously had a postQuery task (indicates we're transitioning back)
        {
            if (postQueryTaskStateRef.current.current.started) {
                // Abort the postQuery task if it's still active (not completed)
                // This handles the case where user backspaces/clears text before postQuery results arrive
                if (!postQueryTaskStateRef.current.current.completed) {
                    (0, $42omo.startTransition)(()=>{
                        fireVitalStatsEventRef.current((0, $bQSQw.onTaskAbort)({
                            searchSessionId: searchSessionIdRef.current,
                            taskId: postQueryTaskStateRef.current.current.id,
                            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                            moreContext: {
                                abortReason: 'text_cleared'
                            }
                        }));
                    });
                    postQueryTaskStateRef.current.current.completed = true;
                }
                // Reset preQuery tracking flags to allow new preQuery task to start
                preQueryTaskStartedRef.current = false;
                preQueryTaskCompletedRef.current = false;
                preQueryTaskIdRef.current = null;
            }
        }
    }, [
        content?.state
    ]);
    // Fire taskSuccess/taskFail for post-query when content state changes
    (0, $42omo.useEffect)(()=>{
        if (!postQueryTaskState.current.started || postQueryTaskState.current.completed) // Don't fire if task hasn't started or already completed
        return;
        const state = content?.state;
        if (state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS') {
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
                }));
            });
            postQueryTaskState.current.completed = true;
        } else if (state === 'POSTQUERY_ERROR') {
            // Include error information if available (errorName and errorMessage for debugging)
            const moreContext = postQueryTaskState.current.error ? {
                errorName: postQueryTaskState.current.error.name,
                errorMessage: postQueryTaskState.current.error.message
            } : undefined;
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskFail)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: moreContext
                }));
            });
            postQueryTaskState.current.completed = true;
        }
    }, [
        content?.state,
        postQueryTaskState
    ]);
    // Handle cached terminal states when dialog reopens
    // This fires VitalStats events for cached POSTQUERY_RESULTS/NO_RESULTS/ERROR states
    // when the dialog opens but no new fetch happens (e.g., same query as before)
    (0, $42omo.useEffect)(()=>{
        if (!quickFindOpen) return;
        // Only fire if task hasn't been started yet (dialog just opened)
        if (postQueryTaskState.current.started) return;
        // Only fire once per dialog open session
        if (handledCachedPostQueryStateRef.current) return;
        const state = content?.state;
        // Check if we have cached terminal postquery states
        if (state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS' || state === 'POSTQUERY_ERROR') {
            // Mark as handled to prevent duplicate events
            handledCachedPostQueryStateRef.current = true;
            // Start and immediately complete the task for the cached state
            const taskId = crypto.randomUUID();
            postQueryTaskState.current.id = taskId;
            postQueryTaskState.current.started = true;
            postQueryTaskState.current.completed = true;
            // Fire taskStart and completion events (defer to not block rendering)
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
                }));
                // Immediately fire completion event based on cached state
                if (state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS') fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
                }));
                else if (state === 'POSTQUERY_ERROR') {
                    // Note: error might be null since it was cleared on dialog close
                    const moreContext = postQueryTaskState.current.error ? {
                        errorName: postQueryTaskState.current.error.name,
                        errorMessage: postQueryTaskState.current.error.message
                    } : undefined;
                    fireVitalStatsEventRef.current((0, $bQSQw.onTaskFail)({
                        searchSessionId: searchSessionIdRef.current,
                        taskId: taskId,
                        task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                        moreContext: moreContext
                    }));
                }
            });
            // Clear error after it's been used to prevent memory accumulation
            if (state === 'POSTQUERY_ERROR') postQueryTaskState.current.error = null;
        }
    }, [
        quickFindOpen,
        content?.state,
        postQueryTaskState
    ]);
    // Handle transition back to PREQUERY_RESULTS from postquery states
    // This fires VitalStats events when user clears the search text and returns to prequery
    (0, $42omo.useEffect)(()=>{
        const state = content?.state;
        // Reset the flag when entering postquery states so we can track the next transition back
        if (state === 'POSTQUERY_LOADING' || state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS' || state === 'POSTQUERY_ERROR') {
            handledCachedPreQueryStateRef.current = false;
            return;
        }
        // Only handle PREQUERY_RESULTS state
        if (state !== 'PREQUERY_RESULTS') return;
        // Don't fire if we've already handled this transition
        if (handledCachedPreQueryStateRef.current) return;
        // Only fire if we previously had a postquery task (meaning we're transitioning back from postquery)
        // We fire events even if preQueryCompleted is false because the results might be cached
        // (i.e., dialog opened with existing cached results, so onPreQueryStart was never called)
        if (postQueryTaskStateRef.current.current.started) {
            // Mark as handled to prevent duplicate events
            handledCachedPreQueryStateRef.current = true;
            // Reset prequery flags and start a new prequery task for the cached results
            // Use existing taskId if already set (e.g., by warmup request), otherwise generate new one
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            const taskId = preQueryTaskIdRef.current;
            preQueryTaskStartedRef.current = true;
            preQueryTaskCompletedRef.current = false; // Set to false first so the state-watching useEffect doesn't interfere
            // Fire taskStart and taskSuccess (defer to not block rendering)
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
                // Immediately fire taskSuccess for cached prequery results
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            // Now mark as completed
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        content?.state
    ]);
    // Delete useUFOExperience when cleaning up qf-remove-old-ufo-metric FG
    const { start: startPreQuery, success: successPreQuery, failure: failurePreQuery } = (0, $2Gu9D.useUFOExperience)({
        id: `${primaryProduct}-pre-query-results-load`,
        component: 'search-dialog',
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    // Delete useUFOExperience when cleaning up qf-remove-old-ufo-metric FG
    const { start: startPostQuery, success: successPostQuery, failure: failurePostQuery, abort: abortPostQuery } = (0, $2Gu9D.useUFOExperience)({
        id: `${primaryProduct}-post-query-results-load`,
        component: 'search-dialog',
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    /**
	 * Called when pre-query search starts.
	 * Fires VitalStats taskStart event to track the beginning of the pre-query operation.
	 * Only fires when Quick Find is actually open (not during background preloading).
	 * Ensures taskStart is only fired once per session.
	 */ const onPreQueryStart = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('qf-remove-old-ufo-metric')) startPreQuery();
        // Fire VitalStats taskStart event only if Quick Find is open and not already started
        // Skip if cached POSTQUERY results are showing (postQuery events will handle that case)
        if (quickFindOpen && !preQueryTaskStartedRef.current) {
            // Check if we have cached postQuery results - if so, don't fire preQuery events
            const state = content?.state;
            if (state === 'POSTQUERY_RESULTS' || state === 'POSTQUERY_NO_RESULTS' || state === 'POSTQUERY_ERROR') // Cached postQuery state detected - skip preQuery tracking
            // The cached postQuery useEffect will handle firing postQuery events
            return;
            // Generate a consistent taskId for this pre-query task
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskStartedRef.current = true;
            // If cached preQuery data is already showing,
            // immediately fire taskSuccess since the useEffect won't trigger (no state change)
            if (content?.state === 'PREQUERY_RESULTS') {
                (0, $42omo.startTransition)(()=>{
                    fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                        searchSessionId: searchSessionIdRef.current,
                        taskId: preQueryTaskIdRef.current,
                        task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                    }));
                });
                preQueryTaskCompletedRef.current = true;
            }
        }
    }, [
        startPreQuery,
        quickFindOpen,
        content?.state
    ]);
    /**
	 * Called when pre-query search completes successfully.
	 * VitalStats taskSuccess event is automatically fired by useEffect when content.state changes to PREQUERY_RESULTS.
	 */ const onPreQuerySuccess = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('qf-remove-old-ufo-metric')) successPreQuery({
            metadata: {
                isQuickFind: true
            }
        });
    // VitalStats success event is handled by useEffect watching content.state
    }, [
        successPreQuery
    ]);
    /**
	 * Called when pre-query search fails with an error.
	 * Stores error details (name, message) which will be included in the VitalStats taskFail event.
	 * VitalStats taskFail event is automatically fired by useEffect when content.state changes to PREQUERY_ERROR.
	 *
	 * @param error - Optional Error object containing failure details. Error messages should not contain PII.
	 */ const onPreQueryFailure = (0, $42omo.useCallback)((error)=>{
        if (!(0, $dh538.fg)('qf-remove-old-ufo-metric')) failurePreQuery();
        // Store error for useEffect to access
        if (error) preQueryErrorRef.current = error;
    // VitalStats fail event is handled by useEffect watching content.state
    }, [
        failurePreQuery
    ]);
    const onPostQueryStart = (0, $42omo.useCallback)(()=>{
        // If dialog is closed, fire taskStart + immediate taskAbort to track background cache request
        // Network request still fires for caching, but user isn't waiting for it
        if (!quickFindOpen) {
            // Generate taskId for the background cache request
            const taskId = crypto.randomUUID();
            postQueryTaskState.current.id = taskId;
            postQueryTaskState.current.started = true;
            postQueryTaskState.current.completed = true; // Mark as completed immediately
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
                }));
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskAbort)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: {
                        abortReason: 'dialog_closed_before_debounce_fired'
                    }
                }));
            });
            return;
        }
        // Abort previous task if still active
        if (postQueryTaskState.current.started && !postQueryTaskState.current.completed) (0, $42omo.startTransition)(()=>{
            fireVitalStatsEventRef.current((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionIdRef.current,
                taskId: postQueryTaskState.current.id,
                task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                moreContext: {
                    abortReason: 'superseded_by_new_query'
                }
            }));
        });
        // Start new task - use existing taskId if already set (e.g., by fetchQuickFindPostQuery)
        // Only generate a new one if not already set or if we just aborted a previous task
        if (!postQueryTaskState.current.id || postQueryTaskState.current.started) postQueryTaskState.current.id = crypto.randomUUID();
        const taskId = postQueryTaskState.current.id;
        postQueryTaskState.current.started = true;
        postQueryTaskState.current.completed = false;
        (0, $42omo.startTransition)(()=>{
            fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                searchSessionId: searchSessionIdRef.current,
                taskId: taskId,
                task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
            }));
        });
        /**
		 * QS-7380 (LDR: https://hello.atlassian.net/wiki/x/QVo8QwE)
		 * Aborting on keypress fires a lot of dirty data volume to ufo. Instead we only instrument on query (inside the debounce), offsetting the start time by the debounce window because the keypress that trigger the debounce is the start of the interaction.
		 */ const startTimestamp = performance.now() - debounceTimeout;
        if ((0, $dh538.fg)('quick_find_metrics_cancel_postquery_on_close')) // Only begin the interaction if QF is still open
        // If QF is closed, we still make the network request, so the next open of the same text is instant
        // However, we must not start the interaction, as if QF is closed during the debounce window, this interaction can abort other intreractions, like FPS search results shown!
        {
            if (quickFindOpen) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_POST_QUERY_INTERACTION), startTimestamp);
        } else (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_POST_QUERY_INTERACTION), startTimestamp);
        // ufo-v1 (above is react-ufo)
        const restartMetric = async ()=>{
            if (!(0, $dh538.fg)('qf-remove-old-ufo-metric')) {
                await abortPostQuery();
                if ((0, $dh538.fg)('quick_find_metrics_cancel_postquery_on_close')) {
                    if (quickFindOpen) await startPostQuery();
                } else await startPostQuery();
            }
        };
        restartMetric();
    }, [
        abortPostQuery,
        startPostQuery,
        quickFindOpen,
        debounceTimeout,
        postQueryTaskState
    ]);
    const onPostQuerySuccess = (0, $42omo.useCallback)((duration, hasThirdPartyResults, resultCount)=>{
        incrementQueryVersion();
        onSearchCompleted?.(resultCount, quickFindQuery);
        if (!(0, $dh538.fg)('qf-remove-old-ufo-metric')) successPostQuery({
            metadata: {
                isQuickFind: true,
                isHello: isHello,
                use3PResults: serveUserShardModel,
                hasThirdPartyResults: hasThirdPartyResults
            }
        });
        fireQuickFindAnalyticsEvent((0, $33a13590dc77f914$export$caa45abe6a87e5b5)({
            attributes: {
                ...commonAttributes,
                postQueryRequestDurationMs: duration,
                hasThirdPartyResults: hasThirdPartyResults
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireQuickFindAnalyticsEvent,
        incrementQueryVersion,
        nonPrivacySafeAttributes,
        isHello,
        serveUserShardModel,
        successPostQuery,
        onSearchCompleted,
        quickFindQuery
    ]);
    const onPostQueryFailure = (0, $42omo.useCallback)((error)=>{
        if (!(0, $dh538.fg)('qf-remove-old-ufo-metric')) failurePostQuery();
        (0, $kJsRi.setInteractionError)((0, $3R0ts.QUICK_FIND_POST_QUERY_INTERACTION), {
            errorMessage: error?.message || 'request failed',
            name: error?.name || 'request failed'
        });
        // Store error for useEffect to access when state changes to POSTQUERY_ERROR
        if (error) postQueryTaskState.current.error = error;
    }, [
        failurePostQuery,
        postQueryTaskState
    ]);
    const onPostQueryCancel = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('qf-remove-old-ufo-metric')) abortPostQuery();
    }, [
        abortPostQuery
    ]);
    return (0, $42omo.useMemo)(()=>({
            onPreQueryStart: onPreQueryStart,
            onPreQuerySuccess: onPreQuerySuccess,
            onPreQueryFailure: onPreQueryFailure,
            onPostQueryStart: onPostQueryStart,
            onPostQuerySuccess: onPostQuerySuccess,
            onPostQueryFailure: onPostQueryFailure,
            onPostQueryCancel: onPostQueryCancel,
            postQueryTaskState: postQueryTaskState,
            preQueryTaskIdRef: preQueryTaskIdRef
        }), [
        onPostQueryCancel,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess,
        postQueryTaskState
    ]);
};



var $3paC4 = parcelRequire("3paC4");

var $iUYhn = parcelRequire("iUYhn");




const $ef123373d1331d42$export$15543ec9771a9a65 = async (user, cloudId)=>{
    const searchClient = (0, $3paC4.createClient)({
        cloudId: cloudId || ''
    });
    const searchProjectsResponse = await searchClient.search({
        query: '',
        resultLimit: 1,
        scopes: [
            (0, $iUYhn.Scope).JiraProject
        ],
        analytics: {
            identifier: 'quick-find'
        }
    });
    const firstProject = searchProjectsResponse?.response.rawData.scopes?.[0]?.results?.[0];
    return [
        {
            id: 'product-filter',
            title: 'Suggested product filter',
            type: 'filter-suggestion',
            data: {
                product: {
                    filterName: 'app',
                    option: {
                        value: (0, $1yEFx.PrimaryProductKeys).Jira,
                        label: 'Jira'
                    }
                },
                ...firstProject && {
                    jProject: {
                        filterName: 'project',
                        option: {
                            value: firstProject.id,
                            label: firstProject.name
                        }
                    }
                },
                ...user?.id && {
                    jAssignee: {
                        filterName: 'assignee',
                        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                        option: {
                            value: user.id,
                            label: user.name || 'me'
                        }
                    }
                }
            }
        }
    ];
};


const $eb3355f5ff6969a5$export$fad190a164f62f75 = ()=>{
    return 'all-containers';
};



var $1L3gY = parcelRequire("1L3gY");

const $6e53edd4c7804f3e$export$290039782fc4e47 = async (query, organizationId, primaryProduct, principalId, siteId)=>{
    // Override townsquare with watermelon as URS does not support townsquare as a primary product
    const productKey = primaryProduct === 'townsquare' ? 'watermelon' : primaryProduct;
    const response = await (0, $1L3gY.default)({
        query: query,
        context: {
            contextType: 'quick_find',
            siteId: siteId,
            productKey: productKey,
            principalId: principalId,
            organizationId: organizationId
        },
        includeUsers: true,
        includeTeams: true,
        includeGroups: false,
        maxNumberOfResults: 2,
        performSearchQueryOnly: false,
        searchQuery: {
            filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)'
        }
    });
    return response.map($6e53edd4c7804f3e$export$cf1f13813d90479a);
};
const $6e53edd4c7804f3e$export$cf1f13813d90479a = (result)=>({
        id: result.id,
        title: result.name || result.displayName || '',
        data: result,
        type: 'people-and-teams'
    });











var $6jKOp = parcelRequire("6jKOp");

var $johDC = parcelRequire("johDC");


var $chwej = parcelRequire("chwej");


var $hm6w9 = parcelRequire("hm6w9");


var $idpYy = parcelRequire("idpYy");








var $dOOW1 = parcelRequire("dOOW1");


var $5XpfZ = parcelRequire("5XpfZ");

const $d781446cbf339237$var$createValidationError = (message)=>{
    return {
        success: false,
        error: {
            name: 'ValidationError',
            message: message
        }
    };
};
const $d781446cbf339237$var$validateBaseSearchResultsResponse = (response)=>{
    if (!response) return $d781446cbf339237$var$createValidationError('Response is null or undefined');
    // GraphQL response should always include a `data` key (it can be null)
    if (!('data' in response)) return $d781446cbf339237$var$createValidationError('Response missing "data" field');
    if (!response.data) return {
        success: true
    };
    const data = response.data;
    if (!data.search) return $d781446cbf339237$var$createValidationError('Response missing "data.search" field');
    if (!data.search.results) return $d781446cbf339237$var$createValidationError('Response missing "data.search.results" field');
    if (!('edges' in data.search.results)) return $d781446cbf339237$var$createValidationError('Response missing "data.search.results.edges" field');
    if (!Array.isArray(data.search.results.edges)) return $d781446cbf339237$var$createValidationError('Expected "data.search.results.edges" to be an array');
    if (response.extensions !== undefined && response.extensions !== null) {
        if (typeof response.extensions !== 'object') return $d781446cbf339237$var$createValidationError('Expected "extensions" to be an object');
    }
    if (response.errors !== undefined && response.errors !== null) {
        if (!Array.isArray(response.errors)) return $d781446cbf339237$var$createValidationError('Expected "errors" to be an array');
    }
    return {
        success: true
    };
};
const $d781446cbf339237$var$validateEdgesHaveRenderableNodes = (response, productName)=>{
    const baseResult = $d781446cbf339237$var$validateBaseSearchResultsResponse(response);
    if (!baseResult.success) return baseResult;
    if (!response.data) return {
        success: true
    };
    const edges = response.data.search?.results?.edges;
    if (!edges || edges.length === 0) return {
        success: true
    };
    for(let i = 0; i < edges.length; i++){
        const node = edges[i]?.node;
        if (!node) return $d781446cbf339237$var$createValidationError(`${productName} response has null/undefined node at index ${i}`);
        if (!node.id || typeof node.id !== 'string' || node.id.length === 0) return $d781446cbf339237$var$createValidationError(`${productName} response node at index ${i} missing valid 'id'`);
        // title can be empty string but not null/undefined
        if (node.title === null || node.title === undefined) return $d781446cbf339237$var$createValidationError(`${productName} response node at index ${i} missing 'title'`);
    }
    return {
        success: true
    };
};
const $d781446cbf339237$export$20b56250dbe571a6 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Confluence entities');
};
const $d781446cbf339237$export$8a51174b28efed00 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Confluence spaces');
};
const $d781446cbf339237$export$bced2ae2552eb202 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Jira issues');
};
const $d781446cbf339237$export$543d873e6345fc5d = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Jira entities');
};
const $d781446cbf339237$export$e4f72abe33981720 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Atlas');
};
const $d781446cbf339237$export$871e055bca75b7a7 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Mercury');
};
const $d781446cbf339237$export$ed329220155db920 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Talent');
};
const $d781446cbf339237$export$e72eeeb1dc40af20 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Assets');
};


const $d482bbe0b8132b8c$var$experience = 'quick-find';
const $d482bbe0b8132b8c$var$userShardAbTestId = 'quick-find-user-shard-search-experiment';
/**
 * Builds merged headers combining atl-attribution and region steering headers.
 * Feature flag check for atl-attribution is handled internally by buildAtlAttributionHeaders.
 */ const $d482bbe0b8132b8c$var$buildMergedHeaders = (cloudId, activationId, sourceProduct, productDataRegions)=>{
    // Feature flag check is handled internally by buildAtlAttributionHeaders
    const atlAttributionHeaders = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: sourceProduct
    });
    const regionSteeringHeaders = (0, $2OtFZ.serveRegionSteeringExperiment)() && sourceProduct && productDataRegions ? {
        'atl-edge-region-hint': (0, $chwej.getEdgeRegionHint)(sourceProduct, productDataRegions)
    } : undefined;
    if (!atlAttributionHeaders && !regionSteeringHeaders) return undefined;
    return {
        ...regionSteeringHeaders,
        ...atlAttributionHeaders
    };
};
const $d482bbe0b8132b8c$export$263a3384b7ce18b1 = (thirdPartyConfigs)=>{
    const excluded3PProducts = [
        (0, $1yEFx.ProductKeys3P).Slack,
        (0, $1yEFx.ProductKeys3P).Teams,
        (0, $1yEFx.ProductKeys3P).Gmail,
        (0, $1yEFx.ProductKeys3P).OutlookMail
    ];
    // Adding additional 3P products not included in thirdPartyConfigs
    const additional3PProducts = [
        (0, $1yEFx.ProductKeys3P).Loom
    ];
    const thirdPartyKeys = Object.keys(thirdPartyConfigs);
    const quickFind3PProducts = additional3PProducts.concat(thirdPartyKeys).filter((productKey)=>!excluded3PProducts.includes(productKey));
    return (0, $dOOW1.getThirdPartyFilters)(quickFind3PProducts, false, [], thirdPartyConfigs);
};
const $d482bbe0b8132b8c$var$getUserShardExperimentOverrides = ({ isUserShardModel: isUserShardModel, isUserShardControl: isUserShardControl, experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId, userShardL1LayerId: userShardL1LayerId })=>{
    const l2LayerId = isUserShardModel ? 'L2-pipelineOnly' : 'default';
    const finalExperimentId = isUserShardModel ? 'L1-usershard' : experimentId ?? undefined;
    const finalShadowExperimentId = shadowExperimentId ?? undefined;
    const finalExperimentLayers = isUserShardModel || isUserShardControl ? [
        {
            name: 'search_platform_layer_l1',
            layerId: null,
            shadowId: null,
            definitions: [
                {
                    layerId: userShardL1LayerId,
                    entity: '*',
                    subEntity: '*',
                    shadowId: null,
                    abTestId: $d482bbe0b8132b8c$var$userShardAbTestId
                }
            ],
            analyticsDefinitions: [
                {
                    layerId: userShardL1LayerId,
                    entity: '*',
                    subEntity: '*',
                    shadowId: null,
                    abTestId: $d482bbe0b8132b8c$var$userShardAbTestId,
                    controlId: 'default'
                }
            ]
        },
        {
            name: 'search_platform_layer_l2',
            layerId: null,
            shadowId: null,
            definitions: [
                {
                    layerId: l2LayerId,
                    entity: '*',
                    subEntity: '*',
                    shadowId: null,
                    abTestId: $d482bbe0b8132b8c$var$userShardAbTestId
                }
            ],
            analyticsDefinitions: [
                {
                    layerId: l2LayerId,
                    entity: '*',
                    subEntity: '*',
                    shadowId: null,
                    abTestId: $d482bbe0b8132b8c$var$userShardAbTestId,
                    controlId: 'default'
                }
            ]
        }
    ] : experimentLayers;
    return {
        finalExperimentId: finalExperimentId,
        finalShadowExperimentId: finalShadowExperimentId,
        finalExperimentLayers: finalExperimentLayers
    };
};
// Experiment cohorts explained here: https://hello.atlassian.net/wiki/spaces/CentAI/pages/6112212590/Experiment+Milestones+for+Adding+3Ps+to+Search+Results
const $d482bbe0b8132b8c$var$serve3PinQuickFindTest1 = (prerequisiteConditions)=>{
    return prerequisiteConditions && (0, $c6GJD.default).getExperimentValue('quick_find_3p_search_results_experiment', 'cohort', 'control') === 'test-1';
};
// Experiment cohorts explained here: https://hello.atlassian.net/wiki/spaces/CentAI/pages/6112212590/Experiment+Milestones+for+Adding+3Ps+to+Search+Results
const $d482bbe0b8132b8c$var$serve3PinQuickFindTest2 = (prerequisiteConditions)=>{
    return prerequisiteConditions && (0, $c6GJD.default).getExperimentValue('quick_find_3p_search_results_experiment', 'cohort', 'control') === 'test-2';
};
const $d482bbe0b8132b8c$export$3c29f91d40cd1d3f = (thirdPartyConfigs)=>{
    // Pre-requisite 1: We should not request 3P in Quick Find if the user is enrolled in the User Shard experiment
    // Context:
    // * https://atlassian.slack.com/archives/C050EC6FM28/p1762995060918559?thread_ts=1762980919.126129&cid=C050EC6FM28
    // * https://atlassian.slack.com/archives/C085K9CRCCS/p1762988464471699
    const { cohort: userShardCohort } = (0, $2OtFZ.getUserShardExperimentFlags)();
    const isNotEnrolledInUserShard = userShardCohort === undefined;
    // Prerequisite 2: We should not request 3P in Quick Find if the user does not have any 3P authenticated
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    const prerequisiteConditions = isNotEnrolledInUserShard && isEligible3PUser;
    const serveTest1 = $d482bbe0b8132b8c$var$serve3PinQuickFindTest1(prerequisiteConditions);
    const serveTest2 = $d482bbe0b8132b8c$var$serve3PinQuickFindTest2(prerequisiteConditions);
    return {
        serveThirdPartyFilters: serveTest1 || serveTest2,
        serveGraphDocument: serveTest1 || serveTest2,
        serveGraphSmartlinks: serveTest1 || serveTest2,
        skip3pHydration: serveTest1 || serveTest2,
        serveAdditionalGraphEntities: serveTest1
    };
};
const $d482bbe0b8132b8c$export$9605a5c4a68b2654 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, filteredEntities, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const isUserShardModel = (0, $2OtFZ.serveUserShardModel)();
    const isUserShardUI = (0, $2OtFZ.serveUserShardUI)();
    const isUserShardControl = (0, $2OtFZ.serveUserShardControl)();
    const userShardPageL1Id = (0, $2OtFZ.getUserShardPageL1Id)();
    const quickFind3PExperiment = $d482bbe0b8132b8c$export$3c29f91d40cd1d3f(thirdPartyConfigs);
    const userShardL1LayerId = isUserShardModel ? userShardPageL1Id ?? 'L1-usershard-shosexp' : 'default';
    const thirdPartyFilters = quickFind3PExperiment.serveThirdPartyFilters ? $d482bbe0b8132b8c$export$263a3384b7ce18b1(thirdPartyConfigs) : {
        titleMatchOnly: true,
        subtypes: []
    };
    const supportedEntities = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost',
        'ati:cloud:confluence:attachment',
        'ati:cloud:confluence:whiteboard',
        'ati:cloud:confluence:database',
        'ati:cloud:confluence:embed',
        'ati:cloud:confluence:folder',
        ...isUserShardModel || quickFind3PExperiment.serveGraphDocument ? [
            'ati:cloud:graph:document'
        ] : [],
        ...(0, $dh538.fg)('quickfind-smartlinks') || quickFind3PExperiment.serveGraphSmartlinks ? [
            'ati:cloud:graph:remote-link'
        ] : [],
        ...quickFind3PExperiment.serveAdditionalGraphEntities ? [
            'ati:cloud:graph:branch',
            'ati:cloud:graph:calendar-event',
            'ati:cloud:graph:design',
            'ati:cloud:graph:pull-request',
            'ati:cloud:graph:repository',
            'ati:cloud:graph:video',
            'ati:cloud:graph:work-item'
        ] : []
    ];
    const entities = supportedEntities.filter((supportedEntity)=>filteredEntities.includes(supportedEntity));
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId,
        thirdPartyFilters: thirdPartyFilters
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const { finalExperimentId: finalExperimentId, finalShadowExperimentId: finalShadowExperimentId, finalExperimentLayers: finalExperimentLayers } = $d482bbe0b8132b8c$var$getUserShardExperimentOverrides({
        isUserShardModel: isUserShardModel,
        isUserShardControl: isUserShardControl,
        experimentLayers: experimentLayers,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        userShardL1LayerId: userShardL1LayerId
    });
    // Default behaviour currently is to include the confluenceEntity hydration,
    // hence the control is to include it. But we check that the cohort is explicitly
    // 'test' to ensure that this user is actually in the experiment.
    const excludeConfluenceEntity = (0, $c6GJD.default).getExperimentValue('remove_confluence_entity_hydration_experiment', 'cohort', 'control') === 'test';
    const limit = isUserShardUI ? 10 : 7;
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: limit,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: finalExperimentId ?? undefined,
        shadowExperimentId: finalShadowExperimentId ?? undefined,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(finalExperimentLayers),
        includeSocialSignals: false,
        includeUserSignals: isUserShardUI,
        includeSpaceSubtype: false,
        includeConfluenceEntity: !excludeConfluenceEntity,
        skipFieldsFor3pInQuickFind: quickFind3PExperiment.skip3pHydration,
        includeAutocompleteSuggestions: (0, $dh538.fg)('fe_quickfind_autocomplete_suggestions')
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            serveUserShardUI: isUserShardUI,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$20b56250dbe571a6)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined,
            autocompleteSuggestions: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$919c2c6ec09a9e2 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:confluence:space'
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const isUserShardModel = (0, $2OtFZ.serveUserShardModel)();
    const isUserShardControl = (0, $2OtFZ.serveUserShardControl)();
    const userShardSpaceL1Id = (0, $2OtFZ.getUserShardSpaceL1Id)();
    const userShardL1LayerId = isUserShardModel ? userShardSpaceL1Id ?? 'default' : 'default';
    const { finalExperimentId: finalExperimentId, finalShadowExperimentId: finalShadowExperimentId, finalExperimentLayers: finalExperimentLayers } = $d482bbe0b8132b8c$var$getUserShardExperimentOverrides({
        isUserShardModel: isUserShardModel,
        isUserShardControl: isUserShardControl,
        experimentLayers: experimentLayers,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        userShardL1LayerId: userShardL1LayerId
    });
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 1,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: finalExperimentId ?? undefined,
        shadowExperimentId: finalShadowExperimentId ?? undefined,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(finalExperimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            serveUserShardUI: false,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$8a51174b28efed00)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchSpacesRequestId: response.extensions?.gateway?.request_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchSpacesRequestId: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$65df7212bf163b08 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const quickFind3PExperiment = $d482bbe0b8132b8c$export$3c29f91d40cd1d3f(thirdPartyConfigs);
    const thirdPartyFilters = quickFind3PExperiment.serveThirdPartyFilters ? $d482bbe0b8132b8c$export$263a3384b7ce18b1(thirdPartyConfigs) : {
        titleMatchOnly: false,
        subtypes: []
    };
    const entities = [
        'ati:cloud:townsquare:project',
        'ati:cloud:townsquare:goal',
        'ati:cloud:townsquare:tag',
        ...quickFind3PExperiment.serveGraphDocument ? [
            'ati:cloud:graph:document'
        ] : [],
        ...quickFind3PExperiment.serveGraphSmartlinks ? [
            'ati:cloud:graph:remote-link'
        ] : [],
        ...quickFind3PExperiment.serveAdditionalGraphEntities ? [
            'ati:cloud:graph:branch',
            'ati:cloud:graph:calendar-event',
            'ati:cloud:graph:design',
            'ati:cloud:graph:pull-request',
            'ati:cloud:graph:repository',
            'ati:cloud:graph:video',
            'ati:cloud:graph:work-item'
        ] : []
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        assetsFilters: assetsFilters,
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: true,
            contentStatuses: [],
            containerStatus: []
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        skipFieldsFor3pInQuickFind: quickFind3PExperiment.skip3pHydration
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            serveUserShardUI: false,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$e4f72abe33981720)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$60162ce0dfbba9f8 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const passionfruitAskEntity = 'ati:cloud:passionfruit:ask';
    const entities = [
        'ati:cloud:mercury:focus-area',
        'ati:cloud:mercury:focus-area-status-update',
        ...(0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled') ? [
            passionfruitAskEntity
        ] : []
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            serveUserShardUI: false,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$871e055bca75b7a7)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$39ffd40a0e828404 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, thirdPartyFilters: thirdPartyFilters, talentFilters: talentFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:radar:position'
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        talentFilters: talentFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            serveUserShardUI: false,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$ed329220155db920)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$7e4a42258e6edc26 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:cmdb:object',
        'ati:cloud:cmdb:schema',
        'ati:cloud:cmdb:type'
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$e72eeeb1dc40af20)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
/**
 * The experiment layers are mapped to ensure permitted attributes are sent into search requests.
 */ const $d482bbe0b8132b8c$var$mapExperimentLayers = (experimentLayers)=>experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
            name: name,
            layerId: layerId,
            shadowId: shadowId,
            definitions: definitions
        }));
const $d482bbe0b8132b8c$export$eaafe46561fa4ee5 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, isJiraIssueIndexed, thirdPartyConfigs, typeFilterEntities, sessionId, hasEditOrViewPlanPermission, networkCallbacks, activationId)=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, jiraFilters: jiraFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery } = typeFilterEntities;
    const supportedEntities = [
        (0, $idpYy.JIRA_ISSUE_ENTITY_ATI),
        (0, $idpYy.JIRA_PROJECT_ENTITY_ATI),
        (0, $idpYy.JIRA_BOARD_ENTITY_ATI),
        (0, $idpYy.JIRA_FILTER_ENTITY_ATI),
        (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
    ];
    if (hasEditOrViewPlanPermission || !(0, $dh538.fg)('rovo_search_check_plan_permission')) supportedEntities.push((0, $idpYy.JIRA_PLAN_ENTITY_ATI));
    const entities = selectedEntities.length ? supportedEntities.filter((supportedEntity)=>entitiesForQuery.includes(supportedEntity)) : [
        (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId,
        isJiraIssueIndexed: isJiraIssueIndexed
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
        tenantId: cloudId,
        limit: (0, $dh538.fg)('search_qf_increase_issues_in_jira') ? 12 : 7,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeJiraIssueType: true,
        includeSpaceSubtype: false,
        assetsFilters: assetsFilters
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            serveUserShardUI: false,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$bced2ae2552eb202)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined,
            autocompleteSuggestions: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$cfa5e5437133749b = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, isJiraIssueIndexed, thirdPartyConfigs, sessionId, hasEditOrViewPlanPermission, networkCallbacks, activationId)=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, jiraFilters: jiraFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        (0, $idpYy.JIRA_BOARD_ENTITY_ATI),
        (0, $idpYy.JIRA_FILTER_ENTITY_ATI),
        (0, $idpYy.JIRA_PROJECT_ENTITY_ATI),
        (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
    ];
    if (hasEditOrViewPlanPermission || !(0, $dh538.fg)('rovo_search_check_plan_permission')) entities.push((0, $idpYy.JIRA_PLAN_ENTITY_ATI));
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId,
        isJiraIssueIndexed: isJiraIssueIndexed
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
        tenantId: cloudId,
        limit: 5,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        assetsFilters: assetsFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeJiraBoardContainer: true,
        includeSpaceSubtype: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$543d873e6345fc5d)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            autocompleteSuggestions: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$cf1f13813d90479a = (result)=>{
    // Detect and filter out invalid/empty nodes from API
    // Allow empty strings but not null/undefined
    if (!result || !result.id || result.title == null) return null;
    return {
        id: result.id,
        title: result.title,
        data: result,
        type: 'search-result'
    };
};
/**
 * Processes nodes and filters out invalid ones.
 */ const $d482bbe0b8132b8c$var$processAndValidateNodes = (nodes)=>{
    const mappedNodes = nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a);
    const validNodes = mappedNodes.filter((node)=>node !== null);
    return validNodes;
};



var $1SV4e = parcelRequire("1SV4e");

const $1435b53be5ab4d50$export$d6415f081f333b17 = (primaryProduct, userId)=>{
    const recentSearches = (0, $1SV4e.getRecentSearches)(userId, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
    return recentSearches.map($1435b53be5ab4d50$export$cf1f13813d90479a);
};
const $1435b53be5ab4d50$export$cf1f13813d90479a = (query)=>({
        id: query,
        title: query,
        data: query,
        type: 'recent-query'
    });








const $2bb736a7e62c9305$export$6e4070116bdfa183 = ({ query: query, hasFiltersSelected: hasFiltersSelected })=>{
    return Boolean(query || hasFiltersSelected);
};
const $2bb736a7e62c9305$var$preQueryErrorHandler = ({ hasQueryOrFilters: hasQueryOrFilters, preQueryError: preQueryError, postQueryDisabled: postQueryDisabled })=>{
    if ((!hasQueryOrFilters || postQueryDisabled) && preQueryError) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
};
const $2bb736a7e62c9305$var$preQueryLoadingHandler = ({ hasQueryOrFilters: hasQueryOrFilters, preQueryLoading: preQueryLoading, filteredRecentQueries: filteredRecentQueries, postQueryDisabled: postQueryDisabled })=>{
    if ((!hasQueryOrFilters || postQueryDisabled) && preQueryLoading) return {
        state: 'PREQUERY_LOADING',
        query: '',
        recentQueries: filteredRecentQueries
    };
};
const $2bb736a7e62c9305$var$preQueryNoResultsHandler = ({ hasQueryOrFilters: hasQueryOrFilters, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, filteredZeroQueries: filteredZeroQueries, postQueryDisabled: postQueryDisabled })=>{
    const totalResults = filteredRecentActivities.result.length + filteredUserDocuments.result.length + filteredZeroQueries.length;
    if ((!hasQueryOrFilters || postQueryDisabled) && totalResults === 0) return {
        state: 'PREQUERY_NO_RESULTS',
        query: ''
    };
};
const $2bb736a7e62c9305$var$preQueryResultsHandler = ({ hasQueryOrFilters: hasQueryOrFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, filteredZeroQueries: filteredZeroQueries, postQueryDisabled: postQueryDisabled, filterSuggestions: filterSuggestions })=>{
    const totalResults = filteredRecentActivities.result.length + filteredUserDocuments.result.length + filteredZeroQueries.length;
    if ((!hasQueryOrFilters || postQueryDisabled) && totalResults > 0) return {
        state: 'PREQUERY_RESULTS',
        query: '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result,
        userDocuments: filteredUserDocuments.result,
        zeroQueries: filteredZeroQueries,
        filterSuggestions: filterSuggestions.result
    };
};
const $2bb736a7e62c9305$var$postQueryErrorHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, postQueryError: postQueryError, postQueryDisabled: postQueryDisabled })=>{
    if (hasQueryOrFilters && !postQueryDisabled && postQueryError) return {
        state: 'POSTQUERY_ERROR',
        query: query || ''
    };
};
const $2bb736a7e62c9305$var$postQueryLoadingHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, postQueryLoading: postQueryLoading, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, filteredRecentQueries: filteredRecentQueries, filteredZeroQueries: filteredZeroQueries, postQueryDisabled: postQueryDisabled, primaryProduct: primaryProduct, autocompleteSuggestions: autocompleteSuggestions })=>{
    if (hasQueryOrFilters && !postQueryDisabled && postQueryLoading) {
        // zero queries are only relevant for Jira in post query loading state
        const zeroQueries = primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira ? filteredZeroQueries : [];
        return {
            state: 'POSTQUERY_LOADING',
            query: query || '',
            recentActivities: filteredRecentActivities.result,
            userDocuments: filteredUserDocuments.result,
            recentQueries: filteredRecentQueries,
            zeroQueries: zeroQueries,
            autocompleteSuggestions: autocompleteSuggestions?.map((suggestion, index)=>({
                    id: `autocomplete-suggestion-${index}`,
                    title: suggestion,
                    data: suggestion,
                    type: 'autocomplete-suggestion'
                }))
        };
    }
};
const $2bb736a7e62c9305$var$postQueryNoResultsHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled })=>{
    const totalResults = filteredRecentActivities.result.length + filteredUserDocuments.result.length + searchResults.result.length + peopleAndTeams.result.length;
    if (hasQueryOrFilters && !postQueryDisabled && totalResults === 0) return {
        state: 'POSTQUERY_NO_RESULTS',
        query: query || ''
    };
};
const $2bb736a7e62c9305$var$postQueryResultsHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled, filteredZeroQueries: filteredZeroQueries, primaryProduct: primaryProduct, autocompleteSuggestions: autocompleteSuggestions })=>{
    // zero queries are only relevant for Jira in post query results state
    const zeroQueries = primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira ? filteredZeroQueries : [];
    const totalResults = filteredRecentActivities.result.length + filteredUserDocuments.result.length + searchResults.result.length + peopleAndTeams.result.length + zeroQueries.length;
    if (hasQueryOrFilters && !postQueryDisabled && totalResults > 0) return {
        state: 'POSTQUERY_RESULTS',
        query: query || '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result,
        userDocuments: filteredUserDocuments.result,
        searchResults: searchResults.result,
        peopleAndTeams: peopleAndTeams.result,
        zeroQueries: zeroQueries,
        autocompleteSuggestions: autocompleteSuggestions?.map((suggestion, index)=>({
                id: `autocomplete-suggestion-${index}`,
                title: suggestion,
                data: suggestion,
                type: 'autocomplete-suggestion'
            }))
    };
};
const $2bb736a7e62c9305$export$35ead133d529e85e = (args)=>{
    if (!args.quickFindOpen) return;
    const serveQFAppSelector = (0, $2OtFZ.serveQFAppSelectorExperiment)(args.primaryProduct, {
        fireExperimentExposure: false
    });
    const hasProductSelected = (serveQFAppSelector && args.hasProductSelected) ?? false;
    const hasQueryOrFilters = $2bb736a7e62c9305$export$6e4070116bdfa183({
        query: args.query,
        hasFiltersSelected: args.hasFiltersSelected || hasProductSelected
    });
    const handlers = [
        $2bb736a7e62c9305$var$preQueryErrorHandler,
        $2bb736a7e62c9305$var$preQueryLoadingHandler,
        $2bb736a7e62c9305$var$preQueryNoResultsHandler,
        $2bb736a7e62c9305$var$preQueryResultsHandler,
        $2bb736a7e62c9305$var$postQueryErrorHandler,
        $2bb736a7e62c9305$var$postQueryLoadingHandler,
        $2bb736a7e62c9305$var$postQueryNoResultsHandler,
        $2bb736a7e62c9305$var$postQueryResultsHandler
    ];
    for (const handler of handlers){
        const result = handler({
            ...args,
            hasQueryOrFilters: hasQueryOrFilters
        });
        if (result) return result;
    }
    // This should never happen, but default to error state
    if (!args.query) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
    else return {
        state: 'POSTQUERY_ERROR',
        query: args.query
    };
};






var $2Kn8h = parcelRequire("2Kn8h");

const $cc3e7a06b2b7df3f$export$eb4e7dba9a53c2c6 = async (cloudId, userId, aggAbsoluteUrl, headers)=>{
    const serveAutorefreshCohort = (0, $c6GJD.default).getExperimentValue('quick_find_autorefresh_experiment_v3', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'autorefresh';
    const response = serveAutorefreshCohort ? await (0, $2Kn8h.cachedUserDocumentsQuery)({
        variables: {
            userId: userId,
            tenantId: cloudId,
            caller: 'quick-find',
            maxNumberOfResults: 6
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        onlyRefreshIfExpired: true,
        returnExpired: false,
        headers: headers
    }) : await (0, $2Kn8h.userDocumentsQuery)({
        variables: {
            userId: userId,
            tenantId: cloudId,
            caller: 'quick-find',
            maxNumberOfResults: 6
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers
    });
    const recommendedObjects = response.data?.smarts?.recommendedObject || [];
    return recommendedObjects.filter((r)=>Boolean(r.object)).map($cc3e7a06b2b7df3f$export$cf1f13813d90479a);
};
const $cc3e7a06b2b7df3f$export$cf1f13813d90479a = (result)=>{
    return {
        id: result.id,
        title: result?.object?.title || '',
        data: result,
        type: 'user-document'
    };
};



var $bz34M = parcelRequire("bz34M");

const $3e8764e0c86280c1$export$90241958e8ec24d5 = async (variables, headers)=>await (0, $bz34M.zeroQueriesQuery)({
        variables: variables,
        headers: headers
    }).then((response)=>{
        const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueries.zeroQueries || [];
        const shuffledZeroQueries = [
            ...zeroQueries
        ].sort(()=>Math.random() - 0.5);
        return shuffledZeroQueries.map($3e8764e0c86280c1$export$cf1f13813d90479a);
    });
const $3e8764e0c86280c1$export$e4c44fb2ea08e0f2 = async (variables, headers)=>await (0, $bz34M.zeroQueriesQueryV1)({
        variables: variables,
        headers: headers
    }).then((response)=>{
        const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueriesV1.zeroQueries || [];
        const shuffledZeroQueries = [
            ...zeroQueries
        ].sort(()=>Math.random() - 0.5);
        return shuffledZeroQueries.map($3e8764e0c86280c1$export$cf1f13813d90479a);
    });
const $3e8764e0c86280c1$export$cf1f13813d90479a = (zeroQuery)=>({
        id: zeroQuery.query,
        title: zeroQuery.query,
        data: zeroQuery.query,
        product: zeroQuery.product,
        accountId: zeroQuery.accountId,
        avatarUrl: zeroQuery.avatarUrl,
        dateRange: zeroQuery.dateRange,
        type: 'zero-query',
        zeroQueryType: zeroQuery.type
    });
const $3e8764e0c86280c1$export$123c86f509cbd0ab = async (variables, headers)=>await (0, $bz34M.zeroQueriesMutation)({
        variables: variables,
        headers: headers
    }).then((response)=>response.data?.knowledgeDiscovery.markZeroQueryInteracted.success ?? false);
const $3e8764e0c86280c1$export$5ceed206e02a9ef = async (variables, headers)=>await (0, $bz34M.zeroQueriesMutationV1)({
        variables: variables,
        headers: headers
    }).then((response)=>response.data?.knowledgeDiscovery.markZeroQueryInteractedV1.success ?? false);


const $0c35e478cf8dbc82$var$EMPTY_RESULTS = {
    result: [],
    duration: 0
};
const $0c35e478cf8dbc82$export$ab15aae48c593ecc = ({ postQueryDisabled: postQueryDisabled, onPreQueryStart: onPreQueryStart, onPreQuerySuccess: onPreQuerySuccess, onPreQueryFailure: onPreQueryFailure, onPostQueryStart: onPostQueryStart, onPostQuerySuccess: onPostQuerySuccess, onPostQueryFailure: onPostQueryFailure, onPostQueryCancel: onPostQueryCancel, postQueryTaskState: postQueryTaskState, preQueryTaskIdRef: preQueryTaskIdRef })=>{
    const [bootstrap] = (0, $j4ply.useBootstrap)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const isSearchReady = (0, $djVCD.useIsSearchReady)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const sessionId = (0, $a0M2t.getSessionIdFromLocalStorage)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const logException = (0, $f8oYd.useLogException)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [retryCount] = (0, $djVCD.useRetryCount)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setRequestedBackendExperiments: setRequestedBackendExperiments } = (0, $djVCD.useSearchActions)();
    const serveUserShardUI = (0, $j4ply.useUserShardUI)();
    const serveUserShardModel = (0, $j4ply.useUserShardModel)();
    const { selectedFilters: selectedFilters, entities: entities, hasFiltersSelected: hasFiltersSelected } = (0, $4VkIo.useSelectedFilters)({
        experience: (0, $hHl3d.SearchExperience).QUICK_FIND
    });
    const useTypeEntitiesArgs = (0, $42omo.useMemo)(()=>({
            thirdPartyConfigs: bootstrap.thirdPartyConfigs
        }), [
        bootstrap.thirdPartyConfigs
    ]);
    const typeFilterEntities = (0, $djVCD.useTypeEntities)(useTypeEntitiesArgs);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const debounceTimeout = (0, $a755cc866a3495f8$export$9e8b58cc1c8bacd2)();
    const { createNetworkCallbacks: createNetworkCallbacks } = (0, $d4ba038bc3c9327c$export$c24470e080406156)();
    /**
	 * Unfortunately, we need to reintroduce this to avoid unnecessarily
	 * fetching results for the same query and filters.
	 *
	 * In order to understand why this is needed, we must first understand that
	 * the filters object is one gigantic object - whenver any kind of updates
	 * happens to the filters, the object reference changes, as it should. This
	 * includes when the loaded options in the filters change, e.g. when opening
	 * the space filter or typing into the lookup query for the filter. These
	 * user interactions cause the filters object to change, which in turn causes
	 * the references of selectedFilters and entities to change, regardless of
	 * whether or not search parameters (query, filters and entities) have changed.
	 *
	 * In the past, we were able to get away wih reacting on references changes
	 * of selectedFilters and entities as it was impossible for filters to change
	 * in Quick Find without actually changing the search parameters. Now that
	 * there are UI elements in Quick Find (e.g. space filter), this is no longer
	 * true.
	 *
	 * This is temporary until we move to search requests being triggered on user
	 * interactions, rather than state updates, which will happen as part of Relay
	 * migration.
	 */ const selectedFiltersEquality = JSON.stringify(selectedFilters);
    const entitiesEquality = JSON.stringify(entities);
    const prevQueryRef = (0, $42omo.useRef)();
    const prevQuickFindOpenRef = (0, $42omo.useRef)(quickFindOpen);
    const warmupRequestWasFired = (0, $42omo.useRef)(false);
    const onPreQuerySuccessWasFired = (0, $42omo.useRef)(false);
    const prevSelectedFiltersEquality = (0, $42omo.useRef)();
    const prevEntitiesEquality = (0, $42omo.useRef)();
    const prevHasFiltersSelected = (0, $42omo.useRef)(hasFiltersSelected);
    const fetchRecentActivitiesPromiseRef = (0, $42omo.useRef)();
    const fetchUserDocumentsPromiseRef = (0, $42omo.useRef)();
    const fetchGithubActivitiesPromiseRef = (0, $42omo.useRef)();
    const githubActivitiesResultRef = (0, $42omo.useRef)();
    const preQueryPromiseRef = (0, $42omo.useRef)();
    const postQueryPromiseRef = (0, $42omo.useRef)();
    const prevSelectedProduct = (0, $42omo.useRef)(selectedProduct);
    const hasGithubSmartLinkAccessRef = (0, $42omo.useRef)();
    const { setUpdateRecentQueries: setUpdateRecentQueries, setFetchEntitiesRequestId: setFetchEntitiesRequestId, setFetchEntitiesTraceId: setFetchEntitiesTraceId, setUpdateZeroQueries: setUpdateZeroQueries, setFetchSpacesRequestId: setFetchSpacesRequestId, setSearchErrors: setSearchErrors } = (0, $4VmlX.useQuickFindActions)();
    const [preQueryLoading, setPreQueryLoading] = (0, $42omo.useState)(true);
    const [preQueryError, setPreQueryError] = (0, $42omo.useState)();
    const [postQueryLoading, setPostQueryLoading] = (0, $42omo.useState)(false);
    const [postQueryError, setPostQueryError] = (0, $42omo.useState)();
    const [recentQueries, setRecentQueries] = (0, $42omo.useState)([]);
    const [filteredRecentQueries, setFilteredRecentQueries] = (0, $42omo.useState)([]);
    const [filteredRecentActivities, setFilteredRecentActivities] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [filteredUserDocuments, setFilteredUserDocuments] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [filteredZeroQueries, setFilteredZeroQueries] = (0, $42omo.useState)([]);
    const [zeroQueries, setZeroQueries] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [searchResults, setSearchResults] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [peopleAndTeams, setPeopleAndTeams] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [filterSuggestions, setFilterSuggestions] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [visibleFilterSuggestions, setVisibleFilterSuggestions] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const serveQFAppSelector = (0, $2OtFZ.serveQFAppSelectorExperiment)(bootstrap.primaryProduct, {
        fireExperimentExposure: false
    });
    const [autocompleteSuggestions, setAutocompleteSuggestions] = (0, $42omo.useState)(undefined);
    const serveFilterSuggestion = (0, $2OtFZ.serveQFFilterSuggestionExperiment)(bootstrap.primaryProduct, {
        fireLayerExposure: false
    });
    const serveZeroQuery = (bootstrap.primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence || bootstrap.primaryProduct === (0, $1yEFx.PrimaryProductKeys).Atlas || bootstrap.primaryProduct === (0, $1yEFx.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) && (0, $dh538.fg)('kd_zero_query_in_qf_fg') || bootstrap.primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira;
    const userRelevantDocumentsEnabled = (0, $dh538.fg)('quick_find_user_documents') && bootstrap.primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence;
    const { serveAutorefreshCohort: serveAutorefreshCohort } = (0, $42omo.useMemo)(()=>{
        const cohort = (0, $c6GJD.default).getExperimentValue('quick_find_autorefresh_experiment_v3', 'cohort', 'control', // We need to know the cohort in order to refresh the activities query, but we are NOT triggering the exposure
        // event here since we should be doing that every time the search dialog opens (not every time the hook re-renders)
        {
            fireExperimentExposure: false
        });
        return {
            serveAutorefreshCohort: cohort === 'autorefresh'
        };
    }, []);
    const workspaceId = bootstrap.primaryProduct && bootstrap.cloudId && bootstrap.analyticsAttributes?.activationId ? `ari:cloud:${bootstrap.primaryProduct}:${bootstrap.cloudId}:workspace/${bootstrap.analyticsAttributes.activationId}` : '';
    let atlAttributionHeaderValue;
    const useKdZeroQueryAtlHeader = (0, $dh538.fg)('kd_zero_query_agg_atl_attribution_header');
    const useRovoSearchAtlHeader = (0, $dh538.fg)('rovo-search-atl-header');
    if (useKdZeroQueryAtlHeader || useRovoSearchAtlHeader) // fg check is stable between renders and won't cause issues with hook calls
    // eslint-disable-next-line react-hooks/rules-of-hooks
    atlAttributionHeaderValue = (0, $42omo.useMemo)(()=>(0, $jwO5V.createAtlAttributionHeaderValue)({
            atlWorkspaceId: workspaceId,
            tenantId: bootstrap.cloudId || '',
            product: bootstrap.primaryProduct || ''
        }), [
        ,
        bootstrap.cloudId,
        bootstrap.primaryProduct,
        workspaceId
    ]);
    /**
	 * Callback to update recent queries for the current product and user
	 */ const fetchRecentQueries = (0, $42omo.useCallback)(()=>{
        if (!bootstrap.primaryProduct || !bootstrap.user?.id) return;
        const recentQueries = (0, $1435b53be5ab4d50$export$d6415f081f333b17)(bootstrap.primaryProduct, bootstrap.user.id);
        setRecentQueries(recentQueries);
    }, [
        bootstrap.primaryProduct,
        bootstrap.user?.id,
        setRecentQueries
    ]);
    /**
	 * Store the callback to update recent queries in the store. This is used to refresh recent queries
	 * when they are updated, e.g. when a search request is made or when a recent query is removed.
	 */ (0, $42omo.useEffect)(()=>{
        fetchRecentQueries();
        setUpdateRecentQueries(fetchRecentQueries);
    }, [
        fetchRecentQueries,
        setUpdateRecentQueries
    ]);
    /**
	 * Callback to fetch recent activities
	 */ const fetchRecentActivitiesCallback = (0, $42omo.useCallback)(async (cursor)=>{
        if (!bootstrap.cloudId) return [];
        const headers = useRovoSearchAtlHeader && atlAttributionHeaderValue ? {
            'atl-attribution': atlAttributionHeaderValue
        } : undefined;
        const taskId = crypto.randomUUID();
        const taskStartAt = performance.now();
        const baseVitalStatsParams = {
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_RECENT_ACTIVITIES_UX
        };
        fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskStart)(baseVitalStatsParams)));
        const networkCallbacks = (0, $dh538.fg)('rovo-search-vitalstats-quickfind-recents-network') ? createNetworkCallbacks({
            taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_RECENT_ACTIVITIES_NETWORK,
            uxTaskId: taskId,
            isPreQuery: true
        }) : undefined;
        try {
            const recentActivities = await (0, $198609fd26633f18$export$ae65634d024c5427)(bootstrap.cloudId, bootstrap.aggAbsoluteUrl, bootstrap.experimentConfig, cursor, bootstrap.thirdPartyConfigs, headers, bootstrap.primaryProduct, networkCallbacks);
            // It doesn't distinguish between a network call and fetching from cache.
            // We can consolidate that once quick_find_autorefresh_experiment_v3 is shipped.
            fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskSuccess)({
                ...baseVitalStatsParams,
                moreContext: {
                    timeTaken: performance.now() - taskStartAt,
                    resultsLoaded: recentActivities.length,
                    resultsWithFailedHydration: recentActivities.filter((activity)=>activity.data?.node?.object?.data === null).map((activity)=>activity.id)
                }
            })));
            return recentActivities;
        } catch (error) {
            fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
                ...baseVitalStatsParams,
                moreContext: {
                    error: error instanceof Error ? error.message : String(error),
                    timeTaken: performance.now() - taskStartAt
                }
            })));
            throw error;
        }
    }, [
        bootstrap.cloudId,
        bootstrap.aggAbsoluteUrl,
        bootstrap.experimentConfig,
        bootstrap.thirdPartyConfigs,
        searchSessionId,
        fireAnalyticsEvent,
        atlAttributionHeaderValue,
        useRovoSearchAtlHeader,
        bootstrap.primaryProduct,
        createNetworkCallbacks
    ]);
    const fetchUserDocumentsCallback = (0, $42omo.useCallback)(async ()=>{
        if (bootstrap.cloudId && bootstrap.user?.id && (bootstrap.primaryProduct === 'confluence' || bootstrap.primaryProduct === 'rovo-extension' && (0, $dh538.fg)('quickfind-rovo-extension'))) {
            const headers = useRovoSearchAtlHeader && atlAttributionHeaderValue ? {
                'atl-attribution': atlAttributionHeaderValue
            } : undefined;
            return (0, $cc3e7a06b2b7df3f$export$eb4e7dba9a53c2c6)(bootstrap.cloudId, bootstrap.user.id, bootstrap.aggAbsoluteUrl, headers);
        } else return [];
    }, [
        bootstrap.cloudId,
        bootstrap.user?.id,
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        useRovoSearchAtlHeader,
        atlAttributionHeaderValue
    ]);
    const fetchFilterSuggestionsCallback = (0, $42omo.useCallback)(async ()=>(0, $ef123373d1331d42$export$15543ec9771a9a65)(bootstrap.user, bootstrap.cloudId), [
        bootstrap.user,
        bootstrap.cloudId
    ]);
    /*
	 * Call filter suggestions as an independent call to avoid delays to the critical path */ (0, $42omo.useEffect)(()=>{
        // Only load the filter suggestions if it's Jira
        if (bootstrap.primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && serveFilterSuggestion) (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchFilterSuggestionsCallback).then((result)=>{
            setFilterSuggestions(result ?? $0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }).catch((error)=>{
            logException(error);
            setFilterSuggestions($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        });
    }, [
        fetchFilterSuggestionsCallback,
        logException,
        bootstrap.primaryProduct,
        serveFilterSuggestion
    ]);
    /**
	 * Callback to fetch zero queries
	 */ const fetchZeroQueriesCallback = (0, $42omo.useCallback)(()=>{
        if (!bootstrap.cloudId) return;
        const fetchFn = (0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(isHello) ? (0, $3e8764e0c86280c1$export$e4c44fb2ea08e0f2) : (0, $3e8764e0c86280c1$export$90241958e8ec24d5);
        (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>fetchFn({
                cloudId: bootstrap.cloudId,
                product: (0, $1yEFx.getUppercasePrimaryProductKey)(bootstrap.primaryProduct)
            }, useKdZeroQueryAtlHeader && atlAttributionHeaderValue ? {
                'atl-attribution': atlAttributionHeaderValue
            } : {})).then((result)=>{
            setZeroQueries(result ?? $0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }).catch((error)=>{
            logException(error);
            setZeroQueries($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        });
    }, [
        bootstrap.cloudId,
        logException,
        bootstrap.primaryProduct,
        atlAttributionHeaderValue,
        useKdZeroQueryAtlHeader,
        isHello
    ]);
    /**
	 * Store the callback to update zero queries in the store. This is used to refresh zero queries
	 * when they are updated, e.g. when a zero query is clicked.
	 */ (0, $42omo.useEffect)(()=>{
        if (serveZeroQuery) fetchZeroQueriesCallback();
        setUpdateZeroQueries(fetchZeroQueriesCallback);
    }, [
        fetchZeroQueriesCallback,
        setUpdateZeroQueries,
        serveZeroQuery
    ]);
    const serveGithubLinksHydrationCohort = (0, $42omo.useMemo)(()=>{
        const cohort = (0, $c6GJD.default).getExperimentValue('enable_github_links_hydration_in_quickfind_recent', 'cohort', 'control', {
            fireExperimentExposure: false
        });
        return cohort === 'test';
    }, []);
    const githubFullConnectorAuthorised = (0, $42omo.useMemo)(()=>{
        const githubConfig = bootstrap.thirdPartyConfigs?.[(0, $hB77E.ProductKeys3P).Github];
        return !!(githubConfig && !githubConfig.userNeedsOAuth);
    }, [
        bootstrap.thirdPartyConfigs
    ]);
    const checkGithubSmartLinkAccess = (0, $42omo.useCallback)(async ()=>{
        const aaid = bootstrap.user?.id;
        if (!aaid) return false;
        return (async ()=>{
            try {
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $dmTG5.onDegradedDependency)({
                        dependency: `outbound-auth-github`,
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE)
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3htW4.onRequestCacheAccess)({
                        requestName: 'outbound-auth-github',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE)
                    }));
                };
                return await (0, $a3b72b1c5f32a0f4$export$950899af45fc526)({
                    aaid: aaid,
                    strategy: (0, $eb3355f5ff6969a5$export$fad190a164f62f75)(),
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback
                });
            } catch (error) {
                fireAnalyticsEvent((0, $cFN1h.onFailedDependency)({
                    dependency: 'outbound-auth-github',
                    searchSessionId: searchSessionId,
                    source: (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE)
                }));
                logException(error instanceof Error ? error : new Error(String(error)));
                return false;
            }
        })();
    }, [
        bootstrap.user?.id,
        logException,
        fireAnalyticsEvent,
        searchSessionId
    ]);
    hasGithubSmartLinkAccessRef.current = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('enable_github_quickfind_experiment')) {
            if (githubFullConnectorAuthorised) return Promise.resolve(true);
            else return checkGithubSmartLinkAccess();
        }
        return Promise.resolve(false);
    }, [
        checkGithubSmartLinkAccess,
        githubFullConnectorAuthorised
    ]);
    const fetchGithubActivitiesCallback = (0, $42omo.useCallback)(async (recentActivities)=>{
        if (!serveGithubLinksHydrationCohort || fetchGithubActivitiesPromiseRef.current) return;
        const headers = useRovoSearchAtlHeader && atlAttributionHeaderValue ? {
            'atl-attribution': atlAttributionHeaderValue
        } : undefined;
        fetchGithubActivitiesPromiseRef.current = (async ()=>{
            if (githubFullConnectorAuthorised || await hasGithubSmartLinkAccessRef.current) (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>(0, $198609fd26633f18$export$9bda9a715c3ed911)(recentActivities, bootstrap.aggAbsoluteUrl, logException, headers)).then(({ result: githubEdges, duration: duration })=>{
                githubActivitiesResultRef.current = {
                    result: githubEdges,
                    duration: duration
                };
            }).catch((error)=>{
                logException(error);
                githubActivitiesResultRef.current = $0c35e478cf8dbc82$var$EMPTY_RESULTS;
            });
            else githubActivitiesResultRef.current = $0c35e478cf8dbc82$var$EMPTY_RESULTS;
        })();
    }, [
        bootstrap.aggAbsoluteUrl,
        logException,
        serveGithubLinksHydrationCohort,
        githubFullConnectorAuthorised,
        useRovoSearchAtlHeader,
        atlAttributionHeaderValue
    ]);
    /**
	 * Callback to fetch pre-query results and updates the store with the results
	 */ const fetchQuickFindPreQuery = (0, $42omo.useCallback)((query, hideFilteredPreQueryResults, shouldRefetchPreQueryResults)=>{
        if (hideFilteredPreQueryResults) {
            setFilteredRecentQueries([]);
            setFilteredRecentActivities($0c35e478cf8dbc82$var$EMPTY_RESULTS);
            setFilteredZeroQueries([]);
            userRelevantDocumentsEnabled && setFilteredUserDocuments($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }
        if (!fetchRecentActivitiesPromiseRef.current || !fetchUserDocumentsPromiseRef.current) {
            setPreQueryError(undefined);
            setPreQueryLoading(true);
            onPreQueryStart?.();
        }
        if (!fetchRecentActivitiesPromiseRef.current) {
            const fetchRecentActivitiesPromise = (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchRecentActivitiesCallback).catch((error)=>{
                logException(error);
                setPreQueryError(error);
                onPreQueryFailure?.(error);
                fetchRecentActivitiesPromiseRef.current = undefined;
                return $0c35e478cf8dbc82$var$EMPTY_RESULTS;
            });
            fetchRecentActivitiesPromiseRef.current = fetchRecentActivitiesPromise;
        }
        if (!fetchUserDocumentsPromiseRef.current) {
            if (userRelevantDocumentsEnabled) {
                const fetchUserDocumentsPromise = (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchUserDocumentsCallback).catch((error)=>{
                    logException(error);
                    onPreQueryFailure?.(error);
                    fetchUserDocumentsPromiseRef.current = undefined;
                    return $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                });
                fetchUserDocumentsPromiseRef.current = fetchUserDocumentsPromise;
            } else fetchUserDocumentsPromiseRef.current = Promise.resolve($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }
        if (shouldRefetchPreQueryResults) {
            // mutual exclusivity with postQuery tasks
            (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>fetchRecentActivitiesCallback()).then((results)=>{
                setPreQueryError(undefined);
                fetchRecentActivitiesPromiseRef.current = Promise.all([
                    fetchRecentActivitiesPromiseRef.current,
                    Promise.resolve(results)
                ]).then(([existingResults, newResults])=>{
                    const deduplicatedResults = (0, $914d54e8bd9a1675$export$f7b7f83c551ecf0b)(existingResults?.result ?? [], newResults?.result ?? []);
                    return {
                        result: deduplicatedResults,
                        duration: newResults.duration
                    };
                });
            }).catch((error)=>{
                logException(error);
                onPreQueryFailure?.(error);
            });
            if (userRelevantDocumentsEnabled) (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>fetchUserDocumentsCallback()).then((results)=>{
                fetchUserDocumentsPromiseRef.current = Promise.all([
                    fetchUserDocumentsPromiseRef.current,
                    Promise.resolve(results)
                ]).then(([existingResults, newResults])=>{
                    const result = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))([
                        ...newResults?.result ?? [],
                        ...existingResults?.result ?? []
                    ], (item)=>item.id);
                    return {
                        result: result,
                        duration: newResults.duration
                    };
                });
            }).catch((error)=>{
                logException(error);
                onPreQueryFailure?.(error);
            });
        }
        const preQueryPromise = new (0, $czt8s.CancellablePromise)(Promise.all([
            fetchRecentActivitiesPromiseRef.current,
            fetchUserDocumentsPromiseRef.current
        ]));
        preQueryPromiseRef.current = preQueryPromise;
        preQueryPromise.promise().then(([recentActivities, userDocuments])=>{
            if (!onPreQuerySuccessWasFired.current) {
                onPreQuerySuccess?.();
                onPreQuerySuccessWasFired.current = true;
            }
            setPreQueryLoading(false);
            if (hideFilteredPreQueryResults) return;
            const filteredRecentQueries = (0, $jjjIy.filterSearchResults)(recentQueries, query);
            setFilteredRecentQueries(filteredRecentQueries);
            if (bootstrap.primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) {
                // We only filter zero queries for Jira as it's needed in post-query state
                const filteredZeroQueries = (0, $jjjIy.filterSearchResults)(zeroQueries.result, query);
                setFilteredZeroQueries(filteredZeroQueries);
            } else setFilteredZeroQueries(zeroQueries.result);
            fetchGithubActivitiesCallback(recentActivities);
            if (serveGithubLinksHydrationCohort && githubActivitiesResultRef.current) {
                const filteredRecentActivities = (0, $jjjIy.filterSearchResults)((0, $914d54e8bd9a1675$export$f7b7f83c551ecf0b)(recentActivities.result, githubActivitiesResultRef.current.result), query);
                setFilteredRecentActivities({
                    result: filteredRecentActivities,
                    duration: recentActivities.duration + githubActivitiesResultRef.current.duration
                });
            } else {
                const filteredRecentActivities = (0, $jjjIy.filterSearchResults)(recentActivities.result, query);
                setFilteredRecentActivities({
                    result: filteredRecentActivities,
                    duration: recentActivities.duration
                });
            }
            if (bootstrap.primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) setVisibleFilterSuggestions(filterSuggestions);
            if (userRelevantDocumentsEnabled) {
                const filteredUserDocuments = (0, $jjjIy.filterSearchResults)(userDocuments.result, query);
                setFilteredUserDocuments({
                    result: filteredUserDocuments,
                    duration: userDocuments.duration
                });
            }
        }).catch(()=>{
        // no-op on cancel
        }).finally(()=>{
            preQueryPromiseRef.current = undefined;
        });
    }, [
        fetchRecentActivitiesCallback,
        fetchGithubActivitiesCallback,
        fetchUserDocumentsCallback,
        logException,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess,
        recentQueries,
        zeroQueries,
        userRelevantDocumentsEnabled,
        bootstrap.primaryProduct,
        serveGithubLinksHydrationCohort,
        filterSuggestions
    ]);
    /**
	 * Callback to fetch confluence entities
	 * @param uxTaskId - The UX task ID to associate with the network requests
	 * @param isPreQuery - Whether this is a pre-query (warmup) request. Defaults to false.
	 */ const fetchConfluenceEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return Promise.all([
            (0, $d482bbe0b8132b8c$export$9605a5c4a68b2654)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, entities, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
                taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_CONFLUENCE_ENTITIES_NETWORK,
                uxTaskId: uxTaskId,
                isPreQuery: isPreQuery
            }), bootstrap.analyticsAttributes?.activationId),
            (0, $d482bbe0b8132b8c$export$919c2c6ec09a9e2)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
                taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_CONFLUENCE_SPACES_NETWORK,
                uxTaskId: uxTaskId,
                isPreQuery: isPreQuery
            }), bootstrap.analyticsAttributes?.activationId)
        ]).then((results)=>{
            const [entities, spaces] = results;
            return {
                results: [
                    ...entities.fetchResults,
                    ...spaces.fetchResults
                ],
                fetchEntitiesRequestId: entities.fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: entities.fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: spaces.fetchSpacesRequestId ?? undefined,
                errors: [
                    ...entities.errors || [],
                    ...spaces.errors || []
                ],
                autocompleteSuggestions: entities.autocompleteSuggestions
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        entities,
        sessionId,
        createNetworkCallbacks
    ]);
    /**
	 * Callback to fetch atlas entities
	 */ const fetchAtlasEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $d482bbe0b8132b8c$export$65df7212bf163b08)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_ATLAS_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: fetchResults,
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchAssetsEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $d482bbe0b8132b8c$export$7e4a42258e6edc26)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_ASSETS_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: fetchResults,
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchMercuryEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $d482bbe0b8132b8c$export$60162ce0dfbba9f8)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_MERCURY_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: [
                    ...fetchResults
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchTalentEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return (0, $d482bbe0b8132b8c$export$39ffd40a0e828404)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_TALENT_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }), bootstrap.analyticsAttributes?.activationId).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results;
            return {
                results: [
                    ...fetchResults
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchJiraIssuesCallback = (0, $42omo.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        const issuesAndTypesCallbacks = createNetworkCallbacks({
            taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_JIRA_ISSUES_AND_TYPES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        });
        const entitiesCallbacks = !hasFiltersSelected ? createNetworkCallbacks({
            taskName: (0, $bQSQw.TASK_NAMES).QUICK_FIND_JIRA_ENTITIES_NETWORK,
            uxTaskId: uxTaskId,
            isPreQuery: isPreQuery
        }) : undefined;
        return Promise.all([
            (0, $d482bbe0b8132b8c$export$eaafe46561fa4ee5)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.isJiraIssueIndexed, bootstrap.thirdPartyConfigs, typeFilterEntities, sessionId, bootstrap.hasEditOrViewPlanPermission, issuesAndTypesCallbacks, bootstrap.analyticsAttributes?.activationId),
            !hasFiltersSelected ? (0, $d482bbe0b8132b8c$export$cfa5e5437133749b)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.isJiraIssueIndexed, bootstrap.thirdPartyConfigs, sessionId, bootstrap.hasEditOrViewPlanPermission, entitiesCallbacks, bootstrap.analyticsAttributes?.activationId) : Promise.resolve({
                fetchResults: [],
                errors: [],
                autocompleteSuggestions: undefined
            })
        ]).then((results)=>{
            const [issuesResult, entitiesResult] = results;
            return {
                results: [
                    ...issuesResult.fetchResults,
                    ...entitiesResult.fetchResults
                ],
                fetchEntitiesRequestId: issuesResult.fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: issuesResult.fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: [
                    ...issuesResult.errors || [],
                    ...entitiesResult.errors || []
                ],
                autocompleteSuggestions: issuesResult.autocompleteSuggestions
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.isJiraIssueIndexed,
        bootstrap.thirdPartyConfigs,
        bootstrap.hasEditOrViewPlanPermission,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        typeFilterEntities,
        hasFiltersSelected,
        sessionId,
        createNetworkCallbacks
    ]);
    /**
	 * Callback to fetch people and teams results
	 */ const fetchPeopleAndTeamsCallback = (0, $42omo.useCallback)(async ()=>{
        const { orgId: orgId, primaryProduct: primaryProduct, user: user, cloudId: cloudId } = bootstrap;
        if (orgId && primaryProduct && user?.id && cloudId) {
            // When a single query filter is selected and it is a contributor filter,
            // get people and teams results using the contributor name
            if (selectedQueryFilters.length === 1 && selectedQueryFilters[0].filterId === 'contributor') return (0, $6e53edd4c7804f3e$export$290039782fc4e47)(selectedQueryFilters[0].displayText, orgId, primaryProduct, user.id, cloudId);
            // Only fetch people and teams results if there are no filters selected
            if (!hasFiltersSelected) return (0, $6e53edd4c7804f3e$export$290039782fc4e47)(quickFindQuery, orgId, primaryProduct, user.id, cloudId);
        }
        return [];
    }, [
        bootstrap,
        quickFindQuery,
        selectedQueryFilters,
        hasFiltersSelected
    ]);
    /**
	 * Function which fetches search results. This consists of a call to get
	 * product search results and a call to get people and teams. Given that Promise.allSettled
	 * is used, the slowest request will determine the time it takes to resolve.
	 *
	 * @param isWarmupRequest - Whether this is a warmup request (controls success/failure callbacks and which UX event to fire)
	 */ const fetchQuickFindPostQuery = (0, $42omo.useCallback)((isWarmupRequest = false)=>{
        // Determine if this is a pre-query state based on whether there's actual text in the query
        // isPreQuery = true when there's no text query (even if filters are selected)
        // isPreQuery = false when there's actual text in the query
        const isPreQuery = !quickFindQuery || quickFindQuery.length === 0;
        // Generate and store uxTaskId so network events use the same taskId as UX events.
        // For pre-query: use preQueryTaskIdRef, for post-query: use postQueryTaskState.
        let uxTaskId;
        if (isPreQuery) {
            if (preQueryTaskIdRef && !preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            uxTaskId = preQueryTaskIdRef?.current || crypto.randomUUID();
        } else {
            // Reset state if previous query completed
            if (postQueryTaskState?.current?.completed) postQueryTaskState.current = {
                id: null,
                started: false,
                completed: false,
                error: null
            };
            if (postQueryTaskState && !postQueryTaskState.current.id) postQueryTaskState.current.id = crypto.randomUUID();
            uxTaskId = postQueryTaskState?.current?.id || crypto.randomUUID();
        }
        let fetchProductEntities;
        if (bootstrap.primaryProduct === 'confluence' || bootstrap.primaryProduct === 'rovo-extension' && (0, $dh538.fg)('quickfind-rovo-extension')) fetchProductEntities = ()=>fetchConfluenceEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === 'townsquare') fetchProductEntities = ()=>fetchAtlasEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === 'mercury') fetchProductEntities = ()=>fetchMercuryEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === 'radar' && (0, $dh538.fg)('talent_global_search')) fetchProductEntities = ()=>fetchTalentEntitiesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === 'jira') fetchProductEntities = ()=>fetchJiraIssuesCallback(uxTaskId, isPreQuery);
        else if (bootstrap.primaryProduct === 'cmdb' && (0, $dh538.fg)('assets_rovo_search_all')) fetchProductEntities = ()=>fetchAssetsEntitiesCallback(uxTaskId, isPreQuery);
        else fetchProductEntities = ()=>Promise.resolve({
                results: [],
                fetchEntitiesRequestId: undefined,
                fetchEntitiesTraceId: undefined,
                fetchSpacesRequestId: undefined,
                errors: [],
                autocompleteSuggestions: undefined
            });
        const fetchPeopleAndTeams = bootstrap.primaryProduct !== 'jira' && bootstrap.primaryProduct !== 'mercury' && !selectedProduct ? fetchPeopleAndTeamsCallback : ()=>Promise.resolve([]);
        const postQueryPromise = new (0, $czt8s.CancellablePromise)(Promise.allSettled([
            (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchProductEntities),
            (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchPeopleAndTeams)
        ]));
        postQueryPromiseRef.current = postQueryPromise;
        // Only fire postquery events for actual queries, not warmup requests
        if (!isWarmupRequest) onPostQueryStart?.();
        postQueryPromise.promise().then((results)=>{
            const productEntitiesStatus = results[0].status;
            const peopleAndTeamsStatus = results[1].status;
            // Post-query success is determined by product entities request, errors
            // from people and teams are ignored
            if (productEntitiesStatus === 'fulfilled') {
                const fetchedResults = results[0].value.result.results;
                setSearchResults({
                    result: fetchedResults,
                    duration: results[0].value.duration
                });
                const errors = results[0].value.result.errors || [];
                setSearchErrors(errors);
                const hasThirdPartyResults = fetchedResults.some((result)=>result.id.startsWith('ari:cloud:graph::document') || result.id.startsWith('ari:cloud:graph::remote-link'));
                setFetchEntitiesRequestId(results[0].value.result.fetchEntitiesRequestId);
                setFetchEntitiesTraceId(results[0].value.result.fetchEntitiesTraceId);
                setFetchSpacesRequestId(results[0].value.result.fetchSpacesRequestId);
                setAutocompleteSuggestions(results[0].value.result.autocompleteSuggestions);
                const peopleAndTeams = peopleAndTeamsStatus === 'fulfilled' ? {
                    result: results[1].value.result,
                    duration: results[1].value.duration
                } : $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                setPeopleAndTeams(peopleAndTeams);
                const allDurations = results.map((result)=>result.status === 'fulfilled' ? result.value.duration : 0);
                const maxDuration = Math.max(...allDurations);
                const resultCount = fetchedResults.length;
                // Only fire postquery events for actual queries, not warmup requests
                if (!isWarmupRequest) onPostQuerySuccess?.(maxDuration, hasThirdPartyResults, resultCount);
            } else {
                const error = new Error('Failed to fetch post query results');
                setPostQueryError(error);
                // Only fire postquery events for actual queries, not warmup requests
                if (!isWarmupRequest) onPostQueryFailure?.(error);
            }
            setPostQueryLoading(false);
            return results;
        }).catch((error)=>{
            if (!(error instanceof (0, $czt8s.CancelError))) logException(error);
        });
    }, [
        bootstrap,
        fetchAssetsEntitiesCallback,
        fetchAtlasEntitiesCallback,
        fetchConfluenceEntitiesCallback,
        fetchJiraIssuesCallback,
        fetchMercuryEntitiesCallback,
        fetchTalentEntitiesCallback,
        fetchPeopleAndTeamsCallback,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        selectedProduct,
        setFetchEntitiesRequestId,
        setFetchEntitiesTraceId,
        setFetchSpacesRequestId,
        setSearchErrors,
        logException,
        preQueryTaskIdRef,
        postQueryTaskState,
        quickFindQuery
    ]);
    /**
	 * Debounced fetch function for quick find results. This callback should never mutate
	 * as the only dependency is the timeout value, hence it can be safely used in dependency array.
	 */ const debouncedFetchQuickFindPostQuery = (0, $e31678cde9628b17$export$e70e6da722faba05)(fetchQuickFindPostQuery, debounceTimeout);
    /**
	 * Warm-up request for user shard permissions cache when dialog is opened **for the first time**
	 * The user shard team has an idea to reduce 3p latency which is to pre-fetch documents and run them through LMC when the dialog opens.
	 * Queries that are not empty will be checked against those cached values, as a way to remove LMC latency from QF queries.
	 * The cache exists in searcher.
	 * For more information, see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/122582/diff#comment-602538177
	 * Demo of how this works: https://www.loom.com/share/e190178ec2e048558273cd8d60a7006d
	 */ (0, $42omo.useEffect)(()=>{
        if (quickFindOpen && !warmupRequestWasFired.current && serveUserShardModel) {
            fetchQuickFindPostQuery(true);
            warmupRequestWasFired.current = true;
        }
    }, [
        quickFindOpen,
        fetchQuickFindPostQuery,
        serveUserShardModel
    ]);
    (0, $42omo.useEffect)(()=>{
        if (quickFindOpen) {
            (async ()=>{
                if ((0, $dh538.fg)('enable_github_quickfind_experiment')) {
                    if (githubFullConnectorAuthorised || await hasGithubSmartLinkAccessRef.current) (0, $c6GJD.default).manuallyLogExperimentExposure('enable_github_links_hydration_in_quickfind_recent');
                }
            })();
            // Only fire an exposure if the user is eligible for the experiment.
            // enable_quick_find_autorefresh_experiment_v3 is referenced in quick_find_autorefresh_experiment_v3.
            if ((0, $dh538.fg)('enable_quick_find_autorefresh_experiment_v3')) (0, $c6GJD.default).manuallyLogExperimentExposure('quick_find_autorefresh_experiment_v3');
            // If the user is allocated to either of these mutually exclusive experiments,
            // We fire an exposure by accessing a parameter within the layer.
            (0, $iA4lt.getMutuallyExclusiveUIExperiment)('quick-find-user-shard-search-experiment', (0, $4OGlb.STATSIG_QUICK_FIND_LAYER))?.get('cohort', undefined);
            (0, $iA4lt.getMutuallyExclusiveUIExperiment)('quick_find_user_relevant_documents_experiment', (0, $4OGlb.STATSIG_QUICK_FIND_LAYER))?.get('cohort', undefined);
            (0, $2OtFZ.serveQFDropdownExperiment)(bootstrap.primaryProduct);
            (0, $2OtFZ.serveQFAppSelectorExperiment)(bootstrap.primaryProduct);
            (0, $2OtFZ.serveQFFilterSuggestionExperiment)(bootstrap.primaryProduct);
            (0, $2OtFZ.serve3PClickIngestionExperiment)(bootstrap.thirdPartyConfigs);
        }
    }, [
        quickFindOpen,
        bootstrap.thirdPartyConfigs,
        bootstrap.primaryProduct,
        githubFullConnectorAuthorised
    ]);
    /**
	 * Updates results when various Quick Find states change, this includes:
	 * - when search is ready
	 * - when the dialog opens
	 * - when the query changes
	 * - when recent queries or activities change
	 * - when selected entities or filters change
	 */ (0, $42omo.useEffect)(()=>{
        if (!isSearchReady) return;
        if (preQueryPromiseRef.current) preQueryPromiseRef.current.cancel();
        const oldHideFilteredPreQueryResults = !!(hasFiltersSelected || quickFindQuery.length && selectedProduct);
        const newHideFilteredPreQueryResults = !!(hasFiltersSelected || selectedProduct);
        const hideFilteredPreQueryResults = serveQFAppSelector ? newHideFilteredPreQueryResults : oldHideFilteredPreQueryResults;
        // As using serveUserShardUI, we will fusion the matched results from recent activities
        // and the results from User Shard Index. So we do not hide prequery results.
        // || (quickFindQuery.length && serveUserShardUI)
        const shouldRefetchPreQueryResults = serveAutorefreshCohort && prevQuickFindOpenRef.current === false && quickFindOpen === true;
        fetchQuickFindPreQuery(quickFindQuery, hideFilteredPreQueryResults, shouldRefetchPreQueryResults);
        prevQuickFindOpenRef.current = quickFindOpen;
        /**
		 * Skip fetching post-query results if:
		 * - Quick Find is closed
		 * - Post-query is disabled
		 * - There is a current query filter selected
		 */ if (!quickFindOpen || postQueryDisabled || currentQueryFilter) return;
        // Check if search parameters have changed, if not, skip fetching post-query results
        if (quickFindQuery === prevQueryRef.current && selectedFiltersEquality === prevSelectedFiltersEquality.current && entitiesEquality === prevEntitiesEquality.current && prevHasFiltersSelected.current === hasFiltersSelected && selectedProduct === prevSelectedProduct.current) return;
        prevQueryRef.current = quickFindQuery;
        prevSelectedFiltersEquality.current = selectedFiltersEquality;
        prevEntitiesEquality.current = entitiesEquality;
        prevHasFiltersSelected.current = hasFiltersSelected;
        prevSelectedProduct.current = selectedProduct;
        // Reset post-query results as search parameters have changed
        setSearchResults({
            result: [],
            duration: 0
        });
        setPeopleAndTeams({
            result: [],
            duration: 0
        });
        setPostQueryLoading(true);
        setPostQueryError(undefined);
        // Cancel the inflight request as search parameters have changed
        if (postQueryPromiseRef.current) {
            postQueryPromiseRef.current.cancel();
            onPostQueryCancel?.();
            postQueryPromiseRef.current = undefined;
        }
        const hasProductSelected = (serveQFAppSelector && Boolean(selectedProduct)) ?? false;
        const hasQuery = (0, $2bb736a7e62c9305$export$6e4070116bdfa183)({
            query: quickFindQuery,
            hasFiltersSelected: hasFiltersSelected || hasProductSelected
        });
        if (hasQuery) {
            setPostQueryLoading(true);
            debouncedFetchQuickFindPostQuery();
        }
    }, [
        fetchQuickFindPreQuery,
        debouncedFetchQuickFindPostQuery,
        quickFindQuery,
        retryCount,
        isSearchReady,
        quickFindOpen,
        selectedFilters,
        entities,
        onPostQueryCancel,
        postQueryDisabled,
        currentQueryFilter,
        selectedProduct,
        hasFiltersSelected,
        serveUserShardUI,
        selectedFiltersEquality,
        entitiesEquality,
        userRelevantDocumentsEnabled,
        serveAutorefreshCohort,
        serveQFAppSelector
    ]);
    return (0, $42omo.useMemo)(()=>(0, $2bb736a7e62c9305$export$35ead133d529e85e)({
            // Using refs here to ensure new results state is returned only
            // when the various result variables in the dependency array change
            query: prevQueryRef.current,
            hasFiltersSelected: prevHasFiltersSelected.current,
            quickFindOpen: prevQuickFindOpenRef.current,
            preQueryError: preQueryError,
            preQueryLoading: preQueryLoading,
            postQueryError: postQueryError,
            postQueryLoading: postQueryLoading,
            filteredRecentQueries: filteredRecentQueries,
            filteredRecentActivities: filteredRecentActivities,
            filteredUserDocuments: filteredUserDocuments,
            filteredZeroQueries: filteredZeroQueries,
            searchResults: searchResults,
            peopleAndTeams: peopleAndTeams,
            postQueryDisabled: postQueryDisabled,
            primaryProduct: bootstrap.primaryProduct,
            hasProductSelected: !!prevSelectedProduct.current,
            autocompleteSuggestions: autocompleteSuggestions,
            filterSuggestions: visibleFilterSuggestions
        }), [
        filteredRecentActivities,
        filteredUserDocuments,
        filteredRecentQueries,
        filteredZeroQueries,
        peopleAndTeams,
        postQueryDisabled,
        postQueryError,
        postQueryLoading,
        preQueryError,
        preQueryLoading,
        searchResults,
        bootstrap.primaryProduct,
        autocompleteSuggestions,
        visibleFilterSuggestions
    ]);
};
const $0c35e478cf8dbc82$export$4f32340729fb620b = ()=>{
    const previousStateRef = (0, $42omo.useRef)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const searchErrors = (0, $4VmlX.useSearchErrors)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestedBackendExperiments] = (0, $djVCD.useRequestedBackendExperiments)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const intentRouterEnabled = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false
    })?.cohort === 'test';
    const productsWithTimeoutsFromErrors = (0, $42omo.useMemo)(()=>{
        const errors = searchErrors || [];
        return errors.filter((error)=>error.extensions?.statusCode === 408).map((error)=>error.extensions?.integration ?? error.extensions?.product).flatMap((s)=>s && (0, $1yEFx.isProductKey)(s) ? [
                s
            ] : []);
    }, [
        searchErrors
    ]);
    const are3PSmartLinksInResults = (0, $42omo.useMemo)(()=>{
        if (!content) return false;
        const serveGithubLinksHydration = (0, $ci6Zg.serveGithubLinksHydrationWithoutExposure)();
        const checkIsSmartLink = (result)=>{
            if (!result.data?.node?.object?.id || !result.data?.node?.event?.eventType) return false;
            const mappedResult = (0, $bfef7c7cb8b104c2$export$1d02b83d52558ed)(result.data, '', '', thirdPartyConfigs, serveGithubLinksHydration);
            return (0, $kQT7c.isResultSmartLink)({
                resultAri: result.data.node.object.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product,
                eventType: result.data.node.event.eventType,
                connectorType: result.data.connectorType
            });
        };
        return ('recentActivities' in content ? content.recentActivities : []).some(checkIsSmartLink) || ('searchResults' in content ? content.searchResults : []).some(checkIsSmartLink);
    }, [
        content,
        thirdPartyConfigs
    ]);
    (0, $42omo.useEffect)(()=>{
        // Store a copy of previous state before updating the ref
        const previousState = previousStateRef.current;
        previousStateRef.current = content ? content.state : undefined;
        // Don't fire analytics event if the dialog is closed
        if (!quickFindOpen || !content) return;
        // Don't fire analytics event if the state hasn't changed
        if (content.state === previousState) return;
        // Ignore states that do not have search results
        if (content.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_LOADING || content.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_ERROR || content.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_ERROR) {
            if (content.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_ERROR) fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
                success: false,
                attributes: commonAttributes,
                resultsType: 'preQuerySearchResults'
            }));
            if (content.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_ERROR) fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
                success: false,
                attributes: commonAttributes,
                resultsType: 'postQuerySearchResults'
            }));
            return;
        }
        /**
		 * Do not fire analytics event when the dialog is opened and post-query
		 * results are already returned. This is to have parity with the old
		 * quick find component.
		 *
		 * Whilst this may not be correct, this is here to ensure changes in metrics
		 * such as QSR and CTR are intentional.
		 *
		 * TODO: Discuss with DS/DE if this correct behaviour
		 */ if (content.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_RESULTS && previousState === undefined) return;
        const resultsTypeMap = {
            PREQUERY_RESULTS: 'preQuerySearchResults',
            PREQUERY_NO_RESULTS: 'preQuerySearchResults',
            POSTQUERY_LOADING: 'cachedResults',
            POSTQUERY_RESULTS: 'postQuerySearchResults',
            POSTQUERY_NO_RESULTS: 'postQuerySearchResults'
        };
        const resultsType = resultsTypeMap[content.state];
        const { sectionCount: sectionCount, resultCount: resultCount } = (0, $9wmQG.getSectionsAndResultsCount)();
        const resultTypeCounts = (0, $9wmQG.getResultTypeCounts)();
        const productsInResults = (0, $9wmQG.getProductsInResults)();
        const isBulkConnectBannerShown = (0, $9wmQG.getIsBulkConnectBannerShown)();
        const resultsShown = (0, $9wmQG.getResultsShown)();
        const noResultsFetched = content.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_NO_RESULTS || content.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_NO_RESULTS || resultCount === 0;
        // Don't fire cachedResults event if there are no results
        if (noResultsFetched && resultsType === 'cachedResults') return;
        const are3pResultsShown = productsInResults.some((0, $1yEFx.is3pProductKeyForAnalytics));
        const authorized3PProducts = Object.keys(thirdPartyConfigs || {}).filter((product)=>!thirdPartyConfigs?.[product]?.userNeedsOAuth);
        fireAnalyticsEvent((0, $e1a1aba41a097938$export$2d1da932f40a427e)({
            attributes: {
                ...commonAttributes,
                sectionCount: sectionCount,
                resultCount: resultCount,
                resultTypeCounts: resultTypeCounts,
                productsInResults: productsInResults,
                are3pResultsShown: are3pResultsShown,
                // Use `searchAndResult` to keep the schema consistent with FPS, but we don't need other attributes yet.
                searchAndResult: {
                    authorized3PProducts: authorized3PProducts
                },
                resultsShown: resultsShown,
                isBulkConnectBannerShown: isBulkConnectBannerShown,
                are3PSmartLinksInResults: are3PSmartLinksInResults,
                noResultsFetched: noResultsFetched,
                ...(0, $inrbX.getCommonQueryAttributes)(content.query),
                ...requestedBackendExperiments,
                ...resultsType === 'postQuerySearchResults' ? {
                    productsWithTimeout: productsWithTimeoutsFromErrors || []
                } : {},
                ...intentRouterEnabled ? {
                    queryClassification: (0, $fa792d959dc8194b$export$928cec68d7595d16).value()?.mode,
                    modelId: (0, $fa792d959dc8194b$export$928cec68d7595d16).value()?.modelId
                } : {}
            },
            nonPrivacySafeAttributes: {
                query: content.query
            },
            resultsType: resultsType
        }));
        fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
            success: true,
            attributes: commonAttributes,
            resultsType: resultsType
        }));
    }, [
        commonAttributes,
        content,
        fireAnalyticsEvent,
        quickFindOpen,
        requestedBackendExperiments,
        are3PSmartLinksInResults,
        thirdPartyConfigs,
        productsWithTimeoutsFromErrors,
        intentRouterEnabled
    ]);
};
const $0c35e478cf8dbc82$export$da9d0159e5272189 = /*#__PURE__*/ (0, $42omo.memo)((options)=>{
    const callbacks = (0, $a755cc866a3495f8$export$483ef80309da5ade)();
    const useQuickFindResultsArgs = (0, $42omo.useMemo)(()=>({
            ...options,
            ...callbacks
        }), [
        options,
        callbacks
    ]);
    const content = $0c35e478cf8dbc82$export$ab15aae48c593ecc(useQuickFindResultsArgs);
    const { setContent: setContent } = (0, $4VmlX.useQuickFindActions)();
    (0, $42omo.useEffect)(()=>{
        setContent(content);
    }, [
        content,
        setContent
    ]);
    $0c35e478cf8dbc82$export$4f32340729fb620b();
    const isSearchPagePOBannerPlacementEnabled = (0, $2OtFZ.serveSearchPageInline3PBannerRevampedExperiment)();
    const portalContainer = (0, $RWXHe.usePlacementPortalContainer)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const bootstrapReady = availableProducts.length > 0;
    const orderedAvailableProducts = (0, $eO6NY.useAvailableProductsOrderForPlacement)({
        isOnSearchDialog: true,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts
    });
    if (!isSearchPagePOBannerPlacementEnabled || !bootstrapReady || !portalContainer || !options.isHovered || (0, $RWXHe.isSearchPagePlacementClaimed)()) return null;
    return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fa64c9b2652b82c5$export$f7ad73a4588a04e6), {
            thirdPartyConfigs: thirdPartyConfigs,
            availableProductsOrder: orderedAvailableProducts,
            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
            onMessageViewed: options.onBannerMessageViewed
        })
    }), portalContainer);
});








// Default value hoisted outside to prevent recreation on every render
const $e6c80dec8a0d452c$var$DEFAULT_TASK_STATE = {
    id: null,
    state: 'idle',
    error: null,
    queryHash: null,
    queryLength: null
};
const $e6c80dec8a0d452c$var$IntentDetectionVitalStatsContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $e6c80dec8a0d452c$export$7d6ff8eec92df467 = ({ children: children })=>{
    // Use hoisted default to prevent object recreation on every render
    const taskStateRef = (0, $42omo.useRef)($e6c80dec8a0d452c$var$DEFAULT_TASK_STATE);
    return /*#__PURE__*/ (0, $l998X.jsx)($e6c80dec8a0d452c$var$IntentDetectionVitalStatsContext.Provider, {
        value: taskStateRef,
        children: children
    });
};
const $e6c80dec8a0d452c$export$714277298f52f5c1 = ()=>{
    const taskStateRef = (0, $42omo.useContext)($e6c80dec8a0d452c$var$IntentDetectionVitalStatsContext);
    if (!taskStateRef) throw new Error('useIntentDetectionVitalStatsTaskState must be used within IntentDetectionVitalStatsProvider');
    return taskStateRef;
};







var $8aC7e = parcelRequire("8aC7e");







parcelRequire("42omo");




const $f58c1f7467c49dec$export$5f60ff1bbe7f1a37 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4VmlX.QuickFindStoreContainer), {
        children: children
    });
};



var $bHLTK = parcelRequire("bHLTK");








var $8C5kA = parcelRequire("8C5kA");







var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");







var $fwDOR = parcelRequire("fwDOR");


var $6CITI = parcelRequire("6CITI");




var $4TTdD = parcelRequire("4TTdD");

var $7ZetK = parcelRequire("7ZetK");

var $8LSUr = parcelRequire("8LSUr");


var $9vOy1 = parcelRequire("9vOy1");











var $5Lref = parcelRequire("5Lref");




parcelRequire("42omo");












const $5cfb43da7e344c6a$var$containerStyles = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100'
});
const $5cfb43da7e344c6a$var$headingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    fontWeight: 'font.weight.semibold',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    width: '100%',
    padding: 'space.100',
    userSelect: 'none'
});
const $5cfb43da7e344c6a$export$a8a3e93435678ff9 = ({ id: id, text: text, includeInAnalytics: includeInAnalytics = true })=>{
    const headingProps = (0, $dh538.fg)('rovo_qf_render_heading_as_h2') ? {
        as: 'h2'
    } : {};
    const headingWithoutAnalyticsWrapper = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $5cfb43da7e344c6a$var$containerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            ...headingProps,
            xcss: $5cfb43da7e344c6a$var$headingStyles,
            children: text
        })
    });
    return includeInAnalytics ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9wmQG.SearchDialogHeaderAnalyticsWrapper), {
        id: id,
        children: headingWithoutAnalyticsWrapper
    }) : headingWithoutAnalyticsWrapper;
};








var $ckkm9 = parcelRequire("ckkm9");











var $kIdP4 = parcelRequire("kIdP4");


var $a5OFf = parcelRequire("a5OFf");




const $2d65b64d3d4cb16d$export$dca164322a50872a = (activities, remainingSlots, topN = 7)=>{
    const topRecentActivities = activities.slice(0, topN);
    const thirdPartyActivities = topRecentActivities.filter((activity)=>(0, $hWR4v.isGraphActivity)(activity.data.node.object));
    const nonThirdPartyActivities = topRecentActivities.filter((activity)=>!(0, $hWR4v.isGraphActivity)(activity.data.node.object));
    return [
        ...thirdPartyActivities,
        ...nonThirdPartyActivities
    ].slice(0, remainingSlots);
};


const $da0a8f0656f9d4ba$export$d20fe15ea6549dcc = ({ attributes: attributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'exposed',
        actionSubject: 'intentRouterExperiment',
        actionSubjectId: 'intentRouterExperimentExposed',
        attributes: attributes
    });


const $57230a101297e6c3$export$bcff6baaecbbc96 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'dismissed',
        actionSubject: `searchDialog`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $de62c0fb6467b42a$export$39e1d377a6a3de5d = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialog`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $71aa6db8e0b63681$export$ccb93b1cc213aa40 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'rendered',
        actionSubject: `searchResults`,
        actionSubjectId: `postQuerySearchResults`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });










var $19BAV = parcelRequire("19BAV");


var $dsrEB = parcelRequire("dsrEB");


























const $269ee6c4b9937e56$export$5b6291bff520e069 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const taskStateRef = (0, $785f0e86c2e88315$export$85fd2191723185b5)();
    const isEnabled = (0, $dh538.fg)('rovo-search-vitalstats-quickfind-postquery-ux');
    const startTask = (0, $42omo.useCallback)(()=>{
        if (!isEnabled) return;
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        // Set the shared context state
        if (taskStateRef.current) {
            taskStateRef.current.id = taskId;
            taskStateRef.current.started = true;
            taskStateRef.current.completed = false;
        }
        fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
        }));
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskSuccess = (0, $42omo.useCallback)(()=>{
        // Check if task is active using the shared context state
        if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId) return;
        fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
        }));
        // Mark task as completed
        if (taskStateRef.current) taskStateRef.current.completed = true;
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskFail = (0, $42omo.useCallback)((error)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId) return;
        fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
            moreContext: {
                errorName: error?.name,
                errorMessage: error?.message
            }
        }));
        // Mark task as completed
        taskStateRef.current.completed = true;
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const abortTask = (0, $42omo.useCallback)((abortReason)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId) return;
        // Mark task as completed FIRST (synchronously) to prevent race conditions
        taskStateRef.current.completed = true;
        // Then defer the analytics event to not block rendering
        (0, $42omo.startTransition)(()=>{
            fireAnalyticsEvent((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                moreContext: {
                    abortReason: abortReason
                }
            }));
        });
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const isTaskActive = (0, $42omo.useCallback)(()=>{
        // Check if task has started but not yet completed
        return taskStateRef.current?.started && !taskStateRef.current?.completed;
    }, [
        taskStateRef
    ]);
    return {
        startTask: startTask,
        completeTaskSuccess: completeTaskSuccess,
        completeTaskFail: completeTaskFail,
        abortTask: abortTask,
        isTaskActive: isTaskActive
    };
};






var $lvsjl = parcelRequire("lvsjl");









var $4mLNH = parcelRequire("4mLNH");

const $64cc6bbe82568b51$export$dfe8038ae9bc34d2 = ()=>{
    const logException = (0, $f8oYd.useLogException)();
    const { onSearchResultsShown: onSearchResultsShownCallback } = (0, $7WbA8.useAppContext)();
    const isPrequeryRecentActivitieHandled = (0, $42omo.useRef)(false);
    /*
	 * This is called only for POSTQUERY_RESULTS state
	 * */ const onSearchResultsShown = (0, $42omo.useCallback)(async (searchResults)=>{
        if (onSearchResultsShownCallback && searchResults.length > 0) try {
            const confluenceSearchResults = (0, $4mLNH.transformQuickFindConfluenceResults)(searchResults);
            if (confluenceSearchResults.length > 0) onSearchResultsShownCallback(confluenceSearchResults);
        } catch (e) {
            logException(e);
        }
    }, [
        onSearchResultsShownCallback,
        logException
    ]);
    /*
	 * This is debounced to avoid triggering the callback if the list changes too quickly
	 *
	 * The recent activities are only available in PREQUERY_RESULTS, POSTQUERY_LOADING and POSTQUERY_RESULTS states.
	 * Since the "Recent Activities" list remains consistent in both POSTQUERY_LOADING and POSTQUERY_RESULTS states, we only report it during the POSTQUERY_LOADING state.
	 * */ const [handleRecentActivitiesCallback] = (0, $lvsjl.default)(async (state, recentActivities)=>{
        try {
            if (onSearchResultsShownCallback && recentActivities.length > 0) {
                /*
					 * The “Recent Activities” in PREQUERY_RESULTS state are reported just once, as they always show the same list after loading.
					 * */ if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_RESULTS && !isPrequeryRecentActivitieHandled.current) {
                    isPrequeryRecentActivitieHandled.current = true;
                    const confluenceRecentActivities = (0, $4mLNH.transformQuickFindConfluenceRecentActivities)(recentActivities);
                    if (confluenceRecentActivities.length > 0) onSearchResultsShownCallback(confluenceRecentActivities);
                }
                if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_LOADING) {
                    const confluenceRecentActivities = (0, $4mLNH.transformQuickFindConfluenceRecentActivities)(recentActivities);
                    if (confluenceRecentActivities.length > 0) onSearchResultsShownCallback(confluenceRecentActivities);
                }
            }
        } catch (e) {
            logException(e);
        }
    }, 500);
    // returning async callbacks to avoid blocking other operations
    return {
        onSearchResultsShown: onSearchResultsShown,
        handleRecentActivitiesCallback: handleRecentActivitiesCallback
    };
};








const $b2e1078ac279219a$export$50f1b1860bee88e0 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, actionSubjectId: actionSubjectId })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $bb6e90fe17bdbf50$export$4d9e9e3a052b2865 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'contextMenu opened',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $a6985f2e364fb5e8$export$d17f8c02a91cd2a5 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'highlighted',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $dd727cd9033cfd92$export$1d3be7f4bb8882c3 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });































const $531c3f35638ca54a$export$8edca358485a7f22 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const taskStateRef = (0, $e6c80dec8a0d452c$export$714277298f52f5c1)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isEnabled = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false
    })?.cohort === 'test';
    const startTask = (0, $42omo.useCallback)((query)=>{
        if (!isEnabled) return;
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        const queryHash = (0, $a0M2t.sha256Hash)(query);
        const queryLength = query.length;
        // Set the shared context state
        if (taskStateRef.current) {
            taskStateRef.current.id = taskId;
            taskStateRef.current.state = 'started';
            taskStateRef.current.queryHash = queryHash;
            taskStateRef.current.queryLength = queryLength;
        }
        fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash,
                queryLength: queryLength
            }
        })));
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskSuccess = (0, $42omo.useCallback)(()=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId, queryHash: queryHash, queryLength: queryLength } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId) return;
        fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskSuccess)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash,
                queryLength: queryLength
            }
        })));
        // Mark task as completed
        taskStateRef.current.state = 'completed';
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskFail = (0, $42omo.useCallback)((error)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId, queryHash: queryHash, queryLength: queryLength } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId) return;
        fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash,
                queryLength: queryLength,
                errorName: error?.name || 'UnknownError',
                errorMessage: error?.message || 'An unknown error occurred'
            }
        })));
        // Mark task as failed
        taskStateRef.current.state = 'failed';
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const abortTask = (0, $42omo.useCallback)((abortReason)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId, queryHash: queryHash, queryLength: queryLength } = taskStateRef.current;
        const searchSessionId = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId) return;
        // Mark task as aborted FIRST (synchronously) to prevent race conditions
        taskStateRef.current.state = 'aborted';
        // Then defer the analytics event to not block rendering
        (0, $42omo.startTransition)(()=>{
            fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
                moreContext: {
                    abortReason: abortReason,
                    queryHash: queryHash,
                    queryLength: queryLength
                }
            })));
        });
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const isTaskActive = (0, $42omo.useCallback)(()=>{
        return taskStateRef.current?.state === 'started';
    }, [
        taskStateRef
    ]);
    return {
        startTask: startTask,
        completeTaskSuccess: completeTaskSuccess,
        completeTaskFail: completeTaskFail,
        abortTask: abortTask,
        isTaskActive: isTaskActive
    };
};


function $6926da8980239f02$export$b6f8db3ad0711b02(state) {
    switch(state){
        case (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_RESULTS:
            return 'preQuerySearchResults';
        case (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_LOADING:
            return 'preQueryLoadingSearchResults';
        case (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_LOADING:
            return 'cachedResults';
        case (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_RESULTS:
            return 'postQuerySearchResults';
        default:
            return '';
    }
}
const $6926da8980239f02$export$b2c60dba9a3fd739 = (event, data)=>{
    if (!event) return false;
    // cmd/ctrl/shift click typically indicates the user intends to open in a new tab/window.
    const isModifiedClick = event.ctrlKey || event.metaKey || event.shiftKey;
    // Middle click (f.e. scroll-wheel) is a common "open in new tab" interaction.
    const isAuxClick = event.type === 'auxclick' || data?.isAuxClick === true;
    return isModifiedClick || isAuxClick;
};
const $6926da8980239f02$export$8a7aec9b1f72e063 = ()=>{
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    return (0, $42omo.useCallback)((props)=>{
        const { event: event, data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes, options: options } = props;
        // VitalStats: Abort intent detection UX task if user clicks on a search result
        if (isIntentDetectionTaskActive()) abortIntentDetectionTask('result_selected');
        const { addCurrentQueryAsRecentQuery: addCurrentQueryAsRecentQuery = true } = options || {};
        const newTab = $6926da8980239f02$export$b2c60dba9a3fd739(event, data);
        if (!newTab) setQuickFindOpen(false);
        if (addCurrentQueryAsRecentQuery) {
            const trimmedInuptQuery = quickFindQuery.trim();
            if (trimmedInuptQuery !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(trimmedInuptQuery, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        }
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $dd727cd9033cfd92$export$1d3be7f4bb8882c3)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        quickFindQuery,
        nonPrivacySafeAttributes,
        primaryProduct,
        setQuickFindOpen,
        updateRecentQueries,
        user,
        isIntentDetectionTaskActive,
        abortIntentDetectionTask
    ]);
};
const $6926da8980239f02$export$bc76edbc675e4404 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $42omo.useCallback)((props)=>{
        const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes } = props;
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $bb6e90fe17bdbf50$export$4d9e9e3a052b2865)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
};
const $6926da8980239f02$export$3f21dcaf9a5530d9 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $42omo.useCallback)((props)=>{
        const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes } = props;
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $a6985f2e364fb5e8$export$d17f8c02a91cd2a5)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
};
const $6926da8980239f02$export$eb0ecd911360e8d4 = ()=>{
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    return (0, $42omo.useCallback)((props)=>{
        const { event: event, state: state, options: options, actionSubjectId: actionSubjectId } = props;
        // VitalStats: Abort intent detection UX task if user clicks footer link
        if (isIntentDetectionTaskActive()) abortIntentDetectionTask('footer_link_selected');
        const { addCurrentQueryAsRecentQuery: addCurrentQueryAsRecentQuery = true } = options || {};
        const newTab = $6926da8980239f02$export$b2c60dba9a3fd739(event);
        if (!newTab) setQuickFindOpen(false);
        if (addCurrentQueryAsRecentQuery) {
            const trimmedInputQuery = quickFindQuery.trim();
            if (trimmedInputQuery !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(trimmedInputQuery, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        }
        if (!primaryProduct) return;
        fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                trigger: 'click',
                newTab: newTab,
                isLoading: state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_LOADING || state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_LOADING
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        quickFindQuery,
        nonPrivacySafeAttributes,
        primaryProduct,
        setQuickFindOpen,
        updateRecentQueries,
        user,
        isIntentDetectionTaskActive,
        abortIntentDetectionTask
    ]);
};












var $NvPpA = parcelRequire("NvPpA");











var $jluld = parcelRequire("jluld");







var $u9agA = parcelRequire("u9agA");












const $4f21e88d3d74c805$export$c6fcf5d81f2dd890 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'autocompleteSuggestion',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });















const $c2c85768bd794f41$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    autocompleteSuggestion: {
        id: "search_dialog_autocomplete_suggestion",
        defaultMessage: "Suggestion"
    }
});


const $d88ba3c49726615e$export$f919aeefffeb339a = ({ result: result, state: state })=>{
    const intl = (0, $8C5kA.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const queryText = (0, $4VmlX.useQuickFindQuery)();
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        const newTab = (0, $6926da8980239f02$export$b2c60dba9a3fd739)(event, data);
        if (!newTab) setQuickFindOpen(false);
        if (result && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)(result, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
            updateRecentQueries?.();
        }
        fireAnalyticsEvent((0, $4f21e88d3d74c805$export$c6fcf5d81f2dd890)({
            actionSubjectId: (0, $6926da8980239f02$export$b6f8db3ad0711b02)(state),
            attributes: {
                // NOTE: DO NOT LOG THE QUERY TEXT HERE. The query text is UGC and will immediately be a HOT.
                ...commonAttributes,
                queryLength: queryText.length
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        queryText.length,
        result,
        setQuickFindOpen,
        state,
        updateRecentQueries,
        user
    ]);
    const mapAutocompleteSuggestionToSearchResult = (0, $42omo.useCallback)((query)=>{
        const id = query;
        const icon = (0, $dh538.fg)('qf_icons_recents_suggested') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
            label: "",
            size: "small",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                label: intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion),
                color: "currentColor"
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion),
            color: "currentColor"
        });
        const title = query;
        const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion)
        });
        const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
            ]
        });
        const url = generateSearchUrl({
            ...queryParams,
            text: query,
            search_id: searchSessionId
        });
        return {
            id: id,
            icon: icon,
            title: title,
            url: url,
            rightMetadata: rightMetadata,
            highlightedRightMetadata: highlightedRightMetadata
        };
    }, [
        intl,
        generateSearchUrl,
        queryParams,
        searchSessionId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        resultType: "autocompleteSuggestions",
        ...mapAutocompleteSuggestionToSearchResult(result),
        onResultClicked: onResultClicked
    });
};





parcelRequire("42omo");





var $2Nwuj = parcelRequire("2Nwuj");




var $5dK2X = parcelRequire("5dK2X");




var $aoVih = parcelRequire("aoVih");







const $be39043139f18c46$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    assetsUnavailableMessage: {
        id: "search_dialog_assets_unavailable_message",
        defaultMessage: "<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>."
    }
});


const $0028c77a13fa2c26$export$d2e895abf2051d81 = ()=>{
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $0028c77a13fa2c26$var$containerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $be39043139f18c46$export$defe85febe8b728c).assetsUnavailableMessage,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            weight: 'bold',
                            children: chunks
                        }),
                    searchLink: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                            href: '/jira/assets?showSearch=true',
                            onClick: ()=>setQuickFindOpen(false),
                            children: chunks
                        })
                }
            })
        })
    });
};
const $0028c77a13fa2c26$var$containerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});












var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $3HOqx = parcelRequire("3HOqx");







var $4SPhZ = parcelRequire("4SPhZ");


var $5tPRL = parcelRequire("5tPRL");


var $i2RLU = parcelRequire("i2RLU");










const $57957bf3159c123e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    rovoTip: {
        id: "search_dialog_rovo_tip",
        defaultMessage: "Rovo tip:"
    },
    dismissBannerLabel: {
        id: "search_dialog_dismiss_banner_label",
        defaultMessage: "Dismiss banner"
    },
    rovoBannerMessage: {
        id: "search_dialog_rovo_banner_message",
        defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer"
    }
});


const $238c7f3a77e6e665$var$RovoTipMessageStyle = (0, $ecnYn.xcss)({
    width: '95%',
    marginLeft: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050'
});
const $238c7f3a77e6e665$var$RovoTipContainerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $238c7f3a77e6e665$var$RovoTipStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: "var(--ds-space-500, 40px)",
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.accent.purple.subtlest',
    color: 'color.text.accent.purple'
});
const $238c7f3a77e6e665$export$4d99a070549a9300 = ()=>{
    const [showRovoTip, setShowRovoTip] = (0, $42omo.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    (0, $42omo.useEffect)(()=>{
        if (!primaryProduct || !user || !user.id) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.getRovoTip)(primaryProduct, user.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        primaryProduct,
        user
    ]);
    const dismissRovoTip = (0, $42omo.useCallback)(()=>{
        if (!primaryProduct || !user || !user.id) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.setRovoTip)(primaryProduct, user.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        primaryProduct,
        user
    ]);
    if (!showRovoTip) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $238c7f3a77e6e665$var$RovoTipContainerStyle,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $238c7f3a77e6e665$var$RovoTipStyle,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                    spacing: "spacious",
                    label: "blank",
                    color: "var(--ds-text-accent-purple, #5E4DB2)"
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                    xcss: $238c7f3a77e6e665$var$RovoTipMessageStyle,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("b", {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $57957bf3159c123e$export$defe85febe8b728c).rovoTip
                            })
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $57957bf3159c123e$export$defe85febe8b728c).rovoBannerMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                        spacing: 'compact',
                        onClick: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            dismissRovoTip();
                            fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
                                isOnSearchDialog: true,
                                componentName: 'RovoTipBanner'
                            }));
                        },
                        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $57957bf3159c123e$export$defe85febe8b728c).dismissBannerLabel
                        }),
                        appearance: 'subtle'
                    })
                })
            ]
        })
    });
};





parcelRequire("42omo");






const $92cb390251785e80$var$dividerStyles = (0, $ecnYn.xcss)({
    height: '0',
    width: '100%',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderColor: 'color.border'
});
const $92cb390251785e80$export$2e0a83ec2e27ecbb = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $92cb390251785e80$var$dividerStyles
    });
};



















const $c81ca25909252d74$export$8657eff97a198097 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialogError`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });








const $7e87035b4b825004$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    errorSearchHeading: {
        id: "search_dialog_error_search_heading",
        defaultMessage: "We're having trouble loading your recently viewed content."
    },
    errorSearchBody: {
        id: "search_dialog_error_search_body",
        defaultMessage: "It might just be a hiccup. Please try refreshing the page or <button>try again</button>."
    }
});



const $5e4b8c366d6ef407$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("k0e2P")));
const $5e4b8c366d6ef407$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $5e4b8c366d6ef407$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $5e4b8c366d6ef407$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $5e4b8c366d6ef407$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $5e4b8c366d6ef407$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $5e4b8c366d6ef407$export$42f84e610f279c31 = ({ onRetry: onRetry })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $c81ca25909252d74$export$8657eff97a198097)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    // Same as other analytics events, we only want this to fire when the screen displays
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $5e4b8c366d6ef407$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $5e4b8c366d6ef407$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)($5e4b8c366d6ef407$var$Image, {})
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $5e4b8c366d6ef407$var$headingStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7e87035b4b825004$export$defe85febe8b728c).errorSearchHeading
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $5e4b8c366d6ef407$var$bodyStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7e87035b4b825004$export$defe85febe8b728c).errorSearchBody,
                    values: {
                        button: (s)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                                xcss: $5e4b8c366d6ef407$var$pressableStyles,
                                onClick: onRetry,
                                children: s
                            })
                    }
                })
            })
        ]
    });
};





parcelRequire("42omo");





var $8tdj3 = parcelRequire("8tdj3");





var $fpGTa = parcelRequire("fpGTa");










var $8UOsA = parcelRequire("8UOsA");





var $7Yuqm = parcelRequire("7Yuqm");













const $5514968f55e57b26$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    feedbackFooter: {
        id: "search_dialog_feedback_footer",
        defaultMessage: "Help us improve search"
    },
    searchChangeMessage: {
        id: "search_dialog_search_change_message",
        defaultMessage: "Why has search changed?"
    }
});


const $67539e0ab092f04e$var$footerContainerStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.150',
    paddingBlockEnd: 'space.150',
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.200',
    color: 'color.text'
});
const $67539e0ab092f04e$var$communityLinkStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.text.subtlest'
    },
    ':visited': {
        color: 'color.text.subtlest'
    }
});
const $67539e0ab092f04e$var$footerTextStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest'
});
const $67539e0ab092f04e$export$e7b87342306a8337 = ()=>{
    const [feedbackIsOpen, { setIsFeedbackModalOpen: setIsFeedbackModalOpen }] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProducts] = (0, $djVCD.useSelectedProducts)();
    const [user] = (0, $j4ply.useUser)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const requestId = (0, $4VmlX.useFetchEntitiesRequestId)();
    const traceId = (0, $4VmlX.useFetchEntitiesTraceId)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        justifyContent: "space-between",
        xcss: $67539e0ab092f04e$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                alignBlock: "center",
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $67539e0ab092f04e$var$footerTextStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $5514968f55e57b26$export$defe85febe8b728c).feedbackFooter
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8UOsA.FeedbackButton), {
                        size: "small",
                        onClick: (e)=>{
                            e.preventDefault();
                            setIsFeedbackModalOpen(true);
                        }
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7Yuqm.default), {
                        cloudId: cloudId || '',
                        experimentConfig: experimentConfig,
                        isOpen: feedbackIsOpen,
                        primaryProduct: primaryProduct || '',
                        product: selectedProducts.length ? selectedProducts.join(', ') : 'no product filter',
                        setIsOpen: setIsFeedbackModalOpen,
                        source: "quick-find",
                        userId: user.id || '',
                        userName: user.name || '',
                        mode: applicationMode,
                        requestId: requestId || '',
                        traceId: traceId || ''
                    })
                ]
            }),
            primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_rovo_search_community_post_link') && /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                xcss: $67539e0ab092f04e$var$communityLinkStyles,
                href: "https://community.atlassian.com/forums/Jira-articles/Introducing-Rovo-Search-for-Jira/ba-p/3093745",
                target: "_blank",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    alignBlock: "center",
                    space: "space.075",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $5514968f55e57b26$export$defe85febe8b728c).searchChangeMessage
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                            size: "small",
                            label: "Link to community post"
                        })
                    ]
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $isYda = parcelRequire("isYda");




var $1s5hv = parcelRequire("1s5hv");








const $7ef803532b158311$export$19c4b3b0e982f1c0 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'suggestedFilter',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });












const $3573b0e30646e134$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    suggested_filter: {
        id: "searchDialog.suggested.filter",
        defaultMessage: "Suggested filter"
    },
    apply_suggested_filter: {
        id: "searchDialog.apply.suggested.filter",
        defaultMessage: "Apply filter"
    },
    suggested_filter_icon_label: {
        id: "searchDialog.suggestedFilter.icon.label",
        defaultMessage: "Suggestion search"
    },
    // filter name messages
    project: {
        id: "searchDialog.suggestedFilter.filterName.project",
        defaultMessage: "project"
    },
    assignee: {
        id: "searchDialog.suggestedFilter.filterName.assignee",
        defaultMessage: "assignee"
    },
    app: {
        id: "searchDialog.suggestedFilter.filterName.product",
        defaultMessage: "app"
    }
});


const $aac51a5e41e61c0e$var$styles = {
    filterBadge: "_2rko12b0 _bfhki8nm _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $aac51a5e41e61c0e$export$1ba589c44bc43c28 = ({ result: result, state: state })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const setQueryParams = (0, $j4ply.useSetQueryParams)();
    const [queryParams] = (0, $j4ply.useQueryParams)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onResultClicked = (0, $42omo.useCallback)(()=>{
        const params = Object.fromEntries(Object.entries(result).map(([key, value])=>[
                key,
                value.option.value
            ]));
        setQueryParams({
            ...queryParams,
            ...params
        });
        fireAnalyticsEvent((0, $7ef803532b158311$export$19c4b3b0e982f1c0)({
            actionSubjectId: (0, $6926da8980239f02$export$b6f8db3ad0711b02)(state),
            attributes: {
                ...commonAttributes,
                suggestedFilters: Object.keys(params)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        result,
        setQueryParams,
        queryParams,
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        state
    ]);
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        size: "small",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
            label: formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).suggested_filter_icon_label),
            color: "currentColor"
        })
    });
    const title = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            columnGap: "space.100",
            children: Object.entries(result).map(([filterId, filterSuggestion])=>{
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $aac51a5e41e61c0e$var$styles.filterBadge,
                    children: [
                        formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c)[filterSuggestion.filterName]),
                        ":",
                        ' ',
                        filterSuggestion.option.label
                    ]
                }, filterId);
            })
        });
    }, [
        result,
        formatMessage
    ]);
    const { rightMetadata: rightMetadata, highlightedRightMetadata: highlightedRightMetadata, hoverRightMetadata: hoverRightMetadata } = (0, $42omo.useMemo)(()=>{
        const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).suggested_filter)
        });
        const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).apply_suggested_filter)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
            ]
        });
        const hoverRightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).apply_suggested_filter)
            })
        });
        return {
            rightMetadata: rightMetadata,
            highlightedRightMetadata: highlightedRightMetadata,
            hoverRightMetadata: hoverRightMetadata
        };
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        resultType: "filterSuggestions",
        id: "filter-suggestion",
        icon: icon,
        title: title,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        hoveredRightMetadata: hoverRightMetadata,
        onResultClicked: onResultClicked
    });
};































const $b7cdee9969fa612b$export$59708e770734a297 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'moreProductFilters',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

















parcelRequire("42omo");
















var $eoZmS = parcelRequire("eoZmS");















var $3gadb = parcelRequire("3gadb");

const $0c4269204833e8a1$var$defaultFilterButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075',
    color: 'color.text.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    // As specified on Figma
    maxWidth: '165px',
    // As specified on Figma
    backgroundColor: 'color.background.neutral.subtle',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $0c4269204833e8a1$var$compactContentFitStyles = (0, $ecnYn.xcss)({
    maxWidth: '113px' // As specified on Figma
});
const $0c4269204833e8a1$var$minWidthZeroStyles = (0, $ecnYn.xcss)({
    minWidth: '0' // Allow the button to shrink as much as possible
});
const $0c4269204833e8a1$var$filterButtonSelectedStateStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $0c4269204833e8a1$var$compactSpacingStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.050'
});
const $0c4269204833e8a1$var$comfortableGapStyles = (0, $ecnYn.xcss)({
    gap: 'space.100'
});
const $0c4269204833e8a1$var$filterButtonContentStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $0c4269204833e8a1$var$noBorderStyles = (0, $ecnYn.xcss)({
    border: 0
});
const $0c4269204833e8a1$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function FilterButton({ children: children, contentFit: contentFit = 'default', iconAfter: iconAfter, iconBefore: iconBefore, isSelected: isSelected, noBorder: noBorder, tooltip: tooltip, minWidthZero: minWidthZero = false, spacing: spacing = 'default', gap: gap = 'default', ...pressableProps }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltip ?? null,
        position: "bottom",
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $2W0qg.default), {
                    ...pressableProps,
                    xcss: [
                        $0c4269204833e8a1$var$defaultFilterButtonStyles,
                        isSelected && $0c4269204833e8a1$var$filterButtonSelectedStateStyles,
                        spacing === 'compact' && $0c4269204833e8a1$var$compactSpacingStyles,
                        contentFit === 'compact' && $0c4269204833e8a1$var$compactContentFitStyles,
                        gap === 'comfortable' && $0c4269204833e8a1$var$comfortableGapStyles,
                        minWidthZero && $0c4269204833e8a1$var$minWidthZeroStyles,
                        noBorder && $0c4269204833e8a1$var$noBorderStyles
                    ],
                    ref: ref,
                    children: [
                        iconBefore,
                        children && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $0c4269204833e8a1$var$filterButtonContentStyles,
                            children: children
                        }),
                        iconAfter
                    ]
                })
            })
    });
});



var $def8z = parcelRequire("def8z");








var $5xGHP = parcelRequire("5xGHP");






















const $1aa60baca70ed4d4$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    appTooltipFor1Pand3PApps: {
        id: "inline-app-selector.1p-3p-app-tooltip",
        defaultMessage: "Open a full page search for this term filtered by {productName} results"
    },
    tooltipForAllApps: {
        id: "inline-app-selector.all-apps-tooltip",
        defaultMessage: "Open a full page search for this term searching all apps"
    }
});








parcelRequire("42omo");

const $8f03b897883d0b88$export$e087ba40596ff085 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_271_181643)",
                children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip1_271_181643)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white",
                            fillOpacity: "0.01"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                            clipPath: "url(#clip2_271_181643)",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
                                    fill: "#0066DA"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
                                    fill: "#00AC47"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
                                    fill: "#EA4335"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
                                    fill: "#00832D"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
                                    fill: "#2684FC"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
                                    fill: "#FFBA00"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_271_181643",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip1_271_181643",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip2_271_181643",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "20",
                            height: "18.3333",
                            fill: "white",
                            transform: "translate(2 2.83325)"
                        })
                    })
                ]
            })
        ]
    });





parcelRequire("42omo");

const $fa17f1a0bfd05113$export$f11b42d1aefdd173 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });



var $9yyKc = parcelRequire("9yyKc");
















// TODO: Render dynamic 1P products, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$supported1PApps = (primaryProduct)=>{
    if (!primaryProduct) return [];
    switch(primaryProduct){
        case (0, $1yEFx.PrimaryProductKeys).Confluence:
            return [
                {
                    productKey: (0, $1yEFx.ProductKeys).Confluence,
                    redirectToFPS: false
                }
            ];
        default:
            return [
                {
                    productKey: (0, $1yEFx.ProductKeys).Confluence,
                    redirectToFPS: true
                },
                {
                    productKey: (0, $1yEFx.ProductKeys).Jira,
                    redirectToFPS: true
                }
            ];
    }
};
// TODO: Render dynamic 1P products, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$supported3PApps = [
    (0, $1yEFx.ProductKeys).GoogleDrive,
    (0, $1yEFx.ProductKeys).Slack
];
// TODO: Render the icons based on configuration, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$appSelectorIcons = {
    [(0, $1yEFx.ProductKeys).GoogleDrive]: (0, $9yyKc.RovoLogoFromSVG)((0, $8f03b897883d0b88$export$e087ba40596ff085)),
    [(0, $1yEFx.ProductKeys).Slack]: (0, $9yyKc.RovoLogoFromSVG)((0, $fa17f1a0bfd05113$export$f11b42d1aefdd173))
};
const $9fbf3b40278c59cd$export$6b2b316097ae586c = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const isDialogAbove400px = dialogWidth > 400;
    const isDialogAbove450px = dialogWidth > 450;
    const apps3PToDisplay = (0, $42omo.useMemo)(()=>$9fbf3b40278c59cd$var$supported3PApps.filter((supported3PApp)=>availableProducts.includes(supported3PApp)).filter((_)=>!selectedProduct).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            }))// TODO: Remove the following Icon override of the icons when we render the icons based on a configuration
        .map(({ productKey: productKey, productConfig: productConfig })=>({
                productKey: productKey,
                productConfig: {
                    ...productConfig,
                    ...$9fbf3b40278c59cd$var$appSelectorIcons[productKey] ? {
                        Icon: $9fbf3b40278c59cd$var$appSelectorIcons[productKey]
                    } : {}
                }
            })), [
        availableProducts,
        productConfigs,
        selectedProduct
    ]);
    const apps1PToDisplay = (0, $42omo.useMemo)(()=>$9fbf3b40278c59cd$var$supported1PApps(primaryProduct).filter((supported1PApp)=>availableProducts.includes(supported1PApp.productKey)).filter((supported1PApp)=>!selectedProduct || supported1PApp.productKey === selectedProduct).map((supportedApp)=>({
                ...supportedApp,
                productConfig: productConfigs[supportedApp.productKey]
            })), [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    return {
        apps1PToDisplay: apps1PToDisplay,
        apps3PToDisplay: apps3PToDisplay,
        isDialogAbove400px: isDialogAbove400px,
        isDialogAbove450px: isDialogAbove450px,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct
    };
};
const $9fbf3b40278c59cd$var$prioritised3PApps = [
    (0, $1yEFx.ProductKeys).GoogleDrive,
    (0, $1yEFx.ProductKeys).Slack
];
const $9fbf3b40278c59cd$export$93388c571f049def = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const apps3PToDisplay = (0, $42omo.useMemo)(()=>availableProducts.filter((0, $1yEFx.is3pProductKey)).sort((a, b)=>{
            const aPreferredPosition = $9fbf3b40278c59cd$var$prioritised3PApps.indexOf(a);
            const bPreferredPosition = $9fbf3b40278c59cd$var$prioritised3PApps.indexOf(b);
            if (aPreferredPosition !== -1 && bPreferredPosition !== -1) return aPreferredPosition - bPreferredPosition;
            else if (aPreferredPosition !== -1) return -1;
            else if (bPreferredPosition !== -1) return 1;
            else return 0;
        }).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            })).slice(0, 2), [
        availableProducts,
        productConfigs
    ]);
    const numberOfAdditionalProducts = availableProducts.length - apps3PToDisplay.length;
    return {
        apps3PToDisplay: apps3PToDisplay,
        primaryProduct: primaryProduct,
        numberOfAdditionalProducts: numberOfAdditionalProducts
    };
};


const $e1138a05237425a8$var$inlineFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $e1138a05237425a8$var$noProductFilterStyles = (0, $ecnYn.xcss)({
    marginRight: 'auto'
});
const $e1138a05237425a8$var$AppButtonFor3PApps = ({ productKey: productKey, redirectToFPSWithProductSelected: redirectToFPSWithProductSelected, trigger: trigger })=>{
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const isSmartlink = (0, $def8z.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.useIsUserOAuthed)(productKey);
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    if (userNeedsOAuth) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "QuickFindAppButtonFor3PAppsOAuthWrapper",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
            product: productKey,
            postAuthAction: ()=>{
                redirectToFPSWithProductSelected();
            },
            trigger: (triggerProps)=>trigger({
                    ...triggerProps,
                    userNeedsAuth: true
                }),
            isOnSearchDialog: true,
            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
            useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
            isSmartlink: isSmartlink,
            searchQuery: quickFindQuery,
            oAuthSource: (0, $ckkm9.OAuthSource).quickFindFilter,
            thirdPartyConfigs: thirdPartyConfigs
        }, productKey)
    });
    return trigger({
        userNeedsAuth: false
    });
};
const $e1138a05237425a8$export$863a72861bb447a2 = ({ onAllFiltersClickCallback: onAllFiltersClickCallback })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { apps1PToDisplay: apps1PToDisplay, isDialogAbove400px: isDialogAbove400px, isDialogAbove450px: isDialogAbove450px, primaryProduct: primaryProduct, selectedProduct: selectedProduct } = (0, $9fbf3b40278c59cd$export$6b2b316097ae586c)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const { apps3PToDisplay: apps3PToDisplay, numberOfAdditionalProducts: numberOfAdditionalProducts } = (0, $9fbf3b40278c59cd$export$93388c571f049def)();
    const onAppFilterSelected = (productKey, options, event)=>{
        const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: newSelectedProduct === undefined ? 'unselected' : 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: options.isPostAuthAction,
                isRedirectedToFPS: options.redirectToFPS
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        if (!options.redirectToFPS) {
            selectProductFilter(newSelectedProduct);
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push', event);
        clearAllFilters();
        setQuickFindOpen(false);
    };
    const apps3pComponent = apps3PToDisplay.map(({ productKey: productKey, productConfig: productConfig })=>{
        const Icon = productConfig.IconBorderless ?? productConfig.Icon;
        return /*#__PURE__*/ (0, $l998X.jsx)($e1138a05237425a8$var$AppButtonFor3PApps, {
            productKey: productKey,
            productConfig: productConfig,
            redirectToFPSWithProductSelected: ()=>onAppFilterSelected(productKey, {
                    redirectToFPS: true,
                    isPostAuthAction: true
                }),
            trigger: ({ triggerProps: triggerProps, userNeedsAuth: userNeedsAuth })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                    ...triggerProps,
                    contentFit: isDialogAbove450px ? 'default' : 'compact',
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                        size: 'xsmall'
                    }),
                    isSelected: false,
                    onClick: (event)=>{
                        if (!userNeedsAuth) onAppFilterSelected(productKey, {
                            redirectToFPS: true,
                            isPostAuthAction: false
                        }, event);
                    },
                    spacing: !userNeedsAuth || isDialogAbove400px ? 'default' : 'compact',
                    tooltip: !userNeedsAuth && formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).appTooltipFor1Pand3PApps, {
                        productName: productConfig.displayName
                    }),
                    children: isDialogAbove400px && productConfig.displayName
                })
        }, productKey);
    });
    const apps1PComponent = apps1PToDisplay.map(({ productKey: productKey, productConfig: productConfig, redirectToFPS: redirectToFPS })=>{
        const AppIcon = productConfig.Icon;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
            "aria-current": selectedProduct === productKey,
            contentFit: isDialogAbove450px ? 'default' : 'compact',
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(AppIcon, {
                size: "small"
            }),
            isSelected: selectedProduct === productKey,
            onClick: (event)=>onAppFilterSelected(productKey, {
                    redirectToFPS: redirectToFPS,
                    isPostAuthAction: false
                }, event),
            tooltip: formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).appTooltipFor1Pand3PApps, {
                productName: productConfig.displayName
            }),
            spacing: isDialogAbove400px ? 'default' : 'compact',
            children: isDialogAbove400px && productConfig.displayName
        }, productKey);
    });
    if (!(0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct)) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        testId: "qf-inline-app-selector",
        xcss: [
            $e1138a05237425a8$var$inlineFilterStyles,
            $e1138a05237425a8$var$noProductFilterStyles
        ],
        children: [
            apps3pComponent,
            apps1PComponent
        ]
    });
    if (isAnyFilterSelected && (0, $2OtFZ.serveQFDropdownExperiment)(primaryProduct, {
        fireExperimentExposure: false
    })) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        testId: "qf-inline-app-selector",
        xcss: $e1138a05237425a8$var$inlineFilterStyles,
        children: [
            apps3pComponent,
            apps3PToDisplay.length > 0 && numberOfAdditionalProducts > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                onClick: (event)=>onAllFiltersClickCallback?.({
                        event: event,
                        action: 'searchByAllApps'
                    }),
                tooltip: formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).tooltipForAllApps),
                testId: "quick-find-app-filters-all-apps-button",
                children: `+ ${numberOfAdditionalProducts}`
            })
        ]
    });
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 









var $ccHMk = parcelRequire("ccHMk");








































var $ehGUC = parcelRequire("ehGUC");


var $ayBYg = parcelRequire("ayBYg");


var $3ZkFT = parcelRequire("3ZkFT");




parcelRequire("42omo");





var $c4sKh = parcelRequire("c4sKh");


var $226KS = parcelRequire("226KS");


var $ghftu = parcelRequire("ghftu");








parcelRequire("42omo");






const $d11e9fb73f3c65ea$var$filterButtonIconContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075'
});
const $d11e9fb73f3c65ea$export$68a752ca64f3cf84 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $d11e9fb73f3c65ea$var$filterButtonIconContainerStyles,
        children: children
    });
};









var $c9mMn = parcelRequire("c9mMn");

var $6Ipjn = parcelRequire("6Ipjn");





var $5eWut = parcelRequire("5eWut");


var $k5mzm = parcelRequire("k5mzm");


var $ls6iZ = parcelRequire("ls6iZ");

const $1e26310d04240baa$export$4f9a317f0153844 = (option)=>{
    const arrayOfOptions = Array.isArray(option) ? option : [
        option
    ];
    return arrayOfOptions.every((popupOption)=>popupOption?.isSelected !== undefined && popupOption?.value !== undefined && popupOption?.trackingKey !== undefined && popupOption?.value !== undefined && popupOption?.queryParamValue !== undefined && popupOption?.isSuggested !== undefined && popupOption?.isDefault !== undefined && popupOption?.label !== undefined);
};


const $40387639b8effd2d$export$381eb977a1d9bc81 = ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, label: label, noOptionsMessage: noOptionsMessage, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, target: target, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, filterId: filterId })=>{
    const debounceTimeout = (0, $42omo.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $42omo.useState)(searchInput);
    // For now, the FilterPopupSelect component is only being used in Quick Find so the following
    // analytics hooks are valid. Please extract out the analytics events when we reuse this
    // component in FPS.
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const handleInputChange = (0, $42omo.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $42omo.useCallback)((value)=>{
        if (!(0, $1e26310d04240baa$export$4f9a317f0153844)(value)) throw new Error('Value should match the PopupSelectOption type');
        onSelectChange(value);
        // Omitting these attrtibutes as there is a race condition here since the filter attributes
        // have not yet been applied in the store so it will always be one update behind.
        const { productSelected: _productSelected, filters: _filters, filterSelections: _filterSelections, ...restAttributes } = commonAttributes;
        const selection = (Array.isArray(value) ? value : [
            value
        ]).at(0);
        if (!selection) return; // This should never be executed
        fireAnalyticsEvent((0, $5eWut.onFilterSelection)({
            action: selection.isSelected ? 'unselected' : 'selected',
            location: 'inline',
            actionSubjectId: 'searchDialogFilter',
            attributes: {
                ...restAttributes,
                filterId: filterId
            }
        }));
    }, [
        commonAttributes,
        filterId,
        fireAnalyticsEvent,
        onSelectChange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6Ipjn.default), {
        blurInputOnSelect: false,
        canClearFilter: canClearFilter,
        closeMenuOnSelect: !checkboxIndicators,
        components: {
            Control: $k5mzm.Control,
            MenuList: isFiltersDiscoverability2Enabled ? (0, $ls6iZ.MenuListWithoutClearFilterOptionLabel) : (0, $ls6iZ.MenuListWithClearFilterOptionLabel),
            ...checkboxIndicators ? {
                Option: (0, $c9mMn.CheckboxOption)
            } : {}
        },
        defaultIsOpen: defaultIsOpen,
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        defaultOptions: false,
        formatOptionLabel: formatOptionLabel,
        inputValue: currentSearchInput,
        isClearable: false,
        isLoading: isLoading,
        isOptionSelected: (option)=>option.isSelected,
        isSearchable: isSearchable,
        label: label,
        maxMenuHeight: 400,
        maxMenuWidth: "22rem",
        menuPlacement: "bottom",
        minMenuWidth: minMenuWidth,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        onInputChange: handleInputChange,
        onMenuClose: ()=>{
            setCurrentSearchInput('');
            onDropdownClose?.();
        },
        onMenuOpen: onDropdownOpen,
        options: options,
        placeholder: placeholder,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        searchThreshold: -1,
        shouldCloseMenuOnTab: false,
        target: target
    });
};



var $5cssW = parcelRequire("5cssW");





var $lx1ar = parcelRequire("lx1ar");




const $76c9230653325278$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    assetsSchema: {
        id: "quick-find.filters.names.assets-schema",
        defaultMessage: "Schema"
    },
    assetsFilterAssetsSchemaPlaceholder: {
        id: "quick-find.assets.filter.assets-schema.placeholder",
        defaultMessage: "Find schemas"
    },
    assetsFilterLabelSelected: {
        id: "quick-find.assets.filter.assets-schema.label.selected",
        defaultMessage: "Selected"
    },
    assetsFilterLabelUnselected: {
        id: "quick-find.assets.filter.assets-schema.label.unselected",
        defaultMessage: "Suggested"
    },
    assetsIconLabel: {
        id: "quick-find.assets.filter.assets-schema.icon.label",
        defaultMessage: "Assets schema filter"
    }
});


const $709eb420c90c9056$export$6cac819feaba71a8 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $lx1ar.filter).id
    });
    const AssetsIcon = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Assets).Icon;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, firstSelectedOptionLabel: firstSelectedOptionLabel, badgeLabel: badgeLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const getIconBefore = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(AssetsIcon, {
                    size: "xxsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                    label: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsIconLabel),
                    size: "small"
                })
            ]
        });
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
            appearance: "primary",
            children: badgeLabel
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $lx1ar.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsSchema),
        placeholder: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterAssetsSchemaPlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                children: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsSchema)
            })
    });
};
var $709eb420c90c9056$export$2e2bcd8739ae039 = $709eb420c90c9056$export$6cac819feaba71a8;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");








var $eiXsV = parcelRequire("eiXsV");








var $gj7hi = parcelRequire("gj7hi");






var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");














var $iUihD = parcelRequire("iUihD");




const $166b563a8d1db87f$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    assetsType: {
        id: "quick-find.filters.names.assets-type",
        defaultMessage: "Object type"
    },
    assetsFilterAssetsTypePlaceholder: {
        id: "quick-find.assets.filter.assets-type.placeholder",
        defaultMessage: "Find object types"
    },
    assetsFilterLabelSelected: {
        id: "quick-find.assets.filter.assets-type.label.selected",
        defaultMessage: "Selected"
    },
    assetsFilterLabelUnselected: {
        id: "quick-find.assets.filter.assets-type.label.unselected",
        defaultMessage: "Suggested"
    },
    assetsIconLabel: {
        id: "quick-find.assets.filter.assets-type.icon.label",
        defaultMessage: "Object type filter"
    }
});


const $013d36e168fbd190$var$styles = {
    imageContainer: "_1bsb7vkz _4t3i7vkz"
};
const $013d36e168fbd190$export$d7168ecc5f9ccc6f = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $iUihD.filter).id
    });
    const AssetsIcon = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Assets).Icon;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, firstSelectedOptionLabel: firstSelectedOptionLabel, badgeLabel: badgeLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const formatOptionLabel = (data)=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: data.avatarUrl,
                        alt: data.label,
                        className: (0, $gMc0m.default)([
                            $013d36e168fbd190$var$styles.imageContainer
                        ])
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.025",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: data.label
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                                    label: "",
                                    size: "small",
                                    color: "var(--ds-text-subtlest)"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    color: "color.text.subtlest",
                                    children: data.metadata.schemaName
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const getIconBefore = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(AssetsIcon, {
                    size: "xxsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eiXsV))), {
                    label: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsIconLabel),
                    size: "small"
                })
            ]
        });
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
            appearance: "primary",
            children: badgeLabel
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $iUihD.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsType),
        placeholder: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterAssetsTypePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        formatOptionLabel: formatOptionLabel,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                children: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsType)
            })
    });
};
var $013d36e168fbd190$export$2e2bcd8739ae039 = $013d36e168fbd190$export$d7168ecc5f9ccc6f;





parcelRequire("42omo");











var $6767u = parcelRequire("6767u");





var $jQ2up = parcelRequire("jQ2up");











var $5X4Ay = parcelRequire("5X4Ay");




const $8aef874e6420f0a9$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    assignee: {
        id: "quick-find.filters.names.assignee",
        defaultMessage: "Assignee"
    },
    jiraFilterAssigneePlaceholder: {
        id: "quick-find.jira.filter.assignee.placeholder",
        defaultMessage: "Find people"
    },
    jiraFilterAssigneeLabelSelected: {
        id: "quick-find.jira.filter.assignee.selected",
        defaultMessage: "Selected"
    },
    jiraFilterAssigneeLabelUnselected: {
        id: "quick-find.jira.filter.assignee.unselected",
        defaultMessage: "Suggested"
    }
});


const $adecdabd8db4a400$export$20e0939737a940df = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5X4Ay.filter).id
    });
    const JiraIcon = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Jira).Icon;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, firstSelectedOptionLabel: firstSelectedOptionLabel, badgeLabel: badgeLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $8aef874e6420f0a9$export$a7357cdd1f0b0168).jiraFilterAssigneeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $8aef874e6420f0a9$export$a7357cdd1f0b0168).jiraFilterAssigneeLabelUnselected),
            options: suggestedOptions
        }
    ];
    const getIconBefore = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(JiraIcon, {
                    size: "xxsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                    label: formatMessage((0, $8aef874e6420f0a9$export$a7357cdd1f0b0168).assignee)
                })
            ]
        });
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
            appearance: "primary",
            children: badgeLabel
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        testId: "search-dialog-assignee-filter",
        filterId: (0, $5X4Ay.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $8aef874e6420f0a9$export$a7357cdd1f0b0168).assignee),
        placeholder: formatMessage((0, $8aef874e6420f0a9$export$a7357cdd1f0b0168).jiraFilterAssigneePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: clearOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "search-dialog-assignee-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                children: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $8aef874e6420f0a9$export$a7357cdd1f0b0168).assignee)
            })
    });
};





parcelRequire("42omo");





























var $aGXLL = parcelRequire("aGXLL");




const $42590f29eedf8f8c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    contributor: {
        id: "quick-find.filters.names.contributor",
        defaultMessage: "Contributor"
    },
    confluenceFilterContributorPlaceholder: {
        id: "quick-find.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterLabelSelected: {
        id: "quick-find.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "quick-find.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $23012254e2ce6f81$export$fcbf8a9904746204 = ({ iconBefore: iconBefore, iconAfter: iconAfter, onFilterClose: onFilterClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOptionForContributorFilter, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aGXLL.filter).id
    });
    const confluenceProductConfig = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Confluence);
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, badgeLabel: badgeLabel, firstSelectedOptionLabel: firstSelectedOptionLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const ConfluenceIcon = confluenceProductConfig.Icon;
    const getIconBefore = ()=>{
        if (iconBefore) return iconBefore;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(ConfluenceIcon, {
                    size: "xxsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                    label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor)
                })
            ]
        });
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? iconAfter ? iconAfter : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
            appearance: "primary",
            children: badgeLabel
        });
    };
    const setOption = (option)=>{
        setOptionForContributorFilter(option, undefined, (0, $1yEFx.ProductKeys).Confluence);
    };
    const onDropdownClose = ()=>{
        clearLookupInput();
        if (onFilterClose) onFilterClose(options, selectedOptions);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $aGXLL.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: onDropdownClose,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor),
        placeholder: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterContributorPlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "search-dialog-contributor-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true,
                children: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor)
            }),
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};





parcelRequire("42omo");








var $hbYDZ = parcelRequire("hbYDZ");




















var $gHwfH = parcelRequire("gHwfH");




const $f2f35461e6afcf35$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    project: {
        id: "quick-find.filters.names.project",
        defaultMessage: "Project"
    },
    jiraFilterProjectPlaceholder: {
        id: "quick-find.jira.filter.project.placeholder",
        defaultMessage: "Find projects"
    },
    jiraFilterProjectLabelSelected: {
        id: "quick-find.jira.filter.project.selected",
        defaultMessage: "Selected"
    },
    jiraFilterProjectLabelUnselected: {
        id: "quick-find.jira.filter.project.unselected",
        defaultMessage: "Suggested"
    },
    spaces: {
        id: "quick-find.filters.names.spaces",
        defaultMessage: "Space"
    },
    jiraFilterSpacesPlaceholder: {
        id: "quick-find.jira.filter.spaces.placeholder",
        defaultMessage: "Find spaces"
    },
    jiraFilterSpacesLabelSelected: {
        id: "quick-find.jira.filter.spaces.selected",
        defaultMessage: "Selected"
    },
    jiraFilterSpacesLabelUnselected: {
        id: "quick-find.jira.filter.spaces.unselected",
        defaultMessage: "Suggested"
    }
});


const $36b59665d0e8964e$export$2d328ee1090a8621 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $gHwfH.filter).id
    });
    const JiraIcon = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Jira).Icon;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, firstSelectedOptionLabel: firstSelectedOptionLabel, badgeLabel: badgeLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $f2f35461e6afcf35$export$a7357cdd1f0b0168).jiraFilterSpacesLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $f2f35461e6afcf35$export$a7357cdd1f0b0168).jiraFilterSpacesLabelUnselected),
            options: suggestedOptions
        }
    ];
    const getIconBefore = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(JiraIcon, {
                    size: "xxsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
                    label: formatMessage((0, $f2f35461e6afcf35$export$a7357cdd1f0b0168).spaces)
                })
            ]
        });
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
            appearance: "primary",
            children: badgeLabel
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        testId: "search-dialog-project-filter",
        filterId: (0, $gHwfH.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $f2f35461e6afcf35$export$a7357cdd1f0b0168).spaces),
        placeholder: formatMessage((0, $f2f35461e6afcf35$export$a7357cdd1f0b0168).jiraFilterSpacesPlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: clearOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "search-dialog-project-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                children: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $f2f35461e6afcf35$export$a7357cdd1f0b0168).spaces)
            })
    });
};





parcelRequire("42omo");














var $eG1e2 = parcelRequire("eG1e2");




















var $a97k3 = parcelRequire("a97k3");




const $98def20fb816381d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    space: {
        id: "search-page.filters.names.space",
        defaultMessage: "Space"
    },
    confluenceFilterSpacePlaceholder: {
        id: "search-page.confluence.filter.space.placeholder",
        defaultMessage: "Find spaces"
    },
    confluenceFilterLabelSelected: {
        id: "search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "search-page.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    },
    confluenceFilterSpaceIcon: {
        id: "search-page.confluence.filter.space.icon",
        defaultMessage: "Space Icon"
    }
});


const $5bd43442241df578$export$2414da0e5c5cdf82 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOptionForSelectFilter, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $a97k3.filter).id
    });
    const confluenceProductConfig = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Confluence);
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, badgeLabel: badgeLabel, firstSelectedOptionLabel: firstSelectedOptionLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $98def20fb816381d$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $98def20fb816381d$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const ConfluenceIcon = confluenceProductConfig.Icon;
    const getIconBefore = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(ConfluenceIcon, {
                    size: "xxsmall"
                }),
                (0, $2OtFZ.serveConfluenceSpaceIconUpdate)() ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
                    label: formatMessage((0, $98def20fb816381d$export$a7357cdd1f0b0168).confluenceFilterSpaceIcon)
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                    label: formatMessage((0, $98def20fb816381d$export$a7357cdd1f0b0168).confluenceFilterSpaceIcon)
                })
            ]
        });
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
            appearance: "primary",
            children: badgeLabel
        });
    };
    const setOption = (option)=>{
        setOptionForSelectFilter(option, undefined, (0, $1yEFx.ProductKeys).Confluence);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $a97k3.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $98def20fb816381d$export$a7357cdd1f0b0168).space),
        placeholder: formatMessage((0, $98def20fb816381d$export$a7357cdd1f0b0168).confluenceFilterSpacePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "search-dialog-space-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true,
                children: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $98def20fb816381d$export$a7357cdd1f0b0168).space)
            }),
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};



var $fJ1R6 = parcelRequire("fJ1R6");




const $db27a10ae551c873$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    externalLinkIconLabel: {
        id: "inline-product-filters.external-link-icon.label",
        defaultMessage: "External Link Icon"
    },
    moreButtonLabel: {
        id: "inline-product-filters.more-filters.label",
        defaultMessage: "More"
    },
    filterByIcon: {
        id: "quick-find-filters.filter-by-icon-label",
        defaultMessage: "Filter by Icon"
    },
    moreButtonTooltip: {
        id: "inline-product-filters.more-filters.tooltip",
        defaultMessage: "Open a full page search with more filter options for {product}"
    },
    clearFilters: {
        id: "quick-find.filters.clear-filters-button-label",
        defaultMessage: "Clear filters"
    }
});



var $fSUtG = parcelRequire("fSUtG");

const $f4dec8f243f8bf8c$var$oldInlineProductFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingInlineStart: 'space.100',
    gap: 'space.100',
    width: '100%',
    minWidth: '0' // Prevents the filter buttons from overflowing from its container and allow it to shrink as much as possible
});
const $f4dec8f243f8bf8c$var$newInlineProductFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    minWidth: '0' // Prevents the filter buttons from overflowing from its container and allow it to shrink as much as possible
});
const $f4dec8f243f8bf8c$var$appSelectorDividerStyles = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    borderColor: 'color.border',
    borderRightStyle: 'solid',
    marginBlock: 'space.025'
});
const $f4dec8f243f8bf8c$var$prioritisedFilters = {
    [(0, $1yEFx.PrimaryProductKeys).Confluence]: [
        (0, $ehGUC.spaceFilter).id,
        (0, $ehGUC.contributorFilter).id
    ],
    [(0, $1yEFx.PrimaryProductKeys).Jira]: [
        (0, $ehGUC.projectFilter).id,
        (0, $ehGUC.assigneeFilter).id
    ],
    // Not supported
    [(0, $1yEFx.PrimaryProductKeys).Atlas]: [],
    [(0, $1yEFx.PrimaryProductKeys).Focus]: [],
    [(0, $1yEFx.PrimaryProductKeys).Assets]: [
        (0, $ehGUC.assetsSchemaFilter).id,
        (0, $ehGUC.assetsTypeFilter).id
    ],
    [(0, $1yEFx.PrimaryProductKeys).Elevate]: [],
    [(0, $1yEFx.PrimaryProductKeys).Talent]: [],
    [(0, $1yEFx.PrimaryProductKeys).RovoExtension]: []
};
const $f4dec8f243f8bf8c$var$ClearAllButton = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        id: "clear-all-button",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            onClick: onClear,
            appearance: "subtle",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                children: formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).clearFilters)
            })
        })
    });
};
const $f4dec8f243f8bf8c$export$b1ad550c251413b4 = ({ onAllFiltersClickCallback: onAllFiltersClickCallback })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const { clearAllFilters: clearAllFilters, resetSort: resetSort } = (0, $djVCD.useSearchActions)();
    const [{ filtersInLine: filtersInLine }] = (0, $djVCD.useFiltersToDisplay)({
        basedOnPrimaryProduct: true,
        primaryProduct: primaryProduct,
        prioritisedFilterIds: primaryProduct ? $f4dec8f243f8bf8c$var$prioritisedFilters[primaryProduct] : []
    });
    const filtersToRender = filtersInLine.filter((f)=>f !== (0, $ehGUC.commentedByMeFilter).id && f !== (0, $ehGUC.watchedFilter).id).slice(0, 2); // Only show 2 filters at a time
    const serveQFAppSelector = (0, $2OtFZ.serveQFAppSelectorExperiment)(primaryProduct, {
        fireExperimentExposure: false
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { onFilterChange: onFilterChange, onDropdownOpenChange: onDropdownOpenChange, onFilterClearAction: onFilterClearAction } = (0, $fSUtG.useFilterAnalytics)(fireAnalyticsEvent, commonAttributes, (0, $hHl3d.SearchExperience).QUICK_FIND);
    (0, $fSUtG.useUnselectProductFilter)({
        isEnabled: !serveQFAppSelector
    });
    const oldInlineProductFilters = /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $f4dec8f243f8bf8c$var$oldInlineProductFilterStyles,
        testId: "qf-product-filters",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5bd43442241df578$export$2414da0e5c5cdf82), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                onClick: (event)=>{
                    onAllFiltersClickCallback?.({
                        ...filtersDiscoverability2Enabled && {
                            filterDropdownOpen: true
                        },
                        event: event
                    });
                },
                iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                    label: formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).externalLinkIconLabel),
                    color: "currentColor",
                    size: "small"
                }),
                children: formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).moreButtonLabel)
            })
        ]
    });
    /**
   * Defines inline product filters to show for each primary product. Given that
   * the filters we decide to show are determined by product and design, there
   * isn't a need to make this dynamic yet.
   */ const newInlineProductFilters = (0, $42omo.useMemo)(()=>{
        // rovo-extension uses Confluence's config since it's not a searchable product
        const productConfigKey = primaryProduct === (0, $1yEFx.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension') ? (0, $1yEFx.ProductKeys).Confluence : primaryProduct;
        const primaryProductDisplayName = productConfigs[productConfigKey]?.displayName ?? '';
        const moreFiltersButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
            onClick: (event)=>{
                onAllFiltersClickCallback?.({
                    ...filtersDiscoverability2Enabled && {
                        filterDropdownOpen: true
                    },
                    action: 'filterByPrimaryProduct',
                    event: event
                });
            },
            iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                label: formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).filterByIcon)
            }),
            noBorder: true,
            tooltip: formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).moreButtonTooltip, {
                product: primaryProductDisplayName
            }),
            testId: "quick-find-inline-product-filters-more-filters-button"
        });
        if ((primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence || primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira || primaryProduct === (0, $1yEFx.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) && (0, $2OtFZ.serveQFDropdownExperiment)(primaryProduct, {
            fireExperimentExposure: false
        })) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $f4dec8f243f8bf8c$var$newInlineProductFilterStyles,
            testId: "qf-product-filters",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3ZkFT.default), {
                    hideOnHoverOut: primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('search_qf_close_dropdown_on_hover_off'),
                    experience: (0, $hHl3d.SearchExperience).QUICK_FIND,
                    onFiltersChange: onFilterChange,
                    onDropdownOpenChange: onDropdownOpenChange
                }),
                serveQFAppSelector && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fJ1R6.AppSelector), {
                            fit: "compact"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $f4dec8f243f8bf8c$var$appSelectorDividerStyles
                        })
                    ]
                }),
                filtersToRender.map((id)=>{
                    const Filter = (0, $ayBYg.filters)[id];
                    if (!Filter) return null;
                    return /*#__PURE__*/ (0, $l998X.jsx)(Filter, {
                        showPrimaryProductIcon: true,
                        fit: "compact",
                        hideOnHoverOut: primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('search_qf_close_dropdown_on_hover_off'),
                        onFilterChange: (change)=>onFilterChange(id, change, 'inline')
                    }, id);
                }),
                isAnyFilterSelected && /*#__PURE__*/ (0, $l998X.jsx)($f4dec8f243f8bf8c$var$ClearAllButton, {
                    onClear: ()=>{
                        clearAllFilters();
                        resetSort();
                        onFilterClearAction('inline');
                    }
                })
            ]
        });
        else if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence || primaryProduct === (0, $1yEFx.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $f4dec8f243f8bf8c$var$newInlineProductFilterStyles,
            testId: "qf-product-filters",
            children: [
                serveQFAppSelector && /*#__PURE__*/ (0, $l998X.jsx)((0, $fJ1R6.AppSelector), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5bd43442241df578$export$2414da0e5c5cdf82), {}),
                filtersDiscoverability2Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $23012254e2ce6f81$export$fcbf8a9904746204), {}),
                moreFiltersButton
            ]
        });
        else if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $f4dec8f243f8bf8c$var$newInlineProductFilterStyles,
            testId: "qf-product-filters",
            children: [
                serveQFAppSelector && /*#__PURE__*/ (0, $l998X.jsx)((0, $fJ1R6.AppSelector), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $36b59665d0e8964e$export$2d328ee1090a8621), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $adecdabd8db4a400$export$20e0939737a940df), {}),
                moreFiltersButton
            ]
        });
        else if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Assets && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $f4dec8f243f8bf8c$var$newInlineProductFilterStyles,
            testId: "qf-product-filters",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $709eb420c90c9056$export$6cac819feaba71a8), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $013d36e168fbd190$export$d7168ecc5f9ccc6f), {}),
                moreFiltersButton
            ]
        });
        else return null; // Keep this when cleaning up serveQFDropdownExperiment
    }, [
        clearAllFilters,
        filtersDiscoverability2Enabled,
        filtersToRender,
        formatMessage,
        isAnyFilterSelected,
        onAllFiltersClickCallback,
        onDropdownOpenChange,
        onFilterChange,
        onFilterClearAction,
        primaryProduct,
        productConfigs,
        resetSort,
        serveQFAppSelector
    ]);
    if ((0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct)) return newInlineProductFilters;
    if (selectedProduct) return oldInlineProductFilters;
    return null;
};





const $77e9ec5198e0dc0e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    filterByIcon: {
        id: "quick-find-filters.filter-by-icon-label",
        defaultMessage: "Filter by Icon"
    }
});


const $b21d47feb05d9034$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.200',
    paddingBlockStart: 'space.025',
    paddingBlockEnd: 'space.075'
});
const $b21d47feb05d9034$var$containerSpaceBetweenStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});
const $b21d47feb05d9034$var$filterDropdownIconStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    marginInlineEnd: 'space.100'
});
const $b21d47feb05d9034$export$cc5615a202a2ea8c = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const serveQFAppSelector = (0, $2OtFZ.serveQFAppSelectorExperiment)(primaryProduct, {
        fireExperimentExposure: false
    });
    const isDialogAbove275px = dialogWidth > 275;
    const displayCustomizeIcon = isDialogAbove275px || !selectedProduct;
    const onAllFiltersClickCallback = (0, $42omo.useCallback)(({ action: action = 'none', filterDropdownOpen: filterDropdownOpen = false, event: event })=>{
        setQuickFindOpen(false);
        fireAnalyticsEvent((0, $b7cdee9969fa612b$export$59708e770734a297)({
            actionSubjectId: 'more-product-filters',
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        // TODO: This is a temporary measure until we do QS-6716 post Team 25 where it syncs filters with FPS.
        // For now, executing a search query on FPS search will always clear the filters in QF as FPS filters
        // is the source of truth for filter state.
        clearAllFilters();
        let newQueryParams = {};
        if (action === 'searchByAllApps') newQueryParams = {};
        else if (action === 'none') newQueryParams = queryParams;
        else if (action === 'filterByPrimaryProduct') newQueryParams = {
            ...queryParams,
            product: primaryProduct
        };
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...newQueryParams,
            ...filtersDiscoverability2Enabled ? {
                filterDropdownOpen: filterDropdownOpen
            } : {},
            text: quickFindQuery
        }), 'push', event);
    }, [
        clearAllFilters,
        commonAttributes,
        fireAnalyticsEvent,
        generateSearchUrl,
        nonPrivacySafeAttributes,
        onNavigate,
        primaryProduct,
        queryParams,
        quickFindQuery,
        setQuickFindOpen,
        filtersDiscoverability2Enabled
    ]);
    if (!(0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct)) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $b21d47feb05d9034$var$containerStyles,
            $b21d47feb05d9034$var$containerSpaceBetweenStyles
        ],
        children: [
            displayCustomizeIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $b21d47feb05d9034$var$filterDropdownIconStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                    label: formatMessage((0, $77e9ec5198e0dc0e$export$a7357cdd1f0b0168).filterByIcon)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e1138a05237425a8$export$863a72861bb447a2), {
                onAllFiltersClickCallback: onAllFiltersClickCallback
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f4dec8f243f8bf8c$export$b1ad550c251413b4), {
                onAllFiltersClickCallback: onAllFiltersClickCallback
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $b21d47feb05d9034$var$containerStyles,
            $b21d47feb05d9034$var$containerSpaceBetweenStyles
        ],
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f4dec8f243f8bf8c$export$b1ad550c251413b4), {
                onAllFiltersClickCallback: onAllFiltersClickCallback
            }),
            !serveQFAppSelector && /*#__PURE__*/ (0, $l998X.jsx)((0, $e1138a05237425a8$export$863a72861bb447a2), {
                onAllFiltersClickCallback: onAllFiltersClickCallback
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 









var $4ymXE = parcelRequire("4ymXE");


var $4ymSL = parcelRequire("4ymSL");




















/* all-apps-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");












var $6mXku = parcelRequire("6mXku");




const $18556631decfdfd2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    more: {
        id: "search.common.icons.all-apps.more",
        defaultMessage: "more"
    }
});


const $1aa88845bd0865d7$var$styles = {
    moreButtonStyles: "_19it1ps9 _2rko12b0 _4cvr1h6o _bfhkhfxm _1e0c1txw _19bvu2gc _u5f312x7",
    iconsStyles: "_1e0c1txw _y4klv77o"
};
const $1aa88845bd0865d7$export$a9ec35d044cf4cf = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        role: "presentation",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $1aa88845bd0865d7$var$styles.iconsStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6mXku.JiraAppSelectorIcon), {})
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $1aa88845bd0865d7$var$styles.moreButtonStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: `+ ${formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).more)}`
                })
            })
        ]
    });
};



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $aa12660590b769fd$export$ff7706047246b98b = ()=>{
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
const $aa12660590b769fd$export$281af962cf87c22e = (keys, refs)=>{
    const rects = new Map();
    for (const key of keys){
        const el = refs.get(key);
        if (el) rects.set(key, el.getBoundingClientRect());
    }
    return rects;
};
const $aa12660590b769fd$export$f9dcc678030ab488 = (order)=>{
    const m = new Map();
    order.forEach((k, i)=>m.set(k, i));
    return m;
};
const $aa12660590b769fd$export$93a5273e04316040 = (prev, next, order)=>{
    if (prev.size !== next.size) return false;
    for (const key of order){
        if (prev.get(key) !== next.get(key)) return false;
    }
    return true;
};


const $b8fd72204c218acd$var$flipListContainerStyles = null;
const $b8fd72204c218acd$var$flipListItemStyles = null;
const $b8fd72204c218acd$var$flipListItemNoTransitionStyles = null;
const $b8fd72204c218acd$var$flipListHiddenStyles = null; /**
                                    * FlipList
                                    *
                                    * Implements a FLIP animation. By default it reorders DOM nodes;
                                    * optionally it can keep DOM node order stable using CSS order.
                                    *
                                    * Expected behavior:
                                    * 1) All items mount with translate=(0,0)
                                    * 2) On reorder: measure FIRST, apply new order, measure LAST
                                    * 3) Apply inverse transform WITHOUT transition
                                    * 4) Next frame: reset transform to 0 WITH transition
                                    * 5) After transition completes: remain at translate=0 with new order
                                    */ 
const $b8fd72204c218acd$export$3d1498497a812571 = ({ order: order, renderItem: renderItem, getItemProps: getItemProps, disabled: disabled = false, durationMs: durationMs = 250, easing: easing = 'cubic-bezier(0.2, 0, 0.2, 1)', containerAs: Container = 'div', containerProps: containerProps, itemAs: Item = 'div', useCssOrder: useCssOrder = false, keepRemovedInDom: keepRemovedInDom = true, xcss: xcss })=>{
    const itemRefs = (0, $42omo.useRef)(new Map());
    const refCallbacksRef = (0, $42omo.useRef)(new Map()); // Stable DOM keys (CSS order) or DOM order that matches `order`.
    const [domKeys, setDomKeys] = (0, $42omo.useState)(()=>[
            ...order
        ]); // Current visual order index map.
    const [orderIndex, setOrderIndex] = (0, $42omo.useState)(()=>(0, $aa12660590b769fd$export$f9dcc678030ab488)(order)); // Current per-item transforms.
    const [transforms, setTransforms] = (0, $42omo.useState)(()=>new Map()); // Phase controls whether we disable transitions while applying inverse transforms.
    const [phase, setPhase] = (0, $42omo.useState)('idle');
    const firstRectsRef = (0, $42omo.useRef)(null);
    const timeoutRef = (0, $42omo.useRef)(null); // Keep domKeys stable (CSS order) or align DOM order to `order`.
    (0, $42omo.useEffect)(()=>{
        setDomKeys((prev)=>{
            if (useCssOrder) {
                let next = prev;
                for (const key of order)if (!next.includes(key)) next = next === prev ? [
                    ...prev,
                    key
                ] : [
                    ...next,
                    key
                ];
                if (!keepRemovedInDom) next = next.filter((k)=>order.includes(k));
                return next;
            }
            let next = [
                ...order
            ];
            if (keepRemovedInDom) {
                for (const key of prev)if (!next.includes(key)) next.push(key);
            }
            return next;
        });
    }, [
        keepRemovedInDom,
        order,
        useCssOrder
    ]); // Cleanup timers.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
        };
    }, []); // Capture FIRST rects and update orderIndex when desired order changes.
    (0, $42omo.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const nextIndex = (0, $aa12660590b769fd$export$f9dcc678030ab488)(order);
        if (disabled || (0, $aa12660590b769fd$export$ff7706047246b98b)()) {
            // Jump immediately: no transforms, just update ordering.
            setPhase((prev)=>prev === 'idle' ? prev : 'idle');
            setTransforms((prev)=>prev.size === 0 ? prev : new Map());
            setOrderIndex((prev)=>(0, $aa12660590b769fd$export$93a5273e04316040)(prev, nextIndex, order) ? prev : nextIndex);
            firstRectsRef.current = null;
            return;
        } // Detect change.
        let changed = false;
        for (const key of order)if (orderIndex.get(key) !== nextIndex.get(key)) {
            changed = true;
            break;
        }
        if (!changed) return;
         // Measure FIRST (current visual layout).
        firstRectsRef.current = (0, $aa12660590b769fd$export$281af962cf87c22e)(domKeys, itemRefs.current); // Apply new visual order (CSS order values or DOM order).
        setOrderIndex(nextIndex); // Next layout effect will measure LAST and compute transforms.
    }, [
        disabled,
        domKeys,
        order,
        orderIndex,
        useCssOrder
    ]); // After orderIndex changes commit, compute LAST rects and perform FLIP.
    (0, $42omo.useLayoutEffect)(()=>{
        if (typeof window === 'undefined') return;
        const first = firstRectsRef.current;
        if (!first) return;
        if (disabled || (0, $aa12660590b769fd$export$ff7706047246b98b)()) {
            firstRectsRef.current = null;
            return;
        }
        const last = (0, $aa12660590b769fd$export$281af962cf87c22e)(domKeys, itemRefs.current);
        const inverse = new Map();
        for (const key of domKeys){
            const a = first.get(key);
            const b = last.get(key);
            if (!a || !b) continue;
            const dx = a.left - b.left;
            const dy = a.top - b.top;
            if (dx !== 0 || dy !== 0) inverse.set(key, {
                x: dx,
                y: dy
            });
        } // Invert (no transition): apply inverse transforms.
        setPhase('inverting');
        setTransforms(inverse); // Play (with transition): next frame, reset transforms to 0.
        window.requestAnimationFrame(()=>{
            setPhase('playing');
            setTransforms(new Map());
            if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>{
                setPhase('idle');
            }, durationMs);
        });
        firstRectsRef.current = null;
    }, [
        disabled,
        domKeys,
        durationMs,
        orderIndex
    ]);
    const getItemRefCallback = (0, $42omo.useCallback)((key)=>{
        const existing = refCallbacksRef.current.get(key);
        if (existing) return existing;
        const cb = (el)=>{
            if (el) itemRefs.current.set(key, el);
            else itemRefs.current.delete(key);
        };
        refCallbacksRef.current.set(key, cb);
        return cb;
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)(Container, {
        ...containerProps,
        style: {
            '--animation-duration': `${durationMs}ms`,
            '--animation-easing': easing
        },
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            xcss
        ]),
        children: domKeys.map((key)=>{
            const itemProps = getItemProps?.(key) ?? {};
            const idx = orderIndex.get(key);
            const hidden = idx === undefined;
            const t = transforms.get(key) ?? {
                x: 0,
                y: 0
            };
            const cssOrderIndex = idx === undefined ? undefined : idx;
            let translateX = `${t.x}px`;
            let translateY = `${t.y}px`;
            let flipOrderValue;
            if (useCssOrder && cssOrderIndex !== undefined) flipOrderValue = `${cssOrderIndex}`;
            return /*#__PURE__*/ (0, $l998X.jsx)(Item, {
                ref: getItemRefCallback(key),
                ...itemProps,
                style: {
                    '--translate-x': translateX,
                    '--translate-y': translateY,
                    '--flip-order': flipOrderValue
                },
                className: (0, $gMc0m.default)([
                    "_v5641tjh _1f491nh5 _t9ec1a9k _m6k41e03",
                    hidden && "_1e0cglyw",
                    (phase === 'inverting' || phase === 'idle') && transforms.size > 0 && "_v564glyw"
                ]),
                children: renderItem(key)
            }, key);
        })
    });
};











const $7e10cef09d2fc3c1$export$c13db7c4cba50c39 = ({ attributes: attributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'selected',
        actionSubject: 'intentRouter',
        actionSubjectId: 'intentRouterSelected',
        attributes: attributes
    });



















const $627c5d243ba159b8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchForAllApps: {
        id: "search.quickFind.intentRouter.searchForAllApps",
        defaultMessage: "Search for all apps"
    },
    allApps: {
        id: "search.quickFind.intentRouter.allApps",
        defaultMessage: "All apps"
    },
    searchForJiraWorkItems: {
        id: "search.quickFind.intentRouter.searchForJiraWorkItems",
        defaultMessage: "Search for Jira work items"
    },
    jiraWorkItems: {
        id: "search.quickFind.intentRouter.jiraWorkItems",
        defaultMessage: "Jira work items"
    }
});













var $lh6Pw = parcelRequire("lh6Pw");













const $b9f84903a04d5c3b$export$92044c909bce4033 = ({ action: action, attributes: attributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: action,
        actionSubject: 'intentDetectionResponse',
        actionSubjectId: 'intentDetection',
        attributes: attributes
    });












const $715adf53e35160a2$export$b829272b1dcc6798 = (urlOrPath)=>{
    const url = new URL(urlOrPath, window.location.origin);
    return url.pathname;
};
const $715adf53e35160a2$export$5f3589c7f067a6e4 = (a, b)=>{
    try {
        return $715adf53e35160a2$export$b829272b1dcc6798(a) === $715adf53e35160a2$export$b829272b1dcc6798(b);
    } catch  {
        return false;
    }
};
const $715adf53e35160a2$export$9fbbf51870efdf63 = (modelId)=>{
    if (!modelId) return false;
    const intentDetectionModel = Object.values((0, $elKbB.KnowledgeDiscoveryJiraIntentDetectionModel));
    return Boolean(intentDetectionModel.find((x)=>x === modelId));
};


const $4ab2bcada25ac17b$export$c5d196f0984a6b2 = ({ defaultMode: defaultMode = (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN } = {})=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const sessionId = (0, $a0M2t.getSessionIdFromLocalStorage)();
    const taskStateRef = (0, $e6c80dec8a0d452c$export$714277298f52f5c1)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const intentDetectionModelId = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false
    })?.modelId;
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    // Memoize atl-attribution headers to avoid recreating on every render
    const atlAttributionHeaders = (0, $42omo.useMemo)(()=>(0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: cloudId,
            activationId: analyticsAttributes?.activationId,
            product: primaryProduct
        }), [
        cloudId,
        analyticsAttributes?.activationId,
        primaryProduct
    ]);
    const validatedModelId = (0, $715adf53e35160a2$export$9fbbf51870efdf63)(intentDetectionModelId) ? intentDetectionModelId : (0, $elKbB.KnowledgeDiscoveryJiraIntentDetectionModel).GNIN_HEURISTIC;
    const fireAnalytics = (0, $42omo.useCallback)((action, attributes = {})=>{
        fireAnalyticsEvent((0, $b9f84903a04d5c3b$export$92044c909bce4033)({
            action: action,
            attributes: {
                ...attributes,
                searchSessionId: searchSessionId,
                modelId: validatedModelId
            }
        }));
    }, [
        searchSessionId,
        fireAnalyticsEvent,
        validatedModelId
    ]);
    return (0, $42omo.useCallback)(async (query)=>{
        // create siteARI based on primary product
        const siteId = `ari:cloud:${primaryProduct}::site/${cloudId}`;
        // VitalStats: Generate task ID and record start time
        const taskId = crypto.randomUUID();
        const uxTaskId = taskStateRef.current.id;
        const startTime = performance.now();
        // Query Analytics attributes
        const queryHash = (0, $a0M2t.sha256Hash)(query);
        const queryLength = query.length;
        fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId || '',
            taskId: taskId,
            task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_NETWORK,
            moreContext: {
                uxTaskId: uxTaskId,
                queryHash: queryHash,
                queryLength: queryLength,
                modelId: validatedModelId
            }
        })));
        try {
            const response = await (0, $lh6Pw.jiraIntentDetectionQuery)({
                query: query,
                siteId: siteId,
                sessionId: sessionId,
                orgId: orgId ?? '',
                experience: (0, $elKbB.KnowledgeDiscoveryJiraSearchExperience).QUICK_FIND,
                model: validatedModelId
            }, atlAttributionHeaders);
            const result = response.data?.knowledgeDiscovery.jiraIntentDetection;
            const latencyMs = performance.now() - startTime;
            const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)((0, $6jKOp.extractTraceInfoFromResponse)(response)) : {};
            if (!(0, $lh6Pw.isIntentDetectionSuccess)(result)) {
                const errorName = 'UnsuccessfulResponse';
                const errorMessage = 'Query typename mismatch';
                fireAnalytics('fail', {
                    queryHash: queryHash,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    queryLength: queryLength
                });
                fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
                    searchSessionId: searchSessionId || '',
                    taskId: taskId,
                    task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_NETWORK,
                    moreContext: {
                        uxTaskId: uxTaskId,
                        queryHash: queryHash,
                        queryLength: queryLength,
                        latencyMs: latencyMs,
                        errorName: errorName,
                        errorMessage: errorMessage,
                        modelId: validatedModelId,
                        ...traceInfo
                    }
                })));
                return defaultMode;
            }
            const intentMode = result.searchClassification?.type || defaultMode;
            fireAnalytics('success', {
                queryHash: queryHash,
                queryLength: queryLength
            });
            fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionId || '',
                taskId: taskId,
                task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_NETWORK,
                moreContext: {
                    uxTaskId: uxTaskId,
                    queryHash: queryHash,
                    queryLength: queryLength,
                    latencyMs: latencyMs,
                    queryClassification: intentMode,
                    modelId: validatedModelId,
                    ...traceInfo
                }
            })));
            return intentMode;
        } catch (error) {
            const latencyMs = performance.now() - startTime;
            const errorName = error?.name || 'UnknownError';
            const errorMessage = error?.message ?? 'An unknown error occurred';
            fireAnalytics('fail', {
                queryHash: queryHash,
                errorName: errorName,
                errorMessage: errorMessage,
                queryLength: queryLength
            });
            fireAnalyticsEvent((0, $bQSQw.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
                searchSessionId: searchSessionId || '',
                taskId: taskId,
                task: (0, $bQSQw.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_NETWORK,
                moreContext: {
                    uxTaskId: uxTaskId,
                    queryHash: queryHash,
                    queryLength: queryLength,
                    latencyMs: latencyMs,
                    errorName: error?.name,
                    errorMessage: error?.message,
                    modelId: validatedModelId,
                    ...(0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(undefined) : {}
                }
            })));
            return defaultMode;
        }
    }, [
        cloudId,
        orgId,
        primaryProduct,
        defaultMode,
        fireAnalytics,
        searchSessionId,
        sessionId,
        fireAnalyticsEvent,
        validatedModelId,
        taskStateRef,
        atlAttributionHeaders
    ]);
};









const $60e53d874e754083$var$INTENT_ROW_TRACKING_ID_BY_MODE = {
    [(0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS]: 'intentRouter:intent-all-apps',
    [(0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN]: 'intentRouter:intent-jira-work-items'
};
const $60e53d874e754083$export$351560332f190b8f = ({ primaryMode: primaryMode, query: query })=>{
    const { highlightComponentAt: highlightComponentAt, unhighlightAll: unhighlightAll, keyboardNavComponents: keyboardNavComponents, getSelectedIndex: getSelectedIndex } = (0, $icqFF.useKeyboardHighlightProvider)();
    const lastAppliedModeRef = (0, $42omo.useRef)(null);
    const prevQueryRef = (0, $42omo.useRef)(query);
    const highlightRafIdRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        const queryChanged = prevQueryRef.current !== query;
        prevQueryRef.current = query;
        const desiredTrackingId = $60e53d874e754083$var$INTENT_ROW_TRACKING_ID_BY_MODE[primaryMode];
        // We can only apply selection once the intent row is registered.
        const desiredIdx = keyboardNavComponents?.findIndex((c)=>c.navigationTrackingId === desiredTrackingId) ?? -1;
        if (desiredIdx < 0) return;
        // Mode already applied — decide whether to re-apply.
        if (lastAppliedModeRef.current === primaryMode) {
            const currentIdx = getSelectedIndex?.();
            // Row is still correctly selected — nothing to do.
            if (currentIdx === desiredIdx) return;
            // A different row is selected (user navigated with arrow keys).
            // Only re-apply if the user typed (query changed); ignore
            // keyboardNavComponents-only changes (e.g. FlipList animation).
            if (currentIdx !== undefined && !queryChanged) return;
        }
        // Mark as applied synchronously to prevent duplicate scheduling
        // on rapid re-renders before the RAF fires.
        lastAppliedModeRef.current = primaryMode;
        // Cancel any previously scheduled RAF.
        if (highlightRafIdRef.current !== null) cancelAnimationFrame(highlightRafIdRef.current);
        // Defer the visual highlight to the next animation frame for a smoother transition.
        highlightRafIdRef.current = requestAnimationFrame(()=>{
            highlightRafIdRef.current = null;
            unhighlightAll?.();
            highlightComponentAt?.(desiredIdx);
            keyboardNavComponents?.[desiredIdx]?.onHighlightedCallback?.(desiredIdx);
        });
        return ()=>{
            if (highlightRafIdRef.current !== null) {
                cancelAnimationFrame(highlightRafIdRef.current);
                highlightRafIdRef.current = null;
            }
        };
    }, [
        keyboardNavComponents,
        primaryMode,
        query,
        getSelectedIndex,
        highlightComponentAt,
        unhighlightAll
    ]);
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


const $88b96a73873e73ff$export$da00a8e161805bdf = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;







var $3fzmz = parcelRequire("3fzmz");





const $5b4b660e006bbec8$export$df776ff95d381170 = ({ query: query, minQueryLength: minQueryLength })=>{
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { selectedFilters: { jiraFilters: jiraFilters } } = (0, $4VkIo.useSelectedFilters)({});
    const allAppsUrl = (0, $42omo.useMemo)(()=>generateSearchUrl({
            ...queryParams,
            text: query
        }), [
        generateSearchUrl,
        queryParams,
        query
    ]);
    const jiraWorkItemsUrl = (0, $42omo.useMemo)(()=>{
        try {
            return (0, $3fzmz.getWorkItemPageUrl)({
                query: query,
                jiraFilters: jiraFilters,
                generateSearchUrl: generateSearchUrl,
                queryParams: queryParams
            });
        } catch  {
            return 0, $88b96a73873e73ff$export$da00a8e161805bdf;
        }
    }, [
        generateSearchUrl,
        jiraFilters,
        queryParams,
        query
    ]);
    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
    const isAllAppsPage = (0, $42omo.useMemo)(()=>currentUrl ? (0, $715adf53e35160a2$export$5f3589c7f067a6e4)(currentUrl, allAppsUrl) : false, [
        currentUrl,
        allAppsUrl
    ]);
    const isJiraWorkItemsPage = (0, $42omo.useMemo)(()=>currentUrl ? (0, $715adf53e35160a2$export$5f3589c7f067a6e4)(currentUrl, jiraWorkItemsUrl) : false, [
        currentUrl,
        jiraWorkItemsUrl
    ]);
    let defaultMode = isAllAppsPage ? (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS : (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN;
    // Hydrate the default mode from the intent detection result if available.
    const intentDetectionResult = (0, $fa792d959dc8194b$export$928cec68d7595d16).value();
    if (intentDetectionResult) {
        const { mode: mode, query: intentDetectionQuery } = intentDetectionResult;
        // If the intent detection result is for the current page, use it as the default mode.
        if (query.length >= minQueryLength && query === intentDetectionQuery) defaultMode = mode;
    }
    return {
        defaultMode: defaultMode,
        allAppsUrl: allAppsUrl,
        jiraWorkItemsUrl: jiraWorkItemsUrl,
        isAllAppsPage: isAllAppsPage,
        isJiraWorkItemsPage: isJiraWorkItemsPage
    };
};








const $b995e1f2175cfd57$export$227eeed9835398d5 = ({ query: query, debounceMs: debounceMs, intentDetection: intentDetection, minQueryLength: minQueryLength, disabled: disabled = false, initialPrimaryMode: initialPrimaryMode = (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN })=>{
    const [primaryMode, setPrimaryMode] = (0, $42omo.useState)(initialPrimaryMode);
    const [isPaused, setIsPaused] = (0, $42omo.useState)(false);
    const resumeTimeoutRef = (0, $42omo.useRef)(null);
    // Track the latest query and the query at pause time.
    const latestQueryRef = (0, $42omo.useRef)(query);
    const pausedQueryRef = (0, $42omo.useRef)(null);
    // Track the last query we triggered detection for to avoid duplicate calls.
    const lastDetectedQueryRef = (0, $42omo.useRef)(null);
    // VitalStats tracking for intent detection UX task lifecycle
    const { startTask: startTask, completeTaskSuccess: completeTaskSuccess, abortTask: abortTask, isTaskActive: isTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    // Keep latestQueryRef up to date.
    latestQueryRef.current = query;
    // Pin primary mode whenever we are disabled.
    (0, $42omo.useEffect)(()=>{
        if (disabled) setPrimaryMode(initialPrimaryMode);
    }, [
        disabled,
        initialPrimaryMode
    ]);
    const shouldRun = !disabled && query.length >= minQueryLength && !isPaused;
    const runDetection = (0, $42omo.useCallback)(async ()=>{
        if (disabled) return;
        const q = latestQueryRef.current;
        if (q.length < minQueryLength) return;
        // VitalStats: Abort previous task if still active (superseded by new query)
        if (isTaskActive()) abortTask('superseded_by_new_query');
        // VitalStats: Start new UX task
        startTask(q);
        // No error handling here as the intent detection service will handle it.
        setPrimaryMode(await intentDetection(q));
        // VitalStats: Mark UX task as successfully completed (UI updated)
        completeTaskSuccess();
    }, [
        disabled,
        intentDetection,
        minQueryLength,
        isTaskActive,
        abortTask,
        startTask,
        completeTaskSuccess
    ]);
    const debouncedDetect = (0, $e31678cde9628b17$export$e70e6da722faba05)(runDetection, debounceMs);
    // Trigger debounced detection when query changes (and conditions are met).
    (0, $42omo.useEffect)(()=>{
        if (!shouldRun) return;
        // Skip if we already triggered detection for this query (e.g. on resume).
        if (lastDetectedQueryRef.current === query) return;
        lastDetectedQueryRef.current = query;
        debouncedDetect();
        return ()=>{
            debouncedDetect.cancel();
        };
    }, [
        debouncedDetect,
        shouldRun,
        query
    ]);
    const pause = (0, $42omo.useCallback)(()=>{
        pausedQueryRef.current = latestQueryRef.current;
        setIsPaused(true);
        debouncedDetect.cancel();
    }, [
        debouncedDetect
    ]);
    const doResume = (0, $42omo.useCallback)(()=>{
        const queryChanged = pausedQueryRef.current !== null && pausedQueryRef.current !== latestQueryRef.current;
        pausedQueryRef.current = null;
        setIsPaused(false);
        if (queryChanged) {
            // Mark this query as detected so the effect doesn't double-trigger.
            lastDetectedQueryRef.current = latestQueryRef.current;
            // Trigger detection for the latest query that changed while paused.
            debouncedDetect();
        }
    }, [
        debouncedDetect
    ]);
    const resume = (0, $42omo.useCallback)(()=>{
        doResume();
    }, [
        doResume
    ]);
    // Pause intent detection while navigating, then resume after a short idle.
    const pauseAndResume = (0, $42omo.useCallback)((timeoutMs = 500)=>{
        pause();
        if (resumeTimeoutRef.current) window.clearTimeout(resumeTimeoutRef.current);
        // Resume after a short idle window (user stops navigating).
        resumeTimeoutRef.current = window.setTimeout(()=>{
            doResume();
        }, timeoutMs);
    }, [
        doResume,
        pause
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (resumeTimeoutRef.current) window.clearTimeout(resumeTimeoutRef.current);
            // VitalStats: Abort task if dialog is closed while intent detection is in-flight
            if (isTaskActive()) abortTask('dialog_closed');
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        primaryMode: primaryMode,
        isPaused: isPaused,
        pause: pause,
        resume: resume,
        pauseAndResume: pauseAndResume
    };
};



const $23cd74b8ba084de6$var$styles = {
    root: "_zulpv77o _1e0c1txw _2lx21bp4"
}; /**
    * Static IntentRouter rows.
    *
    * Returns two destination rows using SearchResult so they integrate
    * with @atlassian/search-dialog keyboard navigation.
    *
    */ 
const $23cd74b8ba084de6$export$86cb87a743ba47f8 = ({ query: query, minQueryLength: minQueryLength })=>{
    const intl = (0, $8C5kA.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { isTaskActive: isTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    const intentDetectionModelId = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false
    })?.modelId;
    const modelId = (0, $715adf53e35160a2$export$9fbbf51870efdf63)(intentDetectionModelId) ? intentDetectionModelId : (0, $elKbB.KnowledgeDiscoveryJiraIntentDetectionModel).GNIN_HEURISTIC;
    const allAppsLabel = intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).allApps);
    const jiraWorkItemsLabel = intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).jiraWorkItems);
    const { defaultMode: defaultMode, allAppsUrl: allAppsUrl, jiraWorkItemsUrl: jiraWorkItemsUrl } = (0, $5b4b660e006bbec8$export$df776ff95d381170)({
        query: query,
        minQueryLength: minQueryLength
    }); // Use the initial primary mode as the default mode for intent detection
    const intentDetection = (0, $4ab2bcada25ac17b$export$c5d196f0984a6b2)({
        defaultMode: defaultMode
    }); // Omitting pauseAndResume from the result as it is not needed for intent router.
    // If we need it in the future, we can add it back to the result.
    const { primaryMode: primaryMode, isPaused: disabled } = (0, $b995e1f2175cfd57$export$227eeed9835398d5)({
        query: query,
        debounceMs: 250,
        intentDetection: intentDetection,
        initialPrimaryMode: defaultMode,
        minQueryLength: minQueryLength
    }); // Keep keyboard selection in sync with the active intent mode and query.
    (0, $60e53d874e754083$export$351560332f190b8f)({
        primaryMode: primaryMode,
        query: query
    });
    const handleResultClicked = (0, $42omo.useCallback)((event, selectedMode, buttonPosition)=>{
        const newTab = (0, $6926da8980239f02$export$b2c60dba9a3fd739)(event);
        if (!newTab) {
            setQuickFindOpen(false); // Keep parity with "Enter on input" behaviour: reset QF filters as FPS is the source of truth.
            clearAllFilters();
        }
        const trimmedQuery = query.trim();
        if (trimmedQuery !== '' && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)(trimmedQuery, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
            updateRecentQueries?.();
        }
        const queryHash = (0, $a0M2t.sha256Hash)(query);
        fireAnalyticsEvent((0, $7e10cef09d2fc3c1$export$c13db7c4cba50c39)({
            attributes: {
                searchSessionId: searchSessionId || '',
                selectedMode: selectedMode,
                queryClassification: primaryMode,
                queryHash: queryHash,
                buttonPosition: buttonPosition,
                queryLength: query.length,
                networkResponded: !isTaskActive(),
                modelId: modelId
            }
        }));
        fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
            actionSubjectId: 'jiraAdvancedSearchLink',
            attributes: {
                ...commonAttributes,
                newTab: newTab,
                isLoading: isTaskActive(),
                selectedMode: selectedMode,
                buttonPosition: buttonPosition,
                queryClassification: primaryMode,
                modelId: modelId
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        clearAllFilters,
        commonAttributes,
        fireAnalyticsEvent,
        modelId,
        nonPrivacySafeAttributes,
        primaryMode,
        primaryProduct,
        query,
        searchSessionId,
        setQuickFindOpen,
        updateRecentQueries,
        user,
        isTaskActive
    ]);
    // Update the global intent detection result
    (0, $fa792d959dc8194b$export$928cec68d7595d16).update({
        mode: primaryMode,
        route: primaryMode === (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS ? allAppsUrl : jiraWorkItemsUrl,
        query: query,
        modelId: // store the query to aid hydration
        modelId
    });
    const orderedModes = primaryMode === (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN ? [
        (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN,
        (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS
    ] : [
        (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS,
        (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN
    ];
    const rowsByMode = {
        [(0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS]: /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
            id: "intent-all-apps",
            resultType: "intentRouter",
            icon: (0, $dh538.fg)('qf_icons_recents_suggested') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
                label: "",
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ymXE))), {
                    label: allAppsLabel
                })
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ymXE))), {
                label: allAppsLabel
            }),
            title: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                direction: "row",
                alignItems: "center",
                gap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: query || intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).searchForAllApps)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: "\u2013\u2013"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).allApps)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1aa88845bd0865d7$export$a9ec35d044cf4cf), {})
                ]
            }),
            url: allAppsUrl,
            onResultClicked: (event)=>handleResultClicked(event, (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS, primaryMode === (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS ? 0 : 1),
            highlightedRightMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        }, "intent-all-apps"),
        [(0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN]: /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
            id: "intent-jira-work-items",
            resultType: "intentRouter",
            icon: (0, $dh538.fg)('qf_icons_recents_suggested') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
                label: "",
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                    label: jiraWorkItemsLabel
                })
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                label: jiraWorkItemsLabel
            }),
            title: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                direction: "row",
                gap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: query || intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).searchForJiraWorkItems)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: "\u2013\u2013"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).jiraWorkItems)
                    })
                ]
            }),
            url: jiraWorkItemsUrl,
            onResultClicked: (event)=>handleResultClicked(event, (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN, primaryMode === (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN ? 0 : 1),
            highlightedRightMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        }, "intent-jira-work-items")
    };
    const order = orderedModes.map((mode)=>mode === (0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS ? 'intent-all-apps' : 'intent-jira-work-items');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $b8fd72204c218acd$export$3d1498497a812571), {
        order: order,
        disabled: disabled,
        containerAs: "div",
        containerProps: {
            role: 'list'
        },
        itemAs: "div",
        renderItem: (key)=>{
            return key === 'intent-all-apps' ? rowsByMode[(0, $fa792d959dc8194b$export$3d3f5f86906a7f73).FPS] : rowsByMode[(0, $fa792d959dc8194b$export$3d3f5f86906a7f73).GNIN];
        },
        xcss: $23cd74b8ba084de6$var$styles.root
    });
};




















// Copied from packages/search/product-search-dialog/src/extensible/quick-find/icons/command-icon.tsx



parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $738ebcb5194247d5$export$76bfbab5e3f9a6a3 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });



































const $02caee92bec6b3d2$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.100',
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.200',
    display: 'flex',
    alignItems: 'center'
});
const $02caee92bec6b3d2$var$resultHoveredStlyes = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $02caee92bec6b3d2$var$keyboardHighlightedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $02caee92bec6b3d2$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $02caee92bec6b3d2$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $02caee92bec6b3d2$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $02caee92bec6b3d2$var$textOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $02caee92bec6b3d2$var$rightSectionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $02caee92bec6b3d2$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    ':focus-visible': {
        outlineStyle: 'solid',
        outlineColor: 'color.border.accent.blue',
        outlineWidth: 'border.width.focused',
        // @ts-ignore
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $02caee92bec6b3d2$export$64ded8b71dfcba9e = ({ icon: icon, title: title, rightMetadata: rightMetadata, url: url, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu })=>{
    const ref = (0, $42omo.useRef)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: ()=>{
            ref.current?.click();
        },
        onHighlightedCallback: ()=>{}
    });
    const onClick = (0, $42omo.useCallback)((event)=>{
        onResultClicked?.(event);
    }, [
        onResultClicked
    ]);
    const onContextMenu = (0, $42omo.useCallback)((event)=>{
        onResultContextMenu?.(event);
    }, [
        onResultContextMenu
    ]);
    return (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        backgroundColor: "color.background.neutral.subtle",
        onClick: onClick,
        onContextMenu: onContextMenu,
        testId: "search-dialog-footer",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
            xcss: [
                $02caee92bec6b3d2$var$linkStyles
            ],
            href: url,
            testId: "search-dialog-footer-link",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $02caee92bec6b3d2$var$resultStyles,
                    isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
                    isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
                ],
                ref: (node)=>{
                    ref.current = node;
                    setRef(node);
                },
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$iconAreaStyles,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$middleAreaStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $02caee92bec6b3d2$var$titleStyles,
                                $02caee92bec6b3d2$var$textOverflowStyles
                            ],
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$rightSectionStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                            above: "xs",
                            children: rightMetadata
                        })
                    })
                ]
            })
        })
    }) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        onClick: onClick,
        onContextMenu: onContextMenu,
        testId: "search-dialog-footer",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
            xcss: [
                $02caee92bec6b3d2$var$linkStyles
            ],
            href: url,
            testId: "search-dialog-footer-link",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $02caee92bec6b3d2$var$resultStyles,
                    isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
                    isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
                ],
                ref: (node)=>{
                    ref.current = node;
                    setRef(node);
                },
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$iconAreaStyles,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$middleAreaStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $02caee92bec6b3d2$var$titleStyles,
                                $02caee92bec6b3d2$var$textOverflowStyles
                            ],
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$rightSectionStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                            above: "xs",
                            children: rightMetadata
                        })
                    })
                ]
            })
        })
    });
};




















const $cb4c307b2668c972$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    jiraSearchWorkItems: {
        id: "jira_advanced_search",
        defaultMessage: "Search Jira for work items"
    }
});


const $e02869b185b9e3c4$var$ACTION_SUBJECT_ID = 'jiraAdvancedIssueSearch';
const $e02869b185b9e3c4$export$104db48ac99dc257 = ({ state: state, onClick: onClick })=>{
    const intl = (0, $8C5kA.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectedFilters: { jiraFilters: jiraFilters } } = (0, $4VkIo.useSelectedFilters)({});
    const swapQuickFindCTAs = (0, $1XDdH.isOnJiraFullPageSearch)() && primaryProduct && primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_search_fps_cta_swap');
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: intl.formatMessage((0, $cb4c307b2668c972$export$defe85febe8b728c).jiraSearchWorkItems),
        color: "currentColor"
    });
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            swapQuickFindCTAs && /*#__PURE__*/ (0, $l998X.jsx)((0, $738ebcb5194247d5$export$76bfbab5e3f9a6a3), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const workItemPageUrl = (0, $42omo.useMemo)(()=>{
        try {
            return (0, $3fzmz.getWorkItemPageUrl)({
                query: quickFindQuery,
                jiraFilters: jiraFilters,
                generateSearchUrl: generateSearchUrl,
                queryParams: queryParams
            });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            return 0, $88b96a73873e73ff$export$da00a8e161805bdf;
        }
    }, [
        queryParams,
        generateSearchUrl,
        quickFindQuery,
        jiraFilters
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: $e02869b185b9e3c4$var$ACTION_SUBJECT_ID
        });
    }, [
        onClick,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $02caee92bec6b3d2$export$64ded8b71dfcba9e), {
        icon: icon,
        title: intl.formatMessage((0, $cb4c307b2668c972$export$defe85febe8b728c).jiraSearchWorkItems),
        rightMetadata: rightMetadata,
        url: workItemPageUrl,
        onResultClicked: onResultClicked
    });
};












var $1Ajko = parcelRequire("1Ajko");






























const $2edb72d725c5d8f9$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    jira_quick_find_single_site_label: {
        id: "jira_single_site_label",
        defaultMessage: "Go to all:"
    },
    jira_quick_find_projects: {
        id: "jira_single_site_projects",
        defaultMessage: "Projects"
    },
    jira_quick_find_spaces: {
        id: "jira_single_site_spaces",
        defaultMessage: "Spaces"
    },
    jira_quick_find_boards: {
        id: "jira_single_site_boards",
        defaultMessage: "Boards"
    },
    jira_quick_find_filters: {
        id: "jira_single_site_filters",
        defaultMessage: "Filters"
    },
    jira_quick_find_plans: {
        id: "jira_single_site_plans",
        defaultMessage: "Plans"
    },
    jira_quick_find_people: {
        id: "jira_single_site_people",
        defaultMessage: "Teams"
    },
    jira_quick_find_work_items: {
        id: "jira_single_site_work_items",
        defaultMessage: "Work items"
    }
});


const $ad3c6b6b491bd60c$var$styles = (0, $ecnYn.xcss)({
    height: '100%',
    display: 'inline-block'
});
const $ad3c6b6b491bd60c$var$singleSiteContainer = (0, $ecnYn.xcss)({
    padding: 'space.100'
});
const $ad3c6b6b491bd60c$var$iconContainer = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    marginRight: 'space.200'
});
const $ad3c6b6b491bd60c$var$styleLink = (0, $ecnYn.xcss)({
    WebkitBoxAlign: 'baseline',
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'inline-flex',
    justifyContent: 'center',
    fontWeight: 'font.weight.medium',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $6fnsQ.N900)})`}`,
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    marginRight: 'space.100',
    color: 'color.text.subtle',
    textDecoration: 'none',
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    ':hover': {
        color: 'color.text.subtle',
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    ':visited': {
        color: 'color.text.subtle'
    },
    ':focus-visible': {
        color: 'color.text.subtle'
    },
    ':focus': {
        color: 'color.text.subtle'
    }
});
var $ad3c6b6b491bd60c$var$JiraFooterLinkActionSubjectId = /*#__PURE__*/ function(JiraFooterLinkActionSubjectId) {
    JiraFooterLinkActionSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_WORK_ITEMS"] = "jiraWorkItemsSearchLink";
    return JiraFooterLinkActionSubjectId;
}($ad3c6b6b491bd60c$var$JiraFooterLinkActionSubjectId || {});
const $ad3c6b6b491bd60c$export$4c85ccfa2dce935c = (query)=>{
    const allLinks = {
        board: {
            href: `/secure/ManageRapidViews.jspa?contains=${query}`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_boards,
            actionSubjectId: "jiraBoardsSearchLink"
        },
        project: {
            href: `/projects?contains=${query}`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_spaces,
            actionSubjectId: "jiraProjectsSearchLink"
        },
        filters: {
            href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_filters,
            actionSubjectId: "jiraFiltersSearchLink"
        },
        plans: {
            href: `/jira/plans`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_plans,
            actionSubjectId: "jiraPlansSearchLink"
        },
        people: {
            href: `/jira/people/search?q=${query}`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_people,
            actionSubjectId: "jiraPeopleSearchLink"
        }
    };
    return allLinks;
};
const $ad3c6b6b491bd60c$export$72bf2a5ecf09330e = ({ state: state, onClick: onClick })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const searchConfiguration = $ad3c6b6b491bd60c$export$4c85ccfa2dce935c(quickFindQuery);
    const intentRouterEnabled = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: (0, $1yEFx.PrimaryProductKeys).Jira,
        fireLayerExposure: false // Exposure is fired when a user calls the intent detection API
    })?.cohort === 'test';
    const workItemsUrl = (0, $42omo.useMemo)(()=>{
        if (!intentRouterEnabled) return;
        try {
            return generateSearchUrl({
                ...queryParams,
                text: quickFindQuery,
                referrer: (0, $hHl3d.SearchExperience).QUICK_FIND
            }, true);
        } catch  {
            return 0, $88b96a73873e73ff$export$da00a8e161805bdf;
        }
    }, [
        generateSearchUrl,
        intentRouterEnabled,
        queryParams,
        quickFindQuery
    ]);
    // Build final configuration including Work Items first if enabled
    const allLinks = (0, $42omo.useMemo)(()=>{
        if (workItemsUrl) return {
            workItems: {
                href: workItemsUrl,
                message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_work_items,
                actionSubjectId: "jiraWorkItemsSearchLink"
            },
            ...searchConfiguration
        };
        return searchConfiguration;
    }, [
        searchConfiguration,
        workItemsUrl
    ]);
    const onFilterClick = (0, $42omo.useCallback)((event, actionSubjectId)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: actionSubjectId
        });
    }, [
        onClick,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $ad3c6b6b491bd60c$var$singleSiteContainer,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $ad3c6b6b491bd60c$var$iconContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Ajko))), {
                    label: "navigate-single-site-icon"
                })
            }),
            Object.keys(allLinks).map((key)=>{
                const { href: href, message: message, actionSubjectId: actionSubjectId } = allLinks[key];
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    role: "none",
                    xcss: $ad3c6b6b491bd60c$var$styles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                        xcss: $ad3c6b6b491bd60c$var$styleLink,
                        href: href,
                        onClick: (event)=>onFilterClick(event, actionSubjectId),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...message
                        })
                    })
                }, `single_site_${key}`);
            })
        ]
    });
};































const $678282c0e0260f8c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    quickFindNoContentHeading: {
        id: "search_dialog_no_content_heading",
        defaultMessage: "Seek and you shall find"
    },
    quickFindNoContentBodyWithRovo: {
        id: "search_dialog_no_content_body_with_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated apps"
    },
    quickFindNoContentBodyWithAtlassianIntelligence: {
        id: "search_dialog_no_content_body_with_atlassian_intelligence",
        defaultMessage: "Search or ask anything across your Atlassian apps"
    },
    quickFindNoContentBodyDefault: {
        id: "search_dialog_no_content_body_default",
        defaultMessage: "Search for anything across your Atlassian apps"
    },
    quickFindNoContentBody: {
        id: "search_dialog_no_content_body",
        defaultMessage: "Search for what you're looking for in your Atlassian and integrated apps"
    },
    quickFindNoContentBodyWithAI: {
        id: "search_dialog_no_content_body_with_ai",
        defaultMessage: "Search or ask what you're looking for in your Atlassian and integrated apps"
    }
});



const $9ebd3fccc7b29e09$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("8PWzv")));
const $9ebd3fccc7b29e09$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $9ebd3fccc7b29e09$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $9ebd3fccc7b29e09$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $9ebd3fccc7b29e09$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $9ebd3fccc7b29e09$export$144e5acf8752ad4a = ()=>{
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const bodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithRovo : isAdminHubAIEnabled ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithAtlassianIntelligence : (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyDefault;
    const newBodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo && isRovoLLMEnabled || isAdminHubAIEnabled ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithAI : (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBody;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $9ebd3fccc7b29e09$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $9ebd3fccc7b29e09$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)($9ebd3fccc7b29e09$var$Image, {})
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $9ebd3fccc7b29e09$var$headingStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25') ? newBodyCopy : bodyCopy
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $9ebd3fccc7b29e09$var$bodyStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentHeading
                })
            })
        ]
    });
};





const $3f03f084e86b29e6$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchDialogAriaLabel: {
        id: "search_dialog_aria_label",
        defaultMessage: "Search Dialog"
    },
    recentsHeading: {
        id: "search_dialog_recents_heading",
        defaultMessage: "Recent"
    },
    recommendationsHeading: {
        id: "search_dialog_recommendations_heading",
        defaultMessage: "Recommendations"
    },
    searchResultsHeading: {
        id: "recents_heading",
        defaultMessage: "Search Results"
    },
    userShardHeading: {
        id: "your_recent_results_heading",
        defaultMessage: "Your recent results"
    }
});






























const $bc6e38173da21e1a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noResultsHeading: {
        id: "search_dialog_no_results_heading",
        defaultMessage: "We couldn't find any results with that title"
    },
    noResultsBody: {
        id: "search_dialog_no_results_search_body",
        defaultMessage: "<link>Search all content across your organization</link> or try again with a different term."
    }
});



const $c5e5408b5df96d67$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("ejJrc")));
const $c5e5408b5df96d67$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $c5e5408b5df96d67$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $c5e5408b5df96d67$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $c5e5408b5df96d67$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $c5e5408b5df96d67$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $c5e5408b5df96d67$export$373c6a9b01d625eb = ({ onRetry: onRetry })=>{
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $c5e5408b5df96d67$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $c5e5408b5df96d67$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)($c5e5408b5df96d67$var$Image, {})
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                as: "h2",
                xcss: $c5e5408b5df96d67$var$headingStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $bc6e38173da21e1a$export$defe85febe8b728c).noResultsHeading,
                    values: {
                        button: (s)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                                xcss: $c5e5408b5df96d67$var$pressableStyles,
                                onClick: onRetry,
                                children: s
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $c5e5408b5df96d67$var$bodyStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $bc6e38173da21e1a$export$defe85febe8b728c).noResultsBody,
                    values: {
                        link: (s)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                                xcss: $c5e5408b5df96d67$var$pressableStyles,
                                href: generateSearchUrl({
                                    ...queryParams,
                                    text: quickFindQuery
                                }),
                                children: s
                            })
                    }
                })
            })
        ]
    });
};












var $esRft = parcelRequire("esRft");





var $c5JjN = parcelRequire("c5JjN");


var $hbEOA = parcelRequire("hbEOA");


var $ay6Zz = parcelRequire("ay6Zz");




var $aU479 = parcelRequire("aU479");


















const $d0b52bf4302d81ca$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    team: {
        id: "search_dialog_team",
        defaultMessage: "Team"
    }
});


const $18e1948c3888bb1b$export$c84e51771b9ba67c = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const { generateTeamUrl: generateTeamUrl, generateUserUrl: generateUserUrl } = (0, $7WbA8.useAppContext)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const id = result.id;
    const userTitle = result.name;
    const teamTitle = result.displayName;
    const title = result.entityType === (0, $c5JjN.EntityType).USER ? userTitle : teamTitle;
    const highlightedTitle = title && quickFindQuery ? (0, $bloXB.highlightMatchedText)(title, quickFindQuery.split(' ')).highlightedTitle : undefined;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
    });
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        appearance: result.entityType === (0, $c5JjN.EntityType).USER ? 'circle' : 'square',
        borderColor: "transparent",
        name: title,
        size: 'small',
        src: result.avatarUrl || result.smallAvatarImageUrl
    });
    const userMetadata = [
        'user-metadata',
        result.title
    ];
    const teamMetadata = [
        'team-metadata',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $d0b52bf4302d81ca$export$defe85febe8b728c).team
        })
    ];
    const metadata = result.entityType === (0, $c5JjN.EntityType).USER ? [
        userMetadata
    ] : [
        teamMetadata
    ];
    // Avoiding typeguards
    const hostProductForTeamsApp = primaryProduct === 'jira' ? 'jira' : primaryProduct === 'confluence' ? 'confluence' : undefined;
    let url;
    let onNavigate;
    if ((0, $hbEOA.isTeamsAppEnabled)({
        hostProduct: hostProductForTeamsApp
    })) {
        const { href: href, onNavigate: onNavigateTeamsApp } = (0, $ay6Zz.navigateToTeamsApp)(result.entityType === (0, $c5JjN.EntityType).USER ? {
            type: 'USER',
            payload: {
                userId: result.id
            },
            cloudId: cloudId || '',
            orgId: orgId
        } : {
            type: 'TEAM',
            payload: {
                teamId: result.id
            },
            cloudId: cloudId || '',
            orgId: orgId
        });
        url = href;
        onNavigate = onNavigateTeamsApp;
    } else {
        let path;
        // TODO remove this statement once all products have specified their own generateUserUrl and generateTeamUrl props
        if (primaryProduct && orgId && cloudId) path = result.entityType === (0, $c5JjN.EntityType).USER ? (0, $aU479.getUserPath)(result.id, primaryProduct, orgId, cloudId) : (0, $aU479.getTeamPath)(result.id, primaryProduct, orgId, cloudId);
        if (generateUserUrl && result.entityType === (0, $c5JjN.EntityType).USER) path = generateUserUrl(result.id);
        else if (generateTeamUrl && result.entityType !== (0, $c5JjN.EntityType).USER) path = generateTeamUrl(result.id);
        url = path && new URL(path, window.location.origin).href;
    }
    const analyticsMetadata = (0, $42omo.useMemo)(()=>({
            contentId: id,
            contentType: 'user'
        }), [
        id
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
        if (onNavigate && (0, $hbEOA.isTeamsAppEnabled)({
            hostProduct: hostProductForTeamsApp
        })) // Handles opening the link in a new tab
        onNavigate(event);
    }, [
        analyticsMetadata,
        onClick,
        onNavigate,
        state,
        hostProductForTeamsApp
    ]);
    const onResultContextMenu = (0, $42omo.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $42omo.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onHighlighted,
        state
    ]);
    if (!title || !metadata || !url) {
        invalidateItem(result.id);
        return null;
    }
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: url,
        searchSessionId: searchSessionId
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        id: id,
        icon: icon,
        resultType: "peopleAndTeams",
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: urlWithAnalyticsQueryParams,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};

























var $k4HRJ = parcelRequire("k4HRJ");


var $2BDjU = parcelRequire("2BDjU");




var $l3paI = parcelRequire("l3paI");

var $7jIfa = parcelRequire("7jIfa");





var $HOiSI = parcelRequire("HOiSI");

var $fhFN4 = parcelRequire("fhFN4");

























var $aKt88 = parcelRequire("aKt88");













var $cWRpe = parcelRequire("cWRpe");





var $92zSJ = parcelRequire("92zSJ");






















const $0559f7291a65cc73$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    statusUpdateTitle: {
        id: "quick-find.mercury.focus-area-status-update.title",
        defaultMessage: "Update for {focusAreaName}"
    },
    issue: {
        id: "issue_type",
        defaultMessage: "Work item"
    },
    talentExternalPositionKey: {
        id: "quick-find.talent.position.external-position-key",
        defaultMessage: "External key {positionKey}"
    },
    talentPositionTitle: {
        id: "quick-find.talent.position.title",
        defaultMessage: "{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}"
    }
});



const $0e1f91acee299cdf$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("eOylV")).then((mod)=>({
            default: mod.HoverCard
        })));
const $0e1f91acee299cdf$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $0e1f91acee299cdf$var$mapLatestUserActionToActivityEventType = (latestUserAction)=>{
    switch(latestUserAction?.toLowerCase()){
        case 'viewed':
            return (0, $3E8x9.VIEWED_EVENT).VIEWED;
        case 'commented':
            return (0, $3E8x9.WORKED_EVENT).COMMENTED;
        case 'edited':
            return (0, $3E8x9.WORKED_EVENT).EDITED;
        case 'shared':
            return (0, $3E8x9.WORKED_EVENT).SHARED;
        default:
            return (0, $3E8x9.WORKED_EVENT).UPDATED;
    }
};
const $0e1f91acee299cdf$var$mapConfluenceSearchResult = (result, query, searchSessionId, serveUserShardUI)=>{
    const id = result.id;
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const space = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.space?.name ? result.space.name : null;
    const spaceId = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.space?.id;
    const isLiveDoc = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.confluenceEntity?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const icon = (0, $dh538.fg)('rovo_search_confluence_icons') ? (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: result.iconUrl,
        type: result.type,
        isLiveDoc: isLiveDoc
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Confluence
    });
    const resultType = isLiveDoc ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $0559f7291a65cc73$export$defe85febe8b728c).liveDoc
    }) : result.type;
    const metadata = [
        'Confluence',
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: resultType,
                    subtype: (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) ? result.confluenceEntity?.subtype : undefined
                })
            })
        ],
        space
    ];
    // Use user action data if available, otherwise fall back to lastModified
    const timestamp = result.latestUserActionTs || result.lastModified || '';
    const eventType = result.latestUserAction ? $0e1f91acee299cdf$var$mapLatestUserActionToActivityEventType(result.latestUserAction) : (0, $3E8x9.WORKED_EVENT).UPDATED;
    // Only set isMyActivityData to true when serveUserShardUI is enabled and both user action fields are present
    const isMyActivityData = Boolean(serveUserShardUI === true && result.latestUserActionTs != null && result.latestUserAction != null);
    const rightMetadata = timestamp ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: isMyActivityData
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const url = (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
        url: result.url,
        query: query,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `confluence ${result.type}`,
        product: `confluence`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapAtlasSearchResult = (result, query, searchSessionId)=>{
    const id = result.id;
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons')) icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: result.iconUrl,
        type: result.type
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Atlas
    });
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const metadata = [
        'Atlas',
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: result.type
                })
            })
        ]
    ];
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `atlas ${result.type}`,
        product: `atlas`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapMercurySearchResult = (result, query, searchSessionId)=>{
    const { id: id } = result;
    let icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Focus
    });
    let resultType, title, highlightedTitle, metadata;
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaPartial)(result)) {
        const { focusArea: focusArea } = result;
        icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $2BDjU.default), {
            status: focusArea?.status?.key,
            health: focusArea?.health?.key
        });
        title = result.title;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Focus area';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                        type: result.type,
                        defaultMessage: resultType
                    })
                })
            ],
            result.focusArea ? [
                'focusAreaType',
                result.focusArea?.focusAreaType.name
            ] : null
        ];
    }
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaStatusUpdatePartial)(result)) {
        title = (0, $92zSJ.getSummarizedAdfContent)(result.description, query);
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Focus area update';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                        type: result.type,
                        defaultMessage: resultType
                    })
                })
            ]
        ];
    }
    if ((0, $HOiSI.isSearchResultSpfAskPartial)(result)) {
        title = result.title;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Ask';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                        type: result.type,
                        defaultMessage: resultType
                    })
                })
            ]
        ];
    }
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `mercury ${result.type}`,
        product: `mercury`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapTalentSearchResult = (result, query, searchSessionId)=>{
    const { id: id } = result;
    let icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small"
    });
    let resultType, title, highlightedTitle, metadata;
    const querySplit = query.split(' ');
    if ((0, $fhFN4.isSearchTalentPartial)(result)) {
        const { position: position } = result;
        let jobTitle = '';
        let externalPositionKey = '';
        let positionKey = '';
        const preferredName = position?.worker?.preferredName || '';
        icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $cWRpe.TalentUserAvatar), {
            isQuickFind: true,
            src: position?.worker?.user?.picture
        });
        for (const field of position?.fieldValues ?? [])switch(field.fieldId){
            case 'positionKey':
                if ('stringValue' in field.fieldValue) positionKey = field.fieldValue.stringValue || '';
                break;
            case 'positionPositionTitle':
                if ('stringValue' in field.fieldValue) jobTitle = field.fieldValue.stringValue || '';
                break;
            case 'positionExternalPositionKey':
                if ('stringValue' in field.fieldValue) externalPositionKey = field.fieldValue.stringValue || '';
                break;
            default:
                break;
        }
        title = preferredName ? `${positionKey}: ${preferredName}` : positionKey;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, querySplit).highlightedTitle : undefined;
        resultType = 'Position';
        metadata = [
            'Talent',
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                        type: result.type,
                        defaultMessage: resultType
                    })
                })
            ],
            [
                'jobTitle',
                jobTitle
            ],
            [
                'externalPositionKey',
                externalPositionKey ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $0559f7291a65cc73$export$defe85febe8b728c).talentExternalPositionKey,
                    values: {
                        positionKey: externalPositionKey
                    }
                }) : null
            ]
        ];
    }
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `talent ${result.type}`,
        product: `talent`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapThirdPartySearchResult = (result, query, searchSessionId, thirdPartyConfigs)=>{
    const { id: id, providerId: providerId, integrationId: integrationId, subtype: subtype, lastModifiedDate: lastModifiedDate, title: title } = result;
    const product = (0, $Y34Hw.get3PProductFromProviderIdOrIntegrationId)({
        thirdPartyConfigs: thirdPartyConfigs,
        providerId: providerId,
        integrationId: integrationId
    });
    if (!(0, $1yEFx.isProductKey)(product)) return;
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(id);
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const typeLabel = (0, $9kYXz.getSubtypeLabel)({
        product: product,
        subtype: subtype,
        resourceType: resourceType
    });
    const parentName = (0, $7ZetK.isDocumentEntity)(result) ? result.entity?.parent?.displayName : null;
    /**
   * Use constant config as fallback
   * Loom is not included in thirdPartyConfigs from API
   */ const productDisplayName = thirdPartyConfigs[product]?.displayName || (0, $hB77E.ThirdPartyConfigs).get(product)?.displayName;
    const metadata = [
        [
            'product',
            productDisplayName
        ],
        [
            'type',
            typeLabel ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...typeLabel
                })
            }) : subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
            }) : null
        ],
        parentName ?? null
    ];
    const timestamp = lastModifiedDate || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapJiraSearchResult = (result, query, searchSessionId, isStatusLoading, primaryProduct)=>{
    const id = result.id;
    const analyticsMetadata = {
        contentId: id,
        contentType: `jira ${result.type}`,
        product: `jira`
    };
    const isIssue = (0, $8LSUr.isSearchResultJiraIssue)(result);
    const title = isIssue ? [
        result.issue?.key,
        result.title
    ].filter(Boolean).join(': ') : result.title;
    const issueIconUrl = isIssue ? result.issue?.issueTypeAvatarUrl : undefined;
    const boardIconUrl = (0, $8LSUr.isSearchResultJiraBoard)(result) ? result.board?.iconUrl : undefined;
    const iconUrl = boardIconUrl || issueIconUrl || result.iconUrl;
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: iconUrl,
        type: result.type,
        isIssue: isIssue
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const status = (0, $8LSUr.isSearchResultJiraIssue)(result) ? (0, $aKt88.getStatus)(result.status?.name, result.status?.colorName, isStatusLoading) : null;
    const metadata = [];
    metadata.push('Jira');
    if ((0, $8LSUr.isSearchResultJiraIssue)(result)) {
        const issueType = result.issue?.issueTypeField?.issueType;
        issueType && metadata.push(issueType.name);
        const project = result.issue?.fieldsById.edges[0]?.node.project.name;
        project && metadata.push(project);
    } else if ((0, $8LSUr.isSearchResultJiraBoard)(result)) {
        metadata.push([
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: result.type
                })
            })
        ]);
        const containerProjectName = result.container && 'projectName' in result.container && result.container.projectName;
        const containerUserName = result.container && 'userName' in result.container && result.container.userName;
        const containerName = containerProjectName || containerUserName || undefined;
        if (containerName) metadata.push(containerName);
    } else {
        const resultType = (0, $Y34Hw.getJiraSearchResultTypeMetadata)(result.type);
        metadata.push([
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: resultType,
                    defaultMessage: result.type
                })
            })
        ]);
    }
    const rightMetadata = (0, $8LSUr.isSearchResultJiraIssue)(result) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: result.lastModifiedDate || '',
        eventType: (0, $3E8x9.WORKED_EVENT).UPDATED,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
    });
    let jiraResultUrl;
    if ((0, $8LSUr.isSearchResultJiraIssue)(result)) jiraResultUrl = result.issue?.webUrl || result.url;
    else if ((0, $8LSUr.isSearchResultJiraBoard)(result)) {
        const notDummyUrl = (0, $1XDdH.isDummyBoardUrl)(result.url) ? undefined : result.url;
        jiraResultUrl = jiraResultUrl = result.board?.boardFrontendUrl || notDummyUrl;
        if (!jiraResultUrl) // We don't want the board with no url to be displayed. Returning null prevents rendering
        return null;
    } else jiraResultUrl = result.url;
    const customParams = primaryProduct?.includes((0, $1yEFx.ProductKeys).Jira) && (0, $dh538.fg)('search_quick_find_query_params_enable') ? new Map([
        [
            'referrer',
            (0, $hHl3d.SearchExperience).QUICK_FIND
        ]
    ]) : new Map();
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: jiraResultUrl,
        searchSessionId: searchSessionId,
        customParams: customParams
    });
    return {
        id: id,
        title: title,
        highlightedTitle: highlightedTitle,
        icon: icon,
        status: status,
        analyticsMetadata: analyticsMetadata,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        rightMetadata: rightMetadata,
        url: url
    };
};
const $0e1f91acee299cdf$var$mapAssetsSearchResult = (result, query, searchSessionId)=>{
    const id = result.id;
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const metadata = (0, $l3paI.isSearchResultAssetsObjectSchema)(result) ? [
        'Assets',
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: result.type
                })
            })
        ]
    ] : [
        'Assets',
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: (0, $l3paI.isSearchResultAssetsObjectType)(result) ? `Object ${result.type}` : /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: result.type
                })
            })
        ],
        [
            'schema',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result.objectSchemaEntity.name
            })
        ]
    ];
    const timestamp = result.lastModifiedDate || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = result.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const getAssetsUrl = (result)=>{
        if ((0, $l3paI.isSearchResultAssetsObjectSchema)(result)) return result.objectSchemaEntity.links.web;
        else if ((0, $l3paI.isSearchResultAssetsObjectType)(result)) return result.objectTypeEntity.links.web;
        else return result.objectEntity.links.web;
    };
    let iconUrl = null;
    if ((0, $l3paI.isSearchResultAssetsObjectSchema)(result)) iconUrl = null;
    else if ((0, $l3paI.isSearchResultAssetsObjectType)(result)) iconUrl = result.objectTypeEntity.icon.url48;
    else if ((0, $l3paI.isSearchResultAssetsObject)(result)) iconUrl = result.objectEntity.avatar.url48;
    const icon = (0, $2waBy.getAssetsEntityIcon)({
        iconUrl: iconUrl,
        type: result.type,
        size: 'small'
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: getAssetsUrl(result),
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `assets ${result.type}`,
        product: `assets`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapSearchResult = (result, query, searchSessionId, thirdPartyConfigs, isStatusLoading, serveUserShardUI, primaryProduct)=>{
    if ((0, $4TTdD.isSearchConfluencePartial)(result)) return $0e1f91acee299cdf$var$mapConfluenceSearchResult(result, query, searchSessionId, serveUserShardUI);
    else if ((0, $7jIfa.isSearchAtlasPartial)(result)) return $0e1f91acee299cdf$var$mapAtlasSearchResult(result, query, searchSessionId);
    else if ((0, $HOiSI.isSearchMercuryPartial)(result)) return $0e1f91acee299cdf$var$mapMercurySearchResult(result, query, searchSessionId);
    else if ((0, $fhFN4.isSearchTalentPartial)(result) && (0, $dh538.fg)('talent_global_search')) return $0e1f91acee299cdf$var$mapTalentSearchResult(result, query, searchSessionId);
    else if ((0, $7ZetK.isSearchResultGraphEntity)(result)) return $0e1f91acee299cdf$var$mapThirdPartySearchResult(result, query, searchSessionId, thirdPartyConfigs);
    else if ((0, $8LSUr.isSearchJiraPartial)(result)) return $0e1f91acee299cdf$var$mapJiraSearchResult(result, query, searchSessionId, isStatusLoading, primaryProduct);
    else if ((0, $l3paI.isSearchAssetsPartial)(result) && (0, $dh538.fg)('assets_rovo_search_all')) return $0e1f91acee299cdf$var$mapAssetsSearchResult(result, query, searchSessionId);
    else return null;
};
const $0e1f91acee299cdf$export$c9f98fed0b66ba21 = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setHoverCardOpen: setHoverCardOpen } = (0, $4VmlX.useQuickFindActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const isHydrationLoading = (0, $djVCD.useIsJiraHydrationLoading)();
    const serveUserShardUI = (0, $j4ply.useUserShardUI)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const mappedResult = $0e1f91acee299cdf$var$mapSearchResult(result, quickFindQuery, searchSessionId, thirdPartyConfigs, isHydrationLoading, serveUserShardUI, primaryProduct);
    const additionalAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            metadata: {
                ...mappedResult?.analyticsMetadata,
                connectorType: (0, $kQT7c.getResultConnectorSource)({
                    connectorType: result.connectorType,
                    resultNodeId: result.id,
                    thirdPartyConfigs: thirdPartyConfigs,
                    productKey: mappedResult?.analyticsMetadata.product
                })
            },
            is3pLink: (0, $1yEFx.is3pProductKeyForAnalytics)(mappedResult?.analyticsMetadata.product),
            is3pSmartLink: (0, $kQT7c.isResultSmartLink)({
                resultAri: result.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product,
                connectorType: result.connectorType
            })
        }), [
        mappedResult,
        result.id,
        thirdPartyConfigs,
        result.connectorType
    ]);
    const onHoverCardVisibilityChange = (0, $42omo.useCallback)((isOpen)=>{
        setHoverCardOpen(result.id, isOpen);
    }, [
        setHoverCardOpen,
        result.id
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
        if ((0, $dh538.fg)('search_qf_fix_close_hover_card')) onHoverCardVisibilityChange(false);
    }, [
        additionalAnalyticsAttributes,
        onClick,
        state,
        onHoverCardVisibilityChange
    ]);
    const onResultContextMenu = (0, $42omo.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $42omo.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        ...mappedResult,
        resultType: "searchResults",
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted,
        connectorType: additionalAnalyticsAttributes.metadata.connectorType
    });
    return (0, $8LSUr.isSearchResultJiraIssue)(result) ? /*#__PURE__*/ (0, $l998X.jsx)($0e1f91acee299cdf$var$JiraResult, {
        result: result,
        content: content,
        mappedResult: mappedResult,
        onHoverCardVisibilityChange: onHoverCardVisibilityChange
    }) : content;
};
const $0e1f91acee299cdf$var$JiraResult = ({ result: result, content: content, mappedResult: mappedResult, onHoverCardVisibilityChange: onHoverCardVisibilityChange })=>{
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const enableJiraIssueHoverCard = primaryProduct === (0, $1yEFx.ProductKeys).Jira && (0, $dh538.fg)('enable_hover_card_jira_issues_quick_find');
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    return enableJiraIssueHoverCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        fallback: content,
        section: "result-hover-card",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: content,
            children: /*#__PURE__*/ (0, $l998X.jsx)($0e1f91acee299cdf$var$HoverCard, {
                url: mappedResult.url,
                actionOptions: {
                    hide: false,
                    exclude: [
                        (0, $hcMBV.CardAction).PreviewAction
                    ]
                },
                role: "dialog",
                titleId: mappedResult.title,
                label: "quick-find-smart-hover-card",
                onVisibilityChange: onHoverCardVisibilityChange,
                shouldRenderToParent: true,
                children: content
            })
        })
    }) : content;
};





parcelRequire("42omo");




























var $4AkKf = parcelRequire("4AkKf");






const $e6d2962f130fd57e$export$724848965240e03c = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'queryFilter',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

















const $a00b54be6ab004d4$export$c37f199dbeef0d2c = ()=>{
    return (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('remove_inline_contributor_filter')) return {};
        const contributorFilterMapping = Object.fromEntries((0, $aGXLL.CONTRIBUTOR_FILTER_QUERY_KEYWORDS).map((keyword)=>[
                keyword,
                (0, $aGXLL.filter).id
            ]));
        return {
            ...contributorFilterMapping
        };
    }, []);
};
const $a00b54be6ab004d4$export$170a7ded78a9d477 = ()=>{
    const contributorFilterFromStore = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aGXLL.filter).id
    });
    return (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('remove_inline_contributor_filter')) return {};
        const contributorFilterMapping = Object.fromEntries((0, $aGXLL.CONTRIBUTOR_FILTER_QUERY_KEYWORDS).map((keyword)=>[
                keyword,
                contributorFilterFromStore[1]
            ]));
        return {
            ...contributorFilterMapping
        };
    // Only want to make this object once as we only need access to the actions
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $a00b54be6ab004d4$export$a47046b35fa42e2d = (query, filterKeywords)=>{
    for (const keyword of filterKeywords){
        if (query.includes(keyword)) return keyword;
    }
};
const $a00b54be6ab004d4$export$3141a593bcb9212f = (query, filterKeyword)=>{
    if (!query.includes(filterKeyword)) return;
    const lookupQueryIndexStart = query.lastIndexOf(filterKeyword) + filterKeyword.length;
    const lookupQuery = query.substring(lookupQueryIndexStart);
    return lookupQuery;
};
const $a00b54be6ab004d4$export$f0a1ecf34ab38b2d = (inputQuery, selectedQueryFilters)=>{
    let filteredQuery = inputQuery;
    for (const selectedQueryFilter of selectedQueryFilters)filteredQuery = filteredQuery.replace(selectedQueryFilter.displayText, '');
    return filteredQuery;
};
const $a00b54be6ab004d4$export$53fd39a93e83286f = (inputQuery, keyword, displayText)=>{
    // Find the last occurrence of the keyword
    const keywordIndex = inputQuery.lastIndexOf(keyword);
    return inputQuery.substring(0, keywordIndex) + keyword + displayText;
};








const $becbf29994847995$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    filterIconLabel: {
        id: "filter",
        defaultMessage: "Filter icon"
    }
});


const $9dcebcedad235590$export$36d18380658d5d20 = ({ title: title, option: option, setOption: setOption, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const intl = (0, $8C5kA.default)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const { addSelectedQueryFilter: addSelectedQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        label: intl.formatMessage((0, $becbf29994847995$export$defe85febe8b728c).filterIconLabel)
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
    });
    const onResultClicked = (0, $42omo.useCallback)(()=>{
        if (!currentQueryFilter) return;
        // Set the filter
        setOption({
            ...option,
            isSelected: false
        });
        // Update the query shown in the input
        const newLocalQuery = (0, $a00b54be6ab004d4$export$53fd39a93e83286f)(localQuery, currentQueryFilter?.keyword, option.label);
        setLocalQuery(newLocalQuery);
        // Update the selected query filters
        addSelectedQueryFilter({
            filterId: currentQueryFilter.filterId,
            keyword: currentQueryFilter.keyword,
            displayText: currentQueryFilter.keyword + option.label,
            option: option
        });
        // Fire analytics event
        fireAnalyticsEvent((0, $e6d2962f130fd57e$export$724848965240e03c)({
            actionSubjectId: currentQueryFilter.filterId,
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        inputRef?.current?.focus();
    }, [
        addSelectedQueryFilter,
        commonAttributes,
        currentQueryFilter,
        fireAnalyticsEvent,
        inputRef,
        localQuery,
        nonPrivacySafeAttributes,
        option,
        setLocalQuery,
        setOption
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        id: option.value,
        icon: icon,
        title: title,
        resultType: 'queryFilters',
        onResultClicked: onResultClicked,
        highlightedRightMetadata: highlightedRightMetadata
    });
};





parcelRequire("42omo");






const $51a381ed95ba126a$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $51a381ed95ba126a$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'radius.large',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
});
const $51a381ed95ba126a$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $51a381ed95ba126a$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small'
});
const $51a381ed95ba126a$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $51a381ed95ba126a$var$titleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small',
    height: '16px',
    width: '40%'
});
const $51a381ed95ba126a$export$1983fc89ea4805f2 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $51a381ed95ba126a$var$containerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $51a381ed95ba126a$var$resultStyles
            ],
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $51a381ed95ba126a$var$iconAreaStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $51a381ed95ba126a$var$iconStyles
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $51a381ed95ba126a$var$middleAreaStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $51a381ed95ba126a$var$titleStyles
                        ]
                    })
                })
            ]
        })
    });
};
const $51a381ed95ba126a$export$cc8f1bc150ee9d84 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {})
        ]
    });
};





parcelRequire("42omo");












const $5fda3f2bb8e62542$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noOptions: {
        id: "noOptions",
        defaultMessage: "No options"
    }
});


const $b44fb3788556f802$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 'space.200'
});
const $b44fb3788556f802$export$eac7c78123119abb = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $b44fb3788556f802$var$containerStyles,
        children: intl.formatMessage((0, $5fda3f2bb8e62542$export$defe85febe8b728c).noOptions)
    });
};


const $8215af3ea39f4647$var$titleContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $8215af3ea39f4647$var$iconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $8215af3ea39f4647$var$titleStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $8215af3ea39f4647$var$ContributorQueryFilterOptions = ({ localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const [filterData, { setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $ehGUC.contributorFilter).id
    });
    if (filterData?.isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $51a381ed95ba126a$export$cc8f1bc150ee9d84), {});
    if (!filterData || filterData.options.length === 0) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b44fb3788556f802$export$eac7c78123119abb), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
        filterData.options.map((option)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $9dcebcedad235590$export$36d18380658d5d20), {
                title: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                    xcss: $8215af3ea39f4647$var$titleContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $8215af3ea39f4647$var$iconStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                                src: option.avatarUrl,
                                size: "small",
                                borderColor: "transparent",
                                appearance: "circle",
                                name: option.label
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $8215af3ea39f4647$var$titleStyles,
                            as: "span",
                            children: option.label
                        })
                    ]
                }),
                option: option,
                setOption: setOption,
                localQuery: localQuery,
                setLocalQuery: setLocalQuery,
                inputRef: inputRef
            }, option.value);
        })
    });
};
const $8215af3ea39f4647$export$385c746fbc3d50c5 = ({ localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    if (!currentQueryFilter) return null;
    if (currentQueryFilter.filterId === 'contributor') return /*#__PURE__*/ (0, $l998X.jsx)($8215af3ea39f4647$var$ContributorQueryFilterOptions, {
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        inputRef: inputRef
    });
    return null;
};
















var $kevJM = parcelRequire("kevJM");























const $7ce255b0a50b97ee$export$18593f729c2ce860 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'recentQuery',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });















const $59ce0bd6e733cc83$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    recentSearch: {
        id: "search_dialog_recent_search",
        defaultMessage: "Recent search"
    },
    removeRecentSearch: {
        id: "search_dialog_remove_recent_search_label",
        defaultMessage: "Remove recent search"
    }
});


const $8aeaf6643ef42bf9$export$de317f365b3e4c5c = ({ result: result, state: state })=>{
    const intl = (0, $8C5kA.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onResultClicked = (0, $42omo.useCallback)((event)=>{
        const newTab = (0, $6926da8980239f02$export$b2c60dba9a3fd739)(event);
        if (!newTab) setQuickFindOpen(false);
        // Move this recent query to the top of the list
        if (result && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)(result, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
            updateRecentQueries?.();
        }
        fireAnalyticsEvent((0, $7ce255b0a50b97ee$export$18593f729c2ce860)({
            actionSubjectId: (0, $6926da8980239f02$export$b6f8db3ad0711b02)(state),
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        result,
        setQuickFindOpen,
        state,
        updateRecentQueries,
        user
    ]);
    const mapRecentQueryToSearchResult = (0, $42omo.useCallback)((query)=>{
        const id = query;
        const icon = (0, $dh538.fg)('qf_icons_recents_suggested') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
            label: "",
            size: "small",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                label: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch),
                color: "currentColor"
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch),
            color: "currentColor"
        });
        const title = query;
        const onClick = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            if (user.id && primaryProduct) {
                (0, $1SV4e.removeRecentSearch)(query, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        };
        const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch)
        });
        const hoveredRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            ...iconProps,
                            size: "medium"
                        }),
                    spacing: 'compact',
                    onClick: onClick,
                    label: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch),
                    appearance: 'subtle'
                })
            ]
        });
        const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
            ]
        });
        const url = generateSearchUrl({
            ...queryParams,
            text: query,
            search_id: searchSessionId
        });
        return {
            id: id,
            icon: icon,
            title: title,
            url: url,
            rightMetadata: rightMetadata,
            hoveredRightMetadata: hoveredRightMetadata,
            highlightedRightMetadata: highlightedRightMetadata
        };
    }, [
        intl,
        generateSearchUrl,
        queryParams,
        searchSessionId,
        user.id,
        primaryProduct,
        updateRecentQueries
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        resultType: "recentQueries",
        ...mapRecentQueryToSearchResult(result),
        onResultClicked: onResultClicked
    });
};





parcelRequire("42omo");






const $191ce2f0a4d53c1e$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $191ce2f0a4d53c1e$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'radius.large',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
});
const $191ce2f0a4d53c1e$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $191ce2f0a4d53c1e$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small'
});
const $191ce2f0a4d53c1e$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $191ce2f0a4d53c1e$var$titleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small',
    height: '16px',
    width: '40%'
});
const $191ce2f0a4d53c1e$var$metadataStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'color.skeleton',
    width: '20%',
    borderRadius: 'radius.small',
    height: '13px'
});
const $191ce2f0a4d53c1e$export$dd3282b157ef6f7a = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $191ce2f0a4d53c1e$var$containerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $191ce2f0a4d53c1e$var$resultStyles
            ],
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $191ce2f0a4d53c1e$var$iconAreaStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $191ce2f0a4d53c1e$var$iconStyles
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                    xcss: $191ce2f0a4d53c1e$var$middleAreaStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $191ce2f0a4d53c1e$var$titleStyles
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $191ce2f0a4d53c1e$var$metadataStyles
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




















































const $fbb70dd8ca3729b4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchAcrossProducts: {
        id: "search_dialog_search_across_products",
        defaultMessage: "Search all apps"
    },
    more: {
        id: "search_dialog_search_across_products.more",
        defaultMessage: "more"
    }
});





parcelRequire("42omo");

const $e44bc7f30f46743e$export$21da0c8b2e1046fc = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "86",
        height: "22",
        viewBox: "0 0 86 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "var(--ds-icon-inverse, #FFFFFF)",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.9065 13.051C12.541 11.4236 11.5578 11.1804 10.1397 11.1804C8.47584 11.1804 7.05777 11.8725 5.79097 13.8179L5.58298 14.1359C5.41282 14.3977 5.375 14.4913 5.375 14.6035C5.375 14.7157 5.43172 14.8093 5.63971 14.9402L7.77626 16.2683C7.88971 16.3431 7.98424 16.3805 8.07878 16.3805C8.19223 16.3805 8.26786 16.3244 8.3813 16.156L8.72164 15.6323C9.25105 14.828 9.72374 14.5661 10.3288 14.5661C10.8582 14.5661 11.4821 14.7157 12.2574 15.0898L14.4884 16.1373C14.7153 16.2496 14.9611 16.1934 15.0746 15.9316L16.1334 13.6121C16.2468 13.3503 16.1712 13.1819 15.9065 13.051ZM6.09349 8.95453C9.45903 10.5819 10.4422 10.825 11.8603 10.825C13.5242 10.825 14.9422 10.133 16.209 8.18761L16.417 7.86962C16.5872 7.60775 16.625 7.51423 16.625 7.40199C16.625 7.28976 16.5683 7.19624 16.3603 7.0653L14.2237 5.73723C14.1103 5.66241 14.0158 5.625 13.9212 5.625C13.8078 5.625 13.7321 5.68112 13.6187 5.84946L13.2784 6.37321C12.749 7.17753 12.2763 7.4394 11.6712 7.4394C11.1418 7.4394 10.5179 7.28976 9.74265 6.91566L7.51155 5.86817C7.28466 5.75594 7.03887 5.81205 6.92542 6.07392L5.8666 8.39337C5.75315 8.65524 5.82878 8.82359 6.09349 8.95453Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "16.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "16.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "var(--ds-icon-inverse, #FFFFFF)",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M24.5168 13.8913H23.4072C21.7337 13.8913 20.5332 12.8662 20.5332 11.3653H26.4995C26.8087 11.3653 27.0088 11.585 27.0088 11.8961V17.8998C25.5172 17.8998 24.5168 16.6918 24.5168 15.0078V13.8913ZM27.4635 10.9077H26.354C24.6805 10.9077 23.48 9.90099 23.48 8.40006H29.4462C29.7555 8.40006 29.9738 8.6014 29.9738 8.91257V14.9163C28.4822 14.9163 27.4635 13.7082 27.4635 12.0243V10.9077ZM30.4285 7.94246H29.3189C27.6454 7.94246 26.4449 6.91743 26.4449 5.4165H32.4112C32.7204 5.4165 32.9205 5.63615 32.9205 5.92902V11.9327C31.4289 11.9327 30.4285 10.7247 30.4285 9.0407V7.94246Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "33",
                y: "1",
                width: "20",
                height: "20",
                rx: "4",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "32.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_1_83305)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M36.2096 16.0781L36.9152 17.2906C37.0619 17.5459 37.2726 17.7465 37.52 17.8923L40.0401 13.5527H35C35 13.8354 35.0733 14.118 35.2199 14.3732L36.2096 16.0781Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M43 8.44751L40.48 4.10791C40.2325 4.25378 40.0218 4.45435 39.8751 4.70962L35.2199 12.7324C35.076 12.9822 35.0002 13.265 35 13.5529H40.0401L43 8.44751Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M48.4794 17.8923C48.7268 17.7465 48.9376 17.5459 49.0842 17.2906L49.3774 16.7892L50.7795 14.3732C50.9261 14.118 50.9994 13.8354 50.9994 13.5527H45.959L47.0315 15.6496L48.4794 17.8923Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M43.0005 8.44756L45.5206 4.10796C45.2731 3.96209 44.9891 3.88916 44.6958 3.88916H41.3052C41.012 3.88916 40.7279 3.97121 40.4805 4.10796L43.0005 8.44756Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M45.9594 13.5527H40.0396L37.5195 17.8923C37.767 18.0382 38.051 18.1111 38.3443 18.1111H47.6547C47.9479 18.1111 48.232 18.0291 48.4794 17.8923L45.9594 13.5527Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M48.4525 8.72101L46.1249 4.70962C45.9782 4.45435 45.7675 4.25378 45.52 4.10791L43 8.44751L45.9599 13.5529H50.9908C50.9908 13.2703 50.9175 12.9877 50.7709 12.7324L48.4525 8.72101Z",
                        fill: "#FFBA00"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "49",
                y: "1",
                width: "20",
                height: "20",
                rx: "4",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "48.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip1_1_83305)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M54.9981 12.8189C54.9981 13.6236 54.3477 14.274 53.543 14.274C52.7383 14.274 52.0879 13.6236 52.0879 12.8189C52.0879 12.0142 52.7383 11.3638 53.543 11.3638H54.9981V12.8189ZM55.7257 12.8189C55.7257 12.0142 56.3761 11.3638 57.1808 11.3638C57.9855 11.3638 58.6359 12.0142 58.6359 12.8189V16.4567C58.6359 17.2614 57.9855 17.9118 57.1808 17.9118C56.3761 17.9118 55.7257 17.2614 55.7257 16.4567V12.8189Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M57.1801 6.97615C56.3754 6.97615 55.725 6.32576 55.725 5.52104C55.725 4.71631 56.3754 4.06592 57.1801 4.06592C57.9848 4.06592 58.6352 4.71631 58.6352 5.52104V6.97615H57.1801ZM57.1801 7.71474C57.9848 7.71474 58.6352 8.36513 58.6352 9.16986C58.6352 9.97458 57.9848 10.625 57.1801 10.625H53.5313C52.7266 10.625 52.0762 9.97458 52.0762 9.16986C52.0762 8.36513 52.7266 7.71474 53.5313 7.71474H57.1801Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M63.0128 9.16986C63.0128 8.36513 63.6632 7.71474 64.4679 7.71474C65.2726 7.71474 65.923 8.36513 65.923 9.16986C65.923 9.97458 65.2726 10.625 64.4679 10.625H63.0128V9.16986ZM62.2852 9.16986C62.2852 9.97458 61.6348 10.625 60.8301 10.625C60.0254 10.625 59.375 9.97458 59.375 9.16986V5.52104C59.375 4.71631 60.0254 4.06592 60.8301 4.06592C61.6348 4.06592 62.2852 4.71631 62.2852 5.52104V9.16986Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M60.8301 15.0016C61.6348 15.0016 62.2852 15.652 62.2852 16.4567C62.2852 17.2614 61.6348 17.9118 60.8301 17.9118C60.0254 17.9118 59.375 17.2614 59.375 16.4567V15.0016H60.8301ZM60.8301 14.274C60.0254 14.274 59.375 13.6236 59.375 12.8189C59.375 12.0142 60.0254 11.3638 60.8301 11.3638H64.4789C65.2837 11.3638 65.9341 12.0142 65.9341 12.8189C65.9341 13.6236 65.2837 14.274 64.4789 14.274H60.8301Z",
                        fill: "#ECB22E"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "64.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "64.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "var(--ds-icon-inverse, #FFFFFF)",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip2_1_83305)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M74.998 11C74.998 10.337 75.252 9.70107 75.7041 9.23223C76.1562 8.76339 76.7694 8.5 77.4088 8.5C78.0481 8.5 78.6613 8.76339 79.1134 9.23223C79.5655 9.70107 79.8195 10.337 79.8195 11C79.8195 11.663 79.5655 12.2989 79.1134 12.7678C78.6613 13.2366 78.0481 13.5 77.4088 13.5C76.7694 13.5 76.1562 13.2366 75.7041 12.7678C75.252 12.2989 74.998 11.663 74.998 11Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M70.1777 16C70.1777 15.337 70.4317 14.7011 70.8838 14.2322C71.3359 13.7634 71.9491 13.5 72.5884 13.5H74.9992V16C74.9992 16.663 74.7452 17.2989 74.2931 17.7678C73.841 18.2366 73.2278 18.5 72.5884 18.5C71.9491 18.5 71.3359 18.2366 70.8838 17.7678C70.4317 17.2989 70.1777 16.663 70.1777 16V16Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M74.998 3.5V8.5H77.4088C78.0481 8.5 78.6613 8.23661 79.1134 7.76777C79.5655 7.29893 79.8195 6.66304 79.8195 6C79.8195 5.33696 79.5655 4.70107 79.1134 4.23223C78.6613 3.76339 78.0481 3.5 77.4088 3.5H74.998Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M70.1777 6C70.1777 6.66304 70.4317 7.29893 70.8838 7.76777C71.3359 8.23661 71.9491 8.5 72.5884 8.5H74.9992V3.5H72.5884C71.9491 3.5 71.3359 3.76339 70.8838 4.23223C70.4317 4.70107 70.1777 5.33696 70.1777 6V6Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M70.1777 11C70.1777 11.663 70.4317 12.2989 70.8838 12.7678C71.3359 13.2366 71.9491 13.5 72.5884 13.5H74.9992V8.5H72.5884C71.9491 8.5 71.3359 8.76339 70.8838 9.23223C70.4317 9.70107 70.1777 10.337 70.1777 11V11Z",
                        fill: "#A259FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_1_83305",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "16",
                            height: "14.2222",
                            fill: "white",
                            transform: "translate(35 3.88916)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip1_1_83305",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white",
                            transform: "translate(52 4)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip2_1_83305",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "9.64286",
                            height: "15",
                            fill: "white",
                            transform: "translate(70.1777 3.5)"
                        })
                    })
                ]
            })
        ]
    });
};





parcelRequire("42omo");

const $d94fcf9e4428b2a8$export$e8cbcd9edcbc9fc8 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "86",
        height: "22",
        viewBox: "0 0 86 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "var(--ds-icon-inverse, #FFFFFF)",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.5168 13.8913H7.4072C5.7337 13.8913 4.5332 12.8662 4.5332 11.3653H10.4995C10.8087 11.3653 11.0088 11.585 11.0088 11.8961V17.8998C9.5172 17.8998 8.5168 16.6918 8.5168 15.0078V13.8913ZM11.4635 10.9077H10.354C8.6805 10.9077 7.48 9.90099 7.48 8.40006H13.4462C13.7555 8.40006 13.9738 8.6014 13.9738 8.91257V14.9163C12.4822 14.9163 11.4635 13.7082 11.4635 12.0243V10.9077ZM14.4285 7.94246H13.3189C11.6454 7.94246 10.4449 6.91743 10.4449 5.4165H16.4112C16.7204 5.4165 16.9205 5.63615 16.9205 5.92902V11.9327C15.4289 11.9327 14.4285 10.7247 14.4285 9.0407V7.94246Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "16.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "16.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "var(--ds-icon-inverse, #FFFFFF)",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M30.9065 13.051C27.541 11.4236 26.5578 11.1804 25.1397 11.1804C23.47584 11.1804 22.05777 11.8725 20.79097 13.8179L20.58298 14.1359C20.41282 14.3977 20.375 14.4913 20.375 14.6035C20.375 14.7157 20.43172 14.8093 20.63971 14.9402L22.77626 16.2683C22.88971 16.3431 22.98424 16.3805 23.07878 16.3805C23.19223 16.3805 23.26786 16.3244 23.3813 16.156L23.72164 15.6323C24.25105 14.828 24.72374 14.5661 25.3288 14.5661C25.8582 14.5661 26.4821 14.7157 27.2574 15.0898L29.4884 16.1373C29.7153 16.2496 29.9611 16.1934 30.0746 15.9316L31.1334 13.6121C31.2468 13.3503 31.1712 13.1819 30.9065 13.051ZM21.09349 8.95453C24.45903 10.5819 25.4422 10.825 26.8603 10.825C28.5242 10.825 29.9422 10.133 31.209 8.18761L31.417 7.86962C31.5872 7.60775 31.625 7.51423 31.625 7.40199C31.625 7.28976 31.5683 7.19624 31.3603 7.0653L29.2237 5.73723C29.1103 5.66241 29.0158 5.625 28.9212 5.625C28.8078 5.625 28.7321 5.68112 28.6187 5.84946L28.2784 6.37321C27.749 7.17753 27.2763 7.4394 26.6712 7.4394C26.1418 7.4394 25.5179 7.28976 24.74265 6.91566L22.51155 5.86817C22.28466 5.75594 22.03887 5.81205 21.92542 6.07392L20.8666 8.39337C20.75315 8.65524 20.82878 8.82359 21.09349 8.95453Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "33",
                y: "1",
                width: "20",
                height: "20",
                rx: "4",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "32.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_1_83305)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M36.2096 16.0781L36.9152 17.2906C37.0619 17.5459 37.2726 17.7465 37.52 17.8923L40.0401 13.5527H35C35 13.8354 35.0733 14.118 35.2199 14.3732L36.2096 16.0781Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M43 8.44751L40.48 4.10791C40.2325 4.25378 40.0218 4.45435 39.8751 4.70962L35.2199 12.7324C35.076 12.9822 35.0002 13.265 35 13.5529H40.0401L43 8.44751Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M48.4794 17.8923C48.7268 17.7465 48.9376 17.5459 49.0842 17.2906L49.3774 16.7892L50.7795 14.3732C50.9261 14.118 50.9994 13.8354 50.9994 13.5527H45.959L47.0315 15.6496L48.4794 17.8923Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M43.0005 8.44756L45.5206 4.10796C45.2731 3.96209 44.9891 3.88916 44.6958 3.88916H41.3052C41.012 3.88916 40.7279 3.97121 40.4805 4.10796L43.0005 8.44756Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M45.9594 13.5527H40.0396L37.5195 17.8923C37.767 18.0382 38.051 18.1111 38.3443 18.1111H47.6547C47.9479 18.1111 48.232 18.0291 48.4794 17.8923L45.9594 13.5527Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M48.4525 8.72101L46.1249 4.70962C45.9782 4.45435 45.7675 4.25378 45.52 4.10791L43 8.44751L45.9599 13.5529H50.9908C50.9908 13.2703 50.9175 12.9877 50.7709 12.7324L48.4525 8.72101Z",
                        fill: "#FFBA00"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "49",
                y: "1",
                width: "20",
                height: "20",
                rx: "4",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "48.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip1_1_83305)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M54.9981 12.8189C54.9981 13.6236 54.3477 14.274 53.543 14.274C52.7383 14.274 52.0879 13.6236 52.0879 12.8189C52.0879 12.0142 52.7383 11.3638 53.543 11.3638H54.9981V12.8189ZM55.7257 12.8189C55.7257 12.0142 56.3761 11.3638 57.1808 11.3638C57.9855 11.3638 58.6359 12.0142 58.6359 12.8189V16.4567C58.6359 17.2614 57.9855 17.9118 57.1808 17.9118C56.3761 17.9118 55.7257 17.2614 55.7257 16.4567V12.8189Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M57.1801 6.97615C56.3754 6.97615 55.725 6.32576 55.725 5.52104C55.725 4.71631 56.3754 4.06592 57.1801 4.06592C57.9848 4.06592 58.6352 4.71631 58.6352 5.52104V6.97615H57.1801ZM57.1801 7.71474C57.9848 7.71474 58.6352 8.36513 58.6352 9.16986C58.6352 9.97458 57.9848 10.625 57.1801 10.625H53.5313C52.7266 10.625 52.0762 9.97458 52.0762 9.16986C52.0762 8.36513 52.7266 7.71474 53.5313 7.71474H57.1801Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M63.0128 9.16986C63.0128 8.36513 63.6632 7.71474 64.4679 7.71474C65.2726 7.71474 65.923 8.36513 65.923 9.16986C65.923 9.97458 65.2726 10.625 64.4679 10.625H63.0128V9.16986ZM62.2852 9.16986C62.2852 9.97458 61.6348 10.625 60.8301 10.625C60.0254 10.625 59.375 9.97458 59.375 9.16986V5.52104C59.375 4.71631 60.0254 4.06592 60.8301 4.06592C61.6348 4.06592 62.2852 4.71631 62.2852 5.52104V9.16986Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M60.8301 15.0016C61.6348 15.0016 62.2852 15.652 62.2852 16.4567C62.2852 17.2614 61.6348 17.9118 60.8301 17.9118C60.0254 17.9118 59.375 17.2614 59.375 16.4567V15.0016H60.8301ZM60.8301 14.274C60.0254 14.274 59.375 13.6236 59.375 12.8189C59.375 12.0142 60.0254 11.3638 60.8301 11.3638H64.4789C65.2837 11.3638 65.9341 12.0142 65.9341 12.8189C65.9341 13.6236 65.2837 14.274 64.4789 14.274H60.8301Z",
                        fill: "#ECB22E"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "64.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "64.625",
                y: "0.625",
                width: "20.75",
                height: "20.75",
                rx: "4.375",
                stroke: "var(--ds-icon-inverse, #FFFFFF)",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip2_1_83305)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M74.998 11C74.998 10.337 75.252 9.70107 75.7041 9.23223C76.1562 8.76339 76.7694 8.5 77.4088 8.5C78.0481 8.5 78.6613 8.76339 79.1134 9.23223C79.5655 9.70107 79.8195 10.337 79.8195 11C79.8195 11.663 79.5655 12.2989 79.1134 12.7678C78.6613 13.2366 78.0481 13.5 77.4088 13.5C76.7694 13.5 76.1562 13.2366 75.7041 12.7678C75.252 12.2989 74.998 11.663 74.998 11Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M70.1777 16C70.1777 15.337 70.4317 14.7011 70.8838 14.2322C71.3359 13.7634 71.9491 13.5 72.5884 13.5H74.9992V16C74.9992 16.663 74.7452 17.2989 74.2931 17.7678C73.841 18.2366 73.2278 18.5 72.5884 18.5C71.9491 18.5 71.3359 18.2366 70.8838 17.7678C70.4317 17.2989 70.1777 16.663 70.1777 16V16Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M74.998 3.5V8.5H77.4088C78.0481 8.5 78.6613 8.23661 79.1134 7.76777C79.5655 7.29893 79.8195 6.66304 79.8195 6C79.8195 5.33696 79.5655 4.70107 79.1134 4.23223C78.6613 3.76339 78.0481 3.5 77.4088 3.5H74.998Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M70.1777 6C70.1777 6.66304 70.4317 7.29893 70.8838 7.76777C71.3359 8.23661 71.9491 8.5 72.5884 8.5H74.9992V3.5H72.5884C71.9491 3.5 71.3359 3.76339 70.8838 4.23223C70.4317 4.70107 70.1777 5.33696 70.1777 6V6Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M70.1777 11C70.1777 11.663 70.4317 12.2989 70.8838 12.7678C71.3359 13.2366 71.9491 13.5 72.5884 13.5H74.9992V8.5H72.5884C71.9491 8.5 71.3359 8.76339 70.8838 9.23223C70.4317 9.70107 70.1777 10.337 70.1777 11V11Z",
                        fill: "#A259FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_1_83305",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "16",
                            height: "14.2222",
                            fill: "white",
                            transform: "translate(35 3.88916)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip1_1_83305",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white",
                            transform: "translate(52 4)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip2_1_83305",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "9.64286",
                            height: "15",
                            fill: "white",
                            transform: "translate(70.1777 3.5)"
                        })
                    })
                ]
            })
        ]
    });
};


const $130bb7db5dbd93df$var$moreButtonStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral',
    borderRadius: "var(--ds-radius-small, 4px)",
    display: 'flex',
    paddingLeft: 'space.100',
    paddingRight: 'space.075'
});
const $130bb7db5dbd93df$var$allAppsIconsStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    translate: "var(--ds-space-050, 4px)"
});
const $130bb7db5dbd93df$export$2bea3e9ad1fa13ae = ({ product: product })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        role: "presentation",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $130bb7db5dbd93df$var$allAppsIconsStyles,
                children: product === (0, $1yEFx.PrimaryProductKeys).Jira ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d94fcf9e4428b2a8$export$e8cbcd9edcbc9fc8), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $e44bc7f30f46743e$export$21da0c8b2e1046fc), {})
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $130bb7db5dbd93df$var$moreButtonStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: `+ ${formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).more)}`
                })
            })
        ]
    });
};
const $130bb7db5dbd93df$export$bf6cf7fe2100de5c = ({ state: state, onClick: onClick })=>{
    const intl = (0, $8C5kA.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const onResultClicked = (0, $42omo.useCallback)((event)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: `${primaryProduct?.toLowerCase() || ''}AdvancedSearchLink`
        });
        // Executing a search query on FPS search will always clear the filters in QF as FPS filters
        // is the source of truth for filter state.
        clearAllFilters();
    }, [
        onClick,
        state,
        primaryProduct,
        clearAllFilters
    ]);
    const swapQuickFindCTAs = (0, $1XDdH.isOnJiraFullPageSearch)() && primaryProduct && primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_search_fps_cta_swap');
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: intl.formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).searchAcrossProducts),
        color: "currentColor"
    });
    const title = intl.formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).searchAcrossProducts);
    const rightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($130bb7db5dbd93df$export$2bea3e9ad1fa13ae, {
                product: primaryProduct
            }),
            primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && !swapQuickFindCTAs && /*#__PURE__*/ (0, $l998X.jsx)((0, $738ebcb5194247d5$export$76bfbab5e3f9a6a3), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const url = generateSearchUrl({
        ...queryParams,
        text: quickFindQuery
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $02caee92bec6b3d2$export$64ded8b71dfcba9e), {
        icon: icon,
        title: title,
        rightMetadata: rightMetadata,
        url: url,
        onResultClicked: onResultClicked
    });
};

















































const $c25c3f300afdded5$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    attachment: {
        id: "attachment_type",
        defaultMessage: "Attachment"
    },
    blogpost: {
        id: "blogpost_type",
        defaultMessage: "Blogpost"
    },
    comment: {
        id: "comment_type",
        defaultMessage: "Comment"
    },
    page: {
        id: "page_type",
        defaultMessage: "Page"
    },
    whiteboard: {
        id: "whiteboard_type",
        defaultMessage: "Whiteboard"
    }
});


const $69f29a2bcea28efa$var$mapConfluenceSearchResult = (result, query, searchSessionId, logException)=>{
    const id = result.id;
    const title = result?.object?.title;
    if (!title) return null;
    const space = result?.object?.space?.name ? result.object.space.name : null;
    const spaceId = result?.object?.space?.id;
    if (!space || !spaceId) return null;
    const rawUrl = result?.object?.links?.base && result.object.links?.webUi ? result?.object?.links?.base + result.object.links?.webUi : undefined;
    if (!rawUrl) return null;
    const url = (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
        url: rawUrl,
        query: query,
        searchSessionId: searchSessionId
    });
    let reason;
    try {
        reason = result.reason ? JSON.parse(result.reason) : undefined;
    } catch (error) {
        logException(error);
        return null;
    }
    const rightMetadata = reason && reason.timestamp ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: reason.timestamp,
        eventType: (0, $3E8x9.VIEWED_EVENT).VIEWED,
        isMyActivityData: reason.type === 'no_collaborator'
    }) : null;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const isLiveDoc = result?.object?.__typename === 'ConfluencePage' && result.object.subtype === 'LIVE';
    const icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: undefined,
        type: result.object?.type?.replace('_', '').toLowerCase() || '',
        isLiveDoc: isLiveDoc
    });
    const metadata = [
        [
            'type',
            isLiveDoc ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $c25c3f300afdded5$export$defe85febe8b728c).liveDoc
            }) : result?.object?.type === 'ATTACHMENT' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $c25c3f300afdded5$export$defe85febe8b728c).attachment
            }) : result?.object?.type === 'BLOG_POST' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $c25c3f300afdded5$export$defe85febe8b728c).blogpost
            }) : result?.object?.type === 'COMMENT' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $c25c3f300afdded5$export$defe85febe8b728c).comment
            }) : result?.object?.type === 'PAGE' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $c25c3f300afdded5$export$defe85febe8b728c).page
            }) : result?.object?.type === 'WHITEBOARD' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $c25c3f300afdded5$export$defe85febe8b728c).whiteboard
            }) : null
        ],
        space
    ];
    const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `confluence ${result?.object?.type}`,
        product: `confluence`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $69f29a2bcea28efa$var$mapSearchResult = (result, query, searchSessionId, logException)=>{
    if (result?.object?.__typename === 'ConfluencePage' || result?.object?.__typename === 'ConfluenceBlogPost') return $69f29a2bcea28efa$var$mapConfluenceSearchResult(result, query, searchSessionId, logException);
    else return null;
};
const $69f29a2bcea28efa$export$5b3636afbb1882d3 = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const logException = (0, $f8oYd.useLogException)();
    const mappedResult = $69f29a2bcea28efa$var$mapSearchResult(result, quickFindQuery, searchSessionId, logException);
    const additionalAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            metadata: {
                ...mappedResult?.analyticsMetadata,
                connectorType: (0, $kQT7c.getResultConnectorSource)({
                    // We cannot provide a value for connectorType here because the user relevant documents API
                    // does not return a connectorType for a given entity.
                    resultNodeId: result.id,
                    thirdPartyConfigs: thirdPartyConfigs,
                    productKey: mappedResult?.analyticsMetadata.product
                })
            },
            is3pLink: (0, $1yEFx.is3pProductKeyForAnalytics)(mappedResult?.analyticsMetadata.product),
            is3pSmartLink: (0, $kQT7c.isResultSmartLink)({
                resultAri: result.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product
            })
        }), [
        mappedResult,
        result.id,
        thirdPartyConfigs
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onClick,
        state
    ]);
    const onResultContextMenu = (0, $42omo.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $42omo.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        ...mappedResult,
        resultType: (0, $dh538.fg)('qf_add_result_type_in_analytics') ? 'recommendations' : 'searchResults',
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};















var $8DN9t = parcelRequire("8DN9t");

























var $epS7s = parcelRequire("epS7s");
















const $342b4005aadcc963$export$41d82c6d8a0a3ca8 = ({ success: success, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'operational',
        action: success ? 'taskSuccess' : 'taskFail',
        actionSubject: 'suggestedQuery',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $875f1f3e3260f408$export$746fc217b00b3d82 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'suggestedQuery',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $80931b93956c3e1c$export$a78be3e217bbe92c = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'suggestedQuery',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });



var $6FG5J = parcelRequire("6FG5J");

const $1d2671f5d43d8750$var$ZeroQueryTypesV0 = [
    (0, $6FG5J.ZeroQueryType).RECENT_WORK,
    (0, $6FG5J.ZeroQueryType).RELATED_QUESTION,
    (0, $6FG5J.ZeroQueryType).WHO_IS
];
const $1d2671f5d43d8750$var$ZeroQueryTypesV1 = [
    (0, $6FG5J.ZeroQueryType).COLLABORATOR_PROFILE,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_30_DAYS,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_7_DAYS,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS,
    (0, $6FG5J.ZeroQueryType).JIRA_MY_WORK_ITEMS,
    (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
    (0, $6FG5J.ZeroQueryType).JIRA_NLQ_COLLABORATOR,
    (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_ASSIGNED,
    (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_ASSIGNED_COLLABORATOR,
    (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_CREATED,
    (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_CREATED_COLLABORATOR,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_MY_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_MY_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_MY_MESSAGES
];
const $1d2671f5d43d8750$var$ZeroQueryTypes3P = [
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_MY_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_MY_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_MY_MESSAGES
];
const $1d2671f5d43d8750$export$2378e9e94d0e91e3 = (zeroQueryType)=>{
    if ($1d2671f5d43d8750$var$ZeroQueryTypesV0.includes(zeroQueryType)) return 0;
    else if ($1d2671f5d43d8750$var$ZeroQueryTypesV1.includes(zeroQueryType)) return 1;
    return null;
};
const $1d2671f5d43d8750$export$6da79ec281e5bbf3 = (zeroQueryType)=>$1d2671f5d43d8750$var$ZeroQueryTypes3P.includes(zeroQueryType);



















const $8dfecd1d0bfad5c1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    zero_query: {
        id: "search_dialog_zero_query",
        defaultMessage: "Suggestion"
    },
    zero_query_icon_label: {
        id: "search_dialog_zero_query_icon_label",
        defaultMessage: "Suggestion search"
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");










parcelRequire("42omo");

const $dbf0ba150e688e75$export$e16bd899bb4eebf9 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_2230_19249)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z",
                        fill: "#FFBA00"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_2230_19249",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "16",
                        height: "14.6667",
                        fill: "white"
                    })
                })
            })
        ]
    });





parcelRequire("42omo");

const $df006fe490c0a4db$export$1c773608dea5140 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_2230_19237)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.18613 9.14286C10.6521 9.14286 12.6512 7.09616 12.6512 4.57143C12.6512 2.0467 10.6521 0 8.18613 0C5.72011 0 3.72101 2.0467 3.72101 4.57143C3.72101 7.09616 5.72011 9.14286 8.18613 9.14286Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.9068 12.9524C14.1673 12.9524 15.9998 11.0763 15.9998 8.76193C15.9998 6.44759 14.1673 4.57145 11.9068 4.57145C9.64629 4.57145 7.81378 6.44759 7.81378 8.76193C7.81378 11.0763 9.64629 12.9524 11.9068 12.9524Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.74415 16C10.4909 16 11.9069 14.5502 11.9069 12.7619C11.9069 10.9735 10.4909 9.5238 8.74415 9.5238C6.99739 9.5238 5.58136 10.9735 5.58136 12.7619C5.58136 14.5502 6.99739 16 8.74415 16Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M8.93036 4.12569V12.2552C8.92851 12.5377 8.76131 12.7915 8.50617 12.899C8.42493 12.9342 8.33763 12.9523 8.24943 12.9524H5.58524C5.58152 12.8876 5.58152 12.8266 5.58152 12.7619C5.58028 12.6983 5.58277 12.6347 5.58897 12.5714C5.65707 11.3537 6.3898 10.2793 7.48292 9.79426V9.08568C5.05014 8.69099 3.3905 6.35191 3.77602 3.86121C3.77869 3.84396 3.78145 3.82672 3.78432 3.8095C3.80284 3.68102 3.82894 3.5538 3.86246 3.42855H8.24944C8.6249 3.43001 8.92893 3.74128 8.93036 4.12569Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M7.87705 3.80953H3.78403C3.37055 6.29575 5.00397 8.65439 7.43236 9.07771C7.50589 9.09053 7.57972 9.10145 7.65379 9.11048C6.5003 9.67048 5.65975 11.261 5.5883 12.5714C5.58211 12.6347 5.57962 12.6983 5.58086 12.7619C5.58086 12.8267 5.58086 12.8876 5.58458 12.9524C5.59129 13.0804 5.60747 13.2078 5.63295 13.3333H7.87667C8.15258 13.3314 8.40045 13.1603 8.5055 12.8991C8.53987 12.8159 8.55758 12.7265 8.5576 12.6362V4.50667C8.55619 4.12241 8.25238 3.81121 7.87705 3.80953Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M7.87739 3.80953H3.78436C3.37098 6.29598 5.00464 8.65473 7.43326 9.07796C7.48294 9.08662 7.53275 9.09442 7.58269 9.10135C6.46641 9.70173 5.65897 11.2884 5.58901 12.5714H7.87739C8.25227 12.5685 8.55548 12.2581 8.55832 11.8743V4.50667C8.55689 4.12226 8.25286 3.811 7.87739 3.80953Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M7.50517 3.80953H3.78424C3.39389 6.15676 4.83048 8.41717 7.08471 9.00268C6.23115 10.0011 5.70762 11.2502 5.58889 12.5714H7.50517C7.88065 12.57 8.18467 12.2587 8.1861 11.8743V4.50667C8.1859 4.12175 7.88115 3.80975 7.50517 3.80953Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0.682047 3.80953H7.504C7.88068 3.80953 8.18605 4.12217 8.18605 4.50782V11.4922C8.18605 11.8778 7.88068 12.1905 7.504 12.1905H0.682047C0.305363 12.1905 0 11.8778 0 11.4922V4.50782C0 4.12217 0.305363 3.80953 0.682047 3.80953Z",
                        fill: "url(#paint0_linear_2230_19237)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M3.04621 7.91468C2.88638 7.80614 2.75286 7.66163 2.65588 7.4922C2.56192 7.31509 2.51508 7.11579 2.52007 6.9143C2.5117 6.64148 2.60162 6.37505 2.77272 6.16572C2.95251 5.95615 3.1849 5.80095 3.44472 5.71696C3.74082 5.61718 4.05096 5.56801 4.36267 5.57144C4.77258 5.55611 5.18193 5.61479 5.57197 5.74478V6.62097C5.40249 6.51586 5.21791 6.43872 5.02499 6.3924C4.81567 6.33984 4.60088 6.31349 4.38536 6.31392C4.15809 6.30538 3.93227 6.35431 3.72787 6.4564C3.57007 6.52608 3.46774 6.68503 3.46741 6.86097C3.46677 6.9677 3.50682 7.07047 3.57904 7.14745C3.66434 7.23819 3.76525 7.31206 3.87672 7.36536C4.00074 7.42859 4.18679 7.51266 4.43485 7.61755C4.46217 7.62639 4.48879 7.63734 4.51448 7.65031C4.75862 7.748 4.99415 7.86691 5.21848 8.00574C5.38837 8.11298 5.53095 8.26 5.63449 8.43469C5.74064 8.63272 5.79209 8.8566 5.78332 9.08231C5.79544 9.3624 5.71174 9.63805 5.54667 9.86174C5.38213 10.0674 5.16216 10.219 4.91411 10.2975C4.62236 10.3912 4.31786 10.4364 4.01215 10.4316C3.73787 10.4329 3.46399 10.41 3.19355 10.3631C2.96521 10.3248 2.74237 10.2578 2.53011 10.1634V9.23964C2.733 9.38799 2.95967 9.49887 3.19988 9.56726C3.43928 9.64364 3.68814 9.68443 3.93886 9.68841C4.17091 9.70345 4.40255 9.65312 4.60863 9.54288C4.75299 9.45948 4.84079 9.3015 4.83709 9.13183C4.83806 9.01377 4.79244 8.90032 4.71058 8.81717C4.60879 8.71486 4.49093 8.63077 4.36194 8.56841C4.2131 8.49221 3.99393 8.39177 3.70445 8.26707C3.47415 8.17228 3.25365 8.05423 3.04621 7.91468Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint0_linear_2230_19237",
                        x1: "1.42208",
                        y1: "3.26391",
                        x2: "6.95471",
                        y2: "12.6234",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "#058F92"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#038489"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#026D71"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_2230_19237",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });





parcelRequire("42omo");

const $faf0963e4257f812$export$b33fb54b08bb6422 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.86632 0C4.98186 0.000652395 4.26606 0.716982 4.26671 1.59967C4.26606 2.48236 4.98251 3.19869 5.86697 3.19935H7.46723V1.60033C7.46789 0.717635 6.75143 0.00130479 5.86632 0C5.86697 0 5.86697 0 5.86632 0V0ZM5.86632 4.26667H1.60026C0.715805 4.26732 -0.000651915 4.98365 1.78649e-06 5.86634C-0.00130562 6.74903 0.715151 7.46536 1.59961 7.46666H5.86632C6.75078 7.46601 7.46723 6.74968 7.46658 5.86699C7.46723 4.98365 6.75078 4.26732 5.86632 4.26667Z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9999 5.86634C16.0005 4.98365 15.2841 4.26732 14.3996 4.26667C13.5151 4.26732 12.7987 4.98365 12.7993 5.86634V7.46667H14.3996C15.2841 7.46601 16.0005 6.74968 15.9999 5.86634ZM11.7331 5.86634V1.59967C11.7338 0.717635 11.018 0.00130479 10.1335 0C9.24907 0.000652395 8.53261 0.716983 8.53327 1.59967V5.86634C8.53196 6.74903 9.24842 7.46536 10.1329 7.46667C11.0173 7.46601 11.7338 6.74968 11.7331 5.86634Z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.133 15.9998C11.0174 15.9992 11.7339 15.2829 11.7333 14.4002C11.7339 13.5175 11.0174 12.8011 10.133 12.8005H8.53272V14.4002C8.53206 15.2822 9.24852 15.9985 10.133 15.9998ZM10.133 11.7325H14.3997C15.2842 11.7319 16.0006 11.0155 16 10.1328C16.0013 9.25014 15.2848 8.53381 14.4004 8.5325H10.1336C9.24917 8.53315 8.53272 9.24949 8.53337 10.1322C8.53272 11.0155 9.24852 11.7319 10.133 11.7325Z",
                fill: "#ECB22E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.000122517 10.1334C-0.000531185 11.0161 0.715927 11.7325 1.60039 11.7331C2.48485 11.7325 3.2013 11.0161 3.20065 10.1334V8.53375H1.60039C0.715927 8.5344 -0.000531185 9.25074 0.000122517 10.1334ZM4.26684 10.1334V14.4001C4.26553 15.2828 4.98199 15.9991 5.86645 16.0004C6.75091 15.9998 7.46737 15.2835 7.46672 14.4008V10.1347C7.46802 9.25204 6.75156 8.53571 5.86711 8.5344C4.98199 8.5344 4.26619 9.25074 4.26684 10.1334C4.26684 10.1341 4.26684 10.1334 4.26684 10.1334Z",
                fill: "#E01E5A"
            })
        ]
    });





const $e12b9f2b99596e0f$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    zero_query_collaborator_profile_suggestion: {
        id: "search_dialog_zero_query_collaborator_profile_suggestion",
        defaultMessage: "{personAvatar} {name}'s profile"
    },
    zero_query_confluence_pages_created_30_days_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_30_days_suggestion",
        defaultMessage: "{productIcon} Confluence pages I created in the {dateIcon} last 30 days"
    },
    zero_query_confluence_pages_created_7_days_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_7_days_suggestion",
        defaultMessage: "{productIcon} Confluence pages I created in the {dateIcon} last 7 days"
    },
    zero_query_confluence_pages_created_collaborator_7_days_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_collaborator_7_days_suggestion",
        defaultMessage: "{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 7 days"
    },
    zero_query_confluence_pages_created_collaborator_last_30_days_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_collaborator_last_30_days_suggestion",
        defaultMessage: "{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 30 days"
    },
    zero_query_confluence_pages_created_collaborator_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_collaborator_suggestion",
        defaultMessage: "{productIcon} Confluence pages created by {personAvatar} {name}"
    },
    zero_query_confluence_pages_created_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_suggestion",
        defaultMessage: "{productIcon} Confluence pages I created"
    },
    zero_query_jira_my_work_items_suggestion: {
        id: "search_dialog_zero_query_jira_my_work_items_suggestion",
        defaultMessage: "Show my {productIcon} work items"
    },
    zero_query_jira_nlq_collaborator_suggestion: {
        id: "search_dialog_zero_query_jira_nlq_collaborator_suggestion",
        defaultMessage: "Recent open items assigned to {name}"
    },
    zero_query_jira_nlq_issues_assigned_to_me_in_the_past_7_days_suggestion: {
        id: "search_dialog_zero_query_issues_assigned_to_me_in_the_past_7_days_suggestion",
        defaultMessage: "Issues assigned to me in the past 7 days"
    },
    zero_query_jira_nlq_issues_i_created_in_the_last_month_suggestion: {
        id: "search_dialog_zero_query_issues_i_created_in_the_last_month_suggestion",
        defaultMessage: "Issues I created in the last month"
    },
    zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion: {
        id: "search_dialog_zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion",
        defaultMessage: "Progress for epics created by me"
    },
    zero_query_jira_nlq_recent_tickets_created_by_me_suggestion: {
        id: "search_dialog_zero_query_recent_tickets_created_by_me_suggestion",
        defaultMessage: "Recent tickets created by me"
    },
    zero_query_jira_nlq_show_all_the_bugs_assigned_to_me_suggestion: {
        id: "search_dialog_zero_query_show_all_the_bugs_assigned_to_me_suggestion",
        defaultMessage: "Show all the bugs assigned to me"
    },
    zero_query_jira_nlq_show_high_priority_tickets_assigned_to_me_suggestion: {
        id: "search_dialog_zero_query_show_high_priority_tickets_assigned_to_me_suggestion",
        defaultMessage: "Show high priority tickets assigned to me"
    },
    zero_query_jira_nlq_show_me_all_of_my_in_progress_work_items_suggestion: {
        id: "search_dialog_zero_query_show_me_all_of_my_in_progress_work_items_suggestion",
        defaultMessage: "Show me all of my in-progress work items"
    },
    zero_query_jira_nlq_show_tickets_due_this_week_suggestion: {
        id: "search_dialog_zero_query_show_tickets_due_this_week_suggestion",
        defaultMessage: "Show tickets due this week"
    },
    zero_query_jira_nlq_what_are_my_open_tickets_suggestion: {
        id: "search_dialog_zero_query_what_are_my_open_tickets_suggestion",
        defaultMessage: "What are my open tickets?"
    },
    zero_query_jira_tickets_assigned_suggestion: {
        id: "search_dialog_zero_query_jira_tickets_assigned_suggestion",
        defaultMessage: "{productIcon} Jira tickets assigned to me"
    },
    zero_query_jira_tickets_assigned_collaborator_suggestion: {
        id: "search_dialog_zero_query_jira_tickets_assigned_collaborator_suggestion",
        defaultMessage: "{productIcon} tickets assigned to {personAvatar} {name}"
    },
    zero_query_jira_tickets_created_collaborator_suggestion: {
        id: "search_dialog_zero_query_jira_tickets_created_collaborator_suggestion",
        defaultMessage: "{productIcon} Jira tickets created by {personAvatar} {name}"
    },
    zero_query_jira_tickets_created_suggestion: {
        id: "search_dialog_zero_query_jira_tickets_created_suggestion",
        defaultMessage: "{productIcon} Jira tickets I created"
    },
    zero_query_third_party_google_collaborator_docs_suggestion: {
        id: "search_dialog_zero_query_third_party_google_collaborator_docs_suggestion",
        defaultMessage: "{productIcon} Google docs from {personAvatar} {name}"
    },
    zero_query_third_party_google_my_docs_suggestion: {
        id: "search_dialog_zero_query_third_party_google_my_docs_suggestion",
        defaultMessage: "My {productIcon} Google Drive docs"
    },
    zero_query_third_party_sharepoint_collaborator_docs_suggestion: {
        id: "search_dialog_zero_query_third_party_sharepoint_collaborator_docs_suggestion",
        defaultMessage: "{productIcon} SharePoint docs from {personAvatar} {name}"
    },
    zero_query_third_party_sharepoint_my_docs_suggestion: {
        id: "search_dialog_zero_query_third_party_sharepoint_my_docs_suggestion",
        defaultMessage: "My {productIcon} SharePoint documents"
    },
    zero_query_third_party_slack_collaborator_messages_suggestion: {
        id: "search_dialog_zero_query_third_party_slack_collaborator_messages_suggestion",
        defaultMessage: "{productIcon} Slack messages from {personAvatar} {name}"
    },
    zero_query_third_party_slack_my_messages_suggestion: {
        id: "search_dialog_zero_query_third_party_slack_my_messages_suggestion",
        defaultMessage: "My {productIcon} Slack messages"
    },
    zero_query_who_is_suggestion: {
        id: "search_dialog_zero_query_who_is_suggestion",
        defaultMessage: "Who is {name}?"
    }
});


const $679323a0f3b8af5f$var$styles = {
    icon3PContainer: "_1e0c116y"
};
const $679323a0f3b8af5f$var$get1PIcon = (product)=>()=>{
        let Icon = null;
        switch(product){
            case (0, $6FG5J.ZeroQueryProduct).CONFLUENCE:
                Icon = (0, $lAFHW.ConfluenceIcon);
                break;
            case (0, $6FG5J.ZeroQueryProduct).JIRA:
                Icon = (0, $lAFHW.JiraIcon);
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: "",
            size: "xsmall",
            shouldUseNewLogoDesign: true
        }, product);
    };
const $679323a0f3b8af5f$var$get3PIcon = (product)=>()=>{
        let Icon = null;
        switch(product){
            case (0, $6FG5J.ZeroQueryProduct).GOOGLE:
                Icon = (0, $dbf0ba150e688e75$export$e16bd899bb4eebf9);
                break;
            case (0, $6FG5J.ZeroQueryProduct).SHAREPOINT:
                Icon = (0, $df006fe490c0a4db$export$1c773608dea5140);
                break;
            case (0, $6FG5J.ZeroQueryProduct).SLACK:
                Icon = (0, $faf0963e4257f812$export$b33fb54b08bb6422);
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            "aria-hidden": true,
            testId: `${product.toLowerCase()}-icon`,
            xcss: $679323a0f3b8af5f$var$styles.icon3PContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {})
        }, `${product.toLowerCase()}-icon`);
    };
const $679323a0f3b8af5f$var$app1PIcons = {
    [(0, $6FG5J.ZeroQueryProduct).CONFLUENCE]: $679323a0f3b8af5f$var$get1PIcon((0, $6FG5J.ZeroQueryProduct).CONFLUENCE),
    [(0, $6FG5J.ZeroQueryProduct).JIRA]: $679323a0f3b8af5f$var$get1PIcon((0, $6FG5J.ZeroQueryProduct).JIRA)
}; // Note on non-null assertion operators: not all 3P configs have an `iconBorderless` property, but these are guaranteed
const $679323a0f3b8af5f$var$app3PIcons = {
    [(0, $6FG5J.ZeroQueryProduct).GOOGLE]: $679323a0f3b8af5f$var$get3PIcon((0, $6FG5J.ZeroQueryProduct).GOOGLE),
    [(0, $6FG5J.ZeroQueryProduct).SLACK]: $679323a0f3b8af5f$var$get3PIcon((0, $6FG5J.ZeroQueryProduct).SLACK),
    [(0, $6FG5J.ZeroQueryProduct).SHAREPOINT]: $679323a0f3b8af5f$var$get3PIcon((0, $6FG5J.ZeroQueryProduct).SHAREPOINT)
};
const $679323a0f3b8af5f$export$c80d9e8e7dfc062e = {
    ...$679323a0f3b8af5f$var$app1PIcons,
    ...$679323a0f3b8af5f$var$app3PIcons
}; // TODO: Remove this once BE sends purely structured data instead of a full result string
const $679323a0f3b8af5f$export$eb2fcf5da41deb74 = [
    {
        type: (0, $6FG5J.ZeroQueryType).COLLABORATOR_PROFILE,
        pattern: /:person: ([A-Za-z ]+)'s profile$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_collaborator_profile_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED,
        pattern: /:product: Confluence pages I created$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_30_DAYS,
        pattern: /:product: Confluence pages I created in the :date: last 30 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_30_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_7_DAYS,
        pattern: /:product: Confluence pages I created in the :date: last 7 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_7_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR,
        pattern: /:product: Confluence pages created by :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_collaborator_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS,
        pattern: /:product: Confluence pages created by :person: ([A-Za-z ]+) in the :date: last 30 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_collaborator_last_30_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS,
        pattern: /:product: Confluence pages created by :person: ([A-Za-z ]+) in the :date: last 7 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_collaborator_7_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_MY_WORK_ITEMS,
        pattern: /Show my :product: work items$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_my_work_items_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Recent tickets created by me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_recent_tickets_created_by_me_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /What are my open tickets\?$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_what_are_my_open_tickets_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Show tickets due this week$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_show_tickets_due_this_week_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Issues I created in the last month$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_issues_i_created_in_the_last_month_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Show high priority tickets assigned to me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_show_high_priority_tickets_assigned_to_me_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Show me all of my in-progress work items$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_show_me_all_of_my_in_progress_work_items_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Issues assigned to me in the past 7 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_issues_assigned_to_me_in_the_past_7_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Show all the bugs assigned to me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_show_all_the_bugs_assigned_to_me_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Progress for epics created by me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ_COLLABORATOR,
        pattern: /Recent open items assigned to ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_collaborator_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_ASSIGNED,
        pattern: /:product: Jira tickets assigned to me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_tickets_assigned_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_ASSIGNED_COLLABORATOR,
        pattern: /:product: tickets assigned to :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_tickets_assigned_collaborator_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_CREATED,
        pattern: /:product: Jira tickets I created$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_tickets_created_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_CREATED_COLLABORATOR,
        pattern: /:product: Jira tickets created by :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_tickets_created_collaborator_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
        pattern: /:product: Google docs from :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_google_collaborator_docs_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_MY_DOCS,
        pattern: /My :product: Google Drive docs$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_google_my_docs_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
        pattern: /:product: SharePoint docs from :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_sharepoint_collaborator_docs_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_MY_DOCS,
        pattern: /My :product: SharePoint documents$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_sharepoint_my_docs_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
        pattern: /:product: Slack messages from :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_slack_collaborator_messages_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_MY_MESSAGES,
        pattern: /My :product: Slack messages$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_slack_my_messages_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).WHO_IS,
        pattern: /Who is ([A-Za-z ]+)\?$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_who_is_suggestion
    }
];
const $679323a0f3b8af5f$export$4e6c5ddb3a43998e = (text)=>text // Replace :placeholder: with single space, handling surrounding whitespace
    .replace(/\s*:\w+:\s*/g, ' ') // Normalize multiple consecutive spaces
    .replace(/\s+/g, ' ') // Trim leading and trailing whitespace
    .replace(/^\s+|\s+$/g, '') // Remove spaces before punctuation
    .replace(/\s+([.,!?])/g, '$1');
const $679323a0f3b8af5f$var$productParamMap = {
    [(0, $6FG5J.ZeroQueryProduct).CONFLUENCE]: 'confluence',
    [(0, $6FG5J.ZeroQueryProduct).JIRA]: 'jira',
    [(0, $6FG5J.ZeroQueryProduct).GOOGLE]: 'google',
    [(0, $6FG5J.ZeroQueryProduct).SLACK]: 'slack',
    [(0, $6FG5J.ZeroQueryProduct).SHAREPOINT]: 'sharepoint'
};
const $679323a0f3b8af5f$var$dateRangeParamMap = {
    [(0, $6FG5J.ZeroQueryDateRange).TODAY]: 'today',
    [(0, $6FG5J.ZeroQueryDateRange).YESTERDAY]: 'yesterday',
    [(0, $6FG5J.ZeroQueryDateRange).PAST_7_DAYS]: 'past7Days',
    [(0, $6FG5J.ZeroQueryDateRange).PAST_30_DAYS]: 'past30Days'
};
const $679323a0f3b8af5f$export$8eefcdc4efd41f87 = (product, accountId, dateRange)=>({
        product: product ? $679323a0f3b8af5f$var$productParamMap[product] : undefined,
        contributors: accountId ? accountId : undefined,
        lastModified: dateRange ? $679323a0f3b8af5f$var$dateRangeParamMap[dateRange] : undefined
    });


const $50393a6d169f1c0b$var$HydratedZeroQueryTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ result: result, product: product, avatarUrl: avatarUrl, zeroQueryType: zeroQueryType })=>{
    const intl = (0, $8C5kA.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [operationalEventFired, setOperationalEventFired] = (0, $42omo.useState)(false);
    const ProductIcon = (0, $679323a0f3b8af5f$export$c80d9e8e7dfc062e)?.[product];
    const templateMatch = (0, $679323a0f3b8af5f$export$eb2fcf5da41deb74).find((template)=>result.match(template.pattern));
    if (templateMatch) {
        if (!operationalEventFired) {
            fireAnalyticsEvent((0, $342b4005aadcc963$export$41d82c6d8a0a3ca8)({
                success: true,
                attributes: {
                    ...commonAttributes,
                    zeroQueryType: zeroQueryType
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            setOperationalEventFired(true);
        }
    } else {
        if (!operationalEventFired) {
            fireAnalyticsEvent((0, $342b4005aadcc963$export$41d82c6d8a0a3ca8)({
                success: false,
                attributes: {
                    ...commonAttributes,
                    zeroQueryType: zeroQueryType,
                    reason: 'Pre-query hydration failed: No matching template'
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            setOperationalEventFired(true);
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050",
            children: (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(result)
        });
    }
    const name = templateMatch.pattern.exec(result)?.[1];
    const hydratedResult = intl.formatMessage(templateMatch.message, {
        dateIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
            label: ""
        }),
        name: name,
        personAvatar: avatarUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            label: "",
            size: "small",
            src: avatarUrl
        }) : undefined,
        productIcon: ProductIcon ? /*#__PURE__*/ (0, $l998X.jsx)(ProductIcon, {}) : undefined
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050",
        children: hydratedResult
    });
});
const $50393a6d169f1c0b$export$598f770f0380f1f5 = ({ result: result, product: product, avatarUrl: avatarUrl, state: state, zeroQueryType: zeroQueryType, zeroQueryPosition: zeroQueryPosition })=>{
    const intl = (0, $8C5kA.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const updateZeroQueries = (0, $4VmlX.useUpdateZeroQueries)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const zeroQueryIs3P = (0, $1d2671f5d43d8750$export$6da79ec281e5bbf3)(zeroQueryType);
    const zeroQueryVersion = (0, $1d2671f5d43d8750$export$2378e9e94d0e91e3)(zeroQueryType);
    const intentRouterEnabled = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false // Exposure is fired when a user calls the intent detection API
    })?.cohort === 'test';
    const logException = (0, $f8oYd.useLogException)();
    const analyticsEventActionSubjectId = (0, $6926da8980239f02$export$b6f8db3ad0711b02)(state);
    const workspaceId = primaryProduct && cloudId && analyticsAttributes?.activationId ? `ari:cloud:${primaryProduct}:${cloudId}:workspace/${analyticsAttributes.activationId}` : '';
    const atlAttributionHeaderValue = (0, $dh538.fg)('kd_zero_query_agg_atl_attribution_header') ? (0, $jwO5V.createAtlAttributionHeaderValue)({
        atlWorkspaceId: workspaceId,
        tenantId: cloudId || '',
        product: primaryProduct || ''
    }) : undefined;
    const onResultClicked = (0, $42omo.useCallback)((event)=>{
        const newTab = (0, $6926da8980239f02$export$b2c60dba9a3fd739)(event);
        if (!newTab) setQuickFindOpen(false);
        // Set the dialog referrer in sessionStorage
        // This will be used to identify when SearchAIDialog is rendered as a result of this click
        (0, $epS7s.setSessionItem)((0, $3R0ts.SEARCH_DIALOG_AI_DIALOG_REFERER_KEY), 'zeroQuery');
        // Move this zero query to the top of the recent list
        if (result && user && user.id && primaryProduct) {
            const zeroQueryResultText = (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(result);
            (0, $1SV4e.addRecentSearch)(zeroQueryResultText, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
            updateRecentQueries?.();
        }
        fireAnalyticsEvent((0, $875f1f3e3260f408$export$746fc217b00b3d82)({
            actionSubjectId: analyticsEventActionSubjectId,
            attributes: {
                ...commonAttributes,
                zeroQueryType: zeroQueryType,
                zeroQueryPosition: zeroQueryPosition,
                ...(0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(isHello) ? {
                    zeroQueryVersion: zeroQueryVersion,
                    is3PZeroQuery: zeroQueryIs3P
                } : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        const mutateFn = (0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(isHello) ? (0, $3e8764e0c86280c1$export$5ceed206e02a9ef) : (0, $3e8764e0c86280c1$export$123c86f509cbd0ab);
        mutateFn({
            input: {
                cloudId: cloudId || '',
                query: result,
                product: (0, $1yEFx.getUppercasePrimaryProductKey)(primaryProduct)
            }
        }, atlAttributionHeaderValue ? {
            'atl-attribution': atlAttributionHeaderValue
        } : {}).then((success)=>{
            if (success) updateZeroQueries?.();
        }).catch((error)=>{
            logException(error);
        });
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        result,
        setQuickFindOpen,
        analyticsEventActionSubjectId,
        user,
        cloudId,
        updateRecentQueries,
        updateZeroQueries,
        logException,
        zeroQueryType,
        zeroQueryPosition,
        zeroQueryVersion,
        zeroQueryIs3P,
        atlAttributionHeaderValue,
        isHello
    ]);
    const mapZeroQueryToSearchResult = (0, $42omo.useCallback)((query)=>{
        const strippedQuery = (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(query);
        const icon = (0, $dh538.fg)('qf_icons_recents_suggested') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
            label: "",
            size: "small",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                label: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query_icon_label),
                color: "currentColor"
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query_icon_label),
            color: "currentColor"
        });
        const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query)
        });
        const highlightedRightMetadata = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), {})
            ]
        });
        const url = generateSearchUrl({
            ...queryParams,
            text: strippedQuery,
            search_id: searchSessionId
        });
        return {
            id: query,
            icon: icon,
            title: strippedQuery,
            url: url,
            rightMetadata: rightMetadata,
            highlightedRightMetadata: highlightedRightMetadata
        };
    }, [
        intl,
        generateSearchUrl,
        queryParams,
        searchSessionId
    ]);
    const mapHydratedZeroQueryToSearchResult = (0, $42omo.useCallback)(({ result: result, product: product, avatarUrl: avatarUrl })=>{
        const icon = (0, $dh538.fg)('qf_icons_recents_suggested') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
            label: "",
            size: "small",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                label: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query_icon_label),
                color: "currentColor"
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query_icon_label),
            color: "currentColor"
        });
        const rightMetadata = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query)
        });
        // TODO: Uncomment once search quality improves with applied filters and structured queries
        // const zeroQueryParams = getZeroQueryParams(product, accountId, dateRange);
        const text = (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(result);
        const url = generateSearchUrl({
            text: // ...zeroQueryParams,
            text
        });
        const title = /*#__PURE__*/ (0, $l998X.jsx)($50393a6d169f1c0b$var$HydratedZeroQueryTitle, {
            avatarUrl: avatarUrl,
            product: product,
            result: result,
            zeroQueryType: zeroQueryType
        });
        return {
            icon: icon,
            title: title,
            url: url,
            rightMetadata: rightMetadata,
            isThirdParty: zeroQueryIs3P
        };
    }, [
        generateSearchUrl,
        intl,
        zeroQueryIs3P,
        zeroQueryType
    ]);
    if ((0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(isHello) || (0, $dh538.fg)('kd_v0_zero_query_shown_event')) // layer and fg checks are stable between renders and won't cause issues with hook calls
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useEffect)(()=>{
        if (quickFindOpen) fireAnalyticsEvent((0, $80931b93956c3e1c$export$a78be3e217bbe92c)({
            actionSubjectId: analyticsEventActionSubjectId,
            attributes: {
                ...commonAttributes,
                zeroQueryType: zeroQueryType,
                zeroQueryPosition: zeroQueryPosition,
                zeroQueryVersion: zeroQueryVersion,
                is3PZeroQuery: zeroQueryIs3P,
                ...intentRouterEnabled ? {
                    queryClassification: (0, $fa792d959dc8194b$export$928cec68d7595d16).value()?.mode,
                    modelId: (0, $fa792d959dc8194b$export$928cec68d7595d16).value()?.modelId
                } : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only need to run when quickFindOpen changes
    }, [
        quickFindOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2944de3e13791145$export$a2def421b23768aa), {
        resultType: "zeroQueries",
        ...(0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(isHello) ? mapHydratedZeroQueryToSearchResult({
            result: result,
            product: product,
            avatarUrl: avatarUrl
        }) : mapZeroQueryToSearchResult(result),
        onResultClicked: onResultClicked
    });
};


// Minimum query length for intent detection
const $71af45ffeeb47c72$var$MIN_QUERY_LENGTH = 2;
const $71af45ffeeb47c72$var$searchDialogStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    width: '100%'
});
const $71af45ffeeb47c72$var$searchDialogDefaultStyles = (0, $ecnYn.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)",
    marginTop: 'space.100'
});
const $71af45ffeeb47c72$var$searchDialogRefreshStyles = (0, $ecnYn.xcss)({
    borderRadius: "var(--ds-radius-large, 8px)",
    marginTop: 'space.050'
});
const $71af45ffeeb47c72$var$searchDialogWithIntentRouter = (0, $ecnYn.xcss)({
    top: 'space.0',
    marginTop: 'space.075',
    paddingTop: 'space.500',
    borderRadius: "var(--ds-radius-large, 8px)"
});
const $71af45ffeeb47c72$var$searchResultsSectionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.100',
    gap: 'space.025',
    overflowY: 'auto'
});
const $71af45ffeeb47c72$var$intentRouterBodyStyles = (0, $ecnYn.xcss)({
    paddingBlockEnd: 'space.100'
});
const $71af45ffeeb47c72$var$footerStyles = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $71af45ffeeb47c72$var$footerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    [(0, $bWLcG.media).above.lg]: {
        flexDirection: 'row'
    }
});
const $71af45ffeeb47c72$var$footerSpotlightTargetContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end'
});
const $71af45ffeeb47c72$var$footerSpotlightTargetContainerPaddingStyles = (0, $ecnYn.xcss)({
    marginInlineEnd: 'space.400',
    [(0, $bWLcG.media).above.lg]: {
        marginInlineEnd: 'unset',
        paddingBlockStart: 'space.1000'
    }
});
const $71af45ffeeb47c72$var$footerSpotlightTargetStyles = (0, $ecnYn.xcss)({
    marginBlockStart: 'space.negative.400',
    [(0, $bWLcG.media).above.lg]: {
        marginBlockStart: 'unset'
    }
});
const $71af45ffeeb47c72$var$defaultSearchResultsSectionHeightStyles = (0, $ecnYn.xcss)({
    // 86px for the QF footer + 48px for the page header + 86px bottom gap
    maxHeight: 'calc(100vh - 220px)'
});
const $71af45ffeeb47c72$var$jiraSearchResultsSectionHeightStyles = (0, $ecnYn.xcss)({
    // 167px for QF footer + 48px for the page header + 15% gap at the bottom
    maxHeight: 'calc(85vh - 215px)'
});
const $71af45ffeeb47c72$var$SearchResultsSectionWrapper = ({ children: children, primaryProduct: primaryProduct })=>{
    const useDefaultHeight = !(primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('search_qf_increase_issues_in_jira'));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            $71af45ffeeb47c72$var$searchResultsSectionStyles,
            useDefaultHeight ? $71af45ffeeb47c72$var$defaultSearchResultsSectionHeightStyles : $71af45ffeeb47c72$var$jiraSearchResultsSectionHeightStyles
        ],
        children: children
    });
};
const $71af45ffeeb47c72$export$2aadebb53f6015f6 = ({ dialogId: dialogId, dialogRef: dialogRef, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef, PlacementPO: PlacementPO, showFilters: showFilters = true, searchRefreshStyling: searchRefreshStyling = false, beforeContent: beforeContent })=>{
    const intl = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { retrySearch: retrySearch } = (0, $djVCD.useSearchActions)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const serveUserShardModel = (0, $j4ply.useUserShardModel)();
    const serveUserShardUI = (0, $j4ply.useUserShardUI)();
    const content = (0, $4VmlX.useContent)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const hasFiredExperimentExposure = (0, $42omo.useRef)(false);
    const productsWithSufficientUsage = (0, $eO6NY.useProductsWithEnoughUsageToShowBanner)({
        products: availableProducts,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const serveZeroQuery = (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence || primaryProduct === (0, $1yEFx.PrimaryProductKeys).Atlas || primaryProduct === (0, $1yEFx.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) && (0, $dh538.fg)('kd_zero_query_in_qf_fg') || primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira;
    const { intentRouterEnabled: intentRouterEnabled, suggestedAndRecentQueryLimit: suggestedAndRecentQueryLimit, hideFilterSuggestions: hideFilterSuggestions } = (0, $42omo.useMemo)(()=>{
        const serveJiraNINFpsNLQNavigationExp = (0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false // Exposure is fired when a user calls the intent detection API
        });
        return {
            intentRouterEnabled: serveJiraNINFpsNLQNavigationExp?.cohort === 'test',
            suggestedAndRecentQueryLimit: serveJiraNINFpsNLQNavigationExp?.uiFeatures.suggestedAndRecentQueryLimit ?? (0, $3R0ts.DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT),
            hideFilterSuggestions: serveJiraNINFpsNLQNavigationExp?.uiFeatures.hideFilterSuggestions ?? false
        };
    }, [
        primaryProduct
    ]);
    const allItems = $71af45ffeeb47c72$export$d88c04dcf9cd911b(content, serveUserShardUI, serveZeroQuery, suggestedAndRecentQueryLimit, hideFilterSuggestions, primaryProduct);
    $71af45ffeeb47c72$var$useResetSessionAnalytics();
    const { fireAnalyticsEvent: fireAnalyticsEvent, fireAnalyticsScreenEvent: fireAnalyticsScreenEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    $71af45ffeeb47c72$var$useAnalyticsEvents(fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes);
    const resultOnClick = (0, $6926da8980239f02$export$8a7aec9b1f72e063)();
    const resultOnContextMenu = (0, $6926da8980239f02$export$bc76edbc675e4404)();
    const resultOnHighlighted = (0, $6926da8980239f02$export$3f21dcaf9a5530d9)();
    const footerOnClick = (0, $6926da8980239f02$export$eb0ecd911360e8d4)();
    const queryFiltersBody = (0, $8215af3ea39f4647$export$385c746fbc3d50c5)({
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        inputRef: inputRef
    });
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    let hasThirdPartyResults = false;
    const localDialogRef = (0, $42omo.useRef)(null);
    (0, $86ob4.useWidthObserverRegistration)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID), localDialogRef);
    const { getNewlyConnectedProducts: getNewlyConnectedProducts } = (0, $dsrEB.useNewlyConnectedProducts)();
    (0, $42omo.useEffect)(()=>{
        (0, $2OtFZ.triggerExposureForEngagementTrackingImprovementsExperiment)();
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!hasFiredExperimentExposure.current && localQuery.length >= $71af45ffeeb47c72$var$MIN_QUERY_LENGTH && primaryProduct) {
            const exposureResult = (0, $26jni.serveJiraNINFpsNLQNavigation)({
                primaryProduct: primaryProduct,
                fireLayerExposure: true
            });
            if (exposureResult?.cohort) fireAnalyticsEvent((0, $da0a8f0656f9d4ba$export$d20fe15ea6549dcc)({
                attributes: {
                    ...commonAttributes,
                    searchSessionId: commonAttributes.searchSessionId || '',
                    cohort: exposureResult.cohort,
                    modelId: exposureResult.modelId,
                    queryLength: localQuery.length
                }
            }));
            hasFiredExperimentExposure.current = true;
        }
    }, [
        localQuery.length,
        primaryProduct,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const serveGithubLinksHydration = (0, $ci6Zg.serveGithubLinksHydrationWithoutExposure)();
    if (!content) return null;
    const swapQuickFindCTAs = (0, $1XDdH.isOnJiraFullPageSearch)() && primaryProduct && primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_search_fps_cta_swap');
    const { state: state } = content;
    const body = [];
    const intentRouterBody = [];
    let searchResultItemBody;
    for (const content of allItems){
        if ((0, $c778002e02670657$export$6500cdbd153f3497)(content)) body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $5e4b8c366d6ef407$export$42f84e610f279c31), {
            onRetry: retrySearch
        }, content.id));
        if ((0, $c778002e02670657$export$6dc914a1cb2e7113)(content)) body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $9ebd3fccc7b29e09$export$144e5acf8752ad4a), {}, content.id));
        if ((0, $c778002e02670657$export$993e95eb6704a94c)(content)) body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $c5e5408b5df96d67$export$373c6a9b01d625eb), {
            onRetry: retrySearch
        }, content.id));
        if ((0, $c778002e02670657$export$9050e45a166250f)(content)) body.push(// TODO: remove the eslint disablement when cleaning up rovo_qf_render_heading_as_h2
        // eslint-disable-next-line @atlassian/a11y/heading-has-content -- See https://go/a11y-heading-has-content for more details
        /*#__PURE__*/ (0, $l998X.jsx)((0, $5cfb43da7e344c6a$export$a8a3e93435678ff9), {
            id: content.id,
            text: content.data,
            includeInAnalytics: content.includeInAnalytics
        }, content.id));
        if ((0, $c778002e02670657$export$d680994c1f15882e)(content)) body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $191ce2f0a4d53c1e$export$dd3282b157ef6f7a), {}, content.id));
        if ((0, $c778002e02670657$export$871ba967042323cb)(content)) (intentRouterEnabled ? intentRouterBody : body).push(/*#__PURE__*/ (0, $l998X.jsx)((0, $8aeaf6643ef42bf9$export$de317f365b3e4c5c), {
            result: content.data,
            state: state
        }, content.id));
        if ((0, $c778002e02670657$export$57fb632bdb82e6e6)(content)) (intentRouterEnabled ? intentRouterBody : body).push(/*#__PURE__*/ (0, $l998X.jsx)((0, $d88ba3c49726615e$export$f919aeefffeb339a), {
            result: content.data,
            state: state
        }, content.id));
        if ((0, $c778002e02670657$export$329ac1434313f6b2)(content)) {
            const activity = /*#__PURE__*/ (0, $l998X.jsx)((0, $bfef7c7cb8b104c2$export$8d9137fcb112aeab), {
                result: content.data,
                state: state,
                onClick: resultOnClick,
                onContextMenu: resultOnContextMenu,
                onHighlighted: resultOnHighlighted,
                serveGithubLinksHydration: serveGithubLinksHydration
            }, content.id);
            if (serveUserShardUI) {
                if (!searchResultItemBody) {
                    searchResultItemBody = [];
                    body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Profiler), {
                        id: "QuickFindSearchDialogResults",
                        onRender: (_, phase, actualDuration)=>{
                            if (phase === 'mount' && localQuery.length) fireAnalyticsEvent((0, $71aa6db8e0b63681$export$ccb93b1cc213aa40)({
                                attributes: {
                                    ...commonAttributes,
                                    durationMs: actualDuration,
                                    hasThirdPartyResults: hasThirdPartyResults
                                },
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes
                            }));
                        },
                        children: searchResultItemBody
                    }));
                }
                searchResultItemBody.push(activity);
            } else body.push(activity);
        }
        if ((0, $c778002e02670657$export$a3a92d47cbabad1c)(content)) body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $69f29a2bcea28efa$export$5b3636afbb1882d3), {
            result: content.data,
            state: state,
            onClick: resultOnClick,
            onContextMenu: resultOnContextMenu,
            onHighlighted: resultOnHighlighted
        }, content.id));
        if ((0, $c778002e02670657$export$99edcb23f38a2d86)(content) && serveZeroQuery) (intentRouterEnabled ? intentRouterBody : body).push(/*#__PURE__*/ (0, $l998X.jsx)((0, $50393a6d169f1c0b$export$598f770f0380f1f5), {
            result: content.data,
            product: content.product,
            avatarUrl: content.avatarUrl,
            state: state,
            zeroQueryType: content.zeroQueryType,
            zeroQueryPosition: allItems.indexOf(content)
        }, content.id));
        if ((0, $c778002e02670657$export$35bb43147cd35a68)(content)) body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $aac51a5e41e61c0e$export$1ba589c44bc43c28), {
            result: content.data,
            state: state
        }, content.id));
        if ((0, $c778002e02670657$export$746233dd1618793c)(content)) {
            const productEntity = /*#__PURE__*/ (0, $l998X.jsx)((0, $0e1f91acee299cdf$export$c9f98fed0b66ba21), {
                result: content.data,
                state: state,
                onClick: resultOnClick,
                onContextMenu: resultOnContextMenu,
                onHighlighted: resultOnHighlighted
            }, content.id);
            if (serveUserShardModel) {
                if (!searchResultItemBody) {
                    searchResultItemBody = [];
                    body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Profiler), {
                        id: "QuickFindSearchDialogResults",
                        onRender: (_, phase, actualDuration)=>{
                            if (phase === 'mount' && localQuery.length) fireAnalyticsEvent((0, $71aa6db8e0b63681$export$ccb93b1cc213aa40)({
                                attributes: {
                                    ...commonAttributes,
                                    durationMs: actualDuration,
                                    hasThirdPartyResults: hasThirdPartyResults
                                },
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes
                            }));
                        },
                        children: searchResultItemBody
                    }));
                }
                searchResultItemBody.push(productEntity);
                if ((0, $7ZetK.isSearchResultGraphEntity)(content.data)) hasThirdPartyResults = true;
            } else body.push(productEntity);
        }
        if ((0, $c778002e02670657$export$bc8d42212d76a15c)(content)) body.push(/*#__PURE__*/ (0, $l998X.jsx)((0, $18e1948c3888bb1b$export$c84e51771b9ba67c), {
            result: content.data,
            state: state,
            onClick: resultOnClick,
            onContextMenu: resultOnContextMenu,
            onHighlighted: resultOnHighlighted
        }, content.id));
    }
    const footer = (()=>{
        // Post-query state with Confluence, Focus, or RovoExtension
        if ((primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence || primaryProduct === (0, $1yEFx.PrimaryProductKeys).Focus || primaryProduct === (0, $1yEFx.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) && (0, $7c0d6974c60a6f80$export$f33d0292f2f7a82a)(state)) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), {}),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $130bb7db5dbd93df$export$bf6cf7fe2100de5c), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $67539e0ab092f04e$export$e7b87342306a8337), {})
            ]
        });
        if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ad3c6b6b491bd60c$export$72bf2a5ecf09330e), {
                    state: state,
                    onClick: footerOnClick
                }),
                !intentRouterEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: swapQuickFindCTAs ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $130bb7db5dbd93df$export$bf6cf7fe2100de5c), {
                                state: state,
                                onClick: footerOnClick
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $e02869b185b9e3c4$export$104db48ac99dc257), {
                                state: state,
                                onClick: footerOnClick
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $e02869b185b9e3c4$export$104db48ac99dc257), {
                                state: state,
                                onClick: footerOnClick
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $130bb7db5dbd93df$export$bf6cf7fe2100de5c), {
                                state: state,
                                onClick: footerOnClick
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $67539e0ab092f04e$export$e7b87342306a8337), {})
            ]
        });
        // Pre-query footer
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), {}),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $130bb7db5dbd93df$export$bf6cf7fe2100de5c), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $67539e0ab092f04e$export$e7b87342306a8337), {})
            ]
        });
    })();
    const isAIEnabled = isRovoLLMEnabled || isAdminHubAIEnabled;
    const displayFilters = (0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct);
    const nonResultsBody = (0, $7c0d6974c60a6f80$export$8984dd36dcb68400)(state);
    const localQueryEmpty = localQuery.trim().length === 0;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $71af45ffeeb47c72$var$searchDialogStyles,
            // remove searchDialogRefreshStyles and searchDialogDefaultStyles when cleaning up intentRouterEnabled as it overrides them
            searchRefreshStyling ? $71af45ffeeb47c72$var$searchDialogRefreshStyles : $71af45ffeeb47c72$var$searchDialogDefaultStyles,
            intentRouterEnabled && $71af45ffeeb47c72$var$searchDialogWithIntentRouter
        ],
        "aria-label": intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).searchDialogAriaLabel),
        testId: 'search-dialog',
        ref: (0, $kIdP4.mergeRefs)(dialogRef, localDialogRef),
        id: dialogId,
        children: [
            beforeContent,
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $39181c35e6b4cafd$export$5643dbed0288c870), {
                allItems: allItems,
                children: [
                    intentRouterEnabled && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            !localQueryEmpty && /*#__PURE__*/ (0, $l998X.jsx)((0, $23cd74b8ba084de6$export$86cb87a743ba47f8), {
                                query: localQuery,
                                minQueryLength: $71af45ffeeb47c72$var$MIN_QUERY_LENGTH
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                                ...localQueryEmpty && intentRouterBody.length > 0 ? {
                                    role: 'list'
                                } : {},
                                space: "space.025",
                                xcss: $71af45ffeeb47c72$var$intentRouterBodyStyles,
                                children: intentRouterBody
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), {})
                        ]
                    }),
                    queryFiltersBody ? /*#__PURE__*/ (0, $l998X.jsx)($71af45ffeeb47c72$var$SearchResultsSectionWrapper, {
                        primaryProduct: primaryProduct,
                        children: queryFiltersBody
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)($71af45ffeeb47c72$var$SearchResultsSectionWrapper, {
                                primaryProduct: primaryProduct,
                                children: [
                                    primaryProduct === (0, $1yEFx.PrimaryProductKeys).Assets && !(0, $dh538.fg)('assets_rovo_search_all') && /*#__PURE__*/ (0, $l998X.jsx)((0, $0028c77a13fa2c26$export$d2e895abf2051d81), {}),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $19BAV.default), {
                                        requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                                        children: [
                                            (0, $7c0d6974c60a6f80$export$bbc0e9ab60a7c746)(state) && ((0, $2OtFZ.serve3PBulkConnectWithoutExposure)() ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                                                section: "QuickFindSearchDialogBulkConnectBanner",
                                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5Lref.BulkConnectBanner), {
                                                            thirdPartyConfigs: thirdPartyConfigs,
                                                            availableProducts: availableProducts,
                                                            getNewlyConnectedProducts: getNewlyConnectedProducts,
                                                            useIsBulkConnectModalOpenQuickFind: (0, $4VmlX.useIsBulkConnectModalOpen),
                                                            isOnSearchDialog: true,
                                                            fireAnalyticsScreenEvent: fireAnalyticsScreenEvent,
                                                            fireAnalyticsEvent: fireAnalyticsEvent,
                                                            commonAttributes: commonAttributes
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $NvPpA.BulkConnectModal), {
                                                            isOnSearchDialog: true,
                                                            oAuthSource: (0, $ckkm9.OAuthSource).quickFindBulkConnect
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                                                section: "QuickFindSearchDialogOAuthContainer",
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5OFf.OAuthContainer), {
                                                    isOnSearchDialog: true,
                                                    thirdPartyConfigs: thirdPartyConfigs,
                                                    availableProducts: availableProducts,
                                                    productsWithSufficientUsage: productsWithSufficientUsage,
                                                    isHello: isHello,
                                                    useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
                                                    fireAnalyticsEvent: fireAnalyticsEvent
                                                })
                                            })),
                                            $71af45ffeeb47c72$export$50d89b0bfbd161a1(state, isAIEnabled) && !serveZeroQuery && /*#__PURE__*/ (0, $l998X.jsx)((0, $238c7f3a77e6e665$export$4d99a070549a9300), {}),
                                            PlacementPO && /*#__PURE__*/ (0, $l998X.jsx)(PlacementPO, {}),
                                            (displayFilters || (0, $7c0d6974c60a6f80$export$f33d0292f2f7a82a)(state)) && showFilters && /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                                                direction: "column",
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b21d47feb05d9034$export$cc5615a202a2ea8c), {}),
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                        paddingInlineStart: "space.400",
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                            id: "spotlight-multi-step-on-trigger-step-1"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $7c0d6974c60a6f80$export$de6adf92470c6d4)(state) && /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                                        name: (0, $3R0ts.QUICK_FIND_LOADING_HOLD)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                                        ...!nonResultsBody ? {
                                            role: 'list'
                                        } : {},
                                        space: "space.025",
                                        children: body
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                                xcss: $71af45ffeeb47c72$var$footerContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                        xcss: $71af45ffeeb47c72$var$footerStyles,
                                        children: footer
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                        xcss: [
                                            $71af45ffeeb47c72$var$footerSpotlightTargetContainerStyles,
                                            !intentRouterEnabled && $71af45ffeeb47c72$var$footerSpotlightTargetContainerPaddingStyles
                                        ],
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                            xcss: $71af45ffeeb47c72$var$footerSpotlightTargetStyles,
                                            id: "spotlight-multi-step-on-trigger-step-2"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $71af45ffeeb47c72$var$setRecentActivityCount = (filteredActivities)=>{
    if ((0, $dh538.fg)('kd_recent_activity_intent')) (0, $6CITI.localStore).setString('recent-activity-count', filteredActivities.length.toString());
};
const $71af45ffeeb47c72$var$getJiraSuggestionsAndRecentQueries = ({ recentQueries: inputRecentQueries, zeroQueries: inputZeroQueries })=>{
    const suggestionsAndRecentQueries = [];
    const zeroQueries = inputZeroQueries.slice(0, 1);
    const dedupedRecentQueries = inputRecentQueries.filter((recentQuery)=>!zeroQueries.map((q)=>q.data).includes(recentQuery.data)).slice(0, 1);
    if (zeroQueries.length > 0 && dedupedRecentQueries.length > 0) {
        suggestionsAndRecentQueries.push(...zeroQueries);
        suggestionsAndRecentQueries.push(...dedupedRecentQueries);
    } else if (zeroQueries.length > 0) // show up to 2 zero queries if no deduped recent queries
    suggestionsAndRecentQueries.push(...inputZeroQueries.slice(0, 2));
    else if (dedupedRecentQueries.length > 0) // show up to 2 recent queries if no zero queries
    suggestionsAndRecentQueries.push(...inputRecentQueries.slice(0, 2));
    return suggestionsAndRecentQueries;
};
const $71af45ffeeb47c72$export$d88c04dcf9cd911b = (content, serveUserShardUI, serveZeroQuery, suggestedAndRecentQueryLimit, hideFilterSuggestions, primaryProduct)=>{
    const intl = (0, $8C5kA.default)();
    const { onSearchResultsShown: onSearchResultsShown, handleRecentActivitiesCallback: handleRecentActivitiesCallback } = (0, $64cc6bbe82568b51$export$dfe8038ae9bc34d2)();
    const serveFilterSuggestion = (0, $2OtFZ.serveQFFilterSuggestionExperiment)(primaryProduct, {
        fireLayerExposure: false
    });
    const userRelevantDocumentsEnabled = (0, $42omo.useMemo)(()=>{
        return !serveUserShardUI && primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence && (0, $dh538.fg)('quick_find_user_documents');
    }, [
        primaryProduct,
        serveUserShardUI
    ]);
    const serve3PBoosting = (0, $42omo.useMemo)(()=>{
        return userRelevantDocumentsEnabled && (0, $2OtFZ.serveQuickFind3PBoostingExperiment)({
            fireExperimentExposure: true
        });
    }, [
        userRelevantDocumentsEnabled
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!content) return [];
        const { state: state } = content;
        const items = [];
        const recentsHeadingItem = {
            id: 'recent-activities',
            type: 'heading',
            data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).recentsHeading)
        };
        const recommendationsHeadingItem = {
            id: 'recent-activities',
            type: 'heading',
            data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).recommendationsHeading)
        };
        const headingItem = userRelevantDocumentsEnabled ? recommendationsHeadingItem : recentsHeadingItem;
        const searchResultsHeadingItem = {
            id: 'search-results',
            type: 'heading',
            data: intl.formatMessage(serveUserShardUI ? (0, $3f03f084e86b29e6$export$defe85febe8b728c).userShardHeading : (0, $3f03f084e86b29e6$export$defe85febe8b728c).searchResultsHeading)
        };
        let filteredRecentActivities = [];
        if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_ERROR) items.push({
            id: 'error',
            type: 'error'
        });
        if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_LOADING) {
            items.push(...content.recentQueries.slice(0, 3));
            items.push(headingItem);
            for(let i = 0; i < 7; i++)items.push({
                id: `skeleton-${i}`,
                type: 'skeleton'
            });
        }
        if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_NO_RESULTS) items.push({
            id: 'landing',
            type: 'landing'
        });
        if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_RESULTS) {
            let zeroQueriesCount = Number(suggestedAndRecentQueryLimit);
            if (serveFilterSuggestion && !hideFilterSuggestions && content.filterSuggestions.length > 0) {
                // filter suggestion replaces one of the zero queries
                zeroQueriesCount = Math.max(0, suggestedAndRecentQueryLimit - 1);
                items.push(...content.filterSuggestions);
            }
            if (serveZeroQuery) {
                const visibleZeroQueries = content.zeroQueries.slice(0, zeroQueriesCount);
                // Only show recent queries if suggestedAndRecentQueryLimit > 0
                let dedupedVisibleRecentQueries = [];
                if (suggestedAndRecentQueryLimit > 0) dedupedVisibleRecentQueries = content.recentQueries.filter((query)=>!visibleZeroQueries.some((zeroQuery)=>zeroQuery.data === query.data)).slice(0, 1); // Always show up to 1 recent query when zero queries are shown
                items.push(...visibleZeroQueries);
                items.push(...dedupedVisibleRecentQueries);
            } else // When zero queries are not served, show 3 recent queries
            items.push(...content.recentQueries.slice(0, 3));
            if (userRelevantDocumentsEnabled) {
                if (content.userDocuments.length + content.recentActivities.length > 0) {
                    items.push(recommendationsHeadingItem);
                    const filteredUserDocuments = content.userDocuments.slice(0, 4);
                    const dedupedRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).filter((recentlyViewedResult)=>{
                        const isDuplicate = filteredUserDocuments.some((userDocument)=>{
                            const activityObject = recentlyViewedResult.data.node.object;
                            const id = (0, $hWR4v.isGraphActivity)(activityObject) ? activityObject.data?.id : recentlyViewedResult.id;
                            return id === userDocument.id;
                        });
                        return !isDuplicate;
                    });
                    const remainingSlots = 7 - filteredUserDocuments.length;
                    if (serve3PBoosting) filteredRecentActivities = (0, $2d65b64d3d4cb16d$export$dca164322a50872a)(dedupedRecentActivities, remainingSlots);
                    else filteredRecentActivities = dedupedRecentActivities.slice(0, remainingSlots);
                    items.push(...filteredUserDocuments);
                    items.push(...filteredRecentActivities);
                }
            } else if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 7);
                items.push(...filteredRecentActivities);
            }
            $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
        }
        if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_ERROR) items.push({
            id: 'error',
            type: 'error'
        });
        if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_LOADING) {
            if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) items.push(...$71af45ffeeb47c72$var$getJiraSuggestionsAndRecentQueries({
                recentQueries: content.recentQueries,
                zeroQueries: content.zeroQueries
            }));
            if (userRelevantDocumentsEnabled) {
                if (content.userDocuments.length + content.recentActivities.length > 0) {
                    items.push(recentsHeadingItem);
                    const filteredUserDocuments = content.userDocuments.slice(0, 5);
                    filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).filter((recentlyViewedResult)=>{
                        const isDuplicate = filteredUserDocuments.some((userDocument)=>{
                            const activityObject = recentlyViewedResult.data.node.object;
                            const id = (0, $hWR4v.isGraphActivity)(activityObject) ? activityObject.data?.id : recentlyViewedResult.id;
                            return id === userDocument.id;
                        });
                        return !isDuplicate;
                    }).slice(0, 5 - filteredUserDocuments.length);
                    items.push(...filteredUserDocuments);
                    items.push(...filteredRecentActivities);
                }
            } else if (!serveUserShardUI && content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 5);
                items.push(...filteredRecentActivities);
            }
            $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
            items.push({
                ...searchResultsHeadingItem,
                includeInAnalytics: false
            });
            const numberOfSkeletons = primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('search_qf_increase_issues_in_jira') ? 10 : 5;
            for(let i = 0; i < numberOfSkeletons; i++)items.push({
                id: `skeleton-${i}`,
                type: 'skeleton'
            });
        }
        if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_NO_RESULTS) items.push({
            id: 'no-results',
            type: 'no-results'
        });
        if (state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_RESULTS) {
            if ('autocompleteSuggestions' in content && Array.isArray(content.autocompleteSuggestions) && (0, $dh538.fg)('fe_quickfind_autocomplete_suggestions')) {
                const autocompleteSuggestions = content.autocompleteSuggestions;
                if (autocompleteSuggestions.length > 0) {
                    const autocompleteSuggestionsHeadingItem = {
                        id: 'autocomplete-suggestions',
                        type: 'heading',
                        data: 'Autocomplete suggestions',
                        includeInAnalytics: false
                    };
                    items.push(autocompleteSuggestionsHeadingItem);
                    autocompleteSuggestions.slice(0, 3).forEach((suggestion, index)=>{
                        items.push({
                            id: `autocomplete-suggestion-${index}`,
                            type: 'autocomplete-suggestion',
                            data: suggestion.data
                        });
                    });
                }
            }
            if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) items.push(...$71af45ffeeb47c72$var$getJiraSuggestionsAndRecentQueries({
                recentQueries: content.recentQueries,
                zeroQueries: content.zeroQueries
            }));
            filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 5);
            const filteredUserDocuments = content.userDocuments.slice(0, 5);
            if (userRelevantDocumentsEnabled) {
                if (content.userDocuments.length + content.recentActivities.length > 0) {
                    items.push(recentsHeadingItem);
                    filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).filter((recentlyViewedResult)=>{
                        const isDuplicate = filteredUserDocuments.some((userDocument)=>{
                            const activityObject = recentlyViewedResult.data.node.object;
                            const id = (0, $hWR4v.isGraphActivity)(activityObject) ? activityObject.data?.id : recentlyViewedResult.id;
                            return id === userDocument.id;
                        });
                        return !isDuplicate;
                    }).slice(0, 5 - filteredUserDocuments.length);
                    items.push(...filteredUserDocuments);
                    items.push(...filteredRecentActivities);
                }
            } else if (!serveUserShardUI) {
                if (filteredRecentActivities.length > 0) {
                    items.push(recentsHeadingItem);
                    items.push(...filteredRecentActivities);
                }
            }
            if (!serveUserShardUI) $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
            let uniqueMatchedRecentActivities = [];
            let dedupedSearchResults = [];
            const seenIds = new Set();
            if (serveUserShardUI) {
                uniqueMatchedRecentActivities = filteredRecentActivities.filter((activity)=>{
                    const activityId = (0, $hWR4v.isGraphActivity)(activity.data.node.object) ? activity.data.node.object.data?.id : activity.id;
                    const isInSearchResults = content.searchResults.some((searchResult)=>searchResult.id === activityId);
                    return !isInSearchResults;
                }).slice(0, 3);
                dedupedSearchResults = content.searchResults.filter((searchResult)=>{
                    const isDuplicatedResult = seenIds.has(searchResult.id);
                    if (!isDuplicatedResult) seenIds.add(searchResult.id);
                    return searchResult.id && !isDuplicatedResult;
                });
            } else dedupedSearchResults = content.searchResults.filter((searchResult)=>{
                const isInRecentActivities = filteredRecentActivities.some((recentlyViewedResult)=>{
                    const activityObject = recentlyViewedResult.data.node.object;
                    const id = (0, $hWR4v.isGraphActivity)(activityObject) ? activityObject.data?.id : recentlyViewedResult.id;
                    return id === searchResult.id;
                });
                const isInUserDocuments = filteredUserDocuments.some((userDocument)=>userDocument.id === searchResult.id);
                const isDuplicateResult = seenIds.has(searchResult.id);
                if (!isDuplicateResult) seenIds.add(searchResult.id);
                return searchResult.id && !isInRecentActivities && !isDuplicateResult && !isInUserDocuments;
            });
            onSearchResultsShown(dedupedSearchResults);
            // The way product entities are shown depend on the primary product
            if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence) {
                const confluenceSpaceResult = dedupedSearchResults.find((result)=>(0, $4TTdD.isSearchConfluenceSpace)(result.data));
                const showSearchResultsSection = Boolean(dedupedSearchResults.length + content.peopleAndTeams.length + uniqueMatchedRecentActivities.length);
                if (showSearchResultsSection) {
                    items.push(searchResultsHeadingItem);
                    const filteredSearchResults = dedupedSearchResults.filter((result)=>!(0, $4TTdD.isSearchConfluenceSpace)(result.data));
                    if (serveUserShardUI) {
                        const fusionResults = [];
                        fusionResults.push(...uniqueMatchedRecentActivities.map((activity)=>({
                                item: activity,
                                timestamp: Date.parse(activity.data.node.event.timestamp)
                            })));
                        const maxSearchResultCount = (confluenceSpaceResult ? 10 : 11) - uniqueMatchedRecentActivities.length;
                        fusionResults.push(...filteredSearchResults.slice(0, maxSearchResultCount).map((result)=>({
                                item: result,
                                timestamp: result.data.latestUserActionTs ? Date.parse(result.data.latestUserActionTs) : 0
                            })));
                        fusionResults.sort((a, b)=>b.timestamp - a.timestamp);
                        items.push(...fusionResults.map((itemWithTimestamp)=>itemWithTimestamp.item));
                    } else items.push(...filteredSearchResults.slice(0, confluenceSpaceResult ? 5 : 6));
                    confluenceSpaceResult && items.push(confluenceSpaceResult);
                    items.push(...content.peopleAndTeams.slice(0, 2));
                    items.push(...content.recentQueries.slice(0, 1));
                }
            } else if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) {
                const showSearchResultsSection = Boolean(dedupedSearchResults.length);
                if (showSearchResultsSection) {
                    const issueResults = dedupedSearchResults.filter((result)=>(0, $8LSUr.isSearchResultJiraIssue)(result.data));
                    const nonIssueResults = dedupedSearchResults.filter((result)=>!(0, $8LSUr.isSearchResultJiraIssue)(result.data));
                    const numberOfJiraIssues = (0, $dh538.fg)('search_qf_increase_issues_in_jira') ? 10 : 5;
                    items.push(searchResultsHeadingItem);
                    items.push(...issueResults.slice(0, numberOfJiraIssues));
                    items.push(...nonIssueResults.slice(0, 3));
                }
            } else {
                const showSearchResultsSection = Boolean(dedupedSearchResults.length + content.peopleAndTeams.length);
                if (showSearchResultsSection) {
                    items.push(searchResultsHeadingItem);
                    items.push(...dedupedSearchResults.slice(0, 6));
                    items.push(...content.peopleAndTeams.slice(0, 2));
                    items.push(...content.recentQueries.slice(0, 1));
                }
            }
        }
        /* We don't want to interrupt the handleRecentActivitiesCallback with POSTQUERY_RESULTS
     * as it's already handled in POSTQUERY_LOADING'
     */ if (state !== (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_RESULTS) handleRecentActivitiesCallback(state, filteredRecentActivities);
        return items;
    }, [
        content,
        intl,
        userRelevantDocumentsEnabled,
        serveUserShardUI,
        suggestedAndRecentQueryLimit,
        hideFilterSuggestions,
        serveFilterSuggestion,
        serveZeroQuery,
        serve3PBoosting,
        primaryProduct,
        onSearchResultsShown,
        handleRecentActivitiesCallback
    ]);
};
const $71af45ffeeb47c72$var$useAnalyticsEvents = (fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes)=>{
    const { abortTask: abortTask, isTaskActive: isTaskActive } = (0, $269ee6c4b9937e56$export$5b6291bff520e069)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $de62c0fb6467b42a$export$39e1d377a6a3de5d)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        return ()=>{
            fireAnalyticsEvent((0, $57230a101297e6c3$export$bcff6baaecbbc96)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            // Fire VitalStats taskAbort if a task is active when dialog is dismissed
            // Note: abortTask handles deferring the analytics event internally
            if (isTaskActive()) abortTask('dialog_closed_during_network');
        };
    // Only want these events to fire when the dialog opens and closes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $71af45ffeeb47c72$var$useResetSessionAnalytics = ()=>{
    const refreshSearchSessionId = (0, $j4ply.useRefreshSearchSessionId)();
    const { resetQueryVersion: resetQueryVersion } = (0, $djVCD.useSearchActions)();
    (0, $42omo.useEffect)(()=>{
        refreshSearchSessionId();
        resetQueryVersion();
    }, [
        refreshSearchSessionId,
        resetQueryVersion
    ]);
};
const $71af45ffeeb47c72$export$50d89b0bfbd161a1 = (state, isAIEnabled = false)=>{
    const isCorrectState = (0, $7c0d6974c60a6f80$export$bbc0e9ab60a7c746)(state) || (0, $7c0d6974c60a6f80$export$3d387094581134ab)(state);
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return isCorrectState && isAIEnabled;
    return isCorrectState;
};






const $ea5066efa7331a88$export$9310e79b116dbbca = ()=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            (0, $fa792d959dc8194b$export$928cec68d7595d16).dispose();
        };
    }, []);
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $chO1Z = parcelRequire("chO1Z");









var $fVUfS = parcelRequire("fVUfS");



























parcelRequire("42omo");











var $gXn1S = parcelRequire("gXn1S");


var $5iakG = parcelRequire("5iakG");


var $2Znam = parcelRequire("2Znam");





var $3dgQu = parcelRequire("3dgQu");





var $1xk5k = parcelRequire("1xk5k");













const $b6d7a903a92ed23b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    type: {
        id: "quick-find.filters.names.type",
        defaultMessage: "Type"
    },
    filterTypePlaceholder: {
        id: "quick-find.filter.type.placeholder",
        defaultMessage: "Find type"
    },
    filterLabelSelected: {
        id: "quick-find.filter.type.label.selected",
        defaultMessage: "Selected"
    },
    filterLabelUnselected: {
        id: "quick-find.filter.type.label.unselected",
        defaultMessage: "Available"
    }
});


const $a2107b05e31d2daf$var$getOptionsToProducts = (typeMapping)=>{
    const optionsToProducts = {};
    (0, $2Znam.allTypeFilterValueKeys).forEach((type)=>{
        optionsToProducts[type] = typeMapping[type].products || [];
    });
    return optionsToProducts;
};
const $a2107b05e31d2daf$export$409b84e60ce4841e = ({ iconBefore: iconBefore, iconAfter: iconAfter, showPrimaryProductIcon: showPrimaryProductIcon })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const optionsToProducts = $a2107b05e31d2daf$var$getOptionsToProducts(typeMapping);
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useUniversalSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId),
        optionsToProducts: optionsToProducts
    });
    if (!filterData) return null;
    // Do not show TypeFilter for Atlas since that is handled by Noun filters
    if (productSelected === (0, $1yEFx.ProductKeys).Atlas) return null;
    const { options: options, lookupInput: lookupInput, selectedOptions: selectedOptions, isLoading: isLoading, isLookupDefined: isLookupDefined } = filterData;
    // Compute the label and badge values since useUniversalSelectFilter doesn't provide them
    const selectedOptionsCount = selectedOptions.length;
    const badgeLabel = selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined;
    const firstSelectedOptionLabel = selectedOptions.at(0)?.label;
    const getIconBefore = ()=>{
        if (iconBefore) return iconBefore;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), {
            children: [
                showPrimaryProductIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $3dgQu.FilterProductIcon), {
                    showPrimaryProductIcon: showPrimaryProductIcon,
                    primaryProduct: primaryProduct
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                    label: formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type)
                })
            ]
        });
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? iconAfter ? iconAfter : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
            appearance: "primary",
            children: badgeLabel
        });
    };
    const handleSetOption = (option)=>{
        setOption(option);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $5iakG.universalTypeFilterId),
        canClearFilter: true,
        checkboxIndicators: false,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: handleSetOption,
        options: options,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type),
        placeholder: formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).filterTypePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "quick-find-universal-type-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true,
                children: firstSelectedOptionLabel ? `${formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type)}: ${firstSelectedOptionLabel}` : formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type)
            }),
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};





parcelRequire("42omo");


const $b9b0457c9911360b$export$767d38fff643cac6 = ({ productConfig: productConfig, onAppFilterSelected: onAppFilterSelected, productKey: productKey })=>{
    const Icon = productConfig.IconBorderless ?? productConfig.Icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            size: 'xsmall'
        }),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        onClick: (event)=>{
            onAppFilterSelected(productKey, {
                redirectToFPS: true,
                isPostAuthAction: false
            }, event);
        },
        children: productConfig.displayName
    });
};





parcelRequire("42omo");


const $2d50858696eaf28c$export$42a563ec5acc14f9 = ({ productConfig: productConfig, userNeedsAuth: userNeedsAuth, triggerProps: triggerProps, onAppFilterSelected: onAppFilterSelected, productKey: productKey })=>{
    const Icon = productConfig.IconBorderless ?? productConfig.Icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
        ...triggerProps,
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            size: 'xsmall'
        }),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        gap: 'comfortable',
        onClick: (event)=>{
            if (!userNeedsAuth) onAppFilterSelected(productKey, {
                redirectToFPS: true,
                isPostAuthAction: false
            }, event);
        },
        children: productConfig.displayName
    });
};





parcelRequire("42omo");






















const $dff2b050324c4738$export$cca86f2b29004207 = ({ productKey: productKey, redirectToFPSWithProductSelected: redirectToFPSWithProductSelected, trigger: trigger })=>{
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const isSmartlink = (0, $def8z.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.useIsUserOAuthed)(productKey);
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    if (userNeedsOAuth) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "FiltersRowAppButtonFor3PAppsOAuthWrapper",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
            product: productKey,
            postAuthAction: ()=>{
                redirectToFPSWithProductSelected();
            },
            trigger: (triggerProps)=>trigger({
                    ...triggerProps,
                    userNeedsAuth: true
                }),
            isOnSearchDialog: false,
            isInline: true,
            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
            useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
            isSmartlink: isSmartlink,
            searchQuery: quickFindQuery,
            oAuthSource: (0, $ckkm9.OAuthSource).quickFindFilter,
            thirdPartyConfigs: thirdPartyConfigs
        }, productKey)
    });
    return trigger({
        userNeedsAuth: false
    });
};





const $e2c0e536b7fb0238$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    filterByIcon: {
        id: "search-filters.filter-by-icon",
        defaultMessage: "Filter by icon"
    },
    more: {
        id: "search_filters.more",
        defaultMessage: "more"
    },
    moreAppsSearchTooltip: {
        id: "search_filters.more-apps-search",
        defaultMessage: "Open full page search for this term searching all apps"
    },
    contributor: {
        id: "search-filters.names.contributor",
        defaultMessage: "Contributor"
    },
    type: {
        id: "search-filters.names.type",
        defaultMessage: "Type"
    }
});





parcelRequire("42omo");

const $17a1e71bd16703fa$export$1020a744a95a8f31 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "36",
        height: "20",
        viewBox: "0 0 36 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "4",
                fill: "var(--ds-surface)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.317703",
                y: "0.317703",
                width: "19.3646",
                height: "19.3646",
                rx: "3.6823",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.635405"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_62_73110)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M10.1403 10.8571C11.9899 10.8571 13.4892 9.32212 13.4892 7.42857C13.4892 5.53502 11.9899 4 10.1403 4C8.29083 4 6.7915 5.53502 6.7915 7.42857C6.7915 9.32212 8.29083 10.8571 10.1403 10.8571Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.9306 13.7142C14.626 13.7142 16.0004 12.3071 16.0004 10.5713C16.0004 8.83557 14.626 7.42847 12.9306 7.42847C11.2352 7.42847 9.86084 8.83557 9.86084 10.5713C9.86084 12.3071 11.2352 13.7142 12.9306 13.7142Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M10.5581 16C11.8682 16 12.9302 14.9127 12.9302 13.5714C12.9302 12.2301 11.8682 11.1428 10.5581 11.1428C9.24806 11.1428 8.18604 12.2301 8.18604 13.5714C8.18604 14.9127 9.24806 16 10.5581 16Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M10.698 7.09439V13.1915C10.6966 13.4034 10.5712 13.5937 10.3799 13.6744C10.3189 13.7008 10.2535 13.7144 10.1873 13.7144H8.18916C8.18637 13.6658 8.18637 13.6201 8.18637 13.5715C8.18544 13.5238 8.1873 13.4761 8.19195 13.4287C8.24303 12.5154 8.79258 11.7096 9.61242 11.3458V10.8144C7.78783 10.5184 6.5431 8.76406 6.83224 6.89603C6.83425 6.88309 6.83632 6.87016 6.83847 6.85725C6.85236 6.76089 6.87193 6.66547 6.89707 6.57153H10.1873C10.4689 6.57263 10.6969 6.80608 10.698 7.09439Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.90829 6.85693H6.83852C6.52842 8.7216 7.75348 10.4906 9.57477 10.8081C9.62992 10.8177 9.6853 10.8259 9.74085 10.8326C8.87573 11.2526 8.24531 12.4455 8.19173 13.4284C8.18709 13.4758 8.18522 13.5235 8.18615 13.5712C8.18615 13.6198 8.18615 13.6655 8.18894 13.7141C8.19397 13.8101 8.2061 13.9056 8.22521 13.9998H9.908C10.1149 13.9984 10.3008 13.87 10.3796 13.6741C10.4054 13.6117 10.4187 13.5447 10.4187 13.4769V7.37979C10.4176 7.09159 10.1898 6.85819 9.90829 6.85693Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.90827 6.85693H6.8385C6.52846 8.72177 7.75371 10.4908 9.57517 10.8083C9.61243 10.8148 9.64979 10.8206 9.68725 10.8258C8.85004 11.2761 8.24446 12.4661 8.19199 13.4284H9.90827C10.1894 13.4262 10.4168 13.1934 10.419 12.9055V7.37979C10.4179 7.09148 10.1899 6.85803 9.90827 6.85693Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.6291 6.85693H6.83841C6.54565 8.61736 7.62309 10.3127 9.31376 10.7518C8.67359 11.5006 8.28094 12.4374 8.1919 13.4284H9.62911C9.91071 13.4273 10.1387 13.1938 10.1398 12.9055V7.37979C10.1397 7.09109 9.91109 6.85709 9.6291 6.85693Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.51251 6.85693H9.62898C9.91149 6.85693 10.1405 7.09141 10.1405 7.38065V12.6189C10.1405 12.9082 9.91149 13.1426 9.62898 13.1426H4.51251C4.23 13.1426 4.00098 12.9082 4.00098 12.6189V7.38065C4.00098 7.09141 4.23 6.85693 4.51251 6.85693Z",
                        fill: "url(#paint0_linear_62_73110)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M6.28515 9.93598C6.16527 9.85457 6.06514 9.74619 5.9924 9.61912C5.92192 9.48628 5.8868 9.33681 5.89054 9.18569C5.88426 8.98108 5.9517 8.78125 6.08002 8.62426C6.21487 8.46708 6.38917 8.35068 6.58402 8.28769C6.8061 8.21285 7.03871 8.17598 7.27249 8.17855C7.57992 8.16705 7.88693 8.21106 8.17946 8.30855V8.96569C8.05236 8.88686 7.91392 8.82901 7.76923 8.79427C7.61224 8.75485 7.45115 8.73509 7.28951 8.73541C7.11906 8.729 6.94969 8.7657 6.79639 8.84227C6.67804 8.89453 6.60129 9.01374 6.60105 9.14569C6.60056 9.22574 6.6306 9.30282 6.68477 9.36055C6.74874 9.42861 6.82442 9.48401 6.90802 9.52398C7.00105 9.57141 7.14058 9.63446 7.32663 9.71313C7.34711 9.71976 7.36708 9.72797 7.38635 9.7377C7.56946 9.81097 7.7461 9.90015 7.91435 10.0043C8.04176 10.0847 8.1487 10.195 8.22635 10.326C8.30597 10.4745 8.34456 10.6424 8.33798 10.8117C8.34707 11.0218 8.28429 11.2285 8.16049 11.3963C8.03709 11.5505 7.8721 11.6642 7.68607 11.7231C7.46726 11.7933 7.23889 11.8273 7.0096 11.8237C6.80389 11.8247 6.59848 11.8074 6.39565 11.7723C6.22439 11.7436 6.05726 11.6933 5.89807 11.6226V10.9297C6.05024 11.041 6.22024 11.1241 6.4004 11.1754C6.57995 11.2327 6.76659 11.2633 6.95463 11.2663C7.12867 11.2776 7.3024 11.2398 7.45696 11.1571C7.56523 11.0946 7.63108 10.9761 7.62831 10.8488C7.62903 10.7603 7.59482 10.6752 7.53343 10.6128C7.45708 10.5361 7.36868 10.473 7.27194 10.4263C7.16031 10.3691 6.99594 10.2938 6.77882 10.2003C6.6061 10.1292 6.44072 10.0406 6.28515 9.93598Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "16",
                width: "20",
                height: "20",
                rx: "4",
                fill: "var(--ds-surface)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "16.3125",
                y: "0.3125",
                width: "19.375",
                height: "19.375",
                rx: "3.6875",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.625"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M21.6286 5.45074L27.4097 5.02374C28.1199 4.96283 28.3023 5.00389 28.7488 5.3285L30.5942 6.62852C30.8986 6.8521 30.9999 6.91301 30.9999 7.15644V14.2863C30.9999 14.7332 30.8376 14.9975 30.2696 15.0378L23.5563 15.4445C23.13 15.4646 22.927 15.4037 22.7037 15.1192L21.3448 13.3521C21.101 13.0269 21 12.7834 21 12.4988V6.16119C21 5.79583 21.1623 5.49117 21.6286 5.45074Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.4097 5.02384L21.6286 5.45084C21.1623 5.49117 21 5.79593 21 6.16119V12.4988C21 12.7833 21.101 13.0267 21.3448 13.3521L22.7037 15.1191C22.927 15.4036 23.13 15.4646 23.5563 15.4444L30.2697 15.0379C30.8373 14.9975 31 14.7332 31 14.2864V7.15655C31 6.92565 30.9088 6.8591 30.6403 6.66205L28.7488 5.3285C28.3024 5.00389 28.1199 4.96283 27.4097 5.02374V5.02384ZM23.7081 7.03985C23.1599 7.07673 23.0355 7.08509 22.7242 6.83194L21.9327 6.20235C21.8522 6.12086 21.8927 6.0192 22.0953 5.99893L27.6528 5.59283C28.1195 5.55208 28.3626 5.71475 28.5451 5.85684L29.4982 6.54744C29.539 6.56802 29.6403 6.68953 29.5184 6.68953L23.7791 7.03504L23.7081 7.03985ZM23.069 14.2255V8.17281C23.069 7.90848 23.1502 7.78655 23.3932 7.76607L29.9851 7.38013C30.2087 7.35997 30.3097 7.50206 30.3097 7.76597V13.7784C30.3097 14.0427 30.269 14.2663 29.904 14.2864L23.596 14.6521C23.231 14.6723 23.0691 14.5508 23.0691 14.2255H23.069ZM29.2959 8.49731C29.3363 8.68015 29.2959 8.86299 29.113 8.88388L28.809 8.94417V13.413C28.545 13.5551 28.302 13.6363 28.0989 13.6363C27.7742 13.6363 27.6932 13.5346 27.45 13.2302L25.4618 10.1021V13.1285L26.0908 13.2709C26.0908 13.2709 26.0908 13.6366 25.5833 13.6366L24.1844 13.7178C24.1436 13.6363 24.1844 13.4333 24.3262 13.3928L24.6915 13.2915V9.28999L24.1845 9.24893C24.1437 9.06609 24.2451 8.80208 24.5293 8.7816L26.0303 8.68057L28.099 11.8491V9.04593L27.5717 8.98533C27.5309 8.76143 27.6932 8.59876 27.8959 8.57891L29.2959 8.49731Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint0_linear_62_73110",
                        x1: "5.06754",
                        y1: "6.44772",
                        x2: "9.21701",
                        y2: "13.4673",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "#058F92"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#038489"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#026D71"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_62_73110",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "12",
                            height: "12",
                            fill: "white",
                            transform: "translate(4.00098 4)"
                        })
                    })
                ]
            })
        ]
    });
};







var $1RDRl = parcelRequire("1RDRl");













// TODO: Render dynamic 1P products, hardcoded for now for Team 25
// This should be synced with the FilterRowLoading component that hard codes filter buttons
const $be53cd525abd320f$var$supported1PApps = (primaryProduct)=>{
    if (!primaryProduct) return [];
    return [
        {
            productKey: (0, $1yEFx.ProductKeys).Confluence,
            redirectToFPS: false
        }
    ];
};
// TODO: Render dynamic 3P products, hardcoded for now for Team 25
// This should be synced with the FilterRowLoading component that hard codes filter buttons
const $be53cd525abd320f$var$supported3PApps = [
    (0, $1yEFx.ProductKeys).GoogleDrive,
    (0, $1yEFx.ProductKeys).Teams
];
// TODO: Render the icons based on configuration, hardcoded for now for Team 25
const $be53cd525abd320f$var$appSelectorIcons = {
    [(0, $1yEFx.ProductKeys).GoogleDrive]: (0, $9yyKc.RovoLogoFromSVG)((0, $8f03b897883d0b88$export$e087ba40596ff085)),
    [(0, $1yEFx.ProductKeys).Teams]: (0, $9yyKc.RovoLogoFromSVG)((0, $1RDRl.TeamsIcon))
};
const $be53cd525abd320f$export$6889317edccadd84 = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const apps3PToDisplay = (0, $42omo.useMemo)(()=>$be53cd525abd320f$var$supported3PApps.filter((supported3PApp)=>availableProducts.includes(supported3PApp)).filter((_)=>!selectedProduct).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            }))// TODO: Remove the following Icon override of the icons when we render the icons based on a configuration
        .map(({ productKey: productKey, productConfig: productConfig })=>({
                productKey: productKey,
                productConfig: {
                    ...productConfig,
                    ...$be53cd525abd320f$var$appSelectorIcons[productKey] ? {
                        Icon: $be53cd525abd320f$var$appSelectorIcons[productKey]
                    } : {}
                }
            })), [
        availableProducts,
        productConfigs,
        selectedProduct
    ]);
    const apps1PToDisplay = (0, $42omo.useMemo)(()=>$be53cd525abd320f$var$supported1PApps(primaryProduct).filter((supported1PApp)=>availableProducts.includes(supported1PApp.productKey)).filter((supported1PApp)=>!selectedProduct || supported1PApp.productKey === selectedProduct).map((supportedApp)=>({
                ...supportedApp,
                productConfig: productConfigs[supportedApp.productKey]
            })), [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    return {
        apps1PToDisplay: apps1PToDisplay,
        apps3PToDisplay: apps3PToDisplay,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct
    };
};


const $b3d2eb85abd87b7a$var$styles = {
    container: "_1mou1ejb _195g1wug _18zr1ejb _1bsb1osq _p12f1rc7 _1n261g80 _zkhy1q9c",
    icon: "_syaz1rpy _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    defaultFilterButton: "_zulp12x7 _2rko12b0 _19itia51 _11c8fhey _18zrutpp _1rjc1b66 _1e0c1txw _4cvr1h6o _syazazsu _1bsb1ris _1tkezwfg _p12f182l _bfhksm61 _o5721q9c _k48p1wq8",
    filterButtonContent: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
};
const $b3d2eb85abd87b7a$export$876f25caa2b82f74 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { selectedProduct: selectedProduct } = (0, $be53cd525abd320f$export$6889317edccadd84)();
    const onAppFilterSelected = (productKey, options, event)=>{
        const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: newSelectedProduct === undefined ? 'unselected' : 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: options.isPostAuthAction,
                isRedirectedToFPS: options.redirectToFPS,
                source: 'inline'
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        if (!options.redirectToFPS) {
            selectProductFilter(newSelectedProduct);
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push', event);
        clearAllFilters();
        setQuickFindOpen(false);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center",
        alignInline: "center",
        xcss: $b3d2eb85abd87b7a$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b3d2eb85abd87b7a$var$styles.icon,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                    label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).filterByIcon)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$FilterSelects, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$FilterApps, {
                onAppFilterSelected: onAppFilterSelected
            })
        ]
    });
};
const $b3d2eb85abd87b7a$var$FilterSelects = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { unselectProductFilter: unselectProductFilter } = (0, $djVCD.useSearchActions)(); // Deselect 'Confluence' when closing the contributor filter with no options selected
    // This should restore any 3P filters that were hidden while this filter was active
    const onFilterClose = (options, selectedOptions)=>{
        if (selectedOptions.length === 0) unselectProductFilter();
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $23012254e2ce6f81$export$fcbf8a9904746204), {
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                    label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor)
                }),
                iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                onFilterClose: onFilterClose
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a2107b05e31d2daf$export$409b84e60ce4841e), {
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
                    label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type)
                }),
                iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {})
            })
        ]
    });
};
const $b3d2eb85abd87b7a$var$FilterApps = ({ onAppFilterSelected: onAppFilterSelected })=>{
    const { apps3PToDisplay: apps3PToDisplay, apps1PToDisplay: apps1PToDisplay } = (0, $be53cd525abd320f$export$6889317edccadd84)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            apps1PToDisplay.map((app)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b9b0457c9911360b$export$767d38fff643cac6), {
                        productConfig: app.productConfig,
                        onAppFilterSelected: onAppFilterSelected,
                        productKey: app.productKey
                    })
                }, app.productKey)),
            apps3PToDisplay.map((app)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dff2b050324c4738$export$cca86f2b29004207), {
                        productKey: app.productKey,
                        redirectToFPSWithProductSelected: ()=>onAppFilterSelected(app.productKey, {
                                redirectToFPS: true,
                                isPostAuthAction: true
                            }),
                        trigger: ({ triggerProps: triggerProps, userNeedsAuth: userNeedsAuth })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2d50858696eaf28c$export$42a563ec5acc14f9), {
                                productConfig: app.productConfig,
                                userNeedsAuth: userNeedsAuth,
                                triggerProps: triggerProps,
                                onAppFilterSelected: onAppFilterSelected,
                                productKey: app.productKey
                            })
                    })
                }, app.productKey)),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$AdditionalAppsButton, {})
        ]
    });
};
const $b3d2eb85abd87b7a$var$AdditionalAppsButton = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const onClick = (event)=>{
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: 'more-apps-search',
            action: 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: false,
                isRedirectedToFPS: true,
                source: 'inline'
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            text: quickFindQuery
        }), 'push', event);
        clearAllFilters();
        setQuickFindOpen(false);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $17a1e71bd16703fa$export$1020a744a95a8f31), {}),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        tooltip: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).moreAppsSearchTooltip),
        onClick: onClick,
        children: `+${formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).more)}`
    });
};
const $b3d2eb85abd87b7a$export$28e86b995fe6c793 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center",
        alignInline: "center",
        xcss: $b3d2eb85abd87b7a$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b3d2eb85abd87b7a$var$styles.icon,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                    label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).filterByIcon)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$ContributorFilterLoading, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$UniversalTypeFilterLoading, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$ProductFilterLoading, {
                productKey: "confluence"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$ProductFilterLoading, {
                productKey: "drive"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$ProductFilterLoading, {
                productKey: "teams"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($b3d2eb85abd87b7a$var$ProductMoreAppsButtonLoading, {})
        ]
    });
};
const $b3d2eb85abd87b7a$var$ContributorFilterLoading = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent,
                children: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor)
            })
        ]
    });
};
const $b3d2eb85abd87b7a$var$UniversalTypeFilterLoading = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
                label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent,
                children: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type)
            })
        ]
    });
};
const $b3d2eb85abd87b7a$var$ProductFilterLoading = ({ productKey: productKey })=>{
    const config1P = (0, $1yEFx.products1P)[productKey];
    const config3P = (0, $hB77E.ThirdPartyConfigs).get(productKey);
    let displayName = '';
    let displayNameString = ''; // 1P configs use config.Icon/IconBorderless, 3P configs use config.icon/iconBorderless
    let IconComponent;
    if (config1P) {
        // ProductConfig from products1P
        IconComponent = config1P.IconBorderless ?? config1P.Icon;
        displayName = config1P.displayName;
        displayNameString = String(displayName);
    } else if (config3P) {
        // ThirdPartyConfig from ThirdPartyConfigs
        IconComponent = config3P.iconBorderless ?? config3P.icon;
        displayName = config3P.displayName;
        displayNameString = String(displayName);
    } else return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                size: "xsmall",
                label: displayNameString
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent,
                children: displayName
            })
        ]
    });
};
const $b3d2eb85abd87b7a$var$ProductMoreAppsButtonLoading = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $17a1e71bd16703fa$export$1020a744a95a8f31), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent,
                children: `+${formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).more)}`
            })
        ]
    });
};












var $hTKp4 = parcelRequire("hTKp4");





var $cbc8g = parcelRequire("cbc8g");























var $hr2Qv = parcelRequire("hr2Qv");









const $936b3cff3811e499$export$f86bcd23f07f7d76 = ({ attributes: attributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `ghostText`,
        actionSubjectId: 'customGhostText',
        attributes: attributes
    });



var $6CCa2 = parcelRequire("6CCa2");









































const $fbd0f9156abc48d4$export$766d74f7dcab3339 = (0, $cgtv4.defineMessages)({
    controlPlaceholder: {
        id: "quick-find.ghost-text.control",
        defaultMessage: "Search"
    },
    default3PPlaceholder: {
        id: "quick-find.ghost-text.default-3p",
        defaultMessage: "Search across all your apps"
    },
    sainPlaceholder: {
        id: "quick-find.ghost-text.sain",
        defaultMessage: "Ask me anything or search..."
    },
    multipleThirdPartyPlaceholder: {
        id: "quick-find.ghost-text.3p-multiple",
        defaultMessage: "Search {firstPartyApp}, {thirdPartyApp1}, {thirdPartyApp2} and other apps"
    },
    twoAppPlaceholder: {
        id: "quick-find.ghost-text.two-apps",
        defaultMessage: "Search {firstPartyApp}, {thirdPartyApp1} and other apps"
    },
    mixedAppsPlaceholder: {
        id: "quick-find.ghost-text.mixed-apps",
        defaultMessage: "Search {currentApp}, {otherFirstPartyApp}, {thirdPartyApp} and other apps"
    },
    // Third-party product specific messages
    googleDrivePlaceholder: {
        id: "quick-find.ghost-text.3p.google-drive",
        defaultMessage: "Search your Google Drive Docs, Sheets and Slides"
    },
    sharepointPlaceholder: {
        id: "quick-find.ghost-text.3p.sharepoint",
        defaultMessage: "Search your SharePoint documents and files"
    },
    onedrivePlaceholder: {
        id: "quick-find.ghost-text.3p.onedrive",
        defaultMessage: "Search your OneDrive documents and files"
    },
    teamsPlaceholder: {
        id: "quick-find.ghost-text.3p.teams",
        defaultMessage: "Search your Microsoft Teams chats and messages"
    },
    slackPlaceholder: {
        id: "quick-find.ghost-text.3p.slack",
        defaultMessage: "Search your Slack DMs and messages"
    },
    githubPlaceholder: {
        id: "quick-find.ghost-text.3p.github",
        defaultMessage: "Search your GitHub repos, commits and PRs"
    },
    // SAIN cohort question suggestions
    sainQuestionTimeOff: {
        id: "quick-find.ghost-text.sain.time-off",
        defaultMessage: "Try any question, like \"How do I request time off?\""
    },
    sainQuestionResetPassword: {
        id: "quick-find.ghost-text.sain.reset-password",
        defaultMessage: "Try any question, like \"How do I reset my password?\""
    },
    sainQuestionNotifications: {
        id: "quick-find.ghost-text.sain.notifications",
        defaultMessage: "Try any question, like \"How do I change my notification settings?\""
    },
    sainQuestionITSupport: {
        id: "quick-find.ghost-text.sain.it-support",
        defaultMessage: "Try any question, like \"How do I contact IT support?\""
    },
    sainQuestionMeetingRoom: {
        id: "quick-find.ghost-text.sain.meeting-room",
        defaultMessage: "Try any question, like \"How do I book a meeting room?\""
    },
    sainQuestionBenefits: {
        id: "quick-find.ghost-text.sain.benefits",
        defaultMessage: "Try any question, like \"Where can I see my benefits?\""
    }
});


// TODO: to be used in second experiment https://hello.atlassian.net/wiki/pages/resumedraft.action?draftId=6192988799
/**
 * Generate ghost text rotations for SAIN cohort (AI-powered question suggestions)
 */ // const calculateSainGhostTextRotations = (
// 	formatMessage: (message: any, values?: any) => string,
// ): string[] => {
// 	return [
// 		formatMessage(ghostTextMessages.sainQuestionTimeOff),
// 		formatMessage(ghostTextMessages.sainQuestionResetPassword),
// 		formatMessage(ghostTextMessages.sainQuestionNotifications),
// 		formatMessage(ghostTextMessages.sainQuestionITSupport),
// 		formatMessage(ghostTextMessages.sainQuestionMeetingRoom),
// 		formatMessage(ghostTextMessages.sainQuestionBenefits),
// 	];
// };
/**
 * Generate ghost text rotations for 3P cohort (based on available products)
 * Returns ordered list: combined texts -> 3P specific texts (sorted by hash)
 */ const $224a05be048f4a29$var$calculate3PGhostTextRotations = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct, formatMessage: formatMessage })=>{
    const SUPPORTED_3P_MESSAGES = new Map([
        [
            (0, $1yEFx.ProductKeys3P).GoogleDrive,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).googleDrivePlaceholder
        ],
        [
            (0, $1yEFx.ProductKeys3P).Sharepoint,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).sharepointPlaceholder
        ],
        [
            (0, $1yEFx.ProductKeys3P).OneDrive,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).onedrivePlaceholder
        ],
        [
            (0, $1yEFx.ProductKeys3P).Teams,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).teamsPlaceholder
        ],
        [
            (0, $1yEFx.ProductKeys3P).Slack,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).slackPlaceholder
        ],
        [
            (0, $1yEFx.ProductKeys3P).Github,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).githubPlaceholder
        ]
    ]);
    const currentAppName = primaryProduct && (0, $1yEFx.is1pProductKey)(primaryProduct) ? (0, $1yEFx.products1P)[primaryProduct]?.displayName : undefined;
    const available1PExcludePrimary = Array.from(new Set(products.filter((0, $1yEFx.is1pProductKey)).map((productKey)=>{
        // Consolidate Jira variants to base Jira for ghost text
        if (productKey === (0, $1yEFx.ProductKeys).JiraProductDiscovery || productKey === (0, $1yEFx.ProductKeys).JiraServiceManagement) return (0, $1yEFx.ProductKeys).Jira;
        return productKey;
    }))).filter((productKey)=>productKey !== primaryProduct);
    const available3PProducts = Object.keys(thirdPartyConfigs || {}).filter((key)=>thirdPartyConfigs?.[key] !== undefined && !thirdPartyConfigs?.[key]?.userNeedsOAuth && !key.toLowerCase().startsWith('forge-connector-') && !key.toLowerCase().includes((0, $1yEFx.ProductKeys3P).AtlassianWebCrawler) && !key.toLowerCase().endsWith('-dc'));
    const textRotations = [];
    if (currentAppName) {
        if (available3PProducts.length >= 1 && available1PExcludePrimary.length >= 1) {
            const top1P = (0, $1yEFx.products1P)[available1PExcludePrimary[0]].displayName;
            const top3P = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            textRotations.push({
                id: (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).mixedAppsPlaceholder.id,
                text: formatMessage((0, $fbd0f9156abc48d4$export$766d74f7dcab3339).mixedAppsPlaceholder, {
                    currentApp: currentAppName,
                    otherFirstPartyApp: top1P,
                    thirdPartyApp: top3P
                })
            });
        }
        if (available3PProducts.length >= 2) {
            const top3P1 = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            const top3P2 = thirdPartyConfigs?.[available3PProducts[1]]?.displayName;
            textRotations.push({
                id: (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).multipleThirdPartyPlaceholder.id,
                text: formatMessage((0, $fbd0f9156abc48d4$export$766d74f7dcab3339).multipleThirdPartyPlaceholder, {
                    firstPartyApp: currentAppName,
                    thirdPartyApp1: top3P1,
                    thirdPartyApp2: top3P2
                })
            });
        }
        if (available3PProducts.length === 1 && available1PExcludePrimary.length === 0) {
            const top3P = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            textRotations.push({
                id: (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).twoAppPlaceholder.id,
                text: formatMessage((0, $fbd0f9156abc48d4$export$766d74f7dcab3339).twoAppPlaceholder, {
                    firstPartyApp: currentAppName,
                    thirdPartyApp1: top3P
                })
            });
        }
    }
    for (const productKey of available3PProducts){
        const message = SUPPORTED_3P_MESSAGES.get(productKey);
        if (message) textRotations.push({
            id: message.id,
            text: formatMessage(message)
        });
    }
    return textRotations;
};
const $224a05be048f4a29$export$1933af4a353afb6d = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct, formatMessage: formatMessage })=>{
    const rotations = $224a05be048f4a29$var$calculate3PGhostTextRotations({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage
    }).filter((r)=>r.text.length <= 85);
    rotations.push({
        id: (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).default3PPlaceholder.id,
        text: formatMessage((0, $fbd0f9156abc48d4$export$766d74f7dcab3339).default3PPlaceholder)
    });
    return rotations;
};
const $224a05be048f4a29$export$d2ecfcb20099e313 = (rotations, locale, existingGhostTextData)=>{
    if (rotations.length === 0) return {
        id: '',
        locale: locale,
        text: '',
        occurrence: 0
    };
    // Find current position by comparing text directly
    let currentIndex = 0;
    let currentOccurrence = 0;
    if (existingGhostTextData) {
        const foundIndex = rotations.findIndex((r)=>{
            if ((0, $6CCa2.isGhostTextDataV2)(existingGhostTextData)) return r.id === existingGhostTextData.id;
            return r.text === existingGhostTextData.text;
        });
        if (foundIndex >= 0) {
            currentIndex = foundIndex;
            currentOccurrence = existingGhostTextData.occurrence ?? 0;
        }
    }
    // Check if we need to rotate to next text
    const newOccurrence = currentOccurrence + 1;
    if (newOccurrence >= (0, $6CCa2.ROTATION_THRESHOLD)) {
        // Move to next text, reset occurrence
        const nextIndex = (currentIndex + 1) % rotations.length;
        return {
            id: rotations[nextIndex].id,
            locale: locale,
            text: rotations[nextIndex].text,
            occurrence: 0
        };
    }
    // Keep current text, increment occurrence
    return {
        id: rotations[currentIndex].id,
        locale: locale,
        text: rotations[currentIndex].text,
        occurrence: newOccurrence
    };
};
const $224a05be048f4a29$export$6d85a15223337a49 = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, locale: locale, primaryProduct: primaryProduct, formatMessage: formatMessage, existingGhostTextData: existingGhostTextData })=>{
    // Get all text rotations
    const rotations = $224a05be048f4a29$export$1933af4a353afb6d({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage
    });
    // Select appropriate text based on current state
    const { id: id, text: text, occurrence: occurrence } = $224a05be048f4a29$export$d2ecfcb20099e313(rotations, locale, existingGhostTextData);
    if (!(0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) return {
        text: text,
        occurrence: occurrence
    };
    return {
        id: id,
        locale: locale,
        text: text,
        occurrence: occurrence
    };
};
/**
 * Check if a serialized ghost text value is considered "empty"
 */ const $224a05be048f4a29$var$isEmptyGhostText = (value)=>{
    return value === '{}' || value === '' || value === null || value === undefined;
};
const $224a05be048f4a29$export$e1cd992f057eb389 = ({ serve3PGhostText: serve3PGhostText, lastPersisted: lastPersisted, products: products, thirdPartyConfigs: thirdPartyConfigs, locale: locale, primaryProduct: primaryProduct, formatMessage: formatMessage, existingGhostTextData: existingGhostTextData })=>{
    const newGhostTextData = serve3PGhostText ? $224a05be048f4a29$export$6d85a15223337a49({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        locale: locale,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage,
        existingGhostTextData: existingGhostTextData
    }) : {};
    const serialized = JSON.stringify(newGhostTextData);
    // Reject transition from non-empty to empty (don't overwrite valid data)
    // Accept transition from empty to non-empty (allow valid data to be set)
    const isNewEmpty = $224a05be048f4a29$var$isEmptyGhostText(serialized);
    const wasLastEmpty = $224a05be048f4a29$var$isEmptyGhostText(lastPersisted);
    if (!wasLastEmpty && isNewEmpty) // Don't overwrite valid ghost text with empty
    return null;
    return serialized;
};















const $908389ef2c25a547$export$d3538183feb90c1a = (localQuery, postQueryDisabled)=>{
    const filterKeywordToFilterId = (0, $a00b54be6ab004d4$export$c37f199dbeef0d2c)();
    const filterKeywordToFilterActions = (0, $a00b54be6ab004d4$export$170a7ded78a9d477)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setQuickFindQuery: setQuickFindQuery, deleteSelectedQueryFilter: deleteSelectedQueryFilter, setCurrentQueryFilter: setCurrentQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const [debouncedSetLookupInput, cancelDebouncedSetLookupInput] = (0, $lvsjl.default)((lookupInput, setLookupInput)=>{
        setLookupInput(lookupInput);
    }, 300);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('keep_filter_values_in_quick_find_input')) {
            const trimmedQuery = localQuery.trim();
            setQuickFindQuery(trimmedQuery);
        }
    }, [
        localQuery,
        setQuickFindQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('keep_filter_values_in_quick_find_input')) return;
        const queryWithoutSelectedQueryFilters = (0, $a00b54be6ab004d4$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        const trimmedQuery = queryWithoutSelectedQueryFilters.trim();
        setQuickFindQuery(trimmedQuery);
    }, [
        localQuery,
        selectedQueryFilters,
        setQuickFindQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if (postQueryDisabled) return;
        // Deselect select query filters if their display text is no longer in the query
        for (const selectedQueryFilter of selectedQueryFilters)if (!localQuery.includes(selectedQueryFilter.displayText)) {
            const filterActions = filterKeywordToFilterActions[selectedQueryFilter.keyword];
            if (filterActions && selectedQueryFilter.option) {
                filterActions.setOption({
                    ...selectedQueryFilter.option,
                    isSelected: true
                });
                deleteSelectedQueryFilter(selectedQueryFilter);
            }
        }
        // To determine if a user is accessing a query filter, we use the query without
        // selected query filters to allow for multiple query filters to be used at once
        const queryWithoutSelectedQueryFilters = (0, $a00b54be6ab004d4$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        // Determine if the user is using a query filter
        const filterKeywords = Object.keys(filterKeywordToFilterId);
        const keyword = (0, $a00b54be6ab004d4$export$a47046b35fa42e2d)(queryWithoutSelectedQueryFilters, filterKeywords);
        // Reset current query filter if keyword is not found
        if (!keyword) {
            cancelDebouncedSetLookupInput();
            setCurrentQueryFilter(undefined);
            return;
        }
        // Get the filter id and actioins for the filter corresponding to the keyword
        const filterId = filterKeywordToFilterId[keyword];
        const filterActions = filterKeywordToFilterActions[keyword];
        const filterLookupQuery = (0, $a00b54be6ab004d4$export$3141a593bcb9212f)(queryWithoutSelectedQueryFilters, keyword);
        // Load the options for the filter
        if (filterId && filterActions && filterLookupQuery !== undefined) {
            setCurrentQueryFilter({
                filterId: filterId,
                keyword: keyword
            });
            cancelDebouncedSetLookupInput();
            if (filterLookupQuery === '') {
                filterActions.loadInitialOptions();
                filterActions.setLookupInput('');
            } else debouncedSetLookupInput(filterLookupQuery, filterActions.setLookupInput);
        }
    }, [
        selectedQueryFilters,
        filterKeywordToFilterId,
        filterKeywordToFilterActions,
        deleteSelectedQueryFilter,
        setCurrentQueryFilter,
        localQuery,
        cancelDebouncedSetLookupInput,
        debouncedSetLookupInput,
        postQueryDisabled
    ]);
};





const $4af3204510a58241$export$db28d8e16fb16e80 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });









const $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME = 300;
const $9fa79de2eb008d7c$export$fe11394d33dcb3dd = ()=>{
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const fireOnTextEnteredAnalyticsCallback = (0, $42omo.useCallback)(()=>{
        if (!quickFindOpen) return;
        fireAnalyticsEvent((0, $4af3204510a58241$export$db28d8e16fb16e80)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        quickFindOpen
    ]);
    return (0, $e31678cde9628b17$export$e70e6da722faba05)(fireOnTextEnteredAnalyticsCallback, $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME);
};


const $33671f0d02952dbc$export$fb8d8fbc0c4c1705 = ({ dialogId: dialogId, inputRef: inputRef, localQuery: localQuery, setLocalQuery: setLocalQuery, textfieldComponent: textfieldComponent, postQueryDisabled: postQueryDisabled, customPlaceholder: customPlaceholder, onGhostTextGenerated: onGhostTextGenerated, intentRouterEnabled: intentRouterEnabled })=>{
    const previousTextQueryParam = (0, $42omo.useRef)();
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $7WbA8.useAppContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const products = (0, $j4ply.useAvailableProducts)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const keyboardHighlight = (0, $icqFF.useKeyboardHighlightProvider)();
    const getSelectedIndex = keyboardHighlight?.getSelectedIndex;
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { selectedFilters: { jiraFilters: jiraFilters } } = (0, $4VkIo.useSelectedFilters)({});
    const { setQuickFindOpen: setQuickFindOpen, resetSelectedQueryFilters: resetSelectedQueryFilters } = (0, $4VmlX.useQuickFindActions)();
    const { setQueryUpdatedTime: setQueryUpdatedTime, clearAllFilters: clearAllFilters, setInputQuery: setInputQuery } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const debouncedOnTextEnteredAnalyticsCallback = (0, $9fa79de2eb008d7c$export$fe11394d33dcb3dd)();
    const logException = (0, $f8oYd.useLogException)();
    const { abortTask: abortTask, isTaskActive: isTaskActive } = (0, $269ee6c4b9937e56$export$5b6291bff520e069)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    (0, $2ok43.useInputSkeleton)({
        localQuery: localQuery,
        inputRef: inputRef
    });
    const serve3PGhostText = (0, $42omo.useMemo)(()=>(0, $ci6Zg.serve3PGhostTextExperiment)({
            thirdPartyConfigs: thirdPartyConfigs,
            locale: locale
        }), [
        thirdPartyConfigs,
        locale
    ]);
    const existingGhostTextData = (0, $42omo.useMemo)(()=>(0, $6CCa2.parseGhostTextData)(customPlaceholder, locale), [
        customPlaceholder,
        locale
    ]);
    // Track last persisted ghost text to prevent overwriting valid data with empty
    const lastPersistedGhostTextRef = (0, $42omo.useRef)('{}');
    (0, $42omo.useEffect)(()=>{
        if (!onGhostTextGenerated || !isConfigLoaded) return;
        const serialized = (0, $224a05be048f4a29$export$e1cd992f057eb389)({
            serve3PGhostText: serve3PGhostText,
            lastPersisted: lastPersistedGhostTextRef.current,
            products: products,
            thirdPartyConfigs: thirdPartyConfigs,
            locale: locale,
            primaryProduct: primaryProduct,
            formatMessage: formatMessage,
            existingGhostTextData: existingGhostTextData
        });
        if (serialized === null) return;
        lastPersistedGhostTextRef.current = serialized;
        onGhostTextGenerated(serialized);
    }, [
        serve3PGhostText,
        products,
        thirdPartyConfigs,
        primaryProduct,
        formatMessage,
        existingGhostTextData,
        onGhostTextGenerated,
        isConfigLoaded,
        locale
    ]);
    (0, $42omo.useEffect)(()=>{
        if (serve3PGhostText && existingGhostTextData) {
            let attributes = {
                customGhostText: existingGhostTextData.text
            };
            if ((0, $6CCa2.isGhostTextDataV2)(existingGhostTextData)) attributes = {
                id: existingGhostTextData.id,
                locale: existingGhostTextData.locale,
                customGhostText: existingGhostTextData.text
            };
            fireAnalyticsEvent((0, $936b3cff3811e499$export$f86bcd23f07f7d76)({
                attributes: attributes
            }));
        }
    }, [
        serve3PGhostText,
        existingGhostTextData,
        fireAnalyticsEvent
    ]);
    /**
   * When Quick Find is SSR'd, users may type into the input before the
   * React component is mounted. Given that useLayoutEffect is called before
   * the first browser paint but after the input ref is set, this essentially
   * initialises the React component with the input's state prior to hydration.
   * - Input in the DOM element is reflected in localQuery
   * - Focus state is preserved as hydration causes the input to lose focus
   *
   * It should be noted that re-renders caused state by updates in useLayoutEffect
   * are synchronous, i.e. occurs before the paint, hence this is TTVC friendly.
   *
   * When this component is not SSR'd, this effectively does nothing.
   */ (0, $42omo.useLayoutEffect)(()=>{
        if (inputRef?.current) {
            setLocalQuery(inputRef.current.value);
            const document = (0, $hTKp4.getDocument)();
            const isFocused = document && document.activeElement === inputRef.current;
            const selectionStart = isFocused ? inputRef.current.selectionStart : null;
            const selectionEnd = isFocused ? inputRef.current.selectionEnd : null;
            if (isFocused) requestAnimationFrame(()=>{
                inputRef?.current?.focus();
                if (selectionStart !== null && selectionEnd !== null) inputRef?.current?.setSelectionRange(selectionStart, selectionEnd);
            });
        }
    }, [
        inputRef,
        setLocalQuery
    ]);
    (0, $908389ef2c25a547$export$d3538183feb90c1a)(localQuery, postQueryDisabled);
    // Only when the text query param changes, update the local query. If the
    // local query without selected query filters is the same as text query param,
    // do nothing.
    (0, $42omo.useEffect)(()=>{
        const textParam = typeof queryParams.text === 'string' ? queryParams.text : undefined;
        if (textParam === previousTextQueryParam.current) return;
        previousTextQueryParam.current = textParam;
        const localQueryWithoutSelectedQueryFilters = (0, $a00b54be6ab004d4$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        const newLocalQuery = typeof queryParams.text === 'string' ? queryParams.text : '';
        if (localQueryWithoutSelectedQueryFilters !== newLocalQuery) {
            setInputQuery(newLocalQuery);
            setLocalQuery(newLocalQuery);
            clearAllFilters();
            resetSelectedQueryFilters();
        }
    }, [
        clearAllFilters,
        queryParams.text,
        resetSelectedQueryFilters,
        selectedQueryFilters,
        setLocalQuery,
        localQuery,
        setInputQuery
    ]);
    // Update query time when query changes
    (0, $42omo.useEffect)(()=>{
        setQueryUpdatedTime();
    }, [
        setQueryUpdatedTime,
        localQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if (quickFindOpen) inputRef?.current?.focus();
        else inputRef?.current?.blur();
    }, [
        inputRef,
        quickFindOpen
    ]);
    const onKeyDown = (0, $42omo.useCallback)(async (event)=>{
        /**
     * Ignore enter key press if a search result is highlighted as we let
     * the keyboard highlight provider handle the event in this case.
     */ const resultHighlighted = getSelectedIndex && getSelectedIndex() !== undefined;
        if (event.key === 'Enter' && !resultHighlighted) {
            /**
       * Prevent IME composition from submitting the search
       */ if (event.nativeEvent.isComposing) {
                event.preventDefault();
                return;
            }
            if (!primaryProduct) return;
            /**
       * Stop the event from propagating to prevent UFO
       * VC90 metric from being cancelled on route change.
       */ event.stopPropagation();
            // Store search in recent searches
            if (quickFindQuery.trim() !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(quickFindQuery.trim(), user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
            event.currentTarget.blur();
            setQuickFindOpen(false);
            fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
                actionSubjectId: `${primaryProduct.toLowerCase()}AdvancedSearchLink`,
                attributes: {
                    ...commonAttributes,
                    trigger: 'return',
                    returnModified: event.metaKey || event.ctrlKey,
                    newTab: false,
                    isLoading: content?.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).PREQUERY_LOADING || content?.state === (0, $7c0d6974c60a6f80$export$7254cc27399e90bd).POSTQUERY_LOADING
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            // Executing a search query on FPS search will always clear the filters in QF as FPS filters
            // is the source of truth for filter state.
            clearAllFilters();
            (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event.timeStamp);
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) {
                const ctrlKey = event.metaKey || event.ctrlKey;
                // Intent detection is ongitly enabled if the experiment is enabled
                if (intentRouterEnabled) {
                    // VitalStats: Abort intent detection UX task if user submits search
                    if (isIntentDetectionTaskActive()) abortIntentDetectionTask('search_submitted');
                    const intentDetection = (0, $fa792d959dc8194b$export$928cec68d7595d16).value();
                    const url = intentDetection?.route || (0, $3fzmz.getWorkItemPageUrl)({
                        query: quickFindQuery,
                        jiraFilters: jiraFilters,
                        generateSearchUrl: generateSearchUrl,
                        queryParams: queryParams
                    });
                    onNavigateCallback(url, 'push', event);
                    return;
                }
                // Ctrl + Enter
                // On Jira Full Page Search, Ctrl + Enter = Go to NIN
                // On other products, Ctrl + Enter = Go to FPS
                const swapQuickFindCTAs = (0, $1XDdH.isOnJiraFullPageSearch)() && primaryProduct && primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_search_fps_cta_swap');
                if (ctrlKey && !swapQuickFindCTAs || !ctrlKey && swapQuickFindCTAs) {
                    onNavigateCallback(generateSearchUrl({
                        ...queryParams,
                        text: quickFindQuery
                    }, false // This is still Confluence, so won't be a secondary link
                    ), 'push', event);
                    return;
                }
                try {
                    const url = (0, $3fzmz.getWorkItemPageUrl)({
                        query: quickFindQuery,
                        jiraFilters: jiraFilters,
                        generateSearchUrl: generateSearchUrl,
                        queryParams: queryParams
                    });
                    onNavigateCallback(url, 'push', event);
                    return;
                } catch (error) {
                    // If network or runtime errors occcur, follow the default redirection behaviour.
                    logException(error);
                }
            }
            const searchForPrimaryProduct = !selectedProduct && (applicationMode === (0, $9vOy1.ApplicationModes).Rovo && (event.metaKey || event.ctrlKey) || applicationMode !== (0, $9vOy1.ApplicationModes).Rovo && !(event.metaKey || event.ctrlKey));
            onNavigateCallback(generateSearchUrl({
                ...queryParams,
                ...searchForPrimaryProduct ? {
                    product: primaryProduct
                } : {},
                text: quickFindQuery,
                cql: undefined // Clear CQL parameter when performing a regular search
            }, false), 'push');
        }
        if (event.key === 'Escape') {
            /**
       * Prevent IME composition from closing the quick find
       */ if (event.nativeEvent.isComposing) {
                event.preventDefault();
                return;
            }
            event.currentTarget.blur();
            setQuickFindOpen(false);
            (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event.timeStamp);
        }
    }, [
        getSelectedIndex,
        primaryProduct,
        quickFindQuery,
        user,
        setQuickFindOpen,
        fireAnalyticsEvent,
        commonAttributes,
        content?.state,
        nonPrivacySafeAttributes,
        selectedProduct,
        applicationMode,
        clearAllFilters,
        onNavigate,
        generateSearchUrl,
        queryParams,
        updateRecentQueries,
        jiraFilters,
        logException,
        intentRouterEnabled,
        isIntentDetectionTaskActive,
        abortIntentDetectionTask
    ]);
    const onChange = (0, $42omo.useCallback)((event)=>{
        const newQuery = event.currentTarget.value;
        setLocalQuery(newQuery);
        debouncedOnTextEnteredAnalyticsCallback();
    }, [
        debouncedOnTextEnteredAnalyticsCallback,
        setLocalQuery
    ]);
    const onFocus = (0, $42omo.useCallback)((event)=>{
        setQuickFindOpen(true);
        if (!quickFindOpen) {
            (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_OPEN_INTERACTION), event.timeStamp);
            (0, $cbc8g.addUFOCustomData)({
                queryLength: localQuery.length
            });
        }
    }, [
        setQuickFindOpen,
        quickFindOpen,
        localQuery.length
    ]);
    const Textfield = textfieldComponent || (0, $hr2Qv.Textfield);
    return /*#__PURE__*/ (0, $l998X.jsx)(Textfield, {
        value: localQuery,
        dialogId: dialogId,
        inputRef: inputRef,
        quickFindOpen: quickFindOpen,
        isNav4Enabled: isNav4Enabled,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        intentRouterEnabled: intentRouterEnabled,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onChange: onChange,
        onClear: ()=>{
            // Cancel pending debounced callback
            debouncedOnTextEnteredAnalyticsCallback.cancel();
            // Abort task if active when user clicks clear button
            // Note: We don't wrap in startTransition here because abortTask needs to
            // update state synchronously to prevent race conditions with new queries
            if (isTaskActive()) abortTask('text_cleared');
            // VitalStats: Abort intent detection UX task if user clears text
            if (isIntentDetectionTaskActive()) abortIntentDetectionTask('text_cleared');
            setLocalQuery('');
            inputRef?.current?.focus();
        },
        placeholder: (0, $dh538.fg)('quickfind-ghosttext') ? existingGhostTextData?.text : undefined
    });
};






var $fFa3V = parcelRequire("fFa3V");

function $447d1b6cafcd352b$var$mapToInteractionType(eventType) {
    if (eventType === 'click' || eventType === 'dblclick' || eventType === 'mousedown') return 'press';
    if (eventType === 'mouseenter' || eventType === 'mouseover') return 'hover';
    return undefined;
}
var $447d1b6cafcd352b$export$2e2bcd8739ae039 = $447d1b6cafcd352b$var$mapToInteractionType;



var $fTvzg = parcelRequire("fTvzg");

/**
 * *Warning* Currently this only supports the events with the following types
 * ```ts
 * 'click' | 'dblclick' | 'mousedown' | 'mouseenter' | 'mouseover'
 * ```
 */ function $3d262149e5e5b88f$var$traceUFOInteraction(name, event) {
    if (!event || !event.isTrusted) return;
    const interactionType = (0, $447d1b6cafcd352b$export$2e2bcd8739ae039)(event.type);
    if (!interactionType) // when interactionType is falsy we do not yet support this type of event. should we blow up with throwing error instead?
    return;
    return (0, $fTvzg.default)(name, interactionType, event.timeStamp);
}
var $3d262149e5e5b88f$export$2e2bcd8739ae039 = $3d262149e5e5b88f$var$traceUFOInteraction;














const $00b97e1dc9e8581d$var$isClickInRelatedLinkModalBlanket = (targetNode)=>{
    if (!targetNode) return false;
    const relatedLinksModal = document.querySelector('[data-testid="related-links-modal"]');
    const relatedLinkModalBlanket = document.querySelector('[data-testid="related-links-modal--blanket"]');
    const isInRelatedLinksModal = relatedLinksModal ? relatedLinksModal.contains(targetNode) : false;
    const isInRelatedLinkModalBlanket = relatedLinkModalBlanket ? relatedLinkModalBlanket.contains(targetNode) : false;
    return isInRelatedLinksModal || isInRelatedLinkModalBlanket;
};
const $00b97e1dc9e8581d$export$92dae2778ae88f9d = ({ dialogRef: dialogRef, inputBoxRef: inputBoxRef })=>{
    const mouseDownInside = (0, $42omo.useRef)(false);
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const [isFeedbackModalOpen] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const [isBulkConnectModalOpen] = (0, $4VmlX.useIsBulkConnectModalOpen)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    (0, $42omo.useEffect)(()=>{
        const onMouseDown = (event)=>{
            mouseDownInside.current = false;
            const { target: target } = event;
            const targetNode = target;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (isClickOnPopup || isClickOnTrigger) mouseDownInside.current = true;
        };
        const onClick = (event)=>{
            const { target: target } = event;
            const targetNode = target;
            if (isFeedbackModalOpen) return;
            if (isBulkConnectModalOpen && (0, $2OtFZ.serve3PBulkConnectWithoutExposure)()) return;
            if ($00b97e1dc9e8581d$var$isClickInRelatedLinkModalBlanket(targetNode)) return;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (!isClickOnPopup && !isClickOnTrigger && !mouseDownInside.current) {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $3d262149e5e5b88f$export$2e2bcd8739ae039)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event);
            }
        };
        const onKeyDown = (event)=>{
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc') {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $3d262149e5e5b88f$export$2e2bcd8739ae039)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event);
            }
        };
        const onBlur = ()=>{
            const activeElement = document.activeElement;
            const activeElementIsIFrame = activeElement instanceof HTMLIFrameElement;
            // Close Quick Find if the new active element is an iframe, we need
            // to do this check since click events are not fired on iframes
            if (activeElementIsIFrame) {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), performance.now());
            }
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'mousedown',
                listener: onMouseDown,
                options: {
                    capture: false
                }
            },
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: true
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'blur',
                listener: onBlur
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        setQuickFindOpen,
        isFeedbackModalOpen,
        isBulkConnectModalOpen,
        quickFindOpen,
        dialogRef,
        inputBoxRef
    ]);
};











const $b7759cf22d019191$export$24139682747f5c4 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'dwelled',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





function $aca2bc20d4823d2b$export$632123ff591ac565({ onTimerEnd: onTimerEnd }) {
    const [timer, setTimer] = (0, $42omo.useState)({
        status: 'idle'
    });
    const start = (0, $42omo.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'idle') return state;
            return {
                ...state,
                startTime: new Date(),
                status: 'running'
            };
        });
    }, []);
    const stop = (0, $42omo.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'running') return state;
            const end = new Date().getTime() - (timer.startTime?.getTime() ?? 0);
            onTimerEnd?.(end);
            return {
                ...state,
                endTime: new Date(),
                milliseconds: end,
                status: 'finished'
            };
        });
    }, [
        onTimerEnd,
        timer.startTime
    ]);
    const cancel = (0, $42omo.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'running') return state;
            return {
                ...state,
                status: 'cancelled'
            };
        });
    }, []);
    return {
        start: start,
        stop: stop,
        cancel: cancel,
        status: timer.status,
        milliseconds: timer.milliseconds
    };
}








const $37f7a1f5b4662dd4$export$20260e4d2b6c9d50 = ()=>{
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const hadInitialQuery = (0, $42omo.useRef)(Boolean((0, $2ok43.getInitialQuery)() || queryParams.text));
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { start: startTimer, stop: stopTimer, cancel: cancelTimer } = (0, $aca2bc20d4823d2b$export$632123ff591ac565)({
        onTimerEnd: (ms)=>fireAnalyticsEvent((0, $b7759cf22d019191$export$24139682747f5c4)({
                attributes: {
                    ...commonAttributes,
                    duration: ms
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }))
    });
    // Analytics to track the first transition from pre-query to post-query
    (0, $42omo.useEffect)(()=>{
        // Do nothing if the page loaded with a query
        if (hadInitialQuery.current) return;
        // Start the timer when the dialog is opened
        if (quickFindOpen) startTimer();
        // Cancel the timer when the dialog is closed
        if (!quickFindOpen) cancelTimer(); // no-ops if the timer hasn't started or has already finished
        // Stop the timer when the user starts typing
        if (quickFindQuery) stopTimer();
    }, [
        cancelTimer,
        quickFindOpen,
        quickFindQuery,
        startTimer,
        stopTimer
    ]);
};





function $64ab60c9a8f30827$export$29d6913fc893cfe8(stateA, setStateA, stateB, setStateB) {
    const prevA = (0, $42omo.useRef)();
    const prevB = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        // Do nothing if any of the arguments are undefined
        if (stateA === undefined || setStateA === undefined || stateB === undefined || setStateB === undefined) return;
        // On mount, use stateA as the source of truth
        if (prevA.current === undefined && prevB.current === undefined) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            return;
        }
        // If updates to both states are updated to the same value in the
        // same render cycle, ensure previous values are updated
        if (stateA === stateB) {
            prevA.current = stateA;
            prevB.current = stateB;
            return;
        }
        // If stateA has changed, update stateB to match
        if (prevA.current !== stateA) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            // Exit here as only one state should be updated, otherwise an infinite
            // loop will occur. This means that stateA takes precedence if both
            // states are changed in the same render cycle.
            return;
        }
        // If stateB has changed, update stateA to match
        if (prevB.current !== stateB) {
            prevA.current = stateB;
            prevB.current = stateB;
            setStateA(stateB);
        }
    }, [
        setStateA,
        setStateB,
        stateA,
        stateB
    ]);
}


const $c8b08557d75a416b$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    width: '100%',
    position: 'relative'
});
const $c8b08557d75a416b$var$minWidthStyles = (0, $ecnYn.xcss)({
    left: '50%',
    transform: 'translate(-50%, 0)',
    position: 'fixed',
    maxWidth: '780px',
    zIndex: 'navigation',
    [(0, $bWLcG.media).above.lg]: {
        maxWidth: 'unset',
        position: 'relative'
    }
});
const $c8b08557d75a416b$var$QuickFindComponent = ({ open: open, setOpen: setOpen, postQueryDisabled: postQueryDisabled, textfieldComponent: textfieldComponent, isSSR: isSSR, PlacementPO: PlacementPO, showFilters: showFilters = true, showFiltersRow: showFiltersRow = false, searchRefreshStyling: searchRefreshStyling = false, customPlaceholder: customPlaceholder, onGhostTextGenerated: onGhostTextGenerated, inputRef: inputRef })=>{
    const inputBoxRef = (0, $42omo.useRef)(null);
    const dialogRef = (0, $42omo.useRef)(null);
    const { isNav4Enabled: isNav4Enabled, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const internalInputRef = (0, $42omo.useRef)(null);
    const effectiveInputRef = inputRef || internalInputRef;
    const intentRouterEnabled = (0, $42omo.useMemo)(()=>(0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false
        })?.cohort === 'test', [
        primaryProduct
    ]);
    const [localQuery, setLocalQuery] = (0, $42omo.useState)(()=>(0, $2ok43.getInitialQuery)(typeof queryParams.text === 'string' && queryParams.text || ''));
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const dialogId = (0, $42omo.useId)();
    const setMinWidthStyles = isNav4Enabled && !textfieldComponent && // min-width styles is only supported with the default text field
    quickFindOpen;
    (0, $64ab60c9a8f30827$export$29d6913fc893cfe8)(quickFindOpen, setQuickFindOpen, open, setOpen);
    (0, $00b97e1dc9e8581d$export$92dae2778ae88f9d)({
        dialogRef: dialogRef,
        inputBoxRef: inputBoxRef
    });
    (0, $37f7a1f5b4662dd4$export$20260e4d2b6c9d50)();
    // Dispose intent detection state when QuickFind unmounts.
    (0, $ea5066efa7331a88$export$9310e79b116dbbca)();
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const handleOpenLayerObserverCloseSignal = (0, $42omo.useCallback)(()=>{
        if (!isFhsEnabled || !(0, $dh538.fg)('platform-dst-side-nav-layering-fixes')) return;
        setQuickFindOpen(false);
    }, [
        isFhsEnabled,
        setQuickFindOpen
    ]);
    /**
	 * We need to notify the open layer observer when the quick find dialog is open.
	 * This is required for several navigation-system features to work correctly, such as:
	 * - Closing layers when the user resizes a layout slot (e.g. SideNav, Panel)
	 * - Ensuring correct layer stacking order when a popup is open within the TopNav or SideNav
	 *
	 * Ideally, the dialog would be using the ADS Popup component instead, which handles this internally
	 * among other benefits.
	 */ (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isFhsEnabled && (0, $dh538.fg)('platform-dst-side-nav-layering-fixes') && quickFindOpen,
        type: 'popup',
        onClose: handleOpenLayerObserverCloseSignal
    });
    const isSearchPagePOBannerPlacementEnabled = (0, $2OtFZ.serveSearchPageInline3PBannerRevampedExperiment)();
    // Store the trackImpression callback provided by the PostOffice placement's onMessageViewed.
    // This is called later by OAuthContainer when the banner becomes visible in search results.
    const trackImpressionRef = (0, $42omo.useRef)(null);
    const onBannerVisible = (0, $42omo.useCallback)(()=>{
        trackImpressionRef.current?.();
    }, []);
    // Create a detached DOM node for the quick-find placement portal.
    // The placement component is mounted early (via createPortal) so its fetch starts in parallel with search, since requests are only made on placement mount.
    // When results render, <PlacementSlot> moves this node into the relevant position in the results list.
    const bannerPortalContainerRef = (0, $42omo.useRef)(null);
    if (isSearchPagePOBannerPlacementEnabled && typeof document !== 'undefined' && !bannerPortalContainerRef.current) {
        bannerPortalContainerRef.current = document.createElement('div');
        bannerPortalContainerRef.current.style.display = 'none';
    }
    const onBannerMessageViewed = (0, $42omo.useCallback)((trackImpression)=>{
        trackImpressionRef.current = trackImpression;
    }, []);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const onMouseEnter = (0, $42omo.useCallback)(()=>setIsHovered(true), []);
    const content = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $0c35e478cf8dbc82$export$da9d0159e5272189), {
                onBannerMessageViewed: onBannerMessageViewed,
                isHovered: isHovered
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $c8b08557d75a416b$var$textFieldBoxStyles,
                    setMinWidthStyles && $c8b08557d75a416b$var$minWidthStyles
                ],
                ref: inputBoxRef,
                onMouseEnter: onMouseEnter,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $icqFF.KeyboardHighlightProvider), {
                    listenerNode: effectiveInputRef?.current,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $33671f0d02952dbc$export$fb8d8fbc0c4c1705), {
                            dialogId: dialogId,
                            inputRef: effectiveInputRef,
                            localQuery: localQuery,
                            setLocalQuery: setLocalQuery,
                            textfieldComponent: textfieldComponent,
                            postQueryDisabled: postQueryDisabled,
                            customPlaceholder: customPlaceholder,
                            onGhostTextGenerated: onGhostTextGenerated,
                            intentRouterEnabled: intentRouterEnabled
                        }),
                        !isSSR && /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
                            children: quickFindOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverProvider), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $71af45ffeeb47c72$export$2aadebb53f6015f6), {
                                    dialogId: dialogId,
                                    dialogRef: dialogRef,
                                    inputRef: effectiveInputRef,
                                    localQuery: localQuery,
                                    setLocalQuery: setLocalQuery,
                                    PlacementPO: PlacementPO,
                                    showFilters: showFilters,
                                    searchRefreshStyling: searchRefreshStyling
                                })
                            })
                        }),
                        showFiltersRow && /*#__PURE__*/ (0, $l998X.jsx)((0, $b3d2eb85abd87b7a$export$876f25caa2b82f74), {})
                    ]
                })
            })
        ]
    });
    if (isSearchPagePOBannerPlacementEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $RWXHe.PlacementPortalContainerProvider), {
        value: bannerPortalContainerRef.current,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $RWXHe.TrackImpressionProvider), {
            value: onBannerVisible,
            children: content
        })
    });
    return content;
};
const $c8b08557d75a416b$export$68bbc91d7879f9e4 = ({ children: children, queryParams: actualQueryParams, callbacks: callbacks, ...props })=>{
    const { onSearchCompleted: onSearchCompleted } = callbacks ?? {};
    const customParams = props.primaryProduct?.includes((0, $1yEFx.ProductKeys).Jira) && (0, $dh538.fg)('search_quick_find_query_params_enable') ? {
        [(0, $a9fb8805b1f49851$export$7640e1e223f51f1a)]: (0, $hHl3d.SearchExperience).QUICK_FIND
    } : {};
    /**
	 * Quick Find does not need to set queryParams, hence using an object
	 * in a state variable as the queryParams object. Any interactions with
	 * the url should be done through onNavigate in the AppContext.
	 */ const [queryParams, setQueryParams] = (0, $42omo.useState)({
        text: actualQueryParams?.text,
        ...customParams
    });
    /**
	 * Quick Find only reacts to changes in the text query parameter when the
	 * user is on the search page.
	 */ const previousTextQueryParam = (0, $42omo.useRef)(actualQueryParams?.text);
    (0, $42omo.useEffect)(()=>{
        if (actualQueryParams?.text === previousTextQueryParam.current) return;
        let onSearchRoute = true; // Default to true in case URL parsing fails
        try {
            const generateSearchUrl = props.generateSearchUrl || (0, $1XDdH.defaultGenerateSearchUrl);
            const searchUrl = new URL(generateSearchUrl({}));
            const searchPath = searchUrl.pathname;
            const currentUrl = new URL(window.location.href);
            const currentPath = currentUrl.pathname;
            onSearchRoute = searchPath === currentPath;
        } catch  {
        // ignore error
        }
        if (onSearchRoute) setQueryParams((previousQueryParams)=>({
                ...previousQueryParams,
                text: actualQueryParams?.text
            }));
        previousTextQueryParam.current = actualQueryParams?.text;
    }, [
        actualQueryParams?.text,
        props.generateSearchUrl
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8aC7e.default), {
        ...props,
        queryParams: queryParams,
        callbacks: {
            onSearchCompleted: onSearchCompleted,
            updateQueryParameters: setQueryParams
        },
        statsigLayer: (0, $4OGlb.STATSIG_QUICK_FIND_LAYER),
        experience: (0, $hHl3d.SearchExperience).QUICK_FIND,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bHLTK.SearchStoreProvider), {
            experience: (0, $hHl3d.SearchExperience).QUICK_FIND,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f58c1f7467c49dec$export$5f60ff1bbe7f1a37), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $785f0e86c2e88315$export$40a6847b10816750), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e6c80dec8a0d452c$export$7d6ff8eec92df467), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7WbA8.AppContextProvider), {
                            ...props,
                            queryParams: queryParams,
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $c8b08557d75a416b$export$7d842d92e2721710 = ({ children: // eslint-disable-next-line no-unused-vars
children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "quick-find",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2lmJQ.default), {
            experience: (0, $hHl3d.SearchExperience).QUICK_FIND,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($c8b08557d75a416b$export$68bbc91d7879f9e4, {
                    ...props,
                    children: /*#__PURE__*/ (0, $l998X.jsx)($c8b08557d75a416b$var$QuickFindComponent, {
                        ...props
                    })
                })
            })
        })
    });
};



var $308Wd = parcelRequire("308Wd");


var $56QzY = parcelRequire("56QzY");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $9wGTI = parcelRequire("9wGTI");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $e4o8D = parcelRequire("e4o8D");


var $4VJDS = parcelRequire("4VJDS");


var $6OL2O = parcelRequire("6OL2O");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $3LDzU = parcelRequire("3LDzU");


var $kysoj = parcelRequire("kysoj");

const $5235a3f27f080bad$var$SEARCH_ROUTE_PRELOAD_DELAY = 500;
const $5235a3f27f080bad$var$QUICK_FIND_SEARCH_PERFORMED_EVENT_MUTATION = (0, $eSUdr.default)`mutation QuickFindSearchPerformedEventMutation($cloudId:ID!$resultCount:Int!$query:String!$timestamp:String!){confluence_generateSearchPerformedEvent(cloudId:$cloudId input:{resultCount:$resultCount query:$query timestamp:$timestamp}){success}}`;
const $5235a3f27f080bad$var$generateUserUrl = (userId, orgId)=>{
    return (0, $9wGTI.fg)('confluence-adopt-teams-nav-config') ? (0, $6OL2O.getNavigateToTeamsApp)(orgId, {
        type: 'USER',
        payload: {
            userId: userId
        }
    }).href : `/wiki/people/${userId}`;
};
const $5235a3f27f080bad$var$generateTeamUrl = (teamId, orgId)=>{
    return (0, $9wGTI.fg)('confluence-adopt-teams-nav-config') ? (0, $6OL2O.getNavigateToTeamsApp)(orgId, {
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    }).href : `/wiki/people/team/${teamId}`;
};
const $5235a3f27f080bad$var$useTextParameter = (0, $dPJCf.createSingleQueryParamHook)('text');
/**
 * Component that handles the search performed event mutation.
 * Wrapped in UFOInteractionIgnore to prevent the mutation from creating UFO holds.
 */ const $5235a3f27f080bad$var$SearchPerformedEventEmitter = ({ cloudId: cloudId, setHandleSearchCompletedRef: setHandleSearchCompletedRef })=>{
    const [generateSearchPerformedEvent] = (0, $308Wd.useMutationInterop)(// @ts-expect-error -- http://go/cfe-use-relay-artifacts
    $5235a3f27f080bad$var$QUICK_FIND_SEARCH_PERFORMED_EVENT_MUTATION);
    const handleSearchCompleted = (0, $42omo.useCallback)((resultCount, query)=>{
        if (!(0, $9wGTI.fg)('should_enable_confluence_search_performed_event')) return;
        generateSearchPerformedEvent({
            variables: {
                cloudId: cloudId,
                resultCount: resultCount || 0,
                query: query || '',
                timestamp: new Date().toISOString()
            }
        });
    }, [
        cloudId,
        generateSearchPerformedEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        setHandleSearchCompletedRef(handleSearchCompleted);
    }, [
        handleSearchCompleted,
        setHandleSearchCompletedRef
    ]);
    return null;
};
const $5235a3f27f080bad$export$8233bb098a93ad26 = (urlQueryParams)=>{
    const url = new URL('/wiki/search', window.location.origin);
    const searchParams = new URLSearchParams(window.location.search);
    Object.entries(urlQueryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
        else searchParams.delete(key);
    });
    url.search = searchParams.toString();
    return url.href;
};
const $5235a3f27f080bad$export$7d842d92e2721710 = ()=>{
    const [open, setOpen] = (0, $42omo.useState)(false);
    const { cloudId: cloudId, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId, displayName: displayName, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, preloadRoute: preloadRoute } = (0, $dPJCf.useRouteActions)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const inputRef = (0, $42omo.useRef)(null);
    const [persistedGhostText] = (0, $42omo.useState)(()=>(0, $kysoj.getPersistedGhostText)(inputRef));
    const onPersistGhostText = (0, $42omo.useCallback)((newGhostText)=>{
        if ((0, $9wGTI.fg)('quickfind-ghosttext')) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT, newGhostText);
    }, []);
    const textParameter = $5235a3f27f080bad$var$useTextParameter();
    const queryParams = (0, $42omo.useMemo)(()=>({
            text: textParameter
        }), [
        textParameter
    ]);
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            activationId: activationId,
            navdexPointType: (0, $56QzY.TOUCH)
        }), [
        activationId
    ]);
    const user = (0, $42omo.useMemo)(()=>({
            id: userId,
            name: displayName
        }), [
        userId,
        displayName
    ]);
    const experimentLayers = (0, $4VJDS.default).getStringList('search_platform_layer_functions', []);
    const preloadDataProvider = (0, $3LDzU.usePreloadDataProvider)();
    const handleSearchCompletedRef = (0, $42omo.useRef)(()=>{});
    const setHandleSearchCompletedRef = (0, $42omo.useCallback)((callback)=>{
        handleSearchCompletedRef.current = callback;
    }, []);
    const onNavigate = (0, $42omo.useCallback)((url)=>push(url), [
        push
    ]);
    const universalNavigationShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_NAVIGATION_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_NAVIGATION_SHORTCUT_WIN);
    const onGenerateUserUrl = (0, $42omo.useCallback)((userIdParam)=>$5235a3f27f080bad$var$generateUserUrl(userIdParam, orgId ?? ''), [
        orgId
    ]);
    const onGenerateTeamUrl = (0, $42omo.useCallback)((teamIdParam)=>$5235a3f27f080bad$var$generateTeamUrl(teamIdParam, orgId ?? ''), [
        orgId
    ]);
    const callbacks = (0, $42omo.useMemo)(()=>({
            onSearchCompleted: (resultCount, query)=>handleSearchCompletedRef.current(resultCount, query)
        }), []);
    const onOpenQuickFind = (0, $42omo.useCallback)(()=>setOpen(true), []);
    const preloadedRef = (0, $42omo.useRef)(false);
    const onGenerateSearchUrlWithPreload = (0, $42omo.useCallback)((urlQueryParams)=>{
        const url = $5235a3f27f080bad$export$8233bb098a93ad26(urlQueryParams);
        if (!preloadedRef.current) setTimeout(()=>{
            const onIdle = window.requestIdleCallback || window.requestAnimationFrame || ((cb)=>setTimeout(cb, 0));
            onIdle(()=>preloadRoute(url));
        }, $5235a3f27f080bad$var$SEARCH_ROUTE_PRELOAD_DELAY);
        preloadedRef.current = true;
        return url;
    }, [
        preloadRoute
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5235a3f27f080bad$var$SearchPerformedEventEmitter, {
        cloudId: cloudId,
        setHandleSearchCompletedRef: setHandleSearchCompletedRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8b08557d75a416b$export$7d842d92e2721710), {
        cloudId: cloudId,
        orgId: orgId,
        primaryProduct: "confluence",
        analyticsAttributes: analyticsAttributes,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isNav4Enabled: true,
        onNavigate: onNavigate,
        queryParams: queryParams,
        open: open,
        setOpen: setOpen,
        user: user,
        generateSearchUrl: onGenerateSearchUrlWithPreload,
        generateUserUrl: onGenerateUserUrl,
        generateTeamUrl: onGenerateTeamUrl,
        experimentLayers: experimentLayers,
        preloadDataProvider: preloadDataProvider,
        isRovoLLMEnabled: isRovoLLMEnabled,
        isSSR: renderServerPlaceholder,
        customPlaceholder: persistedGhostText,
        onGhostTextGenerated: onPersistGhostText,
        inputRef: inputRef,
        callbacks: callbacks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.NAVIGATION_SHORTCUT) : undefined,
        accelerator: isLiveEditMode || isOnEditRoute ? universalNavigationShortcut : [
            universalNavigationShortcut,
            (0, $gnkil.NAVIGATION_SLASH_SHORTCUT)
        ],
        listener: onOpenQuickFind,
        isAppNavigationShortcut: true
    }));
};
module.exports["generateSearchUrl"] = $5235a3f27f080bad$export$8233bb098a93ad26;
module.exports["QuickFind"] = $5235a3f27f080bad$export$7d842d92e2721710;

});

parcelRegister("elKbB", function(module, exports) {
const $e6541db2861321d0$export$52027d47033ea8ad = {
    GNIN: 'GNIN',
    FPS: 'FPS'
};
const $e6541db2861321d0$export$2bc60b2a116fbfaf = {
    QUICK_FIND: 'QUICK_FIND'
};
const $e6541db2861321d0$export$190afca79c4d2b21 = {
    GNIN_HEURISTIC: 'GNIN_HEURISTIC',
    FPS_HEURISTIC: 'FPS_HEURISTIC'
};
module.exports["KnowledgeDiscoveryJiraSearchClassification"] = $e6541db2861321d0$export$52027d47033ea8ad;
module.exports["KnowledgeDiscoveryJiraSearchExperience"] = $e6541db2861321d0$export$2bc60b2a116fbfaf;
module.exports["KnowledgeDiscoveryJiraIntentDetectionModel"] = $e6541db2861321d0$export$190afca79c4d2b21;

});

parcelRegister("eOylV", function(module, exports) {

let $ac9061ea52d597fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac9061ea52d597fe$var$load("7nW1A"),
    $ac9061ea52d597fe$var$load("cM9rX"),
    $ac9061ea52d597fe$var$load("hv4mn"),
    $ac9061ea52d597fe$var$load("dYtBN"),
    $ac9061ea52d597fe$var$load("6wr18"),
    $ac9061ea52d597fe$var$load("kjZZD"),
    $ac9061ea52d597fe$var$load("ffEVr"),
    $ac9061ea52d597fe$var$load("dTsOE"),
    $ac9061ea52d597fe$var$load("hhss7"),
    $ac9061ea52d597fe$var$load("hogcU"),
    $ac9061ea52d597fe$var$load("fjYIR"),
    $ac9061ea52d597fe$var$load("EfTik")
]).then(()=>parcelRequire('1JhVb'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("abk4V", function(module, exports) {

var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $5JS4G = parcelRequire("5JS4G");

const $24d5352d830b0390$var$accountsByAaIdCache = (0, $jnPv4.promiseCache)({
    name: 'accounts-by-aaid-cache',
    expiration: 1800000
});
const $24d5352d830b0390$export$8fc8913ba4f36c51 = async (aaid)=>{
    const url = `/gateway/api/outbound-auth/aaId/${aaid}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new (0, $5JS4G.OutboundAuthApiError)('Failed to fetch accounts by aaId');
    return await response.json();
};
const $24d5352d830b0390$export$75264ee4f9af0fe1 = async ({ aaid: aaid, onlyRefreshIfExpired: onlyRefreshIfExpired = true, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired = false })=>{
    const supplier = ()=>{
        const accountsPromise = $24d5352d830b0390$export$8fc8913ba4f36c51(aaid);
        const degrader = new (0, $3Tbc2.DegradablePromise)(accountsPromise, degradationCallback);
        return degrader.promise();
    };
    const cacheKey = aaid;
    return $24d5352d830b0390$var$accountsByAaIdCache.refreshOnAccessDecorator({
        key: cacheKey,
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback
    });
};
module.exports["fetchAccountsByAaId"] = $24d5352d830b0390$export$75264ee4f9af0fe1;

});

parcelRegister("7ULiR", function(module, exports) {

var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $5JS4G = parcelRequire("5JS4G");

const $1201c3527525730b$var$outboundAuthCache = (0, $jnPv4.promiseCache)({
    name: 'outbound-auth-cache',
    expiration: 300000
});
const $1201c3527525730b$export$782ebc7c03980a9a = async (aaid, containerId, serviceKey)=>{
    const queryParams = new URLSearchParams();
    if (serviceKey) {
        queryParams.append('serviceKey', serviceKey);
        // include=aaId - This bypasses token refresh and profile fetching operations. Adding include=accessToken can trigger token refresh from external providers, and omitting this include query parameter would result in displayName and avatarUrl being added by default to includeFields, which can trigger external API calls for profile data.
        queryParams.append('include', 'aaid');
    }
    const queryString = queryParams.toString();
    const url = `/gateway/api/outbound-auth/aaId/${aaid}/container/${containerId}${queryString ? `?${queryString}` : ''}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new (0, $5JS4G.OutboundAuthApiError)('Failed to fetch outbound auth by aaid and container id');
    return await response.json();
};
const $1201c3527525730b$export$d4802be6b6981d7f = async ({ aaid: aaid, containerId: containerId, serviceKey: serviceKey, onlyRefreshIfExpired: onlyRefreshIfExpired = true, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired = false })=>{
    const supplier = ()=>{
        const outboundAuthPromise = $1201c3527525730b$export$782ebc7c03980a9a(aaid, containerId, serviceKey);
        const degrader = new (0, $3Tbc2.DegradablePromise)(outboundAuthPromise, degradationCallback);
        return degrader.promise();
    };
    const cacheKey = `${aaid}-${containerId}-${serviceKey}`;
    return $1201c3527525730b$var$outboundAuthCache.refreshOnAccessDecorator({
        key: cacheKey,
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback
    });
};
module.exports["fetchOutboundAuthData"] = $1201c3527525730b$export$d4802be6b6981d7f;

});

parcelRegister("2Kn8h", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");

const $791b0854bf4c25c7$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    id
    title
    type
    subtype
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $791b0854bf4c25c7$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    id
    title
    type
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $791b0854bf4c25c7$export$5db520940cf00715 = 'QuickFindUserDocumentsQuery';
const $791b0854bf4c25c7$export$d55cf2ce517f0208 = `
  query ${$791b0854bf4c25c7$export$5db520940cf00715} (
    $userId: String!,
    $tenantId: String!,
    $caller: String!,
    $maxNumberOfResults: Int!
  ) {
    smarts {
      recommendedObject(
        recommendationsQuery: {
          context: {
            userId: $userId
            tenantId: $tenantId
          }, modelRequestParams: {
            caller: $caller
            experience: "ConfUserPages"
          }, 
          requestingUserId: $userId 
          maxNumberOfResults: $maxNumberOfResults
        }
      ) {
        id
        score
        reason
        object {
          ...ConfluencePageFragment
          ...ConfluenceBlogPostFragment
        }
      }
    }
  }
  ${$791b0854bf4c25c7$var$ConfluencePageFragment}
  ${$791b0854bf4c25c7$var$ConfluenceBlogPostFragment}
`;


const $faa27dea184f5d3b$var$QUICK_FIND_USER_DOCUMENTS_CACHE_KEY = 'quick-find-user-documents';
const $faa27dea184f5d3b$var$FAILURE_EXPIRATION_MS = 5000; // 5 seconds for failure
const $faa27dea184f5d3b$var$SUCCESS_EXPIRATION_MS = 300000; // 5 minutes for success
const $faa27dea184f5d3b$export$f17eccb8f0d1390 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $791b0854bf4c25c7$export$d55cf2ce517f0208),
        operationName: $791b0854bf4c25c7$export$5db520940cf00715,
        headers: headers
    });
};
const { refreshOnAccessDecorator: $faa27dea184f5d3b$var$refreshOnAccessDecoratorUserDocuments, clear: $faa27dea184f5d3b$var$clearUserDocumentsCache } = (0, $jnPv4.promiseCache)({
    name: $faa27dea184f5d3b$var$QUICK_FIND_USER_DOCUMENTS_CACHE_KEY
});
const $faa27dea184f5d3b$export$d5cc5053cec68715 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, expiration: expiration, onlyRefreshIfExpired: onlyRefreshIfExpired, returnExpired: returnExpired, headers: headers })=>{
    const cacheKey = (0, $2qzBQ.generateHash)(`${$faa27dea184f5d3b$var$QUICK_FIND_USER_DOCUMENTS_CACHE_KEY}|${JSON.stringify(variables)}`).toString();
    const writeBackWithTTL = (value, ttl)=>{
        $faa27dea184f5d3b$var$refreshOnAccessDecoratorUserDocuments({
            key: cacheKey,
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $faa27dea184f5d3b$var$refreshOnAccessDecoratorUserDocuments({
        key: cacheKey,
        supplier: async ()=>{
            try {
                const result = await $faa27dea184f5d3b$export$f17eccb8f0d1390({
                    variables: variables,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    headers: headers
                });
                writeBackWithTTL(result, $faa27dea184f5d3b$var$SUCCESS_EXPIRATION_MS);
                return result;
            } catch (error) {
                // On failure, cache the rejected promise with a short TTL to avoid hammering the service
                // This ensures the error is still thrown when accessed, but prevents immediate retries
                writeBackWithTTL(Promise.reject(error), $faa27dea184f5d3b$var$FAILURE_EXPIRATION_MS);
                // Re-throw the error so the caller knows the request failed
                throw error;
            }
        },
        expiration: expiration,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        returnExpired: returnExpired
    });
};
const $faa27dea184f5d3b$export$24831cfcdf1e0a31 = (key)=>$faa27dea184f5d3b$var$clearUserDocumentsCache(key);
module.exports["userDocumentsQuery"] = $faa27dea184f5d3b$export$f17eccb8f0d1390;
module.exports["cachedUserDocumentsQuery"] = $faa27dea184f5d3b$export$d5cc5053cec68715;

});

parcelRegister("bz34M", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");

const $77131a80a267b232$export$5db520940cf00715 = 'KnowledgeDiscoveryZeroQueries';
const $77131a80a267b232$export$c6209ded7eb543e2 = `
  query ${$77131a80a267b232$export$5db520940cf00715}($cloudId: String!, $product: KnowledgeDiscoveryProduct) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries") {
			zeroQueries(cloudId: $cloudId, product: $product) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {
                    zeroQueries {
                        query
                        type
						product
						accountId
						avatarUrl
						dateRange
					}
                }
            }
		}
	}
`;
const $77131a80a267b232$export$7a489cc87c267c4 = 'MarkZeroQueryInteracted';
const $77131a80a267b232$export$e15ac8a4356bed82 = `
	mutation ${$77131a80a267b232$export$7a489cc87c267c4}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted") {
			markZeroQueryInteracted(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;
const $77131a80a267b232$export$c279dc9ea93aad98 = 'KnowledgeDiscoveryZeroQueriesV1';
const $77131a80a267b232$export$cca6d12b1794e42a = `
  query ${$77131a80a267b232$export$c279dc9ea93aad98}($cloudId: String!, $product: KnowledgeDiscoveryProduct) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries V1") {
			zeroQueriesV1(cloudId: $cloudId, product: $product) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {
                    zeroQueries {
                        query
                        type
						product
						accountId
						avatarUrl
						dateRange
					}
                }
            }
		}
	}
`;
const $77131a80a267b232$export$2650522d8a738e7e = 'MarkZeroQueryInteractedV1';
const $77131a80a267b232$export$93c9ddb071659b5e = `
	mutation ${$77131a80a267b232$export$2650522d8a738e7e}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted V1") {
			markZeroQueryInteractedV1(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;


const $8001a232370fdb69$export$4e6f8f14fd5cfc8c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $77131a80a267b232$export$c6209ded7eb543e2),
        variables: variables,
        operationName: $77131a80a267b232$export$5db520940cf00715,
        headers: headers
    });
};
const $8001a232370fdb69$export$2338c914f7e7b6c6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $77131a80a267b232$export$cca6d12b1794e42a),
        variables: variables,
        operationName: (0, $77131a80a267b232$export$c279dc9ea93aad98),
        headers: headers
    });
};
const $8001a232370fdb69$export$8cd0dd2078791744 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $77131a80a267b232$export$e15ac8a4356bed82),
        variables: variables,
        operationName: (0, $77131a80a267b232$export$7a489cc87c267c4),
        headers: headers
    });
};
const $8001a232370fdb69$export$2ffea0896a0ec5f = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $77131a80a267b232$export$93c9ddb071659b5e),
        variables: variables,
        operationName: (0, $77131a80a267b232$export$2650522d8a738e7e),
        headers: headers
    });
};
module.exports["zeroQueriesQuery"] = $8001a232370fdb69$export$4e6f8f14fd5cfc8c;
module.exports["zeroQueriesQueryV1"] = $8001a232370fdb69$export$2338c914f7e7b6c6;
module.exports["zeroQueriesMutation"] = $8001a232370fdb69$export$8cd0dd2078791744;
module.exports["zeroQueriesMutationV1"] = $8001a232370fdb69$export$2ffea0896a0ec5f;

});

parcelRegister("kPBHE", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $1e87bb95c8c7b16d$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
    // Hack?
    const Component = linkComponent || 'a';
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ...props
    });
};
module.exports["Link"] = $1e87bb95c8c7b16d$export$a6c7ac8248d6e38a;

});

parcelRegister("k0e2P", function(module, exports) {

let $e8feb3b4f826d88d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8feb3b4f826d88d$var$load("4KiYL").then(()=>parcelRequire('9Wb1k'));

});

parcelRegister("lh6Pw", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $0ccc59682dfec4cc$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME = 'KnowledgeDiscoveryJiraIntentDetectionQuery';
/**
 * GraphQL query string for Jira intent detection.
 */ const $0ccc59682dfec4cc$var$jiraIntentDetectionQueryString = `query ${$0ccc59682dfec4cc$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME}(
	$siteId: String!
	$orgId: String!
	$query: String!
	$experience: KnowledgeDiscoveryJiraSearchExperience!
	$model: KnowledgeDiscoveryJiraIntentDetectionModel!
	$sessionId: String
) {
	knowledgeDiscovery {
		jiraIntentDetection(
			siteId: $siteId
			orgId: $orgId
			query: $query
			experience: $experience
			model: $model
			sessionId: $sessionId
		) @optIn(to: "KnowledgeDiscovery Jira Intent Detection") {
			__typename
			... on KnowledgeDiscoveryJiraIntentDetection {
				searchClassification {
					type
				}
			}
			... on QueryError {
				message
			}
		}
	}
}`;
const $0ccc59682dfec4cc$export$56db430dd07e9e8c = (0, $hw4j5.inMemoryCache)();
const $0ccc59682dfec4cc$export$9e4d70b1495bfcd7 = async (variables, headers)=>{
    const cacheKey = $0ccc59682dfec4cc$export$aa68fd26e593cc7e(variables);
    return $0ccc59682dfec4cc$export$56db430dd07e9e8c.inMemoryDecorator(cacheKey, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $0ccc59682dfec4cc$var$jiraIntentDetectionQueryString,
            variables: variables,
            operationName: $0ccc59682dfec4cc$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'KnowledgeDiscovery',
                ...headers
            }
        });
        const hasGraphQLErrors = response.errors?.some((error)=>error);
        if (hasGraphQLErrors) return Promise.reject(response);
        const result = response.data?.knowledgeDiscovery.jiraIntentDetection;
        if (result?.__typename === 'QueryError') return Promise.reject(response);
        return response;
    });
};
const $0ccc59682dfec4cc$export$aa68fd26e593cc7e = (variables)=>{
    const { siteId: siteId, orgId: orgId, query: query, experience: experience, model: model } = variables;
    const parts = [
        siteId,
        orgId,
        query,
        experience
    ];
    if (model) parts.push(model);
    return parts.join(':');
};
function $0ccc59682dfec4cc$export$5f50223bd877b041(result) {
    return result?.__typename === 'KnowledgeDiscoveryJiraIntentDetection';
}
function $0ccc59682dfec4cc$export$a6431174920baed1(result) {
    return result?.__typename === 'QueryError';
}
module.exports["jiraIntentDetectionQuery"] = $0ccc59682dfec4cc$export$9e4d70b1495bfcd7;
module.exports["isIntentDetectionSuccess"] = $0ccc59682dfec4cc$export$5f50223bd877b041;

});

parcelRegister("8PWzv", function(module, exports) {

let $66f08542dbbb37a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66f08542dbbb37a4$var$load("4KiYL").then(()=>parcelRequire('iTSW4'));

});

parcelRegister("ejJrc", function(module, exports) {

let $a6c61608bfd4511e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a6c61608bfd4511e$var$load("4KiYL").then(()=>parcelRequire('6r800'));

});

parcelRegister("6FG5J", function(module, exports) {
var $2408c829587bdd21$export$37f28874ca0f7950 = /*#__PURE__*/ function(ZeroQueryProduct) {
    ZeroQueryProduct["CONFLUENCE"] = "CONFLUENCE";
    ZeroQueryProduct["JIRA"] = "JIRA";
    ZeroQueryProduct["GOOGLE"] = "GOOGLE";
    ZeroQueryProduct["SLACK"] = "SLACK";
    ZeroQueryProduct["SHAREPOINT"] = "SHAREPOINT";
    return ZeroQueryProduct;
}({});
var $2408c829587bdd21$export$9573eaa7882f441b = /*#__PURE__*/ function(ZeroQueryDateRange) {
    ZeroQueryDateRange["TODAY"] = "today";
    ZeroQueryDateRange["YESTERDAY"] = "yesterday";
    ZeroQueryDateRange["PAST_7_DAYS"] = "past7days";
    ZeroQueryDateRange["PAST_30_DAYS"] = "past30days";
    return ZeroQueryDateRange;
}({});
var $2408c829587bdd21$export$32809655ff50de86 = /*#__PURE__*/ function(ZeroQueryType) {
    ZeroQueryType["COLLABORATOR_PROFILE"] = "COLLABORATOR_PROFILE";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED"] = "CONFLUENCE_PAGES_CREATED";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_30_DAYS"] = "CONFLUENCE_PAGES_CREATED_30_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_7_DAYS"] = "CONFLUENCE_PAGES_CREATED_7_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS";
    ZeroQueryType["JIRA_MY_WORK_ITEMS"] = "JIRA_MY_WORK_ITEMS";
    ZeroQueryType["JIRA_NLQ"] = "JIRA_NLQ";
    ZeroQueryType["JIRA_NLQ_COLLABORATOR"] = "JIRA_NLQ_COLLABORATOR";
    ZeroQueryType["JIRA_TICKETS_ASSIGNED"] = "JIRA_TICKETS_ASSIGNED";
    ZeroQueryType["JIRA_TICKETS_ASSIGNED_COLLABORATOR"] = "JIRA_TICKETS_ASSIGNED_COLLABORATOR";
    ZeroQueryType["JIRA_TICKETS_CREATED"] = "JIRA_TICKETS_CREATED";
    ZeroQueryType["JIRA_TICKETS_CREATED_COLLABORATOR"] = "JIRA_TICKETS_CREATED_COLLABORATOR";
    ZeroQueryType["RECENT_WORK"] = "RECENT_WORK";
    ZeroQueryType["RELATED_QUESTION"] = "RELATED_QUESTION";
    ZeroQueryType["THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS"] = "THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS";
    ZeroQueryType["THIRD_PARTY_GOOGLE_MY_DOCS"] = "THIRD_PARTY_GOOGLE_MY_DOCS";
    ZeroQueryType["THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS"] = "THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS";
    ZeroQueryType["THIRD_PARTY_SHAREPOINT_MY_DOCS"] = "THIRD_PARTY_SHAREPOINT_MY_DOCS";
    ZeroQueryType["THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES"] = "THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES";
    ZeroQueryType["THIRD_PARTY_SLACK_MY_MESSAGES"] = "THIRD_PARTY_SLACK_MY_MESSAGES";
    ZeroQueryType["WHO_IS"] = "WHO_IS";
    return ZeroQueryType;
}({});
module.exports["ZeroQueryProduct"] = $2408c829587bdd21$export$37f28874ca0f7950;
module.exports["ZeroQueryDateRange"] = $2408c829587bdd21$export$9573eaa7882f441b;
module.exports["ZeroQueryType"] = $2408c829587bdd21$export$32809655ff50de86;

});

parcelRegister("fsMoS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $iPfZG = parcelRequire("iPfZG");

var $lgqtG = parcelRequire("lgqtG");

var $2Ehdd = parcelRequire("2Ehdd");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $frIzR = parcelRequire("frIzR");





var $bQm3c = parcelRequire("bQm3c");


var $iSamx = parcelRequire("iSamx");

const $236feafa6fe3ed5c$export$80d66f5e04b5ca9e = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { channel: channel, targetActionSubjects: targetActionSubjects, children: children } = t0;
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== activationId || $[1] !== targetActionSubjects) {
        t1 = (payload)=>{
            let data = payload.data || payload;
            if (!targetActionSubjects || targetActionSubjects.includes(data.actionSubjectId) || targetActionSubjects.includes(data.actionSubject)) data = {
                ...data,
                attributes: {
                    ...data.attributes,
                    activationId: activationId
                }
            };
            if (payload.data) {
                if (payload.data !== data) return {
                    ...payload,
                    data: data
                };
                return payload;
            }
            return data;
        };
        $[0] = activationId;
        $[1] = targetActionSubjects;
        $[2] = t1;
    } else t1 = $[2];
    const eventUpdater = t1;
    const t2 = channel || "*";
    let t3;
    if ($[3] !== children || $[4] !== eventUpdater || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iSamx.AddAttributesWrapper), {
            eventUpdater: eventUpdater,
            channel: t2
        }, children);
        $[3] = children;
        $[4] = eventUpdater;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};



var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $1YXTQ = parcelRequire("1YXTQ");


var $ge2sX = parcelRequire("ge2sX");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");





var $l998X = parcelRequire("l998X");





var $czt8s = parcelRequire("czt8s");


var $6a9Hv = parcelRequire("6a9Hv");


var $12cJV = parcelRequire("12cJV");

function $62cd9cdd84f4378e$export$59a963eec12b52ed(responseError) {
    let stringRepresentation = 'undefined';
    // Check if error response has a nested 'message' object, if so we use that instead.
    const error = responseError.message ? responseError.message : responseError;
    if (error) {
        // Convert it to string directly by default
        stringRepresentation = String(error);
        // If the error is an object we will try to JSON parse it
        if (typeof error === 'object') try {
            // Try to parse it as JSON
            stringRepresentation = JSON.stringify(responseError);
        } catch  {
        // Swallow all stringify errors
        }
    }
    return new Error(stringRepresentation);
}


var $42a3e378fee7fe01$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    return Scope;
}({});
const $42a3e378fee7fe01$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $42a3e378fee7fe01$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $42a3e378fee7fe01$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $42a3e378fee7fe01$export$80a5be864676016b = 'confluence.space';
const $42a3e378fee7fe01$export$70542451ad6057d2 = 'urs.user-confluence';
const $42a3e378fee7fe01$export$6ec00f56b27cdc1d = 'generic-container-result';
const $42a3e378fee7fe01$export$ca1a50bc869949e = 'person-result';
const $42a3e378fee7fe01$export$a99961038e9d5471 = 'confluence-object-result';
const $42a3e378fee7fe01$export$18c69de2b4aa679c = 'recent-confluence';
const $42a3e378fee7fe01$export$dc31f0db54ab1a30 = 'result-confluence';
const $42a3e378fee7fe01$export$cb8b6c470492bee8 = 'recent-person';
const $42a3e378fee7fe01$export$ebb42dafe7a39a20 = 'result-person';
const $42a3e378fee7fe01$export$602b44a55c824e30 = 'advanced-search-confluence';
const $42a3e378fee7fe01$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $42a3e378fee7fe01$export$bbd1709e62826142 = 'confluence-page';
const $42a3e378fee7fe01$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $42a3e378fee7fe01$export$b441f0c13fd510b9 = 'confluence-attachment';
const $42a3e378fee7fe01$export$8ee8726ca4e2f8bd = 'confluence-space';
const $42a3e378fee7fe01$export$d0e824889e01c751 = 'person';



var $3NyIw = parcelRequire("3NyIw");


var $kfImN = parcelRequire("kfImN");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $dwp40 = parcelRequire("dwp40");


var $9Nzn7 = parcelRequire("9Nzn7");




const $8a95e0dcc4ebe080$export$8c5e9a2b7d8e96fa = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:blogpost'
];
const $8a95e0dcc4ebe080$export$f8e8a5f34f6ea725 = `
query($query: String, $entities:[String!]!, $locations: [String!]!, $confluenceFilters: SearchConfluenceFilter, $experience: String!){
  search{
    search(
      query: $query
      filters: {entities: $entities, locations: $locations, confluenceFilters: $confluenceFilters}
      analytics: {searchSessionId: "graphql"}
      experience: $experience
    ) {
      edges {
        node {
          id
          title
          url
          description
          type
          lastModifiedDate
          __typename
          ... on SearchConfluencePageBlogAttachment {
            type
            space {
              key
              iconUrl
            }
          }
        }
      }
    }
  }
}`;
const $8a95e0dcc4ebe080$export$13404986e7746e72 = (sites, cloudId)=>{
    const cloudIds = sites.length > 0 ? sites : [
        cloudId
    ];
    const locations = cloudIds.map((cloudId)=>`ari:cloud:confluence::site/${cloudId}`);
    return locations;
};
const $8a95e0dcc4ebe080$export$2351037d7dbc8a11 = (filters)=>{
    return {
        spaceFilter: filters.filter((filter)=>filter.type === 'space').map((filter)=>filter.id),
        contributorsFilter: filters.filter((filter)=>filter.type === 'contributor').map((filter)=>filter.id)
    };
};



var $dh538 = parcelRequire("dh538");

function $49259ccb7bc3dbc4$export$14ef296862e3705e({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product = 'platform' }) {
    if (!(0, $dh538.fg)('psd_agg_atl_attribution_header')) return;
    const atlAttributionHeader = {
        ...atlWorkspaceId ? {
            atlWorkspaceId: atlWorkspaceId
        } : {},
        tenantId: tenantId,
        product: product
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
}


class $f42a017b762dc955$export$b0f268a6eae2cdf1 {
    async search({ query: query, // todo
    context: _context, entities: entities, // todo
    modelParams: _modelParams, // todo
    resultLimit: _resultLimit, filters: filters, experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, $kfImN.limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
        const locations = (0, $8a95e0dcc4ebe080$export$13404986e7746e72)(cloudIdsToFilterOn, cloudId);
        const body = {
            query: (0, $8a95e0dcc4ebe080$export$f8e8a5f34f6ea725),
            variables: {
                locations: locations,
                entities: entities,
                query: query,
                confluenceFilters: filters,
                experience: experience
            }
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $9Nzn7.timed)(this.makePostRequest($f42a017b762dc955$export$b0f268a6eae2cdf1.GRAPHQL_API_URL, body));
        return {
            response: {
                rawData: response
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(0, $49259ccb7bc3dbc4$export$14ef296862e3705e)({
                            tenantId: this.cloudId
                        })
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
// Static URLs
$f42a017b762dc955$export$b0f268a6eae2cdf1.GRAPHQL_API_URL = 'graphql';



const $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
const $da2db4559cce8604$var$EMPTY_RESULT_PROMISE = Promise.resolve({
    items: [],
    timings: 0
});
class $da2db4559cce8604$export$2bdc82bf1cf036b4 {
    /**
   * Makes a search across all relevant scopes.
   */ search(query, filters, context, queryVersion, sites) {
        const modelParams = [
            {
                '@type': 'queryParams',
                queryVersion: queryVersion
            }
        ];
        if (filters.length > 0) return this.searchWithFilters(query, filters, context, modelParams, sites);
        if (this.useGraphQLClient) // TODO: convert this response to expected confluence search response
        this.graphQLClient.search({
            query: query,
            context: context,
            entities: (0, $8a95e0dcc4ebe080$export$8c5e9a2b7d8e96fa),
            modelParams: modelParams,
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        const scopes = [
            this.scopes.itemScope,
            this.scopes.spaceScope,
            this.scopes.ursUserScope
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: modelParams,
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        const allResults = {
            [(0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluencePageBlogAttachment]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope(this.scopes.itemScope), requestDurationMs))),
            [(0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluenceSpace]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope(this.scopes.spaceScope), requestDurationMs))),
            [(0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope(this.scopes.ursUserScope), requestDurationMs, sites.length > 0)))
        };
        return allResults;
    }
    searchSpaces(query, context, sites) {
        const scopes = [
            (0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluenceSpace
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: [],
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.SPACE_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        return (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope((0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluenceSpace), requestDurationMs)));
    }
    searchUsers(query, context, sites) {
        const scopes = [
            (0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: [],
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        return (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence), requestDurationMs, sites.length > 0)));
    }
    getRecentPeople(context, sites) {
        const { fromCache: fromCache, value: value } = this.bootstrapPeopleCache.get(context, sites);
        return new (0, $czt8s.CancellablePromise)(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    /**
   * Check the user permissions for the given list of products.
   */ async getProductPermissions(products) {
        if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE);
        return this.permissionsDataCache;
    }
    async getAbTestData() {
        if (this.abTestDataCache) return this.abTestDataCache;
        const abTest = await this.aggregatorClient.getAbTestData((0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluencePageBlogAttachment, $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE);
        this.abTestDataCache = abTest;
        return abTest;
    }
    mapConfItem(response, timings) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluencePageBlogAttachment}`);
        if (response.error) throw (0, $62cd9cdd84f4378e$export$59a963eec12b52ed)(response.error);
        function removeHighlightTags(text) {
            return text.replace(/@@@hl@@@|@@@endhl@@@/g, '');
        }
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ const items = response.results.map((item)=>({
                resultId: item.content.id,
                // content always available for pages/blogs/attachments // TODO
                name: removeHighlightTags(item.title),
                href: `${item.baseUrl}${item.url}`,
                containerName: item.container.title,
                analyticsType: (0, $42a3e378fee7fe01$export$dc31f0db54ab1a30),
                contentType: `confluence-${item.content.type}`,
                resultType: (0, $42a3e378fee7fe01$export$a99961038e9d5471),
                containerId: item.content.space && item.content.space.id ? item.content.space.id : 'UNAVAILABLE',
                spaceId: item.container.id,
                iconClass: item.iconCssClass,
                lastModified: item.lastModified,
                isRecentResult: false
            }));
        /* eslint-enable */ return {
            items: items,
            totalSize: response.size !== undefined ? response.size : response.results.length,
            timings: timings
        };
    }
    mapConfSpace(response, timings) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluenceSpace}`);
        if (response.error) throw (0, $62cd9cdd84f4378e$export$59a963eec12b52ed)(response.error);
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ const items = response.results.map((item)=>({
                resultId: item.id,
                avatarUrl: `${item.baseUrl}${item.space.icon.path}`,
                name: item.container.title,
                href: `${item.baseUrl || ''}${item.container.displayUrl}`,
                analyticsType: (0, $42a3e378fee7fe01$export$dc31f0db54ab1a30),
                resultType: (0, $42a3e378fee7fe01$export$6ec00f56b27cdc1d),
                contentType: (0, $42a3e378fee7fe01$export$8ee8726ca4e2f8bd),
                key: item.space.key,
                // TODO
                id: item.id
            }));
        /* eslint-enable */ return {
            items: items,
            timings: timings
        };
    }
    constructor(config, collabGraphClient){
        this.aggregatorClient = void 0;
        this.graphQLClient = void 0;
        this.siteMasterList = void 0;
        this.collaborationGraphClient = void 0;
        this.isCollabGraphEnabled = void 0;
        this.isUserAnonymous = void 0;
        this.useGraphQLClient = void 0;
        this.scopes = void 0;
        this.bootstrapPeopleCache = void 0;
        this.abTestDataCache = null;
        this.permissionsDataCache = null;
        this.searchWithFilters = (query, filters, context, modelParams, sites)=>{
            const scopes = [
                (0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluencePageBlogAttachment
            ];
            const allFilters = [];
            let baseSpaceFilters = null;
            let baseUserFilters = null;
            let baseTimeFilters = null;
            // TODO: GraphQL queries with filters
            filters.forEach((filter)=>{
                switch(filter.type){
                    case 'space':
                        if (!baseSpaceFilters) {
                            baseSpaceFilters = {
                                '@type': 'spaces',
                                spaceKeys: []
                            };
                            allFilters.push(baseSpaceFilters);
                        }
                        baseSpaceFilters.spaceKeys.push(filter.id);
                        break;
                    case 'contributor':
                        if (!baseUserFilters) {
                            baseUserFilters = {
                                '@type': 'contributors',
                                accountIds: []
                            };
                            allFilters.push(baseUserFilters);
                        }
                        baseUserFilters.accountIds.push(filter.id);
                        break;
                    case 'lastModified':
                        if (!baseTimeFilters) {
                            baseTimeFilters = {
                                '@type': 'lastModified',
                                from: filter.id
                            };
                            allFilters.push(baseTimeFilters);
                        }
                        break;
                    default:
                        break;
                }
            });
            const responseAndTiming = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
                filters: allFilters,
                experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            const results = {
                [(0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluencePageBlogAttachment]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope((0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluencePageBlogAttachment), requestDurationMs))),
                [(0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluenceSpace]: (0, $czt8s.CancellablePromise).from($da2db4559cce8604$var$EMPTY_RESULT_PROMISE),
                [(0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence]: (0, $czt8s.CancellablePromise).from($da2db4559cce8604$var$EMPTY_RESULT_PROMISE)
            };
            return results;
        };
        this.recentPeopleSupplier = (context, sites)=>{
            if (this.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0
            });
            if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getUsers().then((response)=>this.mapCollabGraphPeople(response));
            return this.aggregatorClient.search({
                query: '',
                context: context,
                scopes: [
                    (0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence
                ],
                modelParams: [],
                resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
                experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites?.map((s)=>s.cloudId)
            }).then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence), requestDurationMs, sites.length > 0));
        };
        this.mapUrsPeople = (response, timings, isMultiSite)=>{
            if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence}`);
            if (response.error) throw (0, $62cd9cdd84f4378e$export$59a963eec12b52ed)(response.error);
            const items = response.results.map((item)=>({
                    resultType: (0, $42a3e378fee7fe01$export$ca1a50bc869949e),
                    resultId: `people-${item.id}`,
                    userId: item.id,
                    name: item.name,
                    href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
                    avatarUrl: item.avatarUrl,
                    contentType: (0, $42a3e378fee7fe01$export$d0e824889e01c751),
                    analyticsType: (0, $42a3e378fee7fe01$export$ebb42dafe7a39a20),
                    mentionName: item.nickname || '',
                    presenceMessage: ''
                }));
            return {
                items: (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(items, (item)=>item.resultId),
                timings: timings
            };
        };
        this.mapCollabGraphPeople = (response)=>{
            const items = response.collaborationGraphEntities.map((item)=>({
                    resultId: item.userProfile.account_id,
                    userId: item.userProfile.account_id,
                    name: item.userProfile.name,
                    href: `${(0, $kfImN.mapTenantIdToSiteUrl)(item.siteId, this.siteMasterList)}/people/${item.userProfile.account_id}`,
                    analyticsType: (0, $42a3e378fee7fe01$export$cb8b6c470492bee8),
                    mentionName: item.userProfile.name,
                    presenceMessage: item.userProfile.name,
                    resultType: (0, $42a3e378fee7fe01$export$ca1a50bc869949e),
                    avatarUrl: item.userProfile.picture,
                    contentType: (0, $42a3e378fee7fe01$export$d0e824889e01c751)
                }));
            return {
                items: items,
                timings: response.timings
            };
        };
        const { siteMasterList: siteMasterList, scopes: _scopes } = config;
        this.aggregatorClient = new (0, $12cJV.AggregatorClient)(config);
        this.graphQLClient = new (0, $f42a017b762dc955$export$b0f268a6eae2cdf1)(config);
        this.isUserAnonymous = config.isUserAnonymous;
        this.useGraphQLClient = config.useGraphQLClient || false;
        this.bootstrapPeopleCache = new (0, $3NyIw.SimpleCache)(this.recentPeopleSupplier);
        this.siteMasterList = siteMasterList;
        this.collaborationGraphClient = collabGraphClient;
        this.isCollabGraphEnabled = config.isCollaborationGraphEnabled;
        this.scopes = {
            itemScope: _scopes?.itemScope ? _scopes.itemScope : (0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluencePageBlogAttachment,
            spaceScope: _scopes?.spaceScope ? _scopes.spaceScope : (0, $42a3e378fee7fe01$export$775b6bb06e53a214).ConfluenceSpace,
            ursUserScope: _scopes?.ursUserScope ? _scopes.ursUserScope : (0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence
        };
    }
}
$da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT = 30;
$da2db4559cce8604$export$2bdc82bf1cf036b4.SPACE_RESULT_LIMIT = 10;
$da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT = 10;



var $2XqLN = parcelRequire("2XqLN");


var $hL7bb = parcelRequire("hL7bb");







const $efe8e1453cb04fa5$export$e28d152a38023114 = 'confluenceSpace';
const $efe8e1453cb04fa5$export$b9a68081b849a9ab = 'jiraProject';









const $effb6ad10ca37aba$export$be774cfa50234d6d = 'rest/recentlyviewed/1.0/recent';
const $effb6ad10ca37aba$export$d8751bf2ebec9fba = 'rest/recentlyviewed/1.0/recent/spaces';
const $effb6ad10ca37aba$var$RECENT_PAGES_LIMIT = 200;
const $effb6ad10ca37aba$var$RECENT_SPACE_LIMIT = 5;

class $effb6ad10ca37aba$export$2c04424b0b9ef0ac {
    getRecent(cache) {
        const { fromCache: fromCache, value: value } = cache.get();
        return (0, $czt8s.CancellablePromise).from(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    getRecentItems() {
        return this.getRecent(this.recentItemCache);
    }
    getRecentSpaces() {
        return this.getRecent(this.recentSpaceCache);
    }
    createRecentRequestPromise(path, queryParams) {
        const options = {
            path: path,
            queryParams: queryParams
        };
        const requestPromise = (0, $dwp40.utils).requestService(this.serviceConfig, options);
        return (0, $9Nzn7.timed)(requestPromise);
    }
    constructor({ url: url, isCollaborationGraphEnabled: isCollaborationGraphEnabled, recentItemsSupplier: recentItemsSupplier, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl }, collabGraphClient){
        this.baseUrl = void 0;
        this.serviceConfig = void 0;
        this.recentItemCache = void 0;
        this.recentSpaceCache = void 0;
        this.isCollabGraphEnabled = void 0;
        this.collaborationGraphClient = void 0;
        this.useRecentWork = void 0;
        this.recentWorkAPIUrl = void 0;
        this.recentItemsSupplier = async ()=>{
            if (this.useRecentWork) {
                const { createActivityClient: createActivityClient } = await (parcelRequire("jkExj"));
                const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentWorkAPIUrl);
                const { viewed: viewed } = await activityClient.fetchActivities([
                    250
                ], {
                    products: [
                        'confluence'
                    ]
                }, [
                    'viewed'
                ]);
                const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$effb6ad10ca37aba$var$recentWorkItemToResult(item));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: 0
                };
            } else {
                const baseUrl = this.serviceConfig.url;
                const recentPagesPromiseWithTimings = this.createRecentRequestPromise($effb6ad10ca37aba$export$be774cfa50234d6d, {
                    limit: $effb6ad10ca37aba$var$RECENT_PAGES_LIMIT
                });
                const { result: result, durationMs: durationMs } = await recentPagesPromiseWithTimings;
                const items = result.filter((page)=>!!page.title).map((recentPage)=>$effb6ad10ca37aba$var$recentPageToResult(recentPage, baseUrl));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: durationMs
                };
            }
        };
        this.recentSpacesSupplier = ()=>{
            if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getContainers([
                (0, $efe8e1453cb04fa5$export$e28d152a38023114)
            ]).then((response)=>$effb6ad10ca37aba$var$mapCollabGraphContainer(response));
            else {
                const recentSpacesPromise = this.createRecentRequestPromise($effb6ad10ca37aba$export$d8751bf2ebec9fba, {
                    limit: $effb6ad10ca37aba$var$RECENT_SPACE_LIMIT
                });
                return recentSpacesPromise.then(({ result: result, durationMs: durationMs })=>({
                        items: result.map((recentSpace)=>$effb6ad10ca37aba$var$recentSpaceToResult(recentSpace, `${this.baseUrl}/spaces/${recentSpace.key}`)),
                        timings: durationMs
                    }));
            }
        };
        this.serviceConfig = {
            url: url
        };
        this.baseUrl = url;
        this.recentItemCache = new (0, $3NyIw.SimpleCache)(recentItemsSupplier || this.recentItemsSupplier);
        this.recentSpaceCache = new (0, $3NyIw.SimpleCache)(this.recentSpacesSupplier);
        this.collaborationGraphClient = collabGraphClient;
        this.isCollabGraphEnabled = isCollaborationGraphEnabled;
        this.useRecentWork = useRecentWork || false;
        this.recentWorkAPIUrl = recentWorkAPIUrl;
    }
}
function $effb6ad10ca37aba$var$recentWorkItemToResult(recentItem) {
    const { object: object, containers: containers } = recentItem;
    return {
        resultId: object.id,
        containerName: containers[0].name,
        containerId: '',
        resultType: (0, $42a3e378fee7fe01$export$a99961038e9d5471),
        isRecentResult: true,
        name: object.name || '',
        // Failsafe. All items should have a name.
        href: object.url,
        contentType: `confluence-${object.type}`,
        lastModified: undefined,
        // not available
        analyticsType: (0, $42a3e378fee7fe01$export$18c69de2b4aa679c)
    };
}
function $effb6ad10ca37aba$var$recentPageToResult(recentPage, baseUrl) {
    return {
        resultId: String(recentPage.id),
        name: recentPage.title || '',
        // This is a failsafe, there should be a filter to drop pages with no titles
        href: `${baseUrl}${recentPage.url}`,
        containerName: recentPage.space,
        analyticsType: (0, $42a3e378fee7fe01$export$18c69de2b4aa679c),
        resultType: (0, $42a3e378fee7fe01$export$a99961038e9d5471),
        contentType: `confluence-${recentPage.contentType}`,
        iconClass: recentPage.iconClass,
        containerId: recentPage.spaceId.toString(),
        isRecentResult: true,
        lastModified: undefined,
        // not available for recent results
        spaceId: recentPage.spaceId?.toString()
    };
}
function $effb6ad10ca37aba$var$recentSpaceToResult(recentSpace, href) {
    return {
        resultId: recentSpace.id,
        name: recentSpace.name,
        key: recentSpace.key,
        href: href,
        avatarUrl: recentSpace.icon,
        analyticsType: (0, $42a3e378fee7fe01$export$18c69de2b4aa679c),
        resultType: (0, $42a3e378fee7fe01$export$6ec00f56b27cdc1d),
        contentType: (0, $42a3e378fee7fe01$export$8ee8726ca4e2f8bd),
        id: recentSpace.id
    };
}
function $effb6ad10ca37aba$var$mapCollabGraphContainer(response) {
    const items = response.collaborationGraphEntities.map((item)=>({
            id: item.containerDetails?.id,
            key: item.containerDetails?.key,
            icon: item.containerDetails?.iconUrl,
            name: item.containerDetails?.name,
            url: item.containerDetails?.url,
            siteId: item.siteId
        })).filter((space)=>space.id !== undefined).map((space)=>$effb6ad10ca37aba$var$recentSpaceToResult(space, space.url));
    return {
        items: items,
        timings: response.timings
    };
}











class $2d835650f472091b$export$d4989257696242c9 {
    async makeRequest(path, body) {
        const options = {
            path: path,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(body)
            }
        };
        return (0, $9Nzn7.timed)((0, $dwp40.utils).requestService(this.serviceConfig, options));
    }
    constructor({ url: url }){
        this.CONTAINER_URL_PATH = void 0;
        this.USER_URL_PATH = void 0;
        this.containersCache = void 0;
        this.usersCache = void 0;
        this.serviceConfig = void 0;
        this.serviceConfig = {
            url: url
        };
        this.getContainersSupplier = this.getContainersSupplier.bind(this);
        this.getUsersSupplier = this.getUsersSupplier.bind(this);
        this.containersCache = new (0, $3NyIw.SimpleCache)(this.getContainersSupplier);
        this.usersCache = new (0, $3NyIw.SimpleCache)(this.getUsersSupplier);
    }
}



class $a937e9fff7ff80c1$export$75acaca275e7d34b extends (0, $2d835650f472091b$export$d4989257696242c9) {
    getUsers(arg) {
        return this.usersCache.get(arg).value;
    }
    getContainers({ containerTypes: containerTypes, cloudId: cloudId }) {
        return this.containersCache.get({
            containerTypes: containerTypes,
            cloudId: cloudId
        }).value;
    }
    async getContainersSupplier({ containerTypes: containerTypes, cloudId: cloudId }) {
        const body = {
            containerTypes: containerTypes,
            context: {
                principalId: (0, $6e4dcee96054a2d9$export$886facd7f1fb825b),
                siteId: cloudId,
                contextType: (0, $6e4dcee96054a2d9$export$c4871241365cf270)
            },
            maxNumberOfResults: (0, $6e4dcee96054a2d9$export$8b133b5f27893e80),
            userId: (0, $6e4dcee96054a2d9$export$886facd7f1fb825b),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: cloudId
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    async getUsersSupplier({ cloudId: cloudId = '', collabGraphSessionId: collabGraphSessionId = '' }) {
        const body = {
            context: {
                principalId: (0, $6e4dcee96054a2d9$export$886facd7f1fb825b),
                siteId: cloudId,
                sessionId: collabGraphSessionId,
                contextType: (0, $6e4dcee96054a2d9$export$c4871241365cf270)
            },
            maxNumberOfResults: (0, $6e4dcee96054a2d9$export$8b133b5f27893e80),
            userId: (0, $6e4dcee96054a2d9$export$886facd7f1fb825b),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: cloudId
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    constructor({ collaborationGraphUrl: url }){
        super({
            url: url
        });
        this.CONTAINER_URL_PATH = 'v1/collaborationgraph/user/container';
        this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
    }
}










const $5787685b349c0701$var$mergeUsers = (prevResult, nextResult)=>({
        timings: Math.max(prevResult.timings, nextResult.timings),
        collaborationGraphEntities: (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(prevResult.collaborationGraphEntities.concat(nextResult.collaborationGraphEntities), (user)=>user.id)
    });
const $5787685b349c0701$var$emptyUserResponse = {
    timings: 0,
    collaborationGraphEntities: []
};
class $5787685b349c0701$export$6150ad6d7e95f129 extends (0, $2d835650f472091b$export$d4989257696242c9) {
    async getContainersSupplier(arg) {
        const body = {
            containerTypes: arg.containerTypes,
            context: {
                principalId: (0, $6e4dcee96054a2d9$export$886facd7f1fb825b),
                siteIds: arg.cloudIds,
                contextType: (0, $6e4dcee96054a2d9$export$c4871241365cf270)
            },
            maxNumberOfResults: (0, $6e4dcee96054a2d9$export$8b133b5f27893e80),
            userId: (0, $6e4dcee96054a2d9$export$886facd7f1fb825b),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: (0, $kfImN.extractSiteIdBySiteUrl)(cgEntity.containerDetails.url, arg.allSites)
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    async getUsersSupplier(arg) {
        const results = arg.cloudIds.map(async (cloudId)=>{
            const body = {
                context: {
                    principalId: (0, $6e4dcee96054a2d9$export$886facd7f1fb825b),
                    siteId: cloudId,
                    contextType: (0, $6e4dcee96054a2d9$export$c4871241365cf270)
                },
                maxNumberOfResults: (0, $6e4dcee96054a2d9$export$8b133b5f27893e80),
                userId: (0, $6e4dcee96054a2d9$export$886facd7f1fb825b),
                expanded: true
            };
            const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
            result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>({
                    ...cgEntity,
                    siteId: cloudId
                }));
            return {
                ...result,
                timings: durationMs
            };
        });
        return Promise.all(results).then((values)=>values.reduce($5787685b349c0701$var$mergeUsers, $5787685b349c0701$var$emptyUserResponse));
    }
    getUsers({ allSites: allSites, selectedSites: selectedSites }) {
        if (selectedSites.length === 0) return this.usersCache.get({
            cloudIds: (0, $kfImN.limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId)
        }).value;
        else return this.getUsersSupplier({
            cloudIds: selectedSites.map((site)=>site.cloudId)
        });
    }
    getContainers({ allSites: allSites, selectedSites: selectedSites, containerTypes: containerTypes }) {
        if (selectedSites.length === 0) return this.containersCache.get({
            cloudIds: (0, $kfImN.limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId),
            containerTypes: containerTypes
        }).value;
        else return this.getContainersSupplier({
            cloudIds: selectedSites.map((site)=>site.cloudId),
            containerTypes: containerTypes,
            allSites: allSites
        });
    }
    constructor(config){
        super({
            url: config.collaborationGraphUrl
        });
        this.CONTAINER_URL_PATH = 'v1/collaborationgraph/multitenant/user/container';
        this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
    }
}


const $6e4dcee96054a2d9$export$8b133b5f27893e80 = 10;
const $6e4dcee96054a2d9$export$886facd7f1fb825b = 'context';
const $6e4dcee96054a2d9$export$c4871241365cf270 = 'quickSearch';
class $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2 {
    constructor(config){
        this.isMultiSite = void 0;
        this.cloudId = void 0;
        this.sites = void 0;
        this.collabGraphSingleSite = void 0;
        this.collabGraphMultiSite = void 0;
        this.getContainers = (containerTypes, sites = [])=>{
            if (this.isMultiSite) return this.collabGraphMultiSite.getContainers({
                selectedSites: sites,
                containerTypes: containerTypes,
                allSites: this.sites.length > 0 ? this.sites : [
                    {
                        cloudId: this.cloudId
                    }
                ]
            });
            else return this.collabGraphSingleSite.getContainers({
                containerTypes: containerTypes,
                cloudId: this.cloudId
            });
        };
        this.getUsers = (sites = [])=>{
            if (this.isMultiSite) return this.collabGraphMultiSite.getUsers({
                allSites: this.sites.length > 0 ? this.sites : [
                    {
                        cloudId: this.cloudId
                    }
                ],
                selectedSites: sites
            });
            else return this.collabGraphSingleSite.getUsers({
                cloudId: this.cloudId
            });
        };
        this.collabGraphSingleSite = new (0, $a937e9fff7ff80c1$export$75acaca275e7d34b)(config);
        this.collabGraphMultiSite = new (0, $5787685b349c0701$export$6150ad6d7e95f129)(config);
        this.isMultiSite = config.isMultiSite;
        this.cloudId = config.cloudId;
        this.sites = config.sites;
    }
}






var $dQl1W = parcelRequire("dQl1W");

const $06b7bb550af38e43$var$defaultCollaborationGraphConfig = {
    collaborationGraphUrl: 'gateway/api/collaboration',
    useCollaborationGraphForRecents: false
};
const $06b7bb550af38e43$var$getSearchClientWithConfig = (0, $2XqLN.default)((config, collabGraphClient)=>new (0, $da2db4559cce8604$export$2bdc82bf1cf036b4)(config, collabGraphClient), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));
const $06b7bb550af38e43$var$getRecentsClientWithConfig = (0, $2XqLN.default)((config, collabGraphClient)=>new (0, $effb6ad10ca37aba$export$2c04424b0b9ef0ac)(config, collabGraphClient), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));
const $06b7bb550af38e43$var$getCollabGraphClientWithConfig = (0, $2XqLN.default)((config)=>new (0, $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        collabGraphSessionId: config.collabGraphSessionId,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));
const $06b7bb550af38e43$export$5a44dbd630fde657 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR = new Error(`Could not find all required Clients, make sure ConfluenceClientsProvider is created further up the tree`);
//Will generate a session id to be sent to the CG endpoint as well as the frontend analytics
//This is created here as CG results are cached inside search dialog and is not invoked for subsequent use actions
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
const $06b7bb550af38e43$var$COLLABORATION_GRAPH_SESSION_ID = (0, $dQl1W.v4)();
const $06b7bb550af38e43$export$413dca1b70dbb4a7 = (Component)=>{
    return (props)=>/*#__PURE__*/ (0, $l998X.jsx)($06b7bb550af38e43$export$5a44dbd630fde657.Consumer, {
            children: ({ searchClient: searchClient, recentClient: recentClient, cloudId: cloudId, siteUrl: siteUrl = '', sites: sites, collabGraphSessionId: collabGraphSessionId })=>{
                if (!searchClient || !recentClient) throw $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR;
                const { ...rest } = props;
                return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...rest,
                    searchClient: searchClient,
                    recentClient: recentClient,
                    cloudId: cloudId,
                    collabGraphSessionId: collabGraphSessionId,
                    siteUrl: siteUrl,
                    sites: sites
                });
            }
        });
};
const $06b7bb550af38e43$export$43e8a9214cb124ba = ({ children: children, config: config })=>{
    const { baseUrl: baseUrl, cloudId: cloudId, collaborationGraphUrl: collaborationGraphUrl, aggregatorUrl: aggregatorUrl, isUserAnonymous: isUserAnonymous, useCollaborationGraphForRecents: useCollaborationGraphForRecents, recentItemsSupplier: recentItemsSupplier, sites: sites = [], collabGraphSessionId: collabGraphSessionId, scopes: scopes, useGraphQLClient: useGraphQLClient, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl } = {
        ...$06b7bb550af38e43$var$defaultCollaborationGraphConfig,
        ...config
    };
    const siteUrl = (0, $kfImN.extractSiteUrl)(config);
    const collabGraphClient = $06b7bb550af38e43$var$getCollabGraphClientWithConfig({
        collaborationGraphUrl: collaborationGraphUrl,
        cloudId: cloudId,
        isMultiSite: sites.length > 1,
        sites: sites,
        collabGraphSessionId: collabGraphSessionId
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($06b7bb550af38e43$export$5a44dbd630fde657.Provider, {
        value: {
            searchClient: $06b7bb550af38e43$var$getSearchClientWithConfig({
                isUserAnonymous: isUserAnonymous,
                url: aggregatorUrl,
                cloudId: cloudId,
                isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                siteMasterList: sites,
                scopes: scopes,
                useGraphQLClient: useGraphQLClient
            }, collabGraphClient),
            recentClient: $06b7bb550af38e43$var$getRecentsClientWithConfig({
                url: baseUrl,
                isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                recentItemsSupplier: recentItemsSupplier,
                useRecentWork: useRecentWork,
                recentWorkAPIUrl: recentWorkAPIUrl
            }, collabGraphClient),
            collabGraphClient: collabGraphClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites,
            collabGraphSessionId: $06b7bb550af38e43$var$COLLABORATION_GRAPH_SESSION_ID
        },
        children: children
    });
};
const $06b7bb550af38e43$export$4823a6cc022cca16 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($06b7bb550af38e43$export$5a44dbd630fde657);
    if (!context.searchClient || !context.recentClient) throw $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR;
    return context;
};
const $06b7bb550af38e43$export$376c08f4921c6b8d = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($06b7bb550af38e43$export$5a44dbd630fde657);
    return context.recentClient;
};


var $91yhh = parcelRequire("91yhh");

























const $d81dca87d92d32f6$var$USER_DATA_URL = '/rest/api/3/user';
class $d81dca87d92d32f6$export$bbcfcc9f52275229 {
    async makeRequest(path) {
        const options = {
            path: path,
            queryParams: {
                accountId: this.accountId,
                expand: 'applicationRoles'
            }
        };
        return (0, $9Nzn7.timed)((0, $dwp40.utils).requestService(this.serviceConfig, options));
    }
    constructor({ accountId: accountId, baseUrl: baseUrl, currentUserSupplier: currentUserSupplier }){
        this.serviceConfig = void 0;
        this.currentUserCache = void 0;
        this.accountId = void 0;
        this.getCurrentUser = ()=>this.currentUserCache.get().value;
        this.getUserSupplier = async ()=>{
            const { result: result, durationMs: durationMs } = await this.makeRequest($d81dca87d92d32f6$var$USER_DATA_URL);
            return {
                ...result,
                timings: durationMs
            };
        };
        this.serviceConfig = {
            url: baseUrl
        };
        this.accountId = accountId;
        this.currentUserCache = new (0, $3NyIw.SimpleCache)(currentUserSupplier || this.getUserSupplier);
    }
}
const $d81dca87d92d32f6$export$2393d475b44b8a57 = (user = {})=>{
    const [loadingComplete, setLoadingComplete] = (0, $42omo.useState)(false);
    const [currentUser, setCurrentUser] = (0, $42omo.useState)(user);
    const { currentUserClient: currentUserClient } = (0, $fe7e2b06857d7b1f$export$71e1e199804dfd5e)();
    (0, $42omo.useEffect)(()=>{
        if (!loadingComplete) {
            let shouldUpdate = true;
            currentUserClient?.getCurrentUser().then((result)=>{
                if (shouldUpdate && !loadingComplete) {
                    setCurrentUser({
                        id: result.accountId,
                        name: result.displayName,
                        avatarUrl: result.avatarUrls['24x24'],
                        email: result.emailAddress,
                        hasSoftwareAccess: result.applicationRoles.items.some((item)=>item.key === 'jira-software')
                    });
                    setLoadingComplete(true);
                }
            }).catch(()=>{}); // swallow any errors
            return ()=>{
                shouldUpdate = false;
            };
        }
    }, [
        currentUserClient,
        loadingComplete
    ]);
    return currentUser;
};









var $068ba82a94015a1a$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $068ba82a94015a1a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $068ba82a94015a1a$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $068ba82a94015a1a$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $068ba82a94015a1a$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});





class $abe2b3690446e017$export$676c8946b241bf4b extends Error {
    constructor(v){
        super(`Unreachable code was reachable, value: ${v}`);
    }
}










function $074c4d4296761b1e$export$ed218c5a500295c6(response, isCached, timings) {
    const { results: results, size: size } = response;
    return {
        items: results.filter((item)=>item.attributes['@type'] === (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).issue).map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraIssue,
                attributes: {
                    ...item.attributes,
                    isRecentResult: isCached
                },
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: size || results.length
    };
}
function $074c4d4296761b1e$export$3327c57623badb76(results, isCached, timings) {
    return {
        items: results.map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraPlan,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$313c00d1fd0198a9(results, isCached, timings) {
    return {
        items: results.filter((item)=>[
                (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).board,
                (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).project,
                (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).filter,
                (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).plan
            ].includes(item.attributes['@type'])).map((item)=>{
            const contentType = (0, $4194cf53882a191e$export$1436a8642ffb43cf)(item.attributes['@type']);
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: contentType,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$61106bcfd557994b(results, isCached, timings) {
    return {
        items: results.map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraProject,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$ca9c7208f3fa3596(results, isCached, timings, isMultiSite) {
    return {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(results, (item)=>item.id).map((item)=>({
                resultId: item.id,
                name: item.name,
                href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id, 'jira'),
                contentType: (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraPeople,
                attributes: {
                    '@type': (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).people,
                    avatarUrl: item.avatarUrl,
                    userId: item.id
                },
                isCached: isCached
            })),
        timings: timings,
        totalSize: results.length
    };
}





const $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT = 2;
const $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE = 'jira.nav-v3';
class $4194cf53882a191e$export$824e4d5b28750c3f {
    getRecent(cache, context, sites) {
        const { fromCache: fromCache, value: value } = cache.get(context, (0, $kfImN.limitToMaxSiteUsage)(sites));
        return (0, $czt8s.CancellablePromise).from(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    getRecentBoardsProjectsFiltersPlansInterleaved(context, sites) {
        const { fromCache: boardsProjectsFiltersFromCache, value: boardsProjectsFiltersValue } = this.recentBoardsProjectsFiltersCache.get(context, sites);
        const { fromCache: plansFromCache, value: plansValue } = this.recentPlansCache.get(context, sites);
        return (0, $czt8s.CancellablePromise).from(Promise.all([
            boardsProjectsFiltersValue,
            plansValue
        ]).then((results)=>({
                ...this.interleaveRecentBoardsProjectsFiltersPlans(results[0], results[1]),
                isCached: plansFromCache && boardsProjectsFiltersFromCache
            })));
    }
    getRecentIssues(context, sites) {
        return this.getRecent(this.recentIssuesCache, context, sites);
    }
    getRecentPlans(context, sites) {
        return this.getRecent(this.recentPlansCache, context, sites);
    }
    getRecentProjects(context, sites) {
        return this.getRecent(this.recentProjectsCache, context, sites);
    }
    getRecentBoardsProjectsFilters(context, sites) {
        return this.getRecent(this.recentBoardsProjectsFiltersCache, context, sites);
    }
    getRecentBoardsProjectsFiltersPlans(context, sites) {
        return this.getRecentBoardsProjectsFiltersPlansInterleaved(context, sites);
    }
    /**
   * Check the user permissions for the given list of products.
   */ async getProductPermissions(products) {
        if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE);
        return this.permissionsDataCache;
    }
    async getAbTestData() {
        if (this.abTestDataCache) return this.abTestDataCache;
        const abTest = await this.aggregatorClient.getAbTestData((0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraIssue, $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE);
        this.abTestDataCache = abTest;
        return abTest;
    }
    getRecentPeople(context, sites) {
        return this.getRecent(this.recentPeopleCache, context, sites);
    }
    searchPeople(query, context, sites) {
        return (0, $czt8s.CancellablePromise).from(this.searchForPeopleScope(query, context, false, sites));
    }
    searchForPeopleScope(query, context, isForRecentResults, sites, queryVersion) {
        if (this.isUserAnonymous) return Promise.resolve({
            items: [],
            timings: 0,
            totalSize: 0
        });
        const results = this.searchForScope(query, [], context, [
            (0, $068ba82a94015a1a$export$775b6bb06e53a214).People
        ], $4194cf53882a191e$export$824e4d5b28750c3f.PEOPLE_RESULT_LIMIT, isForRecentResults, sites, queryVersion)[(0, $068ba82a94015a1a$export$775b6bb06e53a214).People];
        if (!results) throw new Error(`Failed to retrieve results for scope ${(0, $068ba82a94015a1a$export$775b6bb06e53a214).People}`);
        return results.promise();
    }
    searchProjects(query, context, sites) {
        const results = this.searchForScope(query, [], context, [
            (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraProject
        ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites)[(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraProject];
        if (!results) throw new Error(`Failed to retrieve results for scope ${(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraProject}`);
        return results;
    }
    constructor(config){
        this.abTestDataCache = null;
        this.permissionsDataCache = null;
        this.aggregatorClient = void 0;
        this.recentIssuesCache = void 0;
        this.recentPeopleCache = void 0;
        this.recentBoardsProjectsFiltersCache = void 0;
        this.recentPlansCache = void 0;
        this.recentProjectsCache = void 0;
        this.isUserAnonymous = void 0;
        this.recentIssuesSupplier = async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraIssue
            ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, true, sites)[(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraIssue];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraIssue}`);
            return results.promise();
        };
        // For recent results, we only want to show up to 2 recent plans as the last 2 results
        // as we cannot accurately interleave  recent plans with recent boards, projects, filter results.
        // However, it is valid to show more than 2 plans in the case where other entity types have been exhausted.
        this.interleaveRecentBoardsProjectsFiltersPlans = (boardProjectFilterResults, planResults)=>{
            const timings = planResults.timings > boardProjectFilterResults.timings ? planResults.timings : boardProjectFilterResults.timings;
            const { items: items } = boardProjectFilterResults;
            if (planResults.items.length >= $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT) while(items.length > $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT)items.pop();
            else while(items.length > $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - planResults.items.length)items.pop();
            for(let planCount = 0; items.length < $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT && planResults.items.length > planCount; planCount++)items.push(planResults.items[planCount]);
            return {
                timings: timings,
                items: items,
                totalSize: items.length
            };
        };
        this.search = (query, filters, context, queryVersion, hasAdvancedRoadmapsAccess, sites)=>{
            const issueSearch = this.searchForScope(query, filters, context, [
                (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraIssue
            ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites, queryVersion);
            const onlyDateFilterEnabled = filters.length === 1 && filters[0]?.type === 'dateFromLastModified';
            const scopes = hasAdvancedRoadmapsAccess ? [
                (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraBoardProjectFilterPlan
            ] : [
                (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraBoardProjectFilter
            ];
            const limit = hasAdvancedRoadmapsAccess ? $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT : $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_LIMIT;
            const jiraBoardProjectFilterSearch = filters.length === 0 || onlyDateFilterEnabled ? this.searchForScope(query, filters, context, scopes, limit, false, sites, queryVersion) : {};
            return {
                ...issueSearch,
                ...jiraBoardProjectFilterSearch
            };
        };
        this.searchForScope = (query, filters, context, scopes, resultLimit, isForRecentResults, sites = [], queryVersion)=>{
            const modelParams = queryVersion || queryVersion === 0 ? [
                {
                    '@type': 'queryParams',
                    queryVersion: queryVersion
                }
            ] : [];
            const allFilters = [];
            let baseProjectFilters = null;
            let baseAssigneeFilters = null;
            let baseBinaryStatusCategoryFilters = null;
            let lastModifiedFilter = {
                '@type': 'lastModified'
            };
            let lastViewedFilter = {
                '@type': 'lastViewed'
            };
            filters.forEach((filter)=>{
                switch(filter.type){
                    case 'project':
                        if (!baseProjectFilters) {
                            baseProjectFilters = {
                                '@type': 'projects',
                                projectIds: []
                            };
                            allFilters.push(baseProjectFilters);
                        }
                        baseProjectFilters.projectIds.push(filter.id);
                        break;
                    case 'assignee':
                        if (!baseAssigneeFilters) {
                            baseAssigneeFilters = {
                                '@type': 'assignees',
                                accountIds: []
                            };
                            allFilters.push(baseAssigneeFilters);
                        }
                        baseAssigneeFilters.accountIds.push(filter.id);
                        break;
                    case 'binary_status_category':
                        if (!baseBinaryStatusCategoryFilters) {
                            baseBinaryStatusCategoryFilters = {
                                '@type': 'binary_status_categories',
                                binaryStatusCategories: []
                            };
                            allFilters.push(baseBinaryStatusCategoryFilters);
                        }
                        baseBinaryStatusCategoryFilters.binaryStatusCategories.push(filter.id);
                        break;
                    case 'dateFromLastModified':
                        filter.id && (lastModifiedFilter.from = filter.id);
                        break;
                    case 'dateFromLastViewed':
                        filter.id && (lastViewedFilter.from = filter.id);
                        break;
                    case 'dateToLastModified':
                        filter.id && (lastModifiedFilter.to = filter.id);
                        break;
                    default:
                        break;
                }
            });
            if (lastModifiedFilter.from || lastModifiedFilter.to) allFilters.push(lastModifiedFilter);
            if (lastViewedFilter.from) allFilters.push(lastViewedFilter);
            const responses = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: resultLimit,
                filters: allFilters,
                experience: $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            return scopes.reduce((results, currentScope)=>({
                    ...results,
                    [currentScope]: (0, $czt8s.CancellablePromise).from(responses.then(({ response: response, requestDurationMs: requestDurationMs })=>{
                        const scopedResponse = response.retrieveScope(currentScope);
                        if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
                        if (scopedResponse.error) throw (0, $62cd9cdd84f4378e$export$59a963eec12b52ed)(scopedResponse.error);
                        if (currentScope === (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraIssue) return (0, $074c4d4296761b1e$export$ed218c5a500295c6)(scopedResponse, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraPlan) return (0, $074c4d4296761b1e$export$3327c57623badb76)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraBoardProjectFilter) return (0, $074c4d4296761b1e$export$313c00d1fd0198a9)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraBoardProjectFilterPlan) return (0, $074c4d4296761b1e$export$313c00d1fd0198a9)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraProject) return (0, $074c4d4296761b1e$export$61106bcfd557994b)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $068ba82a94015a1a$export$775b6bb06e53a214).People) return (0, $074c4d4296761b1e$export$ca9c7208f3fa3596)(scopedResponse.results, isForRecentResults, requestDurationMs, sites.length > 0);
                    }))
                }), {});
        };
        const { recentIssuesSupplier: recentIssuesSupplier = null } = config;
        this.aggregatorClient = new (0, $12cJV.AggregatorClient)(config);
        this.recentPeopleCache = new (0, $3NyIw.SimpleCache)((context, sites)=>this.searchForPeopleScope('', context, true, sites));
        this.recentIssuesCache = recentIssuesSupplier ? new (0, $3NyIw.SimpleCache)((ignored)=>recentIssuesSupplier()) : new (0, $3NyIw.SimpleCache)(this.recentIssuesSupplier);
        this.recentBoardsProjectsFiltersCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraBoardProjectFilter
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraBoardProjectFilter];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraBoardProjectFilter}`);
            return results.promise();
        });
        this.recentPlansCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraPlan
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraPlan];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraPlan}`);
            return results.promise();
        });
        this.recentProjectsCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraProject
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_RESULT_LIMIT, true, sites)[(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraProject];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $068ba82a94015a1a$export$775b6bb06e53a214).JiraProject}`);
            return results.promise();
        });
        this.isUserAnonymous = config.isUserAnonymous;
    }
}
$4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT = 50;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_LIMIT = 6;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT = 8;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_RESULT_LIMIT = 10;
$4194cf53882a191e$export$824e4d5b28750c3f.PEOPLE_RESULT_LIMIT = 10;
function $4194cf53882a191e$export$1436a8642ffb43cf(attributeType) {
    switch(attributeType){
        case (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).issue:
            return (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraIssue;
        case (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).project:
            return (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraProject;
        case (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).board:
            return (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraBoard;
        case (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).filter:
            return (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraFilter;
        case (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).plan:
            return (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraPlan;
        case (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).people:
            return (0, $068ba82a94015a1a$export$e2e108cbe2e4f865).JiraPeople;
        default:
            throw new (0, $abe2b3690446e017$export$676c8946b241bf4b)(attributeType);
    }
}









const $fe7e2b06857d7b1f$var$ERROR_MESSAGE = 'Jira search client has not been instantiated. This is most likely because you are missing a JiraSearchClientProvider.';
const $fe7e2b06857d7b1f$var$defaultCollaborationGraphConfig = {
    collaborationGraphUrl: 'gateway/api/collaboration',
    useCollaborationGraphForRecents: false
};
const $fe7e2b06857d7b1f$var$getCollabGraphClientWithConfig = (0, $2XqLN.default)((config)=>new (0, $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));
const $fe7e2b06857d7b1f$export$5b76b773dfc5ee6a = /*#__PURE__*/ (0, $42omo.createContext)({});
const $fe7e2b06857d7b1f$var$DEFAULT_SITES = [];
const $fe7e2b06857d7b1f$export$f8102de5af58503c = ({ aggregatorUrl: aggregatorUrl, cloudId: cloudId, isUserAnonymous: isUserAnonymous, collaborationGraphUrl: collaborationGraphUrl, children: children, baseUrl: baseUrl, accountId: accountId, siteUrl: siteUrl = '', recentIssuesSupplier: recentIssuesSupplier, currentUserSupplier: currentUserSupplier, sites: sites = $fe7e2b06857d7b1f$var$DEFAULT_SITES })=>{
    siteUrl = (0, $42omo.useMemo)(()=>(0, $kfImN.extractSiteUrl)({
            siteUrl: siteUrl,
            sites: sites
        }), [
        siteUrl,
        sites
    ]);
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const searchClient = (0, $42omo.useMemo)(()=>new (0, $4194cf53882a191e$export$824e4d5b28750c3f)({
            siteMasterList: sites,
            url: aggregatorUrl,
            cloudId: cloudId,
            isUserAnonymous: isUserAnonymous,
            recentIssuesSupplier: recentIssuesSupplier,
            siteUrl: siteUrl,
            backendExperiment: backendExperiment
        }), [
        aggregatorUrl,
        cloudId,
        isUserAnonymous,
        recentIssuesSupplier,
        siteUrl,
        sites,
        backendExperiment
    ]);
    const collabGraphClient = $fe7e2b06857d7b1f$var$getCollabGraphClientWithConfig({
        // If no collaborationGraphUrl is passed as a prop, use the fallback (default) URL
        collaborationGraphUrl: collaborationGraphUrl || $fe7e2b06857d7b1f$var$defaultCollaborationGraphConfig.collaborationGraphUrl,
        cloudId: cloudId,
        isMultiSite: sites.length > 1,
        sites: sites
    });
    const currentUserClient = (0, $42omo.useMemo)(()=>accountId ? new (0, $d81dca87d92d32f6$export$bbcfcc9f52275229)({
            accountId: accountId,
            baseUrl: baseUrl,
            currentUserSupplier: currentUserSupplier
        }) : undefined, [
        accountId,
        baseUrl,
        currentUserSupplier
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a.Provider, {
        value: {
            searchClient: searchClient,
            collabGraphClient: collabGraphClient,
            currentUserClient: currentUserClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites
        },
        children: children
    });
};
const $fe7e2b06857d7b1f$export$413dca1b70dbb4a7 = (Component)=>{
    return (props)=>/*#__PURE__*/ (0, $l998X.jsx)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a.Consumer, {
            children: ({ searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, cloudId: cloudId, sites: sites })=>{
                if (!searchClient) throw new Error($fe7e2b06857d7b1f$var$ERROR_MESSAGE);
                const { ...rest } = props;
                return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...rest,
                    searchClient: searchClient,
                    collabGraphClient: collabGraphClient,
                    currentUserClient: currentUserClient,
                    cloudId: cloudId,
                    sites: sites
                });
            }
        });
};
function $fe7e2b06857d7b1f$export$71e1e199804dfd5e() {
    const { searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, siteUrl: siteUrl, sites: sites, cloudId: cloudId } = (0, $42omo.useContext)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a);
    if (!searchClient) throw new Error($fe7e2b06857d7b1f$var$ERROR_MESSAGE);
    return {
        searchClient: searchClient,
        collabGraphClient: collabGraphClient,
        currentUserClient: currentUserClient,
        siteUrl: siteUrl,
        cloudId: cloudId,
        sites: sites
    };
}



var $jlIaF = parcelRequire("jlIaF");


var $5bPOK = parcelRequire("5bPOK");

const $ed5c1b85ee8abc07$export$5d91bb6ce8e0f47 = ({ userId: userId, cloudId: cloudId, children: children, useUrsForPeopleSearch: useUrsForPeopleSearch })=>{
    const clientProviderConfig = {
        isUserAnonymous: !userId,
        aggregatorUrl: '/gateway/api/xpsearch-aggregator',
        collaborationGraphUrl: '/gateway/api/collaboration',
        cloudId: cloudId,
        accountId: userId,
        useUrsForPeopleSearch: useUrsForPeopleSearch
    };
    const [quickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91yhh.ExperimentProvider), {
        quickFindEnabled: quickFindEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06b7bb550af38e43$export$43e8a9214cb124ba), {
        config: {
            ...clientProviderConfig,
            baseUrl: (0, $jlIaF.CONTEXT_PATH),
            scopes: undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe7e2b06857d7b1f$export$f8102de5af58503c), {
        ...clientProviderConfig,
        baseUrl: `${window.location.protocol}//${window.location.hostname}`
    }, children({
        clientProviderConfig: clientProviderConfig
    }))));
};






var $cPER9 = parcelRequire("cPER9");


var $8lYIw = parcelRequire("8lYIw");

const $42ea84ce17f63a94$var$isNewTabClick = (e)=>e && (e.metaKey || e.shiftKey || e.ctrlKey);
const $42ea84ce17f63a94$export$7298e35d46e5a43 = (closeDrawer)=>{
    class ResultLinkComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            const { children: children, href: href, target: target, className: className } = this.props;
            const LinkComponent = this.getLinkComponent(href);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LinkComponent, {
                href: href,
                onClick: this.handleClick,
                target: target,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className
            }, children);
        }
        constructor(...args){
            super(...args);
            this.handleClick = (event)=>{
                if (closeDrawer && !$42ea84ce17f63a94$var$isNewTabClick(event)) closeDrawer();
            };
            this.getLinkComponent = (href)=>href && href.startsWith('/people/') ? (0, $cPER9.PeopleLink) : (0, $8lYIw.Link);
        }
    }
    return ResultLinkComponent;
};



var $2Fqwa = parcelRequire("2Fqwa");





var $bavCP = parcelRequire("bavCP");


var $eSUdr = parcelRequire("eSUdr");

const $f677b35d623dd038$export$6cba1f4a018a0482 = (0, $eSUdr.default)`query CurrentSpaceQuery($spaceKey:String){space(key:$spaceKey){id name icon{path(type:ABSOLUTE)}}}`;


const $844c79f4d45e1a83$export$109846573338f1b2 = ({ children: children, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $f677b35d623dd038$export$6cba1f4a018a0482),
        variables: {
            spaceKey: spaceKey
        }
    }, ({ data: data, loading: loading })=>{
        const id = data?.space?.id;
        const spaceName = data?.space?.name;
        const iconUrl = data?.space?.icon?.path;
        const currentSpace = id && spaceName && iconUrl ? {
            id: id,
            spaceName: spaceName,
            spaceKey: spaceKey,
            iconUrl: iconUrl
        } : undefined;
        return children({
            loading: loading,
            currentSpace: currentSpace
        });
    });



var $escKD = parcelRequire("escKD");


var $kPjLK = parcelRequire("kPjLK");

















var $crAJ1 = parcelRequire("crAJ1");





var $gJKpQ = parcelRequire("gJKpQ");


var $4ldrV = parcelRequire("4ldrV");


var $kmpep = parcelRequire("kmpep");


var $88j1D = parcelRequire("88j1D");


var $fJRVo = parcelRequire("fJRVo");


var $5G9KX = parcelRequire("5G9KX");

const $5da1e983823dc9f1$export$ad9e8f9d9536c33d = ()=>{
    // The key is defined in packages/atlassian-analytics-pipeline/analytics-web-client/src/sessionTracking.ts.
    const LOCAL_STORAGE_KEY = 'awc.session.id';
    try {
        return (0, $5G9KX.getLocalStorageItemAsString)(LOCAL_STORAGE_KEY) ?? undefined;
    } catch (error) {
        return undefined;
    }
};


var $7fdea999808324e3$export$30e31f52a81be3c8 = /*#__PURE__*/ function(BitbucketScope) {
    BitbucketScope["BitbucketRepostitory"] = "bitbucket.repository";
    return BitbucketScope;
}({});
const $7fdea999808324e3$export$49fc3e2141fc5779 = 'bitbucket';


const $51813157f1aed649$var$BITBUCKET_WORKSPACES_URL = '/gateway/api/bitbucket/user/workspaces?pagelen=1';
let $51813157f1aed649$var$cachedPromise = null;
function $51813157f1aed649$export$7bc53b25566a6e2() {
    if ($51813157f1aed649$var$cachedPromise) return $51813157f1aed649$var$cachedPromise;
    $51813157f1aed649$var$cachedPromise = fetch($51813157f1aed649$var$BITBUCKET_WORKSPACES_URL, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject(new Error(`${response.status} ${response.statusText}`));
    }).catch((err)=>{
        $51813157f1aed649$var$cachedPromise = null;
        throw err;
    });
    return $51813157f1aed649$var$cachedPromise;
}
function $51813157f1aed649$export$f2118f24f988616f(response) {
    const first = response.values?.[0]?.workspace?.uuid ?? '';
    return first.length > 0 ? [
        first
    ] : [];
}


const $029554683ea761ec$var$MAX_DEFAULT_SITES = 3;
const $029554683ea761ec$export$dc64f87f5460b276 = (aggregatorClient, sections, context, experience, sourceProduct)=>async ({ query: query, filters: allFilters, workspaces: workspaces, sectionIds: allPermissionedScopes })=>{
        const defaultSites = workspaces?.slice(0, $029554683ea761ec$var$MAX_DEFAULT_SITES).map((workspace)=>workspace.id);
        // Extract sites from filters
        const siteFilter = allFilters.find((filter)=>filter['@type'] === (0, $88j1D.SITE_FILTER_TYPE_NAME));
        // @ts-ignore - typescript is not smart enough to know `siteFilter` will only ever be the sites filter
        const sites = siteFilter?.values || defaultSites || [];
        // Remove sites from the filters array
        let filters = allFilters.filter((filter)=>filter['@type'] !== (0, $88j1D.SITE_FILTER_TYPE_NAME)).map((f)=>f);
        const permittedSections = sections.filter((section)=>allPermissionedScopes.indexOf(section.id) >= 0).filter((section)=>section.isEnabled ? section.isEnabled(query, filters) : true);
        const scopes = permittedSections.map((section)=>section.scope);
        if (!aggregatorClient) return {
            sections: []
        };
        // Pass the session ID only for Jira since BE analytics are only emitted for Jira
        const productSessionId = sourceProduct === 'jira' ? (0, $5da1e983823dc9f1$export$ad9e8f9d9536c33d)() : undefined;
        if (scopes.includes((0, $7fdea999808324e3$export$30e31f52a81be3c8).BitbucketRepostitory) && (0, $dh538.fg)('enable_bitbucket_repository_workspace_search_in_qs')) try {
            const userWorkspacesResponse = await (0, $51813157f1aed649$export$7bc53b25566a6e2)();
            const bitbucketWorkspaceIds = (0, $51813157f1aed649$export$f2118f24f988616f)(userWorkspacesResponse);
            if (bitbucketWorkspaceIds.length > 0) filters = [
                ...filters,
                {
                    '@type': 'workspaces',
                    workspaces: bitbucketWorkspaceIds
                }
            ];
        } catch  {
        // Omit workspaces filter on error
        }
        const { response: response } = await aggregatorClient.search({
            query: query,
            scopes: scopes,
            modelParams: [],
            experience: experience,
            context: context,
            filters: filters,
            sites: sites,
            sourceProduct: sourceProduct,
            productSessionId: productSessionId
        });
        const sectionsWithResults = permittedSections.map(({ scope: scope, id: id, title: title, resultMapper: resultMapper, ...rest })=>{
            const results = response.retrieveScope(scope);
            if (results === null) throw new Error(`Scope ${scope} was not found in the response, despite being requested`);
            return {
                ...rest,
                id: id,
                title: title,
                size: results.size,
                searchResults: resultMapper(results) || [],
                resultMapper: resultMapper
            };
        });
        const scopesWithSize = response.rawData.scopes.filter(({ size: size })=>size);
        const reponseHasSize = scopesWithSize.length > 0;
        const totalSizeAsReportedByAPI = reponseHasSize ? response.rawData.scopes.reduce((count, scope)=>count + (scope.size || 0), 0) : undefined;
        return {
            size: totalSizeAsReportedByAPI,
            sections: sectionsWithResults
        };
    };
const $029554683ea761ec$export$967ff0f6c3886589 = (id, sections, overrides)=>{
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const sessionId = (0, $4ldrV.useSearchSessionId)();
    const productContext = (0, $fJRVo.useProductContext)();
    const { getPrimaryProduct: getPrimaryProduct } = productContext;
    const primaryProduct = getPrimaryProduct();
    const primaryProductId = primaryProduct?.id;
    const search = $029554683ea761ec$export$dc64f87f5460b276(aggregatorClient, sections, {
        sessionId: sessionId,
        referrerId: ''
    }, (0, $gJKpQ.PLACEHOLDER_EXPERIENCE), primaryProductId);
    return {
        preQueryItemSupplier: overrides?.preQueryItemSupplier ?? ((args)=>search({
                ...args,
                query: '',
                filters: []
            })),
        postQueryItemSupplier: overrides?.postQueryItemSupplier ?? search
    };
};



var $cgtv4 = parcelRequire("cgtv4");

const $c3475590821d5a81$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /**
   * Bitbucket
   */ bitbucket_repository_heading: {
        id: "product_search_dialog.bitbucket.repository_heading",
        defaultMessage: "Repositories"
    },
    bitbucket_advanced_search: {
        id: "product_search_dialog.bitbucket.bitbucket_advanced_search",
        defaultMessage: "Search for code in {source}"
    },
    bitbucket_repositories_section_title: {
        id: "product_search_dialog.bitbucket.bitbucket_repositories_section_title",
        defaultMessage: "Repositories"
    },
    bitbucket_recent_repositories: {
        id: "product_search_dialog.bitbucket.bitbucket_recent_repositories",
        defaultMessage: "Recently updated repositories"
    },
    bitbucket_expanded_input_placeholder: {
        id: "product_search_dialog.bitbucket.expanded.input-placeholder",
        defaultMessage: "Search Bitbucket"
    }
});



var $bF0iL = parcelRequire("bF0iL");








var $epvHH = parcelRequire("epvHH");

var $icqFF = parcelRequire("icqFF");


var $jluld = parcelRequire("jluld");


var $3S0fp = parcelRequire("3S0fp");


var $6dP89 = parcelRequire("6dP89");


var $5dFS9 = parcelRequire("5dFS9");


var $eKv3Q = parcelRequire("eKv3Q");


var $l3UB9 = parcelRequire("l3UB9");





var $2ZIpG = parcelRequire("2ZIpG");


var $cStGJ = parcelRequire("cStGJ");

function $7f9d1377acc537c5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7f9d1377acc537c5$export$8e79650dab255425 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "ecy8ma0"
})({
    name: "7whenc",
    styles: "display:flex;width:100%"
});


const $2ba4e0bc1633544b$var$onKeyDown = (e, target, actionSubjectId, fireAnalyticsEvent)=>{
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $5dFS9.Trigger).RETURN,
            actionSubjectId: actionSubjectId,
            isLoading: false,
            newTab: false
        }));
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $2ba4e0bc1633544b$export$2709da4acd7d0aec = ({ advancedSearchMessage: advancedSearchMessage, advancedSearchUrl: advancedSearchUrl, linkComponent: linkComponent })=>{
    const { isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const productName = getActiveProduct()?.title;
    const actionSubjectId = `${productName}AdvancedSearchLink`;
    const onAdvancedSearchClicked = (0, $42omo.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        }));
    }, [
        fireAnalyticsEvent,
        actionSubjectId,
        isLoading
    ]);
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: (0, $42omo.useCallback)((e, target)=>$2ba4e0bc1633544b$var$onKeyDown(e, target, actionSubjectId, fireAnalyticsEvent), [
            actionSubjectId,
            fireAnalyticsEvent
        ])
    });
    if (!advancedSearchUrl || !advancedSearchMessage) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7f9d1377acc537c5$export$8e79650dab255425), {
        ref: ref,
        onClick: onAdvancedSearchClicked,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l3UB9.AdvancedSearchLink), {
            href: advancedSearchUrl,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eKv3Q.CenteredAdvancedSearchGroup), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                            color: "currentColor",
                            label: advancedSearchMessage
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eKv3Q.AdvancedSearchContent), {
                            children: advancedSearchMessage
                        })
                    ]
                }),
                isKeyboardHighlighted && /*#__PURE__*/ (0, $l998X.jsx)((0, $epvHH.ReturnIcon), {
                    inverted: isKeyboardHighlighted
                })
            ]
        })
    });
};



var $a5cba = parcelRequire("a5cba");









const $1e3c0c6b3e40ed4c$export$904bd3598beda83b = (overridenPermissionsSupplier)=>{
    return (0, $42omo.useMemo)(()=>{
        if (overridenPermissionsSupplier) return overridenPermissionsSupplier;
        return ()=>(0, $51813157f1aed649$export$7bc53b25566a6e2)().then((response)=>(0, $51813157f1aed649$export$f2118f24f988616f)(response).length > 0 ? [
                    (0, $7fdea999808324e3$export$30e31f52a81be3c8).BitbucketRepostitory
                ] : []).catch(()=>[]);
    }, [
        overridenPermissionsSupplier
    ]);
};












const $5cca7b29b77d44d1$export$e0a27ecb613d1aab = (overridenPermissionsSupplier)=>{
    const client = (0, $kmpep.useTypedAggregatorClient)();
    return (0, $42omo.useMemo)(()=>{
        if (overridenPermissionsSupplier) return overridenPermissionsSupplier;
        return ()=>client?.getProductScopes((0, $7fdea999808324e3$export$49fc3e2141fc5779), (0, $gJKpQ.PLACEHOLDER_EXPERIENCE)) || [];
    }, [
        client,
        overridenPermissionsSupplier
    ]);
};



const $5e4d9137215cb451$var$getBitbucketBaseURL = ()=>{
    const hostname = window.location.hostname;
    if (hostname.includes('jira-dev.com') || hostname.startsWith('localhost')) return 'https://staging.bb-inf.net';
    return 'https://bitbucket.org';
};
const $5e4d9137215cb451$export$8f020ef2e5947a78 = (overrides)=>{
    const viewAllLinkGenerator = (query)=>`${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}`;
    const urlGeneratorForNoResultsScreen = (query)=>query ? `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}` : `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories`;
    const codeSearchUrlGenerator = (query)=>query ? `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search?q=${encodeURIComponent(query)}` : `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search`;
    const codeSearchContextualUrlGenerator = (query, context)=>{
        const { repository: repository, workspace: workspace } = context;
        let fullModifier = query || repository ? '?q=' : '';
        // Populate query params
        if (repository) {
            const repoSlug = encodeURIComponent(`repo:${repository.slug} `);
            fullModifier = `${fullModifier}${repoSlug}`;
        }
        if (query) fullModifier = `${fullModifier}${encodeURIComponent(query)}`;
        const workspaceUUID = repository?.workspace?.uuid || workspace?.uuid;
        if (workspaceUUID) fullModifier = fullModifier ? `${fullModifier}&account=${encodeURIComponent(workspaceUUID)}` : `?account=${encodeURIComponent(workspaceUUID)}`;
        return `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search${fullModifier}`;
    };
    return {
        viewAllLinkGenerator: overrides?.viewAllLinkGenerator || viewAllLinkGenerator,
        urlGeneratorForNoResultsScreen: overrides?.urlGeneratorForNoResultsScreen || urlGeneratorForNoResultsScreen,
        codeSearchUrlGenerator: overrides?.codeSearchUrlGenerator || codeSearchUrlGenerator,
        codeSearchContextualUrlGenerator: overrides?.codeSearchContextualUrlGenerator || codeSearchContextualUrlGenerator
    };
};



var $eztGN = parcelRequire("eztGN");








var $8C5kA = parcelRequire("8C5kA");


var $lAFHW = parcelRequire("lAFHW");




var $5dK2X = parcelRequire("5dK2X");







var $4mZlP = parcelRequire("4mZlP");


var $e1ib8 = parcelRequire("e1ib8");


var $kfZYI = parcelRequire("kfZYI");

var $T9xHm = parcelRequire("T9xHm");

const $1f7067aa44298f63$export$b182d98f245a5298 = (isGlobalExperienceWorkspace)=>{
    if ((0, $T9xHm.isIsolatedCloud)()) {
        const homeUrl = (0, $kfZYI.getUrlForDomainInContext)('home', 'prod');
        if (isGlobalExperienceWorkspace && homeUrl) return homeUrl;
        // If platform experiences is enabled, use team subdomain with isolated cloud domain
        return `https://team.${(0, $T9xHm.isolatedCloudDomain)() ?? ''}`;
    }
    // Standard behavior for non-isolated cloud
    const hostname = window.location.hostname;
    const subdomain = isGlobalExperienceWorkspace ? 'home' : 'team';
    if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) return `https://${subdomain}.stg.atlassian.com`;
    return `https://${subdomain}.atlassian.com`;
};
const $1f7067aa44298f63$export$4c191d74745f6ab1 = (entityId, path, isGlobalExperienceWorkspace, orgId)=>{
    const baseUrl = $1f7067aa44298f63$export$b182d98f245a5298(isGlobalExperienceWorkspace);
    if (isGlobalExperienceWorkspace && orgId) return `${baseUrl}/o/${orgId}/${path}/${entityId}`;
    return `${baseUrl}/${path}/${entityId}`;
};
const $1f7067aa44298f63$export$5b4f9e589794eb96 = (accountId, isGlobalExperienceWorkspace, orgId)=>$1f7067aa44298f63$export$4c191d74745f6ab1(accountId, 'people', isGlobalExperienceWorkspace, orgId);
const $1f7067aa44298f63$export$a1c75f05b6ef3ec6 = (teamId, isGlobalExperienceWorkspace, orgId)=>$1f7067aa44298f63$export$4c191d74745f6ab1(teamId, 'people/team', isGlobalExperienceWorkspace, orgId);
const $1f7067aa44298f63$var$getAtlasViewAllRedirectUrl = (entity, searchText, workspaces, isGlobalExperienceWorkspace, orgId)=>{
    let url;
    if (workspaces && workspaces.length === 1 && /team\.(stg\.)?atlassian\.com/.test(workspaces[0].baseUrl)) url = new URL(workspaces[0].baseUrl);
    else url = new URL($1f7067aa44298f63$export$b182d98f245a5298(isGlobalExperienceWorkspace));
    const pathPrefix = isGlobalExperienceWorkspace && orgId ? `o/${orgId}/` : '';
    url.pathname = `${pathPrefix}action/search/${entity}`;
    url.searchParams.append('searchText', searchText);
    return url.href;
};
var $1f7067aa44298f63$export$2e2bcd8739ae039 = $1f7067aa44298f63$var$getAtlasViewAllRedirectUrl;





parcelRequire("42omo");






const $5b5eba0a2aeb65d3$var$iconStyles = (0, $ecnYn.xcss)({
    width: '22px',
    height: '22px'
});
const $5b5eba0a2aeb65d3$export$e16bd899bb4eebf9 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $5b5eba0a2aeb65d3$var$iconStyles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    x: "0.618757",
                    y: "0.618757",
                    width: "20.7625",
                    height: "20.7625",
                    rx: "4.38124",
                    stroke: "#0B1228",
                    strokeOpacity: "0.14",
                    strokeWidth: "0.762486"
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip0_931_182)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M4.20962 16.0782L4.91523 17.2907C5.06186 17.546 5.27262 17.7466 5.52005 17.8925L8.04009 13.5529H3C3 13.8355 3.07331 14.1181 3.21993 14.3734L4.20962 16.0782Z",
                            fill: "#0066DA"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M11 8.44751L8.47995 4.10791C8.23253 4.25378 8.02176 4.45435 7.87514 4.70962L3.21993 12.7324C3.07601 12.9822 3.00019 13.265 3 13.5529H8.04009L11 8.44751Z",
                            fill: "#00AC47"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M16.4799 17.8925C16.7273 17.7466 16.9381 17.546 17.0847 17.2907L17.3779 16.7893L18.78 14.3734C18.9266 14.1181 18.9999 13.8355 18.9999 13.5529H13.9595L15.032 15.6497L16.4799 17.8925Z",
                            fill: "#EA4335"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M11 8.4475L13.5201 4.1079C13.2726 3.96203 12.9886 3.8891 12.6953 3.8891H9.30472C9.01148 3.8891 8.7274 3.97115 8.47998 4.1079L11 8.4475Z",
                            fill: "#00832D"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M13.9594 13.5529H8.03958L5.51953 17.8925C5.76695 18.0383 6.05103 18.1113 6.34427 18.1113H15.6547C15.9479 18.1113 16.232 18.0292 16.4794 17.8925L13.9594 13.5529Z",
                            fill: "#2684FC"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M16.4525 8.72101L14.1249 4.70962C13.9782 4.45435 13.7675 4.25378 13.52 4.10791L11 8.44751L13.9599 13.5529H18.9908C18.9908 13.2703 18.9175 12.9877 18.7709 12.7324L16.4525 8.72101Z",
                            fill: "#FFBA00"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_931_182",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "16",
                            height: "14.2222",
                            fill: "white",
                            transform: "translate(3 3.88904)"
                        })
                    })
                })
            ]
        })
    });





parcelRequire("42omo");






const $a12b4f39323b4c5d$var$iconStyles = (0, $ecnYn.xcss)({
    width: '22px',
    height: '22px'
});
const $a12b4f39323b4c5d$export$b33fb54b08bb6422 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $a12b4f39323b4c5d$var$iconStyles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    x: "0.5",
                    y: "0.5",
                    width: "21",
                    height: "21",
                    rx: "4.5",
                    stroke: "#0B1228",
                    strokeOpacity: "0.14"
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip0_931_190)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M6.99813 12.8186C6.99813 13.6234 6.34773 14.2738 5.54301 14.2738C4.73828 14.2738 4.08789 13.6234 4.08789 12.8186C4.08789 12.0139 4.73828 11.3635 5.54301 11.3635H6.99813V12.8186ZM7.72569 12.8186C7.72569 12.0139 8.37608 11.3635 9.1808 11.3635C9.98553 11.3635 10.6359 12.0139 10.6359 12.8186V16.4564C10.6359 17.2612 9.98553 17.9116 9.1808 17.9116C8.37608 17.9116 7.72569 17.2612 7.72569 16.4564V12.8186Z",
                            fill: "#E01E5A"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M9.18109 6.97615C8.37636 6.97615 7.72597 6.32576 7.72597 5.52104C7.72597 4.71631 8.37636 4.06592 9.18109 4.06592C9.98581 4.06592 10.6362 4.71631 10.6362 5.52104V6.97615H9.18109ZM9.18109 7.71474C9.98581 7.71474 10.6362 8.36513 10.6362 9.16986C10.6362 9.97458 9.98581 10.625 9.18109 10.625H5.53227C4.72754 10.625 4.07715 9.97458 4.07715 9.16986C4.07715 8.36513 4.72754 7.71474 5.53227 7.71474H9.18109Z",
                            fill: "#36C5F0"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M15.0123 9.16986C15.0123 8.36513 15.6627 7.71474 16.4674 7.71474C17.2721 7.71474 17.9225 8.36513 17.9225 9.16986C17.9225 9.97458 17.2721 10.625 16.4674 10.625H15.0123V9.16986ZM14.2847 9.16986C14.2847 9.97458 13.6344 10.625 12.8296 10.625C12.0249 10.625 11.3745 9.97458 11.3745 9.16986V5.52104C11.3745 4.71631 12.0249 4.06592 12.8296 4.06592C13.6344 4.06592 14.2847 4.71631 14.2847 5.52104V9.16986Z",
                            fill: "#2EB67D"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M12.8296 15.0013C13.6344 15.0013 14.2847 15.6517 14.2847 16.4564C14.2847 17.2612 13.6344 17.9116 12.8296 17.9116C12.0249 17.9116 11.3745 17.2612 11.3745 16.4564V15.0013H12.8296ZM12.8296 14.2738C12.0249 14.2738 11.3745 13.6234 11.3745 12.8186C11.3745 12.0139 12.0249 11.3635 12.8296 11.3635H16.4784C17.2832 11.3635 17.9336 12.0139 17.9336 12.8186C17.9336 13.6234 17.2832 14.2738 16.4784 14.2738H12.8296Z",
                            fill: "#ECB22E"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_931_190",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white",
                            transform: "translate(4 3.99988)"
                        })
                    })
                })
            ]
        })
    });

















const $254bef028b438f80$var$ModifierIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.ReturnIconWithModifier), {
        showModifierKey: true
    });
const $254bef028b438f80$var$ReturnIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.ReturnIconWithModifier), {});
const $254bef028b438f80$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $254bef028b438f80$var$productIconStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '78px'
});
const $254bef028b438f80$var$moreButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    paddingInline: 'space.075',
    marginRight: 'space.050',
    height: '20px',
    display: 'flex',
    alignItems: 'center'
});
const $254bef028b438f80$var$absoluteStyles = (0, $ecnYn.xcss)({
    position: 'absolute'
});
const $254bef028b438f80$var$borderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '22px',
    width: '22px',
    borderRadius: 'radius.medium'
});
const $254bef028b438f80$var$jiraIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'dialog',
    transform: 'translate(15px, 0)'
});
const $254bef028b438f80$var$confluenceIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'navigation',
    transform: 'translate(30px, 0)'
});
const $254bef028b438f80$var$googleDriveIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'card',
    transform: 'translate(45px, 0)'
});
const $254bef028b438f80$var$slackIconOverlapStyles = (0, $ecnYn.xcss)({
    transform: 'translate(60px, 0)'
});
const $254bef028b438f80$var$IconComponent = ({ showModifierIcon: showModifierIcon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $254bef028b438f80$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $254bef028b438f80$var$productIconStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$jiraIconOverlapStyles,
                            $254bef028b438f80$var$borderStyles
                        ],
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                            size: "xsmall",
                            shouldUseNewLogoDesign: true
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$confluenceIconOverlapStyles,
                            $254bef028b438f80$var$borderStyles
                        ],
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
                            size: "xsmall",
                            shouldUseNewLogoDesign: true
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$googleDriveIconOverlapStyles
                        ],
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5b5eba0a2aeb65d3$export$e16bd899bb4eebf9), {})
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$slackIconOverlapStyles
                        ],
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a12b4f39323b4c5d$export$b33fb54b08bb6422), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $254bef028b438f80$var$moreButtonStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: formatMessage((0, $e1ib8.messages).more)
                })
            }),
            showModifierIcon ? /*#__PURE__*/ (0, $l998X.jsx)($254bef028b438f80$var$ModifierIcon, {}) : /*#__PURE__*/ (0, $l998X.jsx)($254bef028b438f80$var$ReturnIcon, {})
        ]
    });
};
const $254bef028b438f80$export$306c16563e2015b8 = (orgId, cloudId, query, primaryProduct)=>{
    const url = new URL(`${(0, $1f7067aa44298f63$export$b182d98f245a5298)(true)}/o/${orgId}/search`);
    url.searchParams.set('cloudId', cloudId);
    if (primaryProduct) url.searchParams.set('referrer', primaryProduct);
    if (query) url.searchParams.set('text', query);
    return url.toString();
};
const $254bef028b438f80$export$829d02f6cd9ab0ce = ({ orgId: orgId, cloudId: cloudId, showModifierIcon: showModifierIcon, actionSubjectId: actionSubjectId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const activeProduct = getActiveProduct();
    const href = $254bef028b438f80$export$306c16563e2015b8(orgId, cloudId, query, primaryProduct?.id);
    const productName = activeProduct?.title;
    const defaultActionSubjectId = `${productName}AdvancedSearchLink`;
    const onAdvancedSearchClicked = (0, $42omo.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId || defaultActionSubjectId,
            isLoading: isLoading,
            newTab: true,
            isRovoCrossProductSearchLink: true
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        actionSubjectId,
        defaultActionSubjectId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.AdvancedSearchFooterLink), {
        href: href,
        onClick: onAdvancedSearchClicked,
        linkComponent: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l3UB9.AdvancedSearchLink), {
                ...props,
                isKeyboardHighlighted: !!props.isKeyboardHighlighted,
                href: href,
                target: "_blank"
            }),
        contentLabel: formatMessage((0, $e1ib8.messages).extensible_advanced_search_cross_product_footer),
        returnKeyIconComponent: ()=>/*#__PURE__*/ (0, $l998X.jsx)($254bef028b438f80$var$IconComponent, {
                showModifierIcon: showModifierIcon
            })
    });
};



var $iEwUU = parcelRequire("iEwUU");




const $3cc71055164da496$var$mapAggregatorResponseToSearchItem = (repo)=>{
    return {
        title: repo.name,
        id: repo.uuid,
        meta: repo.workspace.name,
        url: repo.links.html.href,
        iconUrl: repo.links.avatar.href,
        containerId: repo.workspace.uuid
    };
};
const $3cc71055164da496$export$9d75ef492044e493 = ({ intl: intl, viewAllLinkGenerator: overriddenViewAllLinkGenerator, codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator, codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen, permissionSupplier: overriddenPermissionsSupplier, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, currentContext: currentContext, features: _features, ...rest })=>{
    const { viewAllLinkGenerator: viewAllLinkGenerator, codeSearchUrlGenerator: codeSearchUrlGenerator, codeSearchContextualUrlGenerator: codeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $42omo.useMemo)(()=>{
        return (0, $5e4d9137215cb451$export$8f020ef2e5947a78)({
            viewAllLinkGenerator: overriddenViewAllLinkGenerator,
            codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator,
            codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator,
            urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen
        });
    }, [
        overriddenCodeSearchUrlGenerator,
        overriddenCodeSearchContextualUrlGenerator,
        overriddenUrlGeneratorForNoResultsScreen,
        overriddenViewAllLinkGenerator
    ]);
    const sections = [
        {
            id: (0, $7fdea999808324e3$export$30e31f52a81be3c8).BitbucketRepostitory,
            title: intl.formatMessage((0, $c3475590821d5a81$export$defe85febe8b728c).bitbucket_repository_heading),
            scope: (0, $7fdea999808324e3$export$30e31f52a81be3c8).BitbucketRepostitory,
            showResultCount: true,
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultMapper: ({ results: results })=>results.map((value)=>$3cc71055164da496$var$mapAggregatorResponseToSearchItem(value))
        }
    ];
    const itemSuppliers = (0, $029554683ea761ec$export$967ff0f6c3886589)((0, $7fdea999808324e3$export$49fc3e2141fc5779), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const workspacesPermissionSupplier = (0, $1e3c0c6b3e40ed4c$export$904bd3598beda83b)(overriddenPermissionsSupplier);
    const scopesPermissionSupplier = (0, $5cca7b29b77d44d1$export$e0a27ecb613d1aab)(overriddenPermissionsSupplier);
    const permissionSupplier = (0, $dh538.fg)('enable_bitbucket_repository_workspace_search_in_qs') ? workspacesPermissionSupplier : scopesPermissionSupplier;
    const formattedSearchForCodeLabel = (context)=>{
        const { repository: repository, workspace: workspace } = context || {};
        let source = 'Bitbucket';
        if (repository) source = repository.name;
        else if (workspace) source = workspace.name;
        return intl.formatMessage((0, $c3475590821d5a81$export$defe85febe8b728c).bitbucket_advanced_search, {
            source: source
        });
    };
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $42omo.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $254bef028b438f80$export$306c16563e2015b8)(orgId, cloudId, query, primaryProduct?.id);
        return viewAllLinkGenerator(query);
    }, [
        viewAllLinkGenerator,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5cba.SearchDialogProduct), {
        expandedStateInputPlaceholder: intl.formatMessage((0, $c3475590821d5a81$export$defe85febe8b728c).bitbucket_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        id: (0, $7fdea999808324e3$export$49fc3e2141fc5779),
        permissionSupplier: permissionSupplier,
        preQuerySectionTitleGenerator: (section)=>section.id === (0, $7fdea999808324e3$export$30e31f52a81be3c8).BitbucketRepostitory ? intl.formatMessage((0, $c3475590821d5a81$export$defe85febe8b728c).bitbucket_recent_repositories) : '',
        sections: sections,
        title: intl.formatMessage((0, $bF0iL.messages).bitbucket_tab_label),
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        ...rest,
        ...itemSuppliers,
        children: ({ linkComponent: linkComponent, query: query })=>{
            const codeSearchUrl = currentContext ? codeSearchContextualUrlGenerator(query, currentContext) : codeSearchUrlGenerator(query);
            const contextualSearchMessage = formattedSearchForCodeLabel(currentContext);
            return {
                Header: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2ba4e0bc1633544b$export$2709da4acd7d0aec), {
                        advancedSearchMessage: contextualSearchMessage,
                        advancedSearchUrl: codeSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $254bef028b438f80$export$829d02f6cd9ab0ce), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $3cc71055164da496$export$a83467d99f696187 = (0, $gmMgo.default)($3cc71055164da496$export$9d75ef492044e493);



























var $jFPud = parcelRequire("jFPud");




const $c4131fa39bec30c7$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /**
   * Compass
   */ compass_tab_label: {
        id: "product_search_dialog.compass.tab_label",
        defaultMessage: "Compass"
    },
    compass_components_section_heading: {
        id: "product_search_dialog.compass.components_section_heading",
        defaultMessage: "Components"
    },
    compass_people_section_heading: {
        id: "product_search_dialog.compass.people_section_heading",
        defaultMessage: "People"
    },
    compass_teams_section_heading: {
        id: "product_search_dialog.compass.teams_section_heading",
        defaultMessage: "Teams"
    },
    compass_endpoints_section_heading: {
        id: "product_search_dialog.compass.endpoints_section_heading",
        defaultMessage: "Endpoints"
    },
    compass_expanded_input_placeholder: {
        id: "product_search_dialog.compass.expanded.input-placeholder",
        defaultMessage: "Search Compass"
    },
    compass_view_all_components: {
        id: "product_search_dialog.compass.view_all_components_label",
        defaultMessage: "View all components"
    },
    compass_view_all_results: {
        id: "product_search_dialog.compass.view_all_results_label",
        defaultMessage: "View all results"
    },
    compass_component_type_service: {
        id: "product_search_dialog.compass.component_type.service",
        defaultMessage: "Service"
    },
    compass_component_type_library: {
        id: "product_search_dialog.compass.component_type.library",
        defaultMessage: "Library"
    },
    compass_component_type_application: {
        id: "product_search_dialog.compass.component_type.application",
        defaultMessage: "Application"
    },
    compass_component_type_capability: {
        id: "product_search_dialog.compass.component_type.capability",
        defaultMessage: "Capability"
    },
    compass_component_type_cloud_resource: {
        id: "product_search_dialog.compass.component_type.cloud_resource",
        defaultMessage: "Cloud resource"
    },
    compass_component_type_data_pipeline: {
        id: "product_search_dialog.compass.component_type.data_pipeline",
        defaultMessage: "Data pipeline"
    },
    compass_component_type_machine_learning_model: {
        id: "product_search_dialog.compass.component_type.machine_learning_model",
        defaultMessage: "Machine learning model"
    },
    compass_component_type_ui_element: {
        id: "product_search_dialog.compass.component_type.ui_element",
        defaultMessage: "UI element"
    },
    compass_component_type_website: {
        id: "product_search_dialog.compass.component_type.website",
        defaultMessage: "Website"
    },
    compass_component_type_other: {
        id: "product_search_dialog.compass.component_type.other",
        defaultMessage: "Other"
    },
    compass_recently_viewed_components: {
        id: "product_search_dialog.compass.recently_viewed_components",
        defaultMessage: "Recently viewed components"
    },
    compass_recently_viewed_teams: {
        id: "product_search_dialog.compass.recently_viewed_teams",
        defaultMessage: "Recently viewed teams"
    },
    compass_recently_viewed_endpoints: {
        id: "product_search_dialog.compass.recently_viewed_endpoints",
        defaultMessage: "Recently viewed endpoints"
    }
});



/* result-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $ho4zm = parcelRequire("ho4zm");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");


var $gnG2x = parcelRequire("gnG2x");


var $9Qum6 = parcelRequire("9Qum6");


var $ejGzS = parcelRequire("ejGzS");




/* result-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");







/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");


var $ea55797a819afe35$export$7dfd429914c57d74 = /*#__PURE__*/ function(CompassScope) {
    CompassScope["Component"] = "compass.component";
    CompassScope["People"] = "compass.people";
    CompassScope["Teams"] = "compass.teams";
    CompassScope["ApiEndpoint"] = "compass.api-endpoint";
    return CompassScope;
}({});
const $ea55797a819afe35$export$6349b6efda58d149 = {
    SERVICE: {
        color: `var(--ds-icon, ${$6fnsQ.P300})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z"
                })
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_service
    },
    LIBRARY: {
        color: `var(--ds-icon, ${$6fnsQ.Y500})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z"
                })
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_library
    },
    APPLICATION: {
        color: `var(--ds-icon, ${$6fnsQ.G300})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z"
                })
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_application
    },
    CAPABILITY: {
        color: `var(--ds-icon, ${$6fnsQ.N600})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.5145 6.15717C10.5145 6.97758 11.1796 7.64266 12 7.64266C12.8204 7.64266 13.4855 6.97758 13.4855 6.15717C13.4855 5.33676 12.8204 4.67168 12 4.67168C11.1796 4.67168 10.5145 5.33676 10.5145 6.15717ZM11.15 9.22799C10.8953 9.15765 10.6534 9.05647 10.4286 8.92873L8.93348 10.426C9.19656 10.8894 9.34679 11.4253 9.34679 11.9963C9.34679 13.7556 7.9206 15.1818 6.1613 15.1818C4.40201 15.1818 2.97581 13.7556 2.97581 11.9963C2.97581 10.237 4.40201 8.81083 6.1613 8.81083C6.73217 8.81083 7.26796 8.96099 7.73134 9.22398L9.22707 7.72612C8.96447 7.263 8.81454 6.72759 8.81454 6.15717C8.81454 4.39787 10.2407 2.97168 12 2.97168C13.7593 2.97168 15.1855 4.39787 15.1855 6.15717C15.1855 6.72831 15.0352 7.26434 14.772 7.72787L16.2683 9.22419C16.7318 8.96107 17.2677 8.81083 17.8387 8.81083C19.598 8.81083 21.0242 10.237 21.0242 11.9963C21.0242 13.7556 19.598 15.1818 17.8387 15.1818C16.0794 15.1818 14.6532 13.7556 14.6532 11.9963C14.6532 11.4255 14.8034 10.8897 15.0663 10.4264L13.5697 8.92972C13.3453 9.057 13.104 9.15784 12.85 9.228V14.7646C14.1966 15.1366 15.1855 16.3705 15.1855 17.8355C15.1855 19.5948 13.7593 21.021 12 21.021C10.2407 21.021 8.81454 19.5948 8.81454 17.8355C8.81454 16.3705 9.80338 15.1366 11.15 14.7646V9.22799ZM4.67581 11.9963C4.67581 12.8167 5.34089 13.4818 6.1613 13.4818C6.98172 13.4818 7.64679 12.8167 7.64679 11.9963C7.64679 11.1759 6.98172 10.5108 6.1613 10.5108C5.34089 10.5108 4.67581 11.1759 4.67581 11.9963ZM12 19.321C11.1796 19.321 10.5145 18.6559 10.5145 17.8355C10.5145 17.0151 11.1796 16.35 12 16.35C12.8204 16.35 13.4855 17.0151 13.4855 17.8355C13.4855 18.6559 12.8204 19.321 12 19.321ZM16.3532 11.9963C16.3532 12.8167 17.0183 13.4818 17.8387 13.4818C18.6591 13.4818 19.3242 12.8167 19.3242 11.9963C19.3242 11.1759 18.6591 10.5108 17.8387 10.5108C17.0183 10.5108 16.3532 11.1759 16.3532 11.9963Z"
                })
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_capability
    },
    CLOUD_RESOURCE: {
        color: `var(--ds-icon, ${$6fnsQ.P300})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_cloud_resource
    },
    DATA_PIPELINE: {
        color: `var(--ds-icon, ${$6fnsQ.R300})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z",
                        stroke: "#fff",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z",
                        stroke: "#fff",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_data_pipeline
    },
    MACHINE_LEARNING_MODEL: {
        color: `var(--ds-icon, ${$6fnsQ.R300})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z",
                        stroke: "#fff",
                        strokeWidth: "1.5",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M4.61222 7.89078L18.8696 16.1906",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M4.85273 16.2901L19.0688 7.95921",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "none",
                        d: "M11.7317 20.2989L11.7317 3.24756",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fill: "#FF5630",
                        d: "M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z",
                        stroke: "#fff",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_machine_learning_model
    },
    UI_ELEMENT: {
        color: `var(--ds-icon, ${$6fnsQ.Y500})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "path-1-inside-1_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            x: "2.83353",
                            y: "13.6489",
                            width: "6.97358",
                            height: "7.36887",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        fill: "none",
                        x: "2.83353",
                        y: "13.6489",
                        width: "6.97358",
                        height: "7.36887",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-1-inside-1_1403_23012)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "path-2-inside-2_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            x: "2.83353",
                            y: "3.01807",
                            width: "18.5455",
                            height: "8.59702",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        fill: "none",
                        x: "2.83353",
                        y: "3.01807",
                        width: "18.5455",
                        height: "8.59702",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-2-inside-2_1403_23012)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                        id: "path-3-inside-3_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            x: "11.5089",
                            y: "13.6489",
                            width: "9.87006",
                            height: "7.36887",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        fill: "none",
                        x: "11.5089",
                        y: "13.6489",
                        width: "9.87006",
                        height: "7.36887",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-3-inside-3_1403_23012)"
                    })
                ]
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_ui_element
    },
    WEBSITE: {
        color: `var(--ds-icon, ${$6fnsQ.G300})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fill: "fff",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.3319 20.9136C13.5069 20.9136 14.6704 20.6821 15.756 20.2325C16.8416 19.7828 17.828 19.1237 18.6589 18.2928C19.4898 17.462 20.1489 16.4756 20.5985 15.39C21.0482 14.3044 21.2796 13.1409 21.2796 11.9658C21.2796 10.7908 21.0482 9.62725 20.5985 8.54166C20.1489 7.45607 19.4898 6.46968 18.6589 5.6388C17.828 4.80793 16.8416 4.14884 15.756 3.69917C14.6704 3.24951 13.5069 3.01807 12.3319 3.01807C9.95879 3.01807 7.68289 3.96077 6.00486 5.6388C4.32683 7.31683 3.38412 9.59273 3.38412 11.9658C3.38412 14.3389 4.32683 16.6148 6.00486 18.2928C7.68289 19.9709 9.95879 20.9136 12.3319 20.9136V20.9136ZM11.4371 19.0614C9.70752 18.8456 8.11636 18.0054 6.96289 16.6987C5.80941 15.3919 5.17312 13.7088 5.17368 11.9658C5.17368 11.4111 5.24526 10.8831 5.36158 10.3642L9.64755 14.6501V15.5449C9.64755 16.5292 10.4529 17.3345 11.4371 17.3345V19.0614V19.0614ZM17.6111 16.7887C17.4975 16.427 17.2713 16.1113 16.9654 15.8875C16.6595 15.6637 16.29 15.5436 15.911 15.5449H15.0162V12.8606C15.0162 12.3685 14.6136 11.9658 14.1214 11.9658H8.75278V10.1763H10.5423C11.0345 10.1763 11.4371 9.77362 11.4371 9.28149V7.49194H13.2267C14.2109 7.49194 15.0162 6.68665 15.0162 5.70239V5.33553C17.6379 6.40032 19.4901 8.96832 19.4901 11.9658C19.4901 13.827 18.7743 15.5181 17.6111 16.7887V16.7887Z"
                })
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_website
    },
    OTHER: {
        color: `var(--ds-icon, ${$6fnsQ.B300})`,
        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z"
                    })
                ]
            }),
        message: (0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_component_type_other
    }
};



var $SZOxu = parcelRequire("SZOxu");


var $5I0OA = parcelRequire("5I0OA");

const $27cceccddbf9c80b$export$e320804e9cbf60f = (0, $5I0OA.default).div`
	display: flex;
	align-items: center;
	justify-content: center;

	width: ${(props)=>(0, $SZOxu.sizes)[props.size]};
	height: ${(props)=>(0, $SZOxu.sizes)[props.size]};

	background-color: ${(props)=>props.color};
	border-radius: 3px;

	& > svg,
	& > span[role='img'],
	& > span[role='presentation'] {
		width: 83.333333%;
	}
`;


const $191b99a422a86faf$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $191b99a422a86faf$export$e8ec4da10aa3e6a6 = ({ type: type, size: size = 'medium' })=>{
    const intl = (0, $8C5kA.default)();
    const componentType = (0, $ea55797a819afe35$export$6349b6efda58d149)[type] ?? (0, $ea55797a819afe35$export$6349b6efda58d149).OTHER;
    const ComponentTypeIcon = componentType.icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: intl.formatMessage(componentType.message),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $27cceccddbf9c80b$export$e320804e9cbf60f), {
            color: componentType.color,
            size: size,
            children: /*#__PURE__*/ (0, $l998X.jsx)(ComponentTypeIcon, {
                "aria-label": type,
                role: "img",
                className: (0, $gMc0m.default)([
                    $191b99a422a86faf$var$sizeStyles[size]
                ])
            })
        })
    });
};


const $fe2b6b1b287be335$export$f2eed8836fc2639e = (args)=>{
    const { productState: productState, searchResult: searchResult } = args;
    const iconSize = productState === (0, $jFPud.ProductStates).PreQuerySuccess ? 'small' : 'medium';
    const iconType = searchResult.icon?.toString() ?? '';
    return (0, $ejGzS.defaultResultRenderer)({
        ...args,
        searchResult: {
            ...searchResult,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $191b99a422a86faf$export$e8ec4da10aa3e6a6), {
                type: iconType,
                size: iconSize
            })
        }
    });
};
const $fe2b6b1b287be335$export$3269347603d2224e = (args)=>{
    const { productState: productState, searchResult: searchResult } = args;
    const iconSize = productState === (0, $jFPud.ProductStates).PreQuerySuccess ? 'xsmall' : 'small';
    return (0, $ejGzS.defaultResultRenderer)({
        ...args,
        searchResult: {
            ...searchResult,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $9Qum6.ResultAvatar), {
                borderColor: "transparent",
                src: searchResult.iconUrl,
                appearance: "square",
                size: iconSize,
                testId: "result-avatar"
            })
        }
    });
};
const $fe2b6b1b287be335$var$MethodDetails = {
    POST: {
        abbreviation: 'POST',
        color: 'purpleLight'
    },
    GET: {
        abbreviation: 'GET',
        color: 'greenLight'
    },
    PUT: {
        abbreviation: 'PUT',
        color: 'blueLight'
    },
    DELETE: {
        abbreviation: 'DEL',
        color: 'redLight'
    },
    PATCH: {
        abbreviation: 'PATCH',
        color: 'greyLight'
    },
    OPTIONS: {
        abbreviation: 'OPT',
        color: 'greyLight'
    },
    HEAD: {
        abbreviation: 'HEAD',
        color: 'greyLight'
    },
    TRACE: {
        abbreviation: 'TRACE',
        color: 'greyLight'
    },
    CONNECT: {
        abbreviation: 'CONN',
        color: 'greyLight'
    }
};
const $fe2b6b1b287be335$var$styles = {
    methodTag: "_18u0r5cr"
};
const $fe2b6b1b287be335$export$2db93eff9b2b2c36 = (args)=>{
    const { searchResult: searchResult } = args;
    const method = (typeof searchResult.icon === 'string' ? searchResult.icon : '').toUpperCase();
    const methodDetails = $fe2b6b1b287be335$var$MethodDetails[method];
    const methodTag = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $fe2b6b1b287be335$var$styles.methodTag,
        children: methodDetails ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: methodDetails.abbreviation,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ho4zm.default), {
                text: methodDetails.abbreviation,
                color: methodDetails.color
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: 'OTHER',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ho4zm.default), {
                text: 'OTHER',
                color: "greyLight"
            })
        })
    });
    const title = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        paddingInlineStart: "space.300",
        children: searchResult.title
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gnG2x.SearchResultContent), {
        isKeyboardHighlighted: args.isKeyboardHighlighted,
        title: title,
        icon: methodTag,
        isCollapsed: args.isCollapsed,
        meta: searchResult.meta
    }, `item_${searchResult.id}`);
};



const $cf8641474df1decd$var$mapComponentAggregatorResponseToSearchItem = (response)=>({
        title: response.title,
        id: response.id,
        meta: response.ownerId,
        url: response.url,
        icon: response.type,
        containerId: '' // no container
    });
const $cf8641474df1decd$var$mapApiEndpointAggregatorResponseToSearchItem = (response)=>({
        title: response.title,
        id: response.id,
        url: response.url,
        icon: response.url.split('/').pop()?.split('.')[0] || '',
        meta: ''
    });
const $cf8641474df1decd$export$ddbcae0b0bd6b092 = (intl)=>{
    const sections = [
        {
            id: (0, $ea55797a819afe35$export$7dfd429914c57d74).Component,
            title: intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_components_section_heading),
            scope: (0, $ea55797a819afe35$export$7dfd429914c57d74).Component,
            showResultCount: true,
            resultRenderer: (0, $fe2b6b1b287be335$export$f2eed8836fc2639e),
            resultMapper: ({ results: results })=>results.map((value)=>$cf8641474df1decd$var$mapComponentAggregatorResponseToSearchItem(value))
        },
        {
            id: (0, $ea55797a819afe35$export$7dfd429914c57d74).ApiEndpoint,
            title: intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_endpoints_section_heading),
            scope: (0, $ea55797a819afe35$export$7dfd429914c57d74).ApiEndpoint,
            showResultCount: true,
            resultRenderer: (0, $fe2b6b1b287be335$export$2db93eff9b2b2c36),
            resultLimit: 5,
            resultMapper: ({ results: results })=>results.map((value)=>$cf8641474df1decd$var$mapApiEndpointAggregatorResponseToSearchItem(value))
        }
    ];
    return sections;
};








const $6972a0988821eda6$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $6972a0988821eda6$var$resolveRecommendationRequest = ({ baseUrl: baseUrl, context: context, includeUsers: includeUsers, includeTeams: includeTeams, query: query, maxNumberOfResults: maxNumberOfResults })=>({
        baseUrl: baseUrl,
        context: context,
        maxNumberOfResults: maxNumberOfResults,
        query: query ?? '',
        searchQueryFilter: $6972a0988821eda6$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
        includeUsers: includeUsers ?? false,
        includeGroups: false,
        includeTeams: includeTeams ?? false
    });

const $6972a0988821eda6$var$asyncGetUserRecommendations = async (request, intl)=>{
    try {
        const { getUserRecommendations: getUserRecommendations } = await (parcelRequire("1ICWL"));
        return getUserRecommendations(request, intl);
    } catch (e) {
    // Ignore
    }
};
const $6972a0988821eda6$export$f16e39d5b6af63da = (peopleAndTeamSections, maxItemsPerSection)=>{
    const intl = (0, $8C5kA.default)();
    return async (query, { baseUrl: baseUrl, context: context, resolveTeamUrl: resolveTeamUrl, resolveUserUrl: resolveUserUrl })=>{
        const teamsRequest = $6972a0988821eda6$var$resolveRecommendationRequest({
            includeTeams: true,
            baseUrl: baseUrl,
            context: context,
            query: query,
            maxNumberOfResults: 20
        });
        // Separate requests enables better empty query results for each section
        const usersRequest = $6972a0988821eda6$var$resolveRecommendationRequest({
            includeUsers: true,
            baseUrl: baseUrl,
            context: context,
            query: query,
            maxNumberOfResults: 20
        });
        try {
            const [teams, users] = await Promise.all([
                $6972a0988821eda6$var$asyncGetUserRecommendations(teamsRequest, intl),
                $6972a0988821eda6$var$asyncGetUserRecommendations(usersRequest, intl)
            ]);
            const teamResults = teams?.map((team)=>{
                return {
                    title: team.name,
                    id: team.id,
                    meta: '',
                    url: resolveTeamUrl ? resolveTeamUrl(team.id) : `/people/team/${team.id}`,
                    iconUrl: team.avatarUrl,
                    isVerified: team.verified
                };
            }) ?? [];
            const userResults = users?.map((user)=>{
                return {
                    title: user.name,
                    id: user.id,
                    meta: user.title || '',
                    url: resolveUserUrl ? resolveUserUrl(user.id) : `/people/${user.id}`,
                    iconUrl: user.avatarUrl
                };
            }) ?? [];
            return {
                sections: [
                    {
                        ...peopleAndTeamSections.people,
                        searchResults: maxItemsPerSection ? userResults.slice(0, maxItemsPerSection) : userResults
                    },
                    {
                        ...peopleAndTeamSections.teams,
                        searchResults: maxItemsPerSection ? teamResults.slice(0, maxItemsPerSection) : teamResults
                    }
                ]
            };
        } catch (error) {
            return {
                sections: [
                    {
                        ...peopleAndTeamSections.people,
                        searchResults: []
                    },
                    {
                        ...peopleAndTeamSections.teams,
                        searchResults: []
                    }
                ]
            };
        }
    };
};







const $39c8c0bb71b97b60$export$a637ff7dbe7c1532 = ({ teamId: teamId, siteId: siteId })=>{
    if (teamId === undefined || siteId === undefined) throw new Error('Missing some required parameters teamId and siteId');
    return `/gateway/api/v4/teams/${encodeURIComponent(teamId)}?siteId=${encodeURIComponent(siteId)}`;
};
const $39c8c0bb71b97b60$export$c11a6707e0ba3a30 = ({ url: url, teamAri: teamAri, siteId: siteId })=>{
    const parts = teamAri.split('/');
    const teamId = parts[parts.length - 1];
    const options = {
        path: $39c8c0bb71b97b60$export$a637ff7dbe7c1532({
            teamId: teamId,
            siteId: siteId
        }),
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
};



const $e86c1942bf63794c$var$getBaseURL = ()=>window.location.origin;
const $e86c1942bf63794c$export$9dd4fd2059f2de3b = (searchUrlOverride)=>{
    const advancedSearchLinkGenerator = (query)=>`${searchUrlOverride || $e86c1942bf63794c$var$getBaseURL()}/compass/components?query=${encodeURIComponent(query)}`;
    const teamUrlGenerator = (teamId)=>`${$e86c1942bf63794c$var$getBaseURL()}/compass/people/team/${teamId}`;
    const userUrlGenerator = (userId)=>`${$e86c1942bf63794c$var$getBaseURL()}/people/${userId}`;
    return {
        advancedSearchLinkGenerator: advancedSearchLinkGenerator,
        teamUrlGenerator: teamUrlGenerator,
        userUrlGenerator: userUrlGenerator
    };
};



const $e334ffb1d4729b69$export$29789a1990c8eafe = 'compass';
const $e334ffb1d4729b69$var$NO_OWNER_TEAM = 'ari:cloud:teams::team/unidentified';
const $e334ffb1d4729b69$export$9b569c25a7f27268 = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier }, sections)=>{
    const intl = (0, $8C5kA.default)();
    const itemSuppliers = (0, $029554683ea761ec$export$967ff0f6c3886589)($e334ffb1d4729b69$export$29789a1990c8eafe, sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const peopleAndTeamSupplier = (0, $6972a0988821eda6$export$f16e39d5b6af63da)({
        people: {
            id: (0, $ea55797a819afe35$export$7dfd429914c57d74).People,
            title: intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_people_section_heading)
        },
        teams: {
            id: (0, $ea55797a819afe35$export$7dfd429914c57d74).Teams,
            title: intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_teams_section_heading)
        }
    }, 3);
    const requestTeamMeta = async (teamId)=>{
        if (!userTeamConfig?.context.siteId || !teamId || teamId === $e334ffb1d4729b69$var$NO_OWNER_TEAM) return '';
        try {
            const team = await (0, $39c8c0bb71b97b60$export$c11a6707e0ba3a30)({
                url: userTeamConfig?.baseUrl || '',
                teamAri: teamId,
                siteId: userTeamConfig?.context.siteId
            });
            return team.displayName;
        } catch (e) {
            // Ignore
            return '';
        }
    };
    const userTeamConfigOverride = {
        context: userTeamConfig.context,
        baseUrl: userTeamConfig.baseUrl,
        resolveTeamUrl: userTeamConfig.resolveTeamUrl ?? (0, $e86c1942bf63794c$export$9dd4fd2059f2de3b)().teamUrlGenerator,
        resolveUserUrl: userTeamConfig.resolveUserUrl ?? (0, $e86c1942bf63794c$export$9dd4fd2059f2de3b)().userUrlGenerator
    };
    const hydrateOwnerMeta = async (items)=>{
        const promises = [];
        const compSection = items.sections.find((s)=>s.id === (0, $ea55797a819afe35$export$7dfd429914c57d74).Component);
        if (compSection) compSection.searchResults.map(async (res)=>{
            promises.push(requestTeamMeta(res.meta).then((teamName)=>res.meta = teamName));
        });
        return Promise.all(promises).then(()=>items);
    };
    const preQueryItemSupplierWithTeamName = async (args)=>{
        const existingSections = await hydrateOwnerMeta(await itemSuppliers.preQueryItemSupplier(args));
        const teamSection = (await peopleAndTeamSupplier('', userTeamConfigOverride)).sections.find((section)=>section.id === (0, $ea55797a819afe35$export$7dfd429914c57d74).Teams);
        return window.location.pathname.startsWith('/compass') ? existingSections : {
            size: existingSections.size,
            sections: [
                ...existingSections.sections,
                ...teamSection ? [
                    {
                        ...teamSection,
                        resultRenderer: (0, $fe2b6b1b287be335$export$3269347603d2224e)
                    }
                ] : []
            ]
        };
    };
    const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await hydrateOwnerMeta(await itemSuppliers.postQueryItemSupplier(args));
        const people = userTeamConfigOverride ? await peopleAndTeamSupplier(args.query, {
            ...userTeamConfigOverride,
            context: {
                ...userTeamConfigOverride.context,
                siteId: userTeamConfigOverride.context.siteId
            }
        }) : null;
        return {
            size: existingSections.size,
            sections: [
                ...existingSections.sections,
                ...people?.sections.map((section)=>({
                        ...section,
                        resultRenderer: (0, $fe2b6b1b287be335$export$3269347603d2224e)
                    })) ?? []
            ]
        };
    };
    const preQuerySectionTitleGenerator = (section)=>{
        switch(section.id){
            case (0, $ea55797a819afe35$export$7dfd429914c57d74).Component:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_recently_viewed_components) : intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_components_section_heading);
            case (0, $ea55797a819afe35$export$7dfd429914c57d74).Teams:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_recently_viewed_teams) : intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_teams_section_heading);
            case (0, $ea55797a819afe35$export$7dfd429914c57d74).ApiEndpoint:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_recently_viewed_endpoints) : intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_endpoints_section_heading);
            default:
                return '';
        }
    };
    return {
        preQueryItemSupplier: preQueryItemSupplierWithTeamName,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    };
};















const $c70e830949a8116b$var$UpsellModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hEG8F")).then((mod)=>({
            default: mod.UpsellModal
        })));
/**
 * Callback function to be used by PSD's permission supplier.
 * @returns all Compass scope required for Compass tab to function properly.
 */ const $c70e830949a8116b$var$upsellPermissionSupplier = ()=>{
    const response = Object.values((0, $ea55797a819afe35$export$7dfd429914c57d74));
    return Promise.resolve(response);
};
const $c70e830949a8116b$var$CompassTabWithIntl = ({ baseUrl: baseUrl, crossFlowEnabled: crossFlowEnabled, intl: intl, isCompassActivated: isCompassActivated = false, isUserAnonymous: isUserAnonymous = false, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, sourceContext: sourceContext, upsellCtaButtonProps: upsellCtaButtonProps, userTeamConfig: userTeamConfig, ...rest })=>{
    const { advancedSearchLinkGenerator: advancedSearchLinkGenerator } = (0, $42omo.useMemo)(()=>{
        return (0, $e86c1942bf63794c$export$9dd4fd2059f2de3b)(baseUrl);
    }, [
        baseUrl
    ]);
    const sections = (0, $cf8641474df1decd$export$ddbcae0b0bd6b092)(intl);
    const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, $e334ffb1d4729b69$export$9b569c25a7f27268)({
        userTeamConfig: userTeamConfig,
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    }, sections);
    const getAdvancedSearchButtonLabel = (0, $42omo.useCallback)((productState)=>{
        switch(productState){
            case (0, $jFPud.ProductStates).PreQueryLoading:
            case (0, $jFPud.ProductStates).PreQuerySuccess:
            case (0, $jFPud.ProductStates).PreQueryError:
            case (0, $jFPud.ProductStates).PreQueryNoResult:
                return intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_view_all_components);
            default:
                return intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_view_all_results);
        }
    }, [
        intl
    ]);
    // https://switcheroo.atlassian.com/ui/gates/87dfd547-5dae-40da-ab90-67c266e10fbd/key/compass-psd-hide-upsell-ad
    const shouldHideUpsellAd = (0, $dh538.fg)('compass-psd-hide-upsell-ad');
    const shouldUpsell = !shouldHideUpsellAd && !isUserAnonymous && crossFlowEnabled && !isCompassActivated && ((0, $dh538.fg)('hide_fedramp_compass_search_tab') ? !(0, $T9xHm.isFedrampModerate)() : true) && !(0, $T9xHm.isIsolatedCloud)();
    const permissionSupplier = shouldUpsell ? $c70e830949a8116b$var$upsellPermissionSupplier : rest.permissionSupplier;
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $42omo.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $254bef028b438f80$export$306c16563e2015b8)(orgId, cloudId, query, primaryProduct?.id);
        return advancedSearchLinkGenerator(query);
    }, [
        advancedSearchLinkGenerator,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $e334ffb1d4729b69$export$29789a1990c8eafe),
        sections: sections,
        title: intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_tab_label),
        expandedStateInputPlaceholder: intl.formatMessage((0, $c4131fa39bec30c7$export$defe85febe8b728c).compass_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        permissionSupplier: permissionSupplier,
        ...rest,
        children: ({ linkComponent: linkComponent, productState: productState, query: query })=>{
            if (shouldUpsell) return {
                Body: ()=>/*#__PURE__*/ (0, $l998X.jsx)($c70e830949a8116b$var$UpsellModal, {
                        sourceContext: sourceContext ?? 'product search dialog',
                        ctaButtonProps: upsellCtaButtonProps
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {})
            };
            const advancedSearchUrl = advancedSearchLinkGenerator(query);
            const message = getAdvancedSearchButtonLabel(productState);
            return {
                Header: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2ba4e0bc1633544b$export$2709da4acd7d0aec), {
                        advancedSearchMessage: message,
                        advancedSearchUrl: advancedSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $254bef028b438f80$export$829d02f6cd9ab0ce), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $c70e830949a8116b$export$47b1e713578cc03f = (0, $gmMgo.default)($c70e830949a8116b$var$CompassTabWithIntl);

/* eslint-disable import/no-internal-modules */ // See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 






var $hpDfc = parcelRequire("hpDfc");


var $jnLgC = parcelRequire("jnLgC");


var $80L9g = parcelRequire("80L9g");

const $d37a1f8828c7be3a$export$5767e6ba1d152dc0 = ()=>{
    const lastModifiedDate = new Date();
    lastModifiedDate.setDate(lastModifiedDate.getDate() - 90);
    return lastModifiedDate.toISOString().split('T')[0];
};
const $d37a1f8828c7be3a$var$useFilters = (defaultFilters = [], storeFilters = (_value)=>{})=>{
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFilters);
    (0, $42omo.useLayoutEffect)(()=>{
        storeFilters(filters);
    });
    const addFilters = (0, $42omo.useCallback)((newFilters)=>{
        dispatch((0, $jnLgC.addFilters)(newFilters));
        storeFilters(filters.concat(newFilters));
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const updateFilter = (0, $42omo.useCallback)((id, isChecked)=>{
        dispatch((0, $jnLgC.updateFilterState)(id, isChecked, true));
        const index = filters.findIndex((filter)=>filter.id === id);
        const newFilters = [
            ...filters
        ];
        newFilters[index] = {
            ...newFilters[index],
            isChecked: isChecked,
            isVisible: true
        };
        storeFilters(filters.concat(newFilters));
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const clearFilter = (0, $42omo.useCallback)(()=>{
        filters.forEach((f)=>{
            dispatch((0, $jnLgC.updateFilterState)(f.id, false));
        });
        const newFilters = filters.map((f)=>{
            const newF = {
                ...f
            };
            newF.isChecked = false;
            return newF;
        });
        storeFilters(newFilters);
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const resetFilter = (0, $42omo.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters));
    }, [
        defaultFilters,
        dispatch
    ]);
    return {
        availableFilters: filters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch
    };
};
const $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE = {
    availableFilters: [],
    addFilters: ()=>{},
    updateFilter: ()=>{},
    clearFilter: ()=>{},
    reset: ()=>{},
    dispatch: ()=>{}
};
const $d37a1f8828c7be3a$var$FilterContext = /*#__PURE__*/ (0, $42omo.createContext)({
    spaceFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    peopleFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    siteFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    resetFilters: ()=>{},
    prequeryFiltersRef: {
        current: ''
    }
});
function $d37a1f8828c7be3a$export$5e1edcb3c154ab79(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $d37a1f8828c7be3a$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultSpaceFilters: defaultSpaceFilters, defaultPeopleFilters: defaultPeopleFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
    const previousEnabledState = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(isEnabled);
    const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters, resetConfluenceFiltersRef: resetConfluenceFiltersRef } = (0, $80L9g.useSessionUserInput)();
    const [filters, setFilters] = (0, $42omo.useState)(readFilters('confluence'));
    const initialSpaceFilters = stickySearchEnabled ? filters?.space || defaultSpaceFilters : defaultSpaceFilters;
    const initialPeopleFilters = stickySearchEnabled ? filters?.people || defaultPeopleFilters : defaultPeopleFilters;
    const initialSiteFilters = stickySearchEnabled ? filters?.site || defaultSiteFilters : defaultSiteFilters;
    const getUpdateFilters = (0, $42omo.useCallback)((type)=>(options)=>{
            const filters = readFilters('confluence');
            switch(type){
                case 'SPACE':
                    filters.space = options;
                    break;
                case 'PEOPLE':
                    filters.people = options;
                    break;
                case 'SITE':
                    filters.site = options;
                    break;
            }
            storeFilters('confluence', filters);
        }, [
        readFilters,
        storeFilters
    ]);
    const spaceFilterStore = $d37a1f8828c7be3a$var$useFilters(initialSpaceFilters, stickySearchEnabled ? getUpdateFilters('SPACE') : undefined);
    const peopleFilterStore = $d37a1f8828c7be3a$var$useFilters(initialPeopleFilters, stickySearchEnabled ? getUpdateFilters('PEOPLE') : undefined);
    const siteFilterStore = $d37a1f8828c7be3a$var$useFilters(initialSiteFilters, stickySearchEnabled ? getUpdateFilters('SITE') : undefined);
    const prequeryFiltersRef = (0, $42omo.useRef)('');
    const filtersAnalyticsContext = spaceFilterStore.availableFilters.length === 0 && peopleFilterStore.availableFilters.length === 0 ? {} : {
        container: $d37a1f8828c7be3a$export$5e1edcb3c154ab79(spaceFilterStore.availableFilters),
        contributor: $d37a1f8828c7be3a$export$5e1edcb3c154ab79(peopleFilterStore.availableFilters)
    };
    const resetFilters = (0, $42omo.useCallback)(()=>{
        spaceFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultSpaceFilters || []));
        peopleFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultPeopleFilters || []));
        siteFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultSiteFilters || []));
    }, [
        defaultPeopleFilters,
        defaultSiteFilters,
        defaultSpaceFilters,
        peopleFilterStore,
        siteFilterStore,
        spaceFilterStore
    ]);
    const clearFilters = (0, $42omo.useCallback)(()=>{
        spaceFilterStore.clearFilter();
        peopleFilterStore.clearFilter();
        siteFilterStore.clearFilter();
        if (stickySearchEnabled) setFilters(readFilters('confluence'));
    }, [
        spaceFilterStore,
        peopleFilterStore,
        siteFilterStore,
        stickySearchEnabled,
        readFilters
    ]);
    (0, $42omo.useEffect)(()=>{
        if (resetConfluenceFiltersRef) resetConfluenceFiltersRef.current = clearFilters;
    }, [
        clearFilters,
        resetConfluenceFiltersRef
    ]);
    // We reset the state when the component becomes disabled
    if (previousEnabledState.current && !isEnabled && !stickySearchEnabled) resetFilters();
    previousEnabledState.current = isEnabled;
    return /*#__PURE__*/ (0, $l998X.jsx)($d37a1f8828c7be3a$var$FilterContext.Provider, {
        value: {
            spaceFilters: spaceFilterStore,
            peopleFilters: peopleFilterStore,
            siteFilters: siteFilterStore,
            resetFilters: resetFilters,
            prequeryFiltersRef: prequeryFiltersRef
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext,
            children: children
        })
    });
};
const $d37a1f8828c7be3a$export$396ef541d9951d45 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($d37a1f8828c7be3a$var$FilterContext);
};




















const $36c76e3adf761bae$export$661dd16d63ed8290 = 'confluence';
const $36c76e3adf761bae$export$4a204ebf24901f2e = 'confluence.nav-v3';
const $36c76e3adf761bae$export$d4cf0635e2303166 = 250;
const $36c76e3adf761bae$export$10d5a4cb19960c6c = 10;
const $36c76e3adf761bae$export$b41e7ecd9ba9baff = 10;
var $36c76e3adf761bae$export$cf834bb06694a4e = /*#__PURE__*/ function(ConfluenceFilters) {
    ConfluenceFilters["Space"] = "spaces";
    ConfluenceFilters["People"] = "contributors";
    ConfluenceFilters["Date"] = "lastModified";
    return ConfluenceFilters;
}({});
var $36c76e3adf761bae$export$bb0f876d33576f3f = /*#__PURE__*/ function(ConfluenceScope) {
    ConfluenceScope["Item"] = "confluence.page,blogpost,attachment";
    ConfluenceScope["Space"] = "confluence.space";
    ConfluenceScope["People"] = "urs.user-confluence";
    ConfluenceScope["Content"] = "confluence.page,blogpost,attachment,whiteboard";
    return ConfluenceScope;
}({});





const $533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL = '/wiki/search';
const $533b56e765b3323a$var$removeDuplicateWikiInUrl = (siteUrl)=>{
    return siteUrl.replace(/\/wiki(\/)?$/, '');
};
function $533b56e765b3323a$export$e189237de9f436c5(siteUrl, filters) {
    const trimmedSiteUrl = $533b56e765b3323a$var$removeDuplicateWikiInUrl(siteUrl);
    const spaceFilterString = filters.spaceFilters.length > 0 ? `&spaces=${encodeURIComponent(filters.spaceFilters.join(','))}` : '';
    const peopleFilterString = filters.peopleFilters.length > 0 ? `&contributors=${encodeURIComponent(filters.peopleFilters.join(','))}` : '';
    const dateFilterString = filters.dateFilter.length > 0 ? `&lastModified=${filters.dateFilter[0]}` : '';
    return (0, $42omo.useCallback)((query, siteUrl)=>{
        const url = siteUrl ? $533b56e765b3323a$var$removeDuplicateWikiInUrl(siteUrl) : trimmedSiteUrl;
        const trimmedQuery = query.trim();
        if (!trimmedQuery) return `${url}${$533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL}`;
        return `${url}${$533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL}?text=${encodeURIComponent(trimmedQuery)}${spaceFilterString}${peopleFilterString}${dateFilterString}`;
    }, [
        trimmedSiteUrl,
        spaceFilterString,
        peopleFilterString,
        dateFilterString
    ]);
}
const $533b56e765b3323a$export$579a505f09fc5afa = (lastModified)=>{
    const date = new Date(lastModified);
    return date.toLocaleString();
};


































const $19ff8c138fce7df4$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
const $19ff8c138fce7df4$var$RECENT_PAGES_PATH = 'rest/recentlyviewed/1.0/recent';
const $19ff8c138fce7df4$var$RECENT_SPACE_PATH = 'rest/recentlyviewed/1.0/recent/spaces';
const $19ff8c138fce7df4$var$DEFAULT_COLLAB_GRAPH_URL = 'gateway/api/collaboration';
const $19ff8c138fce7df4$var$ACTIVITY_CLIENT_RETRY_MS = 250;
const $19ff8c138fce7df4$var$RECENT_PAGES_LIMIT = 200;
const $19ff8c138fce7df4$var$RECENT_SPACE_LIMIT = 10;
const $19ff8c138fce7df4$var$RECENT_PEOPLE_LIMIT = 10;
function $19ff8c138fce7df4$var$recentWorkItemToResult(recentItem) {
    const { object: object, containers: containers } = recentItem;
    return {
        resultId: object.id,
        containerName: containers[0].name,
        containerId: '',
        resultType: (0, $42a3e378fee7fe01$export$a99961038e9d5471),
        isRecentResult: true,
        name: object.name || '',
        // Failsafe. All items should have a name.
        href: object.url,
        contentType: `confluence-${object.type}`,
        lastModified: undefined,
        // not available
        analyticsType: (0, $42a3e378fee7fe01$export$18c69de2b4aa679c)
    };
}
function $19ff8c138fce7df4$var$recentPageToResult(recentPage, baseUrl) {
    return {
        resultId: String(recentPage.id),
        name: recentPage.title || '',
        // This is a failsafe, there should be a filter to drop pages with no titles
        href: `${baseUrl}${recentPage.url}`,
        containerName: recentPage.space,
        analyticsType: (0, $42a3e378fee7fe01$export$18c69de2b4aa679c),
        resultType: (0, $42a3e378fee7fe01$export$a99961038e9d5471),
        contentType: `confluence-${recentPage.contentType}`,
        iconClass: recentPage.iconClass,
        containerId: recentPage.spaceId.toString(),
        isRecentResult: true,
        lastModified: undefined,
        // not available for recent results
        spaceId: recentPage.spaceId?.toString()
    };
}
function $19ff8c138fce7df4$var$mapCollabGraphContainer(response) {
    const items = response.collaborationGraphEntities.map((item)=>({
            id: item.containerDetails?.id,
            key: item.containerDetails?.key,
            icon: item.containerDetails?.iconUrl,
            name: item.containerDetails?.name,
            url: item.containerDetails?.url
        })).filter((space)=>space.id !== undefined).map((space)=>$19ff8c138fce7df4$var$recentSpaceToResult(space, space.url));
    return {
        items: items,
        timings: response.timings
    };
}
function $19ff8c138fce7df4$var$recentSpaceToResult(recentSpace, href) {
    return {
        resultId: recentSpace.id,
        name: recentSpace.name,
        key: recentSpace.key,
        href: href,
        avatarUrl: recentSpace.icon,
        analyticsType: (0, $42a3e378fee7fe01$export$18c69de2b4aa679c),
        resultType: (0, $42a3e378fee7fe01$export$6ec00f56b27cdc1d),
        contentType: (0, $42a3e378fee7fe01$export$8ee8726ca4e2f8bd),
        id: recentSpace.id
    };
}
function $19ff8c138fce7df4$var$mapUrsPeople(response, timings, isMultiSite) {
    if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $42a3e378fee7fe01$export$775b6bb06e53a214).UserConfluence}`);
    if (response.error) throw (0, $62cd9cdd84f4378e$export$59a963eec12b52ed)(response.error);
    const items = response.results.map((item)=>({
            resultType: (0, $42a3e378fee7fe01$export$ca1a50bc869949e),
            resultId: `people-${item.id}`,
            userId: item.id,
            name: item.name,
            href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
            avatarUrl: item.avatarUrl,
            contentType: (0, $42a3e378fee7fe01$export$d0e824889e01c751),
            analyticsType: (0, $42a3e378fee7fe01$export$ebb42dafe7a39a20),
            mentionName: item.nickname || '',
            presenceMessage: ''
        }));
    return {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(items, (item)=>item.resultId),
        timings: timings
    };
}

class $19ff8c138fce7df4$var$RecentsCache {
    constructor(props){
        this.recentCacheProps = void 0;
        this.recentItemCache = void 0;
        this.recentSpaceCache = void 0;
        this.recentPeopleCache = void 0;
        this.recentItemSupplier = async ()=>{
            if (!!this.recentCacheProps.recentWorkAPIUrl) try {
                const { createActivityClient: createActivityClient } = await (parcelRequire("jkExj"));
                const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentCacheProps.recentWorkAPIUrl);
                const { viewed: viewed } = await activityClient.fetchActivities([
                    $19ff8c138fce7df4$var$ACTIVITY_CLIENT_RETRY_MS
                ], {
                    products: [
                        'confluence'
                    ]
                }, [
                    'viewed'
                ]);
                const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$19ff8c138fce7df4$var$recentWorkItemToResult(item));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: 0
                };
            } catch (e) {
                return {
                    items: [],
                    totalSize: 0,
                    timings: -1
                };
            }
            else try {
                const { result: result, durationMs: durationMs } = await (0, $9Nzn7.timed)((0, $dwp40.utils).requestService({
                    url: this.recentCacheProps.url
                }, {
                    path: $19ff8c138fce7df4$var$RECENT_PAGES_PATH,
                    queryParams: {
                        limit: $19ff8c138fce7df4$var$RECENT_PAGES_LIMIT
                    }
                }));
                const items = result.filter((page)=>!!page.title).map((recentPage)=>$19ff8c138fce7df4$var$recentPageToResult(recentPage, this.recentCacheProps.url));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: durationMs
                };
            } catch (e) {
                return {
                    items: [],
                    totalSize: 0,
                    timings: -1
                };
            }
        };
        this.recentSpaceSupplier = async ()=>{
            if (this.recentCacheProps.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0
            });
            if (this.recentCacheProps.isCollaborationGraphEnabled) return this.recentCacheProps.getCollabGraphContainers();
            else try {
                const { result: result, durationMs: durationMs } = await (0, $9Nzn7.timed)((0, $dwp40.utils).requestService({
                    url: this.recentCacheProps.url
                }, {
                    path: $19ff8c138fce7df4$var$RECENT_SPACE_PATH,
                    queryParams: {
                        limit: $19ff8c138fce7df4$var$RECENT_SPACE_LIMIT
                    }
                }));
                return {
                    items: result.map((recentSpace)=>$19ff8c138fce7df4$var$recentSpaceToResult(recentSpace, `${this.recentCacheProps.url}/spaces/${recentSpace.key}`)),
                    timings: durationMs
                };
            } catch (e) {
                return {
                    items: [],
                    timings: -1
                };
            }
        };
        this.recentPeopleSupplier = async ()=>{
            if (this.recentCacheProps.isUserAnonymous || !this.recentCacheProps.aggregatorClient) return Promise.resolve({
                items: [],
                timings: 0
            });
            return this.recentCacheProps.aggregatorClient.search({
                query: '',
                context: {
                    sessionId: '',
                    referrerId: null
                },
                scopes: [
                    (0, $36c76e3adf761bae$export$bb0f876d33576f3f).People
                ],
                modelParams: [],
                resultLimit: $19ff8c138fce7df4$var$RECENT_PEOPLE_LIMIT,
                experience: $19ff8c138fce7df4$var$NAVIGATION_V3_EXPERIENCE,
                sites: this.recentCacheProps.sites?.map((s)=>s.cloudId)
            }).then(({ response: response, requestDurationMs: requestDurationMs })=>$19ff8c138fce7df4$var$mapUrsPeople(response.retrieveScope((0, $36c76e3adf761bae$export$bb0f876d33576f3f).People), requestDurationMs, (this.recentCacheProps.sites || []).length > 0)).catch((e)=>({
                    items: [],
                    timings: -1
                }));
        };
        this.recentCacheProps = props;
        this.recentItemCache = new (0, $3NyIw.SimpleCache)(this.recentItemSupplier);
        this.recentSpaceCache = new (0, $3NyIw.SimpleCache)(this.recentSpaceSupplier);
        this.recentPeopleCache = new (0, $3NyIw.SimpleCache)(this.recentPeopleSupplier);
    }
}
const $19ff8c138fce7df4$var$getRecentsCache = (0, $2XqLN.default)((recentsCacheProps)=>new $19ff8c138fce7df4$var$RecentsCache(recentsCacheProps), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));
const $19ff8c138fce7df4$var$getCollabGraphClientWithConfig = (0, $2XqLN.default)((config)=>new (0, $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2)(config), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));
const $19ff8c138fce7df4$export$2ac7f7e39d1eda48 = (props)=>{
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const collabGraphClient = $19ff8c138fce7df4$var$getCollabGraphClientWithConfig({
        collaborationGraphUrl: props.collaborationGraphUrl || $19ff8c138fce7df4$var$DEFAULT_COLLAB_GRAPH_URL,
        cloudId: props.cloudId,
        isMultiSite: (props.sites || []).length > 1,
        sites: props.sites || [],
        collabGraphSessionId: props.collabGraphSessionId
    });
    const { isUserAnonymous: isUserAnonymous } = props;
    const getCollabGraphContainers = (0, $42omo.useCallback)(async ()=>{
        return isUserAnonymous ? Promise.resolve({
            items: [],
            timings: 0
        }) : collabGraphClient.getContainers([
            (0, $efe8e1453cb04fa5$export$e28d152a38023114)
        ]).then((response)=>$19ff8c138fce7df4$var$mapCollabGraphContainer(response)).catch((e)=>({
                items: [],
                timings: -1
            }));
    }, [
        collabGraphClient,
        isUserAnonymous
    ]);
    const recentsCache = $19ff8c138fce7df4$var$getRecentsCache({
        ...props,
        aggregatorClient: aggregatorClient,
        getCollabGraphContainers: getCollabGraphContainers
    });
    const getRecentItems = (0, $42omo.useCallback)(()=>{
        return recentsCache.recentItemCache.get().value;
    }, [
        recentsCache
    ]);
    const getRecentSpaces = (0, $42omo.useCallback)(()=>{
        return recentsCache.recentSpaceCache.get().value;
    }, [
        recentsCache
    ]);
    const getRecentPeople = (0, $42omo.useCallback)(()=>{
        return recentsCache.recentPeopleCache.get().value;
    }, [
        recentsCache
    ]);
    return {
        getRecentItems: getRecentItems,
        getRecentSpaces: getRecentSpaces,
        getRecentPeople: getRecentPeople,
        getCollabGraphContainers: getCollabGraphContainers,
        searchClient: aggregatorClient,
        collabGraphClient: collabGraphClient
    };
};



var $kzbg7 = parcelRequire("kzbg7");


var $cgH2x = parcelRequire("cgH2x");


var $169DF = parcelRequire("169DF");

















var $USdFJ = parcelRequire("USdFJ");

/**
 * Every product configuration might not choose to have the search config provider.
 * Hence this is explicitly initialised to null.
 */ const $6004f871869f2e35$var$SearchConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    jiraSites: [],
    confluenceSites: [],
    atlasWorkspaces: []
});
const $6004f871869f2e35$export$9ce36a8a6ea7b893 = (props)=>{
    const { children: children, skeleton: SkeletonComponent = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}) } = props;
    const accessibleProducts = (0, $USdFJ.useSearchConfigClient)(props);
    return accessibleProducts == null ? /*#__PURE__*/ (0, $l998X.jsx)(SkeletonComponent, {}) : /*#__PURE__*/ (0, $l998X.jsx)($6004f871869f2e35$var$SearchConfigContext.Provider, {
        value: accessibleProducts,
        children: children
    });
};
function $6004f871869f2e35$export$dca16f1ca9af3934() {
    return (0, $42omo.useContext)($6004f871869f2e35$var$SearchConfigContext);
}



const $a2ad679ee4094498$export$79b79eb7219cb5fd = ()=>{
    const response = Object.values((0, $36c76e3adf761bae$export$bb0f876d33576f3f));
    return Promise.resolve(response);
};



var $hUj82 = parcelRequire("hUj82");















parcelRequire("42omo");


var $dlbUV = parcelRequire("dlbUV");


var $d4cCP = parcelRequire("d4cCP");


var $d8Kpd = parcelRequire("d8Kpd");


var $8DZd1 = parcelRequire("8DZd1");


var $41GKb = parcelRequire("41GKb");


var $11LZV = parcelRequire("11LZV");


var $hY1Uy = parcelRequire("hY1Uy");


var $1iV2p = parcelRequire("1iV2p");


var $ayTrS = parcelRequire("ayTrS");


var $90Icb = parcelRequire("90Icb");


var $hxQwS = parcelRequire("hxQwS");


var $13WX1 = parcelRequire("13WX1");


var $fX9Sa = parcelRequire("fX9Sa");


var $gguok = parcelRequire("gguok");


var $gH8Rx = parcelRequire("gH8Rx");


var $djgQ6 = parcelRequire("djgQ6");


var $20uDq = parcelRequire("20uDq");


var $lzyQK = parcelRequire("lzyQK");


var $dfQbH = parcelRequire("dfQbH");


var $7t8Pn = parcelRequire("7t8Pn");


var $hXc8o = parcelRequire("hXc8o");


var $lkBga = parcelRequire("lkBga");


var $bueVT = parcelRequire("bueVT");


var $5yCDo = parcelRequire("5yCDo");




/**
 * The following code was derived from an implementation in confluence-frontend,
 * although it differs substantially.
 *
 * The original can be found at ./packages/confluence-rest-api/src/helpers/icons.js
 */ const $7ce590926ed55824$var$ATTACHMENT_ICON_CLASS_PREFIXES = [
    // Quick Nav prefix
    'content-type-attachment-',
    // CQL prefix
    'icon-file-'
];
const $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR = (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)));
const $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR_LARGE = (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)));
const $7ce590926ed55824$var$ATTACHMENT_FILE_EXTENSION_MATCHERS = [
    {
        regexp: /\.(gif|jpeg|jpg|png)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
    },
    {
        regexp: /\.(pdf)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    },
    {
        regexp: /\.(zip)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    }
];
const $7ce590926ed55824$var$getIconType = (iconClass, fileName, isLarge)=>{
    // Check the iconClass to make sure we're looking at an attachment
    const prefixMatches = $7ce590926ed55824$var$ATTACHMENT_ICON_CLASS_PREFIXES.find((prefix)=>{
        return iconClass.startsWith(prefix);
    });
    // if it's an attachment, look at the file extension to work out which type
    if (prefixMatches) {
        const matchingType = $7ce590926ed55824$var$ATTACHMENT_FILE_EXTENSION_MATCHERS.find((extensionMatcher)=>{
            const matches = extensionMatcher.regexp.exec(fileName);
            return !!matches && matches.length > 0;
        });
        if (matchingType) return isLarge ? matchingType.avatarLarge : matchingType.avatar;
    }
    return isLarge ? $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR_LARGE : $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR;
};
const $7ce590926ed55824$export$310004de4fa0ccba = ({ type: type, title: title, iconCssClass: iconCssClass, isCollapsed: isCollapsed })=>{
    if (type === 'page' || type === 'confluence-page') {
        const Icon = isCollapsed ? (0, $5yCDo.default) : (0, $13WX1.default);
        return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: type
        });
    } else if (type === 'blogpost' || type === 'confluence-blogpost') {
        const Icon = isCollapsed ? (0, $bueVT.default) : (0, $hxQwS.default);
        return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: type
        });
    } else if (type === 'attachment') {
        const IconComponent = $7ce590926ed55824$var$getIconType(iconCssClass || '', title, isCollapsed);
        return /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
            label: type
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
};
const $7ce590926ed55824$export$9e3ce228520dfa00 = (result, largerIcons)=>()=>{
        if (result.content) return $7ce590926ed55824$export$310004de4fa0ccba({
            type: result.content.type,
            title: result.content.type,
            iconCssClass: result.iconCssClass,
            isCollapsed: largerIcons
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    };
const $7ce590926ed55824$export$8fde8d521a2cd996 = (iconUrl, largerIcons)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: iconUrl,
        appearance: "square",
        size: largerIcons ? 'small' : 'xsmall',
        testId: "result-avatar"
    });








parcelRequire("42omo");













var $eEbYb = parcelRequire("eEbYb");


var $21MH9 = parcelRequire("21MH9");





const $7bcfa13d0f838ade$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
        const { productState: productState } = args;
        const recentTitle = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $bF0iL.messages).common_recently_viewed_section_heading
        });
        const contentTitle = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $bF0iL.messages).confluence_content_section_heading
        });
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
                return recentTitle;
            case (0, $jFPud.ProductStates).PostQueryLoading:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEbYb.LoadingSkeleton), {
                    "data-testid": 'autocorrection-loading-skeleton'
                });
                return contentTitle;
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                    fallback: contentTitle
                });
                return contentTitle;
            default:
                return contentTitle;
        }
    };
const $7bcfa13d0f838ade$export$1bdb91707b6d5bed = ({ searchResult: searchResult, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { productState: productState } = rest;
    if (productState === 'PreQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: ''
        }
    });
    if (productState === 'PostQueryLoading' || productState === 'PostQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: !!searchResult.isRecentResult ? formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading) : searchResult.additionalMeta,
            icon: !!searchResult.isRecentResult ? (0, $7ce590926ed55824$export$310004de4fa0ccba)({
                // the recent content type is stored in additionalMeta but not displayed
                type: searchResult.additionalMeta || '',
                title: searchResult.title,
                isCollapsed: rest.isCollapsed
            }) : searchResult.icon
        }
    });
    return (0, $ejGzS.defaultResultRenderer)({
        searchResult: searchResult,
        ...rest
    });
};


const $38dc479b8383985f$var$ITEM_LIMIT_SIZE = 10;
const $38dc479b8383985f$var$SPACE_LIMIT_SIZE = 3;
const $38dc479b8383985f$var$PEOPLE_LIMIT_SIZE = 3;
const $38dc479b8383985f$export$468e9a0e16eb3222 = ({ formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled, rendererOverride: rendererOverride })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const confluenceItemResultMapper = (0, $42omo.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.content.id,
                title: result.title,
                type: result.content.type,
                meta: result.container.title,
                additionalMeta: result.lastModified ? formatDate ? formatDate(result.lastModified) : (0, $533b56e765b3323a$export$579a505f09fc5afa)(result.lastModified) : '',
                url: `${result.baseUrl}${result.url}`,
                containerId: result.content?.space?.id || result.container?.id || 'UNAVAILABLE',
                iconRenderer: (0, $7ce590926ed55824$export$9e3ce228520dfa00)(result, true)
            })).slice(0, $38dc479b8383985f$var$ITEM_LIMIT_SIZE), [
        formatDate
    ]);
    const confluenceSpaceResultMapper = (0, $42omo.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.id,
                title: result.title,
                meta: '',
                url: `${result.baseUrl || ''}${result.container.displayUrl}`,
                containerId: result.id,
                icon: (0, $7ce590926ed55824$export$8fde8d521a2cd996)(`${result.baseUrl}${result.space.icon.path}`, true)
            })).slice(0, $38dc479b8383985f$var$SPACE_LIMIT_SIZE), []);
    const confluencePeopleResultMapper = (0, $42omo.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.id,
                title: result.name,
                meta: '',
                url: result.absoluteUrl?.replace('/people', '/wiki/people') || '',
                containerId: '',
                icon: (0, $7ce590926ed55824$export$8fde8d521a2cd996)(result.avatarUrl, true)
            })).slice(0, $38dc479b8383985f$var$PEOPLE_LIMIT_SIZE), []);
    const enableSpaceAndPeopleScope = (query, filters)=>{
        return !filters.find((filter)=>filter['@type'] === 'spaces' && filter['spaceKeys'].length > 0 || filter['@type'] === 'contributors' && filter['accountIds'].length > 0 || filter['@type'] === 'lastModified' && filter.from && filter.from !== (0, $88j1D.DEFAULT_OPTION));
    };
    const scopeId = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, $36c76e3adf761bae$export$bb0f876d33576f3f).Item;
    return (0, $42omo.useMemo)(()=>[
            {
                id: scopeId,
                title: formatMessage((0, $bF0iL.messages).confluence_content_section_heading),
                titleRenderer: (0, $7bcfa13d0f838ade$export$aee00814c9e3bae7)(!!autocorrectEnabled),
                resultRenderer: additionalContentTypesEnabled && !!rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, $7bcfa13d0f838ade$export$1bdb91707b6d5bed),
                scope: scopeId,
                resultMapper: confluenceItemResultMapper,
                showResultCount: true,
                resultLimit: $38dc479b8383985f$var$ITEM_LIMIT_SIZE
            },
            {
                id: (0, $36c76e3adf761bae$export$bb0f876d33576f3f).Space,
                title: formatMessage((0, $bF0iL.messages).confluence_spaces_section_heading),
                scope: (0, $36c76e3adf761bae$export$bb0f876d33576f3f).Space,
                resultMapper: confluenceSpaceResultMapper,
                isEnabled: enableSpaceAndPeopleScope
            },
            {
                id: (0, $36c76e3adf761bae$export$bb0f876d33576f3f).People,
                title: formatMessage((0, $bF0iL.messages).confluence_people_section_heading),
                scope: (0, $36c76e3adf761bae$export$bb0f876d33576f3f).People,
                resultMapper: confluencePeopleResultMapper,
                isEnabled: enableSpaceAndPeopleScope
            }
        ], [
        formatMessage,
        autocorrectEnabled,
        confluenceItemResultMapper,
        confluenceSpaceResultMapper,
        confluencePeopleResultMapper,
        scopeId,
        additionalContentTypesEnabled,
        rendererOverride
    ]);
};

























const $522eb9748c713499$export$6d8886e8d5cdbeec = (id, type)=>{
    switch(type){
        case 'page':
            return id.split(':page/')[1];
        case 'blogpost':
            return id.split(':blogpost/')[1];
        case 'attachment':
            return id.split(':attachment/')[1];
        case 'space':
            return id.split(':space/')[1];
        case 'whiteboard':
            return id.split(':whiteboard/')[1];
        case 'embed':
            // embed ari url contains activation id so we split it differently here
            const embedAri = id.split('/');
            return embedAri[embedAri.length - 1];
        case 'database':
            // Databases ari url contains activation id so we split it differently here
            const databaseAri = id.split('/');
            return databaseAri[databaseAri.length - 1];
        default:
            return id;
    }
};


const $4d73e9aedf98202d$var$RECENT_ITEMS_SIZE_LIMIT = 10;
const $4d73e9aedf98202d$var$RECENT_SPACES_SIZE_LIMIT = 3;
const $4d73e9aedf98202d$var$ITEM_LIMIT_SIZE = 10;
const $4d73e9aedf98202d$var$SPACE_LIMIT_SIZE = 3;
const $4d73e9aedf98202d$var$PEOPLE_LIMIT_SIZE = 3;

const $4d73e9aedf98202d$export$c9757f311cedcc1d = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, spaceFilterStore: spaceFilterStore, peopleFilterStore: peopleFilterStore, isExpanded: isExpanded, isUserAnonymous: isUserAnonymous, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, rendererOverride: rendererOverride, additionalContentTypesEnabled: additionalContentTypesEnabled })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const warmUpCache = isExpanded && query !== '' && getActiveProduct()?.id === (0, $36c76e3adf761bae$export$661dd16d63ed8290);
    const [hasFetchedSpaces, setHasFetchedSpaces] = (0, $42omo.useState)(spaceFilterStore?.availableFilters?.length > 0 || false);
    const intl = (0, $8C5kA.default)();
    const hasFetchedUsersRef = (0, $42omo.useRef)(peopleFilterStore?.availableFilters?.length > 0 || false);
    const { isCollaborationGraphEnabled: isCollaborationGraphEnabled } = recentClientConfig;
    const { getRecentItems: getRecentItems, getRecentSpaces: getRecentSpaces, getRecentPeople: getRecentPeople, getCollabGraphContainers: getCollabGraphContainers } = (0, $19ff8c138fce7df4$export$2ac7f7e39d1eda48)(recentClientConfig);
    // Set the default space filters to come from the collab graph if they are not enabled for recents
    (0, $42omo.useEffect)(()=>{
        if (warmUpCache && !isCollaborationGraphEnabled && !hasFetchedSpaces) getCollabGraphContainers().then((spaces)=>{
            if (spaces.items.length > 0) spaceFilterStore.setDefaultFilters(spaces.items.map((item, index)=>({
                    id: item.id,
                    spaceKey: item.key,
                    avatarUrl: item.avatarUrl,
                    label: item.name,
                    filterSource: (0, $169DF.FilterOptionSource).RECENT,
                    isChecked: false,
                    isVisible: index < 3
                })));
            setHasFetchedSpaces(true);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isCollaborationGraphEnabled,
        getCollabGraphContainers,
        isExpanded,
        warmUpCache
    ]);
    (0, $42omo.useEffect)(()=>{
        if (warmUpCache && !hasFetchedUsersRef.current) {
            getRecentPeople().then((recentPeople)=>{
                peopleFilterStore.setDefaultFilters(recentPeople.items.map((item, index)=>({
                        id: item.userId,
                        avatarUrl: item.avatarUrl,
                        label: item.name,
                        filterSource: (0, $169DF.FilterOptionSource).RECENT,
                        isChecked: false,
                        isVisible: index < 3
                    })));
            });
            hasFetchedUsersRef.current = true;
        }
    }, [
        warmUpCache,
        peopleFilterStore,
        getRecentPeople
    ]);
    const contentResultRenderer = additionalContentTypesEnabled && rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, $7bcfa13d0f838ade$export$1bdb91707b6d5bed);
    const scope = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, $36c76e3adf761bae$export$bb0f876d33576f3f).Item;
    const preQueryItemSupplier = (0, $42omo.useMemo)(()=>()=>Promise.all([
                getRecentItems(),
                getRecentSpaces()
            ]).then((results)=>{
                const recentItems = results[0].items;
                const recentSpaces = results[1].items;
                if (!hasFetchedSpaces && isCollaborationGraphEnabled) {
                    spaceFilterStore.setDefaultFilters(recentSpaces.map((item, index)=>({
                            id: item.id,
                            spaceKey: item.key,
                            avatarUrl: item.avatarUrl,
                            label: item.name,
                            filterSource: (0, $169DF.FilterOptionSource).RECENT,
                            isChecked: false,
                            isVisible: index < 3
                        })));
                    setHasFetchedSpaces(true);
                }
                return {
                    size: results.reduce((sum, { items: items })=>{
                        return sum + items.length;
                    }, 0),
                    sections: [
                        {
                            id: 'recent-confluence-items',
                            titleRenderer: (0, $7bcfa13d0f838ade$export$aee00814c9e3bae7)(!!autocorrectEnabled),
                            title: intl.formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading),
                            resultRenderer: contentResultRenderer,
                            scope: scope,
                            searchResults: recentItems.map((result)=>({
                                    id: result.resultId,
                                    title: result.name,
                                    meta: result.containerName,
                                    additionalMeta: result.contentType,
                                    url: result.href,
                                    containerId: result.spaceId,
                                    icon: (0, $7ce590926ed55824$export$310004de4fa0ccba)({
                                        type: result.contentType,
                                        title: result.name,
                                        isCollapsed: false
                                    }),
                                    isRecentResult: true
                                })),
                            resultLimit: $4d73e9aedf98202d$var$RECENT_ITEMS_SIZE_LIMIT
                        },
                        {
                            id: 'recent-confluence-spaces',
                            title: intl.formatMessage((0, $bF0iL.messages).common_recently_spaces_section_heading),
                            searchResults: recentSpaces.map((result)=>({
                                    id: result.resultId,
                                    title: result.name,
                                    meta: '',
                                    url: result.href,
                                    containerId: '',
                                    iconUrl: result.avatarUrl,
                                    isRecentResult: true
                                })),
                            resultLimit: $4d73e9aedf98202d$var$RECENT_SPACES_SIZE_LIMIT
                        }
                    ]
                };
            }), [
        getRecentItems,
        getRecentSpaces,
        hasFetchedSpaces,
        isCollaborationGraphEnabled,
        autocorrectEnabled,
        intl,
        spaceFilterStore,
        contentResultRenderer,
        scope
    ]);
    const postQueryItemSupplier = (0, $42omo.useMemo)(()=>!searchClientConfig?.graphQLEnabled ? undefined : async (args)=>{
            const { hasCheckedFilters: hasCheckedFilters, getUserSearchResults: getUserSearchResults } = await (parcelRequire("cX5Oz"));
            const pageBlogAttachmentGraphQLResultMapper = ({ node: item })=>{
                return {
                    id: (0, $522eb9748c713499$export$6d8886e8d5cdbeec)(item?.id || '', item?.type || ''),
                    title: item?.title || '',
                    url: item?.url || '',
                    meta: item?.space?.name || '',
                    additionalMeta: item?.lastModified ? formatDate ? formatDate(item?.lastModified) : (0, $533b56e765b3323a$export$579a505f09fc5afa)(item?.lastModified) : '',
                    containerId: (0, $522eb9748c713499$export$6d8886e8d5cdbeec)(item?.space?.id || 'UNAVAILABLE', 'space'),
                    type: item?.type || '',
                    icon: (0, $7ce590926ed55824$export$310004de4fa0ccba)({
                        type: item?.type || '',
                        title: item?.title || '',
                        iconCssClass: item?.iconCssClass || '',
                        isCollapsed: true
                    })
                };
            };
            const spaceGraphQLResultMapper = ({ node: item })=>{
                return {
                    id: (0, $522eb9748c713499$export$6d8886e8d5cdbeec)(item?.id || '', item?.type || ''),
                    title: item?.title || '',
                    meta: '',
                    url: item?.url || '',
                    type: item?.type || '',
                    containerId: (0, $522eb9748c713499$export$6d8886e8d5cdbeec)(item?.id || '', item?.type || ''),
                    icon: (0, $7ce590926ed55824$export$8fde8d521a2cd996)(`/wiki${item?.iconPath || ''}`, true)
                };
            };
            const peopleResultMapper = (user)=>({
                    title: user.name,
                    id: user.id,
                    meta: '',
                    url: `${window.location.origin}/wiki/people/${user.id}`,
                    icon: (0, $7ce590926ed55824$export$8fde8d521a2cd996)(`${user.avatarUrl}`, true)
                });
            const fetchOnlyPageBlogAttachments = hasCheckedFilters(args.filters);
            const graphQLResultsPromise = searchClientConfig?.graphQLPromise?.(args);
            const peopleResultsPromise = fetchOnlyPageBlogAttachments || isUserAnonymous ? Promise.resolve([]) : getUserSearchResults({
                query: args.query,
                cloudId: searchClientConfig?.cloudId || '',
                principalId: searchClientConfig?.userId,
                intl: intl
            }).catch((e)=>[]);
            return Promise.all([
                graphQLResultsPromise,
                peopleResultsPromise
            ]).then((results)=>{
                const pageBlogAttachmentResults = results[0]?.search.pageBlogAttachments.edges.map(pageBlogAttachmentGraphQLResultMapper) || [];
                const pageBlogAttachmentsCount = results[0]?.search.pageBlogAttachments.totalCount;
                const spaceResults = results[0]?.search.spaces?.edges.map(spaceGraphQLResultMapper) || [];
                const peopleResults = results[1].map(peopleResultMapper) || [];
                return {
                    sections: [
                        {
                            id: scope,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_content_section_heading),
                            searchResults: pageBlogAttachmentResults,
                            titleRenderer: (0, $7bcfa13d0f838ade$export$aee00814c9e3bae7)(!!autocorrectEnabled),
                            resultRenderer: contentResultRenderer,
                            showResultCount: true,
                            size: pageBlogAttachmentsCount || undefined,
                            resultLimit: $4d73e9aedf98202d$var$ITEM_LIMIT_SIZE
                        },
                        {
                            id: (0, $36c76e3adf761bae$export$bb0f876d33576f3f).Space,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_spaces_section_heading),
                            searchResults: spaceResults,
                            resultLimit: $4d73e9aedf98202d$var$SPACE_LIMIT_SIZE
                        },
                        {
                            id: (0, $36c76e3adf761bae$export$bb0f876d33576f3f).People,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_people_section_heading),
                            searchResults: peopleResults,
                            resultLimit: $4d73e9aedf98202d$var$PEOPLE_LIMIT_SIZE
                        }
                    ],
                    size: pageBlogAttachmentResults.length + spaceResults.length + peopleResults.length
                };
            });
        }, [
        autocorrectEnabled,
        formatDate,
        intl,
        searchClientConfig,
        contentResultRenderer,
        isUserAnonymous,
        scope
    ]);
    return {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    };
};


















const $f80ef50bfa9d23a2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    confluence_typing_state_header_text: {
        id: "product_search_dialog.confluence.typing_state_header_text",
        defaultMessage: "Search for content in Confluence"
    },
    confluence_date_filter_title: {
        id: "product_search_dialog.confluence.date_filter_title",
        defaultMessage: "Last updated"
    },
    confluence_date_filter_today_label: {
        id: "product_search_dialog.confluence.date_filter_today",
        defaultMessage: "Today"
    },
    confluence_date_filter_yesterday_label: {
        id: "product_search_dialog.confluence.date_filter_yesterday",
        defaultMessage: "Yesterday"
    },
    confluence_date_filter_week_label: {
        id: "product_search_dialog.confluence.date_filters_week",
        defaultMessage: "Past 7 days"
    },
    confluence_date_filter_month_label: {
        id: "product_search_dialog.confluence.date_filters_month",
        defaultMessage: "Past 30 days"
    },
    confluence_date_filter_year_label: {
        id: "product_search_dialog.confluence.date_filters_year",
        defaultMessage: "Past year"
    },
    confluence_date_filter_any_label: {
        id: "product_search_dialog.confluence.date_filters_any",
        defaultMessage: "Any time"
    }
});





const $d82bcb6e5a831fde$var$getUTCDateRange = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    const startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const endOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999);
    const from = new Date(startOfDay.getTime() - fromOffset * 86400000);
    const to = new Date(endOfDay.getTime() - toOffset * 86400000);
    return {
        from: from.toISOString().split('Z')[0],
        to: to.toISOString().split('Z')[0]
    };
};
const $d82bcb6e5a831fde$export$a31429ad2d37d59f = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const dateFilterOptionsAndValues = (0, $42omo.useMemo)(()=>{
        return {
            [(0, $88j1D.LastModifiedValues).DEFAULT]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).DEFAULT,
                    label: formatMessage((0, $f80ef50bfa9d23a2$export$defe85febe8b728c).confluence_date_filter_any_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: true,
                    isVisible: true
                },
                dateRange: {
                    from: '',
                    to: ''
                }
            },
            [(0, $88j1D.LastModifiedValues).TODAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).TODAY,
                    label: formatMessage((0, $f80ef50bfa9d23a2$export$defe85febe8b728c).confluence_date_filter_today_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(0, 0)
            },
            [(0, $88j1D.LastModifiedValues).YESTERDAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).YESTERDAY,
                    label: formatMessage((0, $f80ef50bfa9d23a2$export$defe85febe8b728c).confluence_date_filter_yesterday_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(1, 1)
            },
            [(0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS,
                    label: formatMessage((0, $f80ef50bfa9d23a2$export$defe85febe8b728c).confluence_date_filter_week_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(7, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS,
                    label: formatMessage((0, $f80ef50bfa9d23a2$export$defe85febe8b728c).confluence_date_filter_month_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(30, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_YEAR]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_YEAR,
                    label: formatMessage((0, $f80ef50bfa9d23a2$export$defe85febe8b728c).confluence_date_filter_year_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(365, 0)
            }
        };
    }, [
        formatMessage
    ]);
    const dateFilterOptions = (0, $42omo.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
        dateFilterOptionsAndValues
    ]);
    const dateFilterStore = (0, $kzbg7.useFilterStore)(dateFilterOptions, (0, $36c76e3adf761bae$export$661dd16d63ed8290), (0, $36c76e3adf761bae$export$cf834bb06694a4e).Date);
    const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, $88j1D.DEFAULT_OPTION))?.id;
    const getLastModifiedValue = (0, $42omo.useCallback)(()=>{
        return appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? {
            '@type': (0, $36c76e3adf761bae$export$cf834bb06694a4e).Date,
            from: dateFilterOptionsAndValues[appliedDateFilter].dateRange.from,
            to: dateFilterOptionsAndValues[appliedDateFilter].dateRange.to
        } : null;
    }, [
        appliedDateFilter,
        dateFilterOptionsAndValues
    ]);
    const confluenceTabDateFilter = (0, $42omo.useMemo)(()=>{
        return [
            {
                ['@type']: (0, $36c76e3adf761bae$export$cf834bb06694a4e).Date,
                uiVariant: (0, $88j1D.FilterUIVariant).STATIC_SELECT,
                fieldName: 'from',
                store: dateFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, $f80ef50bfa9d23a2$export$defe85febe8b728c).confluence_date_filter_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: ()=>getLastModifiedValue()
            }
        ];
    }, [
        dateFilterStore,
        formatMessage,
        getLastModifiedValue
    ]);
    return {
        appliedDateFilter: appliedDateFilter,
        confluenceTabDateFilter: confluenceTabDateFilter
    };
};



var $gF7Az = parcelRequire("gF7Az");








var $bK7ak = parcelRequire("bK7ak");




parcelRequire("42omo");








const $50734d056dfcdf62$var$ReturnIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.ReturnIconWithModifier), {});
const $50734d056dfcdf62$export$d7ad215466e34991 = ({ orgId: orgId, cloudId: cloudId, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                    ...props,
                    returnKeyIconComponent: $50734d056dfcdf62$var$ReturnIcon
                })
            }),
            orgId && cloudId && /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $254bef028b438f80$export$829d02f6cd9ab0ce), {
                    orgId: orgId,
                    cloudId: cloudId,
                    showModifierIcon: true
                })
            })
        ]
    });
};













const $1f7f0d09c2b7d826$var$InteractiveSearchAIOnboardingBanner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("btL3z")).then(({ InteractiveSearchAIOnboardingBanner: InteractiveSearchAIOnboardingBanner })=>({
            default: InteractiveSearchAIOnboardingBanner
        })));
const $1f7f0d09c2b7d826$export$9afff4557e36fda3 = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, aiSearchConfig: aiSearchConfig, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled = false, rendererOverride: rendererOverride, aiAdminNotificationHeader: aiAdminNotificationHeader, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { setQuery: setQuery } = (0, $2ZIpG.useQuery)();
    const { toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { confluenceSites: confluenceSites } = (0, $6004f871869f2e35$export$dca16f1ca9af3934)();
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    const { isUserAnonymous: isUserAnonymous } = recentClientConfig;
    const { searchClient: searchClient } = (0, $19ff8c138fce7df4$export$2ac7f7e39d1eda48)(recentClientConfig);
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const appendAnalyticsQueryParams = (0, $bK7ak.useQueryParams)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(rest.workspaces || [], (0, $36c76e3adf761bae$export$661dd16d63ed8290));
    const { confluenceTabDateFilter: confluenceTabDateFilter, appliedDateFilter: appliedDateFilter } = (0, $d82bcb6e5a831fde$export$a31429ad2d37d59f)();
    const spaceFilterStore = (0, $kzbg7.useFilterStore)([], (0, $36c76e3adf761bae$export$661dd16d63ed8290), (0, $36c76e3adf761bae$export$cf834bb06694a4e).Space);
    const peopleFilterStore = (0, $kzbg7.useFilterStore)([], (0, $36c76e3adf761bae$export$661dd16d63ed8290), (0, $36c76e3adf761bae$export$cf834bb06694a4e).People);
    const { preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier } = (0, $4d73e9aedf98202d$export$c9757f311cedcc1d)({
        recentClientConfig: recentClientConfig,
        searchClientConfig: searchClientConfig,
        autocorrectEnabled: autocorrectEnabled,
        spaceFilterStore: spaceFilterStore,
        peopleFilterStore: peopleFilterStore,
        isExpanded: isExpanded,
        isUserAnonymous: isUserAnonymous,
        formatDate: formatDate,
        rendererOverride: rendererOverride,
        additionalContentTypesEnabled: additionalContentTypesEnabled
    });
    const sections = (0, $38dc479b8383985f$export$468e9a0e16eb3222)({
        formatDate: formatDate,
        autocorrectEnabled: autocorrectEnabled,
        additionalContentTypesEnabled: additionalContentTypesEnabled,
        rendererOverride: rendererOverride
    });
    const itemSuppliers = (0, $029554683ea761ec$export$967ff0f6c3886589)((0, $36c76e3adf761bae$export$661dd16d63ed8290), sections, {
        preQueryItemSupplier: rest.preQueryItemSupplier || preQueryItemSupplier,
        postQueryItemSupplier: rest.postQueryItemSupplier || postQueryItemSupplier
    });
    const confluenceAdvancedSearchUrlFactory = (0, $533b56e765b3323a$export$e189237de9f436c5)(recentClientConfig.url, {
        spaceFilters: spaceFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.spaceKey || ''),
        peopleFilters: peopleFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.id),
        dateFilter: !!appliedDateFilter ? [
            appliedDateFilter
        ] : []
    });
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $42omo.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $254bef028b438f80$export$306c16563e2015b8)(orgId, cloudId, query, primaryProduct?.id);
        return confluenceAdvancedSearchUrlFactory(query, baseUrl);
    }, [
        confluenceAdvancedSearchUrlFactory,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    const recentSectionTitleGenerator = (0, $42omo.useCallback)((section)=>{
        return section.title;
    }, []);
    const loadSpaceFilters = (0, $42omo.useCallback)((query)=>{
        return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                (0, $36c76e3adf761bae$export$bb0f876d33576f3f).Space
            ],
            modelParams: [],
            resultLimit: (0, $36c76e3adf761bae$export$10d5a4cb19960c6c),
            experience: (0, $36c76e3adf761bae$export$4a204ebf24901f2e),
            sites: []
        }).then(({ response: response })=>{
            const results = response.retrieveScope((0, $36c76e3adf761bae$export$bb0f876d33576f3f).Space)?.results;
            return results?.map((result)=>({
                    value: {
                        id: result.id,
                        spaceKey: result.space?.key || '',
                        avatarUrl: `${result.baseUrl}${result.space.icon.path}`,
                        label: result.title,
                        filterSource: (0, $169DF.FilterOptionSource).SEARCH,
                        isChecked: false,
                        isVisible: true
                    },
                    label: /*#__PURE__*/ (0, $l998X.jsx)((0, $hUj82.FilterOptionItem), {
                        label: result.title,
                        iconProps: {
                            src: `${result.baseUrl}${result.space.icon.path}`,
                            appearance: 'square'
                        }
                    })
                })) || [];
        });
    }, [
        searchClient,
        isUserAnonymous
    ]);
    const loadPeopleFilters = (0, $42omo.useCallback)((query)=>{
        return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                (0, $36c76e3adf761bae$export$bb0f876d33576f3f).People
            ],
            modelParams: [],
            resultLimit: (0, $36c76e3adf761bae$export$b41e7ecd9ba9baff),
            experience: (0, $36c76e3adf761bae$export$4a204ebf24901f2e),
            sites: []
        }).then(({ response: response })=>{
            const results = response.retrieveScope((0, $36c76e3adf761bae$export$bb0f876d33576f3f).People)?.results;
            return results?.map((result)=>({
                    value: {
                        id: result.id,
                        avatarUrl: result.avatarUrl,
                        label: result.name,
                        filterSource: (0, $169DF.FilterOptionSource).SEARCH,
                        isChecked: false,
                        isVisible: true
                    },
                    label: /*#__PURE__*/ (0, $l998X.jsx)((0, $hUj82.FilterOptionItem), {
                        label: result.name,
                        iconProps: {
                            src: result.avatarUrl
                        }
                    })
                })) || [];
        });
    }, [
        searchClient,
        isUserAnonymous
    ]);
    const confluenceTabGenericFilters = (0, $42omo.useMemo)(()=>{
        return [
            {
                ['@type']: (0, $36c76e3adf761bae$export$cf834bb06694a4e).Space,
                fieldName: 'spaceKeys',
                store: spaceFilterStore,
                loadFilterOptions: loadSpaceFilters,
                sectionLabel: formatMessage((0, $bF0iL.messages).space_filters_title),
                findMoreLabel: formatMessage((0, $bF0iL.messages).space_filters_find_more)
            },
            {
                ['@type']: (0, $36c76e3adf761bae$export$cf834bb06694a4e).People,
                fieldName: 'accountIds',
                store: peopleFilterStore,
                loadFilterOptions: loadPeopleFilters,
                sectionLabel: formatMessage((0, $bF0iL.messages).contributor_filters_title),
                findMoreLabel: formatMessage((0, $bF0iL.messages).contributor_filters_find_more),
                filterConfig: {
                    filterOptionIconShape: 'circle'
                }
            }
        ];
    }, [
        formatMessage,
        loadPeopleFilters,
        loadSpaceFilters,
        peopleFilterStore,
        spaceFilterStore
    ]);
    const filtersToDefine = (0, $42omo.useMemo)(()=>{
        return [
            ...confluenceTabDateFilter,
            ...siteFilterDefinition,
            ...confluenceTabGenericFilters
        ];
    }, [
        confluenceTabGenericFilters,
        confluenceTabDateFilter,
        siteFilterDefinition
    ]);
    const onPrequeryBannerRender = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onPrequeryBannerShown)());
    }, [
        fireAnalyticsEvent
    ]);
    const onPromptSuggestionClick = (0, $42omo.useCallback)((prompt, promptId)=>{
        fireAnalyticsEvent((0, $5dFS9.onSuggestedPromptClick)(promptId));
        setQuery(prompt);
        toggleShowSearchAIDialog(true);
    }, [
        fireAnalyticsEvent,
        setQuery,
        toggleShowSearchAIDialog
    ]);
    const dismissOnboardingBanner = (0, $42omo.useCallback)(()=>{
        if (aiSearchConfig?.dismissPrequeryBanner) {
            fireAnalyticsEvent((0, $5dFS9.onPrequeryBannerDismiss)());
            aiSearchConfig.dismissPrequeryBanner();
        }
    }, [
        aiSearchConfig,
        fireAnalyticsEvent
    ]);
    const initializeFilters = (0, $42omo.useCallback)(()=>{
        defineFilters((0, $36c76e3adf761bae$export$661dd16d63ed8290), filtersToDefine);
    }, [
        defineFilters,
        filtersToDefine
    ]);
    initializeFilters();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $36c76e3adf761bae$export$661dd16d63ed8290),
        expandedStateInputPlaceholder: !!aiSearchConfig ? formatMessage((0, $bF0iL.messages).confluence_search_input_expanded_placeholder_ai) : formatMessage((0, $bF0iL.messages).confluence_search_input_expanded_placeholder),
        title: formatMessage((0, $bF0iL.messages).confluence_tab_label),
        autocorrectEnabled: autocorrectEnabled,
        sections: sections,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        preQuerySectionTitleGenerator: recentSectionTitleGenerator,
        showViewAllFiltersLink: true,
        ...rest,
        ...itemSuppliers,
        aiSearchConfig: aiSearchConfig,
        permissionSupplier: confluenceSites.length > 0 ? (0, $a2ad679ee4094498$export$79b79eb7219cb5fd) : rest.permissionSupplier,
        appendQueryParams: appendAnalyticsQueryParams,
        children: ({ productState: productState, ...props })=>{
            const Footer = showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $50734d056dfcdf62$export$d7ad215466e34991), {
                orgId: orgId,
                cloudId: cloudId,
                ...props
            });
            if (productState === (0, $jFPud.ProductStates).PreQuerySuccess) {
                if (!!aiAdminNotificationHeader) return {
                    Header: aiAdminNotificationHeader,
                    Footer: Footer
                };
                if (!!aiSearchConfig && aiSearchConfig.prequeryBannerEnabled) return {
                    Header: ()=>/*#__PURE__*/ (0, $l998X.jsx)($1f7f0d09c2b7d826$var$InteractiveSearchAIOnboardingBanner, {
                            onPromptSuggestionClick: onPromptSuggestionClick,
                            onXButtonClick: dismissOnboardingBanner,
                            onBannerShown: onPrequeryBannerRender
                        }),
                    Footer: Footer
                };
            }
            return {
                Footer: Footer
            };
        }
    });
};

































var $4qT1X = parcelRequire("4qT1X");




parcelRequire("42omo");






var $a2dru = parcelRequire("a2dru");




const $e5e658f2850ebd6c$var$SECONDS_IN_MIN = 60;
const $e5e658f2850ebd6c$var$SECONDS_IN_HR = $e5e658f2850ebd6c$var$SECONDS_IN_MIN * 60;
const $e5e658f2850ebd6c$var$SECONDS_IN_DAY = $e5e658f2850ebd6c$var$SECONDS_IN_HR * 24;
const $e5e658f2850ebd6c$export$be5e766167e613a9 = {
    commented: (0, $bF0iL.commentedEventTypeMessages),
    created: (0, $bF0iL.createdEventTypeMessages),
    edited: (0, $bF0iL.editedEventTypeMessages),
    published: (0, $bF0iL.publishedEventTypeMessages),
    updated: (0, $bF0iL.updatedEventTypeMessages),
    viewed: (0, $bF0iL.viewedEventTypeMessages)
};
const $e5e658f2850ebd6c$var$WithUpdatedLabel = (formattedDate)=>{
    const i18nMessage = (0, $bF0iL.messages).common_updated_date_formatter;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...i18nMessage,
        values: {
            date: formattedDate
        }
    });
};
const $e5e658f2850ebd6c$var$recentEventLabel = (eventType)=>{
    const i18nMessage = eventType ? $e5e658f2850ebd6c$export$be5e766167e613a9[eventType] || (0, $bF0iL.defaultEventTypeMessages) : (0, $bF0iL.defaultEventTypeMessages);
    return (formattedDate)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...i18nMessage.relative,
            values: {
                date: formattedDate
            }
        });
};
const $e5e658f2850ebd6c$var$absoluteRecentEventLabel = (eventType)=>{
    const i18nMessage = eventType ? $e5e658f2850ebd6c$export$be5e766167e613a9[eventType] || (0, $bF0iL.defaultEventTypeMessages) : (0, $bF0iL.defaultEventTypeMessages);
    return (formattedDate)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...i18nMessage.absolute,
            values: {
                date: formattedDate
            }
        });
};
function $e5e658f2850ebd6c$export$406508d2ca449bd(lastModified, isRecentActivity, eventType) {
    const secondsSinceUpdate = Math.floor((Date.now() - new Date(lastModified).getTime()) / 1000);
    const totalDays = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_DAY);
    const totalHours = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_HR);
    const totalMinutes = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_MIN);
    if (secondsSinceUpdate > 1 && secondsSinceUpdate < 60) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
        value: -secondsSinceUpdate,
        style: "narrow",
        unit: "second",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalMinutes >= 1 && totalMinutes < 60) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
        value: -totalMinutes,
        style: "narrow",
        unit: "minute",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalHours >= 1 && totalHours < 24) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
        value: -totalHours,
        style: "narrow",
        unit: "hour",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalDays >= 1 && totalDays < 8) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
        value: -totalDays,
        style: "narrow",
        unit: "day",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
        year: "numeric",
        month: "short",
        day: "2-digit",
        value: lastModified,
        children: isRecentActivity ? $e5e658f2850ebd6c$var$absoluteRecentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
}


const $063073959e52f0d8$export$4029d9db08b61597 = 'JiraSearchDialogQuery';
const $063073959e52f0d8$export$f85f9ec207360460 = `
query ${$063073959e52f0d8$export$4029d9db08b61597}(
	$query: String!
	$cloudIdARI: [String!]!
	$limit: Int!
	$entities: [String!]!
	$queryVersion: Int
	$searchSessionId: String
	$sessionId: String
	$commonFilters: SearchCommonFilter
	$jiraFilters: SearchJiraFilter
	$sort: [SearchSortInput]
	$sourceProduct: String
	$experimentId: String
	$shadowExperimentId: String
	$experimentLayers: [SearchExperimentLayer]
	$after: String
	$disableQueryReplacement: Boolean
	$experience: String!
	$enableHighlighting: Boolean
) {
	search {
		results: search(
			experience: $experience
			enableHighlighting: $enableHighlighting
			query: $query
			first: $limit
			after: $after
			sort: $sort
			disableQueryReplacement: $disableQueryReplacement
			filters: {
				entities: $entities
				locations: $cloudIdARI
				commonFilters: $commonFilters
				jiraFilters: $jiraFilters
			}
			analytics: {
				queryVersion: $queryVersion
				searchSessionId: $searchSessionId
				sessionId: $sessionId
				sourceProduct: $sourceProduct
			}
			experimentContext: {
				experimentId: $experimentId
				shadowExperimentId: $shadowExperimentId
				experimentLayers: $experimentLayers
			}
		) {
			edges {
				node {
					... on SearchResultJiraIssue {
						id
						title
						description
						type
						url
						useHydratedFields
						lastModifiedDate
						issue {
						  webUrl
							issueTypeAvatarUrl
							key
							status {
								statusCategory {
									id
									statusCategoryId
									key
									name
									colorName
								}
							}
							projectField {
								project {
									name
									id
								}
							}
							issueTypeField {
								issueType {
									issueTypeId
									name
								}
							}
						}
					}
					... on SearchResultJiraDashboard {
						id
						description
						title
						type
						url
					}
					... on SearchResultJiraProject {
						id
						iconUrl
						description
						title
						type
						url
					}
					... on SearchResultJiraBoard {
						id
						iconUrl
						title
						type
						url
					}
					... on SearchResultJiraFilter {
						id
						iconUrl
						title
						type
						url
					}
					... on SearchResultJiraPlan {
						id
						iconUrl
						title
						type
						url
					}
				}
			}
			queryInfo {
				originalQuery
				replacementQuery
				suggestedQuery
				originalQueryType
				confidenceScore
				shouldTriggerAutocorrectionExperience
			}
			abTest {
				abTestId
				controlId
				experimentId
			}
			totalCount
			totalCounts {
				product
				count
			}
			pageInfo {
				endCursor
			}
		}
	}
}
`;



var $hm6w9 = parcelRequire("hm6w9");











const $94617b071a9d59a3$var$USER_ARI_PREFIX = 'ari:cloud:identity::user/';
const $94617b071a9d59a3$var$HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $94617b071a9d59a3$var$QUICK_SEARCH_EXPERIENCE = 'quick-search';
const $94617b071a9d59a3$var$jiraSearchDialogQuery = async ({ variables: variables, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        graphQuery: (0, $063073959e52f0d8$export$f85f9ec207360460),
        operationName: (0, $063073959e52f0d8$export$4029d9db08b61597),
        headers: headers
    });
};
const $94617b071a9d59a3$var$mapJiraSearchResults = (response)=>{
    if (!response?.search?.results?.edges) return [];
    return response.search.results.edges.map((edge)=>{
        const node = edge.node;
        const itemId = node.id?.split('/').pop() || node.id;
        if (node.issue) return {
            id: itemId,
            url: node.issue?.webUrl || node.url,
            title: node.issue?.key + ' ' + node.title,
            description: node.description || '',
            type: node.type,
            icon: node.issue?.issueTypeAvatarUrl || '',
            meta: node.issue?.projectField?.project?.name || '',
            additionalMeta: node.lastModifiedDate ? (0, $e5e658f2850ebd6c$export$406508d2ca449bd)(node.lastModifiedDate) : undefined,
            issueKey: node.issue?.key,
            projectName: node.issue?.projectField?.project?.name,
            projectId: node.issue?.projectField?.project?.id,
            issueType: node.issue?.issueTypeField?.issueType?.name,
            issueTypeId: node.issue?.issueTypeField?.issueType?.issueTypeId,
            status: node.issue?.status?.statusCategory?.name,
            statusColor: node.issue?.status?.statusCategory?.colorName,
            lastModifiedDate: node.lastModifiedDate,
            useHydratedFields: node.useHydratedFields,
            iconUrl: node.issue?.issueTypeAvatarUrl
        };
        return {
            id: itemId,
            url: node.url,
            title: node.title,
            description: node.description || '',
            type: node.type,
            icon: node.iconUrl || '',
            meta: ''
        };
    });
};
const $94617b071a9d59a3$var$mapProjectIdsToARIs = ({ projectIds: projectIds, cloudId: cloudId })=>{
    return projectIds.map((projectId)=>{
        if (projectId.startsWith('ari:cloud:jira:')) return projectId;
        return `ari:cloud:jira:${cloudId}:project/${projectId}`;
    });
};
const $94617b071a9d59a3$var$mapAccountIdsToARIs = (accountIds)=>{
    return accountIds.map((accountId)=>{
        if (accountId.startsWith($94617b071a9d59a3$var$USER_ARI_PREFIX)) return accountId;
        return `${$94617b071a9d59a3$var$USER_ARI_PREFIX}${accountId}`;
    });
};
const $94617b071a9d59a3$var$mapAssigneeIdsToARIs = (accountIds)=>{
    return $94617b071a9d59a3$var$mapAccountIdsToARIs(accountIds);
};
const $94617b071a9d59a3$var$mapStatusCategoryIdsToEnumValues = (statusCategoryIds)=>{
    return statusCategoryIds.map((categoryId)=>{
        switch(categoryId){
            case 'open':
                return 'OPEN';
            case 'done':
                return 'DONE';
            case 'OPEN':
                return 'OPEN';
            case 'DONE':
                return 'DONE';
            default:
                return '';
        }
    }).filter(Boolean);
};
const $94617b071a9d59a3$var$mapLastModifiedFilter = (filters)=>{
    const lastModifiedFilter = filters.find((filter)=>filter['@type'] === 'lastModified');
    if (!lastModifiedFilter?.from && !lastModifiedFilter?.to) return null;
    return {
        gt: lastModifiedFilter.from,
        lt: lastModifiedFilter.to
    };
};
const $94617b071a9d59a3$var$mapReportedByFilter = (filters)=>{
    const reportedByFilter = filters.find((filter)=>filter['@type'] === 'reportedBy');
    if (!reportedByFilter || !('accountIds' in reportedByFilter)) return [];
    const accountIds = reportedByFilter.accountIds;
    return $94617b071a9d59a3$var$mapAccountIdsToARIs(accountIds);
};
const $94617b071a9d59a3$var$mapLabelFilter = (filters)=>{
    const labelFilter = filters.find((filter)=>filter['@type'] === 'issueLabels');
    if (!labelFilter || !('issueLabels' in labelFilter)) return [];
    const labels = labelFilter.issueLabels;
    return labels || [];
};
const $94617b071a9d59a3$var$mapScopesToEntities = (scopes)=>{
    const entityMap = {
        issue: 'ati:cloud:jira:issue',
        project: 'ati:cloud:jira:project',
        board: 'ati:cloud:jira:board',
        filter: 'ati:cloud:jira:filter',
        plan: 'ati:cloud:jira:plan'
    };
    return scopes.flatMap((scope)=>{
        // Extract the part after 'jira.' prefix, split by comma, and map to entity ATI types
        const entityKeys = scope.replace('jira.', '').split(',');
        return entityKeys.map((key)=>entityMap[key]).filter(Boolean);
    });
};
const $94617b071a9d59a3$var$createGraphQLSearchSupplier = ({ cloudId: cloudId, sections: sections, searchSessionId: searchSessionId, sessionId: sessionId, experience: experience, sourceProduct: sourceProduct, experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, isJiraIssueIndexed: isJiraIssueIndexed, onError: onError })=>async ({ query: query, filters: allFilters, sectionIds: allPermissionedScopes })=>{
        const filters = allFilters.filter((filter)=>filter['@type'] !== (0, $88j1D.SITE_FILTER_TYPE_NAME)).map((f)=>f);
        const projectFilter = allFilters.find((filter)=>filter['@type'] === 'projects');
        const projectIds = projectFilter && 'projectIds' in projectFilter ? projectFilter.projectIds || [] : [];
        const projectARIs = $94617b071a9d59a3$var$mapProjectIdsToARIs({
            projectIds: projectIds,
            cloudId: cloudId
        });
        const assigneeFilter = allFilters.find((filter)=>filter['@type'] === 'assignees');
        const assigneeAccountIds = assigneeFilter && 'accountIds' in assigneeFilter ? assigneeFilter.accountIds || [] : [];
        const assigneeARIs = $94617b071a9d59a3$var$mapAssigneeIdsToARIs(assigneeAccountIds);
        const statusFilter = allFilters.find((filter)=>filter['@type'] === 'binary_status_categories');
        const statusCategoryIds = statusFilter && 'binaryStatusCategories' in statusFilter ? statusFilter.binaryStatusCategories || [] : [];
        const statusCategories = $94617b071a9d59a3$var$mapStatusCategoryIdsToEnumValues(statusCategoryIds);
        const permittedSections = sections.filter((section)=>allPermissionedScopes.indexOf(section.id) >= 0).filter((section)=>section.isEnabled ? section.isEnabled(query, filters) : true);
        const lastModifiedFilter = $94617b071a9d59a3$var$mapLastModifiedFilter(filters);
        const reporterARIs = $94617b071a9d59a3$var$mapReportedByFilter(filters);
        const issueLabels = $94617b071a9d59a3$var$mapLabelFilter(filters);
        // Create parallel queries for each section scope
        const sectionQueries = permittedSections.map(async (section)=>{
            const scopes = [
                section.scope
            ];
            const mappedEntities = $94617b071a9d59a3$var$mapScopesToEntities(scopes);
            // Get experiment layers for this section's entities
            let backendExperiment;
            const jiraEnableQsExpLayers = (0, $dh538.fg)('jira_enable_qs_exp_layers');
            if (experimentConfig && mappedEntities.length > 0 && jiraEnableQsExpLayers) try {
                backendExperiment = (0, $hm6w9.getBackendExperiment)({
                    experimentConfig: experimentConfig,
                    entities: mappedEntities,
                    isHello: cloudId === $94617b071a9d59a3$var$HELLO_CLOUD_ID,
                    productEdition: productEdition,
                    productDataRegions: productDataRegions,
                    experience: $94617b071a9d59a3$var$QUICK_SEARCH_EXPERIENCE,
                    isJiraIssueIndexed: isJiraIssueIndexed
                });
            } catch (error) {
                onError?.(error);
                backendExperiment = undefined;
            }
            const variables = {
                experience: experience,
                query: query,
                queryVersion: 1,
                cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
                tenantId: cloudId,
                limit: 10,
                commonFilters: {
                    range: lastModifiedFilter ? {
                        lastModified: lastModifiedFilter
                    } : {}
                },
                jiraFilters: {
                    issueFilter: {
                        projectARIs: projectARIs,
                        assigneeARIs: assigneeARIs,
                        issueTypeIDs: [],
                        statusCategories: statusCategories,
                        reporterARIs: reporterARIs,
                        issueLabels: issueLabels
                    },
                    projectFilter: {
                        projectTypes: []
                    }
                },
                entities: mappedEntities,
                experimentLayers: backendExperiment?.experimentLayers?.map(({ analyticsDefinitions: _, ...rest })=>rest) || [],
                sort: [],
                searchSessionId: searchSessionId,
                sessionId: sessionId,
                sourceProduct: sourceProduct
            };
            try {
                const response = await $94617b071a9d59a3$var$jiraSearchDialogQuery({
                    variables: variables,
                    headers: (0, $49259ccb7bc3dbc4$export$14ef296862e3705e)({
                        tenantId: cloudId
                    })
                });
                return {
                    section: section,
                    response: response,
                    success: true,
                    experimentLayers: backendExperiment?.experimentLayers
                };
            } catch  {
                return {
                    section: section,
                    response: null,
                    success: false,
                    experimentLayers: backendExperiment?.experimentLayers
                };
            }
        });
        try {
            const sectionResults = await Promise.all(sectionQueries);
            const results = sectionResults.flatMap((result)=>result.success && result.response?.data ? [
                    result
                ] : []).reduceRight((allSearchItems, searchItem)=>{
                const { section: section, response: response, experimentLayers: experimentLayers } = searchItem;
                // There is a bug on Jira Search dialog query where response?.data?.search?.results.totalCount can be unreliable
                // so response.data?.search?.results.edges.length is used as a fallback
                //  https://atlassian.slack.com/archives/C0919PNMSP6/p1756437134267599?thread_ts=1756430740.125979&cid=C0919PNMSP6
                const size = response.data?.search?.results.totalCount || response.data?.search?.results.edges.length || 0;
                return {
                    sections: [
                        {
                            ...section,
                            id: section.id,
                            title: section.title,
                            size: size,
                            searchResults: response?.data ? $94617b071a9d59a3$var$mapJiraSearchResults(response.data) : [],
                            resultMapper: section.resultMapper
                        },
                        ...allSearchItems.sections
                    ],
                    // Take the first defined experiment layer within the sections
                    experimentLayers: experimentLayers || allSearchItems.experimentLayers,
                    size: (allSearchItems.size ?? 0) + size
                };
            }, {
                sections: [],
                experimentLayers: [],
                size: 0
            });
            return {
                size: results.size,
                sections: results.sections,
                experimentLayers: results.experimentLayers
            };
        } catch  {
            return {
                size: 0,
                sections: [],
                experimentLayers: []
            };
        }
    };
const $94617b071a9d59a3$export$9dc538283f78dd44 = ({ searchSessionId: searchSessionId, sessionId: sessionId, sections: sections, cloudId: cloudId = '', productEdition: productEdition, productDataRegions: productDataRegions, experimentConfig: experimentConfig, isJiraIssueIndexed: isJiraIssueIndexed })=>{
    const productContext = (0, $fJRVo.useProductContext)();
    const { getPrimaryProduct: getPrimaryProduct } = productContext;
    const primaryProduct = getPrimaryProduct();
    const primaryProductId = primaryProduct?.id;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onError = ()=>{
        fireAnalyticsEvent((0, $5dFS9.onGetBackendExperimentFailed)());
    };
    const search = $94617b071a9d59a3$var$createGraphQLSearchSupplier({
        cloudId: cloudId,
        sections: sections,
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        experience: 'product-search-dialog',
        sourceProduct: primaryProductId || '',
        experimentConfig: experimentConfig,
        productEdition: productEdition,
        productDataRegions: productDataRegions,
        isJiraIssueIndexed: isJiraIssueIndexed,
        onError: onError
    });
    return {
        preQueryItemSupplier: (args)=>search({
                ...args,
                query: '',
                filters: []
            }),
        postQueryItemSupplier: search
    };
};


const $c54738dc6b9484af$export$bf5ad8f7e6312fe2 = 'jira';
const $c54738dc6b9484af$export$4a204ebf24901f2e = 'jira.nav-v3';
const $c54738dc6b9484af$export$a0931d840e4e9fd9 = 10;
const $c54738dc6b9484af$export$f6357d218d3fefa3 = 10;
const $c54738dc6b9484af$export$862d39c85199c14c = 6;
const $c54738dc6b9484af$export$223565448ddb4a15 = 8;
const $c54738dc6b9484af$export$e5ea847149c37067 = 'gateway/api/collaboration';
const $c54738dc6b9484af$export$43bbc37c110456ee = '/rest/api/1.0/labels/suggest';
const $c54738dc6b9484af$export$da00a8e161805bdf = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
var $c54738dc6b9484af$export$45df25c6bac04c78 = /*#__PURE__*/ function(JiraScope) {
    JiraScope["Issue"] = "jira.issue";
    JiraScope["ProjectFilter"] = "jira.project,filter";
    JiraScope["BoardProjectFilter"] = "jira.board,project,filter";
    JiraScope["BoardProjectFilterPlans"] = "jira.board,project,filter,plan";
    JiraScope["Project"] = "jira.project";
    JiraScope["Assignee"] = "urs.user-jira";
    return JiraScope;
}({});
var $c54738dc6b9484af$export$dfd4d34c680dbd6e = /*#__PURE__*/ function(JiraFilters) {
    JiraFilters["Projects"] = "projects";
    JiraFilters["Assignees"] = "assignees";
    JiraFilters["Status"] = "binary_status_categories";
    JiraFilters["Date"] = "lastModified";
    JiraFilters["ReportedBy"] = "reportedBy";
    JiraFilters["IssueLabels"] = "issueLabels";
    return JiraFilters;
}({});

















const $eabab0b86d11e1a1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    // NOT USED
    jira_boards_icon_accessibility_text: {
        id: "product_search_dialog.jira.boards_icon_accessibility_text",
        defaultMessage: "Board icon"
    },
    date_filter_today_label: {
        id: "product_search_dialog.jira.date_filter_today",
        defaultMessage: "Today"
    },
    date_filter_yesterday_label: {
        id: "product_search_dialog.jira.date_filter_yesterday",
        defaultMessage: "Yesterday"
    },
    date_filter_past_7_days_label: {
        id: "product_search_dialog.jira.date_filter_past_7_days",
        defaultMessage: "Past 7 days"
    },
    date_filter_past_30_days_label: {
        id: "product_search_dialog.jira.date_filter_past_30_days",
        defaultMessage: "Past 30 days"
    },
    date_filter_past_year_label: {
        id: "product_search_dialog.jira.date_filter_past_year",
        defaultMessage: "Past year"
    },
    report_by_filters_title: {
        id: "product_search_dialog.jira.report_by_filters",
        defaultMessage: "Filter by reporter"
    },
    reported_by_me_filter_option: {
        id: "product_search_dialog.jira.reported_by_me_filter",
        defaultMessage: "Reported by me"
    },
    issue_labels_filters_title: {
        id: "product_search_dialog.jira.issue_labels_filters",
        defaultMessage: "Filter by label"
    },
    issue_labels_filters_placeholder: {
        id: "product_search_dialog.jira.issue_labels_filters_placeholder",
        defaultMessage: "Select label"
    },
    issue_labels_filters_options_group_label: {
        id: "product_search_dialog.jira.issue_labels_filters_options_group_label",
        defaultMessage: "All labels"
    }
});


















































var $7TH2w = parcelRequire("7TH2w");

// Jira uses this for performance monitoring/debugging
const $941b6ab9222e6d09$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $941b6ab9222e6d09$var$getCollabGraphClientWithConfig = (0, $2XqLN.default)((config)=>new (0, $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));
const $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS = 3;
const $941b6ab9222e6d09$export$86c53720f7942492 = (config)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { jiraSites: jiraSites } = (0, $6004f871869f2e35$export$dca16f1ca9af3934)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const statusFilterOptions = [
        {
            id: 'open',
            filterSource: (0, $169DF.FilterOptionSource).STATIC,
            isChecked: false,
            isVisible: true,
            label: formatMessage((0, $bF0iL.messages).binary_status_category_filter_option_open)
        },
        {
            id: 'done',
            filterSource: (0, $169DF.FilterOptionSource).STATIC,
            isChecked: false,
            isVisible: true,
            label: formatMessage((0, $bF0iL.messages).binary_status_category_filter_option_done)
        }
    ];
    const jiraScopeFilterItemMapper = (item, isVisible, isRecent)=>({
            id: item.id,
            avatarUrl: item.avatarUrl || item.attributes?.avatar?.url,
            label: item.name,
            filterSource: isRecent ? (0, $169DF.FilterOptionSource).RECENT : (0, $169DF.FilterOptionSource).SEARCH,
            isChecked: false,
            isVisible: isVisible
        });
    const filterSupplier = async (currentScope, query, defaultItem)=>{
        if (!aggregatorClient) return [];
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                currentScope
            ],
            modelParams: [],
            resultLimit: (0, $c54738dc6b9484af$export$a0931d840e4e9fd9),
            experience: (0, $c54738dc6b9484af$export$4a204ebf24901f2e)
        }).then(({ response: response })=>{
            if (!response) throw (0, $62cd9cdd84f4378e$export$59a963eec12b52ed)(`Expected a response but did not get any for scope: ${currentScope}`);
            const scopedResponse = response.retrieveScope(currentScope);
            if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
            if (scopedResponse.error) throw (0, $62cd9cdd84f4378e$export$59a963eec12b52ed)(scopedResponse.error);
            const maxVisible = defaultItem !== undefined ? $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS - 1 : $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS;
            const options = scopedResponse.results.map((result, i)=>jiraScopeFilterItemMapper(result, i < maxVisible, query === ''));
            return defaultItem !== undefined ? [
                defaultItem,
                ...options
            ] : options;
        });
    };
    const fetchCollabGraphProjectOptions = async ()=>{
        const collabGraphClient = $941b6ab9222e6d09$var$getCollabGraphClientWithConfig({
            collaborationGraphUrl: config?.collaborationGraphUrl || (0, $c54738dc6b9484af$export$e5ea847149c37067),
            cloudId: config?.cloudId || '',
            isMultiSite: jiraSites?.length > 1,
            sites: jiraSites
        });
        return await collabGraphClient.getContainers([
            'jiraProject'
        ], jiraSites).then(({ collaborationGraphEntities: collaborationGraphEntities })=>{
            return collaborationGraphEntities.map((entity, i)=>({
                    label: entity.containerDetails.name,
                    id: entity.containerDetails.id,
                    avatarUrl: entity.containerDetails.iconUrl,
                    filterSource: (0, $169DF.FilterOptionSource).COLLABORATION_GRAPH,
                    isChecked: false,
                    isVisible: i < $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS
                }));
        });
    };
    const interleaveCGAndRecentResults = async (uniqueFn, collabGraphOptions)=>{
        if (collabGraphOptions?.length === (0, $6e4dcee96054a2d9$export$8b133b5f27893e80)) return collabGraphOptions;
        else try {
            const recentOptions = await filterSupplier((0, $c54738dc6b9484af$export$45df25c6bac04c78).Project, '');
            return collabGraphOptions?.length ? (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))([
                ...collabGraphOptions,
                ...recentOptions
            ], uniqueFn).map((item, i)=>({
                    ...item,
                    isVisible: i < $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS
                })) : recentOptions;
        } catch (e) {
            return collabGraphOptions?.length ? collabGraphOptions : [];
        }
    };
    const getProjectOptions = async ()=>{
        let collaborationGraphOptions;
        if (!!config?.cloudId) collaborationGraphOptions = await fetchCollabGraphProjectOptions();
        const interleavedResults = await interleaveCGAndRecentResults((project)=>project.id, collaborationGraphOptions);
        return interleavedResults;
    };
    const issueLabelFilterItemMapper = (issueLabel, isExternal)=>{
        return {
            id: (0, $3S0fp.sha256Hash)(`${config?.cloudId || ''}_${issueLabel.label}`),
            filterSource: isExternal ? (0, $169DF.FilterOptionSource).EXTERNAL : (0, $169DF.FilterOptionSource).SEARCH,
            isChecked: false,
            isVisible: isExternal,
            label: issueLabel.label
        };
    };
    const fireOperationalEvent = (payload)=>{
        fireAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            source: 'searchDialog',
            ...payload
        });
    };
    const fetchIssueLabelOptions = async (query)=>{
        const params = new URLSearchParams([
            [
                'query',
                query
            ]
        ]);
        const path = `${(0, $c54738dc6b9484af$export$43bbc37c110456ee)}?${params.toString()}`;
        const options = {
            requestInit: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    [$941b6ab9222e6d09$var$CAPABILITY_HEADER_NAME]: 'PRODUCT_SEARCH_DIALOG'
                }
            }
        };
        try {
            return await (0, $dwp40.utils).requestService({
                url: path
            }, options).then((response)=>response?.suggestions?.map((issueLabel)=>issueLabelFilterItemMapper(issueLabel, query === '')));
        } catch (error) {
            fireOperationalEvent({
                action: 'failed',
                actionSubject: 'fetchIssueLabels',
                attributes: {
                    error: (0, $62cd9cdd84f4378e$export$59a963eec12b52ed)(error).message
                }
            });
            return [];
        }
    };
    return {
        mapJiraScopeFilterItem: jiraScopeFilterItemMapper,
        mapIssueLabelFilterItem: issueLabelFilterItemMapper,
        statusFilterOptions: statusFilterOptions,
        fetchIssueLabelOptions: fetchIssueLabelOptions,
        fetchCollabGraphProjectOptions: fetchCollabGraphProjectOptions,
        getProjectOptions: getProjectOptions,
        getFilterItemsByJiraScope: filterSupplier
    };
};








// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






const $d5b9dbc2d7e6b5ed$export$53582861b2eaced6 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "ekcv2vh0"
})({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '176px',
    paddingLeft: "var(--ds-space-050, 4px)",
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});


const $892be119e555b7f8$export$fe780e7155e72c07 = (projects, project)=>{
    if (!project) return projects;
    const newOption = {
        ...project,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).EXTERNAL
    };
    const existingItem = projects.find((s)=>s.id === project.id);
    if (!existingItem?.isVisible) {
        const lastVisibleItemIdx = projects.findIndex((s)=>!s.isVisible) - 1;
        if (lastVisibleItemIdx > 0) projects[lastVisibleItemIdx].isVisible = false;
    }
    return [
        newOption
    ].concat(projects.filter((s)=>s.id !== project.id));
};
const $892be119e555b7f8$export$e54fe71d6476ce8f = (assignees, currentUser)=>{
    if (!currentUser) return assignees;
    const newOption = {
        id: currentUser.id,
        label: currentUser.name,
        avatarUrl: currentUser.avatarUrl,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).CURRENT_USER
    };
    const existingItem = assignees.find((assignee)=>assignee.id === currentUser.id);
    if (!existingItem?.isVisible) {
        const lastVisibleItemIdx = assignees.findIndex((assignee)=>!assignee.isVisible) - 1;
        if (lastVisibleItemIdx > 0) assignees[lastVisibleItemIdx].isVisible = false;
    }
    return [
        newOption
    ].concat(assignees.filter((assignee)=>assignee.id !== currentUser.id));
};
const $892be119e555b7f8$export$973ca22476b0e05f = (rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { getFilterItemsByJiraScope: getFilterItemsByJiraScope, getProjectOptions: getProjectOptions, fetchIssueLabelOptions: fetchIssueLabelOptions, statusFilterOptions: statusFilterOptions } = (0, $941b6ab9222e6d09$export$86c53720f7942492)(config);
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(rest.workspaces || [], (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2));
    const projectsFilterStore = (0, $kzbg7.useFilterStore)([], (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2), (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Projects);
    const assigneesFilterStore = (0, $kzbg7.useFilterStore)([], (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2), (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Assignees);
    const reportedByFilterStore = (0, $kzbg7.useFilterStore)([], (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2), (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).ReportedBy);
    const statusFilterStore = (0, $kzbg7.useFilterStore)(statusFilterOptions, (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2), (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Status);
    const issueLabelsFilterStore = (0, $kzbg7.useFilterStore)([], (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2), (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).IssueLabels);
    const loadFilters = (0, $42omo.useCallback)(()=>{
        projectsFilterStore.loadDefaultFilters(getProjectOptions().then((results)=>$892be119e555b7f8$export$fe780e7155e72c07(results, currentProject)));
        assigneesFilterStore.loadDefaultFilters(getFilterItemsByJiraScope((0, $c54738dc6b9484af$export$45df25c6bac04c78).Assignee, '').then((results)=>$892be119e555b7f8$export$e54fe71d6476ce8f(results, currentUser)));
        if (shouldShowIssueLabelsFilter) issueLabelsFilterStore.loadDefaultFilters(fetchIssueLabelOptions(''));
        const defaultReportByOption = currentUser && currentUser.id ? {
            id: currentUser.id,
            label: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).reported_by_me_filter_option),
            avatarUrl: '',
            isChecked: false,
            isVisible: true,
            filterSource: (0, $169DF.FilterOptionSource).CURRENT_USER
        } : undefined;
        if (defaultReportByOption && isReportedByMeFilterEnabled) reportedByFilterStore.setDefaultFilters([
            defaultReportByOption
        ]);
    }, [
        projectsFilterStore,
        getProjectOptions,
        assigneesFilterStore,
        getFilterItemsByJiraScope,
        shouldShowIssueLabelsFilter,
        currentUser,
        formatMessage,
        isReportedByMeFilterEnabled,
        currentProject,
        issueLabelsFilterStore,
        fetchIssueLabelOptions,
        reportedByFilterStore
    ]);
    const searchProject = (0, $42omo.useCallback)(async (query)=>{
        const result = await getFilterItemsByJiraScope((0, $c54738dc6b9484af$export$45df25c6bac04c78).Project, query);
        return result?.map((item)=>({
                value: item,
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $hUj82.FilterOptionItem), {
                    label: item.label,
                    iconProps: {
                        src: item.avatarUrl,
                        appearance: 'square'
                    }
                })
            })) || [];
    }, [
        getFilterItemsByJiraScope
    ]);
    const searchAssignee = (0, $42omo.useCallback)(async (query)=>{
        const result = await getFilterItemsByJiraScope((0, $c54738dc6b9484af$export$45df25c6bac04c78).Assignee, query);
        return result?.map((item)=>({
                value: item,
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $hUj82.FilterOptionItem), {
                    label: item.label,
                    iconProps: {
                        src: item.avatarUrl
                    }
                })
            })) || [];
    }, [
        getFilterItemsByJiraScope
    ]);
    const searchIssueLabels = (0, $42omo.useCallback)(async (query)=>{
        if (shouldShowIssueLabelsFilter) {
            const result = await fetchIssueLabelOptions(query);
            return result?.map((item)=>({
                    value: item,
                    label: item.label
                })) || [];
        }
        return [];
    }, [
        fetchIssueLabelOptions,
        shouldShowIssueLabelsFilter
    ]);
    const defaultValueGetter = (0, $42omo.useCallback)((availableFilters, valueKey = 'id')=>availableFilters.filter((f)=>f.isChecked && f[valueKey]).map((f)=>f[valueKey]), []);
    const appliedReportedByFilter = reportedByFilterStore?.availableFilters?.find((f)=>f.isChecked)?.id;
    const getReportedByMe = (0, $42omo.useCallback)(()=>{
        return appliedReportedByFilter ? {
            '@type': (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).ReportedBy,
            accountIds: [
                appliedReportedByFilter
            ]
        } : null;
    }, [
        appliedReportedByFilter
    ]);
    const reportedByDefinition = isReportedByMeFilterEnabled ? [
        {
            ['@type']: (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).ReportedBy,
            fieldName: 'accountIds',
            store: reportedByFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).report_by_filters_title),
            findMoreLabel: '',
            mapSelectionToAppliedValue: getReportedByMe,
            filterConfig: {
                hideIcon: true,
                usePreloadedOptions: true,
                labelComponent: (0, $d5b9dbc2d7e6b5ed$export$53582861b2eaced6)
            }
        }
    ] : [];
    const appliedIssueLabelsFilters = (0, $42omo.useMemo)(()=>defaultValueGetter(issueLabelsFilterStore.availableFilters, 'label'), [
        defaultValueGetter,
        issueLabelsFilterStore.availableFilters
    ]);
    const getAppliedIssueLabels = (0, $42omo.useCallback)(()=>{
        if (appliedIssueLabelsFilters.length > 0) return {
            '@type': (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).IssueLabels,
            issueLabels: appliedIssueLabelsFilters
        };
        return null;
    }, [
        appliedIssueLabelsFilters
    ]);
    const issueLabelsFilterDefinition = shouldShowIssueLabelsFilter ? [
        {
            ['@type']: (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).IssueLabels,
            uiVariant: (0, $88j1D.FilterUIVariant).MULTI_SELECT,
            fieldName: 'issueLabels',
            store: issueLabelsFilterStore,
            loadFilterOptions: searchIssueLabels,
            sectionLabel: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).issue_labels_filters_title),
            findMoreLabel: '',
            placeholderText: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).issue_labels_filters_placeholder),
            mapSelectionToAppliedValue: getAppliedIssueLabels,
            filterConfig: {
                mainGroupLabel: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).issue_labels_filters_options_group_label)
            }
        }
    ] : [];
    const filtersDefinition = [
        ...siteFilterDefinition,
        {
            ['@type']: (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Projects,
            fieldName: 'projectIds',
            store: projectsFilterStore,
            loadFilterOptions: searchProject,
            sectionLabel: formatMessage((0, $bF0iL.messages).project_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).project_filters_find_more),
            filterConfig: {
                filterOptionIconShape: 'square'
            }
        },
        {
            ['@type']: (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Assignees,
            fieldName: 'accountIds',
            store: assigneesFilterStore,
            loadFilterOptions: searchAssignee,
            sectionLabel: formatMessage((0, $bF0iL.messages).assignee_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).assignee_filters_find_more),
            filterConfig: {
                filterOptionIconShape: 'circle'
            }
        },
        ...reportedByDefinition,
        {
            ['@type']: (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Status,
            fieldName: 'binaryStatusCategories',
            store: statusFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $bF0iL.messages).binary_status_category_filters_title),
            findMoreLabel: '',
            filterConfig: {
                filterGroupedBy: 'row',
                hideIcon: true,
                usePreloadedOptions: true
            }
        },
        ...issueLabelsFilterDefinition
    ];
    const filterValueGetters = (0, $42omo.useMemo)(()=>({
            projects: ()=>defaultValueGetter(projectsFilterStore.availableFilters),
            assignees: ()=>defaultValueGetter(assigneesFilterStore.availableFilters),
            statuses: ()=>defaultValueGetter(statusFilterStore.availableFilters),
            reportedBy: ()=>defaultValueGetter(reportedByFilterStore.availableFilters),
            issueLabels: ()=>shouldShowIssueLabelsFilter ? appliedIssueLabelsFilters : []
        }), [
        defaultValueGetter,
        projectsFilterStore.availableFilters,
        assigneesFilterStore.availableFilters,
        statusFilterStore.availableFilters,
        reportedByFilterStore.availableFilters,
        appliedIssueLabelsFilters,
        shouldShowIssueLabelsFilter
    ]);
    return {
        filterValueGetters: filterValueGetters,
        filtersDefinition: filtersDefinition,
        loadFilters: loadFilters
    };
};





















var $2OcMi = parcelRequire("2OcMi");

const $71fe4fb99370a73e$export$6ad518df41ca9b2f = (href, ids)=>{
    return (0, $2OcMi.addQueryParams)(href, ids);
};






const $01f8562883944ff4$export$fd0142e43ea55591 = (href, searchResult)=>{
    const hrefWithReferrals = (0, $71fe4fb99370a73e$export$6ad518df41ca9b2f)(href, {
        searchObjectId: searchResult.id,
        searchContainerId: searchResult.attributes.containerId,
        searchContentType: (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).issue
    });
    return hrefWithReferrals;
};
const $01f8562883944ff4$export$8aceb1d6e8b68a94 = (href, searchResult)=>{
    const containerAttribute = searchResult.attributes['@type'] === (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).board ? {
        searchContainerId: searchResult.attributes.containerId
    } : {};
    const contentTypeAttribute = {
        searchContentType: searchResult.attributes['@type']
    };
    const hrefWithReferrals = (0, $71fe4fb99370a73e$export$6ad518df41ca9b2f)(href, {
        ...contentTypeAttribute,
        ...containerAttribute,
        searchObjectId: searchResult.id
    });
    return hrefWithReferrals;
};
const $01f8562883944ff4$export$b37ee0d76c6d2fbc = ()=>{
    return (href, searchResult)=>{
        if (searchResult.attributes['@type'] === (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).issue) return $01f8562883944ff4$export$fd0142e43ea55591(href, searchResult);
        return $01f8562883944ff4$export$8aceb1d6e8b68a94(href, searchResult);
    };
};
const $01f8562883944ff4$export$a0b32aef6b0d7373 = (url, searchSessionId)=>{
    return (0, $2OcMi.addQueryParams)(url, {
        searchSessionId: searchSessionId
    });
};









function $a3507ff98cccb432$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a3507ff98cccb432$export$54477ee883ec6167 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "esh65ev0"
})({
    name: "1082qq3",
    styles: "display:block;width:100%"
});





parcelRequire("42omo");





const $2dadc7da0d3cdd55$export$1d30bb3376c56ddb = (intl, formatDate, updated)=>{
    if (!updated) {
        const message = intl.formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading);
        return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            title: message,
            children: message
        });
    }
    if (formatDate) return formatDate(updated);
    else return (0, $e5e658f2850ebd6c$export$406508d2ca449bd)(updated);
};








parcelRequire("42omo");
















const $6d4c433494a08e6d$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
        const { productState: productState } = args;
        const recentTitle = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $bF0iL.messages).common_recently_viewed_section_heading
        });
        const issuesTitleMessage = (0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_issues_section_heading;
        const issuesTitle = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...issuesTitleMessage
        });
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
                return recentTitle;
            case (0, $jFPud.ProductStates).PostQueryLoading:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEbYb.LoadingSkeleton), {
                    "data-testid": 'autocorrection-loading-skeleton'
                });
                return issuesTitle;
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                    fallback: issuesTitle
                });
                return issuesTitle;
            default:
                return issuesTitle;
        }
    };


/* eslint-disable @repo/internal/react/no-class-components */ 





class $b77b2477746b3ccd$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onError && this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
var $b77b2477746b3ccd$export$2e2bcd8739ae039 = $b77b2477746b3ccd$var$ErrorBoundary;



var $hcMBV = parcelRequire("hcMBV");


const $8845a8b56f4b6117$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("eOylV")).then((mod)=>({
            default: mod.HoverCard
        })));
const $8845a8b56f4b6117$var$HoverCardResultWrapper = ({ children: children, url: url = '', titleId: titleId = '' })=>{
    const hidePreviewAction = (0, $42omo.useMemo)(()=>{
        return {
            hide: false,
            exclude: [
                (0, $hcMBV.CardAction).PreviewAction
            ]
        };
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a3507ff98cccb432$export$54477ee883ec6167), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b77b2477746b3ccd$export$2e2bcd8739ae039), {
            fallback: children,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
                fallback: children,
                children: /*#__PURE__*/ (0, $l998X.jsx)($8845a8b56f4b6117$var$HoverCard, {
                    url: url,
                    actionOptions: hidePreviewAction,
                    role: "dialog",
                    titleId: titleId,
                    children: children
                })
            })
        })
    });
};
const $8845a8b56f4b6117$var$viewAllLinkRendererIssues = ({ section: section, totalResults: totalResults })=>{
    const isTotalItemsGreaterThanTheLimit = (totalResults || section.searchResults?.length) > (section.resultLimit || 0);
    return isTotalItemsGreaterThanTheLimit ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $bF0iL.messages).common_show_all_results_link
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
};
const $8845a8b56f4b6117$export$5e1b8123b0df487f = (hasAdvancedRoadmapsAccess, hasSoftwareAccess, viewAllLinkGenerator, isPreviewOnJiraSearchResultsEnabled, intl, formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled)=>{
    const appendQueryParams = (0, $01f8562883944ff4$export$b37ee0d76c6d2fbc)();
    const mapJiraItems = (response)=>response.results.map((item)=>{
            const base = {
                id: item.id,
                title: item.name,
                url: appendQueryParams(item.url || '', item),
                meta: '',
                iconUrl: item.attributes?.avatar?.url || '',
                type: item.attributes['@type']
            };
            if (item.attributes && item.attributes['@type'] === (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).issue) return {
                ...base,
                title: `${item.attributes?.key}  ${item.name}`,
                meta: item.attributes?.container?.title || '',
                containerId: item.attributes?.containerId,
                additionalMeta: (0, $2dadc7da0d3cdd55$export$1d30bb3376c56ddb)(intl, formatDate, item.attributes?.updated)
            };
            if (item.attributes && item.attributes['@type'] === (0, $068ba82a94015a1a$export$d31c6c64cddbeeac).board) return {
                ...base,
                meta: item.attributes?.container?.title || '',
                containerId: item.attributes?.containerId
            };
            return base;
        });
    const getSectionDetailsByAccess = ()=>{
        if (hasAdvancedRoadmapsAccess) return {
            scope: (0, $c54738dc6b9484af$export$45df25c6bac04c78).BoardProjectFilterPlans,
            recentHeading: (0, $bF0iL.messages).jira_recent_boards_projects_filters_plans_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_boards_projects_filters_plans_section_heading
        };
        if (hasSoftwareAccess) return {
            scope: (0, $c54738dc6b9484af$export$45df25c6bac04c78).BoardProjectFilter,
            recentHeading: (0, $bF0iL.messages).jira_recent_boards_projects_filters_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_boards_projects_filters_section_heading
        };
        return {
            scope: (0, $c54738dc6b9484af$export$45df25c6bac04c78).ProjectFilter,
            recentHeading: (0, $bF0iL.messages).jira_recent_projects_filters_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_projects_filters_section_heading
        };
    };
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const secondSectionDetails = getSectionDetailsByAccess();
    const enableNoIssueSection = (query, filters)=>!filters.find((filter)=>filter['accountIds']?.length > 0 || filter['projectIds']?.length > 0 || filter['binaryStatusCategories']?.length > 0 || filter['issueLabels']?.length > 0);
    const resultRenderer = ()=>{
        return (args)=>(0, $ejGzS.defaultResultRenderer)(isConsistentIssueDetailsEnabled ? {
                ...args,
                isCollapsed: true
            } : args);
    };
    const sections = [
        {
            id: (0, $c54738dc6b9484af$export$45df25c6bac04c78).Issue,
            title: formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_issues_section_heading),
            titleRenderer: (0, $6d4c433494a08e6d$export$aee00814c9e3bae7)(!!autocorrectEnabled),
            scope: (0, $c54738dc6b9484af$export$45df25c6bac04c78).Issue,
            resultMapper: mapJiraItems,
            showResultCount: true,
            resultLimit: (0, $c54738dc6b9484af$export$f6357d218d3fefa3),
            viewAllLinkRenderer: $8845a8b56f4b6117$var$viewAllLinkRendererIssues,
            resultRenderer: resultRenderer(),
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultWrapper: isPreviewOnJiraSearchResultsEnabled ? $8845a8b56f4b6117$var$HoverCardResultWrapper : undefined
        },
        {
            id: secondSectionDetails.scope,
            title: formatMessage(secondSectionDetails.searchHeading),
            scope: secondSectionDetails.scope,
            resultMapper: mapJiraItems,
            isEnabled: enableNoIssueSection,
            resultLimit: hasAdvancedRoadmapsAccess ? (0, $c54738dc6b9484af$export$223565448ddb4a15) : (0, $c54738dc6b9484af$export$862d39c85199c14c)
        }
    ];
    const recentSectionTitleGenerator = (section)=>section.id === (0, $c54738dc6b9484af$export$45df25c6bac04c78).Issue ? formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_recently_viewed_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_recently_viewed_issues_section_heading) : formatMessage(secondSectionDetails.recentHeading);
    return {
        recentSectionTitleGenerator: recentSectionTitleGenerator,
        sections: sections,
        mapJiraItems: mapJiraItems,
        getSectionDetailsByAccess: getSectionDetailsByAccess
    };
};






/**
 * Builds a JQL query for text search input using summary and description
 */ const $418b29c7f9ac3680$var$buildTextSearchInputJql = (query)=>{
    if (!query) return '';
    const encodedQuery = encodeURIComponent(query);
    return `textfields ~ "${encodedQuery}*"`;
};
const $418b29c7f9ac3680$var$buildJQLAdvancedIssueUrl = (jql)=>`/issues/?jql=${jql}`;
const $418b29c7f9ac3680$var$buildJiraSearchUrl = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $418b29c7f9ac3680$var$buildSmartQueryAdvancedSearchUrl = (query)=>`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;
const $418b29c7f9ac3680$var$escapeAndQuoteLabels = (label)=>{
    // Escape backslashes and double quotes
    const escapedLabel = label.replace(/([\\"])/g, '\\$1');
    // Wrap the escaped label in double quotes
    return `"${escapedLabel}"`;
};
const $418b29c7f9ac3680$var$buildJqlQuery = (query, projectIds, accountIds, reporterIds, binaryStatusCategoryValues, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled)=>{
    let textJQL;
    if (isSearchWithTextFieldInAllIssuesLinkEnabled) textJQL = query ? `text ~ "${encodeURIComponent(query)}*"` : '';
    else textJQL = query ? $418b29c7f9ac3680$var$buildTextSearchInputJql(query) : '';
    const projectJQL = projectIds.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : '';
    const assigneeJQL = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : '';
    const issueLabelsJQL = issueLabels.length > 0 ? `labels IN (${encodeURIComponent(issueLabels.map((label)=>$418b29c7f9ac3680$var$escapeAndQuoteLabels(label)).join(','))})` : '';
    const reporterJQL = reporterIds.length > 0 ? `reporter IN (${encodeURIComponent(reporterIds.join(','))})` : '';
    const updateDateJQL = appliedDateFilterValue !== null ? `updated >= "${appliedDateFilterValue.from}" AND updated <= "${appliedDateFilterValue.to}"` : '';
    const binaryStatusCategoryJQL = binaryStatusCategoryValues?.length === 1 ? `statusCategory IN (${encodeURIComponent($418b29c7f9ac3680$var$getStatusesByStatusCategory(binaryStatusCategoryValues))})` : '';
    return [
        textJQL,
        projectJQL,
        assigneeJQL,
        reporterJQL,
        binaryStatusCategoryJQL,
        issueLabelsJQL,
        updateDateJQL
    ].filter(Boolean).join(' AND ');
};
const $418b29c7f9ac3680$var$getStatusesByStatusCategory = (values)=>{
    if (!!values.find((v)=>v === 'open')) return '"undefined", "In Progress", "To Do"';
    if (!!values.find((v)=>v === 'done')) return '"Done"';
    return '';
};
const $418b29c7f9ac3680$export$f63780fc2b3633e = (filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled = false)=>{
    const buildJiraAdvancedSearchPath = (0, $42omo.useCallback)((query)=>{
        const trimmedQuery = query.trim();
        const projectIds = filterValueGetters.projects();
        const accountIds = filterValueGetters.assignees();
        const reporterIds = filterValueGetters.reportedBy();
        const binaryStatusCategories = filterValueGetters.statuses();
        const issueLabels = filterValueGetters.issueLabels();
        // If there is a filter applied, and either a query is provided or isPreQueryFiltersEnabled is true, then we build the JQL
        if ((projectIds.length !== 0 || accountIds.length !== 0 || reporterIds.length !== 0 || binaryStatusCategories.length === 1 || issueLabels.length !== 0 || appliedDateFilterValue !== null) && (trimmedQuery || isPreQueryFiltersEnabled)) return $418b29c7f9ac3680$var$buildJQLAdvancedIssueUrl($418b29c7f9ac3680$var$buildJqlQuery(trimmedQuery, projectIds, accountIds, reporterIds, binaryStatusCategories, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled));
        // Otherwise we determine next action based on whether a query is provided or not
        if (!trimmedQuery) // If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
        return query === '' ? (0, $c54738dc6b9484af$export$da00a8e161805bdf) : $418b29c7f9ac3680$var$buildSmartQueryAdvancedSearchUrl(query);
        return $418b29c7f9ac3680$var$buildJiraSearchUrl(trimmedQuery);
    }, [
        filterValueGetters,
        appliedDateFilterValue,
        isPreQueryFiltersEnabled,
        isSearchWithTextFieldInAllIssuesLinkEnabled
    ]);
    const useFiltersAdvancedSearchUrlFactory = (0, $42omo.useCallback)((query, siteUrl)=>`${siteUrl ?? ''}${buildJiraAdvancedSearchPath(query)}`, [
        buildJiraAdvancedSearchPath
    ]);
    return {
        getFiltersAdvancedSearchUrl: useFiltersAdvancedSearchUrlFactory
    };
};





parcelRequire("42omo");





var $lnXRc = parcelRequire("lnXRc");











var $bKrl4 = parcelRequire("bKrl4");

const $2ede78aae473f56f$export$f5d288a16f3b101c = (props)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bKrl4.GetDefaultFooter), {
            returnKeyIconComponent: props.returnKeyIconComponent,
            linkComponent: props.linkComponent,
            productState: props.productState,
            searchFooterLabel: formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_view_all_issues_newIssueTermRefresh : (0, $bF0iL.messages).jira_view_all_issues_new)
        })
    });
};
const $2ede78aae473f56f$export$f8ed21c35936f5aa = (0, $lnXRc.withAnalytics)({
    advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected)
})($2ede78aae473f56f$export$f5d288a16f3b101c);
var $2ede78aae473f56f$export$2e2bcd8739ae039 = $2ede78aae473f56f$export$f8ed21c35936f5aa;
















const $4b29f03d0096a2d7$export$79b79eb7219cb5fd = ()=>{
    const response = Object.values((0, $068ba82a94015a1a$export$775b6bb06e53a214));
    return Promise.resolve(response);
};












parcelRequire("42omo");























// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $kPBHE = parcelRequire("kPBHE");




function $34cfde37e0470e3c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $34cfde37e0470e3c$export$cb4aeb4aba07ad10 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "eq9f4ne2"
})({
    name: "1es2nqu",
    styles: "padding:var(--ds-space-200, 16px)"
});
const $34cfde37e0470e3c$export$f5ae33f1b01a6402 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "eq9f4ne1"
})({
    marginRight: "var(--ds-space-100, 8px)",
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`,
    '&:hover, &:focus': {
        color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':visited': {
        color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
    }
});
const $34cfde37e0470e3c$export$9048d548939551ee = /*#__PURE__*/ (0, $cStGJ.default)((0, $kPBHE.Link), {
    target: "eq9f4ne0"
})({
    WebkitBoxAlign: 'baseline',
    alignItems: 'baseline',
    boxSizing: 'border-box',
    display: 'inline-flex',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    textAlign: 'center',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-150, 8px)"}`,
    marginRight: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N30)})`,
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    '&:visited, &:focus-visible, &:focus': {
        color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`
    }
});


const $ca3b19d515fa565d$export$4c85ccfa2dce935c = (query, features)=>{
    let allLinks = {
        board: {
            href: `/secure/ManageRapidViews.jspa?contains=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_boards,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_BOARDS
        },
        project: {
            href: `/projects?contains=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_projects,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PROJECTS
        },
        filters: {
            href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_filters,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_FILTERS
        },
        plans: {
            href: `/jira/plans`,
            message: (0, $bF0iL.messages).jira_advanced_search_plans,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PLANS
        },
        people: {
            href: `/jira/people/search?q=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_people,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PEOPLE
        }
    };
    // Remove access to plans if the user does not have Advanced Roadmaps access
    if (!features?.hasAdvancedRoadmapsAccess) delete allLinks.plans;
    // Remove access to boards if the user does not have software access
    if (!features?.hasAdvancedRoadmapsAccess && !features?.hasSoftwareAccess) delete allLinks.board;
    return allLinks;
};
const $ca3b19d515fa565d$export$b16edfe49ade2612 = ({ advancedSearchSelected: advancedSearchSelected, features: features, linkComponent: linkComponent })=>{
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const onClickAndFireEvent = (e, actionSubjectId)=>{
        e.preventDefault();
        advancedSearchSelected({
            actionSubjectId: actionSubjectId,
            trigger: (0, $3S0fp.getTrigger)(e),
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        });
    };
    const searchConfiguration = $ca3b19d515fa565d$export$4c85ccfa2dce935c(query, features);
    // Had to extract this into a separate function to avoid the eslint disable getting caught in ratcheting
    // Will move it back on fg clean up
    const advancedSearchListItem = (key)=>{
        const { href: href, message: message, actionSubjectId: actionSubjectId } = searchConfiguration[key];
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            as: "li",
            xcss: $ca3b19d515fa565d$var$advancedSearchListItemStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                onClick: (e)=>onClickAndFireEvent(e, actionSubjectId),
                role: "none",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $34cfde37e0470e3c$export$9048d548939551ee), {
                    linkComponent: linkComponent,
                    href: href,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...message
                    })
                }, `search_link_${key}`)
            })
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $34cfde37e0470e3c$export$cb4aeb4aba07ad10), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $ca3b19d515fa565d$var$advancedSearchListContainerStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $34cfde37e0470e3c$export$f5ae33f1b01a6402), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $bF0iL.messages).jira_advanced_search_label
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    as: "ul",
                    xcss: $ca3b19d515fa565d$var$advancedSearchListStyles,
                    children: Object.keys(searchConfiguration).map((key)=>advancedSearchListItem(key))
                })
            ]
        })
    });
};
const $ca3b19d515fa565d$var$advancedSearchListContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $ca3b19d515fa565d$var$advancedSearchListStyles = (0, $ecnYn.xcss)({
    padding: '0',
    margin: '0',
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $ca3b19d515fa565d$var$advancedSearchListItemStyles = (0, $ecnYn.xcss)({
    margin: '0',
    padding: '0'
});
var $ca3b19d515fa565d$export$2e2bcd8739ae039 = (0, $gmMgo.default)($ca3b19d515fa565d$export$b16edfe49ade2612);






var $2jYn8 = parcelRequire("2jYn8");


var $gRazf = parcelRequire("gRazf");


var $3cM77 = parcelRequire("3cM77");





















// The toOffset default is -1 because the 'to' date is not inclusive,
//  so we set it to the tomorrow's date to include results from today
const $ad28263e005306c5$var$getDateRange = (fromOffset, toOffset = -1)=>{
    const from = new Date();
    const to = new Date();
    from.setDate(from.getDate() - fromOffset);
    to.setDate(to.getDate() - toOffset);
    return {
        from: from.toISOString().split('T')[0],
        to: to.toISOString().split('T')[0]
    };
};
const $ad28263e005306c5$export$ab45d91883e25704 = ({ isDateFromFilterEnabled: isDateFromFilterEnabled })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const dateFilterOptionsAndValues = (0, $42omo.useMemo)(()=>{
        return !isDateFromFilterEnabled ? null : {
            [(0, $88j1D.LastModifiedValues).DEFAULT]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).DEFAULT,
                    label: formatMessage((0, $bF0iL.messages).date_filter_any_time_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: true,
                    isVisible: true
                },
                dateRange: {
                    from: '',
                    to: ''
                }
            },
            [(0, $88j1D.LastModifiedValues).TODAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).TODAY,
                    label: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).date_filter_today_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(0)
            },
            [(0, $88j1D.LastModifiedValues).YESTERDAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).YESTERDAY,
                    label: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).date_filter_yesterday_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(1, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS,
                    label: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).date_filter_past_7_days_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(7)
            },
            [(0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS,
                    label: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).date_filter_past_30_days_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(30)
            },
            [(0, $88j1D.LastModifiedValues).PAST_YEAR]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_YEAR,
                    label: formatMessage((0, $eabab0b86d11e1a1$export$defe85febe8b728c).date_filter_past_year_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(365)
            }
        };
    }, [
        isDateFromFilterEnabled,
        formatMessage
    ]);
    const dateFilterOptions = (0, $42omo.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
        dateFilterOptionsAndValues
    ]);
    const dateFilterStore = (0, $kzbg7.useFilterStore)(dateFilterOptions, (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2), (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Date);
    const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, $88j1D.DEFAULT_OPTION))?.id;
    const appliedDateFilterValue = appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? dateFilterOptionsAndValues[appliedDateFilter].dateRange : null;
    const getLastModifiedValue = (0, $42omo.useCallback)(()=>{
        return appliedDateFilterValue ? {
            '@type': (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Date,
            from: appliedDateFilterValue.from,
            to: appliedDateFilterValue.to
        } : null;
    }, [
        appliedDateFilterValue
    ]);
    const jiraTabDateFilterDefinition = (0, $42omo.useMemo)(()=>{
        return isDateFromFilterEnabled ? [
            {
                ['@type']: (0, $c54738dc6b9484af$export$dfd4d34c680dbd6e).Date,
                uiVariant: (0, $88j1D.FilterUIVariant).STATIC_SELECT,
                fieldName: 'from',
                store: dateFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, $bF0iL.messages).date_filter_filters_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: ()=>getLastModifiedValue()
            }
        ] : [];
    }, [
        isDateFromFilterEnabled,
        dateFilterStore,
        formatMessage,
        getLastModifiedValue
    ]);
    return {
        appliedDateFilterValue: appliedDateFilterValue,
        jiraTabDateFilterDefinition: jiraTabDateFilterDefinition,
        dateFilterOptionsAndValues: dateFilterOptionsAndValues
    };
};










let $704bede17293a569$var$hasLoadedFilters = false;
let $704bede17293a569$var$currentProjectRef;
let $704bede17293a569$var$currentUserRef;
const $704bede17293a569$export$5eff96142961f4a2 = (value)=>$704bede17293a569$var$hasLoadedFilters = value;
const $704bede17293a569$var$JiraNoPreQueryResults = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3cM77.default), {
        message: (0, $bF0iL.messages).jira_empty_state_prequery_heading
    });
const $704bede17293a569$export$8db2a2835d8b9d10 = ({ features: features, children: children, config: config, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, currentProject: currentProject, currentUser: currentUser, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, productEdition: productEdition, productDataRegions: productDataRegions, experimentConfig: experimentConfig, isJiraIssueIndexed: isJiraIssueIndexed, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { jiraSites: jiraSites } = (0, $6004f871869f2e35$export$dca16f1ca9af3934)();
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { query: query } = (0, $2ZIpG.useQuery)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const hasAdvancedRoadmapsAccess = !!features?.hasAdvancedRoadmapsAccess;
    const hasSoftwareAccess = !!features?.hasSoftwareAccess;
    const isPreviewOnJiraSearchResultsEnabled = !!features?.isPreviewOnJiraSearchResultsEnabled;
    const isReportedByMeFilterEnabled = !!features?.isReportedByMeFilterEnabled;
    const isConsistentIssueDetailsEnabled = !!features?.isConsistentIssueDetailsEnabled;
    const isDateFromFilterEnabled = !!features?.enableDateFromFilter;
    const shouldShowIssueLabelsFilter = !!features?.enableIssueLabelsFilter;
    const isPreQueryFiltersEnabled = true;
    const isSearchWithTextFieldInAllIssuesLinkEnabled = !!features?.isSearchWithTextFieldInAllIssuesLinkEnabled;
    const productSessionId = (0, $5da1e983823dc9f1$export$ad9e8f9d9536c33d)();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    const { filtersDefinition: filtersDefinition, loadFilters: loadFilters, filterValueGetters: filterValueGetters } = (0, $892be119e555b7f8$export$973ca22476b0e05f)(rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled);
    const { jiraTabDateFilterDefinition: jiraTabDateFilterDefinition, appliedDateFilterValue: appliedDateFilterValue } = (0, $ad28263e005306c5$export$ab45d91883e25704)({
        isDateFromFilterEnabled: isDateFromFilterEnabled
    });
    const fasterSearchDisabledFromCombinedExperiment = Boolean(experimentConfig?.combinedExperiment?.enabled && experimentConfig?.combinedExperiment?.uiFeatures?.fasterSearchDisabled);
    const abTest = (0, $gRazf.useABTest)();
    const isFasterSearchDisabled = fasterSearchDisabledFromCombinedExperiment || abTest !== null && abTest !== undefined && (abTest.experimentId === 'durian-without-faster-search' || abTest.experimentId === 'default-without-faster-search');
    if ((!$704bede17293a569$var$hasLoadedFilters || $704bede17293a569$var$currentProjectRef?.id !== currentProject?.id || $704bede17293a569$var$currentUserRef?.id !== currentUser?.id || $704bede17293a569$var$currentUserRef?.avatarUrl !== currentUser?.avatarUrl) && isExpanded && getActiveProduct()?.id === (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2) && (isPreQueryFiltersEnabled || query !== '')) {
        loadFilters();
        $704bede17293a569$var$currentProjectRef = currentProject;
        $704bede17293a569$var$currentUserRef = currentUser;
        $704bede17293a569$export$5eff96142961f4a2(true);
    }
    defineFilters((0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2), [
        ...isDateFromFilterEnabled ? jiraTabDateFilterDefinition : [],
        ...filtersDefinition
    ]);
    const { getFiltersAdvancedSearchUrl: getFiltersAdvancedSearchUrl } = (0, $418b29c7f9ac3680$export$f63780fc2b3633e)(filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled);
    const generateAdvancedSearchUrl = (0, $42omo.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $254bef028b438f80$export$306c16563e2015b8)(orgId, cloudId, query, primaryProduct?.id);
        return getFiltersAdvancedSearchUrl(query, baseUrl);
    }, [
        getFiltersAdvancedSearchUrl,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    const { recentSectionTitleGenerator: recentSectionTitleGenerator, sections: sections } = (0, $8845a8b56f4b6117$export$5e1b8123b0df487f)(hasAdvancedRoadmapsAccess, hasSoftwareAccess, getFiltersAdvancedSearchUrl, isPreviewOnJiraSearchResultsEnabled, (0, $8C5kA.default)(), formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled);
    const defaultSuppliers = (0, $029554683ea761ec$export$967ff0f6c3886589)((0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const jiraExperimentSuppliers = (0, $94617b071a9d59a3$export$9dc538283f78dd44)({
        searchSessionId: searchSessionId,
        sessionId: productSessionId,
        sections: sections,
        cloudId: cloudId,
        productEdition: productEdition,
        productDataRegions: productDataRegions,
        experimentConfig: experimentConfig,
        isJiraIssueIndexed: isJiraIssueIndexed
    });
    const isJiraGraphQLEnabled = (0, $dh538.fg)('jira_enable_qs_graphql') && getActiveProduct()?.id === (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2);
    const itemSuppliers = {
        preQueryItemSupplier: defaultSuppliers.preQueryItemSupplier,
        postQueryItemSupplier: isJiraGraphQLEnabled ? jiraExperimentSuppliers.postQueryItemSupplier : defaultSuppliers.postQueryItemSupplier
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $c54738dc6b9484af$export$bf5ad8f7e6312fe2),
        expandedStateInputPlaceholder: formatMessage((0, $bF0iL.messages).jira_search_placeholder),
        title: formatMessage((0, $bF0iL.messages).jira_tab_label),
        autocorrectEnabled: autocorrectEnabled,
        sections: sections,
        preQuerySectionTitleGenerator: recentSectionTitleGenerator,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        ...rest,
        ...itemSuppliers,
        permissionSupplier: jiraSites.length > 0 ? (0, $4b29f03d0096a2d7$export$79b79eb7219cb5fd) : rest.permissionSupplier,
        appendQueryParams: (0, $01f8562883944ff4$export$a0b32aef6b0d7373),
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled,
        debounceTime: 300,
        isFasterSearchDisabled: Boolean(fasterSearchDisabledFromCombinedExperiment),
        children: ({ linkComponent: linkComponent, productState: productState })=>{
            return {
                Body: ()=>{
                    if (productState === (0, $jFPud.ProductStates).PostQueryLoading && isFasterSearchDisabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2jYn8.LoadingSpinner), {});
                    else if (productState === (0, $jFPud.ProductStates).PreQueryNoResult) return /*#__PURE__*/ (0, $l998X.jsx)($704bede17293a569$var$JiraNoPreQueryResults, {});
                },
                SectionFooter: jiraSites.length > 1 ? undefined // don't show the footer for multi sites
                 : ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ca3b19d515fa565d$export$2e2bcd8739ae039), {
                        advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected),
                        linkComponent: linkComponent,
                        productState: productState,
                        features: features
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2ede78aae473f56f$export$f8ed21c35936f5aa), {
                                returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined,
                                linkComponent: linkComponent,
                                productState: productState,
                                features: features
                            }),
                            showAtlassianHomeSearchLink && orgId && /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $254bef028b438f80$export$829d02f6cd9ab0ce), {
                                    orgId: orgId,
                                    cloudId: cloudId,
                                    showModifierIcon: true
                                })
                            })
                        ]
                    })
            };
        }
    });
};



















const $dae70913057c5350$export$edfa1467d84b6872 = (item, query)=>{
    const lowerQuery = query.toLowerCase().trim();
    return item.name.toLowerCase().includes(lowerQuery) || item.attributes.key.toLowerCase().includes(lowerQuery);
};
const $dae70913057c5350$export$e4a4d5c1140c233a = (daysBefore)=>{
    const date = new Date();
    date.setDate(date.getDate() - daysBefore);
    return date.toISOString().split('T')[0];
};


var $67a90fc752dffcfd$var$_BinaryStatusCategory;
const $67a90fc752dffcfd$var$BROCCOLI_30_EXPERIMENT = {
    experimentId: 'broccoli-30-frontend',
    days: 30
};
const $67a90fc752dffcfd$var$BROCCOLI_60_EXPERIMENT = {
    experimentId: 'broccoli-60-frontend',
    days: 60
};
const $67a90fc752dffcfd$var$BROCCOLI_90_EXPERIMENT = {
    experimentId: 'broccoli-90-frontend',
    days: 90
};
const $67a90fc752dffcfd$export$40e7ffc2d13a061c = [
    $67a90fc752dffcfd$var$BROCCOLI_30_EXPERIMENT,
    $67a90fc752dffcfd$var$BROCCOLI_60_EXPERIMENT,
    $67a90fc752dffcfd$var$BROCCOLI_90_EXPERIMENT
];
class $67a90fc752dffcfd$export$bea22cefe0b3447c {
    constructor(id, jqlValue){
        this.id = void 0;
        this.jqlValue = void 0;
        this.id = id;
        this.jqlValue = jqlValue;
    }
}
$67a90fc752dffcfd$var$_BinaryStatusCategory = $67a90fc752dffcfd$export$bea22cefe0b3447c;
$67a90fc752dffcfd$export$bea22cefe0b3447c.OPEN = new $67a90fc752dffcfd$var$_BinaryStatusCategory('open', '"undefined", "In Progress", "To Do"');
$67a90fc752dffcfd$export$bea22cefe0b3447c.DONE = new $67a90fc752dffcfd$var$_BinaryStatusCategory('done', '"Done"');
const $67a90fc752dffcfd$export$b5d1c2ef6aead4e6 = [
    {
        title: (0, $bF0iL.messages).binary_status_category_filter_option_open,
        id: $67a90fc752dffcfd$export$bea22cefe0b3447c.OPEN.id,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).STATIC
    },
    {
        title: (0, $bF0iL.messages).binary_status_category_filter_option_done,
        id: $67a90fc752dffcfd$export$bea22cefe0b3447c.DONE.id,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).STATIC
    }
];
const $67a90fc752dffcfd$export$973ca22476b0e05f = (defaultFilters = [])=>{
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFilters);
    const addFilters = (0, $42omo.useCallback)((newFilters)=>dispatch((0, $jnLgC.addFilters)(newFilters, (a, b)=>{
            if (a.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER) return -1;
            if (a.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER) return 1;
            return 0;
        })), [
        dispatch
    ]);
    const updateFilter = (0, $42omo.useCallback)((id, isChecked)=>dispatch((0, $jnLgC.updateFilterState)(id, isChecked, true)), [
        dispatch
    ]);
    const clearFilter = (0, $42omo.useCallback)(()=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, false)));
    }, [
        filters,
        dispatch
    ]);
    const resetFilter = (0, $42omo.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters));
    }, [
        defaultFilters,
        dispatch
    ]);
    return {
        availableFilters: filters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch
    };
};
const $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE = {
    availableFilters: [],
    addFilters: ()=>{},
    updateFilter: ()=>{},
    clearFilter: ()=>{},
    reset: ()=>{},
    dispatch: ()=>{}
};
const $67a90fc752dffcfd$var$FilterContext = /*#__PURE__*/ (0, $42omo.createContext)({
    projectFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    assigneeFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    siteFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    binaryStatusCategoryFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    dateFilterFrom: {
        value: '',
        setValue: (_value)=>null
    },
    dateFilterTo: {
        value: '',
        setValue: (_value)=>null
    }
});
function $67a90fc752dffcfd$export$5e1edcb3c154ab79(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $67a90fc752dffcfd$var$transformDateFiltersForAnalytics = (dateFilterFrom)=>{
    const availiableFilters = $67a90fc752dffcfd$export$40e7ffc2d13a061c.map((experiment)=>experiment.days).map((days)=>[
            days,
            (0, $dae70913057c5350$export$e4a4d5c1140c233a)(days)
        ]);
    const appliedFilter = availiableFilters.filter(([_, date])=>date === dateFilterFrom).map(([days, _])=>({
            id: days
        }));
    return {
        applied: appliedFilter.map(({ id: id })=>({
                id: id,
                source: (0, $169DF.FilterOptionSource).STATIC
            })),
        recommendedIds: availiableFilters.map(([days, _])=>({
                id: days,
                source: (0, $169DF.FilterOptionSource).STATIC
            }))
    };
};
const $67a90fc752dffcfd$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultProjectFilters: defaultProjectFilters, defaultAssigneeFilters: defaultAssigneeFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
    const previousEnabledState = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(isEnabled);
    const [dateFilterFrom, setDateFilterFrom] = (0, $42omo.useState)('');
    const [dateFilterTo, setDateFilterTo] = (0, $42omo.useState)('');
    const projectFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultProjectFilters);
    const assigneeFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultAssigneeFilters);
    const siteFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultSiteFilters);
    const binaryStatusCategoryFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f($67a90fc752dffcfd$export$b5d1c2ef6aead4e6);
    const filtersAnalyticsContext = projectFilterStore.availableFilters.length === 0 && assigneeFilterStore.availableFilters.length === 0 ? {} : {
        projects: $67a90fc752dffcfd$export$5e1edcb3c154ab79(projectFilterStore.availableFilters),
        assignees: $67a90fc752dffcfd$export$5e1edcb3c154ab79(assigneeFilterStore.availableFilters),
        binaryStatusCategories: $67a90fc752dffcfd$export$5e1edcb3c154ab79(binaryStatusCategoryFilterStore.availableFilters),
        dateFrom: $67a90fc752dffcfd$var$transformDateFiltersForAnalytics(dateFilterFrom)
    };
    // We reset the state when the component becomes disabled
    if (previousEnabledState.current && !isEnabled) {
        projectFilterStore.reset();
        assigneeFilterStore.reset();
        siteFilterStore.reset();
        binaryStatusCategoryFilterStore.clearFilter();
        setDateFilterFrom('');
        setDateFilterTo('');
    }
    previousEnabledState.current = isEnabled;
    return /*#__PURE__*/ (0, $l998X.jsx)($67a90fc752dffcfd$var$FilterContext.Provider, {
        value: {
            projectFilters: projectFilterStore,
            assigneeFilters: assigneeFilterStore,
            siteFilters: siteFilterStore,
            binaryStatusCategoryFilters: binaryStatusCategoryFilterStore,
            dateFilterFrom: {
                value: dateFilterFrom,
                setValue: setDateFilterFrom
            },
            dateFilterTo: {
                value: dateFilterTo,
                setValue: setDateFilterTo
            }
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext,
            children: children
        })
    });
};
const $67a90fc752dffcfd$export$396ef541d9951d45 = ()=>{
    const filterContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($67a90fc752dffcfd$var$FilterContext);
    return filterContext;
};










parcelRequire("42omo");


var $eSS4z = parcelRequire("eSS4z");



















var $1e2E5 = parcelRequire("1e2E5");


var $1E3Hv = parcelRequire("1E3Hv");

const $670fab1500b9ac87$export$507533edf8f43d4e = [
    'en',
    'en-US',
    'en-GB'
];






























async function $670fab1500b9ac87$var$getMessages(locale) {
    let messages;
    switch(locale){
        case 'cs':
            messages = (parcelRequire("gI0He"));
            break;
        case 'da':
            messages = (parcelRequire("9xDFS"));
            break;
        case 'de':
            messages = (parcelRequire("17Noe"));
            break;
        case 'en':
            messages = Promise.resolve((parcelRequire("1E3Hv")));
            break;
        case 'en_GB':
            messages = (parcelRequire("3R53Q"));
            break;
        case 'en_ZZ':
            messages = (parcelRequire("7RIcW"));
            break;
        case 'es':
            messages = (parcelRequire("9nBQQ"));
            break;
        case 'et':
            messages = (parcelRequire("jZRxI"));
            break;
        case 'fi':
            messages = (parcelRequire("e2Bgo"));
            break;
        case 'fr':
            messages = (parcelRequire("i4KAI"));
            break;
        case 'hu':
            messages = (parcelRequire("8nPWu"));
            break;
        case 'is':
            messages = (parcelRequire("fbhPR"));
            break;
        case 'it':
            messages = (parcelRequire("bxxnU"));
            break;
        case 'ja':
            messages = (parcelRequire("jCna3"));
            break;
        case 'ko':
            messages = (parcelRequire("hXwJC"));
            break;
        case 'nb':
            messages = (parcelRequire("fYJCf"));
            break;
        case 'nl':
            messages = (parcelRequire("bG90O"));
            break;
        case 'pl':
            messages = (parcelRequire("edTRh"));
            break;
        case 'pt_BR':
            messages = (parcelRequire("b7MN8"));
            break;
        case 'pt_PT':
            messages = (parcelRequire("3JZ3A"));
            break;
        case 'ro':
            messages = (parcelRequire("hG7Tu"));
            break;
        case 'ru':
            messages = (parcelRequire("dpTtT"));
            break;
        case 'sk':
            messages = (parcelRequire("l5BOg"));
            break;
        case 'sv':
            messages = (parcelRequire("ev7pl"));
            break;
        case 'th':
            messages = (parcelRequire("d4I9K"));
            break;
        case 'tr':
            messages = (parcelRequire("gldMm"));
            break;
        case 'uk':
            messages = (parcelRequire("a4pmT"));
            break;
        case 'vi':
            messages = (parcelRequire("82Ppc"));
            break;
        case 'zh':
            messages = (parcelRequire("8d361"));
            break;
        case 'zh_TW':
            messages = (parcelRequire("dY6k3"));
            break;
        default:
            throw new Error('Unknown locale: ' + locale);
    }
    return (await messages).default;
}
const $670fab1500b9ac87$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        return await $670fab1500b9ac87$var$getMessages(locale);
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        return await $670fab1500b9ac87$var$getMessages(parentLocale);
    } catch (e) {
    // ignore
    }
    return 0, $1E3Hv.default;
};





class $9c5b4abe555f149c$var$MessagesIntlProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
            messages: this.state.messages,
            locale: this.props.intl.locale,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.fetchLocale = ()=>{
            (0, $670fab1500b9ac87$export$d0a3169680473b6c)(this.props.intl.locale).then((messages)=>this.setState({
                    messages: messages
                }));
        };
        this.state = {
            messages: (0, $670fab1500b9ac87$export$507533edf8f43d4e).indexOf(props.intl.locale) !== -1 ? (0, $1E3Hv.default) : undefined
        };
        this.fetchLocale();
    }
}
const $9c5b4abe555f149c$var$MessagesIntlProviderWithIntl = (0, $gmMgo.default)($9c5b4abe555f149c$var$MessagesIntlProvider);
var $9c5b4abe555f149c$export$2e2bcd8739ae039 = $9c5b4abe555f149c$var$MessagesIntlProviderWithIntl;





parcelRequire("42omo");





var $2GmtI = parcelRequire("2GmtI");

const $79b726b1281ccb40$export$7095b8205ce661b6 = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
        analyticContext: {
            frontend: (0, $2GmtI.BUILD_VERSION)
        },
        nonPrivacySafeAnalyticContext: {},
        children: children
    });




















var $95fbe0eb5eb00d19$export$2e2bcd8739ae039 = ()=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'operational',
            action: 'exposed',
            actionSubject: 'quickSearchExperiment',
            source: 'searchDialog'
        });
    // We keep the searchSessionId here because we want a new experiment exposure event every new session
    }, [
        fireAnalyticsEvent,
        searchSessionId
    ]);
    return null;
};











class $2910c33607471958$export$b768cbf5d904a94a extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        const { onDialogClosed: onDialogClosed, isExpanded: isExpanded, activeProduct: activeProduct } = this.props;
        if (prevProps.isExpanded && !isExpanded) onDialogClosed(activeProduct);
    }
    render() {
        return null;
    }
}
const $2910c33607471958$export$50483e15753411d8 = (0, $lnXRc.withAnalytics)({
    onDialogClosed: (0, $5dFS9.onDismissed)
})($2910c33607471958$export$b768cbf5d904a94a);



















const $c422feafa0c6ebb6$export$c658105a3bdf0409 = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const [isFetched, setIsFetched] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (query && isFetched === false && isExpanded) {
            (parcelRequire("1ICWL"));
            (parcelRequire("4Scw6"));
            setIsFetched(true);
        }
    }, [
        query,
        isFetched,
        setIsFetched,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
};






var $hKdD9 = parcelRequire("hKdD9");



















const $5fa054eff2cb0a5a$export$18e8dcaf0a5a46b2 = ({ isExpanded: isExpanded, onDialogShown: onDialogShown, activeProduct: activeProduct })=>{
    const { products: products, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const isRovoCrossProductSearchLinkShown = (0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    (0, $42omo.useEffect)(()=>{
        const emitAnalyticsEvent = ()=>{
            const visibleProducts = products.map((product)=>product.title);
            const visibleTabsCount = visibleProducts.length > 1 ? products.length : 0;
            onDialogShown({
                visibleProducts: visibleProducts,
                visibleTabsCount: visibleTabsCount,
                isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown,
                activeProduct: activeProduct
            });
        };
        isExpanded && emitAnalyticsEvent();
    }, [
        isExpanded
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
};
const $5fa054eff2cb0a5a$export$914029055eb3fe8e = (0, $lnXRc.withAnalytics)({
    onDialogShown: (0, $5dFS9.onShown)
})($5fa054eff2cb0a5a$export$18e8dcaf0a5a46b2);



var $amrMu = parcelRequire("amrMu");




parcelRequire("42omo");




const $f9a704b413e9ca44$export$bf21b659e40e8eb4 = ({ children: children, isQuickFind: isQuickFind = false })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
        analyticContext: {
            isQuickFind: isQuickFind
        },
        nonPrivacySafeAnalyticContext: {},
        children: children
    });



var $aDRXf = parcelRequire("aDRXf");


var $cGCOz = parcelRequire("cGCOz");


var $4wMwH = parcelRequire("4wMwH");

const $a995c577a9050532$export$3d88e5d350ac07d9 = ({ children: children, theme: theme, setIsExpanded: setIsExpanded, isExpanded: isExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, clientProviderFeatures: clientProviderFeatures, user: user, orgId: orgId, dialogFeatures: dialogFeatures, primaryProduct: primaryProduct, forwardRef: forwardRef, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4wMwH.QueryParamsProvider), {
        queryParams: queryParams,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $amrMu.FeaturesProvider), {
            dialogFeatures: dialogFeatures,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iEwUU.UserProvider), {
                user: user,
                orgId: orgId,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cGCOz.RovoContextProvider), {
                    isEnabled: isRovoEnabled,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9c5b4abe555f149c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f9a704b413e9ca44$export$bf21b659e40e8eb4), {
                            isQuickFind: dialogFeatures?.quickFind?.enabled,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $79b726b1281ccb40$export$7095b8205ce661b6), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eSS4z.ThemeProvider), {
                                    partialSearchCSS: theme,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gF7Az.DialogExpansionContextProvider), {
                                        isExpanded: isExpanded,
                                        setIsExpanded: setIsExpanded,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fJRVo.ProductRouter), {
                                            primaryProduct: primaryProduct,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kmpep.AggregatorClientContextProvider), {
                                                abTestCloudId: abTestCloudId,
                                                aggregatorUrl: aggregatorUrl,
                                                features: clientProviderFeatures,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gRazf.ABTestContextProvider), {
                                                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4ldrV.SearchSessionProvider), {
                                                        sessionKey: `ssid_provider_${isExpanded}`,
                                                        children: [
                                                            isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, $95fbe0eb5eb00d19$export$2e2bcd8739ae039), {}) : null,
                                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2ZIpG.QueryContextProvider), {
                                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgH2x.FilterContextHOC), {
                                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hKdD9.AutocorrectionProvider), {
                                                                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $aDRXf.InputContext), {
                                                                            forwardRef: forwardRef,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $c422feafa0c6ebb6$export$c658105a3bdf0409), {}),
                                                                                /*#__PURE__*/ (0, $l998X.jsx)($a995c577a9050532$var$DialogDismissedAndShownHandler, {
                                                                                    isExpanded: isExpanded
                                                                                }),
                                                                                children
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
const $a995c577a9050532$var$DialogDismissedAndShownHandler = ({ isExpanded: isExpanded })=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2910c33607471958$export$50483e15753411d8), {
                isExpanded: isExpanded,
                activeProduct: activeProduct?.id ?? ''
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5fa054eff2cb0a5a$export$914029055eb3fe8e), {
                isExpanded: isExpanded,
                activeProduct: activeProduct?.id ?? ''
            })
        ]
    });
};



var $7qNFx = parcelRequire("7qNFx");













parcelRequire("42omo");


var $kHWmv = parcelRequire("kHWmv");

const $811464270192717d$export$774d556eae0f6945 = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kHWmv.EnlargedSearchAnchorWrapper), {
        isExpanded: isExpanded,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHWmv.AbsoluteContainer), {
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHWmv.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });




var $59aAc = parcelRequire("59aAc");




/**
 * Helper util class to merge a forward and callback ref.
 * The implementation to do this is not clean and so it's isolated here until React has a better solution.
 */ const $0ffb284ad494cbe0$var$callRef = (callbackOrForwardRef, ref)=>{
    if (!callbackOrForwardRef) return;
    if (typeof callbackOrForwardRef === 'function') callbackOrForwardRef(ref);
    else if (typeof callbackOrForwardRef === 'object' && Object.prototype.hasOwnProperty.call(callbackOrForwardRef, 'current')) // `#current` is technically read only, but we will force an assignment here.
    /* eslint-disable-next-line no-param-reassign */ callbackOrForwardRef.current = ref;
    else // This should never happen
    throw new Error('unsupported ref format, currently only callback and forward refs are supported');
};
const $0ffb284ad494cbe0$export$bf39ce724f6cc9e5 = (...refs)=>{
    return (ref)=>{
        refs.forEach((r)=>$0ffb284ad494cbe0$var$callRef(r, ref));
    };
};






var $4TXTZ = parcelRequire("4TXTZ");

class $59d6c08dd81e927a$export$bb50437fb01e8bb5 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isExpanded: isExpanded, isQuickFind: isQuickFind, shouldFillContainer: shouldFillContainer, children: children } = this.props;
        const SearchAnchorComponent = isQuickFind ? (0, $811464270192717d$export$774d556eae0f6945) : (0, $59aAc.SearchAnchor);
        return /*#__PURE__*/ (0, $l998X.jsx)(SearchAnchorComponent, {
            onBlur: this.onBlurHandler,
            onFocus: this.onFocusHandler,
            onKeyDown: this.handleKeyDown,
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $icqFF.KeyboardHighlightProvider), {
                listenerNode: this.state.ref,
                children: children ? children(this.setRef) : null
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ref: null
        };
        /**
     * Hold a timeout id for the onBlur and onFocus handlers
     */ this.timeout = undefined;
        this.handleKeyDown = (event)=>{
            if (event.key === 'Escape' && !event.defaultPrevented && this.props.isExpanded) {
                (0, $4TXTZ.default)('quick-search-close', performance.now());
                event.preventDefault();
                this.close();
            }
        };
        this.onBlurHandler = ()=>{
            (0, $4TXTZ.default)('quick-search-close', performance.now());
            this.timeout = window.setTimeout(()=>{
                this.close();
            });
        };
        this.onFocusHandler = ()=>{
            window.clearTimeout(this.timeout);
        };
        this.setRef = (ref)=>{
            if (this.state.ref !== ref) this.setState({
                ref: ref
            });
        };
        this.close = ()=>{
            const { ref: ref } = this.state;
            ref && ref.blur();
            this.props.onClose();
        };
    }
}
const $59d6c08dd81e927a$export$8ee2389f89cfdd2f = ({ children: children, keepExpandedInTab: keepExpandedInTab = false, forwardRef: forwardRef, shouldFillContainer: shouldFillContainer, ...rest })=>{
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded, allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const inputRef = (0, $42omo.useRef)(null);
    const mergedForwardref = (0, $0ffb284ad494cbe0$export$bf39ce724f6cc9e5)(inputRef, forwardRef);
    const isQuickFind = (0, $amrMu.useFeaturesContext)().quickFind?.enabled;
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    const onTabChange = (0, $42omo.useCallback)(()=>{
        if (document.hidden) allowChangeExpand(false);
        else {
            if (isExpanded) inputRef?.current?.focus?.();
            allowChangeExpand(true);
        }
    }, [
        allowChangeExpand,
        isExpanded
    ]);
    (0, $42omo.useEffect)(()=>{
        if (keepExpandedInTab) {
            document.addEventListener('visibilitychange', onTabChange);
            return ()=>{
                document.removeEventListener('visibilitychange', onTabChange);
            };
        }
    }, [
        onTabChange,
        keepExpandedInTab
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($59d6c08dd81e927a$export$bb50437fb01e8bb5, {
        ...rest,
        shouldFillContainer: shouldFillContainer,
        onClose: onClose,
        isExpanded: isExpanded,
        isQuickFind: isQuickFind,
        children: (setRef)=>{
            const ref = (0, $0ffb284ad494cbe0$export$bf39ce724f6cc9e5)(setRef, mergedForwardref);
            const onRetry = ()=>{
                inputRef?.current?.focus?.();
            };
            return children({
                ref: ref,
                onRetry: onRetry
            });
        }
    });
};















var $1pSma = parcelRequire("1pSma");














/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 


/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */ 









var $fwSxy = parcelRequire("fwSxy");





var $iSHbD = parcelRequire("iSHbD");


var $1qfLF = parcelRequire("1qfLF");


var $fG2rA = parcelRequire("fG2rA");


var $1jolb = parcelRequire("1jolb");

const $6ea4f392138dd417$var$MAX_INPUT_LENGTH = 500;
const $6ea4f392138dd417$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $eSS4z.useTheme)();
    const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer, placeholder: nonFeaturesPlaceholder, ariaLabel: ariaLabel, dataSsrPlaceholder: dataSsrPlaceholder } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
    if (enabled || (0, $fG2rA.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1jolb.SSRsearchInput), {
        shouldFillContainer: shouldFillContainer,
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder || nonFeaturesPlaceholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kHWmv.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        "data-ssr-placeholder": dataSsrPlaceholder,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwSxy.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: false,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.MobileSearchIconWrapper), {
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                theme: theme,
                                isExpanded: false
                            })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                        theme: theme,
                        isExpanded: false
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SearchInputField), {
                    "data-test-id": "search-dialog-search-skeleton",
                    isExpanded: false,
                    placeholder: nonFeaturesPlaceholder || placeholder,
                    ref: forwardRef || undefined,
                    disabled: true,
                    value: "",
                    maxLength: $6ea4f392138dd417$var$MAX_INPUT_LENGTH,
                    onChange: ()=>{},
                    "aria-label": ariaLabel || nonFeaturesPlaceholder || placeholder,
                    ...theme
                })
            ]
        })
    });
};
var $6ea4f392138dd417$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)($6ea4f392138dd417$export$9b2f977cfc67f251, {
        ...props,
        forwardRef: ref
    }));




parcelRequire("42omo");

const $40910eaaf86d577d$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, $l998X.jsx)((0, $eSS4z.ThemeProvider), {
        partialSearchCSS: theme,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6ea4f392138dd417$export$2e2bcd8739ae039), {
            ...rest
        })
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $6ea4f392138dd417$export$2e2bcd8739ae039), {
        ...rest
    });
};



var $boBbB = parcelRequire("boBbB");























var $bPdpL = parcelRequire("bPdpL");













// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");










const $b971e56a6791576d$export$3324ef4e3e3970dc = /*#__PURE__*/ (0, $cStGJ.default)((0, $fwSxy.DesktopSearchIconWrapper), {
    target: "e4mn9mz2"
})("width:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).half().px : (0, $2azjJ.grid).multiple(2).px, ";height:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).half().px : (0, $2azjJ.grid).multiple(2).px, ";top:", (props)=>props.isExpanded ? (0, $2azjJ.grid).multiple(1.5).px : (0, $2azjJ.grid).px, ";left:", (props)=>props.isExpanded ? (0, $2azjJ.grid).multiple(2).px : (0, $2azjJ.grid).px, ";display:flex;align-items:center;");
const $b971e56a6791576d$export$68bd88880d49fc5 = /*#__PURE__*/ (0, $cStGJ.default)((0, $fwSxy.ClearIconWrapper), {
    target: "e4mn9mz1"
})("width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);padding-top:0;padding-bottom:0;padding-left:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-150, 12px)"}` : '0', ";padding-right:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-200, 16px)"}` : '2px', ";color:", `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`, ";");
const $b971e56a6791576d$export$aa34c63c6bd8fcb0 = /*#__PURE__*/ (0, $cStGJ.default)((0, $fwSxy.SearchInputField), {
    target: "e4mn9mz0"
})("display:flex;align-items:center;height:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).px : (0, $2azjJ.inputFieldHeight).px, ";border-radius:", (props)=>props.isExpanded ? '8px' : '5px', ";padding:", (props)=>props.isExpanded ? `${"var(--ds-space-150, 12px)"} 52px ${"var(--ds-space-150, 12px)"} 52px` : `0px ${"var(--ds-space-300, 24px)"} 0px 30px`, ";:focus{border:none;box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, $2azjJ.grid).multiple(0.5).px + ' ' + (0, $2azjJ.grid).px + ' ' + (0, $6fnsQ.N50A) + ', 0 0 1px ' + (0, $6fnsQ.N60A)})`, ";}");





parcelRequire("42omo");





var $hmuev = parcelRequire("hmuev");


const $9d7751af5f629de9$export$cfdb69c9b0b1fec = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, isExpanded: isExpanded })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.InputBoxOverlayRight), {
        children: showClearButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $b971e56a6791576d$export$68bd88880d49fc5), {
            ...theme,
            role: "button",
            onClick: onClear,
            onMouseEnter: ()=>{
                allowChangeExpand?.(false);
            },
            onMouseLeave: ()=>{
                allowChangeExpand?.(true);
            },
            tabIndex: 0,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                color: "currentColor",
                label: clearSearchLabel || 'Clear search session',
                spacing: "spacious"
            })
        })
    });
};





const $701d0a94d5d1fefc$var$MAX_INPUT_LENGTH = 500;
const $701d0a94d5d1fefc$export$33e4ffe00576d3b4 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, shouldFillContainer: shouldFillContainer, onSelect: onSelect, ariaLabelContent: ariaLabelContent })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $fwSxy.HiddenTooltip);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwSxy.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        onClick: handleClick,
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded
                            })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $b971e56a6791576d$export$3324ef4e3e3970dc), {
                    ...theme,
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded,
                        primaryColor: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                        label: exitSearchLabel || 'Exit Search',
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $b971e56a6791576d$export$aa34c63c6bd8fcb0), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $701d0a94d5d1fefc$var$MAX_INPUT_LENGTH,
                    "aria-label": ariaLabelContent || placeholder,
                    ...theme
                }),
                showClearButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $9d7751af5f629de9$export$cfdb69c9b0b1fec), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    isExpanded: isExpanded
                })
            ]
        })
    });
};
var $701d0a94d5d1fefc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const theme = (0, $eSS4z.useTheme)();
    return /*#__PURE__*/ (0, $l998X.jsx)($701d0a94d5d1fefc$export$33e4ffe00576d3b4, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});




var $epS7s = parcelRequire("epS7s");

var $1IGQP = parcelRequire("1IGQP");










// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






function $be76b25cc1b2639d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $be76b25cc1b2639d$export$e2deb14b255cffa0 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e19ugnpx1"
})({
    name: "1buofu5",
    styles: "display:flex;line-height:16px;align-items:center;padding-bottom:var(--ds-space-025, 2px);padding-top:var(--ds-space-025, 2px)"
});
const $be76b25cc1b2639d$export$47a1bf8d9994c680 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e19ugnpx0"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N400)})`,
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-text-inverse, ${(0, $6fnsQ.N400)})`}`,
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    marginLeft: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});















var $jSnXV = parcelRequire("jSnXV");

class $b3576e5ec930ddc0$export$6cdeb9eeefdb65f3 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        const { query: query } = this.props;
        if (prevProps.query !== query) /**
       * Earlier this component was child of [confluence|jira]-search-dialog which ensured that this got fired after the debounced search.
       * Now it will get moved to the wrapper component which will bring this at the same level as [confluence|jira]-search-dialog.
       * This leads to the event handler getting fired in the same tick before the debounced search.
       * Hence, forceful execution in the next tick.
       */ setTimeout(()=>this.textEntered());
    }
    componentWillUnmount() {
        this.textEntered.cancel();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.textEntered = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            const { textEntered: textEntered, activeProduct: activeProduct } = this.props;
            textEntered(activeProduct);
        }, this.props.debounceTime || 0);
    }
}
var $b3576e5ec930ddc0$export$2e2bcd8739ae039 = (0, $lnXRc.withAnalytics)({
    textEntered: (0, $5dFS9.onTextEntered)
})($b3576e5ec930ddc0$export$6cdeb9eeefdb65f3);




























var $20N1w = parcelRequire("20N1w");



















var $7a3bb0801b8c1429$export$8b40788ab131f69a = /*#__PURE__*/ function(CrossProductScope) {
    CrossProductScope["RECENTS"] = "rovo-cross-product.recents";
    CrossProductScope["RESULTS"] = "rovo-cross-product.results";
    return CrossProductScope;
}({});





const $644bc14e6914d1ea$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    cross_product_tab_label: {
        id: "product_search_dialog.cross_product.tab_label",
        defaultMessage: "All"
    },
    cross_product_expanded_input_placeholder: {
        id: "product_search_dialog.cross_product.expanded.input-placeholder",
        defaultMessage: "Search All"
    },
    cross_product_recents_section_heading: {
        id: "product_search_dialog.cross_product.recents.section_heading",
        defaultMessage: "Recently viewed"
    },
    cross_product_results_section_heading: {
        id: "product_search_dialog.cross_product.results.section_heading",
        defaultMessage: "Search results"
    },
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    cross_product_empty_state_body: {
        id: "product_search_dialog.cross_product.empty.no_results_body",
        defaultMessage: "<a>Search all content across your organization</a> or try a different term."
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Work item"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});






var $ja8yA = parcelRequire("ja8yA");




parcelRequire("42omo");







var $hWR4v = parcelRequire("hWR4v");

var $6h3V2 = parcelRequire("6h3V2");


var $icWhS = parcelRequire("icWhS");

var $lNtmT = parcelRequire("lNtmT");





parcelRequire("42omo");


var $4Nwes = parcelRequire("4Nwes");




var $buthI = parcelRequire("buthI");




parcelRequire("42omo");

const $cfe74c44e346a556$var$AdobeXDIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-635.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.5802 7.40457L9.75898 12.1789L12.7683 17.2427C12.7871 17.2812 12.7965 17.3198 12.7871 17.3584C12.7777 17.397 12.7401 17.368 12.6836 17.3777H10.5301C10.3796 17.3777 10.2762 17.368 10.2104 17.2716C10.0129 16.8665 9.806 16.471 9.60851 16.0659C9.41103 15.6705 9.19473 15.2654 8.96903 14.8507C8.74334 14.4359 8.51764 14.0212 8.29194 13.5968H8.27313C8.07565 14.0115 7.85935 14.4263 7.64306 14.841C7.42677 15.2558 7.21047 15.6705 7.00359 16.0756C6.78729 16.4807 6.571 16.8954 6.3547 17.2909C6.31709 17.3873 6.24186 17.397 6.13841 17.397H4.06952C4.0319 17.397 4.00369 17.4163 4.00369 17.368C3.99429 17.3295 4.00369 17.2909 4.0225 17.262L6.94716 12.3429L4.09773 7.39492C4.06952 7.35634 4.06011 7.31776 4.07892 7.29847C4.09773 7.26953 4.13535 7.25989 4.17296 7.25989H6.30768C6.3547 7.25989 6.40173 7.26953 6.43934 7.27918C6.47696 7.29847 6.50517 7.3274 6.53338 7.36598C6.71206 7.78073 6.91895 8.19547 7.13524 8.61021C7.36094 9.02496 7.57723 9.43006 7.81233 9.83515C8.03803 10.2403 8.24492 10.6453 8.44241 11.0601H8.46122C8.6587 10.6357 8.86559 10.221 9.07248 9.81586C9.27937 9.41077 9.49566 9.00567 9.71196 8.60057C9.92825 8.19547 10.1351 7.78073 10.342 7.38528C10.3514 7.34669 10.3702 7.30811 10.3985 7.28882C10.4361 7.26953 10.4737 7.25989 10.5207 7.26953H12.505C12.552 7.25989 12.599 7.28882 12.6084 7.33705C12.6178 7.34669 12.599 7.38528 12.5802 7.40457Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.9248 17.5803C16.2289 17.5899 15.533 17.4453 14.9029 17.1463C14.3105 16.8666 13.8215 16.4036 13.4829 15.8345C13.135 15.2462 12.9657 14.5131 12.9657 13.6354C12.9563 12.9217 13.135 12.2176 13.4829 11.6003C13.8403 10.9733 14.3575 10.4525 14.9782 10.1053C15.6364 9.72911 16.4264 9.54585 17.3574 9.54585C17.4044 9.54585 17.4702 9.54585 17.5549 9.5555C17.711 9.5733 17.8464 9.43978 17.8464 9.28259V6.52691C17.8464 6.45939 17.8746 6.42081 17.9404 6.42081H19.791C19.8299 6.42081 19.873 6.41051 19.9052 6.43245C19.9189 6.44186 19.9299 6.45544 19.937 6.4702C19.9425 6.48177 19.9435 6.50762 19.9435 6.50762C19.9435 6.50762 19.9435 6.50762 19.9435 6.50762V15.6898C19.9435 15.8635 19.9529 16.0564 19.9623 16.2686C19.9811 16.4711 19.9905 16.664 19.9999 16.828C19.9999 16.8955 19.9717 16.9534 19.9059 16.9823C19.4169 17.1945 18.8996 17.3488 18.373 17.4453C17.8934 17.5321 17.4138 17.5803 16.9248 17.5803ZM17.5438 15.7015C17.7293 15.7077 17.8464 15.5265 17.8464 15.3409V11.666C17.8464 11.5147 17.7428 11.3763 17.5925 11.3591C17.489 11.3495 17.3856 11.3399 17.2821 11.3399C16.9154 11.3399 16.5486 11.417 16.2195 11.5906C15.8998 11.7546 15.627 11.9957 15.4201 12.3044C15.2133 12.613 15.1098 13.0278 15.1098 13.5293C15.1004 13.8669 15.1568 14.2045 15.2697 14.5228C15.3637 14.7832 15.5048 15.0147 15.6929 15.2076C15.8715 15.3812 16.0878 15.5162 16.3323 15.5934C16.5862 15.6802 16.8496 15.7188 17.1129 15.7188C17.2409 15.7188 17.3612 15.7108 17.4737 15.7022C17.4964 15.7004 17.521 15.7007 17.5438 15.7015Z",
                fill: "#FF61F6"
            })
        ]
    });
};
var $cfe74c44e346a556$export$2e2bcd8739ae039 = $cfe74c44e346a556$var$AdobeXDIcon;





parcelRequire("42omo");

const $5694a8281bd37d8b$var$AdobeSignIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-19.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
                fill: "white"
            })
        ]
    });
};
var $5694a8281bd37d8b$export$2e2bcd8739ae039 = $5694a8281bd37d8b$var$AdobeSignIcon;





parcelRequire("42omo");

const $2925c70e149e0de5$var$AhaIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-635.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M13.5114 14.3589C13.4961 13.9874 13.4858 13.6157 13.4829 13.2439C13.4806 12.9476 13.4822 12.6512 13.4798 12.3549C13.4779 12.1238 13.4776 11.8926 13.4483 11.6628C13.4314 11.5303 13.4041 11.4003 13.3459 11.2789C13.2429 11.0639 13.0729 10.9187 12.8595 10.8216C12.562 10.6863 12.2524 10.6769 11.9374 10.742C11.6833 10.7945 11.4482 10.8957 11.2248 11.0259C11.1582 11.0647 11.0935 11.1066 11.0248 11.1522C11.0248 11.139 11.0248 11.1317 11.0248 11.1242C11.024 10.9117 11.0232 10.6993 11.0223 10.4868C11.0205 10.0525 11.0181 9.61825 11.0083 9.18407C11.0075 9.14589 11.0068 9.1076 11.003 9.06965C10.9985 9.02436 10.9605 8.99346 10.9209 9.00118C10.7482 9.03488 10.5756 9.06898 10.403 9.10296C10.182 9.14651 9.96017 9.18597 9.73703 9.21771C9.63006 9.23294 9.52302 9.24761 9.41605 9.26266C9.40776 9.26384 9.39813 9.26496 9.39433 9.27313C9.38968 9.28299 9.39892 9.28864 9.4053 9.29306C9.41476 9.29956 9.4137 9.30885 9.41498 9.31786C9.43737 9.47365 9.45467 9.63006 9.46883 9.7868C9.49083 10.0299 9.5041 10.2737 9.51339 10.5176C9.52722 10.8799 9.53366 11.2423 9.53607 11.6048C9.54323 12.6756 9.53573 13.7464 9.52577 14.8172C9.52515 14.8822 9.54228 14.8991 9.60722 14.8982C9.9839 14.8933 10.3605 14.8882 10.7372 14.8834C10.8454 14.882 10.9536 14.8819 11.0617 14.88C11.1067 14.8793 11.1419 14.8617 11.1375 14.803C11.1263 14.6534 11.1212 14.5034 11.1135 14.3536C11.0966 14.0279 11.0824 13.7021 11.0754 13.376C11.0725 13.24 11.0686 13.104 11.0675 12.968C11.065 12.6502 11.064 12.3324 11.0619 12.0146C11.0618 12.0001 11.0668 11.9933 11.0802 11.9881C11.1314 11.9683 11.1821 11.9472 11.233 11.9266C11.3449 11.8813 11.4598 11.8553 11.582 11.8677C11.6869 11.8784 11.7678 11.9237 11.8182 12.0183C11.8354 12.0504 11.8491 12.0839 11.8596 12.1188C11.9079 12.2798 11.9208 12.4461 11.9309 12.6124C11.9449 12.8432 11.9481 13.0743 11.9491 13.3054C11.9514 13.8152 11.9454 14.3249 11.943 14.8346C11.9427 14.8967 11.9627 14.9166 12.025 14.9164C12.2432 14.9154 12.4613 14.9063 12.6794 14.9013C12.7968 14.8986 12.9143 14.8968 13.0318 14.9015C13.1743 14.9071 13.3167 14.9164 13.4594 14.9164C13.5133 14.9164 13.5378 14.89 13.5351 14.8365C13.527 14.6775 13.5179 14.5184 13.5113 14.3592L13.5114 14.3589Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.9366 9.01969C19.8949 9.01381 19.8552 9.02663 19.8151 9.03307C19.5797 9.07063 19.3445 9.10948 19.1092 9.14766C18.8849 9.18405 18.6607 9.22071 18.4363 9.25626C18.3593 9.26846 18.3278 9.30709 18.335 9.3844C18.3477 9.52166 18.3605 9.65887 18.372 9.79624C18.3901 10.0134 18.4071 10.2308 18.4246 10.448C18.4441 10.6912 18.4592 10.9349 18.473 11.1785C18.4862 11.4092 18.4974 11.64 18.5087 11.8708C18.5253 12.2067 18.5413 12.5427 18.5572 12.8786C18.5601 12.9403 18.5901 12.9699 18.6524 12.9689C18.8259 12.966 18.9992 12.9627 19.1727 12.9596C19.1727 12.959 19.1727 12.9585 19.1727 12.9579C19.2109 12.9579 19.2491 12.9584 19.2874 12.9578C19.4272 12.9557 19.567 12.9535 19.7069 12.9509C19.7598 12.9499 19.7931 12.9184 19.7943 12.8695C19.7981 12.7158 19.8008 12.5621 19.8057 12.4084C19.8128 12.1849 19.8201 11.9614 19.8299 11.7379C19.8428 11.4466 19.8577 11.1554 19.8727 10.8642C19.8815 10.6958 19.8914 10.5274 19.9024 10.3592C19.9159 10.1537 19.9299 9.94834 19.9456 9.74312C19.9583 9.57691 19.9737 9.41088 19.9879 9.24479C19.9923 9.19379 19.9984 9.14279 20 9.09168C20.0016 9.04511 19.9823 9.02619 19.9366 9.01969H19.9366Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.8688 14.1793C19.8688 13.9604 19.8688 13.7414 19.8688 13.5225C19.8688 13.4553 19.8458 13.4339 19.7778 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3336 13.4735 19.0533 13.4827 18.7725 13.4746C18.6672 13.4715 18.562 13.4672 18.4571 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3715 13.5886 18.3713 13.6537 18.3731 13.7185C18.3774 13.8731 18.3778 14.0277 18.3757 14.1823C18.3727 14.4096 18.372 14.6369 18.3711 14.8643C18.3709 14.9132 18.3988 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.695 14.9194C18.9465 14.9041 19.198 14.9013 19.4498 14.9076C19.5653 14.9104 19.6808 14.9132 19.7964 14.9166C19.8276 14.9174 19.8511 14.9065 19.864 14.8775C19.8706 14.8627 19.8688 14.8464 19.8688 14.8306C19.8689 14.6135 19.8688 14.3964 19.8688 14.1793Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.07031 14.2687C8.61418 12.7687 8.15801 11.2688 7.70189 9.76881C7.63667 9.55441 7.57151 9.34 7.50612 9.1256C7.48597 9.05949 7.43526 9.0268 7.36791 9.03771C7.25763 9.05557 7.14763 9.07522 7.03735 9.09313C6.67802 9.15152 6.31852 9.20884 5.96031 9.274C5.86772 9.29085 5.80132 9.34224 5.77154 9.43248C5.18325 11.2134 4.59553 12.9943 4.00768 14.7753C3.98317 14.8496 4.01849 14.8982 4.09703 14.8982C4.53249 14.8982 4.96801 14.8982 5.40348 14.8983C5.42128 14.8983 5.43902 14.8983 5.45593 14.8922C5.47636 14.8849 5.49142 14.8721 5.49635 14.8498C5.51896 14.7472 5.54136 14.6445 5.56425 14.5419C5.6335 14.2314 5.70297 13.921 5.77233 13.6105C5.77546 13.5964 5.77815 13.5867 5.79847 13.587C6.27581 13.5939 6.7532 13.6 7.23054 13.6053C7.25254 13.6055 7.26054 13.6121 7.26508 13.633C7.3552 14.0446 7.446 14.456 7.53669 14.8675C7.54811 14.9193 7.56759 14.935 7.62116 14.9357C7.63141 14.9358 7.64165 14.9352 7.6519 14.9349C7.90072 14.9282 8.14961 14.9214 8.34341 14.9162C8.65494 14.9162 8.91138 14.9165 9.16782 14.9161C9.22923 14.916 9.25593 14.8791 9.2383 14.8211C9.18226 14.6369 9.12623 14.4528 9.07025 14.2686L9.07031 14.2687ZM7.00544 12.4829C6.70517 12.4823 6.4049 12.4822 6.10457 12.483C6.07881 12.4831 6.07909 12.4754 6.08486 12.4548C6.22089 11.9665 6.3497 11.4762 6.47397 10.9849C6.50952 10.8442 6.54289 10.703 6.57737 10.562C6.57866 10.5569 6.58056 10.5518 6.58465 10.5392C6.6816 10.937 6.76787 11.3295 6.85732 11.7211C6.91319 11.966 6.96978 12.2107 7.02739 12.4552C7.03299 12.479 7.02834 12.4829 7.0055 12.4828L7.00544 12.4829Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.6715 14.483C17.6508 14.1846 17.6368 13.8858 17.6337 13.5866C17.6292 13.1505 17.6392 12.7144 17.6459 12.2783C17.6489 12.0854 17.6451 11.8927 17.6116 11.7017C17.5626 11.4229 17.427 11.1973 17.2 11.0277C17.0326 10.9026 16.8409 10.8332 16.6391 10.7888C16.3129 10.7171 15.9826 10.7133 15.6513 10.735C15.4224 10.75 15.1954 10.7808 14.9697 10.822C14.7443 10.8632 14.5215 10.9154 14.3015 10.9796C14.2482 10.9951 14.2304 11.018 14.2279 11.0738C14.225 11.1361 14.2232 11.1986 14.2205 11.2609C14.2138 11.4201 14.2068 11.5793 14.2002 11.7385C14.1971 11.812 14.193 11.8856 14.1925 11.9591C14.192 12.0256 14.2482 12.0552 14.2961 12.0363C14.4737 11.9667 14.6519 11.899 14.8344 11.8434C15.1069 11.7603 15.3843 11.7096 15.6705 11.7156C15.765 11.7175 15.8584 11.726 15.9472 11.7617C16.0354 11.797 16.0909 11.8595 16.1043 11.9553C16.11 11.996 16.1065 12.0371 16.106 12.0781C16.1057 12.1005 16.0979 12.1097 16.0745 12.1129C15.9739 12.127 15.8735 12.1417 15.7735 12.1592C15.4704 12.2122 15.1722 12.2838 14.8841 12.3937C14.6487 12.4835 14.426 12.5963 14.2307 12.7575C14.0093 12.9403 13.8519 13.1654 13.7916 13.4492C13.733 13.7249 13.7543 13.9976 13.8446 14.2642C13.9131 14.4664 14.0269 14.6385 14.1966 14.7708C14.3761 14.9107 14.5826 14.976 14.8076 14.9892C14.8076 14.9907 14.8078 14.9922 14.808 14.9937H14.9647C14.9647 14.9921 14.9647 14.9906 14.9649 14.989C15.0468 14.9825 15.1278 14.9702 15.2076 14.9506C15.5361 14.87 15.8352 14.7248 16.1143 14.5361C16.1279 14.527 16.1412 14.5175 16.1583 14.5057V14.5414C16.1583 14.6448 16.1582 14.7483 16.1584 14.8517C16.1585 14.9143 16.1809 14.9365 16.2426 14.9356C16.3964 14.9334 16.5502 14.9309 16.7041 14.9288C17.0099 14.9245 17.3157 14.9204 17.6215 14.9161C17.6734 14.9154 17.696 14.8915 17.6952 14.8397C17.6951 14.8341 17.6948 14.8285 17.6945 14.823C17.6868 14.7095 17.6793 14.5962 17.6714 14.4828L17.6715 14.483ZM16.1219 13.3558C16.1219 13.4806 16.1214 13.6055 16.1224 13.7302C16.1226 13.7497 16.1161 13.76 16.0995 13.7695C15.9485 13.857 15.7891 13.9147 15.6115 13.9032C15.4004 13.8894 15.2482 13.7607 15.226 13.5542C15.2022 13.3329 15.2951 13.1667 15.5135 13.0711C15.6245 13.0225 15.7419 12.9981 15.861 12.9813C15.9384 12.9704 16.0164 12.9631 16.0939 12.9531C16.1155 12.9503 16.1227 12.9553 16.1224 12.9785C16.1213 13.1043 16.1219 13.2301 16.1219 13.3558Z",
                fill: "white"
            })
        ]
    });
};
var $2925c70e149e0de5$export$2e2bcd8739ae039 = $2925c70e149e0de5$var$AhaIcon;





parcelRequire("42omo");

const $5642884c1dd34cff$var$AirtableIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-635.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.1447 5.16889L5.17945 7.63723C4.84772 7.77451 4.85115 8.24569 5.18496 8.37801L11.1751 10.7535C11.7015 10.9622 12.2876 10.9622 12.8139 10.7535L18.8042 8.37801C19.1379 8.24569 19.1414 7.77451 18.8096 7.63723L12.8445 5.16889C12.3002 4.9437 11.6888 4.9437 11.1447 5.16889Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.5259 12.0506V17.9848C12.5259 18.2671 12.8105 18.4603 13.0728 18.3563L19.7477 15.7655C19.9001 15.705 20.0001 15.5578 20.0001 15.3939V9.45974C20.0001 9.17748 19.7155 8.98421 19.4531 9.08821L12.7782 11.6791C12.6259 11.7395 12.5259 11.8867 12.5259 12.0506Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.9672 12.3568L8.98623 13.3133L8.78509 13.4105L4.6034 15.4141C4.33833 15.542 4 15.3488 4 15.0544V9.48465C4 9.37811 4.05462 9.28613 4.12788 9.21686C4.15845 9.1862 4.19309 9.16097 4.22908 9.14098C4.32901 9.08102 4.47155 9.06501 4.59273 9.11295L10.9339 11.6254C11.2562 11.7533 11.2815 12.2049 10.9672 12.3568Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.9672 12.3568L8.98628 13.3133L4.12793 9.21686C4.1585 9.1862 4.19314 9.16097 4.22913 9.14098C4.32906 9.08102 4.4716 9.06501 4.59278 9.11295L10.934 11.6254C11.2563 11.7533 11.2816 12.2049 10.9672 12.3568Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
};
var $5642884c1dd34cff$export$2e2bcd8739ae039 = $5642884c1dd34cff$var$AirtableIcon;





parcelRequire("42omo");

const $e49fc528719c2d47$var$AmplitudeIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-507.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.0516 7.60124C11.0073 7.54277 10.9568 7.51208 10.9007 7.51208C10.8545 7.51208 10.8122 7.53281 10.7851 7.55016C10.3591 7.88478 9.77609 9.30229 9.29834 11.1701L9.72131 11.1749C10.5565 11.1844 11.419 11.1942 12.2715 11.2073C12.0468 10.3518 11.8344 9.61843 11.6397 9.02646C11.3552 8.16124 11.1629 7.77393 11.0516 7.60124Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 12.0001C20 16.4183 16.4183 20.0001 12 20.0001C7.58169 20.0001 4 16.4183 4 12.0001C4 7.58181 7.58169 4.00012 12 4.00012C16.4183 4.00012 20 7.58181 20 12.0001ZM17.9088 11.8171C17.9088 11.6117 17.764 11.4404 17.569 11.4014C17.5679 11.4012 17.5667 11.4009 17.5655 11.4006C17.5632 11.4003 17.561 11.3995 17.5587 11.3992L17.5508 11.3984C17.5301 11.395 17.5091 11.3929 17.4876 11.3926L17.4315 11.3873C16.0916 11.2914 14.7131 11.2536 13.4199 11.2278L13.4173 11.2183C12.788 8.85747 12.0018 6.44382 10.9417 6.44382C9.9539 6.44831 9.06345 8.03418 8.29446 11.1584C7.75116 11.1514 7.2559 11.1439 6.78892 11.1359C6.76241 11.1354 6.73863 11.1352 6.71743 11.1352C6.61783 11.1352 6.56916 11.1394 6.54506 11.1426C6.28209 11.1892 6.09124 11.4186 6.09124 11.6883C6.09124 11.9633 6.29655 12.1992 6.56402 12.2377L6.56948 12.2433H8.04257C7.90586 12.8684 7.78602 13.4865 7.68594 14.0821L7.64209 14.3442L7.64161 14.3567C7.64257 14.559 7.80787 14.7235 8.00996 14.7235C8.13815 14.7235 8.2543 14.6567 8.32064 14.5526L8.33108 14.5609L9.05526 12.2433H12.5435C12.81 13.2502 13.0864 14.2899 13.4517 15.2657C13.6471 15.7874 14.1044 17.0094 14.8688 17.0155H14.8774C16.0604 17.0155 16.5214 15.1047 16.8268 13.8398C16.8924 13.5677 16.9491 13.3327 17.0026 13.16L17.0239 13.0886H17.0238C17.0289 13.0719 17.0316 13.0543 17.0316 13.0358C17.0316 12.9346 16.9496 12.8525 16.8484 12.8525C16.7698 12.8525 16.703 12.9018 16.6768 12.9712L16.6765 12.971L16.6508 13.0421C16.5504 13.32 16.4575 13.5828 16.3753 13.8157L16.369 13.8332C15.857 15.2833 15.6233 15.9452 15.1655 15.9453L15.1542 15.9452L15.1478 15.9461L15.1364 15.9458C14.5504 15.9458 13.9986 13.5635 13.7908 12.6668C13.7549 12.5114 13.7219 12.3688 13.6916 12.2433H17.481C17.5521 12.2433 17.6191 12.2255 17.6779 12.1947C17.6784 12.1945 17.6787 12.1943 17.679 12.1942C17.685 12.1911 17.6906 12.1876 17.6964 12.1842C17.7028 12.1805 17.7091 12.1768 17.7152 12.1728C17.7182 12.1709 17.7211 12.1688 17.724 12.1667C17.7332 12.1604 17.742 12.1539 17.7507 12.1468C17.7513 12.1463 17.7518 12.1458 17.7524 12.1453C17.8479 12.0671 17.9088 11.9486 17.9088 11.8171Z",
                fill: "white"
            })
        ]
    });
};
var $e49fc528719c2d47$export$2e2bcd8739ae039 = $e49fc528719c2d47$var$AmplitudeIcon;





parcelRequire("42omo");

const $dd4523c3c0079a21$var$AsanaIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#F06A6A"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9553 12.3807C14.2737 12.3807 12.9105 13.7439 12.9105 15.4256C12.9105 17.1072 14.2737 18.4704 15.9553 18.4704C17.6369 18.4704 19 17.1072 19 15.4256C19 13.7439 17.6369 12.3807 15.9553 12.3807ZM8.04475 12.381C6.3632 12.381 5 13.7439 5 15.4256C5 17.1072 6.3632 18.4704 8.04475 18.4704C9.72637 18.4704 11.0896 17.1072 11.0896 15.4256C11.0896 13.7439 9.72637 12.381 8.04475 12.381ZM15.0447 8.57471C15.0447 10.2564 13.6816 11.6197 12 11.6197C10.3184 11.6197 8.95526 10.2564 8.95526 8.57471C8.95526 6.89336 10.3184 5.53003 12 5.53003C13.6816 5.53003 15.0447 6.89336 15.0447 8.57471Z",
                fill: "white"
            })
        ]
    });
};
var $dd4523c3c0079a21$export$2e2bcd8739ae039 = $dd4523c3c0079a21$var$AsanaIcon;





parcelRequire("42omo");

const $53660837dec24876$var$AzureDevopsIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.5 7.30929V16.4293L15.75 19.5L9.9375 17.3839V19.4818L6.64714 15.1821L16.2375 15.9321V7.71964L19.5 7.30929ZM16.3029 7.76786L10.9221 4.5V6.64393L5.98071 8.09571L4.5 9.99643V14.3132L6.61929 15.2486V9.71679L16.3029 7.76786Z",
                fill: "white"
            })
        ]
    });
};
var $53660837dec24876$export$2e2bcd8739ae039 = $53660837dec24876$var$AzureDevopsIcon;





parcelRequire("42omo");

const $7b4c7485efb04e66$var$BoxIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0071F7"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.8589 15.3516C20.0587 15.6312 20.0187 15.9907 19.779 16.1905C19.4994 16.3902 19.0999 16.3502 18.9002 16.1106L17.5021 14.313L16.1439 16.0706C15.9441 16.3502 15.5447 16.3502 15.265 16.1505C14.9854 15.9508 14.9455 15.5913 15.1452 15.3116L16.7431 13.2344L15.1452 11.1571C14.9455 10.8775 15.0254 10.478 15.265 10.2783C15.5447 10.0786 15.9441 10.1585 16.1439 10.3982L17.5021 12.1958L18.9002 10.478C19.0999 10.1984 19.4595 10.1585 19.779 10.3582C20.0587 10.5579 20.0587 10.9574 19.8589 11.237L18.301 13.2743L19.8589 15.3516ZM12.5886 15.1119C11.55 15.1119 10.7111 14.313 10.7111 13.2743C10.7111 12.2757 11.55 11.4368 12.5886 11.4368C13.6272 11.4368 14.4661 12.2757 14.4661 13.2743C14.4261 14.313 13.5873 15.1119 12.5886 15.1119ZM7.07591 15.1119C6.03729 15.1119 5.19841 14.313 5.19841 13.2743C5.19841 12.2757 6.03729 11.4368 7.07591 11.4368C8.11453 11.4368 8.95342 12.2757 8.95342 13.2743C8.95342 14.313 8.11453 15.1119 7.07591 15.1119ZM12.5886 10.2384C11.4301 10.2384 10.3915 10.8775 9.8722 11.8362C9.35289 10.8775 8.31427 10.2384 7.11586 10.2384C6.39682 10.2384 5.75766 10.478 5.23835 10.8376V8.28097C5.23835 7.96139 4.95873 7.68176 4.63915 7.68176C4.27963 7.68176 4 7.96139 4 8.28097V13.3143C4.03995 14.9921 5.39814 16.3103 7.07591 16.3103C8.27432 16.3103 9.31294 15.6312 9.83225 14.6725C10.3516 15.6312 11.3902 16.3103 12.5486 16.3103C14.2664 16.3103 15.6645 14.9521 15.6645 13.2344C15.7045 11.5966 14.3063 10.2384 12.5886 10.2384Z",
                fill: "white"
            })
        ]
    });
};
var $7b4c7485efb04e66$export$2e2bcd8739ae039 = $7b4c7485efb04e66$var$BoxIcon;





parcelRequire("42omo");

const $a8045fbc5fd77557$var$CanvaIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_1737_5849)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.0221 14.2091C16.9332 14.2091 16.855 14.2841 16.7737 14.4479C15.8548 16.3111 14.2679 17.6294 12.4314 17.6294C10.308 17.6294 8.993 15.7125 8.993 13.0644C8.993 8.57869 11.4923 5.98516 13.6875 5.98516C14.7133 5.98516 15.3398 6.62979 15.3398 7.65565C15.3398 8.87317 14.6481 9.51781 14.6481 9.94721C14.6481 10.14 14.768 10.2567 15.0057 10.2567C15.9609 10.2567 17.082 9.15909 17.082 7.60853C17.082 6.10509 15.7735 5 13.5783 5C9.95033 5 6.72607 8.36346 6.72607 13.0172C6.72607 16.6195 8.78313 19 11.9571 19C15.3258 19 17.2737 15.6483 17.2737 14.5604C17.2737 14.3194 17.1506 14.2091 17.0221 14.2091Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1737_5849",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $a8045fbc5fd77557$export$2e2bcd8739ae039 = $a8045fbc5fd77557$var$CanvaIcon;





parcelRequire("42omo");

const $5cc910e047331ab3$var$DocusignIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-115.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
                fill: "black"
            })
        ]
    });
};
var $5cc910e047331ab3$export$2e2bcd8739ae039 = $5cc910e047331ab3$var$DocusignIcon;





parcelRequire("42omo");

const $dd8c52e47d888b99$var$DovetailIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-747.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 13.8484C5.74119 13.8676 5.74119 13.9156 5.77446 13.9349L8.90847 15.7448C8.93934 15.7626 8.95836 15.7956 8.95836 15.8312V19.4501C8.95836 19.4885 8.99997 19.5125 9.03327 19.4933L12.1673 17.6834C12.1981 17.6656 12.2172 17.6326 12.2172 17.597V13.9492C12.2172 13.9136 12.1981 13.8806 12.1672 13.8628L8.95836 12.0106L5.77446 13.8484Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 6.32257C5.74119 6.3418 5.74119 6.38983 5.77446 6.40903L8.90847 8.21896C8.93934 8.23681 8.95836 8.26975 8.95836 8.30542V12.0108L12.2172 10.1288V6.42346C12.2172 6.38779 12.1981 6.35482 12.1672 6.33697L9.00828 4.51363C8.97741 4.49578 8.93934 4.49578 8.90847 4.51363L5.77446 6.32257Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2173 10.1281L15.4261 11.9813C15.457 11.9991 15.4761 12.0321 15.4761 12.0678V15.6866C15.4761 15.7251 15.5177 15.7491 15.5509 15.7299L18.6849 13.9199C18.7158 13.9021 18.7348 13.8691 18.7348 13.8335V10.1858C18.7348 10.1501 18.7158 10.1171 18.6849 10.0993L15.526 8.27594C15.4951 8.25812 15.457 8.25812 15.4261 8.27594L12.2173 10.1281Z",
                fill: "white"
            })
        ]
    });
};
var $dd8c52e47d888b99$export$2e2bcd8739ae039 = $dd8c52e47d888b99$var$DovetailIcon;





parcelRequire("42omo");

const $317758376a6d0f17$var$DropboxIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0061FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0098 8.48964L8.24219 10.8931L12.0098 13.2965L8.24219 15.7L4.47461 13.2836L8.24219 10.8801L4.47461 8.48964L8.24219 6.08618L12.0098 8.48964ZM8.2227 16.473L11.9903 14.0695L15.7579 16.473L11.9903 18.8765L8.2227 16.473ZM12.0098 13.2836L15.7773 10.8801L12.0098 8.48964L15.7579 6.08618L19.5254 8.48964L15.7579 10.8931L19.5254 13.2965L15.7579 15.7L12.0098 13.2836Z",
                fill: "white"
            })
        ]
    });
};
var $317758376a6d0f17$export$2e2bcd8739ae039 = $317758376a6d0f17$var$DropboxIcon;





parcelRequire("42omo");

const $b8ffc72fdfda17ef$var$FigmaIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12 12C12 11.337 12.254 10.7011 12.7061 10.2322C13.1582 9.76339 13.7714 9.5 14.4107 9.5C15.0501 9.5 15.6633 9.76339 16.1153 10.2322C16.5674 10.7011 16.8214 11.337 16.8214 12C16.8214 12.663 16.5674 13.2989 16.1153 13.7678C15.6633 14.2366 15.0501 14.5 14.4107 14.5C13.7714 14.5 13.1582 14.2366 12.7061 13.7678C12.254 13.2989 12 12.663 12 12Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.17871 17C7.17871 16.337 7.4327 15.7011 7.88479 15.2322C8.33689 14.7634 8.95006 14.5 9.58943 14.5H12.0001V17C12.0001 17.663 11.7462 18.2989 11.2941 18.7678C10.842 19.2366 10.2288 19.5 9.58943 19.5C8.95006 19.5 8.33689 19.2366 7.88479 18.7678C7.4327 18.2989 7.17871 17.663 7.17871 17V17Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12 4.5V9.5H14.4107C15.0501 9.5 15.6633 9.23661 16.1153 8.76777C16.5674 8.29893 16.8214 7.66304 16.8214 7C16.8214 6.33696 16.5674 5.70107 16.1153 5.23223C15.6633 4.76339 15.0501 4.5 14.4107 4.5H12Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.17871 7C7.17871 7.66304 7.4327 8.29893 7.88479 8.76777C8.33689 9.23661 8.95006 9.5 9.58943 9.5H12.0001V4.5H9.58943C8.95006 4.5 8.33689 4.76339 7.88479 5.23223C7.4327 5.70107 7.17871 6.33696 7.17871 7V7Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.17871 12C7.17871 12.663 7.4327 13.2989 7.88479 13.7678C8.33689 14.2366 8.95006 14.5 9.58943 14.5H12.0001V9.5H9.58943C8.95006 9.5 8.33689 9.76339 7.88479 10.2322C7.4327 10.7011 7.17871 11.337 7.17871 12V12Z",
                        fill: "#A259FF"
                    })
                ]
            })
        ]
    });
};
var $b8ffc72fdfda17ef$export$2e2bcd8739ae039 = $b8ffc72fdfda17ef$var$FigmaIcon;





parcelRequire("42omo");

const $a895e192628ab9a7$var$FreshserviceIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#09C6FA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.6954 4.25008C15.7025 4.25008 16.7099 4.25338 17.7183 4.25008C18.2271 4.24619 18.6802 4.38244 19.0651 4.72054C19.4877 5.09067 19.7328 5.55604 19.7349 6.11783C19.7436 8.16046 19.767 10.2037 19.7289 12.2454C19.6945 14.0838 19.0364 15.7066 17.8236 17.091C16.5561 18.5389 14.9606 19.4014 13.0546 19.6709C11.5776 19.8805 10.1533 19.6736 8.79837 19.0498C6.90652 18.179 5.57016 16.7631 4.79229 14.8358C4.32449 13.676 4.16198 12.4628 4.29456 11.2138C4.46875 9.57492 5.09668 8.1346 6.17833 6.89283C7.22587 5.69708 8.52271 4.90171 10.0581 4.49714C10.7129 4.32786 11.3871 4.2451 12.0634 4.25098C12.9401 4.25158 13.8175 4.25128 14.6954 4.25008ZM13.1971 11.1482C12.6063 11.1482 12.0155 11.1464 11.4247 11.15C11.322 11.15 11.2897 11.1323 11.3274 11.0221C11.4729 10.5945 11.6099 10.1642 11.7503 9.73443C11.895 9.29243 12.0394 8.85042 12.1837 8.40841C12.2211 8.29372 12.1837 8.20089 12.084 8.14459C11.9844 8.08829 11.8838 8.10895 11.8087 8.20268C11.7668 8.25509 11.7291 8.31079 11.689 8.36529C11.0002 9.32517 10.3118 10.2847 9.62382 11.244C9.34987 11.6257 9.07501 12.0067 8.79926 12.3868C8.76505 12.4287 8.74371 12.4796 8.73781 12.5334C8.73192 12.5872 8.74172 12.6415 8.76604 12.6898C8.81722 12.8 8.9115 12.842 9.02673 12.8464C9.07581 12.8482 9.1252 12.8479 9.17428 12.8479H12.5042C12.7054 12.8479 12.709 12.8479 12.6449 13.0456C12.3744 13.8747 12.1026 14.7032 11.8296 15.5311C11.7802 15.6809 11.8036 15.7737 11.9113 15.8336C12.0191 15.8935 12.1128 15.8677 12.2106 15.7437C12.2247 15.7264 12.2376 15.7081 12.2507 15.6898C13.2284 14.3369 14.2055 12.9839 15.182 11.6309C15.2554 11.5294 15.2919 11.4237 15.2299 11.3063C15.168 11.1889 15.0626 11.1461 14.9288 11.1467C14.3518 11.1503 13.7745 11.1482 13.1971 11.1482Z",
                fill: "white"
            })
        ]
    });
};
var $a895e192628ab9a7$export$2e2bcd8739ae039 = $a895e192628ab9a7$var$FreshserviceIcon;





parcelRequire("42omo");

const $ebee6edabad8a9c4$var$GmailIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.52273 17.625H7.90909V11.8295L4.5 9.27271V16.6023C4.5 17.1682 4.95852 17.625 5.52273 17.625Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.0908 17.625H18.4772C19.0431 17.625 19.4999 17.1665 19.4999 16.6023V9.27271L16.0908 11.8295",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.0908 7.3977V11.8295L19.4999 9.2727V7.90906C19.4999 6.64429 18.0562 5.92327 17.0454 6.68179",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.90918 11.8295V7.39771L12.0001 10.4659L16.091 7.39771V11.8295L12.0001 14.8977",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.5 7.90931V9.27294L7.90909 11.8298V7.39794L6.95455 6.68203C5.94205 5.92351 4.5 6.64453 4.5 7.90931Z",
                        fill: "#C5221F"
                    })
                ]
            })
        ]
    });
};
var $ebee6edabad8a9c4$export$2e2bcd8739ae039 = $ebee6edabad8a9c4$var$GmailIcon;





parcelRequire("42omo");

const $37eb7b587ecd273b$var$GithubIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
                fill: "white"
            })
        ]
    });
};
var $37eb7b587ecd273b$export$2e2bcd8739ae039 = $37eb7b587ecd273b$var$GithubIcon;





parcelRequire("42omo");

const $aa50a4b50f89009d$var$GitlabIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-587.5",
                y: "-363.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.7331 10.3948L19.7115 10.3373L17.5339 4.65705C17.4898 4.54552 17.4114 4.4509 17.31 4.3869C17.2343 4.33846 17.1483 4.30842 17.059 4.29919C16.9696 4.28996 16.8793 4.30179 16.7953 4.33375C16.7113 4.3657 16.636 4.41688 16.5754 4.4832C16.5147 4.54951 16.4705 4.6291 16.4461 4.7156L14.9763 9.21564H9.02381L7.55392 4.7156C7.5294 4.62923 7.48504 4.54979 7.42438 4.4836C7.36371 4.41742 7.28842 4.36632 7.20451 4.3344C7.1206 4.30247 7.03039 4.29059 6.94107 4.2997C6.85175 4.30882 6.7658 4.33868 6.69007 4.3869C6.58865 4.4509 6.51022 4.54552 6.46615 4.65705L4.28957 10.3383L4.26697 10.3948C3.95361 11.2138 3.91501 12.1125 4.15698 12.9553C4.39895 13.7981 4.90838 14.5394 5.60846 15.0674L5.61668 15.0736L5.63517 15.088L8.94779 17.5706L10.5913 18.8125L11.5897 19.5675C11.7068 19.656 11.8496 19.7038 11.9964 19.7038C12.1432 19.7038 12.2861 19.656 12.4032 19.5675L13.4016 18.8125L15.0451 17.5706L18.3813 15.0736L18.3906 15.0664C19.0906 14.5386 19.6001 13.7975 19.8423 12.9549C20.0844 12.1123 20.0461 11.2138 19.7331 10.3948Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.7329 10.3948L19.7114 10.3373C18.6504 10.555 17.6507 11.0047 16.7839 11.6541L12.0024 15.2698L15.047 17.5706L18.3832 15.0736L18.3925 15.0664C19.0922 14.5383 19.6012 13.7971 19.843 12.9545C20.0848 12.1119 20.0462 11.2135 19.7329 10.3948Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.94775 17.5708L10.5912 18.8126L11.5896 19.5676C11.7068 19.6561 11.8496 19.7039 11.9964 19.7039C12.1432 19.7039 12.286 19.6561 12.4032 19.5676L13.4016 18.8126L15.045 17.5708L12.0005 15.2699L8.94775 17.5708Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.21598 11.6541C6.34952 11.005 5.35016 10.5556 4.28957 10.3383L4.26697 10.3948C3.95361 11.2137 3.91501 12.1124 4.15698 12.9552C4.39895 13.798 4.90838 14.5393 5.60846 15.0674L5.61668 15.0735L5.63517 15.0879L8.94779 17.5706L11.9944 15.2697L7.21598 11.6541Z",
                fill: "#FC6D26"
            })
        ]
    });
};
var $aa50a4b50f89009d$export$2e2bcd8739ae039 = $aa50a4b50f89009d$var$GitlabIcon;





parcelRequire("42omo");

const $1a2c5202162d89c8$var$GoogleCalendarIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-124.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.8208 8.17936L12.3822 7.7973L8.17949 8.17936L7.79736 12.0001L8.17942 15.8207L12.0001 16.2983L15.8208 15.8207L16.2029 11.9046L15.8208 8.17936Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.74654 14.1071C9.46096 13.9142 9.26322 13.6324 9.15527 13.2599L9.81819 12.9867C9.87837 13.216 9.98341 13.3936 10.1334 13.5197C10.2824 13.6458 10.4639 13.7079 10.6759 13.7079C10.8928 13.7079 11.079 13.642 11.2347 13.5101C11.3903 13.3783 11.4687 13.2102 11.4687 13.0068C11.4687 12.7986 11.3866 12.6285 11.2223 12.4967C11.058 12.365 10.8517 12.299 10.6052 12.299H10.2222V11.6428H10.566C10.7781 11.6428 10.9567 11.5856 11.1019 11.4709C11.2471 11.3563 11.3197 11.1997 11.3197 11C11.3197 10.8224 11.2547 10.681 11.1249 10.575C10.995 10.469 10.8306 10.4155 10.631 10.4155C10.4362 10.4155 10.2814 10.4671 10.1668 10.5712C10.0522 10.6753 9.96904 10.8033 9.91655 10.9542L9.26039 10.681C9.34728 10.4346 9.50684 10.2168 9.74081 10.0287C9.97484 9.8405 10.2738 9.74591 10.6367 9.74591C10.9051 9.74591 11.1468 9.79752 11.3608 9.90162C11.5747 10.0057 11.7428 10.15 11.8641 10.3333C11.9854 10.5176 12.0456 10.724 12.0456 10.9532C12.0456 11.1872 11.9893 11.3849 11.8766 11.5473C11.7638 11.7097 11.6253 11.8338 11.461 11.9208V11.9599C11.6779 12.0507 11.8546 12.1892 11.994 12.3754C12.1325 12.5617 12.2022 12.7843 12.2022 13.0441C12.2022 13.3039 12.1363 13.536 12.0045 13.7394C11.8726 13.9429 11.6902 14.1034 11.4591 14.2199C11.227 14.3364 10.9662 14.3956 10.6768 14.3956C10.3416 14.3966 10.0321 14.3001 9.74654 14.1071Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.8145 10.8175L13.0905 11.3438L12.7266 10.7917L14.0323 9.84991H14.5328V14.2924H13.8145V10.8175Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.8208 19.2592L19.2593 15.8206L17.54 15.0565L15.8208 15.8206L15.0566 17.5399L15.8208 19.2592Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.41504 17.54L8.17915 19.2593H15.8205V15.8207H8.17915L7.41504 17.54Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.88689 4.74078C5.25366 4.74078 4.74072 5.25372 4.74072 5.88695V15.8207L6.46001 16.5848L8.17929 15.8207V8.17935H15.8206L16.5847 6.46007L15.8207 4.74078H5.88689Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.74072 15.8207V18.1131C4.74072 18.7464 5.25366 19.2593 5.88689 19.2593H8.17929V15.8207H4.74072Z",
                        fill: "#188038"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.8203 8.17945V15.8208H19.2589V8.17945L17.5396 7.41534L15.8203 8.17945Z",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M19.2589 8.17929V5.88689C19.2589 5.25359 18.7459 4.74072 18.1127 4.74072H15.8203V8.17929H19.2589Z",
                        fill: "#1967D2"
                    })
                ]
            })
        ]
    });
};
var $1a2c5202162d89c8$export$2e2bcd8739ae039 = $1a2c5202162d89c8$var$GoogleCalendarIcon;





parcelRequire("42omo");

const $cf8fe8259ed5344f$var$HubSpotFilterIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-587.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FF5C35"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
                fill: "white"
            })
        ]
    });
};
var $cf8fe8259ed5344f$export$2e2bcd8739ae039 = $cf8fe8259ed5344f$var$HubSpotFilterIcon;





parcelRequire("42omo");

const $a5f11824900bc125$var$LucidIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-587.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
                fill: "white"
            })
        ]
    });
};
var $a5f11824900bc125$export$2e2bcd8739ae039 = $a5f11824900bc125$var$LucidIcon;





parcelRequire("42omo");

const $65126ba42d15d21a$var$LoomIcon = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "#5753F3"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
var $65126ba42d15d21a$export$2e2bcd8739ae039 = $65126ba42d15d21a$var$LoomIcon;





parcelRequire("42omo");

const $cb3865c96b8d866c$var$MiroIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0122 5.5H13.1097L14.6951 8.28547L11.2073 5.5H9.30491L11.0488 8.90456L7.40244 5.5H5.5L7.40244 9.83362L5.5 18.5H7.40244L11.0488 9.21453L9.30491 18.5H11.2073L14.6951 8.59544L13.1097 18.5H15.0122L18.5 7.6664L15.0122 5.5Z",
                fill: "black"
            })
        ]
    });
};
var $cb3865c96b8d866c$export$2e2bcd8739ae039 = $cb3865c96b8d866c$var$MiroIcon;





parcelRequire("42omo");

const $0516226a48c56413$var$MondayIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.36594 16.7731C6.03435 16.7738 5.70851 16.6807 5.42172 16.5032C5.13492 16.3257 4.89744 16.0701 4.73354 15.7627C4.57214 15.4574 4.49165 15.111 4.50068 14.7606C4.50972 14.4103 4.60793 14.0691 4.78482 13.7738L8.14648 8.14287C8.31854 7.84024 8.56281 7.59175 8.85436 7.42277C9.14592 7.2538 9.47429 7.1704 9.80595 7.18109C10.1373 7.18956 10.4607 7.2918 10.7429 7.47734C11.0251 7.66289 11.256 7.92507 11.412 8.23707C11.7254 8.86914 11.6862 9.6296 11.3109 10.2229L7.95133 15.8538C7.78097 16.137 7.54634 16.3697 7.2692 16.5304C6.99206 16.6911 6.68137 16.7746 6.36594 16.7731Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.1321 16.7728C11.454 16.7728 10.8301 16.3861 10.5025 15.7647C10.3415 15.4602 10.2612 15.1148 10.2702 14.7653C10.2793 14.4159 10.3773 14.0756 10.5538 13.7811L13.9091 8.16313C14.0786 7.85625 14.322 7.60333 14.614 7.43061C14.9061 7.25789 15.2361 7.17165 15.5699 7.18084C16.2537 7.19679 16.8733 7.60475 17.1867 8.2429C17.4979 8.88105 17.4523 9.64607 17.0656 10.2379L13.7111 15.8559C13.5412 16.1378 13.3075 16.3696 13.0316 16.5299C12.7556 16.6901 12.4463 16.7737 12.1321 16.7728Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.7693 16.82C18.7251 16.82 19.4999 16.0108 19.4999 15.0126C19.4999 14.0145 18.7251 13.2053 17.7693 13.2053C16.8134 13.2053 16.0386 14.0145 16.0386 15.0126C16.0386 16.0108 16.8134 16.82 17.7693 16.82Z",
                fill: "#00CA72"
            })
        ]
    });
};
var $0516226a48c56413$export$2e2bcd8739ae039 = $0516226a48c56413$var$MondayIcon;





parcelRequire("42omo");

const $39ba9afef184103e$var$MuralIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.6754 16.1763C12.6757 14.0134 12.6843 11.8504 12.6739 9.68758C12.6654 7.94483 13.8929 6.44038 15.5576 6.08234C15.8132 6.02736 16.0709 5.99181 16.3335 6.00416C16.3754 6.06652 16.3699 6.13777 16.3701 6.20736C16.3708 6.83713 16.371 7.46704 16.3698 8.09681C16.3696 8.17062 16.3803 8.24819 16.3276 8.31236C15.8848 8.32742 15.5243 8.50576 15.2565 8.86034C15.089 9.08221 14.9992 9.3339 14.9928 9.61332C14.9914 9.67342 14.9908 9.73352 14.9908 9.79377C14.9908 11.8638 14.9908 13.9339 14.9905 16.0039C14.9905 16.0639 14.9863 16.1238 14.9842 16.1839C14.9391 16.2353 14.8769 16.2339 14.8176 16.2342C14.1625 16.2368 13.5073 16.2368 12.8522 16.2342C12.7888 16.2339 12.7197 16.2401 12.6755 16.1763H12.6754Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.9958 9.66997C19.997 9.7251 19.9991 9.78023 19.9991 9.83536C19.9992 12.6608 19.9994 15.4861 19.9988 18.3115C19.9988 18.5251 20.0262 18.4962 19.8174 18.4965C19.1651 18.4977 18.5127 18.497 17.8602 18.497C17.8251 18.497 17.7899 18.4955 17.7548 18.497C17.7016 18.4992 17.684 18.4709 17.6862 18.4226C17.6871 18.4025 17.6862 18.3825 17.6862 18.3623C17.6865 15.4716 17.6867 12.5811 17.687 9.69046C17.687 9.68548 17.6874 9.68036 17.6876 9.67539C17.7236 9.6043 17.7918 9.60324 17.8563 9.60294C18.5111 9.59948 19.1658 9.59963 19.8206 9.60249C19.8869 9.60279 19.9509 9.61213 19.9956 9.66982L19.9958 9.66997Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.31589 9.65845C6.31815 9.71343 6.32222 9.76841 6.32222 9.82339C6.32252 12.6568 6.32267 15.4902 6.32222 18.3237C6.32222 18.5291 6.34511 18.5007 6.1493 18.501C5.48729 18.502 4.82529 18.502 4.16344 18.5002C4.11208 18.5002 4.05183 18.5251 4.01025 18.4692C4.02758 18.4151 4.01538 18.3598 4.01538 18.3053C4.01628 15.4761 4.01613 12.6469 4.01613 9.81781C4.01613 9.61688 4.02682 9.60212 4.22535 9.60121C4.85738 9.5985 5.4894 9.59941 6.12143 9.60106C6.19072 9.60121 6.26407 9.59579 6.31604 9.65845H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.3296 18.485C11.282 18.508 11.2309 18.499 11.1813 18.4991C10.5242 18.5006 9.86683 18.5014 9.20965 18.5021C9.1845 18.5021 9.15949 18.5029 9.13434 18.502C9.06545 18.4995 9.02985 18.4615 9.02754 18.3881C9.02709 18.373 9.02754 18.358 9.02754 18.3429C9.02754 15.4932 9.02754 12.6434 9.02769 9.79368C9.02769 9.74864 9.03101 9.70361 9.03282 9.65842C9.08463 9.59651 9.15738 9.60103 9.22667 9.60073C9.86141 9.59907 10.4961 9.59907 11.1309 9.60073C11.2003 9.60088 11.2728 9.59711 11.3247 9.65857C11.3267 9.72364 11.3305 9.78871 11.3305 9.85378C11.3308 11.899 11.3306 13.9442 11.3311 15.9892C11.3311 16.0542 11.3234 16.1197 11.3409 16.1837C11.3704 16.2444 11.3702 16.3096 11.3702 16.3748C11.3704 17.0109 11.371 17.647 11.3696 18.283C11.3696 18.3521 11.3782 18.4246 11.3296 18.4847V18.485Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.3247 9.65883C10.5607 9.65883 9.79675 9.65883 9.03263 9.65868C9.00822 9.44901 8.97343 9.24296 8.87477 9.05166C8.60861 8.53577 8.0406 8.24174 7.47124 8.32896C6.89584 8.41707 6.43884 8.87166 6.34515 9.45007C6.33401 9.5192 6.32557 9.58879 6.31593 9.65823C5.60302 9.65823 4.89011 9.65793 4.17719 9.65778C4.15716 9.65778 4.13682 9.65944 4.11694 9.65763C4.04795 9.65145 4.01226 9.67751 4.01753 9.75132C4.02039 9.79123 4.01783 9.8316 4.01783 9.87182C4.01783 12.6882 4.01783 15.5048 4.01753 18.3212C4.01753 18.3709 4.01286 18.4206 4.01015 18.4697C3.99267 18.4307 4.00307 18.3902 4.00307 18.351C4.00231 15.501 4.00201 12.6509 4.00277 9.80087C4.00277 9.28513 4.06874 8.77888 4.27389 8.30139C4.8172 7.03749 5.76675 6.26101 7.12404 6.04561C9.03022 5.74301 10.8088 6.97166 11.247 8.85389C11.3084 9.11794 11.3462 9.38605 11.3246 9.65883H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.3295 18.4854C11.3295 17.7731 11.3295 17.0608 11.3299 16.3486C11.3299 16.2938 11.3216 16.2382 11.3408 16.1844C11.7857 16.1819 12.2307 16.1793 12.6756 16.1768C12.7253 16.1795 12.7752 16.1844 12.8249 16.1844C13.5447 16.1849 14.2644 16.1846 14.9843 16.1844C14.9865 16.2343 14.9909 16.2843 14.9909 16.3342C14.9913 16.9954 14.9912 17.6568 14.9912 18.3181C14.9912 18.3532 14.99 18.3883 14.9909 18.4232C14.9921 18.4723 14.9705 18.4981 14.9201 18.4975C14.885 18.4972 14.8499 18.4982 14.8149 18.4982C13.7077 18.4982 12.6006 18.4982 11.4933 18.4981C11.4385 18.4981 11.3829 18.5051 11.3296 18.4853L11.3295 18.4854Z",
                fill: "#FFAA00"
            })
        ]
    });
};
var $39ba9afef184103e$export$2e2bcd8739ae039 = $39ba9afef184103e$var$MuralIcon;





parcelRequire("42omo");

const $146e6df0b25543ec$var$NotionIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5.72382 5.14736L14.0236 4.53432C15.0431 4.44687 15.305 4.50582 15.9461 4.97186L18.5955 6.83828C19.0325 7.15927 19.178 7.24672 19.178 7.59621V17.8325C19.178 18.474 18.945 18.8535 18.1295 18.9114L8.49127 19.4952C7.87928 19.5241 7.58784 19.4367 7.26729 19.0282L5.31628 16.4912C4.96634 16.0243 4.82129 15.6748 4.82129 15.2662V6.16734C4.82129 5.6428 5.05423 5.20541 5.72382 5.14736Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0236 4.53447L5.72382 5.14751C5.05423 5.20541 4.82129 5.64295 4.82129 6.16734V15.2662C4.82129 15.6746 4.96634 16.0241 5.31628 16.4912L7.26729 19.0281C7.58784 19.4365 7.87928 19.5241 8.49127 19.495L18.1296 18.9115C18.9446 18.8535 19.1781 18.474 19.1781 17.8326V7.59636C19.1781 7.26487 19.0472 7.16932 18.6617 6.88643L15.9461 4.97186C15.3052 4.50582 15.0431 4.44687 14.0236 4.53432V4.53447ZM8.70921 7.42882C7.92218 7.48177 7.74368 7.49377 7.29669 7.13032L6.16031 6.22644C6.04482 6.10944 6.10286 5.96349 6.39386 5.9344L14.3727 5.35136C15.0427 5.29286 15.3916 5.5264 15.6536 5.7304L17.0221 6.72188C17.0806 6.75143 17.2261 6.92588 17.051 6.92588L8.81121 7.42192L8.70921 7.42882ZM7.79168 17.7452V9.05539C7.79168 8.67589 7.90823 8.50085 8.25712 8.47145L17.721 7.91736C18.042 7.88841 18.1871 8.0924 18.1871 8.4713V17.1032C18.1871 17.4827 18.1286 17.8037 17.6046 17.8326L8.54827 18.3576C8.02433 18.3866 7.79183 18.2121 7.79183 17.7452H7.79168ZM16.7315 9.52128C16.7896 9.78377 16.7315 10.0463 16.469 10.0763L16.0325 10.1628V16.5786C15.6535 16.7826 15.3046 16.8992 15.013 16.8992C14.547 16.8992 14.4306 16.7532 14.0815 16.3161L11.2271 11.8252V16.1702L12.13 16.3746C12.13 16.3746 12.13 16.8996 11.4015 16.8996L9.39305 17.0162C9.33455 16.8992 9.39305 16.6077 9.5966 16.5497L10.1211 16.4042V10.6593L9.3932 10.6004C9.3347 10.3379 9.4802 9.95882 9.88819 9.92942L12.0432 9.78437L15.0131 14.3333V10.3089L14.2561 10.2219C14.1976 9.90047 14.4306 9.66692 14.7215 9.63842L16.7315 9.52128Z",
                fill: "#292A2E"
            })
        ]
    });
};
var $146e6df0b25543ec$export$2e2bcd8739ae039 = $146e6df0b25543ec$var$NotionIcon;





parcelRequire("42omo");

const $00d08bb2217642b2$var$OutlookCalendarIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    });
};
var $00d08bb2217642b2$export$2e2bcd8739ae039 = $00d08bb2217642b2$var$OutlookCalendarIcon;





parcelRequire("42omo");

const $b09cd2aa9525d4b4$var$OutlookMailIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    });
};
var $b09cd2aa9525d4b4$export$2e2bcd8739ae039 = $b09cd2aa9525d4b4$var$OutlookMailIcon;





parcelRequire("42omo");

const $854c18960b2d6ffb$var$PipedriveIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-635.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#017737"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.2336 10.1635C10.2336 11.5838 10.9541 13.1159 12.5396 13.1159C13.7154 13.1159 14.9043 12.198 14.9043 10.1427C14.9043 8.34075 13.9697 7.13106 12.5787 7.13106C11.4453 7.13106 10.2336 7.92728 10.2336 10.1635ZM13.1373 4.5C15.9802 4.5 17.8917 6.75159 17.8917 10.1032C17.8917 13.4022 15.878 15.7053 12.9993 15.7053C11.6268 15.7053 10.7476 15.1175 10.2879 14.6919C10.2912 14.7928 10.2933 14.9058 10.2933 15.0264V19.5H7.34834V7.58072C7.34834 7.40743 7.29292 7.3526 7.12122 7.3526H6.1084V4.74238H8.5796C9.71739 4.74238 10.0086 5.32145 10.0641 5.76782C10.5259 5.25017 11.4833 4.5 13.1373 4.5Z",
                fill: "white"
            })
        ]
    });
};
var $854c18960b2d6ffb$export$2e2bcd8739ae039 = $854c18960b2d6ffb$var$PipedriveIcon;





parcelRequire("42omo");

const $c002cdcd98eda8d3$var$SalesforceIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M3 5.71326H21V18.2868H3V5.71326Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask0_719_13847)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.4738 7.08983C11.0548 6.48497 11.8635 6.11041 12.7569 6.11041C13.9481 6.11041 14.9804 6.77218 15.5363 7.75821C16.0297 7.53763 16.5642 7.42374 17.1047 7.42402C19.2488 7.42402 20.9892 9.17769 20.9892 11.3417C20.9892 13.5056 19.2488 15.2593 17.1047 15.2593C16.8426 15.2593 16.5872 15.233 16.337 15.1832C15.8506 16.0501 14.9209 16.6391 13.862 16.6391C13.431 16.6399 13.0054 16.5422 12.6179 16.3532C12.1249 17.5113 10.9767 18.3253 9.63998 18.3253C8.24366 18.3253 7.0591 17.4451 6.60248 16.2076C6.39925 16.2505 6.1921 16.2721 5.98439 16.2719C4.32336 16.2719 2.97998 14.9087 2.97998 13.2344C2.97998 12.1094 3.58483 11.13 4.48219 10.6006C4.29181 10.1621 4.19382 9.689 4.19432 9.21091C4.19432 7.27856 5.7627 5.7168 7.69505 5.7168C8.82667 5.7168 9.83917 6.25614 10.4745 7.09327",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6037 12.2516C5.59239 12.2812 5.60774 12.2873 5.61138 12.2925C5.64519 12.317 5.67954 12.3348 5.71395 12.3547C5.89792 12.452 6.07131 12.4804 6.25263 12.4804C6.62189 12.4804 6.85153 12.2839 6.85153 11.9675V11.9613C6.85153 11.6688 6.59211 11.5623 6.34991 11.4862L6.31821 11.4759C6.1349 11.4165 5.97674 11.3647 5.97674 11.2443V11.2381C5.97674 11.1349 6.06939 11.0588 6.21233 11.0588C6.37115 11.0588 6.56042 11.1117 6.68152 11.1786C6.68152 11.1786 6.71739 11.2018 6.73042 11.1671C6.7375 11.1484 6.79925 10.9832 6.80586 10.9646C6.81288 10.9453 6.80057 10.9306 6.78793 10.9231C6.64896 10.8384 6.45705 10.7808 6.25852 10.7808L6.22166 10.7809C5.8835 10.7809 5.64725 10.9854 5.64725 11.2779V11.2842C5.64725 11.5926 5.90798 11.6932 6.15151 11.7627L6.19069 11.7748C6.36804 11.8294 6.52157 11.8768 6.52157 12.0012V12.0074C6.52157 12.1219 6.42164 12.2072 6.2615 12.2072C6.19922 12.2072 6.00076 12.2062 5.78569 12.0703C5.75968 12.0551 5.74486 12.0442 5.72481 12.0319C5.71422 12.0255 5.68775 12.0139 5.67623 12.0486L5.60344 12.2511M11.0101 12.2511C10.9987 12.2806 11.0141 12.2868 11.0179 12.292C11.0515 12.3165 11.086 12.3342 11.1204 12.3541C11.3044 12.4514 11.4778 12.4799 11.6591 12.4799C12.0284 12.4799 12.258 12.2833 12.258 11.967V11.9608C12.258 11.6683 11.9993 11.5618 11.7564 11.4856L11.7247 11.4754C11.5414 11.416 11.3832 11.3642 11.3832 11.2438V11.2376C11.3832 11.1344 11.4759 11.0583 11.6188 11.0583C11.7776 11.0583 11.9662 11.1112 12.088 11.1781C12.088 11.1781 12.1239 11.2012 12.137 11.1666C12.144 11.1479 12.2058 10.9826 12.2118 10.9641C12.2188 10.9447 12.2065 10.9301 12.1939 10.9226C12.0549 10.8378 11.863 10.7803 11.6645 10.7803L11.6275 10.7804C11.2894 10.7804 11.0531 10.9849 11.0531 11.2774V11.2837C11.0531 11.5921 11.3139 11.6926 11.5574 11.7621L11.5965 11.7743C11.7745 11.8288 11.9274 11.8762 11.9274 12.0006V12.0069C11.9274 12.1213 11.8275 12.2067 11.6673 12.2067C11.6049 12.2067 11.4059 12.2056 11.1915 12.0697C11.1655 12.0546 11.1503 12.0441 11.1306 12.0314C11.1239 12.0272 11.0927 12.015 11.0821 12.0481L11.0093 12.2506M14.7019 11.6312C14.7019 11.8098 14.6686 11.9508 14.6033 12.0507C14.5382 12.1493 14.4398 12.1976 14.3029 12.1976C14.1659 12.1976 14.0679 12.1497 14.0037 12.0514C13.9391 11.9521 13.9065 11.8105 13.9065 11.6318C13.9065 11.4532 13.9393 11.3129 14.0037 11.2143C14.0678 11.1163 14.1652 11.0693 14.3029 11.0693C14.4405 11.0693 14.5385 11.1168 14.6033 11.2143C14.669 11.3129 14.7019 11.4532 14.7019 11.6318M15.0103 11.3003C14.9799 11.1977 14.9329 11.1077 14.87 11.0323C14.8071 10.9568 14.7277 10.8959 14.6331 10.8523C14.5391 10.8083 14.4279 10.7861 14.3022 10.7861C14.1765 10.7861 14.066 10.8084 13.9713 10.8523C13.8773 10.8962 13.7973 10.9568 13.7344 11.0323C13.6717 11.1077 13.6246 11.1977 13.5941 11.3003C13.564 11.4022 13.5487 11.5134 13.5487 11.6318C13.5487 11.7503 13.564 11.8615 13.5941 11.9634C13.6244 12.0659 13.6715 12.1559 13.7344 12.2314C13.7973 12.3068 13.8773 12.3671 13.9713 12.4101C14.066 12.4529 14.1771 12.4748 14.3022 12.4748C14.4273 12.4748 14.5385 12.4529 14.6324 12.4101C14.7264 12.3672 14.8065 12.3068 14.8693 12.2314C14.9321 12.1559 14.9792 12.0659 15.0096 11.9634C15.0397 11.8615 15.055 11.7503 15.055 11.6318C15.055 11.514 15.0397 11.4022 15.0096 11.3003M17.5442 12.1473C17.5341 12.1174 17.5048 12.1287 17.5048 12.1287C17.46 12.1458 17.4122 12.1617 17.3612 12.1696C17.3099 12.1777 17.2527 12.1818 17.1925 12.1818C17.0436 12.1818 16.9244 12.1374 16.8397 12.0494C16.7544 11.9614 16.7067 11.8198 16.7074 11.6279C16.7078 11.4532 16.7501 11.3221 16.8258 11.2215C16.9006 11.1223 17.0158 11.0707 17.168 11.0707C17.295 11.0707 17.3923 11.0854 17.4942 11.1173C17.4942 11.1173 17.5184 11.1278 17.53 11.096C17.557 11.0212 17.577 10.9676 17.6061 10.8856C17.6143 10.8621 17.5942 10.8521 17.5868 10.8493C17.5468 10.8337 17.4525 10.8081 17.381 10.7973C17.3142 10.7871 17.2367 10.7818 17.1494 10.7818C17.0197 10.7818 16.9045 10.804 16.8059 10.8479C16.7073 10.8918 16.6239 10.9525 16.5578 11.0279C16.4916 11.1033 16.4413 11.1933 16.4075 11.2959C16.3741 11.3978 16.3572 11.5097 16.3572 11.6281C16.3572 11.8836 16.4261 12.0907 16.5624 12.2422C16.6987 12.3944 16.9039 12.4712 17.1712 12.4712C17.3294 12.4712 17.4915 12.4393 17.608 12.3931C17.608 12.3931 17.6302 12.3824 17.6206 12.3565L17.5445 12.1473M18.0838 11.4591C18.0985 11.3598 18.1257 11.2771 18.1685 11.2129C18.2325 11.115 18.33 11.0614 18.467 11.0614C18.6039 11.0614 18.6946 11.1153 18.7595 11.2129C18.8025 11.2775 18.8213 11.3632 18.8283 11.4591L18.0805 11.459L18.0838 11.4591ZM19.1228 11.2407C19.0965 11.1421 19.0314 11.0422 18.9891 10.9965C18.9216 10.9244 18.8561 10.8734 18.7906 10.8457C18.696 10.8054 18.5942 10.7848 18.4914 10.785C18.3611 10.785 18.2426 10.807 18.1467 10.8518C18.0507 10.8969 17.97 10.9584 17.9064 11.0351C17.843 11.1119 17.7953 11.2025 17.7648 11.3064C17.7344 11.409 17.719 11.5215 17.719 11.6393C17.719 11.7598 17.735 11.8716 17.7663 11.9728C17.798 12.0748 17.8491 12.1641 17.9179 12.2382C17.9867 12.313 18.0747 12.3712 18.1806 12.4123C18.2858 12.4529 18.4135 12.4741 18.5598 12.4736C18.8616 12.4726 19.0204 12.4054 19.0852 12.369C19.0968 12.3626 19.1077 12.3514 19.0941 12.3191L19.0259 12.1279C19.0155 12.0994 18.9866 12.1097 18.9866 12.1097C18.9119 12.1376 18.806 12.1878 18.5578 12.1871C18.3957 12.1869 18.2759 12.139 18.2005 12.064C18.1237 11.9873 18.0853 11.8754 18.0794 11.7166L19.1249 11.7174C19.1249 11.7174 19.1525 11.7171 19.1553 11.6903C19.1564 11.6791 19.1911 11.4759 19.1242 11.2409L19.1228 11.2407ZM9.7257 11.4591C9.74046 11.3598 9.76772 11.2771 9.81041 11.2129C9.87447 11.115 9.97188 11.0614 10.1089 11.0614C10.2458 11.0614 10.3365 11.1153 10.4014 11.2129C10.4443 11.2775 10.4631 11.3632 10.4702 11.4591L9.72239 11.459L9.7257 11.4591ZM10.7647 11.2407C10.7385 11.1421 10.6733 11.0422 10.631 10.9965C10.5635 10.9244 10.498 10.8734 10.4325 10.8457C10.3379 10.8054 10.2361 10.7848 10.1333 10.785C10.003 10.785 9.88453 10.807 9.78857 10.8518C9.69261 10.8969 9.61188 10.9584 9.54835 11.0351C9.48502 11.1119 9.43717 11.2025 9.40673 11.3064C9.37636 11.409 9.36107 11.5215 9.36107 11.6393C9.36107 11.7598 9.37689 11.8716 9.40845 11.9728C9.44008 12.0748 9.49117 12.1641 9.55933 12.2382C9.62816 12.313 9.71617 12.3712 9.82206 12.4123C9.92728 12.4529 10.0543 12.4741 10.2012 12.4736C10.503 12.4726 10.6618 12.4054 10.7267 12.369C10.7382 12.3626 10.7492 12.3514 10.7355 12.3191L10.6673 12.1279C10.6568 12.0994 10.628 12.1097 10.628 12.1097C10.5532 12.1376 10.4473 12.1878 10.1991 12.1871C10.0377 12.1869 9.91722 12.139 9.84178 12.064C9.76501 11.9873 9.72663 11.8754 9.72067 11.7166L10.7663 11.7174C10.7663 11.7174 10.7938 11.7171 10.7966 11.6903C10.7978 11.6791 10.8324 11.4759 10.7654 11.2409L10.7647 11.2407ZM7.46908 12.1407C7.42812 12.108 7.42243 12.1 7.40886 12.0788C7.38815 12.0468 7.37756 12.0014 7.37756 11.9431C7.37756 11.8518 7.408 11.7856 7.47087 11.7413C7.47021 11.7414 7.56087 11.6632 7.77396 11.6658C7.86881 11.6675 7.96343 11.6756 8.05719 11.69V12.1645H8.05733C8.05733 12.1645 7.92497 12.193 7.77542 12.202C7.56299 12.2148 7.46902 12.1409 7.46968 12.1411L7.46908 12.1407ZM7.88467 11.4062C7.84232 11.4031 7.78739 11.4015 7.72188 11.4015C7.63254 11.4015 7.54585 11.4127 7.46511 11.4345C7.38372 11.4565 7.31026 11.4905 7.24739 11.5357C7.18435 11.5807 7.1325 11.6396 7.09585 11.7078C7.05886 11.7766 7.04 11.8574 7.04 11.9487C7.04 12.0413 7.05608 12.1214 7.08784 12.1869C7.11897 12.2519 7.16583 12.3081 7.22417 12.3504C7.2822 12.3926 7.35387 12.4238 7.43659 12.4424C7.51865 12.4611 7.6113 12.4706 7.71321 12.4706C7.82042 12.4706 7.92696 12.4616 8.03019 12.4441C8.11812 12.429 8.20571 12.4119 8.29292 12.3931C8.32772 12.3851 8.36637 12.3745 8.36637 12.3745C8.39218 12.368 8.3902 12.3404 8.3902 12.3404L8.3896 11.3874C8.3896 11.1783 8.33375 11.0228 8.2235 10.9269C8.11364 10.8309 7.95283 10.7826 7.74438 10.7826C7.66629 10.7826 7.53989 10.7932 7.46445 10.8083C7.46445 10.8083 7.23681 10.8525 7.14283 10.9261C7.14283 10.9261 7.12219 10.9388 7.13344 10.9676L7.20756 11.1661C7.21675 11.1919 7.24183 11.1831 7.24183 11.1831C7.24183 11.1831 7.24971 11.18 7.25897 11.1745C7.45949 11.0653 7.71361 11.0686 7.71361 11.0686C7.82611 11.0686 7.91346 11.0914 7.97169 11.1361C8.02867 11.1798 8.05772 11.246 8.05772 11.3849V11.4291C7.96839 11.4161 7.88567 11.4086 7.88567 11.4086L7.88467 11.4062ZM16.2891 10.8682C16.2906 10.8647 16.2914 10.8609 16.2914 10.8571C16.2914 10.8533 16.2907 10.8495 16.2892 10.846C16.2878 10.8425 16.2856 10.8394 16.2829 10.8367C16.2802 10.834 16.2769 10.832 16.2734 10.8306C16.2556 10.8238 16.1669 10.8051 16.0987 10.8009C15.9677 10.7926 15.8949 10.8148 15.8294 10.8441C15.7646 10.8733 15.693 10.9202 15.6533 10.9745L15.6532 10.8474C15.6532 10.83 15.6408 10.8159 15.6232 10.8159H15.3559C15.3385 10.8159 15.326 10.83 15.326 10.8474V12.4026C15.326 12.411 15.3293 12.419 15.3353 12.425C15.3412 12.4309 15.3492 12.4343 15.3577 12.4343H15.6316C15.64 12.4343 15.6481 12.4309 15.654 12.425C15.6599 12.419 15.6633 12.411 15.6633 12.4026V11.6217C15.6633 11.5171 15.6748 11.4133 15.6977 11.3477C15.7204 11.2829 15.7511 11.2313 15.7891 11.1942C15.8252 11.1584 15.8695 11.1319 15.9181 11.1168C15.9637 11.1037 16.0109 11.0971 16.0584 11.0971C16.113 11.0971 16.1729 11.1111 16.1729 11.1111C16.193 11.1133 16.2042 11.101 16.211 11.0829C16.2289 11.0352 16.2798 10.8923 16.2897 10.8639",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.1503C13.6961 10.14 13.6616 10.1319 13.6267 10.1258C13.5799 10.118 13.5324 10.1143 13.4849 10.1148C13.2961 10.1148 13.1472 10.1681 13.0427 10.2735C12.939 10.378 12.8684 10.5373 12.833 10.7469L12.8202 10.8177H12.5832C12.5832 10.8177 12.5543 10.8165 12.5482 10.848L12.5093 11.0651C12.5066 11.0859 12.5155 11.0988 12.5433 11.0987H12.774L12.5399 12.4052C12.5216 12.5104 12.5006 12.597 12.4774 12.6626C12.4545 12.7273 12.4321 12.7758 12.4046 12.811C12.3779 12.8451 12.3527 12.8702 12.309 12.8848C12.273 12.8969 12.2316 12.9025 12.1862 12.9025C12.1609 12.9025 12.1273 12.8982 12.1025 12.8933C12.0777 12.8884 12.0648 12.8828 12.0462 12.875C12.0462 12.875 12.0191 12.8647 12.0085 12.8918C11.9998 12.914 11.9383 13.0831 11.931 13.104C11.9236 13.1246 11.934 13.1409 11.9471 13.1456C11.9778 13.1566 12.0007 13.1636 12.0425 13.1735C12.1006 13.1872 12.1496 13.188 12.1954 13.188C12.2915 13.188 12.3791 13.1745 12.4517 13.1483C12.5247 13.1219 12.5883 13.0759 12.6446 13.0137C12.7054 12.9465 12.7436 12.8761 12.7802 12.7802C12.8164 12.6851 12.8473 12.567 12.8719 12.4294L13.1071 11.0987H13.451C13.451 11.0987 13.48 11.0998 13.486 11.0683L13.5249 10.8513C13.5276 10.8305 13.5187 10.8175 13.4908 10.8177H13.1571C13.1587 10.8101 13.1739 10.6927 13.2122 10.5822C13.2286 10.535 13.2593 10.497 13.2854 10.4708C13.3098 10.4459 13.3397 10.4273 13.3728 10.4164C13.4091 10.4052 13.4469 10.3998 13.4849 10.4003C13.5163 10.4003 13.5471 10.4041 13.5706 10.4089C13.603 10.4158 13.6156 10.4195 13.624 10.422C13.6581 10.4324 13.6626 10.4223 13.6693 10.4058L13.7491 10.1867C13.7573 10.1631 13.7373 10.1532 13.7299 10.1503ZM9.0662 12.408C9.0662 12.4255 9.05376 12.4397 9.03629 12.4397H8.75947C8.74193 12.4397 8.72949 12.4255 8.72949 12.408V10.18C8.72949 10.1626 8.74193 10.1485 8.75947 10.1485H9.03629C9.05376 10.1485 9.0662 10.1626 9.0662 10.18V12.408Z",
                fill: "#FFFFFE"
            })
        ]
    });
};
var $c002cdcd98eda8d3$export$2e2bcd8739ae039 = $c002cdcd98eda8d3$var$SalesforceIcon;





parcelRequire("42omo");

const $9335974b50c62609$var$SentryIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-779.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M13.2634 5.12647C13.1313 4.90729 12.9448 4.72597 12.722 4.6001C12.4992 4.47423 12.2477 4.40808 11.9918 4.40808C11.7359 4.40808 11.4844 4.47423 11.2616 4.6001C11.0388 4.72597 10.8523 4.90729 10.7202 5.12647L8.62849 8.70913C10.2265 9.50694 11.588 10.7089 12.5779 12.1956C13.5677 13.6823 14.1514 15.4021 14.2711 17.1842H12.8024C12.683 15.6566 12.1667 14.1867 11.3047 12.9199C10.4427 11.6531 9.26492 10.6334 7.8878 9.96162L5.95183 13.309C6.726 13.6562 7.40046 14.1925 7.91318 14.8686C8.4259 15.5446 8.76042 16.3387 8.88598 17.1778H5.51314C5.47313 17.175 5.43447 17.1622 5.40062 17.1407C5.36677 17.1192 5.33881 17.0896 5.31926 17.0546C5.2997 17.0196 5.28917 16.9803 5.28861 16.9402C5.28805 16.9001 5.29747 16.8605 5.31604 16.8249L6.25065 15.2355C5.93401 14.9713 5.57212 14.7667 5.18253 14.6315L4.25746 16.2209C4.16115 16.3861 4.09863 16.5688 4.07353 16.7584C4.04842 16.9479 4.06124 17.1406 4.11122 17.3251C4.16121 17.5097 4.24737 17.6825 4.3647 17.8335C4.48203 17.9844 4.62819 18.1106 4.7947 18.2046C5.01407 18.3282 5.26134 18.3938 5.51314 18.3953H10.1321C10.2179 17.3368 10.0289 16.274 9.58332 15.3099C9.13777 14.3459 8.45081 13.5132 7.58898 12.8926L8.32331 11.621C9.41096 12.3681 10.285 13.3858 10.8592 14.5738C11.4334 15.7618 11.6879 17.0789 11.5976 18.3953H15.5109C15.602 16.4012 15.1682 14.418 14.2528 12.6441C13.3373 10.8701 11.9724 9.36748 10.2943 8.28633L11.7788 5.74318C11.8119 5.68775 11.8655 5.64764 11.928 5.63156C11.9906 5.61549 12.0569 5.62476 12.1126 5.65735C12.2811 5.74954 18.5627 16.7105 18.6803 16.8377C18.701 16.8748 18.7115 16.9168 18.7108 16.9593C18.7101 17.0019 18.6982 17.0435 18.6763 17.0799C18.6543 17.1164 18.6232 17.1464 18.5859 17.1669C18.5487 17.1874 18.5066 17.1978 18.4641 17.1969H16.9509C16.97 17.6017 16.97 18.0054 16.9509 18.4081H18.4705C18.6634 18.4093 18.8547 18.3723 19.0333 18.2991C19.2118 18.226 19.3741 18.1181 19.5107 17.9818C19.6473 17.8455 19.7554 17.6835 19.829 17.5051C19.9025 17.3267 19.94 17.1355 19.9391 16.9426C19.9393 16.6877 19.8713 16.4374 19.742 16.2178L13.2634 5.12647Z",
                fill: "white"
            })
        ]
    });
};
var $9335974b50c62609$export$2e2bcd8739ae039 = $9335974b50c62609$var$SentryIcon;





parcelRequire("42omo");

const $c57db68586008b59$var$SharePointIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-650.5",
                y: "-28.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#0B1228",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.1863 13.1429C14.6523 13.1429 16.6514 11.0962 16.6514 8.57143C16.6514 6.0467 14.6523 4 12.1863 4C9.72029 4 7.72119 6.0467 7.72119 8.57143C7.72119 11.0962 9.72029 13.1429 12.1863 13.1429Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.907 16.9525C18.1675 16.9525 20 15.0763 20 12.762C20 10.4477 18.1675 8.57153 15.907 8.57153C13.6465 8.57153 11.814 10.4477 11.814 12.762C11.814 15.0763 13.6465 16.9525 15.907 16.9525Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.7443 20.0001C14.4911 20.0001 15.9071 18.5504 15.9071 16.762C15.9071 14.9737 14.4911 13.5239 12.7443 13.5239C10.9976 13.5239 9.58154 14.9737 9.58154 16.762C9.58154 18.5504 10.9976 20.0001 12.7443 20.0001Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.9302 8.12585V16.2554C12.9283 16.5379 12.7611 16.7916 12.506 16.8992C12.4248 16.9344 12.3374 16.9525 12.2492 16.9525H9.58506C9.58134 16.8878 9.58134 16.8268 9.58134 16.762C9.5801 16.6984 9.58258 16.6348 9.58878 16.5716C9.65688 15.3538 10.3896 14.2794 11.4827 13.7944V13.0858C9.04996 12.6911 7.39032 10.3521 7.77583 7.86137C7.77851 7.84412 7.78127 7.82688 7.78414 7.80966C7.80266 7.68118 7.82876 7.55396 7.86228 7.42871H12.2493C12.6247 7.43017 12.9287 7.74144 12.9302 8.12585Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78421C7.37074 10.2958 9.00415 12.6544 11.4325 13.0777C11.5061 13.0906 11.5799 13.1015 11.654 13.1105C10.5005 13.6705 9.65993 15.261 9.58849 16.5715C9.5823 16.6348 9.57981 16.6984 9.58104 16.7619C9.58104 16.8267 9.58104 16.8877 9.58476 16.9524C9.59147 17.0805 9.60765 17.2078 9.63313 17.3334H11.8769C12.1528 17.3315 12.4006 17.1603 12.5057 16.8991C12.54 16.8159 12.5578 16.7265 12.5578 16.6362V8.50671C12.5564 8.12245 12.2526 7.81125 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78418C7.37079 10.296 9.00445 12.6548 11.4331 13.078C11.4828 13.0867 11.5326 13.0945 11.5825 13.1014C10.4662 13.7018 9.65879 15.2884 9.58883 16.5715H11.8772C12.2521 16.5686 12.5553 16.2581 12.5581 15.8743V8.50671C12.5567 8.1223 12.2527 7.81103 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.505 7.80957H7.78405C7.39371 10.1568 8.8303 12.4172 11.0845 13.0027C10.231 14.0012 9.70744 15.2502 9.58871 16.5715H11.505C11.8805 16.57 12.1845 16.2587 12.1859 15.8743V8.50671C12.1857 8.12178 11.881 7.80978 11.505 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.68205 7.80957H11.504C11.8807 7.80957 12.186 8.1222 12.186 8.50786V15.4922C12.186 15.8779 11.8807 16.1905 11.504 16.1905H4.68205C4.30536 16.1905 4 15.8779 4 15.4922V8.50786C4 8.1222 4.30536 7.80957 4.68205 7.80957Z",
                        fill: "#026D71"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.04621 11.9147C6.88638 11.8062 6.75286 11.6617 6.65588 11.4922C6.56192 11.3151 6.51508 11.1158 6.52007 10.9143C6.5117 10.6415 6.60162 10.3751 6.77272 10.1658C6.95251 9.95618 7.1849 9.80099 7.44472 9.717C7.74082 9.61722 8.05096 9.56805 8.36267 9.57148C8.77258 9.55614 9.18193 9.61482 9.57197 9.74481V10.621C9.40249 10.5159 9.21791 10.4388 9.02499 10.3924C8.81567 10.3399 8.60088 10.3135 8.38536 10.314C8.15809 10.3054 7.93227 10.3544 7.72787 10.4564C7.57007 10.5261 7.46774 10.6851 7.46741 10.861C7.46677 10.9677 7.50682 11.0705 7.57904 11.1475C7.66434 11.2382 7.76525 11.3121 7.87672 11.3654C8.00074 11.4286 8.18679 11.5127 8.43485 11.6176C8.46217 11.6264 8.48879 11.6374 8.51448 11.6504C8.75862 11.748 8.99415 11.867 9.21848 12.0058C9.38837 12.113 9.53095 12.26 9.63449 12.4347C9.74064 12.6328 9.79209 12.8566 9.78332 13.0824C9.79544 13.3624 9.71174 13.6381 9.54667 13.8618C9.38213 14.0674 9.16216 14.219 8.91411 14.2976C8.62236 14.3912 8.31786 14.4365 8.01215 14.4317C7.73787 14.433 7.46399 14.41 7.19355 14.3631C6.96521 14.3249 6.74237 14.2578 6.53011 14.1635V13.2397C6.733 13.388 6.95967 13.4989 7.19988 13.5673C7.43928 13.6437 7.68814 13.6845 7.93886 13.6884C8.17091 13.7035 8.40255 13.6532 8.60863 13.5429C8.75299 13.4595 8.84079 13.3015 8.83709 13.1319C8.83806 13.0138 8.79244 12.9004 8.71058 12.8172C8.60879 12.7149 8.49093 12.6308 8.36194 12.5684C8.2131 12.4922 7.99393 12.3918 7.70445 12.2671C7.47415 12.1723 7.25365 12.0543 7.04621 11.9147Z",
                        fill: "white"
                    })
                ]
            })
        ]
    });
};
var $c57db68586008b59$export$2e2bcd8739ae039 = $c57db68586008b59$var$SharePointIcon;





parcelRequire("42omo");

const $f59be1161c1b0258$var$SlackIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-603.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
                        fill: "#ECB22E"
                    })
                ]
            })
        ]
    });
};
var $f59be1161c1b0258$export$2e2bcd8739ae039 = $f59be1161c1b0258$var$SlackIcon;





parcelRequire("42omo");

const $d739a59c58974af2$var$SmartsheetIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-171.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.2708 12.9524C12.0781 12.5707 11.8938 12.2011 11.6762 11.8499C11.4003 11.4042 11.1009 10.9773 10.6919 10.6414C10.3847 10.3891 10.0444 10.2293 9.63382 10.2899C9.27961 10.3422 8.99393 10.5287 8.73676 10.7652C8.60099 10.8901 8.47697 11.0271 8.36318 11.1923C8.42475 11.2006 8.47588 11.2054 8.52636 11.2146C8.8921 11.2813 9.17343 11.4943 9.4269 11.7487C9.85292 12.1767 10.1699 12.6838 10.4539 13.2121C11.0905 14.3964 11.5574 15.6505 11.9569 16.9316C11.9608 16.944 11.9643 16.9564 11.9732 16.9859C13.5754 13.1534 15.383 9.45358 17.8734 6.12915L17.9021 6.13874C17.9021 6.22486 17.9021 6.31098 17.9021 6.39688C17.9021 9.19064 17.9052 11.9844 17.9002 14.7784C17.8986 15.6202 17.8858 16.4624 17.8233 17.3027C17.8027 17.5811 17.7742 17.8593 17.6754 18.1242C17.5601 18.4333 17.3395 18.5127 17.0594 18.338C16.8218 18.1898 16.6373 17.9825 16.4822 17.754C16.1504 17.2654 15.831 16.7687 15.6093 16.2167C15.5952 16.1814 15.5917 16.1009 15.5142 16.1761C15.009 16.6673 14.4222 17.0471 13.8187 17.4003C12.0839 18.4152 10.2293 19.1317 8.28355 19.6187C7.58535 19.7934 6.88193 19.9416 6.1735 20.0672C6.10497 20.0794 6.08734 20.0753 6.10192 19.997C6.19656 19.4857 6.23986 18.9697 6.23986 18.449C6.23856 14.0349 6.23964 9.6208 6.23638 5.20669C6.23638 5.09615 6.26314 5.07239 6.37128 5.07239C10.1708 5.07544 13.9701 5.075 17.7696 5.075H17.9017C15.5708 7.38279 13.6026 9.93061 12.2715 12.9526L12.2708 12.9524Z",
                fill: "white"
            })
        ]
    });
};
var $d739a59c58974af2$export$2e2bcd8739ae039 = $d739a59c58974af2$var$SmartsheetIcon;





parcelRequire("42omo");

const $9affea886ceab4a6$var$StripeIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.0639 9.32966C11.0639 8.76566 11.5259 8.54366 12.2939 8.54366C13.3979 8.54366 14.7899 8.87966 15.8939 9.47366V6.06566C14.6879 5.58566 13.4999 5.39966 12.2999 5.39966C9.35395 5.39966 7.39795 6.93566 7.39795 9.50366C7.39795 13.5057 12.9119 12.8697 12.9119 14.5977C12.9119 15.2637 12.3299 15.4797 11.5199 15.4797C10.3139 15.4797 8.77795 14.9877 7.55995 14.3217V17.7717C8.90995 18.3537 10.2719 18.5997 11.5199 18.5997C14.5379 18.5997 16.6139 17.1057 16.6139 14.5077C16.5899 10.1877 11.0639 10.9557 11.0639 9.32966Z",
                fill: "white"
            })
        ]
    });
};
var $9affea886ceab4a6$export$2e2bcd8739ae039 = $9affea886ceab4a6$var$StripeIcon;





parcelRequire("42omo");

const $21498f2ed987f6e9$var$TeamsIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-506.5",
                y: "-603.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.1",
                d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.1",
                d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                opacity: "0.2",
                d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
                fill: "white"
            })
        ]
    });
};
var $21498f2ed987f6e9$export$2e2bcd8739ae039 = $21498f2ed987f6e9$var$TeamsIcon;





parcelRequire("42omo");

const $31f411dca8ce7b46$var$TodoistIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-731.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.7653 5.01575H7.2667C6.03236 5.01575 5.03174 6.01638 5.03174 7.25072V16.7493C5.03174 17.9837 6.03236 18.9843 7.2667 18.9843H16.7653C17.9996 18.9843 19.0002 17.9837 19.0002 16.7493V7.25072C19.0002 6.01638 17.9996 5.01575 16.7653 5.01575Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.98402 11.5604L10.7664 9.9593L10.7699 9.95712L13.6369 8.30708C13.7578 8.23724 13.7635 8.02335 13.6282 7.94565L13.5334 7.89152C13.3951 7.81295 13.2161 7.7108 13.1397 7.66628C13.0728 7.62983 12.9976 7.61118 12.9214 7.61209C12.8452 7.61301 12.7705 7.63347 12.7045 7.67151C12.6368 7.7108 8.12065 10.3072 7.96961 10.3932C7.88062 10.4441 7.77988 10.4708 7.67737 10.4708C7.57485 10.4708 7.47412 10.4441 7.38512 10.3932L5 9.00726V10.1854L5.02444 10.1994C5.61985 10.5464 7.02892 11.3671 7.37377 11.5613C7.58286 11.6792 7.78278 11.6766 7.98402 11.5604Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.98402 13.9142L10.7629 12.3148L10.7734 12.3087L13.6369 10.6608C13.7578 10.591 13.7635 10.3767 13.6282 10.2994L13.5334 10.2453C13.3955 10.1667 13.2161 10.0646 13.1397 10.02C13.0728 9.98359 12.9976 9.96494 12.9214 9.96585C12.8452 9.96677 12.7705 9.98723 12.7045 10.0253C12.6368 10.0641 8.12065 12.661 7.96961 12.7465C7.88062 12.7974 7.77988 12.8242 7.67737 12.8242C7.57485 12.8242 7.47412 12.7974 7.38512 12.7465C7.24282 12.6645 5 11.361 5 11.361V12.5387L5.02444 12.5531C5.62029 12.9002 7.02892 13.7204 7.37377 13.9151C7.58286 14.0329 7.78278 14.0303 7.98402 13.9142Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.7668 14.6663L7.98402 16.2679C7.78279 16.384 7.58242 16.3866 7.37377 16.2688C7.02892 16.0741 5.62029 15.2539 5.02444 14.9069L5 14.8924V13.7147L7.38512 15.1002C7.5654 15.2046 7.7889 15.2032 7.96961 15.1002C8.12065 15.0147 12.6368 12.4178 12.7045 12.3785C12.7705 12.3405 12.8452 12.32 12.9214 12.3191C12.9976 12.3182 13.0728 12.3369 13.1397 12.3733C13.3022 12.4673 13.4652 12.5604 13.6286 12.6527C13.7639 12.7304 13.7578 12.9447 13.6369 13.0146L10.7668 14.6663Z",
                fill: "#DE483A"
            })
        ]
    });
};
var $31f411dca8ce7b46$export$2e2bcd8739ae039 = $31f411dca8ce7b46$var$TodoistIcon;





parcelRequire("42omo");

const $80a9ca5eb54c4f1b$var$WebexIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-554.5",
                y: "-363.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M20.5 6.177H3.5V18.551H20.5V6.177Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                mask: "url(#mask0_719_13847)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.77473 18.5019C5.62694 18.5019 4.55554 14.5209 4.31548 13.7465C3.71261 11.8018 3.52935 10.05 3.50994 9.86618C3.39799 8.80539 4.24877 8.06718 5.18252 8.06718C5.8895 8.06718 6.71005 8.49041 6.81877 9.51726C6.83761 9.68995 6.98136 11.1795 7.48984 12.8026C8.02049 14.4964 8.58341 15.1479 8.98879 15.1479C9.64347 15.1479 10.0429 13.4664 10.396 11.8653C10.6562 10.6857 10.9374 9.49712 11.4926 8.44128C12.4585 6.60445 13.9181 6.177 15.1791 6.177C17.944 6.177 19.3278 9.38049 19.3278 10.2105C19.3278 11.5975 18.1965 11.9513 17.7062 11.9513C16.6338 11.9513 16.2703 11.2327 15.9643 10.6029C15.689 10.0363 15.4016 9.56515 15.0299 9.56515C14.9078 9.56515 14.7946 9.62698 14.69 9.73341C13.7662 10.6723 13.4565 15.584 11.6095 17.4612C10.5856 18.5019 9.47152 18.5019 8.77473 18.5019Z",
                        fill: "#00BBFF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M18.8181 8.06718C18.6934 8.06718 18.5681 8.07894 18.4451 8.1032C19.0296 8.94596 19.3221 9.82891 19.3221 10.2104C19.3221 11.5975 18.1907 11.9512 17.7004 11.9512C17.3178 11.9512 17.0254 11.8597 16.7937 11.7134C16.7916 11.7221 16.7895 11.7307 16.7873 11.7394C16.7184 12.0147 16.664 12.3159 16.5698 12.6092C16.3888 13.1729 16.1446 13.8168 15.8839 14.3151C15.6028 14.8523 15.3246 15.1666 14.9929 15.1501C14.6157 15.1314 14.3099 14.6452 13.9298 13.2711C13.8072 12.8281 13.6937 12.3423 13.5885 11.8653C13.3276 10.6822 13.0074 9.49254 12.4598 8.44128C11.5653 6.72426 10.0396 6.177 8.82156 6.177C7.69192 6.177 6.84795 6.71182 6.18495 7.3857C6.00175 7.57192 5.80158 7.82283 5.60059 8.11766C6.17886 8.25694 6.72565 8.69224 6.81293 9.51716C6.83015 9.67444 6.95085 10.9237 7.35628 12.3714C7.4726 12.0084 7.64222 11.4709 8.03625 10.6029C8.22939 10.2054 8.40369 9.94325 8.56092 9.78348C8.70514 9.63686 8.83499 9.57634 8.95193 9.57634C9.07804 9.57634 9.50861 9.69177 9.92778 11.1628C10.4477 12.9869 10.8346 15.8898 12.3086 17.4312C12.9587 18.1111 13.8685 18.551 15.1294 18.551C16.2358 18.551 17.1582 18.0637 17.8159 17.3859C18.8973 16.2712 19.4898 14.4284 19.7011 13.7465C20.3026 11.8064 20.4711 10.0518 20.4907 9.86618C20.6026 8.80539 19.709 8.06718 18.8181 8.06718Z",
                        fill: "#316AFF"
                    })
                ]
            })
        ]
    });
};
var $80a9ca5eb54c4f1b$export$2e2bcd8739ae039 = $80a9ca5eb54c4f1b$var$WebexIcon;





parcelRequire("42omo");

const $17bdaf6b639eb088$var$ZeplinIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    });
};
var $17bdaf6b639eb088$export$2e2bcd8739ae039 = $17bdaf6b639eb088$var$ZeplinIcon;





parcelRequire("42omo");

const $9bcd7036eebc7598$var$ZendeskIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-491.5",
                y: "-219.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#03363D"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.6092 9.34881V17.3365H4.99316L11.6092 9.34881ZM11.6092 6.48242C11.6092 7.35976 11.2607 8.20117 10.6403 8.82155C10.0199 9.44192 9.17853 9.79044 8.30119 9.79044C7.42384 9.79044 6.58244 9.44192 5.96206 8.82155C5.34169 8.20117 4.99316 7.35976 4.99316 6.48242H11.6092ZM12.6991 17.3372C12.6991 16.4598 13.0477 15.6184 13.668 14.9981C14.2884 14.3777 15.1298 14.0292 16.0072 14.0292C16.8845 14.0292 17.7259 14.3777 18.3463 14.9981C18.9667 15.6184 19.3152 16.4598 19.3152 17.3372H12.6991ZM12.6991 14.4708V6.48242H19.3166L12.6991 14.4701V14.4708Z",
                fill: "white"
            })
        ]
    });
};
var $9bcd7036eebc7598$export$2e2bcd8739ae039 = $9bcd7036eebc7598$var$ZendeskIcon;





parcelRequire("42omo");




const $73cf90867809d07b$var$GitbookIcon = ()=>// eslint-disable-next-line @atlassian/a11y/role-img-alt
    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
        })
    });
var $73cf90867809d07b$export$2e2bcd8739ae039 = $73cf90867809d07b$var$GitbookIcon;





parcelRequire("42omo");

const $3698078ac83fd1c3$var$LaunchDarklyIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-683.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M20.0232 12.0808C20.0002 12.2346 19.9148 12.3512 19.8075 12.4584C17.3508 14.9147 14.895 17.3719 12.4389 19.8288C12.4116 19.8561 12.3853 19.8845 12.3562 19.9098C12.2424 20.0088 12.113 20.0247 11.9781 19.9655C11.845 19.9072 11.7732 19.798 11.7632 19.6539C11.7574 19.5702 11.7891 19.4944 11.8388 19.4264C11.9362 19.2931 12.0329 19.1593 12.13 19.0257C12.7486 18.1738 13.3672 17.3218 13.9859 16.47C14.3904 15.913 14.795 15.3562 15.1995 14.7994C15.3066 14.6519 15.4141 14.5047 15.5208 14.357C15.5315 14.3423 15.5483 14.3295 15.5454 14.3065C15.5243 14.3004 15.5082 14.3131 15.4912 14.32C14.8996 14.5611 14.308 14.8024 13.7166 15.0438C13.2263 15.2439 12.7362 15.4442 12.246 15.6446C11.1843 16.0784 10.1224 16.5119 9.06106 16.9467C8.97552 16.9817 8.88978 17.0024 8.79819 16.9813C8.65305 16.9479 8.54691 16.8331 8.52155 16.684C8.49883 16.5505 8.56326 16.4093 8.68877 16.3339C8.9313 16.1881 9.17582 16.0455 9.41951 15.9016C10.289 15.3879 11.1584 14.8742 12.028 14.3607C12.7979 13.9061 13.568 13.4519 14.338 12.9974C14.3655 12.9812 14.3924 12.9642 14.4339 12.9389C14.3588 12.9323 14.2988 12.9253 14.2387 12.922C13.9713 12.9073 13.7038 12.894 13.4363 12.8793C13.2181 12.8673 13 12.8547 12.7819 12.8415C12.5296 12.8261 12.2774 12.8095 12.0251 12.7943C11.9225 12.788 11.8197 12.7846 11.717 12.7786C11.5224 12.7673 11.3279 12.7548 11.1333 12.7432C11.0542 12.7385 10.975 12.7358 10.8959 12.7303C10.7057 12.7172 10.515 12.711 10.3246 12.6999C10.0723 12.6852 9.82012 12.6679 9.56774 12.6531C9.48432 12.6482 9.40084 12.6449 9.31742 12.6397C9.0523 12.6232 8.78686 12.6112 8.52161 12.5966C8.29917 12.5844 8.07679 12.5711 7.85434 12.5583C7.62765 12.5453 7.40082 12.5335 7.17426 12.519C6.95188 12.5048 6.72956 12.4913 6.50699 12.4805C6.28229 12.4696 6.05785 12.4551 5.83328 12.4422C5.61083 12.4294 5.38845 12.4166 5.166 12.4038C4.94356 12.391 4.72111 12.3791 4.49873 12.3648C4.43675 12.3608 4.37431 12.3592 4.31284 12.3523C4.16358 12.3353 4.05918 12.256 4.00602 12.1135C3.99707 12.0894 3.99243 12.0637 3.97705 12.0422V11.9393C3.99733 11.9207 3.99932 11.8936 4.0091 11.8701C4.06504 11.736 4.16332 11.6549 4.30917 11.6409C4.4307 11.6293 4.5528 11.6239 4.67464 11.6167C4.89921 11.6034 5.12378 11.5908 5.34835 11.5778C5.5708 11.565 5.79318 11.5517 6.01569 11.5395C6.28312 11.5249 6.55069 11.513 6.818 11.4964C6.89929 11.4914 6.98058 11.4877 7.06188 11.483C7.24364 11.4725 7.42528 11.4591 7.60705 11.4487C7.79532 11.438 7.98384 11.432 8.17185 11.4184C8.25315 11.4125 8.33451 11.4106 8.4158 11.4056C8.60606 11.3938 8.79639 11.3816 8.98672 11.3705C9.08938 11.3644 9.19223 11.3612 9.2949 11.355C9.54721 11.3397 9.79945 11.3229 10.0518 11.3077C10.2741 11.2942 10.4967 11.282 10.7191 11.2693C10.9458 11.2563 11.1726 11.2433 11.3993 11.2303C11.6196 11.2176 11.8398 11.2048 12.0602 11.1922C12.2847 11.1792 12.5093 11.1658 12.7339 11.1535C13.0014 11.1389 13.2689 11.127 13.5362 11.1105C13.6175 11.1055 13.6988 11.1016 13.7801 11.0971C13.9812 11.0858 14.1821 11.0732 14.3832 11.0609C14.3985 11.0599 14.4156 11.0646 14.4308 11.0529C14.4137 11.033 14.3934 11.0251 14.3751 11.0143C13.5146 10.5062 12.654 9.99844 11.7936 9.49047C10.898 8.96178 10.0024 8.43308 9.10689 7.90432C8.96837 7.82258 8.82909 7.74206 8.69192 7.65813C8.56776 7.58211 8.50449 7.44392 8.52374 7.31442C8.55817 7.0829 8.80701 6.93975 9.02933 7.03359C9.54483 7.25121 10.0641 7.45969 10.5821 7.67152C11.5167 8.05372 12.4516 8.43553 13.3863 8.81767C14.0887 9.10486 14.7912 9.39225 15.4938 9.679C15.5099 9.68556 15.5262 9.70217 15.5467 9.68743C15.5473 9.66503 15.5315 9.65177 15.5205 9.63665C15.1123 9.07442 14.7037 8.51251 14.2954 7.95041C13.7824 7.24426 13.2698 6.53792 12.7569 5.8317C12.4532 5.41352 12.1522 4.99341 11.8443 4.57832C11.679 4.35536 11.8105 4.07621 12.0167 4.01719C12.031 4.01313 12.0443 4.00579 12.0581 4C12.101 4 12.1439 4 12.1868 4C12.282 4.02349 12.354 4.08136 12.4221 4.14939C14.8857 6.61367 17.3497 9.07744 19.8147 11.5404C19.9208 11.6464 20.0037 11.7613 20.0233 11.9138V12.081L20.0232 12.0808Z",
                fill: "white"
            })
        ]
    });
};
var $3698078ac83fd1c3$export$2e2bcd8739ae039 = $3698078ac83fd1c3$var$LaunchDarklyIcon;





parcelRequire("42omo");

const $9db123cd7b504f9e$var$PagerDutyIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-731.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.33974 9.0588C7.33988 9.05866 7.33996 9.05847 7.33996 9.05827C7.33996 7.60876 7.34084 6.15925 7.3382 4.70974C7.3382 4.5796 7.33644 4.4987 7.51495 4.50002C9.30876 4.51057 11.1026 4.49738 12.8964 4.51892C13.9116 4.53123 14.8801 4.77262 15.7546 5.30858C16.8256 5.96414 17.4222 6.94066 17.6117 8.16868C17.8148 9.48551 17.6012 10.7206 16.7918 11.8057C16.1033 12.7294 15.1439 13.2175 14.0285 13.4329C13.3347 13.567 12.6326 13.5846 11.9309 13.5899C10.4668 13.6013 9.00231 13.5912 7.53781 13.5991C7.36414 13.6 7.33557 13.5411 7.33645 13.3859C7.34172 11.9438 7.33952 10.5014 7.33952 9.05933C7.33952 9.05913 7.3396 9.05894 7.33974 9.0588Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.35232 17.4818C7.35232 16.8821 7.35539 16.2819 7.34968 15.6822C7.34836 15.5516 7.36463 15.4905 7.52246 15.4931C8.14414 15.5037 8.76626 15.5024 9.38794 15.4931C9.53215 15.4909 9.55281 15.5415 9.55237 15.6681C9.54798 16.89 9.5471 18.1118 9.55325 19.3333C9.55413 19.4753 9.50841 19.5003 9.37959 19.499C8.75791 19.4929 8.13579 19.4911 7.51411 19.4999C7.3699 19.5021 7.34836 19.452 7.34968 19.3249C7.35583 18.7102 7.35232 18.096 7.35232 17.4813V17.4818Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.54312 8.99636C9.54312 8.1834 9.54488 7.37088 9.54093 6.55791C9.54049 6.43788 9.55148 6.37589 9.70184 6.37677C10.7051 6.38424 11.7084 6.36446 12.7113 6.38776C13.2833 6.40095 13.8408 6.53021 14.3464 6.81996C15.0103 7.20028 15.3295 7.79604 15.3967 8.54042C15.4464 9.09221 15.4223 9.63697 15.1853 10.1514C14.8072 10.9723 14.1037 11.3416 13.2675 11.521C12.8942 11.601 12.5143 11.6195 12.1332 11.6195C11.3422 11.619 10.5513 11.612 9.76075 11.6247C9.56818 11.6278 9.53697 11.565 9.53917 11.3913C9.5484 10.5933 9.54312 9.79481 9.54312 8.9968V8.99636Z",
                fill: "#04AB38"
            })
        ]
    });
};
var $9db123cd7b504f9e$export$2e2bcd8739ae039 = $9db123cd7b504f9e$var$PagerDutyIcon;





parcelRequire("42omo");

const $a2db9f138882b352$var$PowerBIIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-602.5",
                y: "-507.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.4031 4H13.1618C12.7971 4 12.5015 4.29563 12.5015 4.66032V19.3397C12.5015 19.7044 12.7971 20 13.1618 20H17.4031C17.7677 20 18.0634 19.7044 18.0634 19.3397V4.66032C18.0634 4.29563 17.7677 4 17.4031 4Z",
                fill: "#B25400"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "#DE9800"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3394V19.9998H6.66032C6.29562 19.9998 6 19.7041 6 19.3394V12.6601C6 12.2954 6.29562 11.9998 6.66032 11.9998H10.9016C11.2663 11.9998 11.5619 12.2954 11.5619 12.6601V19.3394Z",
                fill: "#F3CD32"
            })
        ]
    });
};
var $a2db9f138882b352$export$2e2bcd8739ae039 = $a2db9f138882b352$var$PowerBIIcon;





parcelRequire("42omo");

const $ad198126728ea2d1$var$ServiceNowIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-539.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0473 4.00178C10.4382 3.99842 8.86528 4.4785 7.53234 5.37978C6.19941 6.28105 5.16796 7.56197 4.57171 9.05646C3.97546 10.5509 3.84191 12.1901 4.18837 13.7614C4.53483 15.3327 5.34532 16.7637 6.51478 17.8688C6.78908 18.13 7.14782 18.2844 7.52608 18.3041C7.90434 18.3237 8.27713 18.2073 8.57701 17.9759C9.56641 17.2396 10.7668 16.842 12.0001 16.842C13.2334 16.842 14.4339 17.2396 15.4233 17.9759C15.726 18.2078 16.1021 18.3232 16.4828 18.301C16.8635 18.2788 17.2236 18.1205 17.4973 17.8549C18.6576 16.7539 19.4626 15.3314 19.8092 13.7698C20.1558 12.2082 20.0282 10.5787 19.4426 9.09017C18.8571 7.60161 17.8404 6.32184 16.5228 5.41488C15.2052 4.50793 13.6467 4.01512 12.0473 3.99963M12.0001 16.0379C11.4713 16.0522 10.9451 15.9586 10.4536 15.7628C9.96216 15.567 9.51573 15.2731 9.1416 14.8991C8.76746 14.525 8.47347 14.0787 8.27754 13.5873C8.08161 13.0959 7.98787 12.5697 8.00202 12.0408C8.00202 10.9805 8.42326 9.96353 9.17305 9.21374C9.92284 8.46395 10.9398 8.04272 12.0001 8.04272C13.0605 8.04272 14.0774 8.46395 14.8272 9.21374C15.577 9.96353 15.9983 10.9805 15.9983 12.0408C16.0124 12.5697 15.9187 13.0959 15.7227 13.5873C15.5268 14.0787 15.2328 14.525 14.8587 14.8991C14.4846 15.2731 14.0381 15.567 13.5467 15.7628C13.0552 15.9586 12.529 16.0522 12.0001 16.0379Z",
                fill: "#62D84E"
            })
        ]
    });
};
var $ad198126728ea2d1$export$2e2bcd8739ae039 = $ad198126728ea2d1$var$ServiceNowIcon;





parcelRequire("42omo");

const $ab446c4f11477054$var$AWSS3Icon = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                width: "24",
                height: "24",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        id: "Icon-Architecture-BG/64/Storage",
                        fill: "#7AA116",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            id: "Rectangle",
                            x: "0",
                            y: "0",
                            width: "24",
                            height: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
                        transform: "scale(0.3) translate(12.999900, 11.999600)",
                        fill: "#FFFFFF",
                        width: "24",
                        height: "24",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
                            id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
                        })
                    })
                ]
            })
        ]
    });
var $ab446c4f11477054$export$2e2bcd8739ae039 = $ab446c4f11477054$var$AWSS3Icon;





parcelRequire("42omo");

const $6e09550576c833cf$export$e16bd899bb4eebf9 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "-587.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.20962 17.0782L5.91523 18.2907C6.06186 18.546 6.27262 18.7466 6.52005 18.8925L9.04009 14.5529H4C4 14.8355 4.07331 15.1181 4.21993 15.3734L5.20962 17.0782Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12 9.44751L9.47995 5.10791C9.23253 5.25378 9.02176 5.45435 8.87514 5.70962L4.21993 13.7324C4.07601 13.9822 4.00019 14.265 4 14.5529H9.04009L12 9.44751Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.4799 18.8925C17.7273 18.7466 17.9381 18.546 18.0847 18.2907L18.3779 17.7893L19.78 15.3734C19.9266 15.1181 19.9999 14.8355 19.9999 14.5529H14.9595L16.032 16.6497L17.4799 18.8925Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12 9.4475L14.5201 5.1079C14.2726 4.96203 13.9886 4.8891 13.6953 4.8891H10.3047C10.0115 4.8891 9.7274 4.97115 9.47998 5.1079L12 9.4475Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.9594 14.5529H9.03958L6.51953 18.8925C6.76695 19.0383 7.05103 19.1113 7.34427 19.1113H16.6547C16.9479 19.1113 17.232 19.0292 17.4794 18.8925L14.9594 14.5529Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.4525 9.72101L15.1249 5.70962C14.9782 5.45435 14.7675 5.25378 14.52 5.10791L12 9.44751L14.9599 14.5529H19.9908C19.9908 14.2703 19.9175 13.9877 19.7709 13.7324L17.4525 9.72101Z",
                        fill: "#FFBA00"
                    })
                ]
            })
        ]
    });
};
var $6e09550576c833cf$export$2e2bcd8739ae039 = $6e09550576c833cf$export$e16bd899bb4eebf9;





parcelRequire("42omo");






const $9dca3af2d039b729$var$t25IconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $ecnYn.xcss)({
        width: '32x',
        height: '32px'
    })
};
const $9dca3af2d039b729$var$iconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
function $9dca3af2d039b729$export$f2e275790a265e16(t25LogoComponent, LogoComponent) {
    return t25LogoComponent;
}
function $9dca3af2d039b729$export$fab9faef3411dc6c(iconGlyph, iconLabel) {
    return $9dca3af2d039b729$export$dae027fade2c6d1d(iconGlyph, iconLabel);
}
const $9dca3af2d039b729$export$1776e6671850176d = ({ glyph: SVG, label: label, size: size })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            $9dca3af2d039b729$var$t25IconContainerStyles[size],
            $9dca3af2d039b729$var$iconStyles
        ],
        "aria-label": label,
        children: /*#__PURE__*/ (0, $l998X.jsx)(SVG, {})
    });
};
const $9dca3af2d039b729$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: "small",
            appearance: "brand"
        });
    };
};
function $9dca3af2d039b729$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            ...props,
            shouldUseNewLogoDesign: true
        });
}
const $9dca3af2d039b729$export$dae027fade2c6d1d = (glyph, defaultLabel = '')=>{
    return ({ label: label = defaultLabel })=>/*#__PURE__*/ (0, $l998X.jsx)($9dca3af2d039b729$export$1776e6671850176d, {
            label: label,
            glyph: glyph,
            size: "medium"
        });
};


const $f69e6a05e0e63212$var$ProductKeys3P = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    JsmDC: 'jsm-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3'
};
const $f69e6a05e0e63212$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury'
};
const $f69e6a05e0e63212$var$products1PIcons = {
    [$f69e6a05e0e63212$var$ProductKeys1P.Confluence]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.ConfluenceIcon)), 'Confluence'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Atlas]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $4Nwes.AtlassianIcon), 'Home'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Jira]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.JiraIcon)), 'Jira'),
    [$f69e6a05e0e63212$var$ProductKeys1P.JiraProductDiscovery]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.JiraProductDiscoveryIcon)), 'Jira Product Discovery'),
    [$f69e6a05e0e63212$var$ProductKeys1P.JiraServiceManagement]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.JiraServiceManagementIcon)), 'Jira Service Management'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Bitbucket]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.BitbucketIcon)), 'Bitbucket'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Trello]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.TrelloIcon)), 'Trello'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Compass]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.CompassIcon)), 'Compass'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Focus]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.FocusIcon)), 'Focus')
};
const $f69e6a05e0e63212$var$products3PIcons = {
    [$f69e6a05e0e63212$var$ProductKeys3P.AdobeXD]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $cfe74c44e346a556$export$2e2bcd8739ae039), 'Adobe XD'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AdobeSign]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $5694a8281bd37d8b$export$2e2bcd8739ae039), 'Adobe Sign'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Aha]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $2925c70e149e0de5$export$2e2bcd8739ae039), 'Aha'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Airtable]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $5642884c1dd34cff$export$2e2bcd8739ae039), 'Airtable'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Amplitude]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $e49fc528719c2d47$export$2e2bcd8739ae039), 'Amplitude'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Asana]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $dd4523c3c0079a21$export$2e2bcd8739ae039), 'Asana'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AzureDevops]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $53660837dec24876$export$2e2bcd8739ae039), 'Azure Devops'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Box]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $7b4c7485efb04e66$export$2e2bcd8739ae039), 'Box'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Canva]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $a8045fbc5fd77557$export$2e2bcd8739ae039), 'Canva'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Docusign]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $5cc910e047331ab3$export$2e2bcd8739ae039), 'Docusign'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Dovetail]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $dd8c52e47d888b99$export$2e2bcd8739ae039), 'Dovetail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Dropbox]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $317758376a6d0f17$export$2e2bcd8739ae039), 'Dropbox'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Figma]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $b8ffc72fdfda17ef$export$2e2bcd8739ae039), 'Figma'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Freshservice]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $a895e192628ab9a7$export$2e2bcd8739ae039), 'Freshservice'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gmail]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $ebee6edabad8a9c4$export$2e2bcd8739ae039), 'Gmail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Github]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $37eb7b587ecd273b$export$2e2bcd8739ae039), 'Github'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gitlab]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $aa50a4b50f89009d$export$2e2bcd8739ae039), 'Gitlab'),
    [$f69e6a05e0e63212$var$ProductKeys3P.GoogleCalendar]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $1a2c5202162d89c8$export$2e2bcd8739ae039), 'Google Calendar'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Hubspot]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $cf8fe8259ed5344f$export$2e2bcd8739ae039), 'Hubspot'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Lucid]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $a5f11824900bc125$export$2e2bcd8739ae039), 'Lucid'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Loom]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $65126ba42d15d21a$export$2e2bcd8739ae039), 'Loom'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Miro]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $cb3865c96b8d866c$export$2e2bcd8739ae039), 'Miro'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Monday]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $0516226a48c56413$export$2e2bcd8739ae039), 'Monday'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Mural]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $39ba9afef184103e$export$2e2bcd8739ae039), 'Mural'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Notion]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $146e6df0b25543ec$export$2e2bcd8739ae039), 'Notion'),
    [$f69e6a05e0e63212$var$ProductKeys3P.OutlookCalendar]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $00d08bb2217642b2$export$2e2bcd8739ae039), 'Outlook Calendar'),
    [$f69e6a05e0e63212$var$ProductKeys3P.OutlookMail]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $b09cd2aa9525d4b4$export$2e2bcd8739ae039), 'Outlook Mail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Pipedrive]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $854c18960b2d6ffb$export$2e2bcd8739ae039), 'Pipedrive'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Salesforce]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $c002cdcd98eda8d3$export$2e2bcd8739ae039), 'Salesforce'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Sentry]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $9335974b50c62609$export$2e2bcd8739ae039), 'Sentry'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Sharepoint]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $c57db68586008b59$export$2e2bcd8739ae039), 'Sharepoint'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Slack]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $f59be1161c1b0258$export$2e2bcd8739ae039), 'Slack'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Smartsheet]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $d739a59c58974af2$export$2e2bcd8739ae039), 'Smartsheet'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Stripe]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $9affea886ceab4a6$export$2e2bcd8739ae039), 'Stripe'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Teams]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $21498f2ed987f6e9$export$2e2bcd8739ae039), 'Teams'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Todoist]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $31f411dca8ce7b46$export$2e2bcd8739ae039), 'Todoist'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Webex]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $80a9ca5eb54c4f1b$export$2e2bcd8739ae039), 'Webex'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Zeplin]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $17bdaf6b639eb088$export$2e2bcd8739ae039), 'Zeplin'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Zendesk]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $9bcd7036eebc7598$export$2e2bcd8739ae039), 'Zendesk'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gitbook]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $73cf90867809d07b$export$2e2bcd8739ae039), 'Gitbook'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AtlassianWebCrawler]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), 'Atlassian Web Crawler'),
    [$f69e6a05e0e63212$var$ProductKeys3P.ConfluenceDC]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.ConfluenceIcon)), 'Confluence'),
    [$f69e6a05e0e63212$var$ProductKeys3P.JiraDC]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.JiraIcon)), 'Jira'),
    [$f69e6a05e0e63212$var$ProductKeys3P.JsmDC]: (0, $9dca3af2d039b729$export$32db889b380fa03c)((0, $9dca3af2d039b729$export$a34cd1871c6541c9)((0, $lAFHW.JiraServiceManagementIcon)), 'Jira Service Management'),
    [$f69e6a05e0e63212$var$ProductKeys3P.LaunchDarkly]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $3698078ac83fd1c3$export$2e2bcd8739ae039), 'LaunchDarkly'),
    [$f69e6a05e0e63212$var$ProductKeys3P.PagerDuty]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $9db123cd7b504f9e$export$2e2bcd8739ae039), 'PagerDuty'),
    [$f69e6a05e0e63212$var$ProductKeys3P.PowerBI]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $a2db9f138882b352$export$2e2bcd8739ae039), 'PowerBI'),
    [$f69e6a05e0e63212$var$ProductKeys3P.ServiceNow]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $ad198126728ea2d1$export$2e2bcd8739ae039), 'ServiceNow'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AWSS3]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $ab446c4f11477054$export$2e2bcd8739ae039), 'AWSS3'),
    [$f69e6a05e0e63212$var$ProductKeys3P.GoogleDrive]: (0, $9dca3af2d039b729$export$fab9faef3411dc6c)((0, $6e09550576c833cf$export$2e2bcd8739ae039), 'GoogleDrive')
};
const $f69e6a05e0e63212$var$productIcons = {
    ...$f69e6a05e0e63212$var$products1PIcons,
    ...$f69e6a05e0e63212$var$products3PIcons
};
const $f69e6a05e0e63212$export$92e44ea1079b9ec6 = {
    ...$f69e6a05e0e63212$var$ProductKeys1P,
    ...$f69e6a05e0e63212$var$ProductKeys3P
};
const $f69e6a05e0e63212$export$1a199e029d5e93d6 = ({ productKey: productKey })=>{
    const Icon = $f69e6a05e0e63212$var$productIcons[productKey];
    return Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: productKey
    }) : null;
};






const $8c4486081ff94342$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $8c4486081ff94342$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $644bc14e6914d1ea$export$defe85febe8b728c).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $644bc14e6914d1ea$export$defe85febe8b728c).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $644bc14e6914d1ea$export$defe85febe8b728c).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $644bc14e6914d1ea$export$defe85febe8b728c).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $644bc14e6914d1ea$export$defe85febe8b728c).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $644bc14e6914d1ea$export$defe85febe8b728c).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $f69e6a05e0e63212$export$92e44ea1079b9ec6).Sharepoint || product === (0, $f69e6a05e0e63212$export$92e44ea1079b9ec6).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $f69e6a05e0e63212$export$92e44ea1079b9ec6).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    return label;
};
const $8c4486081ff94342$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $644bc14e6914d1ea$export$defe85febe8b728c)) return (0, $644bc14e6914d1ea$export$defe85febe8b728c)[labelKey];
    else return (0, $644bc14e6914d1ea$export$defe85febe8b728c).otherLabel;
};
const $8c4486081ff94342$var$mapConfluenceActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $f69e6a05e0e63212$export$1a199e029d5e93d6), {
        productKey: (0, $f69e6a05e0e63212$export$92e44ea1079b9ec6).Confluence
    });
    const spaceName = space?.name || '';
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    if (!title || !url) return undefined;
    return {
        id: id,
        url: url,
        icon: icon,
        type: activity.object.type,
        title: title,
        meta: spaceName,
        containerId: (0, $lNtmT.transformAriToId)(space?.id || 'UNAVAILABLE', 'space'),
        additionalMeta: timestamp ? (0, $e5e658f2850ebd6c$export$406508d2ca449bd)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapJiraActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $f69e6a05e0e63212$export$1a199e029d5e93d6), {
        productKey: (0, $f69e6a05e0e63212$export$92e44ea1079b9ec6).Jira
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const meta = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: activity.object.type
    });
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        url: webUrl,
        icon: icon,
        type: activity.object.type,
        title: title,
        meta: meta,
        containerId: '',
        additionalMeta: timestamp ? (0, $e5e658f2850ebd6c$export$406508d2ca449bd)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapTownsquareActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $f69e6a05e0e63212$export$1a199e029d5e93d6), {
        productKey: (0, $f69e6a05e0e63212$export$92e44ea1079b9ec6).Atlas
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    if (!name || !url) return undefined;
    return {
        id: id,
        url: url,
        icon: icon,
        type: activity.object.type,
        title: name,
        meta: key,
        containerId: '',
        additionalMeta: timestamp ? (0, $e5e658f2850ebd6c$export$406508d2ca449bd)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphDocumentActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url } = activity.object.data;
    const id = activity.object.id;
    const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
    const resourceType = resourceOwner.split('.').at(1);
    const product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    if (!Object.values((0, $f69e6a05e0e63212$export$92e44ea1079b9ec6)).includes(product)) return;
    const title = displayName;
    if (!title || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $f69e6a05e0e63212$export$1a199e029d5e93d6), {
        productKey: product
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const subtype = type?.category?.toLowerCase();
    const label = $8c4486081ff94342$export$a47c0c6de01249fd({
        product: product,
        subtype: subtype
    });
    const typeLabel = label ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...label
        })
    }) : subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
    }) : null;
    return {
        id: id,
        url: url,
        icon: icon,
        type: type,
        title: title,
        meta: typeLabel,
        containerId: parent?.id || 'UNAVAILABLE',
        additionalMeta: timestamp ? (0, $e5e658f2850ebd6c$export$406508d2ca449bd)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphRemoteLinkActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const { displayName: displayName, category: category, url: url } = activity.object.data;
    const id = activity.object.id;
    const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
    const resourceType = resourceOwner.split('.').at(1);
    const product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    if (!Object.values((0, $f69e6a05e0e63212$export$92e44ea1079b9ec6)).includes(product)) return;
    const title = displayName;
    if (!title || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $f69e6a05e0e63212$export$1a199e029d5e93d6), {
        productKey: product
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const subtype = category?.toLowerCase();
    const label = $8c4486081ff94342$export$19dc2415a5fa9123({
        product: product,
        subtype: subtype
    });
    const typeLabel = label ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...label
        })
    }) : subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
    }) : null;
    return {
        id: id,
        url: url,
        icon: icon,
        type: category,
        title: title,
        meta: typeLabel,
        containerId: 'UNAVAILABLE',
        additionalMeta: timestamp ? (0, $e5e658f2850ebd6c$export$406508d2ca449bd)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphActivityToSearchResult = (activity)=>{
    if ((0, $hWR4v.isDocumentActivity)(activity.object)) return $8c4486081ff94342$var$mapGraphDocumentActivityToSearchResult(activity);
    if ((0, $hWR4v.isRemoteLinkActivity)(activity.object)) return $8c4486081ff94342$var$mapGraphRemoteLinkActivityToSearchResult(activity);
    return undefined;
};
const $8c4486081ff94342$export$b4f3fd6ea4c72985 = (edge, searchSessionId)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const result = (0, $hWR4v.isGraphActivity)(activity.object) ? $8c4486081ff94342$var$mapGraphActivityToSearchResult(activity) : product === 'confluence' ? $8c4486081ff94342$var$mapConfluenceActivityToSearchResult(activity) : product === 'jira' ? $8c4486081ff94342$var$mapJiraActivityToSearchResult(activity) : product === 'townsquare' ? $8c4486081ff94342$var$mapTownsquareActivityToSearchResult(activity) : undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams
    };
};


const $474e7b9761beed17$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $474e7b9761beed17$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $474e7b9761beed17$export$ae65634d024c5427 = async (cloudId, searchSessionId)=>{
    return await (0, $ja8yA.recentActivitiesQuery)({
        variables: {
            filteredProducts: $474e7b9761beed17$export$48de245659972a87,
            filteredObjectTypes: $474e7b9761beed17$export$742b5ce6018da1f4,
            filteredRootContainerIds: [
                `ari:cloud:platform::site/${cloudId}`,
                `ari:cloud:townsquare::site/${cloudId}`
            ],
            filteredEventTypes: [],
            itemsLimit: 200
        }
    }).then((response)=>{
        const edges = response.data?.activity?.myActivity?.all?.edges || [];
        try {
            return edges.map((edge)=>(0, $8c4486081ff94342$export$b4f3fd6ea4c72985)(edge, searchSessionId || ''));
        } catch  {
            return [];
        }
    }).catch((error)=>{
        throw error;
    });
};






var $lfOhG = parcelRequire("lfOhG");


var $74Udv = parcelRequire("74Udv");

const $6bef6d6b7bd7e701$export$6f9668437bcabf4e = 'rovo-cross-product';
const $6bef6d6b7bd7e701$var$resultRenderer = (args)=>(0, $ejGzS.defaultResultRenderer)({
        ...args,
        isCollapsed: true
    });
const $6bef6d6b7bd7e701$export$6ca9415334f42abe = ()=>{
    const intl = (0, $8C5kA.default)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const [results, setResults] = (0, $42omo.useState)([]);
    const [isQueryResolved, setIsQueryResolved] = (0, $42omo.useState)(false);
    const hasFilters = (0, $lfOhG.useCurrentProductHasAppliedFilters)();
    const preQuerySupplier = (0, $42omo.useCallback)(async ()=>{
        let currentResults = results;
        if (!isQueryResolved) {
            const response = await (0, $474e7b9761beed17$export$ae65634d024c5427)(cloudId || '', searchSessionId || '');
            currentResults = response.filter((result)=>result !== undefined);
            setResults(currentResults);
            setIsQueryResolved(true);
        }
        return {
            size: currentResults.length,
            sections: [
                {
                    id: (0, $7a3bb0801b8c1429$export$8b40788ab131f69a).RECENTS,
                    title: intl.formatMessage((0, $644bc14e6914d1ea$export$defe85febe8b728c).cross_product_recents_section_heading),
                    searchResults: currentResults,
                    resultRenderer: $6bef6d6b7bd7e701$var$resultRenderer
                }
            ]
        };
    }, [
        cloudId,
        intl,
        isQueryResolved,
        results,
        searchSessionId
    ]);
    const postQuerySupplier = (0, $42omo.useCallback)(async (args)=>{
        let currentResults = results;
        if (!isQueryResolved) {
            const response = await (0, $474e7b9761beed17$export$ae65634d024c5427)(cloudId || '', searchSessionId || '');
            currentResults = response.filter((result)=>result !== undefined);
            setResults(currentResults);
            setIsQueryResolved(true);
        }
        const searchResults = {
            size: currentResults.length,
            sections: [
                {
                    id: (0, $7a3bb0801b8c1429$export$8b40788ab131f69a).RESULTS,
                    title: intl.formatMessage((0, $644bc14e6914d1ea$export$defe85febe8b728c).cross_product_results_section_heading),
                    searchResults: currentResults,
                    resultRenderer: $6bef6d6b7bd7e701$var$resultRenderer
                }
            ]
        };
        return (0, $74Udv.filterFirstSectionItems)(searchResults, args.query, hasFilters ? 0 : 3);
    }, [
        cloudId,
        intl,
        isQueryResolved,
        results,
        searchSessionId,
        hasFilters
    ]);
    return {
        preQuerySupplier: preQuerySupplier,
        postQuerySupplier: postQuerySupplier
    };
};



const $b16b15c35dd761da$var$SearchAIPromptComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("1YJgS")).then(({ SearchAIPrompt: SearchAIPrompt })=>({
            default: SearchAIPrompt
        })));
const $b16b15c35dd761da$var$useShowAIButton = (activeProduct, query)=>{
    const previousActiveProductRef = (0, $42omo.useRef)(activeProduct);
    (0, $42omo.useEffect)(()=>{
        if (activeProduct) previousActiveProductRef.current = activeProduct;
    }, [
        activeProduct
    ]);
    const showAIButton = (0, $42omo.useMemo)(()=>{
        if (activeProduct) return !!activeProduct.aiSearchConfig;
        else // We need this to handle closed dialog case:
        // if activeProduct is undefined, use previousActiveProductRef
        return !!previousActiveProductRef.current?.aiSearchConfig && query.length > 0;
    }, [
        activeProduct,
        query
    ]);
    return showAIButton;
};
const $b16b15c35dd761da$var$AskAIButton = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const queryHash = (0, $3S0fp.sha256Hash)(query);
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const shouldShowButton = $b16b15c35dd761da$var$useShowAIButton(activeProduct, query);
    const handleToggleShowSearchAIDialog = (0, $42omo.useCallback)((show)=>{
        if (isGriffinNavEnabled) setIsExpanded(show);
        toggleShowSearchAIDialog(show);
    }, [
        isGriffinNavEnabled,
        setIsExpanded,
        toggleShowSearchAIDialog
    ]);
    return shouldShowButton || !!showSearchAIDialog && isExpanded || isGriffinNavEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)($b16b15c35dd761da$var$SearchAIPromptComponent, {
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            onToggleShowSearchAIDialog: handleToggleShowSearchAIDialog,
            source: "searchDialog"
        })
    }) : null;
};
const $b16b15c35dd761da$var$getTooltipContent = (message)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $be76b25cc1b2639d$export$e2deb14b255cffa0), {
        children: [
            message,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $be76b25cc1b2639d$export$47a1bf8d9994c680), {
                children: '/'
            })
        ]
    });
class $b16b15c35dd761da$export$f964308946b6123b extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        const { onInput: onInput, stickySearchEnabled: stickySearchEnabled } = this.props;
        const skeletonFocused = (0, $fG2rA.getInputSkeletonFocus)();
        const skeletonQuery = (0, $fG2rA.getInputSkeletonQuery)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $fG2rA.getInputSkeletonSelection)();
        const stickySearchQuery = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY)) || '';
        if (skeletonFocused) {
            this.expand((0, $5dFS9.Trigger).CLICK);
            onInput?.(skeletonQuery);
            if (this.ref) {
                this.ref.value = skeletonQuery;
                this.ref.focus();
                this.ref?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $fG2rA.removeInputSkeletonState)();
        if (stickySearchEnabled && stickySearchQuery) onInput?.(stickySearchQuery);
    }
    render() {
        const { value: value, isExpanded: isExpanded, expandedPlaceholder: expandedPlaceholder, collapsedPlaceholder: collapsedPlaceholder, debounceTime: debounceTime, intl: intl, showAIToggleButton: showAIToggleButton, isQuickFind: isQuickFind, activeProduct: activeProduct, ...rest } = this.props;
        const placeholder = isExpanded ? expandedPlaceholder : collapsedPlaceholder;
        const tooltipContent = $b16b15c35dd761da$var$getTooltipContent(intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder));
        const SearchInputComponent = isQuickFind ? (0, $701d0a94d5d1fefc$export$2e2bcd8739ae039) : (0, $1IGQP.default);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b3576e5ec930ddc0$export$2e2bcd8739ae039), {
                    query: value,
                    debounceTime: debounceTime,
                    activeProduct: activeProduct
                }) : null,
                /*#__PURE__*/ (0, $l998X.jsx)(SearchInputComponent, {
                    ...rest,
                    onClick: this.onInputClick,
                    onInput: this.onInput,
                    ref: this.onRef,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    value: value,
                    onEnter: this.onEnter,
                    onClear: this.onClear,
                    toggleAISearchButton: showAIToggleButton ? /*#__PURE__*/ (0, $l998X.jsx)($b16b15c35dd761da$var$AskAIButton, {}) : undefined,
                    tooltipContent: tooltipContent,
                    exitSearchLabel: intl.formatMessage((0, $bF0iL.messages).common_search_input_exit_button_label),
                    clearSearchLabel: intl.formatMessage((0, $bF0iL.messages).common_search_input_clear_button_label),
                    ariaLabelContent: intl.formatMessage(isQuickFind ? (0, $bF0iL.messages).common_search_input_enlarged_aria_label : (0, $bF0iL.messages).common_search_input_aria_label)
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.onInput = (value)=>{
            if (value !== this.props.value) {
                this.expand((0, $5dFS9.Trigger).TEXT_ENTERED);
                this.props.onInput?.(value);
            }
        };
        this.expand = (trigger)=>{
            const { isExpanded: isExpanded, onOpen: onOpen, preQueryScreenViewed: preQueryScreenViewed, searchSessionId: searchSessionId } = this.props;
            if (!isExpanded) {
                onOpen();
                preQueryScreenViewed({
                    searchSessionId: searchSessionId,
                    trigger: trigger
                });
            }
        };
        this.close = (e)=>{
            const { isExpanded: isExpanded, onBack: onBack } = this.props;
            if (isExpanded) {
                (0, $4TXTZ.default)('quick-search-close', performance.now());
                onBack?.(e);
            }
        };
        this.onInputClick = ()=>{
            setTimeout(()=>this.ref?.focus());
            this.expand((0, $5dFS9.Trigger).CLICK);
        };
        this.onEnter = (event)=>{
            const { isExpanded: isExpanded, onEnter: onEnter } = this.props;
            if (isExpanded) onEnter?.(event);
        };
        this.onClear = ()=>{
            setTimeout(()=>this.ref?.focus());
            this.props.onClear?.();
        };
        this.onRef = (0, $0ffb284ad494cbe0$export$bf39ce724f6cc9e5)(this.props.forwardRef, (ref)=>{
            this.ref = ref;
        });
    }
}
const $b16b15c35dd761da$export$b12c0eea3d812057 = (0, $gmMgo.default)($b16b15c35dd761da$export$f964308946b6123b);
const $b16b15c35dd761da$export$1ea4f29215db3ad6 = (props)=>{
    const [_ignore, persistRecentSearchOnEnter] = (0, $20N1w.usePersistRecentSearches)();
    const { actionSubjectId: actionSubjectId, advancedSearchURL: advancedSearchURL, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, isLoading: isLoading, onNavigate: onNavigate, ...rest } = props;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { stickySearchEnabled: stickySearchEnabled, query: query, resetSearchSession: resetSearchSession, showSearchAIDialog: showSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const isRovoCrossProductSearchLinkShown = (0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    const { quickFind: quickFind, isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const showSearchOnEnter = !!getActiveProduct()?.showSearchOnEnter;
    const invokePostQuerySearchRef = getActiveProduct()?.invokePostQuerySearchRef;
    const activeProduct = getActiveProduct();
    const showAskAIButton = $b16b15c35dd761da$var$useShowAIButton(activeProduct, query);
    const aiSearchEnabled = isGriffinNavEnabled ? showAskAIButton : showAskAIButton || !!showSearchAIDialog;
    const isQuickFind = quickFind?.enabled;
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    const onEnter = (0, $42omo.useCallback)((event)=>{
        // Stops event propagation when a user searches to fix VC90 transition event
        event?.stopPropagation?.();
        persistRecentSearchOnEnter(event);
        if (showSearchAIDialog) return;
        if (showSearchOnEnter && !event?.shiftKey) {
            if (invokePostQuerySearchRef) {
                fireAnalyticsEvent((0, $5dFS9.onNonDebouncedSearchTriggered)());
                invokePostQuerySearchRef.current();
            }
            return;
        }
        const modifierKeyPressed = navigator.userAgent.includes('Mac') ? event.metaKey : event.ctrlKey;
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: false,
            trigger: modifierKeyPressed ? (0, $5dFS9.Trigger).SHORTCUT_MODIFIED : (0, $5dFS9.Trigger).SHORTCUT,
            // We know the user navigated to Rovo Search in Atlassian Home if the Rovo Search link was shown to them AND they either:
            // 1. navigated when the "All" product tab was selected
            // 2. navigated by using (cmd or ctrl) + enter when any product tab was selected
            isRovoCrossProductSearchLink: isRovoCrossProductSearchLinkShown && (activeProduct?.id === (0, $6bef6d6b7bd7e701$export$6f9668437bcabf4e) || modifierKeyPressed)
        }));
        if (stickySearchEnabled && advancedSearchURL && !isGriffinNavEnabled && !(event.metaKey || event.ctrlKey)) resetSearchSession();
        if (isGriffinNavEnabled) event.currentTarget.blur();
        onNavigate(modifierKeyPressed && secondaryAdvancedSearchURL ? secondaryAdvancedSearchURL : advancedSearchURL, event);
    }, [
        persistRecentSearchOnEnter,
        showSearchAIDialog,
        showSearchOnEnter,
        fireAnalyticsEvent,
        actionSubjectId,
        isLoading,
        stickySearchEnabled,
        advancedSearchURL,
        onNavigate,
        secondaryAdvancedSearchURL,
        invokePostQuerySearchRef,
        resetSearchSession,
        isGriffinNavEnabled,
        isRovoCrossProductSearchLinkShown,
        activeProduct?.id
    ]);
    const onClear = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onXButtonClicked)({
            actionSubjectId: actionSubjectId,
            searchSessionId: searchSessionId
        }));
        resetSearchSession();
        allowChangeExpand(true);
    }, [
        fireAnalyticsEvent,
        actionSubjectId,
        searchSessionId,
        resetSearchSession,
        allowChangeExpand
    ]);
    const onPreQueryScreenViewedCB = (0, $42omo.useCallback)((preQueryProps)=>fireAnalyticsEvent({
            ...(0, $5dFS9.onPreQueryScreenViewed)(preQueryProps),
            actionSubject: actionSubjectId
        }), [
        fireAnalyticsEvent,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($b16b15c35dd761da$export$b12c0eea3d812057, {
        ...rest,
        onEnter: onEnter,
        searchSessionId: searchSessionId,
        preQueryScreenViewed: onPreQueryScreenViewedCB,
        onClear: onClear,
        showClearButton: stickySearchEnabled && query !== '',
        allowChangeExpand: allowChangeExpand,
        stickySearchEnabled: stickySearchEnabled,
        showSearchOnEnter: showSearchOnEnter,
        showAIToggleButton: aiSearchEnabled,
        isLoading: isLoading,
        onNavigate: onNavigate,
        isQuickFind: isQuickFind,
        isGriffinNavEnabled: isGriffinNavEnabled,
        queryParams: queryParams,
        activeProduct: activeProduct?.id || ''
    });
};















var $k2JFl = parcelRequire("k2JFl");

const $e66e5da1711e0ddd$var$debounceTime = 250;
const $e66e5da1711e0ddd$var$GenericInputWithIntl = ({ activeProductId: activeProductId, intl: intl, onNavigateGeneric: onNavigateGeneric, query: query, isExpanded: isExpanded, isLoading: isLoading, onOpen: onOpen, forwardRef: forwardRef, onBack: onBack, setQuery: setQuery, shouldFillContainer: shouldFillContainer })=>{
    const activeProduct = (0, $k2JFl.useActiveProduct)();
    const { getProduct: getProduct } = (0, $fJRVo.useProductContext)();
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    const hasQueryParamText = queryParams?.hasOwnProperty('text');
    const queryParamText = queryParams?.text?.toString() || '';
    const onNavigateGenericInput = (0, $42omo.useCallback)((productId)=>(href, event)=>{
            if (href) onNavigateGeneric(productId, href, event);
        }, [
        onNavigateGeneric
    ]);
    // We're using a ref for setQuery so that we can guarantee the function
    // definition is the same reference between renders.
    const setQueryRef = (0, $42omo.useRef)(setQuery);
    (0, $42omo.useEffect)(()=>{
        setQueryRef.current = setQuery;
    }, [
        setQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isGriffinNavEnabled && hasQueryParamText) setQueryRef.current(queryParamText);
    }, [
        isGriffinNavEnabled,
        hasQueryParamText,
        queryParamText,
        setQueryRef
    ]);
    const { advancedSearchUrl: advancedSearchUrl, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, onNavigate: onNavigate, actionSubjectId: actionSubjectId, expandedStateInputPlaceholder: // @ts-ignore - TS2525 TypeScript 5.9.2 upgrade
    expandedStateInputPlaceholder } = (()=>{
        if (!activeProductId || !getProduct(activeProductId)) return {
            advancedSearchUrl: '',
            secondaryAdvancedSearchURL: '',
            onNavigate: isGriffinNavEnabled ? onNavigateGenericInput('') : ()=>{},
            actionSubjectId: 'noActiveProduct'
        };
        return {
            advancedSearchUrl: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query) || '',
            secondaryAdvancedSearchURL: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query, undefined, 'onInputEnterModified') || '',
            expandedStateInputPlaceholder: getProduct(activeProductId)?.expandedStateInputPlaceholder || '',
            onNavigate: onNavigateGenericInput(activeProductId),
            actionSubjectId: activeProductId
        };
    })();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $b16b15c35dd761da$export$1ea4f29215db3ad6), {
        shouldFillContainer: shouldFillContainer,
        forwardRef: forwardRef,
        value: query,
        isExpanded: isExpanded,
        isLoading: isLoading,
        onOpen: onOpen,
        debounceTime: $e66e5da1711e0ddd$var$debounceTime,
        advancedSearchURL: advancedSearchUrl,
        secondaryAdvancedSearchURL: secondaryAdvancedSearchURL,
        actionSubjectId: actionSubjectId,
        onBack: onBack,
        onInput: setQuery,
        expandedPlaceholder: expandedStateInputPlaceholder ? expandedStateInputPlaceholder : intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder),
        collapsedPlaceholder: intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder),
        onNavigate: onNavigate,
        activeProduct: activeProduct
    });
};
const $e66e5da1711e0ddd$export$372be6d3f9d3f49 = (0, $gmMgo.default)($e66e5da1711e0ddd$var$GenericInputWithIntl);











const $088dcb4257ca9f76$export$83ddef5d719c74b1 = ({ forwardRef: forwardRef, isExpanded: isExpanded, setIsExpanded: setIsExpanded, activeProductId: activeProductId, query: query, setQuery: setQuery, onNavigateGeneric: onNavigateGeneric, isLoading: isLoading, pageLoadMetrics: pageLoadMetrics, shouldFillContainer: shouldFillContainer })=>{
    const inputRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (pageLoadMetrics) {
            const { metric: metric, customDataGetter: customDataGetter } = pageLoadMetrics;
            metric.stop({
                customData: customDataGetter()
            });
        }
    }, [
        pageLoadMetrics
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isExpanded) inputRef?.current?.focus();
    }, [
        isExpanded,
        inputRef,
        activeProductId
    ]);
    const ref = (0, $0ffb284ad494cbe0$export$bf39ce724f6cc9e5)(forwardRef, inputRef);
    const openPressTracing = (0, $1pSma.default)('product-search-input-open');
    const onOpen = (0, $42omo.useCallback)(()=>{
        setIsExpanded(true);
        openPressTracing();
    }, [
        setIsExpanded,
        openPressTracing
    ]);
    const onBack = (0, $42omo.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    const inputComponentProps = {
        activeProductId: activeProductId,
        query: query,
        setQuery: setQuery,
        forwardRef: ref,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        onOpen: onOpen,
        onNavigateGeneric: onNavigateGeneric,
        onBack: onBack,
        isLoading: isLoading,
        shouldFillContainer: shouldFillContainer
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e66e5da1711e0ddd$export$372be6d3f9d3f49), {
        ...inputComponentProps
    });
};
const $088dcb4257ca9f76$export$88d712058aeecea7 = ({ features: features, shouldFillContainer: shouldFillContainer, ...rest })=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { query: query, setQuery: setQuery, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { stickySearchEnabled: stickySearchEnabled } = (0, $80L9g.useSessionUserInput)();
    const abTest = (0, $gRazf.useABTest)();
    const theme = (0, $eSS4z.useTheme)();
    const activeProduct = getActiveProduct();
    const intl = (0, $8C5kA.default)();
    if (!abTest) return features?.interactiveSkeleton ? /*#__PURE__*/ (0, $l998X.jsx)((0, $boBbB.ProductSearchInputSkeletonInteractive), {
        theme: theme,
        shouldFillContainer: shouldFillContainer,
        stickySearchEnabled: stickySearchEnabled,
        ...features.interactiveSkeleton
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $40910eaaf86d577d$export$91fb362ea940bd8b), {
        shouldFillContainer: shouldFillContainer,
        theme: theme,
        placeholder: intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($088dcb4257ca9f76$export$83ddef5d719c74b1, {
        ...rest,
        shouldFillContainer: shouldFillContainer,
        activeProductId: activeProduct?.id,
        query: query,
        setQuery: setQuery,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        isLoading: isLoading
    });
};



var $jAnRi = parcelRequire("jAnRi");








var $48BnN = parcelRequire("48BnN");








var $24xEE = parcelRequire("24xEE");










const $08c163fce83bd841$export$8cce9f9e667fae48 = ({ children: children })=>{
    const { getActiveProduct: getActiveProduct, getDefaultAIConfig: getDefaultAIConfig } = (0, $fJRVo.useProductContext)();
    const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const onCloseAIDialog = (0, $42omo.useCallback)(()=>{
        toggleShowSearchAIDialog(false);
    }, [
        toggleShowSearchAIDialog
    ]);
    const defaultAIConfig = getDefaultAIConfig();
    return children({
        activeProduct: getActiveProduct(),
        showSearchAIDialog: showSearchAIDialog,
        onCloseAIDialog: onCloseAIDialog,
        defaultAIConfig: defaultAIConfig
    });
};



var $aQmDW = parcelRequire("aQmDW");




parcelRequire("42omo");


var $7DA0P = parcelRequire("7DA0P");










const $51e1c9118342ae7a$export$99f979ec765e5f8f = ({ children: children, shouldFillContainer: shouldFillContainer })=>{
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7DA0P.SearchDialog), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        style: {
            boxShadow: isExpanded ? undefined : 'none',
            borderRadius: quickFind?.enabled ? (0, $dh538.fg)('confluence_frontend_tokenize_border') ? "var(--ds-radius-medium, 6px)" // 6px - proper radius token without fallback
             : "var(--ds-space-100, 8px)" // Legacy fallback
             : undefined
        },
        children: children
    });
};


const $5e2053bb9142cd57$var$ConditionalWrapper = ({ wrapper: wrapper, children: children })=>wrapper?.({
        children: children
    }) ?? children;

const $5e2053bb9142cd57$var$SearchAIDialogComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("Jl0nn")).then(({ SearchAIDialog: SearchAIDialog })=>({
            default: SearchAIDialog
        })));
const $5e2053bb9142cd57$var$SearchAIAnswerDialog = ({ aiSearchConfig: aiSearchConfig, onClose: onClose, edition: edition, closeParentDialog: closeParentDialog })=>{
    const { query: query, setQueryOnly: setQueryOnly } = (0, $2ZIpG.useQuery)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId || '';
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { resetSearchSession: resetSearchSession } = (0, $80L9g.useSessionUserInput)();
    const { allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const filters = (0, $48BnN.useAppliedFilters)('confluence');
    const onNavigate = (0, $42omo.useCallback)(()=>{
        resetSearchSession();
        allowChangeExpand(true);
    }, [
        resetSearchSession,
        allowChangeExpand
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)($5e2053bb9142cd57$var$SearchAIDialogComponent, {
            query: query,
            setQuery: setQueryOnly,
            cloudId: cloudId,
            getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
            edition: edition,
            followUpsEnabled: aiSearchConfig.followUpsEnabled,
            onNavigate: onNavigate,
            onClose: onClose,
            searchSessionId: searchSessionId,
            userDetails: user,
            source: "searchDialog",
            parsedFilters: filters,
            closeParentDialog: closeParentDialog,
            sourceProduct: "confluence",
            userGeneratedAI: true
        })
    });
};
const $5e2053bb9142cd57$export$c952be4395be8d29 = ({ children: children, theme: theme, isExpanded: isExpanded, setIsExpanded: setIsExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, dialogFeatures: dialogFeatures, user: user, orgId: orgId, forwardRef: forwardRef, onNavigateGeneric: onNavigateGeneric, keepExpandedInTab: keepExpandedInTab, pageLoadMetrics: pageLoadMetrics, DialogWrapper: DialogWrapper, OnboardingRenderer: OnboardingRenderer, aiSearchConfig: aiSearchConfig, edition: edition, primaryProduct: primaryProduct, shouldFillContainer: shouldFillContainer, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
    (0, $24xEE.useUFOComponentExperience)((0, $jAnRi.initialisationExperience));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a995c577a9050532$export$3d88e5d350ac07d9), {
        theme: theme,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        abTestCloudId: abTestCloudId,
        aggregatorUrl: aggregatorUrl,
        clientProviderFeatures: dialogFeatures,
        user: user,
        orgId: orgId,
        dialogFeatures: dialogFeatures,
        primaryProduct: primaryProduct,
        forwardRef: forwardRef,
        isRovoEnabled: isRovoEnabled,
        queryParams: queryParams,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $59d6c08dd81e927a$export$8ee2389f89cfdd2f), {
            shouldFillContainer: shouldFillContainer,
            forwardRef: forwardRef,
            keepExpandedInTab: keepExpandedInTab,
            children: ({ ref: ref, onRetry: onRetry })=>{
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $088dcb4257ca9f76$export$88d712058aeecea7), {
                            shouldFillContainer: shouldFillContainer,
                            forwardRef: ref,
                            onNavigateGeneric: onNavigateGeneric,
                            features: dialogFeatures,
                            pageLoadMetrics: pageLoadMetrics
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)($5e2053bb9142cd57$var$ConditionalWrapper, {
                            wrapper: DialogWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $08c163fce83bd841$export$8cce9f9e667fae48), {
                                    children: ({ activeProduct: activeProduct, showSearchAIDialog: showSearchAIDialog, onCloseAIDialog: onCloseAIDialog, defaultAIConfig: defaultAIConfig })=>{
                                        const finalAIConfig = dialogFeatures?.isGriffinNavEnabled ? aiSearchConfig || defaultAIConfig : aiSearchConfig;
                                        return showSearchAIDialog && finalAIConfig && isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)($5e2053bb9142cd57$var$SearchAIAnswerDialog, {
                                            aiSearchConfig: finalAIConfig,
                                            onClose: onCloseAIDialog,
                                            edition: edition,
                                            closeParentDialog: ()=>setIsExpanded(false)
                                        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $51e1c9118342ae7a$export$99f979ec765e5f8f), {
                                            shouldFillContainer: shouldFillContainer,
                                            children: [
                                                OnboardingRenderer && isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $aQmDW.DisableXPSAB), {
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)(OnboardingRenderer, {
                                                        activeProductId: activeProduct?.id
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7qNFx.ProductTabs), {}),
                                                children({
                                                    ref: ref,
                                                    onRetry: onRetry
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
};

















const $8b3e3400ae6f3971$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /*
   * Opsgenie
   */ opsgenie_expanded_input_placeholder: {
        id: "product_search_dialog.opsgenie.expanded.input-placeholder",
        defaultMessage: "Search Opsgenie"
    },
    opsgenie_recent_alerts: {
        id: "product_search_dialog.opsgenie.opsgenie_recent_alerts",
        defaultMessage: "Recent Alerts"
    },
    opsgenie_alerts_heading: {
        id: "product_search_dialog.opsgenie.alert_heading",
        defaultMessage: "Alerts"
    },
    opsgenie_advanced_search: {
        id: "product_search_dialog.opsgenie.advanced_search",
        defaultMessage: "Advanced alert search"
    }
});








var $57b4f9c3ea98ed8b$export$dc14148e3ded2998 = /*#__PURE__*/ function(OpsgenieScope) {
    OpsgenieScope["OpsgenieAlert"] = "opsgenie.alert";
    return OpsgenieScope;
}({});





const $ddbd2b3a958b61d9$var$getOpsgenieAggregatorRedirectUrl = ({ cloudId: cloudId, hostUrl: hostUrl = '' })=>{
    return `${hostUrl}/gateway/api/xpsearch-aggregator/redirect/advanced/opsgenie/${cloudId}`;
};
const $ddbd2b3a958b61d9$export$c78c65c0f344862e = (arg)=>{
    const opsgenieAggregatorRedirector = (0, $42omo.useCallback)((query)=>`${$ddbd2b3a958b61d9$var$getOpsgenieAggregatorRedirectUrl(arg)}?query=${query}`, [
        arg
    ]);
    return {
        viewAllLinkGenerator: opsgenieAggregatorRedirector,
        urlGeneratorForNoResultsScreen: opsgenieAggregatorRedirector
    };
};















const $6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID = 'opsgenie';
const $6cbf2f1ae9737b11$export$864cff1b26c75e89 = (alert)=>{
    return {
        title: alert.message,
        id: alert.id,
        meta: alert.status.charAt(0).toUpperCase() + alert.status.slice(1),
        url: alert.link,
        iconUrl: alert.iconURI,
        containerId: '' // no conatiner
    };
};
const $6cbf2f1ae9737b11$export$527d10d7fdeeea4e = ({ intl: intl, cloudId: cloudId, generateAdvancedSearchUrl: overriddenGenerateAdvancedSearchUrl, hostUrl: hostUrl, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, ...rest })=>{
    const urlGeneratorArguments = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hostUrl: hostUrl
        }), [
        cloudId,
        hostUrl
    ]);
    const { viewAllLinkGenerator: viewAllLinkGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $ddbd2b3a958b61d9$export$c78c65c0f344862e)(urlGeneratorArguments);
    const sections = [
        {
            id: (0, $57b4f9c3ea98ed8b$export$dc14148e3ded2998).OpsgenieAlert,
            title: intl.formatMessage((0, $8b3e3400ae6f3971$export$defe85febe8b728c).opsgenie_alerts_heading),
            scope: (0, $57b4f9c3ea98ed8b$export$dc14148e3ded2998).OpsgenieAlert,
            showResultCount: true,
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultMapper: ({ results: results })=>results.map((value)=>$6cbf2f1ae9737b11$export$864cff1b26c75e89(value))
        }
    ];
    const itemSuppliers = (0, $029554683ea761ec$export$967ff0f6c3886589)($6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID, sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const preQuerySectionTitleGenerator = (0, $42omo.useCallback)((section)=>section.id === (0, $57b4f9c3ea98ed8b$export$dc14148e3ded2998).OpsgenieAlert ? intl.formatMessage((0, $8b3e3400ae6f3971$export$defe85febe8b728c).opsgenie_recent_alerts) : '', [
        intl
    ]);
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $42omo.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink && orgId) return (0, $254bef028b438f80$export$306c16563e2015b8)(orgId, cloudId, query, primaryProduct?.id);
        return overriddenGenerateAdvancedSearchUrl?.(query, baseUrl, usage) || viewAllLinkGenerator(query);
    }, [
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id,
        overriddenGenerateAdvancedSearchUrl,
        viewAllLinkGenerator
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5cba.SearchDialogProduct), {
        expandedStateInputPlaceholder: intl.formatMessage((0, $8b3e3400ae6f3971$export$defe85febe8b728c).opsgenie_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        id: $6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        sections: sections,
        title: intl.formatMessage((0, $bF0iL.messages).opsgenie_tab_label),
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        ...rest,
        ...itemSuppliers,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                                    ...rest,
                                    searchFooterLabel: intl.formatMessage((0, $8b3e3400ae6f3971$export$defe85febe8b728c).opsgenie_advanced_search),
                                    returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined
                                })
                            }),
                            showAtlassianHomeSearchLink && orgId && /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $254bef028b438f80$export$829d02f6cd9ab0ce), {
                                    orgId: orgId,
                                    cloudId: cloudId,
                                    showModifierIcon: true
                                })
                            })
                        ]
                    })
            };
        }
    });
};
const $6cbf2f1ae9737b11$export$7571e7fdcc46c96b = (0, $gmMgo.default)($6cbf2f1ae9737b11$export$527d10d7fdeeea4e);










function $b276001131c7a99f$var$getServiceUrl(cloudId, baseUrlOverride) {
    const path = `/gateway/api/townsquare/s/${cloudId}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`;
    if (baseUrlOverride) return `${baseUrlOverride}${path}`;
    return path;
}
async function $b276001131c7a99f$export$d39036e5b47a0af(cloudId, baseUrlOverride) {
    if (cloudId === undefined) return false;
    try {
        const response = await fetch($b276001131c7a99f$var$getServiceUrl(cloudId, baseUrlOverride), {
            credentials: 'include'
        });
        if (response.ok) {
            const workspaceType = await response.text();
            return workspaceType === 'GLOBAL_EXPERIENCE';
        }
        return false;
    } catch (err) {
        return false;
    }
}






const $ea6f0aa982c7afdb$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /*
   * Atlas, formerly known as Team Central or Townsquare
   */ atlas_search_input_expanded_placeholder: {
        id: "product_search_dialog.atlas.search_input_expanded_placeholder",
        defaultMessage: "Search Atlas"
    },
    townsquare_search_input_expanded_placeholder: {
        id: "product_search_dialog.townsquare.search_input_expanded_placeholder",
        defaultMessage: "Search Home"
    },
    townsquare_tab_label: {
        id: "cross_product_search_dialog.townsquare_tab_label",
        defaultMessage: "Atlas"
    },
    townsquare_globex_tab_label: {
        id: "cross_product_search_dialog.townsquare_globex_tab_label",
        defaultMessage: "Home"
    },
    townsquare_recent_projects: {
        id: "cross_product_search_dialog.townsquare_recent_projects",
        defaultMessage: "Recent Projects"
    },
    townsquare_recent_goals: {
        id: "cross_product_search_dialog.townsquare_recent_goals",
        defaultMessage: "Recent Goals"
    },
    townsquare_recent_help_links: {
        id: "cross_product_search_dialog.townsquare_recent_help_links",
        defaultMessage: "Recent Help Links"
    },
    townsquare_recent_learnings_risks_decisions: {
        id: "cross_product_search_dialog.townsquare_recent_learnings_risks_decisions",
        defaultMessage: "Recent Learnings, Risks and Decisions"
    },
    townsquare_recent_topics: {
        id: "product_search_dialog.townsquare_recent_topics",
        defaultMessage: "Recent Topics"
    },
    townsquare_recent_people: {
        id: "product_search_dialog.townsquare_recent_people",
        defaultMessage: "Recent People"
    },
    townsquare_projects_heading: {
        id: "product_search_dialog.townsquare_projects_heading",
        defaultMessage: "Projects"
    },
    townsquare_projects_view_all: {
        id: "product_search_dialog.townsquare_projects_view_all",
        defaultMessage: "Search all projects"
    },
    townsquare_goals_heading: {
        id: "product_search_dialog.townsquare_goals_heading",
        defaultMessage: "Goals"
    },
    townsquare_goals_view_all: {
        id: "product_search_dialog.townsquare_goals_view_all",
        defaultMessage: "Search all goals"
    },
    townsquare_help_links_heading: {
        id: "product_search_dialog.townsquare_help_links_heading",
        defaultMessage: "Help Links"
    },
    townsquare_topics_heading: {
        id: "product_search_dialog.townsquare_topics_heading",
        defaultMessage: "Topics"
    },
    townsquare_topics_view_all: {
        id: "product_search_dialog.townsquare_topics_view_all",
        defaultMessage: "Search all topics"
    },
    townsquare_learnings_risks_decisions_heading: {
        id: "product_search_dialog.townsquare_learnings_risks_decisions_heading",
        defaultMessage: "Learnings, Risks and Decisions"
    },
    townsquare_people_heading: {
        id: "product_search_dialog.townsquare_people_heading",
        defaultMessage: "People"
    },
    townsquare_people_view_all: {
        id: "product_search_dialog.townsquare_people_view_all",
        defaultMessage: "Search all people"
    },
    townsquare_teams_heading: {
        id: "product_search_dialog.townsquare_teams_heading",
        defaultMessage: "Teams"
    },
    townsquare_teams_view_all: {
        id: "product_search_dialog.townsquare_teams_view_all",
        defaultMessage: "Search all teams"
    }
});














parcelRequire("42omo");





var $7175e1aafd675626$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});



let $ad01931f226af666$var$defaultTownsquareResultMapper = ({ results: results })=>results.map((value)=>$ad01931f226af666$var$mapAggregatorResponseToSearchItem(value)).slice(0, $ad01931f226af666$export$ece7c64a85a33d85);
const $ad01931f226af666$export$ece7c64a85a33d85 = 3;
const $ad01931f226af666$var$mapAggregatorResponseToSearchItem = (response)=>{
    if ('account_id' in response) return {
        title: response.name,
        id: response.account_id,
        meta: '',
        url: response.absoluteUrl || '',
        iconUrl: response.picture,
        containerId: '' // no container
    };
    else return {
        title: response.title,
        id: response.id,
        meta: '',
        url: response.url,
        iconUrl: response.iconUrl,
        containerId: '' // no container
    };
};
const $ad01931f226af666$export$ddbcae0b0bd6b092 = (intl, workspaces, isGlobalExperienceWorkspace, orgId)=>[
        {
            id: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareProject,
            title: intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_projects_heading),
            showResultCount: false,
            scope: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareProject,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>{
                return (0, $1f7067aa44298f63$export$2e2bcd8739ae039)('projects', query, workspaces, isGlobalExperienceWorkspace, orgId);
            },
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_projects_view_all
                })
        },
        {
            id: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareGoal,
            title: intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_goals_heading),
            scope: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareGoal,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>(0, $1f7067aa44298f63$export$2e2bcd8739ae039)('goals', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_goals_view_all
                })
        },
        {
            id: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareHelpLink,
            title: intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_help_links_heading),
            scope: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareHelpLink,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper
        },
        {
            id: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareTag,
            title: intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_topics_heading),
            scope: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareTag,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>(0, $1f7067aa44298f63$export$2e2bcd8739ae039)('topics', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_topics_view_all
                })
        },
        {
            id: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareLearning,
            title: intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_learnings_risks_decisions_heading),
            scope: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareLearning,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper
        }
    ];





parcelRequire("42omo");












const $f4a2ff59ef026569$export$dac5be8ec1b3ddb1 = 'townsquare';
const $f4a2ff59ef026569$var$sectionSortOrder = [
    (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareProject,
    (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareGoal,
    (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).People,
    (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).Teams,
    (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareTag,
    (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareHelpLink,
    (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareLearning
];
/**
 * Sorting sections to match the order defined in the array {sectionSortOrder}
 * While this should not happen, if the section is not part of the array, it is considered to be at the end.
 */ const $f4a2ff59ef026569$var$sortSections = (sectionA, sectionB)=>{
    const indexA = $f4a2ff59ef026569$var$sectionSortOrder.indexOf(sectionA.id);
    const indexB = $f4a2ff59ef026569$var$sectionSortOrder.indexOf(sectionB.id);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
};
const $f4a2ff59ef026569$export$a0d26d0ba1e6d87a = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, workspaces: workspaces, organizationId: organizationId, isGlobalExperienceWorkspace: isGlobalExperienceWorkspace })=>{
    const intl = (0, $8C5kA.default)();
    const orgId = organizationId ?? userTeamConfig?.context.organizationId;
    const itemSuppliers = (0, $029554683ea761ec$export$967ff0f6c3886589)($f4a2ff59ef026569$export$dac5be8ec1b3ddb1, (0, $ad01931f226af666$export$ddbcae0b0bd6b092)(intl, workspaces, isGlobalExperienceWorkspace, orgId), {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    // If we are in a global experience workspace, we need to set the product key to 'people'
    if (userTeamConfig) userTeamConfig.context.productKey = isGlobalExperienceWorkspace ? 'people' : userTeamConfig?.context.productKey;
    const peopleAndTeamSupplier = (0, $6972a0988821eda6$export$f16e39d5b6af63da)({
        people: {
            id: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).People,
            title: intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_people_heading),
            viewAllLinkGenerator: (query)=>(0, $1f7067aa44298f63$export$2e2bcd8739ae039)('people', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_people_view_all
                })
        },
        teams: {
            id: (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).Teams,
            title: intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_teams_heading),
            viewAllLinkGenerator: (query)=>(0, $1f7067aa44298f63$export$2e2bcd8739ae039)('teams', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_teams_view_all
                })
        }
    }, (0, $ad01931f226af666$export$ece7c64a85a33d85));
    const preQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await itemSuppliers.preQueryItemSupplier(args);
        const people = userTeamConfig ? await peopleAndTeamSupplier('', {
            resolveUserUrl: (userId)=>(0, $1f7067aa44298f63$export$5b4f9e589794eb96)(userId, isGlobalExperienceWorkspace, orgId),
            resolveTeamUrl: (teamId)=>(0, $1f7067aa44298f63$export$a1c75f05b6ef3ec6)(teamId, isGlobalExperienceWorkspace, orgId),
            ...userTeamConfig
        }) : null;
        const unsortedSections = [
            ...existingSections.sections,
            ...people?.sections ?? []
        ];
        return {
            size: unsortedSections.length,
            sections: unsortedSections.sort($f4a2ff59ef026569$var$sortSections)
        };
    };
    const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await itemSuppliers.postQueryItemSupplier(args);
        const { filters: filters } = args;
        const selectedWorkspace = filters.filter((filter)=>filter['@type'] === 'sites').map((filter)=>filter.values[0]).filter((val)=>val).shift();
        const people = userTeamConfig ? await peopleAndTeamSupplier(args.query, {
            resolveUserUrl: (userId)=>(0, $1f7067aa44298f63$export$5b4f9e589794eb96)(userId, isGlobalExperienceWorkspace, orgId),
            resolveTeamUrl: (teamId)=>(0, $1f7067aa44298f63$export$a1c75f05b6ef3ec6)(teamId, isGlobalExperienceWorkspace, orgId),
            ...userTeamConfig,
            context: {
                ...userTeamConfig.context,
                siteId: selectedWorkspace || userTeamConfig.context.siteId
            }
        }) : null;
        const unsortedSections = [
            ...existingSections.sections,
            ...people?.sections ?? []
        ];
        return {
            size: unsortedSections.length,
            sections: unsortedSections.sort($f4a2ff59ef026569$var$sortSections)
        };
    };
    const preQuerySectionTitleGenerator = (section)=>{
        switch(section.id){
            case (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareProject:
                return intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_recent_projects);
            case (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareGoal:
                return intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_recent_goals);
            case (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareHelpLink:
                return intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_recent_help_links);
            case (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareTag:
                return intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_recent_topics);
            case (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).TownsquareLearning:
                return intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_recent_learnings_risks_decisions);
            case (0, $7175e1aafd675626$export$fca43c5c12a4e3fa).People:
                return intl.formatMessage((0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_recent_people);
            default:
                return '';
        }
    };
    return {
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    };
};




var $lzcvT = parcelRequire("lzcvT");


var $c6GJD = parcelRequire("c6GJD");


















var $5spQU = parcelRequire("5spQU");

const $3dc7d02d49b2e18c$var$defaultPermissionsSupplier = ()=>{
    const response = Object.values((0, $7175e1aafd675626$export$fca43c5c12a4e3fa));
    return Promise.resolve(response);
};
const $3dc7d02d49b2e18c$export$e502dfe73eec1c84 = ({ intl: intl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, userTeamConfig: userTeamConfig, workspaces: workspaces, atlasClientBaseUrlOverride: atlasClientBaseUrlOverride, organizationId: _organizationId, ...rest })=>{
    const [isGlobalExperienceWorkspace, setGlobalExperienceWorkspace] = (0, $42omo.useState)();
    const { atlasWorkspaces: atlasWorkspaces } = (0, $6004f871869f2e35$export$dca16f1ca9af3934)();
    if (!workspaces) workspaces = atlasWorkspaces;
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(workspaces, (0, $f4a2ff59ef026569$export$dac5be8ec1b3ddb1));
    const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, $f4a2ff59ef026569$export$a0d26d0ba1e6d87a)({
        userTeamConfig: userTeamConfig,
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier,
        workspaces: workspaces,
        isGlobalExperienceWorkspace: isGlobalExperienceWorkspace
    });
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    defineFilters((0, $f4a2ff59ef026569$export$dac5be8ec1b3ddb1), siteFilterDefinition);
    (0, $42omo.useEffect)(()=>{
        (0, $b276001131c7a99f$export$d39036e5b47a0af)(userTeamConfig?.context.siteId, atlasClientBaseUrlOverride).then((result)=>{
            setGlobalExperienceWorkspace(result);
        }).catch(()=>{
            setGlobalExperienceWorkspace(false);
        });
    }, [
        atlasClientBaseUrlOverride,
        userTeamConfig?.context.siteId
    ]);
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $42omo.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $254bef028b438f80$export$306c16563e2015b8)(orgId, cloudId, query, primaryProduct?.id);
        return '';
    }, [
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    let permissionSupplier = workspaces && workspaces.length > 0 || isGlobalExperienceWorkspace ? $3dc7d02d49b2e18c$var$defaultPermissionsSupplier : rest.permissionSupplier;
    if (isGlobalExperienceWorkspace === undefined) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5cba.SearchDialogProduct), {
        ...rest,
        id: (0, $f4a2ff59ef026569$export$dac5be8ec1b3ddb1),
        expandedStateInputPlaceholder: intl.formatMessage(isGlobalExperienceWorkspace ? (0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_search_input_expanded_placeholder : (0, $ea6f0aa982c7afdb$export$defe85febe8b728c).atlas_search_input_expanded_placeholder),
        sections: (0, $ad01931f226af666$export$ddbcae0b0bd6b092)(intl, workspaces, isGlobalExperienceWorkspace, userTeamConfig?.context.organizationId),
        title: intl.formatMessage(isGlobalExperienceWorkspace ? (0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_globex_tab_label : (0, $ea6f0aa982c7afdb$export$defe85febe8b728c).townsquare_tab_label),
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        workspaces: workspaces,
        permissionSupplier: permissionSupplier,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $254bef028b438f80$export$829d02f6cd9ab0ce), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $3dc7d02d49b2e18c$export$485492c388dcd81e = (props)=>{
    if ((0, $dh538.fg)('use_frontend_feature_encoding_sdk_platform')) {
        const enabled = (0, $5spQU.isFeatureEnabled)('search', 'search-townsquare-tab');
        if (!enabled) return null;
    } else {
        if ((0, $c6GJD.default).initializeCompleted() && (0, $c6GJD.default).checkGate('ignore_atlas_product_search_dialog_on_fedramp') && (0, $lzcvT.isFedRamp)()) return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($3dc7d02d49b2e18c$export$e502dfe73eec1c84, {
        ...props
    });
};
const $3dc7d02d49b2e18c$export$b2c9c8ae315d8935 = (0, $gmMgo.default)($3dc7d02d49b2e18c$export$485492c388dcd81e);














var $6la50 = parcelRequire("6la50");


















var $5tPRL = parcelRequire("5tPRL");




// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






function $c143c0027bdf6a89$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c143c0027bdf6a89$export$14ccea95a01eec04 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1rjmdl23"
})({
    name: "andpxo",
    styles: "display:flex;overflow:hidden"
});
const $c143c0027bdf6a89$export$67495cfd95013c39 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1rjmdl22"
})({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '5%',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $c143c0027bdf6a89$export$cd22da1a99fcf7b1 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1rjmdl21"
})({
    marginLeft: "var(--ds-space-050, 4px)",
    flexShrink: 0,
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $c143c0027bdf6a89$export$43a2b5c94cb85d9c = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1rjmdl20"
})({
    name: "zjik7",
    styles: "display:flex"
});



var $aJ5e0 = parcelRequire("aJ5e0");
















const $2ab6392a5ef0ce9c$var$cards = new Map();
const $2ab6392a5ef0ce9c$export$167729b86606a89e = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const loadCard = (0, $42omo.useCallback)(async (cardId)=>{
        try {
            const response = await fetch(`/1/card/${cardId}?fields=name,closed,url,cover,labels,idAttachmentCover&attachments=cover`);
            if (response.ok) {
                const cardResponse = await response.json();
                $2ab6392a5ef0ce9c$var$cards.set(cardId, cardResponse);
                return cardResponse;
            } else throw new Error(`Invalid response: ${response?.status}`);
        } catch (e) {
            if (e instanceof Error) fireAnalyticsEvent({
                ...(0, $5dFS9.onCardRequestFailed)({
                    attributes: {
                        errorMsg: e?.message,
                        errorName: e?.name
                    }
                })
            });
        }
    }, [
        fireAnalyticsEvent
    ]);
    const getCard = (0, $42omo.useCallback)(async (cardId)=>{
        return $2ab6392a5ef0ce9c$var$cards.get(cardId) ? Promise.resolve($2ab6392a5ef0ce9c$var$cards.get(cardId)) : loadCard(cardId);
    }, [
        loadCard
    ]);
    return {
        getCard: getCard
    };
};



const $d89a9a3c06a88b05$var$TrelloPopperAsync = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("2PzNg")).then(({ TrelloPopper: TrelloPopper })=>({
            default: TrelloPopper
        })));
const $d89a9a3c06a88b05$export$5662bd1eb353c490 = ({ id: id, title: title, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, type: type, children: children, isColorBlindModeEnabled: isColorBlindModeEnabled, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, screen: screen })=>{
    const { getCard: getCard } = (0, $2ab6392a5ef0ce9c$export$167729b86606a89e)();
    const [result, setResult] = (0, $42omo.useState)();
    const onFetchCard = (0, $42omo.useCallback)(async ()=>{
        const card = await getCard(id);
        if (card) setResult({
            ...card,
            type: 'card',
            id: id,
            title: title,
            closed: closed,
            meta: meta,
            additionalMeta: additionalMeta,
            screen: screen
        });
    }, [
        getCard,
        id,
        title,
        closed,
        meta,
        screen,
        additionalMeta
    ]);
    const onFetchBoard = (0, $42omo.useCallback)(()=>{
        if (prefs) setResult({
            type: 'board',
            id: id,
            title: title,
            prefs: prefs,
            meta: meta,
            closed: closed,
            screen: screen
        });
    }, [
        id,
        title,
        prefs,
        meta,
        closed,
        screen
    ]);
    if (!isPreviewOnTrelloSearchResultsEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($d89a9a3c06a88b05$var$TrelloPopperAsync, {
            type: type,
            result: result,
            onFetchCard: onFetchCard,
            onFetchBoard: onFetchBoard,
            isColorBlindModeEnabled: isColorBlindModeEnabled,
            screen: screen,
            children: children
        })
    });
};


const $bdbfd4cb99d517f5$export$995a33bac606d212 = ({ id: id, title: title, url: url, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, isColorBlindModeEnabled: isColorBlindModeEnabled, screen: screen, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isBoard = Boolean(prefs);
    const type = (0, $42omo.useMemo)(()=>isBoard ? 'board' : 'card', [
        isBoard
    ]);
    const metaValue = (0, $42omo.useMemo)(()=>isBoard && !meta.value ? formatMessage((0, $6la50.messages).trello_private_workspace) : meta.value, [
        formatMessage,
        isBoard,
        meta.value
    ]);
    const resultContentWrapperOnClick = (0, $42omo.useCallback)(()=>{
        if (onResultClick !== undefined) onResultClick();
    }, [
        onResultClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d89a9a3c06a88b05$export$5662bd1eb353c490), {
        id: id,
        title: title,
        url: url,
        prefs: prefs,
        meta: meta,
        additionalMeta: additionalMeta,
        closed: closed,
        type: type,
        isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled,
        isColorBlindModeEnabled: isColorBlindModeEnabled,
        screen: screen,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.ResultContentWrapper), {
            isCollapsed: true,
            onClick: resultContentWrapperOnClick,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.IconContainer), {
                    children: isBoard && prefs ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aJ5e0.BoardIcon), {
                        id: id,
                        name: title,
                        url: url,
                        prefs: prefs
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aJ5e0.CardIcon), {})
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.ResultTitleContainer), {
                            isCollapsed: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                title: !isPreviewOnTrelloSearchResultsEnabled ? title : undefined,
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $c143c0027bdf6a89$export$43a2b5c94cb85d9c), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $c143c0027bdf6a89$export$14ccea95a01eec04), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $c143c0027bdf6a89$export$67495cfd95013c39), {
                                            title: !isPreviewOnTrelloSearchResultsEnabled ? `${meta.title}: ${metaValue}` : undefined,
                                            children: metaValue
                                        }),
                                        additionalMeta ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $c143c0027bdf6a89$export$67495cfd95013c39), {
                                            title: !isPreviewOnTrelloSearchResultsEnabled ? `${additionalMeta.title}: ${additionalMeta.value}` : undefined,
                                            children: [
                                                ": ",
                                                additionalMeta.value
                                            ]
                                        }) : null
                                    ]
                                }),
                                closed ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $c143c0027bdf6a89$export$cd22da1a99fcf7b1), {
                                    title: !isPreviewOnTrelloSearchResultsEnabled ? isBoard ? formatMessage((0, $6la50.messages).trello_closed_board_hover) : formatMessage((0, $6la50.messages).trello_archived_card_hover) : undefined,
                                    children: [
                                        "\u2022 ",
                                        isBoard ? formatMessage((0, $6la50.messages).trello_closed) : formatMessage((0, $6la50.messages).trello_archived)
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





parcelRequire("42omo");










// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $eEA8O = parcelRequire("eEA8O");







function $7ef4a4349ad50bfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7ef4a4349ad50bfd$export$b68f382ed631ffe5 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "evrkq7c2"
})({
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`
});
const $7ef4a4349ad50bfd$export$4d44d7534024e0b6 = /*#__PURE__*/ (0, $cStGJ.default)((0, $eEA8O.default), {
    target: "evrkq7c1"
})("&&{text-decoration:underline;&:hover{color:", `var(--ds-link-pressed, ${(0, $6fnsQ.N900)})`, "!important;}}");
const $7ef4a4349ad50bfd$export$a6be8d069f8a5fb4 = /*#__PURE__*/ (0, $cStGJ.default)((0, $crAJ1.SearchFooter), {
    target: "evrkq7c0"
})({
    name: "13ku56z",
    styles: "display:flex;flex-direction:column;height:100%"
});












const $24ad7b08697a57d9$export$c139d851a817966 = ({ feedbackUrl: feedbackUrl, showAtlassianHomeSearchLink: showAtlassianHomeSearchLink, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7ef4a4349ad50bfd$export$a6be8d069f8a5fb4), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                ...rest,
                returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined
            }),
            showAtlassianHomeSearchLink && orgId && cloudId && /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $254bef028b438f80$export$829d02f6cd9ab0ce), {
                    orgId: orgId,
                    cloudId: cloudId,
                    showModifierIcon: true
                })
            }),
            feedbackUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $7ef4a4349ad50bfd$export$b68f382ed631ffe5), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ef4a4349ad50bfd$export$4d44d7534024e0b6), {
                    appearance: "subtle-link",
                    href: feedbackUrl,
                    target: "_blank",
                    children: formatMessage((0, $6la50.messages).trello_feedback_link)
                })
            })
        ]
    });
};


const $f671aeb58cfbd736$export$4788c0ef19dba72f = 'trello';
var $f671aeb58cfbd736$export$1f420d5694f8d5b3 = /*#__PURE__*/ function(TrelloScope) {
    TrelloScope["Board"] = "trello.board";
    TrelloScope["Card"] = "trello.card";
    return TrelloScope;
}({});





const $8cadf475bb862c29$var$getBaseUrl = ()=>{
    const hostname = window?.location?.hostname;
    if (hostname?.includes('jira-dev.com') || hostname?.startsWith('trellis.coffee') || hostname?.startsWith('localhost') || hostname?.startsWith('team.stg')) return 'https://trellis.coffee';
    return 'https://trello.com';
};
const $8cadf475bb862c29$export$28a2ffcf7191490b = (query)=>query ? `${$8cadf475bb862c29$var$getBaseUrl()}/search?q=${encodeURIComponent(query)}` : `${$8cadf475bb862c29$var$getBaseUrl()}/search`;



















const $ab7ced8b5c4b8113$var$TrelloBodyAsync = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hEfPy")).then(({ TrelloBody: TrelloBody })=>({
            default: TrelloBody
        })));
const $ab7ced8b5c4b8113$export$78fe0655c043c20 = ({ feedbackUrl: feedbackUrl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, generateAdvancedSearchUrl: generateAdvancedSearchUrl, features: features, resultOnClick: resultOnClick, ...rest })=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const trelloGenerateAdvancedSearchUrl = (0, $42omo.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $254bef028b438f80$export$306c16563e2015b8)(orgId, cloudId, query, primaryProduct?.id);
        return (0, $2OcMi.addQueryParams)((0, $8cadf475bb862c29$export$28a2ffcf7191490b)(query), {
            search_id: searchSessionId
        });
    }, [
        searchSessionId,
        showAtlassianHomeSearchLink,
        orgId,
        cloudId,
        primaryProduct?.id
    ]);
    const boardSection = (0, $42omo.useMemo)(()=>{
        return {
            id: (0, $f671aeb58cfbd736$export$1f420d5694f8d5b3).Board,
            title: formatMessage((0, $6la50.messages).trello_boards_heading),
            scope: (0, $f671aeb58cfbd736$export$1f420d5694f8d5b3).Board,
            showResultCount: false,
            resultMapper: ({ results: results })=>results.map((board)=>({
                        id: board.id,
                        title: board.name,
                        meta: board.organization?.displayName ?? '',
                        closed: board.closed,
                        url: board.url,
                        prefs: board.prefs,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $aJ5e0.BoardIcon), {
                            ...board
                        }),
                        containerId: board.idOrganization ?? undefined
                    })),
            resultRenderer: (args)=>{
                const { id: id, title: title, meta: meta, closed: closed, url: url, prefs: prefs } = args?.searchResult;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $bdbfd4cb99d517f5$export$995a33bac606d212), {
                    id: id,
                    title: title,
                    meta: {
                        title: formatMessage((0, $6la50.messages).trello_workspace),
                        value: meta
                    },
                    closed: closed,
                    url: url,
                    prefs: prefs,
                    isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                    isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                    screen: args?.screen,
                    onResultClick: resultOnClick
                });
            }
        };
    }, [
        features?.isColorBlindModeEnabled,
        features?.isPreviewOnTrelloSearchResultsEnabled,
        formatMessage,
        resultOnClick
    ]);
    const cardSection = (0, $42omo.useMemo)(()=>{
        return {
            id: (0, $f671aeb58cfbd736$export$1f420d5694f8d5b3).Card,
            title: formatMessage((0, $6la50.messages).trello_cards_heading),
            scope: (0, $f671aeb58cfbd736$export$1f420d5694f8d5b3).Card,
            showResultCount: false,
            resultMapper: ({ results: results })=>results.map((card)=>({
                        id: card.id,
                        title: card.name,
                        meta: card.board.name,
                        additionalMeta: card.list.name,
                        closed: card.closed,
                        url: card.url,
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $aJ5e0.CardIcon), {}),
                        containerId: card.idBoard
                    })),
            resultRenderer: (args)=>{
                const { id: id, title: title, meta: meta, additionalMeta: additionalMeta, url: url, closed: closed } = args?.searchResult;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $bdbfd4cb99d517f5$export$995a33bac606d212), {
                    id: id,
                    title: title,
                    meta: {
                        title: formatMessage((0, $6la50.messages).trello_board),
                        value: meta
                    },
                    additionalMeta: {
                        title: formatMessage((0, $6la50.messages).trello_list),
                        value: additionalMeta
                    },
                    closed: closed,
                    url: url,
                    isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                    isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                    screen: args?.screen,
                    onResultClick: resultOnClick
                });
            }
        };
    }, [
        features?.isColorBlindModeEnabled,
        features?.isPreviewOnTrelloSearchResultsEnabled,
        formatMessage,
        resultOnClick
    ]);
    const sections = (0, $42omo.useMemo)(()=>{
        return features?.isCardResultsSectionFirst ? [
            cardSection,
            {
                ...boardSection,
                viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
            }
        ] : [
            boardSection,
            {
                ...cardSection,
                viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
            }
        ];
    }, [
        boardSection,
        cardSection,
        features?.isCardResultsSectionFirst,
        trelloGenerateAdvancedSearchUrl
    ]);
    const itemSuppliers = (0, $029554683ea761ec$export$967ff0f6c3886589)((0, $f671aeb58cfbd736$export$4788c0ef19dba72f), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const preQuerySectionTitleGenerator = (0, $42omo.useCallback)((section)=>section.id === (0, $f671aeb58cfbd736$export$1f420d5694f8d5b3).Board ? formatMessage((0, $6la50.messages).trello_recent_boards_heading) : '', [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $f671aeb58cfbd736$export$4788c0ef19dba72f),
        expandedStateInputPlaceholder: formatMessage((0, $6la50.messages).trello_expanded_input_placeholder),
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        generateAdvancedSearchUrl: trelloGenerateAdvancedSearchUrl,
        sections: sections,
        title: formatMessage((0, $bF0iL.messages).trello_tab_label),
        ...rest,
        ...itemSuppliers,
        children: (props)=>{
            return features?.isCardResultsSectionFirst ? {
                Footer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $24ad7b08697a57d9$export$c139d851a817966), {
                        feedbackUrl: feedbackUrl,
                        urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl,
                        linkComponent: props.linkComponent,
                        showAtlassianHomeSearchLink: !!showAtlassianHomeSearchLink
                    }),
                Body: ()=>/*#__PURE__*/ (0, $l998X.jsx)($ab7ced8b5c4b8113$var$TrelloBodyAsync, {
                        ...props
                    })
            } : {
                Footer: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $24ad7b08697a57d9$export$c139d851a817966), {
                        feedbackUrl: feedbackUrl,
                        urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl,
                        linkComponent: props.linkComponent,
                        showAtlassianHomeSearchLink: !!showAtlassianHomeSearchLink
                    })
            };
        }
    });
};





var $9oxdN = parcelRequire("9oxdN");








var $kDja4 = parcelRequire("kDja4");


var $gXsSh = parcelRequire("gXsSh");


var $yuLaV = parcelRequire("yuLaV");










const $a33223da5daebf45$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    recentlyWorkedOn: {
        id: "navigation-search-dialog.suppliers.recentlyWorkedOn",
        defaultMessage: "Recently worked on"
    },
    recentlyViewed: {
        id: "navigation-search-dialog.suppliers.recentlyViewed",
        defaultMessage: "Recently viewed"
    },
    contents: {
        id: "navigation-search-dialog.suppliers.contents",
        defaultMessage: "Content"
    },
    spaces: {
        id: "navigation-search-dialog.suppliers.spaces",
        defaultMessage: "Spaces"
    },
    people: {
        id: "navigation-search-dialog.suppliers.people",
        defaultMessage: "People"
    },
    confluenceSpace: {
        id: "navigation-search-dialog.quickfind.confluenceSpace",
        defaultMessage: "Confluence Space"
    },
    team: {
        id: "navigation-search-dialog.team",
        defaultMessage: "Team"
    }
});


/* IconRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gj7hi = parcelRequire("gj7hi");


var $esRft = parcelRequire("esRft");




















var $2v58P = parcelRequire("2v58P");


var $8WOej = parcelRequire("8WOej");


var $bCECL = parcelRequire("bCECL");

const $6460b69e49ab179f$var$NegativeMargin = null;
const $6460b69e49ab179f$export$bf56fa242f0fc37d = ({ type: type, title: title, iconCssClass: iconCssClass, size: size = 'medium', imageSrc: imageSrc })=>{
    if (type === 'page' || type === 'confluence-page' || type === 'content') {
        const Icon = size === 'medium' ? (0, $5yCDo.default) : (0, $13WX1.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: type
        });
    } else if (type === 'blogpost' || type === 'confluence-blogpost') {
        const Icon = size === 'medium' ? (0, $bueVT.default) : (0, $hxQwS.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: type
        });
    } else if (type === 'whiteboard') // CTIA-142 - This will be swapped out when AK supports the whiteboard icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: "whiteboard",
        height: size === 'small' ? 16 : 24
    });
    else if (type === 'database') // CTIA-142 - This will be swapped out when AK supports the database icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: "database",
        height: size === 'small' ? 16 : 24
    });
    else if (type === 'slide') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: "slide",
        height: size === 'small' ? 16 : 24
    });
    else if (type === 'embed') // CTIA-142 - This will be swapped out when AK supports the embed icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: "embed",
        height: size === 'small' ? 16 : 24
    });
    else if (type === 'folder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: "folder",
        height: size === 'small' ? 16 : 24
    });
    else if (type === 'jira') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2v58P.default), {
        label: type
    });
    else if (type === 'atlas') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: imageSrc || '',
        "aria-label": type,
        alt: type,
        width: "24px",
        height: "24px"
    });
    else if (type === 'attachment') {
        if (!iconCssClass) {
            const Icon = size === 'medium' ? (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6))) : (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                label: type
            });
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8WOej.AttachmentIcon), {
            mediaType: iconCssClass,
            title: title,
            size: size,
            label: type
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
};
const $6460b69e49ab179f$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18s81i6y _1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        size: size,
        borderColor: "transparent",
        src: iconUrl,
        appearance: appearance,
        testId: "result-avatar"
    }));


const $7b25068d4e2f79dd$export$bba16a2668c13d43 = ({ searchResult: searchResult, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { productState: productState } = rest;
    // REST API stores recent content type as meta data
    const contentType = searchResult.additionalMeta && typeof searchResult.additionalMeta === 'string' ? searchResult.additionalMeta || '' : searchResult.icon || '';
    // AFE does not return newer content type icons (i.e whiteboard/database) so we render it here
    const renderContentIcon = ()=>{
        if (searchResult?.type === 'whiteboard' || searchResult.icon === 'whiteboard') return (0, $6460b69e49ab179f$export$bf56fa242f0fc37d)({
            type: 'whiteboard',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'database' || searchResult.icon === 'database') return (0, $6460b69e49ab179f$export$bf56fa242f0fc37d)({
            type: 'database',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'slide' || searchResult.icon === 'slide') return (0, $6460b69e49ab179f$export$bf56fa242f0fc37d)({
            type: 'slide',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'embed' || searchResult.icon === 'embed') return (0, $6460b69e49ab179f$export$bf56fa242f0fc37d)({
            type: 'embed',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'folder' || searchResult.icon === 'folder') return (0, $6460b69e49ab179f$export$bf56fa242f0fc37d)({
            type: 'folder',
            title: searchResult.title
        }) || '';
        return searchResult.icon;
    };
    if (productState === 'PreQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: undefined,
            icon: (0, $6460b69e49ab179f$export$bf56fa242f0fc37d)({
                type: contentType,
                title: searchResult.title || '',
                size: 'small'
            })
        }
    });
    if (productState === 'PostQueryTyping' || productState === 'PostQueryLoading' || productState === 'PostQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: !!searchResult.isRecentResult ? formatMessage((0, $a33223da5daebf45$export$a7357cdd1f0b0168).recentlyViewed) : searchResult.additionalMeta,
            icon: !!searchResult.isRecentResult ? (0, $6460b69e49ab179f$export$bf56fa242f0fc37d)({
                type: contentType,
                title: searchResult.title || ''
            }) : renderContentIcon()
        }
    });
    return (0, $ejGzS.defaultResultRenderer)({
        searchResult: searchResult,
        ...rest
    });
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $df938f5c6250aebc$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    return ActivitiesObjectType;
}({});



var $1mK5P = parcelRequire("1mK5P");

/**
 * @graphql agg
 */ 






var $7hXu9 = parcelRequire("7hXu9");





var $g9GR5 = parcelRequire("g9GR5");

var $cvntw = parcelRequire("cvntw");


var $d4Pk4 = parcelRequire("d4Pk4");


var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");


var $7Sm4c = parcelRequire("7Sm4c");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6mKj3 = parcelRequire("6mKj3");


var $1HFOS = parcelRequire("1HFOS");






const $6a84866f2cdf6d7e$export$b4cc117e80f3c39f = (0, $eSUdr.default)`query confluence_recentQuickSearch($cloudId:ID!$contentItemsLimit:Int!$spaceLimit:Int!$objectTypes:[ActivitiesObjectType!]$workedOnAPIEnabled:Boolean!){activities{myActivities{viewed(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$contentItemsLimit)@skip(if:$workedOnAPIEnabled){edges{node{id object{id content{id title links{webui}type space{id name}status}}}}}workedOn(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$contentItemsLimit)@include(if:$workedOnAPIEnabled){edges{node{id object{id content{id title links{webui}type space{id name}status}}}}}}}myVisitedSpaces(limit:$spaceLimit){nodes{spaces{id key name icon{path}links{webui}}}}}`;












const $f5220b530c5db4b0$export$b25447981a133bbe = (autocorrectEnabled, workedOnAPIEnabled, formatMessage)=>({ productState: productState })=>{
        const recentlyViewedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, workedOnAPIEnabled ? formatMessage((0, $a33223da5daebf45$export$a7357cdd1f0b0168).recentlyWorkedOn) : formatMessage((0, $a33223da5daebf45$export$a7357cdd1f0b0168).recentlyViewed));
        const pageBlogAttachmentTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, formatMessage((0, $a33223da5daebf45$export$a7357cdd1f0b0168).contents));
        if (productState === 'PreQuerySuccess') return recentlyViewedTitle;
        if (autocorrectEnabled) {
            if (productState === 'PostQueryLoading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEbYb.LoadingSkeleton), {
                "data-testid": "autocorrection-loading-skeleton"
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $21MH9.AutocorrectAsyncWrapper), {
                fallback: pageBlogAttachmentTitle
            });
        }
        return pageBlogAttachmentTitle;
    };


const $38ca96c4d9c67f5e$var$RECENT_CONTENTS_FETCH_LIMIT = 100;
const $38ca96c4d9c67f5e$var$RECENT_SPACE_FETCH_LIMIT = 10;
const $38ca96c4d9c67f5e$var$MAX_RESULTS_CONTENTS = 10;
const $38ca96c4d9c67f5e$var$MAX_RESULTS_SPACES = 3;
const $38ca96c4d9c67f5e$var$recentContentsCCResultMapper = (edge)=>{
    const item = edge?.node?.object?.content;
    return {
        id: item?.id || '',
        title: item?.title || '',
        type: item?.type || '',
        url: `${0, $jlIaF.CONTEXT_PATH}${item?.links?.webui || ''}`,
        meta: item?.space?.name || '',
        additionalMeta: item?.type || '',
        containerId: item?.space?.id || '',
        icon: item?.type || '',
        isRecentResult: true
    };
};
const $38ca96c4d9c67f5e$var$recentContentsCCResultMapperV3 = (edge)=>{
    const item = edge?.node?.object?.data;
    const normalizedType = item?.type?.toLowerCase() === 'blog_post' ? 'blogpost' : item?.type?.toLowerCase();
    return {
        id: item?.id || '',
        title: item?.title || '',
        type: normalizedType,
        url: `${0, $jlIaF.CONTEXT_PATH}${item?.links?.webUi || ''}`,
        meta: item?.space?.name || '',
        additionalMeta: normalizedType,
        containerId: item?.space?.id || '',
        icon: normalizedType,
        isRecentResult: true
    };
};
const $38ca96c4d9c67f5e$var$recentSpaceCCResultMapper = (item)=>({
        id: item?.id || '',
        title: item?.name || '',
        type: 'space',
        meta: '',
        url: `${0, $jlIaF.CONTEXT_PATH}${item?.links?.webui || ''}`,
        containerId: item?.id || undefined,
        icon: (0, $6460b69e49ab179f$export$e5d849fb708254a9)({
            iconUrl: `${(0, $jlIaF.CONTEXT_PATH)}${item?.icon?.path || ''}`,
            size: 'xsmall'
        }),
        isRecentResult: true
    });
const $38ca96c4d9c67f5e$export$4c9ff87550df51de = ({ cloudId: cloudId, userId: userId, principalId: principalId = 'context', autocorrectEnabled: autocorrectEnabled = false, isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled, isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled, objectTypes: objectTypes })=>{
    const intl = (0, $8C5kA.default)();
    const confCloudClient = (0, $7hXu9.useApolloClient)();
    const aggClient = (0, $gKr8t.getAGGClient)();
    const workedOnAPIEnabled = false;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const contentEntities = (0, $42omo.useMemo)(()=>[
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost',
            'ati:cloud:confluence:attachment',
            'ati:cloud:confluence:embed',
            'ati:cloud:confluence:folder',
            ...isQuickSearchForWhiteboardsEnabled ? [
                'ati:cloud:confluence:whiteboard'
            ] : [],
            ...isQuickSearchForDatabasesEnabled ? [
                'ati:cloud:confluence:database'
            ] : []
        ], [
        isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled
    ]);
    const preQueryItemSupplier = (0, $42omo.useCallback)(async ()=>{
        experienceTracker.start({
            name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY)
        });
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { recentContents: recentContents, recentSpaces: recentSpaces } = !userId ? {
            recentContents: [],
            recentSpaces: []
        } : (0, $6mKj3.expValEquals)('cc_migrate_remaining_activity_v2_queries_to_v3', 'isEnabled', true) ? await confCloudClient.query({
            query: $38ca96c4d9c67f5e$export$26482aebefd0500f,
            variables: {
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                contentItemsLimit: $38ca96c4d9c67f5e$var$RECENT_CONTENTS_FETCH_LIMIT,
                spaceLimit: $38ca96c4d9c67f5e$var$RECENT_SPACE_FETCH_LIMIT,
                objectTypes: objectTypes.map(String),
                eventTypes: workedOnAPIEnabled ? [
                    'CREATED',
                    'EDITED',
                    'VIEWED'
                ] : [
                    'VIEWED'
                ]
            }
        }).then((response)=>{
            const rawSpaces = response.data?.myVisitedSpaces?.nodes?.spaces;
            const rawContent = response.data?.activity?.myActivity?.all?.edges;
            const filteredRawContent = rawContent && rawContent.filter(// #help-work-platform suggested handling null content in FE while they investigate why some results are being returned null
            (edge)=>{
                const data = edge?.node?.object?.data;
                return !!data && data.status !== 'TRASHED' && data.pageStatus !== 'TRASHED' && data.blogStatus !== 'TRASHED';
            });
            return {
                recentContents: filteredRawContent?.map($38ca96c4d9c67f5e$var$recentContentsCCResultMapperV3) || [],
                recentSpaces: rawSpaces?.map($38ca96c4d9c67f5e$var$recentSpaceCCResultMapper) || []
            };
        }).catch((error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY),
                error: error
            });
            // error is handled by the platform PSD component
            (0, $7Sm4c.markErrorAsHandled)(error);
            // The error will bubble up and the parent component will catch the error and handle it
            throw error;
        }) : await confCloudClient.query({
            query: (0, $6a84866f2cdf6d7e$export$b4cc117e80f3c39f),
            variables: {
                cloudId: cloudId,
                contentItemsLimit: $38ca96c4d9c67f5e$var$RECENT_CONTENTS_FETCH_LIMIT,
                spaceLimit: $38ca96c4d9c67f5e$var$RECENT_SPACE_FETCH_LIMIT,
                objectTypes: objectTypes,
                workedOnAPIEnabled: workedOnAPIEnabled
            }
        }).then((response)=>{
            const rawSpaces = response.data?.myVisitedSpaces?.nodes?.spaces;
            const rawContent = workedOnAPIEnabled ? response.data.activities?.myActivities?.workedOn?.edges : response.data.activities?.myActivities?.viewed?.edges;
            const filteredRawContent = rawContent && rawContent.filter(// #help-work-platform suggested handling null content in FE while they investigate why some results are being returned null
            (edge)=>!(edge?.node?.object?.content?.status === 'trashed') && !(edge?.node?.object?.content === null));
            return {
                recentContents: filteredRawContent?.map($38ca96c4d9c67f5e$var$recentContentsCCResultMapper) || [],
                recentSpaces: rawSpaces?.map($38ca96c4d9c67f5e$var$recentSpaceCCResultMapper) || []
            };
        }).catch((error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY),
                error: error
            });
            // error is handled by the platform PSD component
            (0, $7Sm4c.markErrorAsHandled)(error);
            // The error will bubble up and the parent component will catch the error and handle it
            throw error;
        });
        experienceTracker.succeed({
            name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY)
        });
        return {
            sections: [
                {
                    id: 'recent-confluence-items',
                    title: workedOnAPIEnabled ? intl.formatMessage((0, $a33223da5daebf45$export$a7357cdd1f0b0168).recentlyWorkedOn) : intl.formatMessage((0, $a33223da5daebf45$export$a7357cdd1f0b0168).recentlyViewed),
                    searchResults: recentContents,
                    resultLimit: $38ca96c4d9c67f5e$var$MAX_RESULTS_CONTENTS,
                    titleRenderer: (0, $f5220b530c5db4b0$export$b25447981a133bbe)(autocorrectEnabled, workedOnAPIEnabled, intl.formatMessage),
                    resultRenderer: (0, $7b25068d4e2f79dd$export$bba16a2668c13d43)
                },
                {
                    id: 'recent-confluence-spaces',
                    title: intl.formatMessage((0, $a33223da5daebf45$export$a7357cdd1f0b0168).spaces),
                    searchResults: recentSpaces,
                    resultLimit: $38ca96c4d9c67f5e$var$MAX_RESULTS_SPACES
                }
            ]
        };
    }, [
        confCloudClient,
        cloudId,
        userId,
        intl,
        autocorrectEnabled,
        experienceTracker,
        workedOnAPIEnabled,
        objectTypes
    ]);
    const { backendExperiment: backendExperiment, productEdition: productEdition } = (0, $1HFOS.useDynamicBackendExperiment)({
        cloudId: cloudId,
        entities: contentEntities,
        userId: userId || undefined,
        experience: 'quick-search'
    }) || {};
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    const searchClientConfig = {
        graphQLEnabled: true,
        graphQLPromise: (args)=>aggClient.query({
                query: (0, $cvntw.ConfluenceQuickSearchQuery),
                variables: (0, $g9GR5.confluenceGraphQLSearchVariablesMapper)({
                    ...args,
                    cloudId: cloudId,
                    contentEntities: contentEntities,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                            name: name,
                            layerId: layerId,
                            shadowId: shadowId,
                            definitions: definitions
                        })),
                    isLivePagesEnabled: (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in')
                })
            }).then((response)=>response.data),
        cloudId: cloudId,
        userId: principalId
    };
    return {
        experimentLayers: backendExperiment?.experimentLayers?.map((layer)=>{
            const { analyticsDefinitions: analyticsDefinitions, definitions: _definitions, ...rest } = layer;
            return {
                ...rest,
                definitions: analyticsDefinitions
            };
        }),
        productEdition: productEdition,
        preQueryItemSupplier: preQueryItemSupplier,
        searchClientConfig: searchClientConfig
    };
};
const $38ca96c4d9c67f5e$export$26482aebefd0500f = (0, $eSUdr.default)`query useConfluenceItemSuppliersRecentQuickSearchQuery($cloudId:ID!$contentItemsLimit:Int!$spaceLimit:Int!$objectTypes:[String!]$eventTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes eventTypes:$eventTypes}}first:$contentItemsLimit){edges{node{id object{id data{...on ConfluencePage{id title type pageStatus:status links{webUi}space{id name}}...on ConfluenceBlogPost{id title type blogStatus:status links{webUi}space{id name}}...on ConfluenceWhiteboard{id title type status links{webUi}space{id name}}...on ConfluenceDatabase{id title type status links{webUi}space{id name}}...on ConfluenceEmbed{id title type status links{webUi}space{id name}}}}}}}}}myVisitedSpaces(limit:$spaceLimit){nodes{spaces{id key name icon{path}links{webui}}}}}`;


const $0508fd4bbb3caedf$export$303ed8cbfd5b717a = ({ isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled, isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled })=>{
    let contentScope = 'confluence.page,blogpost,attachment,embed,folder';
    const spaceAndUserScope = [
        'confluence.space',
        'urs.user-confluence'
    ];
    if (isQuickSearchForWhiteboardsEnabled) contentScope = `${contentScope},whiteboard`;
    if (isQuickSearchForDatabasesEnabled) contentScope = `${contentScope},database`;
    return {
        contentScope: contentScope,
        extensibleScopes: [
            contentScope,
            ...spaceAndUserScope
        ]
    };
};






var $3pfAb = parcelRequire("3pfAb");


var $kDuN4 = parcelRequire("kDuN4");

const $4875423f526257e1$export$4f8d571a44f08abe = ({ experimentLayers: experimentLayers, productEdition: productEdition, children: children })=>{
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        const action = event.payload.action;
        const actionSubject = event.payload.actionSubject;
        const actionSubjectId = event.payload.actionSubjectId;
        const isQuickFind = event.payload.attributes?.isQuickFind;
        // Do not update the event if its not a searchResults shown event on Quick Search
        if (actionSubject !== 'searchResults' || action !== 'shown' || actionSubjectId !== 'postQuerySearchResults' || isQuickFind) return;
        event.update((payload)=>{
            return {
                ...payload,
                attributes: {
                    ...payload.attributes,
                    backendExperiments: {
                        experimentLayers: experimentLayers
                    },
                    productEdition: productEdition,
                    abTest: undefined
                }
            };
        });
    }, [
        experimentLayers,
        productEdition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $3pfAb.FabricChannel).elements
    }, children);
};


const $8a27c616de5aba0e$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER = 'watermelon';
const $8a27c616de5aba0e$var$COMPASS_PRODUCT_IDENTIFIER = 'compass';
const $8a27c616de5aba0e$var$AI_SEARCH_PREQUERY_BANNER_MESSAGE_ID = 'confluence.frontend.search.sain.prequery.banner.message';
const $8a27c616de5aba0e$export$c89d6fd97d04eec5 = (0, $gXsSh.withRoutesContext)((props)=>{
    const { cloudId: cloudId, aggregatorUrl: aggregatorUrl, formatDate: formatDate, isExpanded: isExpanded, forwardRef: forwardRef, linkComponent: linkComponent, onNavigate: onNavigate, onNavigateSecondary: onNavigateSecondary, setIsExpanded: setIsExpanded, theme: theme, user: user, features: { jiraFeatures: jiraFeatures, interactiveSkeleton: interactiveSkeleton }, clearStickySearchRef: clearStickySearchRef, shouldFillContainer: shouldFillContainer, getQueryParams: getQueryParams } = props;
    const { edition: edition, userId: userId, orgId: orgId, locale: locale } = (0, $bQm3c.useSessionData)();
    const [showPrequeryBanner, setShowPrequeryBanner] = (0, $42omo.useState)(false);
    const [prequeryBannerEligible, prequeryBannerDismissed, prequeryBannerError] = (0, $9oxdN.useFeatureDiscovery)($8a27c616de5aba0e$var$AI_SEARCH_PREQUERY_BANNER_MESSAGE_ID);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isQuickSearchForWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isQuickSearchForDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const autocorrectEnabled = locale.split('-')[0] === 'en';
    const objectTypes = [
        (0, $df938f5c6250aebc$export$4edf00fad4b97379).PAGE,
        (0, $df938f5c6250aebc$export$4edf00fad4b97379).BLOGPOST,
        (0, $df938f5c6250aebc$export$4edf00fad4b97379).EMBED,
        ...isQuickSearchForWhiteboardsEnabled ? [
            (0, $df938f5c6250aebc$export$4edf00fad4b97379).WHITEBOARD
        ] : [],
        ...isQuickSearchForDatabasesEnabled ? [
            (0, $df938f5c6250aebc$export$4edf00fad4b97379).DATABASE
        ] : []
    ];
    const { experimentLayers: experimentLayers, productEdition: productEdition, ...confluenceSuppliers } = (0, $38ca96c4d9c67f5e$export$4c9ff87550df51de)({
        cloudId: cloudId,
        userId: userId,
        principalId: userId || undefined,
        formatDate: formatDate,
        autocorrectEnabled: autocorrectEnabled,
        isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled,
        objectTypes: objectTypes
    });
    const dismissPrequeryBanner = ()=>{
        setShowPrequeryBanner(false);
        prequeryBannerDismissed();
    };
    const { aiSearchConfig: aiSearchConfig } = (0, $1mK5P.useAISearchSupplier)({
        prequeryBannerEnabled: showPrequeryBanner,
        dismissPrequeryBanner: dismissPrequeryBanner
    });
    (0, $42omo.useEffect)(()=>{
        if (prequeryBannerEligible && !prequeryBannerError) setShowPrequeryBanner(true);
    }, [
        prequeryBannerEligible,
        prequeryBannerError
    ]);
    const onNavigateMultiProduct = (id, href)=>{
        const navigationCallback = id === 'confluence' ? onNavigate : onNavigateSecondary;
        navigationCallback(href);
    };
    const { contentScope: contentScope, extensibleScopes: extensibleScopes } = (0, $0508fd4bbb3caedf$export$303ed8cbfd5b717a)({
        isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled
    });
    const queryParams = getQueryParams();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80L9g.UserInputContextProvider), {
        stickySearchEnabled: true,
        isExpanded: isExpanded,
        resetStickySearchRef: clearStickySearchRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67a90fc752dffcfd$export$eb71bf38f5ae0f9c), {
        isEnabled: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d37a1f8828c7be3a$export$eb71bf38f5ae0f9c), {
        isEnabled: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4875423f526257e1$export$4f8d571a44f08abe), {
        experimentLayers: experimentLayers,
        productEdition: productEdition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e2053bb9142cd57$export$c952be4395be8d29), {
        aiSearchConfig: aiSearchConfig,
        aggregatorUrl: aggregatorUrl,
        abTestCloudId: cloudId,
        orgId: orgId,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        theme: theme,
        user: user,
        forwardRef: forwardRef,
        onNavigateGeneric: onNavigateMultiProduct,
        dialogFeatures: {
            interactiveSkeleton: interactiveSkeleton,
            isGriffinNavEnabled: true
        },
        edition: edition?.toString(),
        shouldFillContainer: shouldFillContainer,
        queryParams: queryParams
    }, ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            role: "tabpanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f7f0d09c2b7d826$export$9afff4557e36fda3), {
            order: 0,
            linkComponent: linkComponent,
            formatDate: formatDate,
            onRetry: onRetry,
            permissionSupplier: ()=>Promise.resolve(extensibleScopes),
            ...confluenceSuppliers,
            isPrefetchingEnabled: true,
            recentClientConfig: {
                url: (0, $jlIaF.CONTEXT_PATH),
                cloudId: cloudId,
                isUserAnonymous: !userId,
                isCollaborationGraphEnabled: false,
                collaborationGraphUrl: '/gateway/api/collaboration'
            },
            autocorrectEnabled: autocorrectEnabled,
            additionalContentTypesEnabled: true,
            aiSearchConfig: aiSearchConfig,
            rendererOverride: {
                ConfluenceResultRenderer: $7b25068d4e2f79dd$export$bba16a2668c13d43,
                contentScope: contentScope
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $704bede17293a569$export$8db2a2835d8b9d10), {
            order: 1,
            formatDate: formatDate,
            onRetry: onRetry,
            features: jiraFeatures
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3cc71055164da496$export$a83467d99f696187), {
            order: 2,
            onRetry: onRetry,
            features: {
                enableSingleScopesCall: true
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cbf2f1ae9737b11$export$7571e7fdcc46c96b), {
            order: 3,
            onRetry: onRetry,
            cloudId: cloudId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dc7d02d49b2e18c$export$b2c9c8ae315d8935), {
            order: 4,
            onRetry: onRetry,
            userTeamConfig: {
                context: {
                    contextType: 'filter',
                    organizationId: orgId,
                    principalId: 'Context',
                    productKey: $8a27c616de5aba0e$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER,
                    siteId: cloudId
                }
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab7ced8b5c4b8113$export$78fe0655c043c20), {
            order: 5,
            onRetry: onRetry
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c70e830949a8116b$export$47b1e713578cc03f), {
            sourceContext: "confluence",
            isUserAnonymous: !userId,
            order: 6,
            onRetry: onRetry,
            userTeamConfig: {
                context: {
                    contextType: 'CompassFilter',
                    organizationId: orgId,
                    principalId: 'Context',
                    productKey: $8a27c616de5aba0e$var$COMPASS_PRODUCT_IDENTIFIER,
                    siteId: cloudId
                }
            }
        })))))));
});



var $lI5WA = parcelRequire("lI5WA");




const $350bb53b739c1971$export$c0d6ac131d4391b9 = 'search-spotlight';
const $350bb53b739c1971$export$3ae94a2503e890a1 = (date)=>{
    const timeAgo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: date,
        dateFormatOptions: {
            month: 'short'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...(0, $lI5WA.i18n).lastUpdatedDate,
        values: {
            datetime: timeAgo
        }
    });
};
const $350bb53b739c1971$var$analyticsContainerStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $350bb53b739c1971$var$NavigationSearchDialogWithRouter = ({ theme: theme, shouldFillContainer: shouldFillContainer, intl: intl, clearStickySearchRef: clearStickySearchRef })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const searchInputRef = (0, $42omo.useRef)(null);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const openDialog = (e)=>{
        if (e) {
            e.preventDefault(); //prevent shortcut key from being added to search input
            searchInputRef.current?.focus();
        }
        setIsOpen(true);
    };
    const closeDialog = ()=>{
        setIsOpen(false);
    };
    const onResultLinkClick = ()=>{
        closeDialog();
    };
    const onNavigate = (url)=>{
        closeDialog();
        push(url);
    };
    const onInteractiveSkeletonEnter = (0, $kPjLK.generateInteractiveSkeletonOnEnter)(push);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'search',
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4'
                }
            }
        }).fire();
    };
    const getRootSearchDialog = ({ ref: ref, ...rest }, clientProviderConfig)=>{
        const { cloudId: cloudId, aggregatorUrl: aggregatorUrl } = clientProviderConfig;
        const interactiveSkeleton = {
            onEnter: onInteractiveSkeletonEnter,
            placeholder: intl.formatMessage((0, $lI5WA.i18n).placeholder)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgqtG.SpotlightManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ehdd.SpotlightTarget), {
            name: $350bb53b739c1971$export$c0d6ac131d4391b9
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $350bb53b739c1971$var$analyticsContainerStyles,
            onClick: fireClickAnalytics,
            "data-vc": "app-navigation-search-dialog",
            "data-ssr-placeholder-replace": "search-input"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $236feafa6fe3ed5c$export$80d66f5e04b5ca9e), {
            channel: "fabric-elements",
            targetActionSubjects: [
                'postQuerySearchResults',
                'cachedResults'
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a27c616de5aba0e$export$c89d6fd97d04eec5), {
            jiraFeatures: {
                hasSoftwareAccess: true
            },
            forwardRef: ref,
            setIsExpanded: (value)=>value ? openDialog(null) : closeDialog(),
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl,
            onNavigateSecondary: (href)=>{
                // eslint-disable-next-line no-restricted-syntax
                window.location.assign(href);
            },
            features: {
                jiraFeatures: rest.jiraFeatures,
                confluenceFeatures: rest.confluenceFeatures,
                interactiveSkeleton: interactiveSkeleton
            },
            clearStickySearchRef: clearStickySearchRef,
            ...rest
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iPfZG.EngagementSpotlight), {
            isMigrated: true,
            engagementId: $350bb53b739c1971$export$c0d6ac131d4391b9
        }));
    };
    const getSearchDialog = (searchDialogProps, clientProviderConfig)=>{
        const autoAddCurrentSpaceIsEnabled = false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageSubscriber), null, ({ spaceKey: spaceKey })=>{
            return !!spaceKey && autoAddCurrentSpaceIsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $844c79f4d45e1a83$export$109846573338f1b2), {
                spaceKey: spaceKey
            }, ({ currentSpace: currentSpace, loading: loading })=>{
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kPjLK.InteractiveSearchInputSkeleton), {
                    theme: searchDialogProps.theme,
                    shouldFillContainer: searchDialogProps.shouldFillContainer
                });
                else {
                    const currentSpaceValid = currentSpace && Object.values(currentSpace).every((v)=>v !== undefined);
                    return getRootSearchDialog({
                        ...searchDialogProps,
                        confluenceFeatures: {
                            currentSpace: currentSpaceValid ? currentSpace : undefined
                        }
                    }, clientProviderConfig);
                }
            }) : getRootSearchDialog({
                ...searchDialogProps
            }, clientProviderConfig);
        });
    };
    const universalNavigationShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_NAVIGATION_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_NAVIGATION_SHORTCUT_WIN);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, ({ cloudId: cloudId, userId: userId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed5c1b85ee8abc07$export$5d91bb6ce8e0f47), {
            cloudId: cloudId,
            userId: userId,
            useUrsForPeopleSearch: false
        }, ({ clientProviderConfig: clientProviderConfig })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO,
                modal: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fqwa.UserContext), null, ({ data: data, isLoading: isLoading })=>{
                return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kPjLK.InteractiveSearchInputSkeleton), {
                    theme: theme,
                    shouldFillContainer: shouldFillContainer
                }) : getSearchDialog({
                    isExpanded: isOpen,
                    onOpen: openDialog,
                    onClose: closeDialog,
                    linkComponent: (0, $42ea84ce17f63a94$export$7298e35d46e5a43)(onResultLinkClick),
                    formatDate: $350bb53b739c1971$export$3ae94a2503e890a1,
                    ref: searchInputRef,
                    theme: theme,
                    user: {
                        name: data && data.name,
                        email: data && data.email,
                        id: data && data.id
                    },
                    onNavigate: onNavigate,
                    shouldFillContainer: shouldFillContainer
                }, clientProviderConfig);
            })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.NAVIGATION_SHORTCUT) : undefined,
        accelerator: isLiveEditMode || isOnEditRoute ? universalNavigationShortcut : [
            universalNavigationShortcut,
            (0, $gnkil.NAVIGATION_SLASH_SHORTCUT)
        ],
        listener: openDialog,
        isAppNavigationShortcut: true
    }));
};
const $350bb53b739c1971$var$NavigationSearchDialogInternal = (0, $gmMgo.default)($350bb53b739c1971$var$NavigationSearchDialogWithRouter);
const $350bb53b739c1971$export$8d31f534ef9d9122 = (props)=>{
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    return isQuickFindEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $escKD.QuickFindNav3), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($350bb53b739c1971$var$NavigationSearchDialogInternal, props);
};
module.exports["NavigationSearchDialog"] = $350bb53b739c1971$export$8d31f534ef9d9122;

});

parcelRegister("3NyIw", function(module, exports) {
// A imperfect workaround to represent variadic parameters (varargs) in typescript
class $d9c68f16ddda70b9$export$de40364712978bcb {
    get(...args) {
        if (!this.currentValue || Date.now() >= this.nextCacheRefreshTime) {
            this.updateNextRefreshTime();
            let exception = new Error('');
            try {
                const result = this.supplier(...args);
                this.currentValue = result;
                if (this.currentValue) return {
                    fromCache: false,
                    value: this.currentValue
                };
            } catch (e) {
                // If there's an error we will return the last good value but will attempt again on the next get()
                this.invalidate();
                exception = e;
            }
            if (!this.currentValue) throw new Error(`Failed to initialise a value for the cache: ${exception?.stack}`);
        }
        return {
            fromCache: true,
            value: this.currentValue
        };
    }
    /**
   * Calls the given supplier and caches the value. If the value is a promise
   * which rejects, the cache will be invalidated and a subsequent call to
   * this function will call the supplier again.
   * @param args
   * @returns
   */ getAsync(...args) {
        const { fromCache: fromCache, value: value } = this.get(...args);
        // When the cached value is a promise which rejects, invalidate the cache
        Promise.resolve(value).catch(()=>this.invalidate());
        return {
            fromCache: fromCache,
            value: value
        };
    }
    invalidate() {
        this.nextCacheRefreshTime = Date.now();
    }
    updateNextRefreshTime() {
        this.nextCacheRefreshTime = Date.now() + this.timeoutMs;
    }
    /**
   * @param initialValue The initial value, if undefined then the first get() call when initiate the cache value
   *
   * @param supplier The callback that will be called if the cache times out or if no existing value exists for the cache.
   *                 In the case that the supplier throws an exception the error will not be cached. If there's an error
   *                    we will instead return the last known good value but will attempt to refresh the cache again the next time
   *                    get() is called.
   *                 Any parameters passed into get() will be passed through to supplier. Unlike memoize the cache does not
   *                    care about the parameters and will not be invalidated if these parameters change.
   *
   * @param timeoutMs The time to wait before allowing the cache to refresh, this defaults to 15 mins.
   */ constructor(supplier, initialValue = null, timeoutMs = $d9c68f16ddda70b9$export$de40364712978bcb.DEFAULT_TIMEOUT_IN_MS){
        this.timeoutMs = void 0;
        this.nextCacheRefreshTime = Date.now();
        this.currentValue = void 0;
        this.supplier = void 0;
        this.timeoutMs = timeoutMs;
        this.supplier = supplier;
        this.currentValue = null;
        if (initialValue) {
            this.currentValue = initialValue;
            this.updateNextRefreshTime();
        }
    }
}
$d9c68f16ddda70b9$export$de40364712978bcb.DEFAULT_TIMEOUT_IN_MS = 900000;
module.exports["SimpleCache"] = $d9c68f16ddda70b9$export$de40364712978bcb;

});

parcelRegister("jkExj", function(module, exports) {

let $e12f543ff285ff48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e12f543ff285ff48$var$load("9S9Mz"),
    $e12f543ff285ff48$var$load("fjYIR"),
    $e12f543ff285ff48$var$load("efZH2")
]).then(()=>parcelRequire('mS2VM'));

});

parcelRegister("escKD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $4jplB = parcelRequire("4jplB");

const $9d71cfad51bcb6ee$export$d916d15625b46dc9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "quick-find-container",
        xcss: $9d71cfad51bcb6ee$var$searchBarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9d71cfad51bcb6ee$var$searchBarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4jplB.QuickFind), null)));
const $9d71cfad51bcb6ee$var$searchBarWrapper = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '200px',
    height: "var(--ds-space-500, 40px)"
});
const $9d71cfad51bcb6ee$var$searchBarContainer = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    bottom: 'space.0',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 'dialog'
});
module.exports["QuickFindNav3"] = $9d71cfad51bcb6ee$export$d916d15625b46dc9;

});

parcelRegister("kmpep", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $12cJV = parcelRequire("12cJV");


var $91yhh = parcelRequire("91yhh");

const $1c8fa64373cfd191$var$AggregatorClientContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $1c8fa64373cfd191$export$db02e603a9db00 = ({ abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, children: children })=>{
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const aggregatorClient = (0, $42omo.useMemo)(()=>new (0, $12cJV.AggregatorClient)({
            url: aggregatorUrl,
            cloudId: abTestCloudId,
            siteMasterList: [],
            backendExperiment: backendExperiment
        }), [
        abTestCloudId,
        aggregatorUrl,
        backendExperiment
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1c8fa64373cfd191$var$AggregatorClientContext.Provider, {
        value: aggregatorClient,
        children: children
    });
};
const $1c8fa64373cfd191$export$b8a9ed32354e757e = ()=>{
    const aggregatorClient = (0, $42omo.useContext)($1c8fa64373cfd191$var$AggregatorClientContext);
    return aggregatorClient;
};
const $1c8fa64373cfd191$export$51bbe78d05c20324 = ()=>{
    // Casting done here to ensure that the result types match the scopes requested
    const untypedClient = (0, $42omo.useContext)($1c8fa64373cfd191$var$AggregatorClientContext);
    return untypedClient;
};
module.exports["AggregatorClientContextProvider"] = $1c8fa64373cfd191$export$db02e603a9db00;
module.exports["useAggregatorClient"] = $1c8fa64373cfd191$export$b8a9ed32354e757e;
module.exports["useTypedAggregatorClient"] = $1c8fa64373cfd191$export$51bbe78d05c20324;

});

parcelRegister("4ldrV", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $hpDfc = parcelRequire("hpDfc");

const $833e609371746364$var$SearchSessionContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    searchSessionId: undefined
});
class $833e609371746364$var$SearchSessionProviderError extends Error {
    constructor(){
        super('Could not find any SearchSessionProvider, make sure there is a SearchSessionProvider further up the tree');
    }
}
function $833e609371746364$export$432081be24450536(Component) {
    const WrapperComponent = (props)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)($833e609371746364$var$SearchSessionContext.Consumer, {
            children: ({ searchSessionId: searchSessionId })=>{
                if (!searchSessionId) throw new $833e609371746364$var$SearchSessionProviderError();
                return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props,
                    searchSessionId: searchSessionId
                });
            }
        });
    };
    return WrapperComponent;
}
class $833e609371746364$export$facabd4fde35268 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromProps(props, state) {
        // Reset the searchSessionId only when the dialog is expanded
        return {
            sessionKey: props.sessionKey,
            searchSessionId: props.sessionKey !== state.sessionKey && props.sessionKey !== 'ssid_provider_false' ? // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))() : state.searchSessionId
        };
    }
    render() {
        const { children: children } = this.props;
        const { searchSessionId: searchSessionId } = this.state;
        return /*#__PURE__*/ (0, $l998X.jsx)($833e609371746364$var$SearchSessionContext.Provider, {
            value: {
                searchSessionId: searchSessionId
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
                analyticContext: {
                    searchSessionId: searchSessionId
                },
                nonPrivacySafeAnalyticContext: {},
                children: children
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            sessionKey: this.props.sessionKey,
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
        };
    }
}
function $833e609371746364$export$e1e7a4797df1a656() {
    const { searchSessionId: searchSessionId } = (0, $42omo.useContext)($833e609371746364$var$SearchSessionContext);
    if (searchSessionId) return searchSessionId;
    throw new $833e609371746364$var$SearchSessionProviderError();
}
module.exports["SearchSessionProvider"] = $833e609371746364$export$facabd4fde35268;
module.exports["useSearchSessionId"] = $833e609371746364$export$e1e7a4797df1a656;

});

parcelRegister("88j1D", function(module, exports) {
const $aa1fd6477603f439$export$f76bd7c689371575 = 'sites';
const $aa1fd6477603f439$export$d3212964e526b51c = 'default';
var $aa1fd6477603f439$export$ab762b8071023de0 = /*#__PURE__*/ function(FilterUIVariant) {
    FilterUIVariant["CHECKBOX"] = "CHECKBOX";
    FilterUIVariant["STATIC_SELECT"] = "STATIC_SELECT";
    FilterUIVariant["MULTI_SELECT"] = "MULTI_SELECT";
    return FilterUIVariant;
}({});
var $aa1fd6477603f439$export$2a1fb5b806348bf0 = /*#__PURE__*/ function(LastModifiedValues) {
    LastModifiedValues["DEFAULT"] = "default";
    LastModifiedValues["TODAY"] = "today";
    LastModifiedValues["YESTERDAY"] = "yesterday";
    LastModifiedValues["PAST_SEVEN_DAYS"] = "past7Days";
    LastModifiedValues["PAST_THIRTY_DAYS"] = "past30Days";
    LastModifiedValues["PAST_YEAR"] = "pastYear";
    return LastModifiedValues;
}({});
module.exports["SITE_FILTER_TYPE_NAME"] = $aa1fd6477603f439$export$f76bd7c689371575;
module.exports["DEFAULT_OPTION"] = $aa1fd6477603f439$export$d3212964e526b51c;
module.exports["FilterUIVariant"] = $aa1fd6477603f439$export$ab762b8071023de0;
module.exports["LastModifiedValues"] = $aa1fd6477603f439$export$2a1fb5b806348bf0;

});

parcelRegister("2ZIpG", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $80L9g = parcelRequire("80L9g");


var $hpDfc = parcelRequire("hpDfc");





var $3S0fp = parcelRequire("3S0fp");

const $bdba8c9822bcf66e$var$defaultAnalyticsContextState = {
    queryVersion: 0,
    isLoading: false
};
const $bdba8c9822bcf66e$var$analyticsContextReducer = (state, action)=>{
    switch(action.type){
        case 'queryVersion':
            return {
                ...state,
                queryVersion: action.value
            };
        case 'isLoading':
            return {
                ...state,
                isLoading: action.value
            };
        case 'reset':
            return $bdba8c9822bcf66e$var$defaultAnalyticsContextState;
        default:
            throw new Error();
    }
};
const $bdba8c9822bcf66e$export$d1f587f82ad51c4 = (query)=>{
    const [{ queryVersion: queryVersion, isLoading: isLoading }, setAdditionalAnalyticsContext] = (0, $42omo.useReducer)($bdba8c9822bcf66e$var$analyticsContextReducer, $bdba8c9822bcf66e$var$defaultAnalyticsContextState);
    const addAnalyticContext = (0, $42omo.useCallback)(()=>{
        return {
            wordCount: (0, $3S0fp.getWordCount)(query),
            queryLength: query.length,
            queryHash: (0, $3S0fp.sha256Hash)(query),
            queryHashSHA256: (0, $3S0fp.sha256Hash)(query),
            queryVersion: queryVersion
        };
    }, [
        query,
        queryVersion
    ]);
    const nonPrivacySafeContext = (0, $42omo.useCallback)(()=>{
        return {
            query: query
        };
    }, [
        query
    ]);
    return {
        isLoading: isLoading,
        setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
        addAnalyticContext: addAnalyticContext,
        nonPrivacySafeContext: nonPrivacySafeContext,
        queryVersion: queryVersion
    };
};



var $gF7Az = parcelRequire("gF7Az");

const $2904842909f92043$var$QueryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    query: '',
    queryVersion: 0,
    isLoading: false,
    setQuery: (ignore)=>{},
    setQueryOnly: (ignore)=>{},
    setAdditionalAnalyticsContext: (ignore)=>({})
});
const $2904842909f92043$export$96e4d538f00fbce1 = ({ children: children })=>{
    const [stateQuery, setStateQuery] = (0, $42omo.useState)('');
    const { stickySearchEnabled: stickySearchEnabled, query: sessionQuery, showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog, storeQuery: storeQuery } = (0, $80L9g.useSessionUserInput)();
    const query = stickySearchEnabled ? sessionQuery : stateQuery;
    const setQuery = (0, $42omo.useCallback)((value)=>{
        if (showSearchAIDialog) toggleShowSearchAIDialog(false);
        stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
    }, [
        showSearchAIDialog,
        toggleShowSearchAIDialog,
        stickySearchEnabled,
        storeQuery
    ]);
    const setQueryOnly = (0, $42omo.useCallback)((value)=>{
        stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
    }, [
        stickySearchEnabled,
        storeQuery
    ]);
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { isLoading: isLoading, setAdditionalAnalyticsContext: setAdditionalAnalyticsContext, addAnalyticContext: addAnalyticContext, nonPrivacySafeContext: nonPrivacySafeContext, queryVersion: queryVersion } = (0, $bdba8c9822bcf66e$export$d1f587f82ad51c4)(query);
    (0, $42omo.useEffect)(()=>{
        if (!isExpanded) {
            if (!stickySearchEnabled) setQuery('');
            setAdditionalAnalyticsContext({
                type: 'reset'
            });
        }
    }, [
        isExpanded,
        setAdditionalAnalyticsContext,
        stickySearchEnabled,
        setQuery
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($2904842909f92043$var$QueryContext.Provider, {
        value: {
            query: query,
            queryVersion: queryVersion,
            setQuery: setQuery,
            setQueryOnly: setQueryOnly,
            setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
            isLoading: isLoading
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: addAnalyticContext,
            nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeContext,
            children: children
        })
    });
};
const $2904842909f92043$export$dd0a697e1782aedd = ()=>{
    return (0, $42omo.useContext)($2904842909f92043$var$QueryContext);
};
module.exports["QueryContextProvider"] = $2904842909f92043$export$96e4d538f00fbce1;
module.exports["useQuery"] = $2904842909f92043$export$dd0a697e1782aedd;

});

parcelRegister("80L9g", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $epS7s = parcelRequire("epS7s");


var $6dP89 = parcelRequire("6dP89");


var $hpDfc = parcelRequire("hpDfc");


var $5dFS9 = parcelRequire("5dFS9");

const $14178128195429da$var$noop = ()=>{};
const $14178128195429da$var$SESSION_RESET_TIMEOUT_MS = 300000;
const $14178128195429da$var$anyConfluenceFiltersChecked = (filters)=>{
    const confluencefilters = filters.confluence;
    if (confluencefilters) {
        const hasSpaceFilterChecked = confluencefilters.space?.length ? confluencefilters.space?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        const hasPeopleFilterChecked = confluencefilters.people?.length ? confluencefilters.people?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        const hasSiteFilterChecked = confluencefilters.site?.length ? confluencefilters.site?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        return hasSpaceFilterChecked || hasPeopleFilterChecked || hasSiteFilterChecked;
    }
    return false;
};
const $14178128195429da$export$c87c231bb0fb0228 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    stickySearchEnabled: false,
    query: '',
    showSearchAIDialog: false,
    storeQuery: $14178128195429da$var$noop,
    toggleShowSearchAIDialog: $14178128195429da$var$noop,
    readFilters: $14178128195429da$var$noop,
    storeFilters: $14178128195429da$var$noop,
    resetSearchSession: $14178128195429da$var$noop,
    resetConfluenceFiltersRef: undefined,
    resetExtensibleFiltersRef: undefined
});
const $14178128195429da$export$dab413a8570d1ac4 = ({ stickySearchEnabled: stickySearchEnabled = false, sessionResetIdleTime: sessionResetIdleTime = $14178128195429da$var$SESSION_RESET_TIMEOUT_MS, isExpanded: isExpanded = false, resetStickySearchRef: resetStickySearchRef, children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const [query, setQuery] = (0, $42omo.useState)((0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY)) || '');
    const [isStickyUpdated, setIsStickyUpdated] = (0, $42omo.useState)(false);
    const [stickyQueryUpdated, setStickyQueryUpdated] = (0, $42omo.useState)(false);
    const queryFirstUpdatedRef = (0, $42omo.useRef)(undefined);
    const lastExpandRef = (0, $42omo.useRef)(false);
    const lastQueryRef = (0, $42omo.useRef)('');
    const timeoutRef = (0, $42omo.useRef)();
    const resetConfluenceFiltersRef = (0, $42omo.useRef)();
    const resetExtensibleFiltersRef = (0, $42omo.useRef)();
    const sessionShowSearchAIDialogStr = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY));
    const sessionShowSearchAIDialog = sessionShowSearchAIDialogStr ? JSON.parse(sessionShowSearchAIDialogStr) : false;
    const [showSearchAIDialog, setShowSearchAIDialog] = (0, $42omo.useState)(sessionShowSearchAIDialog);
    const resetSearchSession = (0, $42omo.useCallback)(()=>{
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_QUERY_KEY));
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY));
        resetConfluenceFiltersRef.current?.();
        resetExtensibleFiltersRef.current?.();
        setQuery('');
        setShowSearchAIDialog(false);
        queryFirstUpdatedRef.current = undefined;
        lastQueryRef.current = '';
    }, [
        resetConfluenceFiltersRef,
        resetExtensibleFiltersRef
    ]);
    const readFilters = (0, $42omo.useCallback)((productId)=>{
        const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
        if (productId in filters) return filters[productId];
        return {};
    }, []);
    const updateSessionResetTimeout = (0, $42omo.useCallback)(()=>{
        if (timeoutRef?.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            if (timeoutRef?.current) clearTimeout(timeoutRef.current);
            const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
            const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
            if (query === '' && !$14178128195429da$var$anyConfluenceFiltersChecked(filters)) return; // Skip the reset and analytics event if no filters or query entered
            resetSearchSession();
            fireAnalyticsEvent((0, $5dFS9.onStickySearchCleared)({
                timeout: sessionResetIdleTime
            }));
        }, sessionResetIdleTime);
    }, [
        query,
        sessionResetIdleTime,
        resetSearchSession,
        fireAnalyticsEvent
    ]);
    const storeQuery = (0, $42omo.useCallback)((query)=>{
        setQuery(query);
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_QUERY_KEY), query);
        updateSessionResetTimeout();
        if (queryFirstUpdatedRef.current === undefined) queryFirstUpdatedRef.current = Date.now();
        if (lastQueryRef.current) setStickyQueryUpdated(query !== lastQueryRef.current);
    }, [
        updateSessionResetTimeout
    ]);
    const toggleShowSearchAIDialog = (0, $42omo.useCallback)((showSearchAIDialog)=>{
        setShowSearchAIDialog(showSearchAIDialog);
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY), showSearchAIDialog.toString());
    }, []);
    const storeFilters = (0, $42omo.useCallback)((productId, value)=>{
        const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
        filters[productId] = value;
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY), JSON.stringify(filters));
        if (lastExpandRef.current) updateSessionResetTimeout;
    }, [
        lastExpandRef,
        updateSessionResetTimeout
    ]);
    (0, $42omo.useEffect)(()=>{
        if (resetStickySearchRef) resetStickySearchRef.current = resetSearchSession;
    });
    (0, $42omo.useEffect)(()=>{
        if (!lastExpandRef.current && isExpanded) updateSessionResetTimeout();
        if (lastExpandRef.current && !isExpanded) updateSessionResetTimeout();
    }, [
        lastExpandRef,
        isExpanded,
        updateSessionResetTimeout
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!lastExpandRef.current && isExpanded) {
            setIsStickyUpdated(query !== '');
            lastQueryRef.current = query;
            setStickyQueryUpdated(false);
        }
        lastExpandRef.current = isExpanded;
    }, [
        isExpanded,
        lastExpandRef,
        lastQueryRef,
        query
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($14178128195429da$export$c87c231bb0fb0228.Provider, {
        value: {
            stickySearchEnabled: stickySearchEnabled,
            query: query,
            showSearchAIDialog: showSearchAIDialog,
            storeQuery: stickySearchEnabled ? storeQuery : $14178128195429da$var$noop,
            toggleShowSearchAIDialog: toggleShowSearchAIDialog,
            readFilters: stickySearchEnabled ? readFilters : $14178128195429da$var$noop,
            storeFilters: stickySearchEnabled ? storeFilters : $14178128195429da$var$noop,
            resetSearchSession: stickySearchEnabled ? resetSearchSession : $14178128195429da$var$noop,
            resetConfluenceFiltersRef: stickySearchEnabled ? resetConfluenceFiltersRef : undefined,
            resetExtensibleFiltersRef: stickySearchEnabled ? resetExtensibleFiltersRef : undefined
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: stickySearchEnabled ? {
                isSticky: true,
                isStickyUpdated: isStickyUpdated,
                stickyQueryUpdated: stickyQueryUpdated,
                queryUpdatedAgo: queryFirstUpdatedRef.current ? Date.now() - queryFirstUpdatedRef.current : undefined
            } : {
                isSticky: false
            },
            children: children
        })
    });
};
const $14178128195429da$export$296c1552a8cb35a5 = ()=>{
    return (0, $42omo.useContext)($14178128195429da$export$c87c231bb0fb0228);
};
module.exports["UserInputContextProvider"] = $14178128195429da$export$dab413a8570d1ac4;
module.exports["useSessionUserInput"] = $14178128195429da$export$296c1552a8cb35a5;

});

parcelRegister("2jYn8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cStGJ = parcelRequire("cStGJ");

function $63fd68c4ea134445$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $63fd68c4ea134445$export$574c01fef92380ae = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "eh93uzp1"
})({
    name: "9th5i",
    styles: "margin:0 auto"
});
const $63fd68c4ea134445$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "eh93uzp0"
})({
    name: "1smqxmg",
    styles: "height:96px;width:100%;display:flex;align-items:center"
});



var $9hlns = parcelRequire("9hlns");


var $fwDOR = parcelRequire("fwDOR");

const $2eff2ad85863b392$var$QUICK_SEARCH_LOADING_HOLD = 'quick-search-loading';
const $2eff2ad85863b392$export$b08b517936747730 = ()=>{
    const spinner = /*#__PURE__*/ (0, $l998X.jsx)((0, $63fd68c4ea134445$export$a5e06607a5ac6158), {
        "data-testid": "search-dialog-loading-spinner",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $63fd68c4ea134445$export$574c01fef92380ae), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: $2eff2ad85863b392$var$QUICK_SEARCH_LOADING_HOLD,
        children: spinner
    });
};
module.exports["LoadingSpinner"] = $2eff2ad85863b392$export$b08b517936747730;

});

parcelRegister("jAnRi", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $e4619431597b06fa$export$af1e30ebbae9df3b = 'search-dialog';
const $e4619431597b06fa$export$e5b98327036a989d = new (0, $5aVN7.UFOExperience)('intialisation', {
    type: (0, $9NDUe.ExperienceTypes).Load,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $e4619431597b06fa$export$af1e30ebbae9df3b
    }
});
module.exports["COMPONENT"] = $e4619431597b06fa$export$af1e30ebbae9df3b;
module.exports["initialisationExperience"] = $e4619431597b06fa$export$e5b98327036a989d;

});

parcelRegister("bBxPo", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fJRVo = parcelRequire("fJRVo");

const $d457cad9438f33e2$export$13224c53a1606253 = ({ children: children, id: id })=>{
    const { getProduct: getProduct } = (0, $fJRVo.useProductContext)();
    const product = getProduct(id);
    if (!product?.isDisplayed) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ActiveProduct"] = $d457cad9438f33e2$export$13224c53a1606253;

});

parcelRegister("jTYcx", function(module, exports) {

let $e7d1da14e5d1bcc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7d1da14e5d1bcc3$var$load("8F6ik").then(()=>parcelRequire('f8JZq'));

});

parcelRegister("amrMu", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4wMwH = parcelRequire("4wMwH");

const $1fd3b472f26a38c1$export$98552201007e6417 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $1fd3b472f26a38c1$export$502d46f2366b5b43 = ({ dialogFeatures: dialogFeatures = {}, children: children })=>{
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    // Do not proceed with griffin navigation if query param props are not available
    const isGriffinNavEnabled = (0, $42omo.useMemo)(()=>dialogFeatures.isGriffinNavEnabled === true && queryParams !== undefined, [
        dialogFeatures.isGriffinNavEnabled,
        queryParams
    ]);
    return(/**
		 * Defaults and platfrom feature flag values can be overriden if explicit props are injected. This serves two purposes:
		 *
		 * 1. Storybook knobs can be provisioned for features that are powered by platfrom feature flags
		 *
		 * 2. Consumer products like Confluence, Jira can run statsig based experiments, where the Statsig evaluation happens in the product's code
		 * but the effect happens inside the code shipped by search platform.
		 */ /*#__PURE__*/ (0, $l998X.jsx)($1fd3b472f26a38c1$export$98552201007e6417.Provider, {
        value: {
            ...dialogFeatures,
            isGriffinNavEnabled: isGriffinNavEnabled
        },
        children: children
    }));
};
const $1fd3b472f26a38c1$export$38c566c0640fb69a = ()=>{
    return (0, $42omo.useContext)($1fd3b472f26a38c1$export$98552201007e6417);
};
module.exports["FeaturesProvider"] = $1fd3b472f26a38c1$export$502d46f2366b5b43;
module.exports["useFeaturesContext"] = $1fd3b472f26a38c1$export$38c566c0640fb69a;

});

parcelRegister("eztGN", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $cGCOz = parcelRequire("cGCOz");


var $iEwUU = parcelRequire("iEwUU");

const $70c648daba3c4f25$export$14841bea82c8a2c4 = (primaryProduct)=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $cGCOz.useRovoContext)();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    return $70c648daba3c4f25$export$52dc59b9f236d940(isRovoEnabled, orgId, primaryProduct);
};
const $70c648daba3c4f25$export$52dc59b9f236d940 = (isRovoEnabled, orgId, primaryProduct)=>!!(isRovoEnabled && orgId && primaryProduct === 'jira' && (0, $dh538.fg)('jira_rovo_in_quick_search'));
module.exports["useShowAtlassianHomeSearchLink"] = $70c648daba3c4f25$export$14841bea82c8a2c4;

});

parcelRegister("7ujO6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $DXuE9 = parcelRequire("DXuE9");

const $e1ffbeb6e0936f83$export$349601f91196bc9c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $DXuE9.TruncatedTextDiv), {
        ...props,
        ref: ref
    }));
module.exports["ForwardedRefToolTipTag"] = $e1ffbeb6e0936f83$export$349601f91196bc9c;

});

parcelRegister("DXuE9", function(module, exports) {

var $6fnsQ = parcelRequire("6fnsQ");


var $kPBHE = parcelRequire("kPBHE");


var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

function $9319a5a14fadb0c4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9319a5a14fadb0c4$export$636ae9b701e134a6 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e17810te5"
})({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'start',
    flexDirection: 'row',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}`,
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $2azjJ.dialogWidth),
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});
const $9319a5a14fadb0c4$export$f5ae33f1b01a6402 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e17810te4"
})({
    name: "1qp6hzm",
    styles: "margin-right:var(--ds-space-050, 4px);flex-shrink:0"
});
const $9319a5a14fadb0c4$export$f060a0d7354d6f0f = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e17810te3"
})({
    name: "l8l8b8",
    styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis"
});
const $9319a5a14fadb0c4$export$70f18730b5e534f8 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e17810te2"
})({
    name: "7bnap7",
    styles: "flex:1 1 0;overflow:hidden;max-width:max-content;margin-right:var(--ds-space-025, 2px)"
});
const $9319a5a14fadb0c4$export$c0a945c47b321ccb = /*#__PURE__*/ (0, $cStGJ.default)((0, $kPBHE.Link), {
    target: "e17810te1"
})({
    display: 'flex',
    textOverflow: 'ellipsis',
    borderRadius: "var(--ds-radius-small, 3px)",
    transitionDuration: '0.2s',
    transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:focus': {
        outline: 'none',
        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`} inset`
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
const $9319a5a14fadb0c4$export$62368ee747a81340 = /*#__PURE__*/ (0, $cStGJ.default)((0, $kPBHE.Link), {
    target: "e17810te0"
})({
    display: 'block',
    position: 'relative',
    '&:focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`}`,
        outlineOffset: '-2px'
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
module.exports["SearchFooterLinksContainer"] = $9319a5a14fadb0c4$export$636ae9b701e134a6;
module.exports["LabelContainer"] = $9319a5a14fadb0c4$export$f5ae33f1b01a6402;
module.exports["TruncatedTextDiv"] = $9319a5a14fadb0c4$export$f060a0d7354d6f0f;
module.exports["PrimaryButtonWrapper"] = $9319a5a14fadb0c4$export$70f18730b5e534f8;
module.exports["PrimaryButtonStyledLink"] = $9319a5a14fadb0c4$export$c0a945c47b321ccb;
module.exports["DropownMenuLink"] = $9319a5a14fadb0c4$export$62368ee747a81340;

});

parcelRegister("92OBo", function(module, exports) {

let $695b8d825f43abfa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $695b8d825f43abfa$var$load("6sXO4").then(()=>parcelRequire('gg9qV'));

});

parcelRegister("iBckn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eSUdr = parcelRequire("eSUdr");

const $7c8d7e5d36cb13e1$var$QuickFindSpacesFragment = (0, $eSUdr.default)`fragment QuickFindSpacesFragment on Space{id key name icon{path}links{webui}}`;
const $7c8d7e5d36cb13e1$export$9af2898b36d6a2cf = (0, $eSUdr.default)`query QuickFindSpacesQuery($spaceLimit:Int!){myVisitedSpaces(limit:$spaceLimit){nodes{spaces{...QuickFindSpacesFragment}}}}${$7c8d7e5d36cb13e1$var$QuickFindSpacesFragment}`;



var $ja8yA = parcelRequire("ja8yA");


var $4qT1X = parcelRequire("4qT1X");

const $c3125637c00709c9$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    __typename
    key
  }
}
`;
const $c3125637c00709c9$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    __typename
    key
  }
}
`;
const $c3125637c00709c9$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
  __typename
  lastModified
  latestUserAction @include(if: $includeUserSignals)
  latestUserActionTs @include(if: $includeUserSignals)
  iconCssClass
  space {
    __typename
    id
    name
  }
  confluenceEntity @include(if: $includeAncestors) {
    ... on ConfluencePage {
      __typename
      ancestors {
        __typename
        id
        title
      }
    }
  }
}`;
const $c3125637c00709c9$export$5db520940cf00715 = 'QuickFindSearchQuery';
const $c3125637c00709c9$export$5dd443f88002bca3 = `
  query ${$c3125637c00709c9$export$5db520940cf00715}(
    $query: String!
    $cloudIdARI: String!
    $resultsLimit: Int!
    $spaceLimit: Int!
    $contentEntities: [String!]!
    $confluenceFilters: SearchConfluenceFilter
    $queryVersion: Int
    $searchSessionId: String
    $includeSpaces: Boolean!
    $includeAncestors: Boolean!
    $includeUserSignals: Boolean!
    $experimentId: String
    $shadowExperimentId: String
    $experimentLayers: [SearchExperimentLayer]
  ) {
    search {
      results: search(
        experience: "quick-find"
        query: $query
        first: $resultsLimit
        filters: {
          entities: $contentEntities
          locations: [$cloudIdARI]
          confluenceFilters: $confluenceFilters
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
        experimentContext: {
          experimentId: $experimentId
          shadowExperimentId: $shadowExperimentId
          experimentLayers: $experimentLayers
        }
      ) {
        __typename
        edges {
          __typename
          node {
            id
            title
            url
            type
            iconUrl
            __typename
            ${$c3125637c00709c9$var$SearchConfluencePageBlogAttachment}
            ${$c3125637c00709c9$var$SearchResultAtlasProject}
            ${$c3125637c00709c9$var$SearchResultAtlasGoal}
          }
        }
        abTest {
          __typename
          abTestId
          controlId
          experimentId
        }
        totalCount
      }
      spaces: search(
        experience: "searchDialog"
        query: $query
        first: $spaceLimit
        filters: {
          entities: ["ati:cloud:confluence:space"]
          locations: [$cloudIdARI]
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
      ) @include(if: $includeSpaces) {
        __typename
        edges {
          __typename
          node {
            ... on SearchConfluenceSpace {
              __typename
              id
              key
              title
              type
              url
              iconPath
            }
          }
        }
      }
    }
  }
`;


const $8c45e3f8287acbdd$export$ac350a1cbaa2773a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $c3125637c00709c9$export$5dd443f88002bca3),
        operationName: $c3125637c00709c9$export$5db520940cf00715,
        headers: headers
    });
};



var $5kTPO = parcelRequire("5kTPO");

const $dca90199d0dcae68$var$MAX_RESULTS_USERS = 2;
const $dca90199d0dcae68$export$6e670d76ab78fcb3 = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $dca90199d0dcae68$export$69624d2b3a5a261b = ({ query: query, cloudId: cloudId, orgId: orgId, principalId: principalId = 'Context', intl: intl })=>(0, $5kTPO.default)({
        searchQueryFilter: $dca90199d0dcae68$export$6e670d76ab78fcb3,
        includeUsers: true,
        includeGroups: false,
        includeTeams: true,
        context: {
            contextType: 'confluence_search-dialog',
            principalId: principalId,
            productKey: 'confluence',
            siteId: cloudId,
            organizationId: orgId
        },
        maxNumberOfResults: $dca90199d0dcae68$var$MAX_RESULTS_USERS,
        query: query
    }, intl);


class $1c744931ef76935f$export$beb638af7aef4c03 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = void 0;
        this.name = 'GraphQLNoResultsWithErrorResponseError';
        this.graphQLErrors = graphQLErrors;
        this.message = 'GraphQL returned errors and no results';
    }
}


function $5eb9952c6e8f9411$export$e877f985e0128c5e(data, graphQLErrors) {
    // Return data if there are no errors
    if (!graphQLErrors?.length) return data;
    // Return data if there are errors, but there is also partial data
    if (graphQLErrors?.length && data) {
        console.warn('Returning partial data despite GraphQL errors: ', graphQLErrors);
        return data;
    }
    // Throw an exception only if there are errors and NO data
    throw new (0, $1c744931ef76935f$export$beb638af7aef4c03)(graphQLErrors);
}


const $39c726418f03e72e$var$INCLUDED_PRODUCTS = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
// To filter out Confluence comment results - although query does
// not include comment type it is still returning comment results
const $39c726418f03e72e$var$INCLUDED_OBJECT_TYPES = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED = 200;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED = 10;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED = 7;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED = 3;
const $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS = 7;
const $39c726418f03e72e$var$POST_QUERY_MAX_SPACES = 1;
const $39c726418f03e72e$export$9747eb11a16f4445 = 'recent-items';
const $39c726418f03e72e$export$3813b30107e5b323 = 'recent-spaces';
const $39c726418f03e72e$export$ec546060f7cdc293 = ({ confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, markErrorAsHandled: markErrorAsHandled, itemRenderer: itemRenderer, recentContentResultMapper: recentContentResultMapper, recentSpaceResultMapper: recentSpaceResultMapper, userId: userId, cloudId: cloudId })=>{
    return (0, $42omo.useCallback)(async ()=>{
        const getSections = ({ recentContents: recentContents, recentSpaces: recentSpaces })=>({
                sections: [
                    {
                        id: $39c726418f03e72e$export$9747eb11a16f4445,
                        title: '',
                        searchResults: recentContents,
                        resultLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED,
                        resultRenderer: itemRenderer
                    },
                    {
                        id: $39c726418f03e72e$export$3813b30107e5b323,
                        title: '',
                        searchResults: recentSpaces,
                        resultLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED,
                        resultRenderer: itemRenderer
                    }
                ]
            });
        if (!userId) return getSections({
            recentContents: [],
            recentSpaces: []
        });
        const recentActivitiesPromise = (0, $ja8yA.recentActivitiesQuery)({
            variables: {
                filteredProducts: $39c726418f03e72e$var$INCLUDED_PRODUCTS,
                filteredObjectTypes: $39c726418f03e72e$var$INCLUDED_OBJECT_TYPES,
                filteredRootContainerIds: [
                    `ari:cloud:platform::site/${cloudId}`,
                    // covers Confluence, Jira
                    `ari:cloud:townsquare::site/${cloudId}` // for some reason Atlas has a different root container id
                ],
                filteredEventTypes: [],
                itemsLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const recentSpacesPromise = confCloudClient ? confCloudClient.query({
            query: (0, $7c8d7e5d36cb13e1$export$9af2898b36d6a2cf),
            variables: {
                spaceLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED
            }
        }) : Promise.resolve(undefined);
        const { recentContents: recentContents, recentSpaces: recentSpaces } = await Promise.all([
            recentActivitiesPromise,
            recentSpacesPromise
        ]).then(([recentItemsResponse, recentSpacesResponse])=>{
            const recentContents = recentItemsResponse?.data?.activity?.myActivity?.all.edges.filter((edge)=>edge?.node?.object?.data).map(recentContentResultMapper) || [];
            const recentSpacesResults = (0, $5eb9952c6e8f9411$export$e877f985e0128c5e)(recentSpacesResponse?.data?.myVisitedSpaces, recentSpacesResponse?.errors);
            const recentSpaces = recentSpacesResults?.nodes?.spaces?.map(recentSpaceResultMapper) || [];
            return {
                recentContents: recentContents,
                recentSpaces: recentSpaces
            };
        }).catch((err)=>{
            markErrorAsHandled && markErrorAsHandled(err);
            throw err;
        });
        return getSections({
            recentContents: recentContents,
            recentSpaces: recentSpaces
        });
    }, [
        confCloudClient,
        userId,
        markErrorAsHandled,
        itemRenderer,
        recentContentResultMapper,
        recentSpaceResultMapper,
        aggAbsoluteUrl,
        cloudId
    ]);
};
const $39c726418f03e72e$var$CONFLUENCE_CONTENT_ENTITIES = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database'
];
const $39c726418f03e72e$var$ATLAS_ENTITIES = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
const $39c726418f03e72e$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID = 'townsquare.project,goal,tag';
const $39c726418f03e72e$export$7b0766a033869f00 = 'confluence.page,blogpost,attachment';
const $39c726418f03e72e$export$47653725e5b469bb = 'space';
const $39c726418f03e72e$export$f80b16ba1f3b0d5c = 'people-and-teams';
const $39c726418f03e72e$var$ProductKeys = {
    Confluence: 'confluence',
    Atlas: 'townsquare'
};
const $39c726418f03e72e$export$f872504428bf2e7e = ({ aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, resultRenderer: resultRenderer, confluenceResultMapper: confluenceResultMapper, atlasResultMapper: atlasResultMapper, spaceResultMapper: spaceResultMapper, peopleAndTeamsResultMapper: peopleAndTeamsResultMapper, sectionTitle: sectionTitle, userId: userId, orgId: orgId, primaryProduct: primaryProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, serveUserShardUI: serveUserShardUI = false })=>{
    const intl = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)(async (args)=>{
        const { query: query, analyticsInfo: analyticsInfo } = args;
        const getPeopleAndTeamsResults = async (query, userId, cloudId)=>{
            if (!userId || !cloudId) return [];
            const peopleResults = await (0, $dca90199d0dcae68$export$69624d2b3a5a261b)({
                query: query,
                cloudId: cloudId,
                principalId: userId || '',
                orgId: orgId || '',
                intl: intl
            }).catch((e)=>{
                console.error(e);
                return [];
            });
            return peopleResults.map(peopleAndTeamsResultMapper);
        };
        const getConfluenceResults = async (query, cloudId)=>{
            const contentQueryResults = await (0, $8c45e3f8287acbdd$export$ac350a1cbaa2773a)({
                variables: {
                    query: query,
                    cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                    resultsLimit: $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS,
                    spaceLimit: $39c726418f03e72e$var$POST_QUERY_MAX_SPACES,
                    includeAncestors: true,
                    // to show breadcrumbs
                    includeUserSignals: serveUserShardUI,
                    contentEntities: $39c726418f03e72e$var$CONFLUENCE_CONTENT_ENTITIES,
                    confluenceFilters: {
                        titleMatchOnly: true
                    },
                    searchSessionId: analyticsInfo?.searchSessionId,
                    queryVersion: analyticsInfo?.queryVersion,
                    includeSpaces: true,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const contentResponse = contentQueryResults.data?.search.results?.edges || [];
            const contentResults = contentResponse.map(confluenceResultMapper);
            const spaceResponse = contentQueryResults.data?.search.spaces?.edges || [];
            const spaceResults = spaceResponse.map(spaceResultMapper);
            return {
                contentResults: contentResults,
                spaceResults: spaceResults
            };
        };
        const getAtlasResults = async (query, analyticsInfo)=>{
            const contentQueryResults = await (0, $8c45e3f8287acbdd$export$ac350a1cbaa2773a)({
                variables: {
                    query: query,
                    cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                    contentEntities: $39c726418f03e72e$var$ATLAS_ENTITIES,
                    confluenceFilters: {
                        titleMatchOnly: true
                    },
                    // this filter is applied on Atlas results as well
                    resultsLimit: $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS,
                    spaceLimit: $39c726418f03e72e$var$POST_QUERY_MAX_SPACES,
                    includeAncestors: false,
                    includeUserSignals: false,
                    // Atlas entities don't have user action data
                    searchSessionId: analyticsInfo?.searchSessionId,
                    queryVersion: analyticsInfo?.queryVersion,
                    includeSpaces: false,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const contentResponse = contentQueryResults.data?.search.results?.edges || [];
            const contentResults = contentResponse.map(atlasResultMapper);
            return {
                contentResults: contentResults,
                spaceResults: []
            };
        };
        const getResults = (product)=>{
            switch(product){
                case $39c726418f03e72e$var$ProductKeys.Confluence:
                    return getConfluenceResults(query, cloudId);
                case $39c726418f03e72e$var$ProductKeys.Atlas:
                    return getAtlasResults(query, analyticsInfo);
                default:
                    return getConfluenceResults(query, cloudId);
            }
        };
        const { contentResults: contentResults, spaceResults: spaceResults } = await getResults(primaryProduct);
        const peopleAndTeamsResults = await getPeopleAndTeamsResults(query, userId, cloudId);
        const getContentSectionId = (product)=>{
            switch(product){
                case $39c726418f03e72e$var$ProductKeys.Confluence:
                    return $39c726418f03e72e$export$7b0766a033869f00;
                case $39c726418f03e72e$var$ProductKeys.Atlas:
                    return $39c726418f03e72e$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID;
                default:
                    return $39c726418f03e72e$export$7b0766a033869f00;
            }
        };
        return {
            sections: [
                {
                    id: getContentSectionId(primaryProduct),
                    title: sectionTitle,
                    searchResults: contentResults,
                    resultRenderer: resultRenderer
                },
                {
                    id: $39c726418f03e72e$export$47653725e5b469bb,
                    searchResults: spaceResults,
                    title: !contentResults.length ? sectionTitle : '',
                    resultRenderer: resultRenderer
                },
                {
                    id: $39c726418f03e72e$export$f80b16ba1f3b0d5c,
                    searchResults: peopleAndTeamsResults,
                    title: !contentResults.length && !spaceResults.length ? sectionTitle : '',
                    resultRenderer: resultRenderer
                }
            ],
            experimentLayers: experimentLayers ?? []
        };
    }, [
        cloudId,
        resultRenderer,
        confluenceResultMapper,
        atlasResultMapper,
        spaceResultMapper,
        peopleAndTeamsResultMapper,
        sectionTitle,
        intl,
        orgId,
        userId,
        aggAbsoluteUrl,
        primaryProduct,
        experimentId,
        shadowExperimentId,
        experimentLayers,
        serveUserShardUI
    ]);
};
module.exports["RECENT_ITEMS_SECTION_ID"] = $39c726418f03e72e$export$9747eb11a16f4445;
module.exports["RECENT_SPACES_SECTION_ID"] = $39c726418f03e72e$export$3813b30107e5b323;
module.exports["useQuickFindItemSupplier"] = $39c726418f03e72e$export$ec546060f7cdc293;
module.exports["CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID"] = $39c726418f03e72e$export$7b0766a033869f00;
module.exports["useQuickFindPostQueryItemSupplier"] = $39c726418f03e72e$export$f872504428bf2e7e;

});

parcelRegister("8ioQN", function(module, exports) {
const $e45c02ccc2a6876d$export$205c1cd8d8ed1926 = {
    size: 0,
    sections: []
};
module.exports["EMPTY_SEARCH_ITEMS"] = $e45c02ccc2a6876d$export$205c1cd8d8ed1926;

});

parcelRegister("jFPud", function(module, exports) {
var $dfe01d0022147fd7$export$c701d1d8ac310aa0 = /*#__PURE__*/ function(APIStates) {
    APIStates["Typing"] = "typing";
    APIStates["Loading"] = "loading";
    APIStates["Error"] = "error";
    APIStates["NoResult"] = "noresult";
    APIStates["Success"] = "success";
    return APIStates;
}({});
var $dfe01d0022147fd7$export$212790b4ffec121f = /*#__PURE__*/ function(ProductStates) {
    ProductStates["PreQueryLoading"] = "PreQueryLoading";
    ProductStates["PostQueryLoading"] = "PostQueryLoading";
    ProductStates["PreQuerySuccess"] = "PreQuerySuccess";
    ProductStates["PostQuerySuccess"] = "PostQuerySuccess";
    ProductStates["PreQueryError"] = "PreQueryError";
    ProductStates["PostQueryError"] = "PostQueryError";
    ProductStates["PreQueryNoResult"] = "PreQueryNoResult";
    ProductStates["PostQueryNoResult"] = "PostQueryNoResult";
    ProductStates["PostQueryTyping"] = "PostQueryTyping";
    ProductStates["Invalid"] = "Invalid";
    return ProductStates;
}({});
module.exports["APIStates"] = $dfe01d0022147fd7$export$c701d1d8ac310aa0;
module.exports["ProductStates"] = $dfe01d0022147fd7$export$212790b4ffec121f;

});

parcelRegister("kPY5t", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $2azjJ = parcelRequire("2azjJ");

const $67b453f3f4811515$export$853d1166284edec0 = ()=>window.innerWidth <= (0, $2azjJ.dialogPageTakeoverWidth);
module.exports["useIsMobileView"] = $67b453f3f4811515$export$853d1166284edec0;

});

parcelRegister("kUZlH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $bO2XA = parcelRequire("bO2XA");



parcelRequire("42omo");


var $c4sKh = parcelRequire("c4sKh");


var $hiGBZ = parcelRequire("hiGBZ");

const $806221755b41bdf0$export$51a5a703da15f0f7 = ({ title: title, totalResults: totalResults, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hiGBZ.SearchResultSectionContainer), {
        "data-vc": "search-result-section",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $hiGBZ.SearchResultSectionHeading), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hiGBZ.SearchResultsSectionTitle), {
                    children: [
                        title,
                        totalResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hiGBZ.SearchResultSectionTitleBadgeContainer), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                                testId: "search-result-count-badge",
                                children: totalResults
                            })
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
};



var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $hpDfc = parcelRequire("hpDfc");


var $2jE99 = parcelRequire("2jE99");







parcelRequire("42omo");


var $5tPRL = parcelRequire("5tPRL");





var $icqFF = parcelRequire("icqFF");

/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */ const $c5296a0f968b5575$var$onKeyDown = (e, target)=>{
    // Only navigate if Enter was pressed without any modifiers
    if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        // Find the deepest child element in the DOM
        let clickTarget = target;
        while(clickTarget.firstElementChild instanceof HTMLElement && clickTarget.firstElementChild?.click)clickTarget = clickTarget.firstElementChild;
        clickTarget.click();
    }
};
const $c5296a0f968b5575$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: $c5296a0f968b5575$var$onKeyDown,
        navigationTrackingId: searchResultId ?? null
    });
    // Ref for whether or not this search result was last highlighted
    const previousHighlight = (0, $42omo.useRef)(false);
    // Call the onHighlighted callback when this search result is highlighted
    (0, $42omo.useEffect)(()=>{
        if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted?.();
        previousHighlight.current = isKeyboardHighlighted;
    }, [
        isKeyboardHighlighted,
        previousHighlight,
        onHighlighted
    ]);
    return {
        isKeyboardHighlighted: isKeyboardHighlighted,
        ref: ref
    };
};


const $6dc18a1d5e5462b9$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $c5296a0f968b5575$export$9803d460130e453)({
        searchResultId: searchResultId,
        onHighlighted: onHighlighted
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        onClick: onSelect,
        onContextMenu: onContextMenu,
        role: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.ResultLink), {
            linkComponent: linkComponent,
            href: href,
            ...rest,
            children: children(isKeyboardHighlighted)
        })
    }));
};






var $4ldrV = parcelRequire("4ldrV");


var $2OcMi = parcelRequire("2OcMi");


var $ejGzS = parcelRequire("ejGzS");


var $O4eEI = parcelRequire("O4eEI");

const $37c05cfbff7bc1a9$var$DefaultSearchResultItemWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
/**
 * Intended to be used for search results that are not links
 */ const $37c05cfbff7bc1a9$var$SearchResultItemKeyboardHiglightWrapper = ({ searchResultId: searchResultId, children: children })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $c5296a0f968b5575$export$9803d460130e453)({
        searchResultId: searchResultId
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        children: children(isKeyboardHighlighted)
    });
};
const $37c05cfbff7bc1a9$export$56e008c8bd1ccf7c = ({ isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, resultRenderer: resultRenderer, resultWrapper: resultWrapper, screen: screen, searchResult: searchResult, appendQueryParams: appendQueryParams, useAnalyticsOverride: useAnalyticsOverride = ()=>({}) })=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { onHighlightCallback: defaultOnHighlightCallback, onSelectCallback: defaultOnSelectCallback, onContextMenuCallback: defaultOnContextMenuCallback } = (0, $O4eEI.useSearchResultAnalyticsCallbacks)({
        screen: screen,
        actionSubject: 'searchResult'
    });
    const { onHighlightCallback: overriddenOnHighlightCallback, onSelectCallback: overriddenOnSelectCallback, onContextMenuCallback: overriddenOnContextMenuCallback } = useAnalyticsOverride({
        screen: screen
    });
    const url = appendQueryParams === undefined ? (0, $2OcMi.addQuery)(searchResult.url, 'search_id', searchSessionId) : appendQueryParams(searchResult.url, searchSessionId, searchResult.type, searchResult.id);
    const SearchResultItemWrapper = resultWrapper || $37c05cfbff7bc1a9$var$DefaultSearchResultItemWrapper;
    const searchResultContentRenderer = (0, $42omo.useCallback)((isKeyboardHighlighted)=>resultRenderer ? resultRenderer({
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            productState: productState,
            screen: screen,
            searchResult: searchResult
        }) : (0, $ejGzS.defaultResultRenderer)({
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            screen: screen,
            searchResult: searchResult
        }), [
        isCollapsed,
        productState,
        resultRenderer,
        screen,
        searchResult
    ]);
    const id = `link-${searchResult.id}`;
    return /*#__PURE__*/ (0, $l998X.jsx)(SearchResultItemWrapper, {
        url: url,
        titleId: id,
        children: url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6dc18a1d5e5462b9$export$76cc11d043a1381), {
            href: url,
            linkComponent: searchResult.linkComponent ?? linkComponent,
            searchResultId: searchResult.id,
            onContextMenu: overriddenOnContextMenuCallback || defaultOnContextMenuCallback,
            onHighlighted: overriddenOnHighlightCallback || defaultOnHighlightCallback,
            onSelect: overriddenOnSelectCallback || defaultOnSelectCallback,
            "data-testid": id,
            id: id,
            children: (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)
        }) : /*#__PURE__*/ (0, $l998X.jsx)($37c05cfbff7bc1a9$var$SearchResultItemKeyboardHiglightWrapper, {
            searchResultId: searchResult.id,
            children: (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)
        })
    });
};





parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");




parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");


var $2azjJ = parcelRequire("2azjJ");


var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

const $9155aa83cf58fa2b$export$3545bd757920e2b3 = /*#__PURE__*/ (0, $cStGJ.default)((0, $eEA8O.default), {
    target: "e1052ovn0"
})("margin-left:", (0, $2azjJ.grid).half().px, ";color:", `var(--ds-link, ${(0, $6fnsQ.B400)})`, ";cursor:pointer!important;&:hover{text-decoration:underline!important;}");


const $a5b1325517543fd8$export$f39804bac419a7f4 = ({ children: children, linkComponent: linkComponent, ...rest })=>/* component must either be `undefined` or an component. A null or false will throw an error */ /*#__PURE__*/ (0, $l998X.jsx)((0, $9155aa83cf58fa2b$export$3545bd757920e2b3), {
        appearance: "link",
        ...rest,
        component: linkComponent || undefined,
        children: children
    });



var $bF0iL = parcelRequire("bF0iL");


var $2ZIpG = parcelRequire("2ZIpG");


var $6dP89 = parcelRequire("6dP89");


var $5dFS9 = parcelRequire("5dFS9");

const $ae4aed250b0b0b86$export$f8fe8ba0816633ed = ({ linkComponent: linkComponent, section: section, totalResults: totalResults = 0 })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { viewAllLinkGenerator: viewAllLinkGenerator, viewAllLinkRenderer: viewAllLinkRenderer } = section;
    if (!viewAllLinkGenerator) return null;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        onClick: ()=>{
            fireAnalyticsEvent((0, $5dFS9.onSearchResultViewAllLinkClicked)(section.id));
        },
        role: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5b1325517543fd8$export$f39804bac419a7f4), {
            linkComponent: linkComponent,
            href: viewAllLinkGenerator(query),
            testId: "search-result-section-link",
            children: viewAllLinkRenderer ? viewAllLinkRenderer({
                section: section,
                totalResults: totalResults
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $bF0iL.messages).common_show_all_results_link
            })
        })
    }));
};



var $20N1w = parcelRequire("20N1w");


var $amrMu = parcelRequire("amrMu");




parcelRequire("42omo");


var $5I0OA = parcelRequire("5I0OA");




// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da656065b0b219a8$var$QuickFindSearchResultWrapper = (0, $5I0OA.default).div`
	display: flex;
	flex-direction: column;
	gap: ${"var(--ds-space-025, 2px)"};
	padding: ${"var(--ds-space-100, 8px)"};
`;
const $da656065b0b219a8$export$7ef688c5abd67ccc = ({ children: children })=>{
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    return quickFind?.enabled ? /*#__PURE__*/ (0, $l998X.jsx)($da656065b0b219a8$var$QuickFindSearchResultWrapper, {
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};



var $fJRVo = parcelRequire("fJRVo");

const $3e96c9432766ab22$export$f6fdc80358dfd95 = 10;
const $3e96c9432766ab22$export$fd06a2c70d34842e = (searchResultSections, sectionIndex)=>searchResultSections.slice(0, sectionIndex).reduce((accumulator, currentElem)=>accumulator + Math.min(currentElem.searchResults.length, currentElem.resultLimit || $3e96c9432766ab22$export$f6fdc80358dfd95), 0);
const $3e96c9432766ab22$var$getTotalResultCount = (forceHideResultCount, section)=>{
    // resultCount is only shown when a size is specified. We changed this
    // from using searchResults.length as we want to indicate the number of
    // possible search results rather than just the ones shown.
    const resultCount = !forceHideResultCount && section.showResultCount && section.size && section.searchResults.length ? Math.max(section.size, section.searchResults.length) : undefined;
    // totalResults considers the count returned from a section's resultMapper
    // to ensure rendered results align with the displayed count, in case results shown
    // are limited by the resultMapper
    const totalResults = Boolean(resultCount && section.searchResults.length < (section.resultLimit || $3e96c9432766ab22$export$f6fdc80358dfd95) && resultCount >= section.searchResults.length) ? section.searchResults.length : resultCount;
    return totalResults;
};
const $3e96c9432766ab22$var$GenericSearchResultWithIntl = ({ children: children, forceHideResultCount: forceHideResultCount = false, generateSectionTitle: generateSectionTitle = ({ title: title })=>title, intl: intl, isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, renderSectionViewAll: renderSectionViewAll, searchItems: searchItems, screen: screen, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext, appendQueryParams: appendQueryParams })=>{
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    if (!searchItems || !(0, $2jE99.hasSearchResults)(searchItems)) {
        // This is mainly used to handle the loading state (e.g. a spinner or a skeleton)
        if (children) return /*#__PURE__*/ (0, $l998X.jsx)((0, $da656065b0b219a8$export$7ef688c5abd67ccc), {
            children: children
        });
        return null;
    }
    const ResultSection = quickFind?.enabled ? (0, $bO2XA.EnlargedSearchResultSection) : (0, $806221755b41bdf0$export$51a5a703da15f0f7);
    const QuickFindPersistRecentSearch = quickFind?.enabled ? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment : (0, $20N1w.PersistRecentSearch);
    const ItemSection = (props)=>{
        const { section: section, sectionIndex: sectionIndex } = props;
        const itemLimit = typeof section.resultLimit === 'number' ? section.resultLimit : $3e96c9432766ab22$export$f6fdc80358dfd95;
        const searchResults = section.searchResults?.slice(0, itemLimit) || [];
        const totalResults = $3e96c9432766ab22$var$getTotalResultCount(forceHideResultCount, section);
        const totalNumberOfItemsInPreviousSections = $3e96c9432766ab22$export$fd06a2c70d34842e(searchItems.sections, sectionIndex);
        if (searchResults.length === 0) return null;
        const recentSearchResultsLength = searchResults.filter((result)=>result.isRecentResult).length;
        return /*#__PURE__*/ (0, $l998X.jsxs)(ResultSection, {
            totalResults: totalResults,
            title: section.titleRenderer ? section.titleRenderer({
                isCollapsed: isCollapsed,
                productState: productState
            }) : generateSectionTitle(section, intl),
            children: [
                searchResults.map((result, index)=>{
                    const analyticContext = {
                        sectionIndex: sectionIndex,
                        sectionId: section.id,
                        containerId: result.containerId || null,
                        indexWithinSection: index,
                        searchResultRelativeIndex: index - recentSearchResultsLength >= 0 ? index - recentSearchResultsLength : null,
                        globalIndex: totalNumberOfItemsInPreviousSections + index,
                        isCached: result.isRecentResult || false,
                        activeProduct: activeProduct?.id ?? '',
                        metadata: {
                            contentId: result.id,
                            containerId: result.containerId || null,
                            contentType: result.type || null
                        }
                    };
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
                        analyticContext: analyticContext,
                        nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext || {},
                        children: /*#__PURE__*/ (0, $l998X.jsx)(QuickFindPersistRecentSearch, {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $37c05cfbff7bc1a9$export$56e008c8bd1ccf7c), {
                                isCollapsed: isCollapsed,
                                linkComponent: linkComponent,
                                productState: productState,
                                resultRenderer: section.resultRenderer,
                                resultWrapper: section.resultWrapper,
                                screen: screen,
                                searchResult: result,
                                appendQueryParams: appendQueryParams,
                                useAnalyticsOverride: section.useAnalyticsOverride
                            })
                        })
                    }, result.id);
                }),
                renderSectionViewAll && section.viewAllLinkGenerator && /*#__PURE__*/ (0, $l998X.jsx)((0, $ae4aed250b0b0b86$export$f8fe8ba0816633ed), {
                    linkComponent: linkComponent,
                    section: section,
                    totalResults: totalResults
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $da656065b0b219a8$export$7ef688c5abd67ccc), {
        children: [
            searchItems.sections.map((section, index)=>/*#__PURE__*/ (0, $l998X.jsx)(ItemSection, {
                    section: section,
                    sectionIndex: index
                }, section.id)),
            children
        ]
    });
};
const $3e96c9432766ab22$export$855c9ab7e6e3e97f = (0, $gmMgo.default)($3e96c9432766ab22$var$GenericSearchResultWithIntl);
module.exports["GenericSearchResult"] = $3e96c9432766ab22$export$855c9ab7e6e3e97f;

});

parcelRegister("2jE99", function(module, exports) {
const $278487f7dee8bb82$export$bcf020eea629e7ed = (searchItems)=>{
    const sectionsWithSearchResults = searchItems.sections.filter(({ searchResults: searchResults })=>searchResults.length > 0);
    return sectionsWithSearchResults.length > 0;
};
module.exports["hasSearchResults"] = $278487f7dee8bb82$export$bcf020eea629e7ed;

});

parcelRegister("kiEGX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6uGcC = parcelRequire("6uGcC");


var $iLCTn = parcelRequire("iLCTn");


var $8C5kA = parcelRequire("8C5kA");


var $iEwUU = parcelRequire("iEwUU");


var $h2sba = parcelRequire("h2sba");


var $2GmtI = parcelRequire("2GmtI");


var $kmpep = parcelRequire("kmpep");


var $fJRVo = parcelRequire("fJRVo");


var $amrMu = parcelRequire("amrMu");


var $91yhh = parcelRequire("91yhh");


const $1b8b9c22c9ab1c26$var$AkFeedbackCollector = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $1b8b9c22c9ab1c26$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $1b8b9c22c9ab1c26$var$HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $1b8b9c22c9ab1c26$var$ENTRYPOINT_ID = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const $1b8b9c22c9ab1c26$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
/**
 * Feedback collector for extensible tabs in Quick Search i.e. confluence tab in QS and QF
 */ const $1b8b9c22c9ab1c26$var$FeedbackCollector = ({ TriggerComponent: TriggerComponent = (0, $h2sba.FeedbackButton) })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { name: name, id: id } = user;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(false);
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, $91yhh.useExperiments)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct()?.title;
    const primaryProduct = getPrimaryProduct()?.title;
    const isHello = $1b8b9c22c9ab1c26$var$HELLO_TENANT_ID === cloudId;
    const isQuickFind = (0, $amrMu.useFeaturesContext)().quickFind?.enabled;
    const experience = isQuickFind ? 'quick-find' : 'quick-search';
    const feedbackContext = JSON.stringify({
        experimentLayers: backendExperiment?.experimentLayers,
        frontendExperiments: frontendExperiments,
        frontendVersion: (0, $2GmtI.BUILD_VERSION),
        product: activeProduct,
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        userId: id,
        source: 'product-search-dialog',
        isHello: isHello,
        experience: experience,
        release: (0, $iLCTn.getProductReleaseVersion)(primaryProduct)
    });
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(TriggerComponent, {
                onClick: (e)=>{
                    e.preventDefault();
                    setIsOpen(true);
                }
            }),
            isOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)($1b8b9c22c9ab1c26$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>setIsOpen(false),
                    onSubmit: ()=>setDisplayFlag(true),
                    atlassianAccountId: id,
                    name: name,
                    entrypointId: $1b8b9c22c9ab1c26$var$ENTRYPOINT_ID,
                    additionalFields: [
                        {
                            id: $1b8b9c22c9ab1c26$var$FEEDBACK_CONTEXT_CF,
                            value: feedbackContext
                        }
                    ]
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($1b8b9c22c9ab1c26$var$AkFeedbackFlag, {
                        locale: locale
                    })
                })
            })
        ]
    });
};
var $1b8b9c22c9ab1c26$export$2e2bcd8739ae039 = $1b8b9c22c9ab1c26$var$FeedbackCollector;
module.exports["default"] = $1b8b9c22c9ab1c26$export$2e2bcd8739ae039;

});

parcelRegister("h2sba", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $bF0iL = parcelRequire("bF0iL");


var $ccHMk = parcelRequire("ccHMk");

function $9740cc300cdd6cc9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9740cc300cdd6cc9$var$buttonStyles = {
    name: "1y6tyz0",
    styles: "margin:0 auto;width:fit-content"
};
const $9740cc300cdd6cc9$export$116fedbe5e2e2bd8 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $9740cc300cdd6cc9$var$buttonStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccHMk.default), {
        onClick: onClick,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $bF0iL.messages).common_give_feedback)));
};
module.exports["FeedbackButton"] = $9740cc300cdd6cc9$export$116fedbe5e2e2bd8;

});

parcelRegister("6yoZS", function(module, exports) {

let $4c594eef01830b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c594eef01830b0b$var$load("hhss7"),
    $4c594eef01830b0b$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});

parcelRegister("a7YLG", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $2azjJ = parcelRequire("2azjJ");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

parcelRequire("42omo");


var $cStGJ = parcelRequire("cStGJ");

const $3c24ade336ec6966$var$TitleContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginTop: 'space.100'
});
const $3c24ade336ec6966$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $3c24ade336ec6966$var$TitleContainerStyles,
        children: children
    });
};
const $3c24ade336ec6966$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1ttkipm1"
})({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $2azjJ.grid).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.primaryTextColour)
});
const $3c24ade336ec6966$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1ttkipm0"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $2azjJ.grid).twice().px
});


const $63d3900d9fbf3b90$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $3c24ade336ec6966$export$e6dfd72ab29f8598), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(Image, {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3c24ade336ec6966$export$f99233281efd08a0), {
                    children: title
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3c24ade336ec6966$export$7c6e2c02157bb7d2), {
                    children: content
                })
            ]
        })
    });
module.exports["EmptyState"] = $63d3900d9fbf3b90$export$fddf379e22a74b00;

});

parcelRegister("iCHOT", function(module, exports) {

let $d8edc4500d2d48c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d8edc4500d2d48c5$var$load("4Sse2").then(()=>parcelRequire('c473Z'));

});

parcelRegister("4Lm6U", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $42omo = parcelRequire("42omo");


var $a7YLG = parcelRequire("a7YLG");

var $kPBHE = parcelRequire("kPBHE");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $bF0iL = parcelRequire("bF0iL");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

const $369c822a7a7f1b34$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1hs8rk0"
})({
    color: `var(--ds-link, ${(0, $6fnsQ.B400)})`,
    cursor: 'pointer'
});



const $d95f96bde66e8ac9$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hd6fF")));
class $d95f96bde66e8ac9$export$930da00ff8e1539f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $bF0iL.messages).common_error_state_failed_search_heading),
            Image: $d95f96bde66e8ac9$var$Image,
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.getContent = ()=>{
            const { onRetry: onRetry } = this.props;
            const linkComponent = (props)=>// eslint-disable-next-line @atlassian/a11y/no-redundant-roles -- See https://go/a11y-no-redundant-roles for more details
                /*#__PURE__*/ (0, $l998X.jsx)((0, $369c822a7a7f1b34$export$353f5b6fc5456de1), {
                    ...props,
                    role: "button",
                    tabIndex: 0,
                    onClick: ()=>onRetry(),
                    onKeyDown: (event)=>event.key === 'Enter' ? onRetry() : undefined
                });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $bF0iL.messages).common_error_state_failed_search_body,
                values: {
                    emptyLink: (s)=>// eslint-disable-next-line @atlassian/a11y/anchor-is-valid
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kPBHE.Link), {
                            linkComponent: linkComponent,
                            href: '',
                            children: s
                        })
                }
            });
        };
    }
}
var $d95f96bde66e8ac9$export$2e2bcd8739ae039 = (0, $gmMgo.default)($d95f96bde66e8ac9$export$930da00ff8e1539f);


const $60673a10504c6d4a$export$66fb8d8f30619036 = ({ onRetry: onRetry = ()=>null })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d95f96bde66e8ac9$export$2e2bcd8739ae039), {
        onRetry: onRetry
    });
};
module.exports["SearchErrorScreen"] = $60673a10504c6d4a$export$66fb8d8f30619036;

});

parcelRegister("hd6fF", function(module, exports) {

let $c8788002a5921fb5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8788002a5921fb5$var$load("eQXoP").then(()=>parcelRequire('6Vk9P'));

});

parcelRegister("7OZuO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8910aa043bf2e2af$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lnXRc = parcelRequire("lnXRc");


var $5dFS9 = parcelRequire("5dFS9");








var $a7YLG = parcelRequire("a7YLG");

var $kPBHE = parcelRequire("kPBHE");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $3S0fp = parcelRequire("3S0fp");





var $bF0iL = parcelRequire("bF0iL");


var $eEA8O = parcelRequire("eEA8O");


var $cStGJ = parcelRequire("cStGJ");

function $118ff74bd36c6a4e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $118ff74bd36c6a4e$export$8c06dfd742f74a6f = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "eg9i8g80"
})({
    name: "1y04g5d",
    styles: "padding-top:var(--ds-space-400, 32px)"
});



const $5dc707e28a4ee781$export$3e431a229df88919 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("7lQUe")));
class $5dc707e28a4ee781$export$ef6006467f04ee41 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $bF0iL.messages).common_empty_state_heading),
            Image: $5dc707e28a4ee781$export$3e431a229df88919,
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.onAdvancedSearchClicked = (e)=>{
            const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
            advancedSearchSelected({
                trigger: (0, $3S0fp.getTrigger)(e),
                actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).NO_RESULTS,
                isLoading: false,
                newTab: (0, $3S0fp.isNewTab)(e)
            });
            onClick && onClick(advancedSearchUrl, e);
        };
        this.getContent = ()=>{
            const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
            if (!hasFilters) return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                role: "none",
                onClick: this.onAdvancedSearchClicked,
                children: isMultiSite || !advancedSearchUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body_no_advanced_search
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body,
                    values: {
                        a: (s)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kPBHE.Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl,
                                children: s
                            })
                    }
                })
            }));
            else return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        tagName: "div",
                        ...(0, $bF0iL.messages).filters_applied
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $118ff74bd36c6a4e$export$8c06dfd742f74a6f), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            onClick: clearFilters,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $bF0iL.messages).clear_filters
                            })
                        })
                    })
                ]
            });
        };
    }
}
var $5dc707e28a4ee781$export$2e2bcd8739ae039 = (0, $gmMgo.default)($5dc707e28a4ee781$export$ef6006467f04ee41);



























var $dDSTM = parcelRequire("dDSTM");






class $1e1084fdfd1fe42d$export$be28e1c115e337c7 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $dDSTM.messages).quick_find_post_query_no_results_header),
            Image: (0, $5dc707e28a4ee781$export$3e431a229df88919),
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.onAdvancedSearchClicked = (e)=>{
            const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
            advancedSearchSelected({
                trigger: (0, $3S0fp.getTrigger)(e),
                actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).NO_RESULTS,
                isLoading: false,
                newTab: (0, $3S0fp.isNewTab)(e)
            });
            onClick && onClick(advancedSearchUrl, e);
        };
        this.getContent = ()=>{
            const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
            if (!hasFilters) return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                role: "none",
                onClick: this.onAdvancedSearchClicked,
                children: isMultiSite || !advancedSearchUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body_no_advanced_search
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $dDSTM.messages).quick_find_post_query_no_results_body,
                    values: {
                        SearchContentLink: (s)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kPBHE.Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl,
                                children: s
                            })
                    }
                })
            }));
            else return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        tagName: "div",
                        ...(0, $bF0iL.messages).filters_applied
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $118ff74bd36c6a4e$export$8c06dfd742f74a6f), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            onClick: clearFilters,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $bF0iL.messages).clear_filters
                            })
                        })
                    })
                ]
            });
        };
    }
}
var $1e1084fdfd1fe42d$export$2e2bcd8739ae039 = (0, $gmMgo.default)($1e1084fdfd1fe42d$export$be28e1c115e337c7);



var $2ZIpG = parcelRequire("2ZIpG");


var $5TmpD = parcelRequire("5TmpD");


var $21MH9 = parcelRequire("21MH9");


var $eEbYb = parcelRequire("eEbYb");

const $8910aa043bf2e2af$var$NoResultsWithHooks = ({ urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', advancedSearchSelected: advancedSearchSelected, fromQuickFindPostQueryNoResults: fromQuickFindPostQueryNoResults })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $5TmpD.useAutocorrectionEnabled)();
    const advancedSearchUrl = urlGeneratorForNoResultsScreen(query); // TODO: needs filters here
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            autocorrectionEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                container: (0, $eEbYb.NoResultsAutocorrectWrapper)
            }),
            fromQuickFindPostQueryNoResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1e1084fdfd1fe42d$export$2e2bcd8739ae039), {
                advancedSearchUrl: advancedSearchUrl,
                advancedSearchSelected: advancedSearchSelected
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $5dc707e28a4ee781$export$2e2bcd8739ae039), {
                advancedSearchUrl: advancedSearchUrl,
                advancedSearchSelected: advancedSearchSelected
            })
        ]
    });
};
var $8910aa043bf2e2af$export$2e2bcd8739ae039 = (0, $lnXRc.withAnalytics)({
    advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected)
})($8910aa043bf2e2af$var$NoResultsWithHooks);

});

parcelRegister("7lQUe", function(module, exports) {

let $55a3889a9b51f124$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55a3889a9b51f124$var$load("9RypW").then(()=>parcelRequire('hd6X6'));

});

parcelRegister("beGYg", function(module, exports) {

let $82e255ab833e2bed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82e255ab833e2bed$var$load("6kNSo").then(()=>parcelRequire('kOUyO'));

});

parcelRegister("74Udv", function(module, exports) {

var $bloXB = parcelRequire("bloXB");


var $3q90y = parcelRequire("3q90y");


var $6a9Hv = parcelRequire("6a9Hv");

const $fa84d6e3ef79d059$export$c942155d15f72814 = (searchItems, query, numberOfResultItems = 3)=>{
    if (!searchItems.sections[0]) return searchItems;
    const filteredSearchResults = searchItems.sections[0].searchResults.filter((item)=>{
        return item.title.toLowerCase().includes(query.toLowerCase());
    }).slice(0, numberOfResultItems);
    return {
        size: filteredSearchResults.length,
        sections: [
            {
                ...searchItems.sections[0],
                searchResults: filteredSearchResults
            }
        ]
    };
};
const $fa84d6e3ef79d059$export$f48d35d3732436aa = (searchItems, query, numberOfResultItems = 3)=>{
    if (query === '') return searchItems;
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredSearchSections = searchItems.sections.map((section)=>{
        return {
            ...section,
            searchResults: section.searchResults.map((item)=>{
                // 1st pass
                const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
                    if (!acc) return acc;
                    return item.title.toLowerCase().includes(word.toLowerCase());
                }, true);
                if (doAllWordsMatch) {
                    // 2nd and 3rd Pass
                    const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $bloXB.highlightMatchedText)(item.title, wordsInQuery);
                    itemScoreMap[item.id] = score;
                    return {
                        ...item,
                        highlightedTitle: section.id !== (0, $3q90y.RECENT_SEARCHES_SECTION_ID) ? highlightedTitle : negatedHighlightedTitle
                    };
                }
                return null;
            }).filter((item)=>item).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.id] - itemScoreMap[item.id] : 0).slice(0, numberOfResultItems)
        };
    });
    const size = filteredSearchSections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0);
    return {
        size: size,
        sections: filteredSearchSections
    };
};
const $fa84d6e3ef79d059$export$630e09546900f38e = (postQueryItems, query)=>{
    const wordsInQuery = query.split(' ');
    const highlightedSearchSections = postQueryItems.sections.map((section)=>{
        return {
            ...section,
            searchResults: section.searchResults.map((item)=>{
                const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(item.title, wordsInQuery);
                return {
                    ...item,
                    highlightedTitle: highlightedTitle
                };
            })
        };
    });
    return {
        size: postQueryItems.size,
        sections: highlightedSearchSections
    };
};
const $fa84d6e3ef79d059$export$c28e3f530240553c = (intermediateSearchItems, postQuerySearchItems)=>{
    if (!intermediateSearchItems.sections[0] || intermediateSearchItems.sections[0]?.searchResults.length === 0) return postQuerySearchItems;
    if (!postQuerySearchItems.sections[0] || postQuerySearchItems.sections[0]?.searchResults.length === 0) return intermediateSearchItems;
    const fullMergedResultsList = [
        ...intermediateSearchItems.sections[0].searchResults.map((result)=>({
                ...result,
                isRecentResult: true
            })),
        ...postQuerySearchItems.sections[0].searchResults
    ];
    const deduplicatedList = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(fullMergedResultsList, (item)=>item.id);
    const sections = [
        {
            ...postQuerySearchItems.sections[0],
            searchResults: deduplicatedList
        }
    ];
    return {
        size: sections.reduce((accumulator, currentElem)=>accumulator + currentElem.searchResults.length, 0),
        sections: sections
    };
};
module.exports["filterFirstSectionItems"] = $fa84d6e3ef79d059$export$c942155d15f72814;
module.exports["filterAllSectionItems"] = $fa84d6e3ef79d059$export$f48d35d3732436aa;
module.exports["highlightPostQueryResultTitles"] = $fa84d6e3ef79d059$export$630e09546900f38e;
module.exports["mergeFirstSectionSearchItems"] = $fa84d6e3ef79d059$export$c28e3f530240553c;

});

parcelRegister("1ICWL", function(module, exports) {

let $14081c8e007124b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14081c8e007124b3$var$load("fSobj"),
    $14081c8e007124b3$var$load("74u2y"),
    $14081c8e007124b3$var$load("6wr18"),
    $14081c8e007124b3$var$load("7EorR"),
    $14081c8e007124b3$var$load("ffEVr"),
    $14081c8e007124b3$var$load("jjAxo")
]).then(()=>parcelRequire('7HssB'));

});

parcelRegister("hEG8F", function(module, exports) {

let $cda6dbfad04f6e8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cda6dbfad04f6e8a$var$load("hhss7"),
    $cda6dbfad04f6e8a$var$load("5kEKD")
]).then(()=>parcelRequire('eFfFJ'));

});

parcelRegister("169DF", function(module, exports) {
var $d4be48b9fe9cdb51$export$a386c4ddeb43c20a = /*#__PURE__*/ function(FilterOptionSource) {
    /**
	 * This means the result came from collab graph
	 */ FilterOptionSource["COLLABORATION_GRAPH"] = "COLLABORATION_GRAPH";
    /**
	 * This means the result came from smart user picker
	 */ FilterOptionSource["SMART_USER_PICKER"] = "SMART_USER_PICKER";
    /**
	 * This means the result came from a recents (bootstrap) query
	 */ FilterOptionSource["RECENT"] = "RECENT";
    /**
	 * This means the result came from an explicit search
	 */ FilterOptionSource["SEARCH"] = "SEARCH";
    /**
	 * This means the result is derived from the current user
	 */ FilterOptionSource["CURRENT_USER"] = "CURRENT_USER";
    /**
	 * This means the result came from an external source passed into the component
	 */ FilterOptionSource["EXTERNAL"] = "EXTERNAL";
    /**
	 * This means the result is static without any user-generation
	 */ FilterOptionSource["STATIC"] = "STATIC";
    return FilterOptionSource;
}({});
module.exports["FilterOptionSource"] = $d4be48b9fe9cdb51$export$a386c4ddeb43c20a;

});

parcelRegister("cgH2x", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $gF7Az = parcelRequire("gF7Az");


var $80L9g = parcelRequire("80L9g");


var $169DF = parcelRequire("169DF");


var $kzbg7 = parcelRequire("kzbg7");


var $88j1D = parcelRequire("88j1D");


var $bF0iL = parcelRequire("bF0iL");

const $e93e47a7b7b4ad5d$export$95f4aabc01d7575d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    filterDefinitions: {},
    defineFilters: ()=>{}
});
const $e93e47a7b7b4ad5d$export$ceb34aeb37186333 = ({ children: children })=>{
    const filterDefinitions = (0, $42omo.useRef)({}).current;
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { stickySearchEnabled: stickySearchEnabled, resetExtensibleFiltersRef: resetExtensibleFiltersRef } = (0, $80L9g.useSessionUserInput)();
    const previousExpandState = (0, $42omo.useRef)(isExpanded);
    const defineFilters = (productId, filters)=>{
        filterDefinitions[productId] = filters;
    };
    const resetFilters = ()=>{
        Object.keys(filterDefinitions).forEach((productId)=>{
            filterDefinitions[productId].forEach((filter)=>{
                filter.store.reset();
            });
        });
    };
    (0, $42omo.useEffect)(()=>{
        if (previousExpandState.current && !isExpanded && !stickySearchEnabled) Object.keys(filterDefinitions).forEach((productId)=>{
            filterDefinitions[productId].forEach((filter)=>{
                filter.store.reset();
            });
        });
        previousExpandState.current = isExpanded;
    }, [
        isExpanded,
        stickySearchEnabled
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $42omo.useEffect)(()=>{
        if (resetExtensibleFiltersRef) resetExtensibleFiltersRef.current = resetFilters;
    }); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $l998X.jsx)($e93e47a7b7b4ad5d$export$95f4aabc01d7575d.Provider, {
        value: {
            filterDefinitions: filterDefinitions,
            defineFilters: defineFilters
        },
        children: children
    });
};
const $e93e47a7b7b4ad5d$export$bc4556a4dba20090 = ()=>(0, $42omo.useContext)($e93e47a7b7b4ad5d$export$95f4aabc01d7575d);
const $e93e47a7b7b4ad5d$export$aa277293bef5fdbf = (workspaces, productId)=>{
    const isMultiWorkspace = workspaces && workspaces.length > 1;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const siteFilterStore = (0, $kzbg7.useFilterStore)(workspaces?.map((workspace, index)=>({
            label: workspace.name,
            id: workspace.id,
            isChecked: false,
            isVisible: index < 3,
            filterSource: (0, $169DF.FilterOptionSource).EXTERNAL,
            avatarUrl: ''
        })), productId, (0, $88j1D.SITE_FILTER_TYPE_NAME));
    if (isMultiWorkspace) return [
        {
            '@type': (0, $88j1D.SITE_FILTER_TYPE_NAME),
            fieldName: 'values',
            store: siteFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $bF0iL.messages).site_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).site_filters_find_more)
        }
    ];
    else return [];
};
module.exports["FilterContextHOC"] = $e93e47a7b7b4ad5d$export$ceb34aeb37186333;
module.exports["useGenericFilters"] = $e93e47a7b7b4ad5d$export$bc4556a4dba20090;
module.exports["useSiteFilterDefinition"] = $e93e47a7b7b4ad5d$export$aa277293bef5fdbf;

});

parcelRegister("hUj82", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");




parcelRequire("42omo");


var $lggDm = parcelRequire("lggDm");

const $2226f60f4cec6118$export$c09bfbbe14287de2 = ({ label: label, icon: icon, ...rest })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $lggDm.LabelWrapper), {
        ...rest,
        children: [
            icon && /*#__PURE__*/ (0, $l998X.jsx)((0, $lggDm.IconWrapper), {
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lggDm.FilterColLabelText), {
                children: label
            })
        ]
    });
};



var $esRft = parcelRequire("esRft");

const $bf37330ffae29f1b$export$150fbd78f757731d = ({ label: label, iconProps: iconProps })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2226f60f4cec6118$export$c09bfbbe14287de2), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            name: label,
            size: 'small',
            ...iconProps
        }),
        label: label
    });
};
module.exports["FilterOptionItem"] = $bf37330ffae29f1b$export$150fbd78f757731d;

});

parcelRegister("lggDm", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");


var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

const $b7a96cd3a77f60a3$export$397f5285b920487e = (0, $2azjJ.grid).multiple(22);
const $b7a96cd3a77f60a3$export$f51daa55764f8a9 = $b7a96cd3a77f60a3$export$397f5285b920487e.half();
const $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE = 2;
// The +4px is to ensure consistency with the Atlaskit avatar which has a 2px padding around the 24px icon
const $b7a96cd3a77f60a3$var$ICON_WIDTH = (0, $2azjJ.grid).multiple(3).unitless + $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
const $b7a96cd3a77f60a3$var$ICON_HEIGHT = (0, $2azjJ.grid).multiple(3).unitless + $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
const $b7a96cd3a77f60a3$export$be58b4326e23250f = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e6939t15"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$b7a96cd3a77f60a3$var$ICON_HEIGHT}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$b7a96cd3a77f60a3$var$ICON_WIDTH}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).unitless - $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px 0 ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $2azjJ.grid).half().unitless - $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px`
});
const $b7a96cd3a77f60a3$export$147422f7450ccfac = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e6939t14"
})({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // Offset the label's 4px padding-left
    marginLeft: "var(--ds-space-negative-050, -4px)",
    // The -2px is to offset the 28px container (see IconWrapper)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $2azjJ.grid).unitless - 2} 0`
});
const $b7a96cd3a77f60a3$export$39d33abf45c3996 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e6939t13"
})((0, $2azjJ.nowrapEllipsis), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $b7a96cd3a77f60a3$export$397f5285b920487e.px,
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});
const $b7a96cd3a77f60a3$export$dd6e1c6307d95848 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e6939t12"
})((0, $2azjJ.nowrapEllipsis), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $2azjJ.grid).half().px,
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $b7a96cd3a77f60a3$export$f51daa55764f8a9.px
});
const $b7a96cd3a77f60a3$export$eef12940a6696c78 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e6939t11"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $2azjJ.grid).unitless - 2}px 0`,
    display: 'flex',
    flexGrow: 1
});
const $b7a96cd3a77f60a3$export$c5e39530e713771e = /*#__PURE__*/ (0, $cStGJ.default)("button", {
    target: "e6939t10"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $2azjJ.grid).multiple(3).unitless + 2}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.selected ? `var(--ds-text-brand, ${0, $6fnsQ.B400})` : `var(--ds-text-subtlest, ${0, $6fnsQ.N500})`,
        outline: 'none',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${(0, $2azjJ.grid).half().px} ${(0, $2azjJ.grid).px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $6fnsQ.B50})` : `var(--ds-background-accent-gray-subtlest, ${0, $6fnsQ.N20})`,
        border: 'none',
        borderRadius: "var(--ds-radius-full, 9999px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: `${(0, $2azjJ.grid).multiple(2).unitless + 2}px`,
        cursor: 'pointer',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus-visible': {
            outline: `${"var(--ds-border-width-focused, 2px)"} solid ${`var(--ds-border-focused, ${0, $6fnsQ.B100})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        }
    }));
module.exports["IconWrapper"] = $b7a96cd3a77f60a3$export$be58b4326e23250f;
module.exports["LabelWrapper"] = $b7a96cd3a77f60a3$export$147422f7450ccfac;
module.exports["FilterColLabelText"] = $b7a96cd3a77f60a3$export$39d33abf45c3996;
module.exports["FilterRowLabelText"] = $b7a96cd3a77f60a3$export$dd6e1c6307d95848;
module.exports["CheckboxWrapper"] = $b7a96cd3a77f60a3$export$eef12940a6696c78;
module.exports["PillButton"] = $b7a96cd3a77f60a3$export$c5e39530e713771e;

});

parcelRegister("cX5Oz", function(module, exports) {

let $96df8161149e8f23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $96df8161149e8f23$var$load("9S9Mz"),
    $96df8161149e8f23$var$load("5QGog")
]).then(()=>parcelRequire('eBmVD'));

});

parcelRegister("btL3z", function(module, exports) {

let $85b6e79a4d741e05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $85b6e79a4d741e05$var$load("awWN9"),
    $85b6e79a4d741e05$var$load("8XFC9")
]).then(()=>parcelRequire('gnNGp'));

});

parcelRegister("bKrl4", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4mZlP = parcelRequire("4mZlP");


var $crAJ1 = parcelRequire("crAJ1");

const $a98761a6028dbe88$export$e3c8b9bd86c3cfd6 = ({ productState: productState, ...rest })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $crAJ1.SearchFooter), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.AdvancedSearchFooter), {
            ...rest
        })
    });
};
module.exports["GetDefaultFooter"] = $a98761a6028dbe88$export$e3c8b9bd86c3cfd6;

});

parcelRegister("3cM77", function(module, exports) {
$parcel$export(module.exports, "default", () => $542edd51ae7cea6d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $a7YLG = parcelRequire("a7YLG");


var $gmMgo = parcelRequire("gmMgo");


var $bF0iL = parcelRequire("bF0iL");


const $542edd51ae7cea6d$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hjSWM")));
const $542edd51ae7cea6d$var$NoPreQueryResults = ({ intl: intl, message: message })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a7YLG.EmptyState), {
        title: intl.formatMessage(message || (0, $bF0iL.messages).common_empty_state_prequery_heading),
        Image: $542edd51ae7cea6d$var$Image
    });
var $542edd51ae7cea6d$export$2e2bcd8739ae039 = (0, $gmMgo.default)($542edd51ae7cea6d$var$NoPreQueryResults);

});

parcelRegister("hjSWM", function(module, exports) {

let $c9bed56257737592$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9bed56257737592$var$load("3BloW").then(()=>parcelRequire('4SDWJ'));

});

parcelRegister("1E3Hv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6c104c09525816b7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $da82b26d75032a0f$export$2e2bcd8739ae039 = {
    'archive.label': 'Archive',
    'audio.label': 'Audio',
    'blogpost.label': 'Blogpost',
    'code.label': 'Code',
    'cross_product_search_dialog.atlas.tab_label': 'Atlas',
    'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
    'cross_product_search_dialog.confluence.tab_label': 'Confluence',
    'cross_product_search_dialog.google_drive.tab_label': 'Drive',
    'cross_product_search_dialog.google_drive.unauthenticated_prompt': 'You can work on all of your Google sheets, docs, slides and more, without ever leaving Atlassian. Only you have this access.',
    'cross_product_search_dialog.jira.tab_label': 'Jira',
    'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
    'cross_product_search_dialog.recently_viewed_title': 'Recently Viewed {sectionTitle}',
    'cross_product_search_dialog.townsquare_globex_tab_label': 'Home',
    'cross_product_search_dialog.townsquare_recent_goals': 'Recent Goals',
    'cross_product_search_dialog.townsquare_recent_help_links': 'Recent Help Links',
    'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': 'Recent Learnings, Risks and Decisions',
    'cross_product_search_dialog.townsquare_recent_projects': 'Recent Projects',
    'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
    'cross_product_search_dialog.trello.tab_label': 'Trello',
    'cross_product_search_dialog.view_all_results_link': 'View all {sectionTitle}',
    'customer-org.label': 'Customer Org',
    'dashboard.label': 'Dashboard',
    'database.label': 'Database',
    'deal.label': 'Deal',
    'design.label': 'Design',
    'document-search-result.google-docs-label': 'Docs',
    'document-search-result.google-sheets-label': 'Sheets',
    'document-search-result.google-slides-label': 'Slides',
    'document-search-result.ms-excel-label': 'Excel',
    'document-search-result.ms-powerpoint-label': 'PowerPoint',
    'document-search-result.ms-word-label': 'Word',
    'document.label': 'Document',
    'extensible_search_dialog.advanced_search': 'Advanced search',
    'extensible_search_dialog.advanced_search_all_apps': 'Search all apps',
    'extensible_search_dialog.connect': 'Connect',
    'extensible_search_dialog.connect_to': 'Connect to',
    'extensible_search_dialog.more': '+ more',
    'file.label': 'File',
    'global_search.jira.advanced_search_boards': 'Boards',
    'global_search.jira.advanced_search_filters': 'Filters',
    'global_search.jira.advanced_search_issues': 'Issues',
    'global_search.jira.advanced_search_issues-issue-term-refresh': 'Work items',
    'global_search.jira.advanced_search_label': 'Go to all:',
    'global_search.jira.advanced_search_people': 'People',
    'global_search.jira.advanced_search_plans': 'Plans',
    'global_search.jira.advanced_search_projects': 'Projects',
    'global_search.jira.search_placeholder': 'Search Jira',
    'global_search.jira.search_placeholder_experiment_jsw_enabled': 'Search for issues, boards, projects, and filters',
    'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh': 'Search for work items, boards, projects, and filters',
    'image.label': 'Image',
    'invoice.label': 'Invoice',
    'issue.label': 'Work item',
    'other.label': 'Other',
    'page.label': 'Page',
    'pdf.label': 'PDF',
    'presentation.label': 'Presentation',
    'product_s earch_dialog.confluence.assignee_filters_find_more': 'Find an assignee',
    'product_search_dialog.atlas.search_input_expanded_placeholder': 'Search Atlas',
    'product_search_dialog.autocorrection.label': 'Did you mean',
    'product_search_dialog.bitbucket.bitbucket_advanced_search': 'Search for code in {source}',
    'product_search_dialog.bitbucket.bitbucket_recent_repositories': 'Recently updated repositories',
    'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'Repositories',
    'product_search_dialog.bitbucket.expanded.input-placeholder': 'Search Bitbucket',
    'product_search_dialog.bitbucket.repository_heading': 'Repositories',
    'product_search_dialog.common.site_filters': 'Filter by site',
    'product_search_dialog.compass.component_type.application': 'Application',
    'product_search_dialog.compass.component_type.capability': 'Capability',
    'product_search_dialog.compass.component_type.cloud_resource': 'Cloud resource',
    'product_search_dialog.compass.component_type.data_pipeline': 'Data pipeline',
    'product_search_dialog.compass.component_type.library': 'Library',
    'product_search_dialog.compass.component_type.machine_learning_model': 'Machine learning model',
    'product_search_dialog.compass.component_type.other': 'Other',
    'product_search_dialog.compass.component_type.service': 'Service',
    'product_search_dialog.compass.component_type.ui_element': 'UI element',
    'product_search_dialog.compass.component_type.website': 'Website',
    'product_search_dialog.compass.components_section_heading': 'Components',
    'product_search_dialog.compass.endpoints_section_heading': 'Endpoints',
    'product_search_dialog.compass.expanded.input-placeholder': 'Search Compass',
    'product_search_dialog.compass.people_section_heading': 'People',
    'product_search_dialog.compass.recently_viewed_components': 'Recently viewed components',
    'product_search_dialog.compass.recently_viewed_endpoints': 'Recently viewed endpoints',
    'product_search_dialog.compass.recently_viewed_teams': 'Recently viewed teams',
    'product_search_dialog.compass.tab_label': 'Compass',
    'product_search_dialog.compass.teams_section_heading': 'Teams',
    'product_search_dialog.compass.upsell_modal_cta_text': 'Get Compass free',
    'product_search_dialog.compass.upsell_modal_description': "Catalog your software architecture in one place \u2013 so the teams working on it can reduce context switching, find what they need faster, and be more productive. How\u2019s that for a developer experience?",
    'product_search_dialog.compass.upsell_modal_description.bitbucket': 'See owners, dependencies, and help resources for your repositories by linking them to a central software catalog.',
    'product_search_dialog.compass.upsell_modal_heading': 'Control your software sprawl, so developers can control their time',
    'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'Bring more context to your code',
    'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Learn more about Compass',
    'product_search_dialog.compass.upsell_modal_learn_more_link': 'Learn more',
    'product_search_dialog.compass.upsell_tab_title_lozenge': 'New',
    'product_search_dialog.compass.view_all_components_label': 'View all components',
    'product_search_dialog.compass.view_all_results_label': 'View all results',
    'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Confluence advanced search',
    'product_search_dialog.confluence.clear_filters': 'Clear filters',
    'product_search_dialog.confluence.content_section_heading': 'Content',
    'product_search_dialog.confluence.contributor_filters': 'Filter by contributor',
    'product_search_dialog.confluence.contributor_filters_find_more': 'Find a contributor',
    'product_search_dialog.confluence.date_filter_title': 'Last updated',
    'product_search_dialog.confluence.date_filter_today': 'Today',
    'product_search_dialog.confluence.date_filter_yesterday': 'Yesterday',
    'product_search_dialog.confluence.date_filters_any': 'Any time',
    'product_search_dialog.confluence.date_filters_month': 'Past 30 days',
    'product_search_dialog.confluence.date_filters_week': 'Past 7 days',
    'product_search_dialog.confluence.date_filters_year': 'Past year',
    'product_search_dialog.confluence.empty_state_body_no_advanced_search': 'Try different keywords, fewer of them, or ones that are more general.',
    'product_search_dialog.confluence.empty_state_body_prequery_filters': "We can\u2019t find anything created or updated in the last 90 days with your selected filters.",
    'product_search_dialog.confluence.empty_state_body_title': "We couldn't find any matches for your search.",
    'product_search_dialog.confluence.filters_applied': 'Looks like you have some filters applied',
    'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'Pages, blogs and attachments',
    'product_search_dialog.confluence.people_section_heading': 'People',
    'product_search_dialog.confluence.search_input_expanded_placeholder': 'Search Confluence',
    'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Search or ask questions within your Confluence',
    'product_search_dialog.confluence.space_filters': 'Filter by space',
    'product_search_dialog.confluence.space_filters_find_more': 'Find a space',
    'product_search_dialog.confluence.spaces_section_heading': 'Spaces',
    'product_search_dialog.confluence.typing_state_header_text': 'Search for content in Confluence',
    'product_search_dialog.cross_product.empty.no_results_body': '<a>Search all content across your organization</a> or try a different term.',
    'product_search_dialog.cross_product.expanded.input-placeholder': 'Search All',
    'product_search_dialog.cross_product.recents.section_heading': 'Recently viewed',
    'product_search_dialog.cross_product.results.section_heading': 'Search results',
    'product_search_dialog.cross_product.tab_label': 'All',
    'product_search_dialog.empty.no_results_body': 'Try again with a different term, or refine your results with <a>Advanced Search</a>',
    'product_search_dialog.empty.no_results_body_with_no_advanced_search': 'Try again with a different term.',
    'product_search_dialog.empty.no_results_heading': "We couldn't find anything matching your search.",
    'product_search_dialog.empty_prequery.error_heading': 'Something went wrong with showing initial results',
    'product_search_dialog.empty_prequery.no_results_heading': 'Search for what you need',
    'product_search_dialog.error.failed_loading_search_body': 'It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>',
    'product_search_dialog.error.failed_loading_search_heading': "We're having trouble loading your recently viewed content.",
    'product_search_dialog.give_feedback': 'Give feedback',
    'product_search_dialog.google_drive.files_heading': 'Files',
    'product_search_dialog.inline_onboarding_action': 'Ok',
    'product_search_dialog.inline_onboarding_body': 'Use the Jira and Confluence tabs to search and see recent items in either location.',
    'product_search_dialog.inline_onboarding_title': 'Search across Jira and Confluence',
    'product_search_dialog.jira.assignee_filters': 'Filter by assignee',
    'product_search_dialog.jira.boards_icon_accessibility_text': 'Board icon',
    'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Boards, Projects, Filters and Plans',
    'product_search_dialog.jira.boards_projects_filters_section_heading': 'Boards, Projects and Filters',
    'product_search_dialog.jira.date_filter_30': '30d',
    'product_search_dialog.jira.date_filter_60': '60d',
    'product_search_dialog.jira.date_filter_90': '90d',
    'product_search_dialog.jira.date_filter_any': 'Any time',
    'product_search_dialog.jira.date_filter_past_30_days': 'Past 30 days',
    'product_search_dialog.jira.date_filter_past_7_days': 'Past 7 days',
    'product_search_dialog.jira.date_filter_past_year': 'Past year',
    'product_search_dialog.jira.date_filter_today': 'Today',
    'product_search_dialog.jira.date_filter_yesterday': 'Yesterday',
    'product_search_dialog.jira.date_filters': 'Last updated',
    'product_search_dialog.jira.empty_prequery.no_results_heading': 'Start searching to find your work',
    'product_search_dialog.jira.issue_filter_done': 'Done',
    'product_search_dialog.jira.issue_filter_open': 'Open',
    'product_search_dialog.jira.issue_filters': 'Filter by status',
    'product_search_dialog.jira.issue_labels_filters': 'Filter by label',
    'product_search_dialog.jira.issue_labels_filters_options_group_label': 'All labels',
    'product_search_dialog.jira.issue_labels_filters_placeholder': 'Select label',
    'product_search_dialog.jira.issues_section_heading': 'Issues',
    'product_search_dialog.jira.issues_section_heading-issue-term-refresh': 'Work items',
    'product_search_dialog.jira.jira_view_all_issues_new': 'View all issues',
    'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh': 'View all work items',
    'product_search_dialog.jira.project_filters': 'Filter by project',
    'product_search_dialog.jira.project_filters_find_more': 'Find a project',
    'product_search_dialog.jira.projects_filters_section_heading': 'Projects and Filters',
    'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading': 'Recent Boards, Projects, Filters and Plans',
    'product_search_dialog.jira.recent_boards_projects_filters_section_heading': 'Recent Boards, Projects and Filters',
    'product_search_dialog.jira.recent_projects_filters_section_heading': 'Recent Projects and Filters',
    'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Recently viewed issues',
    'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh': 'Recently viewed work items',
    'product_search_dialog.jira.report_by_filters': 'Filter by reporter',
    'product_search_dialog.jira.reported_by_me_filter': 'Reported by me',
    'product_search_dialog.jira.site_filters_find_more': 'Find a site',
    'product_search_dialog.loading_filters': 'Loading',
    'product_search_dialog.more_filters': 'View all filters',
    'product_search_dialog.multi_site_advanced_search_label': 'Search on:',
    'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} more',
    'product_search_dialog.no_options_filters': 'No options',
    'product_search_dialog.opsgenie.advanced_search': 'Advanced alert search',
    'product_search_dialog.opsgenie.alert_heading': 'Alerts',
    'product_search_dialog.opsgenie.expanded.input-placeholder': 'Search Opsgenie',
    'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Recent Alerts',
    'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Ask Atlassian Intelligence',
    'product_search_dialog.quick_find_confluence_space': 'Confluence Space',
    'product_search_dialog.quick_find_footer_full_page_search_products_link': 'Search across products',
    'product_search_dialog.quick_find_footer_full_page_search_products_link-appify': 'Search across apps',
    'product_search_dialog.quick_find_footer_help_text': 'Help us improve search',
    'product_search_dialog.quick_find_no_content_body_rovo': "Search or ask Rovo what you're looking for in your Atlassian and integrated apps",
    'product_search_dialog.quick_find_no_content_header': 'Seek and you shall find',
    'product_search_dialog.quick_find_post_query_no_results_body': '<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term.',
    'product_search_dialog.quick_find_post_query_no_results_header': "We couldn't find any results with that title",
    'product_search_dialog.quick_find_recent_draft_label': 'DRAFT',
    'product_search_dialog.quick_find_recent_search': 'Recent search',
    'product_search_dialog.quick_find_recent_search_text_dialog': 'From your recent searches',
    'product_search_dialog.quick_find_recent_spaces_additional_meta': 'You recently visited',
    'product_search_dialog.quick_find_recently_viewed': 'Recently Viewed',
    'product_search_dialog.quick_find_result_item_team': 'Team',
    'product_search_dialog.quick_find_results_section': 'Search Results',
    'product_search_dialog.quick_find_rovo_tip': "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer.",
    'product_search_dialog.quick_find_search_input_rovo_placeholder': 'Search or ask Rovo',
    'product_search_dialog.quick_find_search_results': 'Search Results',
    'product_search_dialog.quick_find_show_filtered_confluence_results': 'Filter by Confluence spaces, contributors and more',
    'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon': 'Filter by {confluenceIcon} Confluence spaces, contributors and more',
    'product_search_dialog.quick_find_show_organization_results': 'Search your organization',
    'product_search_dialog.recent_spaces_section_heading': 'Recent spaces',
    'product_search_dialog.recently_viewed_heading': 'Advanced search',
    'product_search_dialog.recently_viewed_section_heading': 'Recently viewed',
    'product_search_dialog.recently_worked_with_section_heading': 'Recently worked with',
    'product_search_dialog.results.remove_button_label': 'Remove this.',
    'product_search_dialog.search_input_aria_label': 'Search, press enter to navigate to advanced search with your text query',
    'product_search_dialog.search_input_collapsed_placeholder': 'Search',
    'product_search_dialog.search_input_enlarged_aria_label': 'Press enter to navigate to advanced search',
    'product_search_dialog.search_people_link': 'Search people',
    'product_search_dialog.show_all_results_link': 'View all results',
    'product_search_dialog.show_more_results_link': 'Show more',
    'product_search_dialog.townsquare.search_input_expanded_placeholder': 'Search Home',
    'product_search_dialog.townsquare_goals_heading': 'Goals',
    'product_search_dialog.townsquare_goals_view_all': 'Search all goals',
    'product_search_dialog.townsquare_help_links_heading': 'Help Links',
    'product_search_dialog.townsquare_learnings_risks_decisions_heading': 'Learnings, Risks and Decisions',
    'product_search_dialog.townsquare_people_heading': 'People',
    'product_search_dialog.townsquare_people_view_all': 'Search all people',
    'product_search_dialog.townsquare_projects_heading': 'Projects',
    'product_search_dialog.townsquare_projects_view_all': 'Search all projects',
    'product_search_dialog.townsquare_recent_people': 'Recent People',
    'product_search_dialog.townsquare_recent_topics': 'Recent Topics',
    'product_search_dialog.townsquare_teams_heading': 'Teams',
    'product_search_dialog.townsquare_teams_view_all': 'Search all teams',
    'product_search_dialog.townsquare_topics_heading': 'Topics',
    'product_search_dialog.townsquare_topics_view_all': 'Search all topics',
    'product_search_dialog.trello.archived': 'Archived',
    'product_search_dialog.trello.archived.card-hover': 'This card is archived',
    'product_search_dialog.trello.board': 'Board',
    'product_search_dialog.trello.boards_heading': 'Boards',
    'product_search_dialog.trello.cards_heading': 'Cards',
    'product_search_dialog.trello.closed': 'Closed',
    'product_search_dialog.trello.closed.board-hover': 'This board is closed',
    'product_search_dialog.trello.expanded.input-placeholder': 'Search Trello',
    'product_search_dialog.trello.feedback_link': 'Help us improve your search results!',
    'product_search_dialog.trello.list': 'List',
    'product_search_dialog.trello.private_workspace': 'Private Workspace',
    'product_search_dialog.trello.recent_boards_heading': 'Recent boards',
    'product_search_dialog.trello.workspace': 'Workspace',
    'product_search_dialog.updated_date_formatter': 'Updated {date}',
    'project.label': 'Project',
    'recentWork.eventTypeMessage.absolute.commented': 'You commented on {date}',
    'recentWork.eventTypeMessage.absolute.created': 'You created on {date}',
    'recentWork.eventTypeMessage.absolute.edited': 'You edited on {date}',
    'recentWork.eventTypeMessage.absolute.published': 'You published on {date}',
    'recentWork.eventTypeMessage.absolute.updated': 'You updated on {date}',
    'recentWork.eventTypeMessage.absolute.viewed': 'You viewed on {date}',
    'recentWork.eventTypeMessage.absolute.workedOn': 'You worked on {date}',
    'recentWork.eventTypeMessage.relative.commented': 'You commented {date}',
    'recentWork.eventTypeMessage.relative.created': 'You created {date}',
    'recentWork.eventTypeMessage.relative.edited': 'You edited {date}',
    'recentWork.eventTypeMessage.relative.published': 'You published {date}',
    'recentWork.eventTypeMessage.relative.updated': 'You updated {date}',
    'recentWork.eventTypeMessage.relative.viewed': 'You viewed {date}',
    'recentWork.eventTypeMessage.relative.workedOn': 'You worked on {date}',
    'repository.label': 'Repository',
    'search_dialog.filters.group.show-more': 'Show more',
    'search_dialog.search_input_clear_label': 'Clear search session',
    'search_dialog.search_input_exit_label': 'Exit Search',
    'space.label': 'Space',
    'spreadsheet.label': 'Spreadsheet',
    'task.label': 'Task',
    'video.label': 'Video',
    'web-page.label': 'Web Page'
};


var $6c104c09525816b7$export$2e2bcd8739ae039 = (0, $da82b26d75032a0f$export$2e2bcd8739ae039);

});

parcelRegister("gI0He", function(module, exports) {

let $c2a14baf52e5c976$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2a14baf52e5c976$var$load("dXz7U").then(()=>parcelRequire('efF3A'));

});

parcelRegister("9xDFS", function(module, exports) {

let $01caef5d76581f86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01caef5d76581f86$var$load("gGEZv").then(()=>parcelRequire('1Mvyi'));

});

parcelRegister("17Noe", function(module, exports) {

let $0d1cc1b24c96a717$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d1cc1b24c96a717$var$load("d3blt").then(()=>parcelRequire('5Abiq'));

});

parcelRegister("3R53Q", function(module, exports) {

let $2cea3f5da6ccc58b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2cea3f5da6ccc58b$var$load("59Z93").then(()=>parcelRequire('fY7GX'));

});

parcelRegister("7RIcW", function(module, exports) {

let $5b9fc665ec1b8214$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b9fc665ec1b8214$var$load("kotjW").then(()=>parcelRequire('1JK4e'));

});

parcelRegister("9nBQQ", function(module, exports) {

let $6d439f84e767f0f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d439f84e767f0f5$var$load("kK6se").then(()=>parcelRequire('dr5EV'));

});

parcelRegister("jZRxI", function(module, exports) {

let $e8ed3f4d540e9c94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8ed3f4d540e9c94$var$load("5xf60").then(()=>parcelRequire('928dD'));

});

parcelRegister("e2Bgo", function(module, exports) {

let $a38e284f262281ef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a38e284f262281ef$var$load("9VEIz").then(()=>parcelRequire('8u8jr'));

});

parcelRegister("i4KAI", function(module, exports) {

let $d28cbdc69ade55ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d28cbdc69ade55ec$var$load("cjdHS").then(()=>parcelRequire('iV9jc'));

});

parcelRegister("8nPWu", function(module, exports) {

let $61a8c35dca539424$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61a8c35dca539424$var$load("Whd6n").then(()=>parcelRequire('6zDwd'));

});

parcelRegister("fbhPR", function(module, exports) {

let $b0d5b7dbace42f97$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0d5b7dbace42f97$var$load("jkUKZ").then(()=>parcelRequire('4V7KZ'));

});

parcelRegister("bxxnU", function(module, exports) {

let $866cac47db71e24e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $866cac47db71e24e$var$load("9LPlo").then(()=>parcelRequire('eIyMR'));

});

parcelRegister("jCna3", function(module, exports) {

let $e4838843ac59e512$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4838843ac59e512$var$load("bCZbu").then(()=>parcelRequire('2cNOn'));

});

parcelRegister("hXwJC", function(module, exports) {

let $d13156d083814ff1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d13156d083814ff1$var$load("jUfGx").then(()=>parcelRequire('i1XCh'));

});

parcelRegister("fYJCf", function(module, exports) {

let $ba1fd7fde592e8a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ba1fd7fde592e8a8$var$load("8yxgV").then(()=>parcelRequire('k4Hxm'));

});

parcelRegister("bG90O", function(module, exports) {

let $880a9b948d554570$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $880a9b948d554570$var$load("dBE2i").then(()=>parcelRequire('6e98G'));

});

parcelRegister("edTRh", function(module, exports) {

let $a5ad9be9f70cdf36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5ad9be9f70cdf36$var$load("6FNZU").then(()=>parcelRequire('cRwJj'));

});

parcelRegister("b7MN8", function(module, exports) {

let $81963222c45baf71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $81963222c45baf71$var$load("ilWcC").then(()=>parcelRequire('3bomr'));

});

parcelRegister("3JZ3A", function(module, exports) {

let $2b94efaee46b5e8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b94efaee46b5e8d$var$load("edU6Z").then(()=>parcelRequire('lD7ty'));

});

parcelRegister("hG7Tu", function(module, exports) {

let $cdec7b82682993a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cdec7b82682993a2$var$load("atNxX").then(()=>parcelRequire('jE6uv'));

});

parcelRegister("dpTtT", function(module, exports) {

let $9c48a594255c3adc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c48a594255c3adc$var$load("gpgvY").then(()=>parcelRequire('aOGjz'));

});

parcelRegister("l5BOg", function(module, exports) {

let $f5a764d24ea51dd5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5a764d24ea51dd5$var$load("3IA7L").then(()=>parcelRequire('3vd6f'));

});

parcelRegister("ev7pl", function(module, exports) {

let $a8e9b4fb613f02c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8e9b4fb613f02c5$var$load("hpq4P").then(()=>parcelRequire('hy5e4'));

});

parcelRegister("d4I9K", function(module, exports) {

let $984de699effd6c59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $984de699effd6c59$var$load("8WMbP").then(()=>parcelRequire('47py6'));

});

parcelRegister("gldMm", function(module, exports) {

let $be594bb8a743c199$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be594bb8a743c199$var$load("kffHA").then(()=>parcelRequire('fZXUj'));

});

parcelRegister("a4pmT", function(module, exports) {

let $754df4b5ed42468f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $754df4b5ed42468f$var$load("2zh8u").then(()=>parcelRequire('4BVSW'));

});

parcelRegister("82Ppc", function(module, exports) {

let $5db662ae05da7a15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5db662ae05da7a15$var$load("9YoTA").then(()=>parcelRequire('eI8pB'));

});

parcelRegister("8d361", function(module, exports) {

let $5fa1f0735c405a83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5fa1f0735c405a83$var$load("a9qyt").then(()=>parcelRequire('6xDrT'));

});

parcelRegister("dY6k3", function(module, exports) {

let $a2b5c875eaa4c162$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a2b5c875eaa4c162$var$load("04egH").then(()=>parcelRequire('fBdRZ'));

});

parcelRegister("4Scw6", function(module, exports) {

let $38c5ea243cce1e24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38c5ea243cce1e24$var$load("lUh9w").then(()=>parcelRequire('5F6io'));

});

parcelRegister("hKdD9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $2ZIpG = parcelRequire("2ZIpG");


var $5TmpD = parcelRequire("5TmpD");


var $kmpep = parcelRequire("kmpep");

const $e996a7cbe3e17aef$var$NO_CORRECTION = [];
const $e996a7cbe3e17aef$var$AutocorrectionContext = /*#__PURE__*/ (0, $42omo.createContext)({
    correction: undefined,
    setCorrection: ()=>{}
});
const $e996a7cbe3e17aef$export$8ba6d08e2bcc861f = ({ children: children })=>{
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $5TmpD.useAutocorrectionEnabled)();
    const [correction, setCorrection] = (0, $42omo.useState)($e996a7cbe3e17aef$var$NO_CORRECTION);
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { locale: locale } = (0, $8C5kA.default)();
    const lang = (0, $5TmpD.sanitizeLanguage)(locale);
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const { url: aggregatorUrl, cloudId: cloudId } = aggregatorClient?.getAggregatorConfig() || {};
    (0, $42omo.useEffect)(()=>{
        setCorrection($e996a7cbe3e17aef$var$NO_CORRECTION);
        if (autocorrectionEnabled && (0, $5TmpD.shouldFetchAutocorrection)(query) && aggregatorUrl && cloudId) (0, $5TmpD.fetchAutocorrection)({
            query: query,
            aggregatorUrl: aggregatorUrl,
            lang: lang,
            cloudId: cloudId
        }).then((result)=>{
            if (!!result.termCorrections) setCorrection(result.termCorrections);
        }).catch((_error_)=>{});
    }, [
        autocorrectionEnabled,
        query,
        aggregatorUrl,
        cloudId,
        lang
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($e996a7cbe3e17aef$var$AutocorrectionContext.Provider, {
        value: {
            correction: correction,
            setCorrection: setCorrection
        },
        children: children
    });
};
const $e996a7cbe3e17aef$export$2f6912f63e498900 = ()=>{
    return (0, $42omo.useContext)($e996a7cbe3e17aef$var$AutocorrectionContext);
};
module.exports["AutocorrectionProvider"] = $e996a7cbe3e17aef$export$8ba6d08e2bcc861f;
module.exports["useAutocorrection"] = $e996a7cbe3e17aef$export$2f6912f63e498900;

});

parcelRegister("1jolb", function(module, exports) {
$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);
/* eslint-disable import/extensions */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fwSxy = parcelRequire("fwSxy");


var $2wQTl = parcelRequire("2wQTl");


var $iSHbD = parcelRequire("iSHbD");

const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
    const scriptRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        const current = scriptRef?.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRsearchInputWrapper), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            id: "ssr-search-input-popout-container",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $l998X.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwSxy.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            ref: scriptRef,
                            dangerouslySetInnerHTML: {
                                __html: (0, $2wQTl.script)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("lfOhG", function(module, exports) {

var $fJRVo = parcelRequire("fJRVo");


var $cgH2x = parcelRequire("cgH2x");


var $88j1D = parcelRequire("88j1D");

const $22c6390f7332d66f$export$7fe06de49ac4bced = ()=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    return !!(product && filterDefinitions[product.id]?.length > 0);
};
const $22c6390f7332d66f$export$1f8e3e68f7016027 = ()=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    return product && filterDefinitions[product.id] || [];
};
const $22c6390f7332d66f$export$75dfe0d9a43fb0ea = ()=>{
    const filters = $22c6390f7332d66f$export$1f8e3e68f7016027();
    let hasFilters = false;
    filters.forEach((filter)=>{
        filter.store.availableFilters.forEach((option)=>{
            if (option.isChecked && option.id !== (0, $88j1D.DEFAULT_OPTION)) hasFilters = true;
        });
    });
    return hasFilters;
};
const $22c6390f7332d66f$export$b5ddd6b67ba52fed = ()=>{
    const filters = $22c6390f7332d66f$export$1f8e3e68f7016027();
    const genericFilters = filters.filter((filter)=>filter['@type'] !== (0, $88j1D.SITE_FILTER_TYPE_NAME));
    return genericFilters.reduce((filterCount, nextFilter)=>nextFilter.store.availableFilters.filter((f)=>f.isChecked).length + filterCount, 0);
};
module.exports["useCurrentProductHasFilters"] = $22c6390f7332d66f$export$7fe06de49ac4bced;
module.exports["useGetCurrentProductFilters"] = $22c6390f7332d66f$export$1f8e3e68f7016027;
module.exports["useCurrentProductHasAppliedFilters"] = $22c6390f7332d66f$export$75dfe0d9a43fb0ea;
module.exports["useCurrentProductGenericSelectedFilterCount"] = $22c6390f7332d66f$export$b5ddd6b67ba52fed;

});

parcelRegister("1YJgS", function(module, exports) {

let $170e82f179e05b48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $170e82f179e05b48$var$load("awWN9"),
    $170e82f179e05b48$var$load("1Ojgx")
]).then(()=>parcelRequire('4E1b5'));

});

parcelRegister("48BnN", function(module, exports) {

var $88j1D = parcelRequire("88j1D");


var $cgH2x = parcelRequire("cgH2x");

const $20c4d524183fb4e9$export$51b04ed1f44b6aaf = (activeProductId)=>{
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    let appliedFilters = [];
    // Find all of the filters that apply to the current product
    const filters = filterDefinitions[activeProductId];
    if (filters !== undefined) filters.forEach((filter)=>{
        // filters with specified value mapping logic should implement it, else use generic logic
        if (filter.mapSelectionToAppliedValue) {
            const valueToApply = filter.mapSelectionToAppliedValue();
            !!valueToApply && appliedFilters.push(valueToApply);
        } else {
            let applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.id);
            // if no site filters are applied, the search should use the top 3 available sites
            if (filter['@type'] === (0, $88j1D.SITE_FILTER_TYPE_NAME) && applied.length === 0) applied = filter.store.availableFilters.slice(0, 3).map((filter)=>filter.id);
            if (filter['@type'] === 'spaces') applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.spaceKey || '');
            if (applied.length > 0) appliedFilters.push({
                '@type': filter['@type'],
                [filter.fieldName]: applied
            });
        }
    });
    return appliedFilters;
};
module.exports["useAppliedFilters"] = $20c4d524183fb4e9$export$51b04ed1f44b6aaf;

});

parcelRegister("Jl0nn", function(module, exports) {

let $08847f408af3a4ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08847f408af3a4ec$var$load("9S9Mz"),
    $08847f408af3a4ec$var$load("4xmPF"),
    $08847f408af3a4ec$var$load("fSobj"),
    $08847f408af3a4ec$var$load("74u2y"),
    $08847f408af3a4ec$var$load("2YffH"),
    $08847f408af3a4ec$var$load("iDB1L"),
    $08847f408af3a4ec$var$load("eEyVs"),
    $08847f408af3a4ec$var$load("6mHrv"),
    $08847f408af3a4ec$var$load("awWN9"),
    $08847f408af3a4ec$var$load("agAjs"),
    $08847f408af3a4ec$var$load("9CYct"),
    $08847f408af3a4ec$var$load("iIoyG"),
    $08847f408af3a4ec$var$load("2xn4F"),
    $08847f408af3a4ec$var$load("hZtKG"),
    $08847f408af3a4ec$var$load("iNmaF"),
    $08847f408af3a4ec$var$load("lVO3w"),
    $08847f408af3a4ec$var$load("hyzoX"),
    $08847f408af3a4ec$var$load("h9Ed7"),
    $08847f408af3a4ec$var$load("eBRUf"),
    $08847f408af3a4ec$var$load("cUIaj"),
    $08847f408af3a4ec$var$load("j8gSv"),
    $08847f408af3a4ec$var$load("8hnOL"),
    $08847f408af3a4ec$var$load("gVbhn"),
    $08847f408af3a4ec$var$load("80E7K"),
    $08847f408af3a4ec$var$load("8A3nE"),
    $08847f408af3a4ec$var$load("jbxHq"),
    $08847f408af3a4ec$var$load("8YSo7"),
    $08847f408af3a4ec$var$load("kiGNy"),
    $08847f408af3a4ec$var$load("fuKGN"),
    $08847f408af3a4ec$var$load("4IYLb"),
    $08847f408af3a4ec$var$load("7E8Pd"),
    $08847f408af3a4ec$var$load("g9CVe"),
    $08847f408af3a4ec$var$load("7EorR"),
    $08847f408af3a4ec$var$load("Wowvf"),
    $08847f408af3a4ec$var$load("7oiUM"),
    $08847f408af3a4ec$var$load("8t3po"),
    $08847f408af3a4ec$var$load("855o0"),
    $08847f408af3a4ec$var$load("8MfZE"),
    $08847f408af3a4ec$var$load("hv4mn"),
    $08847f408af3a4ec$var$load("dYtBN"),
    $08847f408af3a4ec$var$load("6wr18"),
    $08847f408af3a4ec$var$load("kjZZD"),
    $08847f408af3a4ec$var$load("7nW1A"),
    $08847f408af3a4ec$var$load("cM9rX"),
    $08847f408af3a4ec$var$load("9u7sS"),
    $08847f408af3a4ec$var$load("1fem1"),
    $08847f408af3a4ec$var$load("kHOMt"),
    $08847f408af3a4ec$var$load("ffEVr"),
    $08847f408af3a4ec$var$load("dTsOE"),
    $08847f408af3a4ec$var$load("hhss7"),
    $08847f408af3a4ec$var$load("5Zg4L"),
    $08847f408af3a4ec$var$load("ik1cX"),
    $08847f408af3a4ec$var$load("k5Ch2"),
    $08847f408af3a4ec$var$load("djob1"),
    $08847f408af3a4ec$var$load("hogcU"),
    $08847f408af3a4ec$var$load("fjYIR"),
    $08847f408af3a4ec$var$load("h3ABO"),
    $08847f408af3a4ec$var$load("kC80R"),
    $08847f408af3a4ec$var$load("fiCwF")
]).then(()=>parcelRequire('bDy3t'));

});

parcelRegister("6la50", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $97d7736b9ea01187$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /**
   * Trello
   */ trello_archived: {
        id: "product_search_dialog.trello.archived",
        defaultMessage: "Archived"
    },
    trello_archived_card_hover: {
        id: "product_search_dialog.trello.archived.card-hover",
        defaultMessage: "This card is archived"
    },
    trello_board: {
        id: "product_search_dialog.trello.board",
        defaultMessage: "Board"
    },
    trello_closed: {
        id: "product_search_dialog.trello.closed",
        defaultMessage: "Closed"
    },
    trello_closed_board_hover: {
        id: "product_search_dialog.trello.closed.board-hover",
        defaultMessage: "This board is closed"
    },
    trello_list: {
        id: "product_search_dialog.trello.list",
        defaultMessage: "List"
    },
    trello_workspace: {
        id: "product_search_dialog.trello.workspace",
        defaultMessage: "Workspace"
    },
    trello_private_workspace: {
        id: "product_search_dialog.trello.private_workspace",
        defaultMessage: "Private Workspace"
    },
    trello_expanded_input_placeholder: {
        id: "product_search_dialog.trello.expanded.input-placeholder",
        defaultMessage: "Search Trello"
    },
    trello_recent_boards_heading: {
        id: "product_search_dialog.trello.recent_boards_heading",
        defaultMessage: "Recent boards"
    },
    trello_boards_heading: {
        id: "product_search_dialog.trello.boards_heading",
        defaultMessage: "Boards"
    },
    trello_cards_heading: {
        id: "product_search_dialog.trello.cards_heading",
        defaultMessage: "Cards"
    },
    trello_feedback_link: {
        id: "product_search_dialog.trello.feedback_link",
        defaultMessage: "Help us improve your search results!"
    }
});
module.exports["messages"] = $97d7736b9ea01187$export$defe85febe8b728c;

});

parcelRegister("aJ5e0", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $1To4a = parcelRequire("1To4a");


var $cStGJ = parcelRequire("cStGJ");

const $d7612f6af24b36cb$var$baseStyle = {
    display: 'flex',
    // hack around IconContainer styles
    flexShrink: 0,
    // hack around IconContainer styles
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
};
const $d7612f6af24b36cb$export$d00fcd959e6e6c2b = ()=>{
    const iconColor = (0, $1To4a.default)('color.icon', (0, $6fnsQ.N800));
    return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.66667 0C1.19391 0 0 1.19391 0 2.66667V16C0 17.4728 1.19391 18.6667 2.66667 18.6667H21.3333C22.8061 18.6667 24 17.4728 24 16V2.66667C24 1.19391 22.8061 0 21.3333 0H2.66667ZM21.3333 2.66667H2.66667V10.6667H21.3333V2.66667ZM18.6667 14.6667C18.6667 15.403 19.2636 16 20 16C20.7364 16 21.3333 15.403 21.3333 14.6667C21.3333 13.9303 20.7364 13.3333 20 13.3333C19.2636 13.3333 18.6667 13.9303 18.6667 14.6667ZM4 16C3.26362 16 2.66667 15.403 2.66667 14.6667C2.66667 13.9303 3.26362 13.3333 4 13.3333H9.33333C10.0697 13.3333 10.6667 13.9303 10.6667 14.6667C10.6667 15.403 10.0697 16 9.33333 16H4Z" fill="${iconColor}"/></svg>`)}`;
};
const $d7612f6af24b36cb$export$419622b78ee4bd67 = ()=>{
    const iconColor = (0, $1To4a.default)('color.icon', (0, $6fnsQ.N800));
    return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.77778C0 0.795938 0.795938 0 1.77778 0H14.2222C15.2041 0 16 0.795938 16 1.77778V14.2222C16 15.2041 15.2041 16 14.2222 16H1.77778C0.795938 16 0 15.2041 0 14.2222V1.77778ZM1.77778 2.66667C1.77778 2.17575 2.17575 1.77778 2.66667 1.77778H6.22222C6.71314 1.77778 7.11111 2.17575 7.11111 2.66667V11.5556C7.11111 12.0465 6.71314 12.4444 6.22222 12.4444H2.66667C2.17575 12.4444 1.77778 12.0465 1.77778 11.5556V2.66667ZM9.77778 1.77778C9.28686 1.77778 8.88889 2.17575 8.88889 2.66667V8C8.88889 8.49092 9.28686 8.88889 9.77778 8.88889H13.3333C13.8243 8.88889 14.2222 8.49092 14.2222 8V2.66667C14.2222 2.17575 13.8243 1.77778 13.3333 1.77778H9.77778Z" fill="${iconColor}"/></svg>`)}`;
};
const $d7612f6af24b36cb$export$2f9da8868573b55d = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "est758s1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ prefs: { backgroundImageScaled: backgroundImageScaled, backgroundImage: backgroundImage, backgroundColor: backgroundColor } })=>{
    const boardUrl = backgroundImageScaled?.[0]?.url || backgroundImage;
    if (boardUrl) return {
        ...$d7612f6af24b36cb$var$baseStyle,
        height: '24px',
        width: '24px',
        backgroundImage: `url(${boardUrl})`
    };
    return {
        ...$d7612f6af24b36cb$var$baseStyle,
        height: '24px',
        width: '24px',
        backgroundColor: backgroundColor || `var(--ds-background-neutral, ${0, $6fnsQ.N40})`
    };
});
const $d7612f6af24b36cb$export$f4619d70a16e5ea0 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "est758s0"
})(()=>{
    return {
        ...$d7612f6af24b36cb$var$baseStyle,
        height: `19px`,
        width: '24px',
        marginBottom: "var(--ds-space-100, 8px)",
        backgroundImage: `url(${$d7612f6af24b36cb$export$d00fcd959e6e6c2b()})`
    };
});
module.exports["getCardIconUrl"] = $d7612f6af24b36cb$export$d00fcd959e6e6c2b;
module.exports["getBoardIconUrl"] = $d7612f6af24b36cb$export$419622b78ee4bd67;
module.exports["BoardIcon"] = $d7612f6af24b36cb$export$2f9da8868573b55d;
module.exports["CardIcon"] = $d7612f6af24b36cb$export$f4619d70a16e5ea0;

});

parcelRegister("2PzNg", function(module, exports) {

let $20fc1c07d30387b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20fc1c07d30387b2$var$load("2exA8").then(()=>parcelRequire('iiIdc'));

});

parcelRegister("hEfPy", function(module, exports) {

let $cd9273aeb9cc154f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd9273aeb9cc154f$var$load("eVnxm").then(()=>parcelRequire('5MSS3'));

});

parcelRegister("g9GR5", function(module, exports) {
var $d70deb832e9cbf50$export$c23e925a9f49ee3c = /*#__PURE__*/ function(ConfluenceGraphQLDateFilterFieldType) {
    ConfluenceGraphQLDateFilterFieldType["LASTMODIFIED"] = "LASTMODIFIED";
    ConfluenceGraphQLDateFilterFieldType["CREATED"] = "CREATED,";
    return ConfluenceGraphQLDateFilterFieldType;
}({});


const $448834a0f6f65d76$var$CONFLUENCE_ARI_PREFIX = 'ari:cloud:confluence::site/';
const $448834a0f6f65d76$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS = 10;
const $448834a0f6f65d76$var$MAX_RESULTS_SPACES = 3;
const $448834a0f6f65d76$export$71fb3a6d48f3d84f = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment'
];
const $448834a0f6f65d76$var$graphQLFilterMapper = (filters)=>{
    const confluenceFilters = {};
    filters.forEach((filter)=>{
        switch(filter['@type']){
            case 'spaces':
                confluenceFilters['spacesFilter'] = filter.spaceKeys;
                break;
            case 'verified':
                confluenceFilters['isVerified'] = filter.verified;
                break;
            case 'contributors':
                confluenceFilters['contributorsFilter'] = filter.accountIds;
                break;
            case 'lastModified':
                confluenceFilters['range'] = {
                    field: (0, $d70deb832e9cbf50$export$c23e925a9f49ee3c).LASTMODIFIED,
                    gt: filter.from,
                    lt: filter.to
                };
                break;
            case 'titleMatchOnly':
                confluenceFilters['titleMatchOnly'] = filter.enabled;
                break;
            case 'pageStatus':
                confluenceFilters['pageStatus'] = filter.pageStatus;
                break;
            default:
                break;
        }
    });
    return confluenceFilters;
};
const $448834a0f6f65d76$export$74c39e342047d9d1 = (filters)=>filters.some((filter)=>{
        if (filter['@type'] === 'spaces' && filter.spaceKeys && filter.spaceKeys.length > 0) return true;
        else if (filter['@type'] === 'contributors' && filter.accountIds && filter.accountIds.length > 0) return true;
        else if (filter['@type'] === 'lastModified' && filter.from && filter.to) return true;
        return false;
    });
const $448834a0f6f65d76$export$76ca4f6f223de78a = ({ query: query, filters: filters, contentEntities: contentEntities = $448834a0f6f65d76$export$71fb3a6d48f3d84f, analyticsInfo: analyticsInfo, cloudId: cloudId, pageBlogAttachmentLimit: pageBlogAttachmentLimit = $448834a0f6f65d76$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS, spaceLimit: spaceLimit = $448834a0f6f65d76$var$MAX_RESULTS_SPACES, includeAncestors: includeAncestors = false, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, isLivePagesEnabled: isLivePagesEnabled = false })=>{
    return {
        query: query,
        cloudIdARI: `${$448834a0f6f65d76$var$CONFLUENCE_ARI_PREFIX}${cloudId}`,
        pageBlogAttachmentLimit: pageBlogAttachmentLimit,
        spaceLimit: spaceLimit,
        includeAncestors: includeAncestors,
        contentEntities: contentEntities,
        confluenceFilters: $448834a0f6f65d76$var$graphQLFilterMapper(filters),
        searchSessionId: analyticsInfo?.searchSessionId,
        queryVersion: analyticsInfo?.queryVersion,
        includeSpaces: !$448834a0f6f65d76$export$74c39e342047d9d1(filters),
        isLivePagesEnabled: isLivePagesEnabled,
        experimentContext: {
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers
        }
    };
};
module.exports["hasCheckedFilters"] = $448834a0f6f65d76$export$74c39e342047d9d1;
module.exports["confluenceGraphQLSearchVariablesMapper"] = $448834a0f6f65d76$export$76ca4f6f223de78a;

});

parcelRegister("cvntw", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $701861e6cdd6ef14$export$913ed806993df47d = (0, $eSUdr.default)`query ConfluenceQuickSearchQuery($query:String!$cloudIdARI:String!$pageBlogAttachmentLimit:Int!$spaceLimit:Int!$contentEntities:[String!]!$confluenceFilters:SearchConfluenceFilter$queryVersion:Int$searchSessionId:String$includeSpaces:Boolean!$includeAncestors:Boolean!$experimentContext:SearchExperimentContextInput$isLivePagesEnabled:Boolean!){search{pageBlogAttachments:search(experience:"product-search-dialog" query:$query first:$pageBlogAttachmentLimit filters:{entities:$contentEntities locations:[$cloudIdARI]confluenceFilters:$confluenceFilters}analytics:{queryVersion:$queryVersion searchSessionId:$searchSessionId}experimentContext:$experimentContext){edges{node{...on SearchConfluencePageBlogAttachment{id title type url lastModified iconCssClass space{id name}confluenceEntity{...on ConfluencePage{id subtype@include(if:$isLivePagesEnabled)ancestors@include(if:$includeAncestors){id title}}}}}}abTest{abTestId controlId experimentId}totalCount}spaces:search(experience:"searchDialog" query:$query first:$spaceLimit filters:{entities:["ati:cloud:confluence:space"]locations:[$cloudIdARI]}analytics:{queryVersion:$queryVersion searchSessionId:$searchSessionId}experimentContext:$experimentContext)@include(if:$includeSpaces){edges{node{...on SearchConfluenceSpace{id key title type url iconPath}}}}}}`;
module.exports["ConfluenceQuickSearchQuery"] = $701861e6cdd6ef14$export$913ed806993df47d;

});

parcelRegister("4ymXE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df727533991c4aac2a7e523738f16a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $350c2601c1bf73a9$var$_react = $350c2601c1bf73a9$var$_interopRequireDefault((parcelRequire("42omo")));

var $350c2601c1bf73a9$var$_baseNew = $350c2601c1bf73a9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $350c2601c1bf73a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $350c2601c1bf73a9$var$AiSearchIcon = (props)=>/*#__PURE__*/ $350c2601c1bf73a9$var$_react.default.createElement($350c2601c1bf73a9$var$_baseNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$350c2601c1bf73a9$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $350c2601c1bf73a9$var$_default = module.exports.default = $350c2601c1bf73a9$var$AiSearchIcon;

});

parcelRegister("1Ajko", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::432ea26d62f26515b4626718ca47f05c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1278255a56286459$var$_react = $1278255a56286459$var$_interopRequireDefault((parcelRequire("42omo")));

var $1278255a56286459$var$_baseNew = $1278255a56286459$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1278255a56286459$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cursor".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Selecting the cursor in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1278255a56286459$var$CursorIcon = (props)=>/*#__PURE__*/ $1278255a56286459$var$_react.default.createElement($1278255a56286459$var$_baseNew.default, Object.assign({
        name: "CursorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.827 2.827 6.914 13.23l1.272-4.134c.134-.436.474-.776.91-.91l4.134-1.272zm-1.5.282C.886 1.99 1.99.887 3.108 1.326L14.11 5.648c1.21.476 1.145 2.212-.099 2.594L9.6 9.6l-1.358 4.412c-.382 1.244-2.118 1.31-2.594.099z" clip-rule="evenodd"/>`
    }, props));
$1278255a56286459$var$CursorIcon.displayName = 'CursorIcon';
var $1278255a56286459$var$_default = module.exports.default = $1278255a56286459$var$CursorIcon;

});

parcelRegister("5JS4G", function(module, exports) {
/**
 * Type definitions for Outbound Auth service responses
 *
 * These types mirror the response models from the outbound-auth service.
 * Source of truth: https://bitbucket.org/atlassian/outbound-auth/
 * Reference implementation: /src/service/accountManagement.ts
 * API Spec: /docs/content/platform/outbound-auth/swagger.yaml
 */ /**
 * Include fields for controlling what data is returned in account responses
 * Mirrors AtlassianAuthAccount.IncludeFields from outbound-auth service
 */ var $f5db1b1a2bd17d33$export$9e1d8c9863da0d81 = /*#__PURE__*/ function(IncludeFields) {
    IncludeFields["AccessToken"] = "accessToken";
    IncludeFields["DisplayName"] = "displayName";
    IncludeFields["AaId"] = "aaId";
    IncludeFields["AvatarUrl"] = "avatarUrl";
    IncludeFields["ExternalAccountId"] = "externalAccountId";
    IncludeFields["Expiry"] = "expiry";
    return IncludeFields;
}({});
class $f5db1b1a2bd17d33$export$7f02dcf7cf9277d8 extends Error {
    constructor(message){
        super(message);
        this.name = 'OutboundAuthApiError';
    }
}
module.exports["OutboundAuthApiError"] = $f5db1b1a2bd17d33$export$7f02dcf7cf9277d8;

});

parcelRegister("5tPRL", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");


var $kPBHE = parcelRequire("kPBHE");


var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

function $d4baf0504b42b38c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d4baf0504b42b38c$export$d0a8235d2583609 = /*#__PURE__*/ (0, $cStGJ.default)((0, $kPBHE.Link), {
    target: "e8crcwv22"
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.primaryTextColour),
    '&:hover': {
        textDecoration: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $2azjJ.primaryTextColour)
    },
    '&:focus': {
        outlineOffset: '-2px'
    },
    '&:visited': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $2azjJ.primaryTextColour),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.SearchDialogResultTitle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: (0, $2azjJ.visitedLinkColor)
        }
    }
});
const $d4baf0504b42b38c$export$87a308048e18f5d7 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv21"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2azjJ.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $2azjJ.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $2azjJ.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $2azjJ.itemHighlightColor)
        }
    }));
const $d4baf0504b42b38c$export$e10965f6350456f8 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv20"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-space-075, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $2azjJ.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $2azjJ.itemHighlightColor)
        }
    }));
const $d4baf0504b42b38c$export$b7244afbfdf4cb9a = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv19"
})((props)=>({
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $2azjJ.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $2azjJ.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2azjJ.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $2azjJ.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $2azjJ.grid).px : (0, $2azjJ.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $d4baf0504b42b38c$export$cc248e72bc9d7b85 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv18"
})({
    name: "qrg2ys",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px)"
});
const $d4baf0504b42b38c$export$d84276b3ae03593f = /*#__PURE__*/ (0, $cStGJ.default)($d4baf0504b42b38c$export$b7244afbfdf4cb9a, {
    target: "e8crcwv17"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $2azjJ.grid).multiple(2.5).px,
    opacity: 1
});
const $d4baf0504b42b38c$export$8f314e512d92575f = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv16"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2azjJ.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $2azjJ.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2azjJ.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});
const $d4baf0504b42b38c$export$ca5c00fa71c2e27e = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv15"
})({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
    display: 'flex',
    alignItems: 'center'
});
const $d4baf0504b42b38c$export$9c613d6c52df949a = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv14"
})((0, $2azjJ.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $2azjJ.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $2azjJ.primaryTextColour), ";@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}");
const $d4baf0504b42b38c$export$e97ece467686c93c = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv13"
})((0, $2azjJ.nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, $2azjJ.primaryTextColour), ";height:16px;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}width:90%;");
const $d4baf0504b42b38c$export$a999164f6ebc756c = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e8crcwv12"
})((0, $2azjJ.nowrapEllipsis), {
    color: "var(--ds-text-subtle, #5E6C84)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2azjJ.grid).px
});
const $d4baf0504b42b38c$export$b695f824f00c1cb0 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv11"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $2azjJ.grid).multiple(3).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).multiple(19).px
});
const $d4baf0504b42b38c$export$addf7aa0f753bbe8 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv10"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $d4baf0504b42b38c$export$a44951d703db9a17 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv9"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $d4baf0504b42b38c$export$c571ffd341b1e6fe = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv8"
})({
    maxWidth: '100%',
    width: '256px',
    height: '14px',
    marginBottom: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});
const $d4baf0504b42b38c$export$c8ec38cc79b76eaa = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv7"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'",
    minWidth: 'fit-content',
    marginLeft: "var(--ds-space-150, 12px)"
});
const $d4baf0504b42b38c$export$a15ed502bc39849a = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv6"
})({
    maxWidth: '100%',
    width: '100px',
    height: '12px',
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});
const $d4baf0504b42b38c$export$43a2b5c94cb85d9c = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv5"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $2azjJ.grid).multiple(54).px
});
const $d4baf0504b42b38c$export$2dfb537c5a7f8cc3 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv4"
})({
    name: "uy5e1i",
    styles: "display:flex;width:90%"
});
const $d4baf0504b42b38c$export$35507434feaa4496 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv3"
})({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).px}`
});
const $d4baf0504b42b38c$export$ee32d1086c278cfc = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv2"
})({
    name: "1ls843y",
    styles: "display:block;min-width:0;flex-grow:1"
});
const $d4baf0504b42b38c$export$2cacbb382e8a2ce4 = /*#__PURE__*/ (0, $cStGJ.default)("button", {
    target: "e8crcwv1"
})({
    name: "ykaoo6",
    styles: "background-color:transparent;border:none;cursor:pointer;padding:0;width:100%;text-align:left"
});
const $d4baf0504b42b38c$export$3c77a9b2eee1dfc5 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv0"
})({
    width: '100%',
    height: '100%',
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});
module.exports["ResultLink"] = $d4baf0504b42b38c$export$d0a8235d2583609;
module.exports["ResultContentWrapper"] = $d4baf0504b42b38c$export$87a308048e18f5d7;
module.exports["EnlargedResultContentWrapper"] = $d4baf0504b42b38c$export$e10965f6350456f8;
module.exports["ReturnIconContainer"] = $d4baf0504b42b38c$export$b7244afbfdf4cb9a;
module.exports["EnlargedReturnIconContainer"] = $d4baf0504b42b38c$export$cc248e72bc9d7b85;
module.exports["IconContainer"] = $d4baf0504b42b38c$export$8f314e512d92575f;
module.exports["EnlargedIconContainer"] = $d4baf0504b42b38c$export$ca5c00fa71c2e27e;
module.exports["ResultTitleContainer"] = $d4baf0504b42b38c$export$9c613d6c52df949a;
module.exports["EnlargedResultTitleContainer"] = $d4baf0504b42b38c$export$e97ece467686c93c;
module.exports["ResultLabel"] = $d4baf0504b42b38c$export$a999164f6ebc756c;
module.exports["ResultDetail"] = $d4baf0504b42b38c$export$b695f824f00c1cb0;
module.exports["CollapsedResultDetail"] = $d4baf0504b42b38c$export$addf7aa0f753bbe8;
module.exports["EnlargedCollapsedResultDetail"] = $d4baf0504b42b38c$export$a44951d703db9a17;
module.exports["EnlargedResultTitleContainerSkeleton"] = $d4baf0504b42b38c$export$c571ffd341b1e6fe;
module.exports["EnlargedResultDetail"] = $d4baf0504b42b38c$export$c8ec38cc79b76eaa;
module.exports["EnlargedResultDetailSkeleton"] = $d4baf0504b42b38c$export$a15ed502bc39849a;
module.exports["CollapsedResultDetailWrapper"] = $d4baf0504b42b38c$export$43a2b5c94cb85d9c;
module.exports["EnlargedCollapsedResultDetailWrapper"] = $d4baf0504b42b38c$export$2dfb537c5a7f8cc3;
module.exports["DetailsSeparator"] = $d4baf0504b42b38c$export$35507434feaa4496;
module.exports["CollapsedResultContentWrapper"] = $d4baf0504b42b38c$export$ee32d1086c278cfc;
module.exports["EnlargedSkeletonIcon"] = $d4baf0504b42b38c$export$3c77a9b2eee1dfc5;

});

parcelRegister("4SPhZ", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");

const $801ec4174110d9b1$export$568e0ce3cc5a9972 = 'atlassian.unified-search.quick-find-rovo-tip';
const $801ec4174110d9b1$export$4bac6b574c2c1d97 = 'anonymous-user';
const $801ec4174110d9b1$export$b9330795d9444727 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $801ec4174110d9b1$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = (0, $5G9KX.getLocalStorageItemAsString)($801ec4174110d9b1$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    const rovoTipProducts = rovoTip[userIdOrAnonymous] || {};
    return rovoTipProducts[productId] === undefined ? true : rovoTipProducts[productId];
};
const $801ec4174110d9b1$export$297a6fb093b042a3 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $801ec4174110d9b1$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = (0, $5G9KX.getLocalStorageItemAsString)($801ec4174110d9b1$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    if (!rovoTip[userIdOrAnonymous]) rovoTip[userIdOrAnonymous] = {};
    rovoTip[userIdOrAnonymous][productId] = false;
    (0, $5G9KX.setLocalStorageItem)($801ec4174110d9b1$export$568e0ce3cc5a9972, JSON.stringify(rovoTip));
    return rovoTip[userIdOrAnonymous][productId];
};
module.exports["getRovoTip"] = $801ec4174110d9b1$export$b9330795d9444727;
module.exports["setRovoTip"] = $801ec4174110d9b1$export$297a6fb093b042a3;

});

parcelRegister("12cJV", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $9Nzn7 = parcelRequire("9Nzn7");


var $kfImN = parcelRequire("kfImN");


var $dxrRk = parcelRequire("dxrRk");


var $bKLey = parcelRequire("bKLey");

class $160b24ddcdce5168$export$842695bca69eca86 {
    async getAbTestData(_scope, _experience, _product) {
        // Return default AB test values instead of calling deprecated experiment endpoint
        return Promise.resolve({
            abTestId: 'default',
            controlId: 'default'
        });
    }
    /**
   * Get a list of permitted scopes for the supplied product.
   *
   * Consumers should favour {@link batchedGetExtensibleProductPermission}, to batch
   * multiple scopes calls into one. {@link getProductScopes} may be used when a caller
   * explicitly wants a separate REST call to fetch scopes. One example may be if a product
   * has different scopes caching rules to other products.
   *
   * @param productId the product id to lookup scopes for
   * @param experience the experience this UI represents
   * @returns a promise of a list of scopes for the supplied product
   */ async getProductScopes(productId, experience) {
        const productScopeMap = await this.getGenericProductPermissions({
            productIds: [
                productId
            ],
            experience: experience
        });
        return productScopeMap.get(productId) || [];
    }
    /**
   * Returns a list of {@link Products} which the user should see in the dialog
   *
   * @deprecated consumers should use {@link batchedGetExtensibleProductPermission} to fetch product scopes, or
   * {@link getProductScopes} to force a separate call to fetch a single product's scopes.
   *
   */ async getProductPermissions(products, experience) {
        const lowercaseProductIds = products.map((p)=>p.toLowerCase());
        const productScopeMap = await this.getGenericProductPermissions({
            productIds: lowercaseProductIds,
            experience: experience
        });
        return lowercaseProductIds.filter((product)=>productScopeMap.get(product)?.length).map((product)=>product.toUpperCase());
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [], sourceProduct: sourceProduct, productSessionId: productSessionId }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, $kfImN.limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn,
            experimentId: this.backendExperiment?.experimentId,
            shadowExperimentId: this.backendExperiment?.shadowExperimentId,
            ...sourceProduct ? {
                sourceProduct: sourceProduct
            } : {},
            sessionId: productSessionId
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $9Nzn7.timed)(this.makePostRequest($160b24ddcdce5168$export$842695bca69eca86.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList, backendExperiment: backendExperiment }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.backendExperiment = void 0;
        this.getAggregatorConfig = ()=>{
            return {
                url: this.serviceConfig.url,
                cloudId: this.cloudId,
                siteMasterList: this.siteMasterList
            };
        };
        this.getGenericProductPermissions = async (args)=>{
            return (0, $bKLey.getFetchProductPermissions)(this.makeGetRequest)(args.productIds, this.cloudId, args.experience);
        };
        this.batchedGetExtensibleProductPermission = (0, $dxrRk.batchMethod)((args)=>{
            const emptyProductPermissions = {
                productIds: [],
                experience: ''
            };
            if (args.length === 0) return emptyProductPermissions;
            return args.reduce((acc, arg)=>{
                return {
                    productIds: [
                        ...acc.productIds,
                        ...arg.productIds
                    ],
                    experience: arg.experience
                };
            }, emptyProductPermissions);
        }, this.getGenericProductPermissions, (response, id)=>response.get(id) || []);
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.makeGetRequest = (path)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
        this.backendExperiment = backendExperiment;
    }
}
// Static URLs
$160b24ddcdce5168$export$842695bca69eca86.QUICKSEARCH_API_URL = 'quicksearch/v1';
module.exports["AggregatorClient"] = $160b24ddcdce5168$export$842695bca69eca86;

});

parcelRegister("91yhh", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iA4lt = parcelRequire("iA4lt");

var $gkXKl = parcelRequire("gkXKl");

var $4OGlb = parcelRequire("4OGlb");

const $c9b4bbfb0318c1b1$export$ce7a53bcef5d6aee = ({ quickFindEnabled: quickFindEnabled, children: children })=>{
    const layerName = quickFindEnabled ? (0, $4OGlb.STATSIG_QUICK_FIND_LAYER) : undefined;
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = (0, $42omo.useMemo)(()=>(0, $gkXKl.getMutuallyExclusiveExperiment)(layerName), [
        layerName
    ]);
    let frontendExperiments;
    if (quickFindEnabled) {
        const exampleFrontendExperiment = (0, $iA4lt.getFrontendExperiment)({
            abTestId: 'fe_search_experiment'
        });
        frontendExperiments = {
            // the mutually exclusive frontend experiment
            ...frontendExperiment?.abTestId && {
                [frontendExperiment.abTestId]: frontendExperiment
            },
            // add other frontend experiments that can be run alongside backend experiments here
            [exampleFrontendExperiment.abTestId]: exampleFrontendExperiment
        };
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($c9b4bbfb0318c1b1$var$ExperimentContext.Provider, {
        value: {
            backendExperiment: backendExperiment,
            frontendExperiments: frontendExperiments
        },
        children: children
    });
};
const $c9b4bbfb0318c1b1$var$ExperimentContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    backendExperiment: undefined,
    frontendExperiments: undefined
});
const $c9b4bbfb0318c1b1$export$d98589668c6e11a9 = ()=>{
    return (0, $42omo.useContext)($c9b4bbfb0318c1b1$var$ExperimentContext);
};
module.exports["ExperimentProvider"] = $c9b4bbfb0318c1b1$export$ce7a53bcef5d6aee;
module.exports["useExperiments"] = $c9b4bbfb0318c1b1$export$d98589668c6e11a9;

});

parcelRegister("hpDfc", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5dFS9 = parcelRequire("5dFS9");


var $kDuN4 = parcelRequire("kDuN4");

const $16dbb5df832b7062$export$b6f131c43d0365a = ({ analyticContext: analyticContext, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext = {}, filterAnalyticsContext: filterAnalyticsContext = {}, nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeAnalyticContextGenerator, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
        channel: (0, $5dFS9.DEFAULT_GAS_CHANNEL),
        onEvent: (event)=>{
            const additionalAttributes = typeof analyticContext === 'function' ? analyticContext() : analyticContext;
            const nonPrivacySafeAttributes = nonPrivacySafeAnalyticContextGenerator !== undefined ? nonPrivacySafeAnalyticContextGenerator() : nonPrivacySafeAnalyticContext;
            event.update((payload)=>{
                const filters = {
                    ...payload.attributes?.filters,
                    ...filterAnalyticsContext
                };
                // Operational event not support nonPrivacySafeAttributes
                const nonPrivacySafeAttributesPayload = payload.eventType === 'operational' ? {} : {
                    nonPrivacySafeAttributes: {
                        ...payload?.nonPrivacySafeAttributes,
                        ...nonPrivacySafeAttributes
                    }
                };
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        ...additionalAttributes,
                        filters: Object.keys(filters).length > 0 ? filters : undefined
                    },
                    ...nonPrivacySafeAttributesPayload
                };
            });
        },
        children: children
    });
};
module.exports["SearchDialogAnalyticsContext"] = $16dbb5df832b7062$export$b6f131c43d0365a;

});

parcelRegister("4wMwH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $de5accedd145fe95$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    queryParams: undefined
});
const $de5accedd145fe95$export$90a656ad86ba2e2 = ({ queryParams: queryParams, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($de5accedd145fe95$var$Context.Provider, {
        value: {
            queryParams: queryParams
        },
        children: children
    });
};
const $de5accedd145fe95$export$b37ee0d76c6d2fbc = ()=>{
    return (0, $42omo.useContext)($de5accedd145fe95$var$Context);
};
module.exports["QueryParamsProvider"] = $de5accedd145fe95$export$90a656ad86ba2e2;
module.exports["useQueryParams"] = $de5accedd145fe95$export$b37ee0d76c6d2fbc;

});

parcelRegister("cGCOz", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $a17b947b16252498$var$RovoContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    isRovoEnabled: false,
    setIsRovoEnabled: (isRovoEnabled)=>{}
});
const $a17b947b16252498$export$ee92d5ccc84fac27 = ({ isEnabled: isEnabled, children: children })=>{
    const [isRovoEnabled, setIsRovoEnabled] = (0, $42omo.useState)(isEnabled || false);
    return /*#__PURE__*/ (0, $l998X.jsx)($a17b947b16252498$var$RovoContext.Provider, {
        value: {
            isRovoEnabled: isRovoEnabled,
            setIsRovoEnabled: setIsRovoEnabled
        },
        children: children
    });
};
function $a17b947b16252498$export$4deb785ed026cc56() {
    return (0, $42omo.useContext)($a17b947b16252498$var$RovoContext);
}
module.exports["RovoContextProvider"] = $a17b947b16252498$export$ee92d5ccc84fac27;
module.exports["useRovoContext"] = $a17b947b16252498$export$4deb785ed026cc56;

});

parcelRegister("iEwUU", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $977849d86adacef2$var$UserContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    user: {},
    setUser: (user)=>{}
});
const $977849d86adacef2$export$88f24fd8fcfab6ca = ({ user: initialUser, orgId: orgId, children: children })=>{
    const [user, setUser] = (0, $42omo.useState)(initialUser || {});
    return /*#__PURE__*/ (0, $l998X.jsx)($977849d86adacef2$var$UserContext.Provider, {
        value: {
            user: user,
            orgId: orgId,
            setUser: setUser
        },
        children: children
    });
};
function $977849d86adacef2$export$87c54b525b914dab() {
    return (0, $42omo.useContext)($977849d86adacef2$var$UserContext);
}
module.exports["UserProvider"] = $977849d86adacef2$export$88f24fd8fcfab6ca;
module.exports["useUserContext"] = $977849d86adacef2$export$87c54b525b914dab;

});

parcelRegister("bO2XA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $c4sKh = parcelRequire("c4sKh");


var $hiGBZ = parcelRequire("hiGBZ");

const $c6b6394c69100db5$export$3cb2a92d364e01db = ({ title: title, totalResults: totalResults, children: children })=>{
    const hasTitle = Boolean(title);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hiGBZ.EnlargedSearchResultSectionContainer), {
        "data-vc": "search-result-section-enlarged",
        children: [
            hasTitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $hiGBZ.EnlargedSearchResultSectionHeading), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hiGBZ.EnlargedSearchResultsSectionTitle), {
                    children: [
                        title,
                        totalResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hiGBZ.SearchResultSectionTitleBadgeContainer), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                                testId: "search-result-count-badge",
                                children: totalResults
                            })
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
};
module.exports["EnlargedSearchResultSection"] = $c6b6394c69100db5$export$3cb2a92d364e01db;

});

parcelRegister("hiGBZ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

function $4c44caf80474dcb2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4c44caf80474dcb2$export$ee908270616a8c0 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1vq42j46"
})({
    padding: `${"var(--ds-space-100, 8px)"} 0`
});
const $4c44caf80474dcb2$export$503dfba90bfcca30 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1vq42j45"
})({
    name: "1yyzl0r",
    styles: "padding:0;display:flex;flex-direction:column;gap:var(--ds-space-025, 2px)"
});
const $4c44caf80474dcb2$export$12a98bde80b93e83 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1vq42j44"
})({
    marginBottom: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: (0, $2azjJ.grid).multiple(4).px
});
const $4c44caf80474dcb2$export$7ff5e58611d4f213 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1vq42j43"
})({
    name: "1ifu3fr",
    styles: "height:28px;display:flex"
});
const $4c44caf80474dcb2$export$ce295363b4299a23 = /*#__PURE__*/ (0, $cStGJ.default)("h2", {
    target: "e1vq42j42"
})({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2azjJ.grid).twice().px,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).twice().px}`
});
const $4c44caf80474dcb2$export$ba58138b255a651c = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1vq42j41"
})({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    boxSizing: 'border-box',
    padding: `0 ${"var(--ds-space-100, 8px)"}`
});
const $4c44caf80474dcb2$export$47dafe5a3fc802fe = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1vq42j40"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $2azjJ.grid).px,
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
module.exports["SearchResultSectionContainer"] = $4c44caf80474dcb2$export$ee908270616a8c0;
module.exports["EnlargedSearchResultSectionContainer"] = $4c44caf80474dcb2$export$503dfba90bfcca30;
module.exports["SearchResultSectionHeading"] = $4c44caf80474dcb2$export$12a98bde80b93e83;
module.exports["EnlargedSearchResultSectionHeading"] = $4c44caf80474dcb2$export$7ff5e58611d4f213;
module.exports["SearchResultsSectionTitle"] = $4c44caf80474dcb2$export$ce295363b4299a23;
module.exports["EnlargedSearchResultsSectionTitle"] = $4c44caf80474dcb2$export$ba58138b255a651c;
module.exports["SearchResultSectionTitleBadgeContainer"] = $4c44caf80474dcb2$export$47dafe5a3fc802fe;

});

parcelRegister("2OcMi", function(module, exports) {
const $1f2b7f00ecdc409c$export$46ffbef61eff3d00 = (url, key, unencodedValue)=>{
    return $1f2b7f00ecdc409c$export$cbc5b385481fb319(url, {
        [key]: unencodedValue
    });
};
const $1f2b7f00ecdc409c$export$cbc5b385481fb319 = (url, params)=>{
    if (!url) return url;
    const sanitisedUrl = url.endsWith('?') || url.endsWith('&') ? url.slice(0, url.length - 1) : url;
    const paramsString = Object.entries(params).reduce((rest, [key, unencodedValue])=>{
        if (!key) return rest;
        const nextPart = `${encodeURIComponent(key)}=${encodeURIComponent(unencodedValue)}`;
        if (rest) return `${rest}&${nextPart}`;
        return nextPart;
    }, '');
    if (!paramsString) return url;
    // If it has a query string already
    if (sanitisedUrl.includes('?')) return `${sanitisedUrl}&${paramsString}`;
    return `${sanitisedUrl}?${paramsString}`;
};
module.exports["addQuery"] = $1f2b7f00ecdc409c$export$46ffbef61eff3d00;
module.exports["addQueryParams"] = $1f2b7f00ecdc409c$export$cbc5b385481fb319;

});

parcelRegister("ejGzS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $cO3Oi = parcelRequire("cO3Oi");


var $gnG2x = parcelRequire("gnG2x");


var $9Qum6 = parcelRequire("9Qum6");

const $c2d03b527301e03f$export$fa734eedc505eef7 = ({ isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, screen: screen, searchResult: searchResult })=>{
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(searchResult.icon) ? searchResult.icon : typeof searchResult.icon === 'string' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: searchResult.icon,
        appearance: "square",
        size: "xsmall",
        testId: "result-avatar"
    }) : searchResult.iconRenderer ? searchResult.iconRenderer({
        screen: screen
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: searchResult.iconUrl,
        appearance: "square",
        size: "xsmall",
        testId: "result-avatar"
    });
    const title = searchResult.isVerified ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            searchResult.title,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO3Oi.VerifiedTeamIcon), {})
        ]
    }) : searchResult.title;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gnG2x.SearchResultContent), {
        isKeyboardHighlighted: isKeyboardHighlighted,
        title: title,
        meta: searchResult.meta,
        additionalMeta: searchResult.additionalMeta,
        isCollapsed: isCollapsed,
        icon: icon
    }, `item_${searchResult.id}`);
};
module.exports["defaultResultRenderer"] = $c2d03b527301e03f$export$fa734eedc505eef7;

});

parcelRegister("O4eEI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5dFS9 = parcelRequire("5dFS9");


var $6dP89 = parcelRequire("6dP89");

const $2ea9acd69c9f229c$export$4381245974d3b25a = ({ onHighlighted: onHighlighted, onSelect: onSelect, screen: screen, actionSubject: actionSubject })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onHighlightCallback = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultHighlighted)({
            screen: screen,
            actionSubject: actionSubject
        }));
        onHighlighted?.();
    }, [
        actionSubject,
        fireAnalyticsEvent,
        onHighlighted,
        screen
    ]);
    const onSelectCallback = (0, $42omo.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultSelected)({
            screen: screen,
            actionSubject: actionSubject
        }));
        onSelect?.(e);
    }, [
        actionSubject,
        fireAnalyticsEvent,
        onSelect,
        screen
    ]);
    const onContextMenuCallback = (0, $42omo.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultContext)({
            screen: screen,
            actionSubject: actionSubject
        }));
    }, [
        actionSubject,
        fireAnalyticsEvent,
        screen
    ]);
    return {
        onHighlightCallback: onHighlightCallback,
        onSelectCallback: onSelectCallback,
        onContextMenuCallback: onContextMenuCallback
    };
};
module.exports["useSearchResultAnalyticsCallbacks"] = $2ea9acd69c9f229c$export$4381245974d3b25a;

});

parcelRegister("20N1w", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iEwUU = parcelRequire("iEwUU");


var $1SV4e = parcelRequire("1SV4e");


var $fJRVo = parcelRequire("fJRVo");


var $2ZIpG = parcelRequire("2ZIpG");

const $6c6cdd0bab182993$export$3adda20dc7f5408f = (overrideQuery)=>{
    const previousQuery = (0, $42omo.useRef)(null);
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const persistRecentSearch = (0, $42omo.useCallback)(()=>{
        if (user?.id && product?.id) {
            if (overrideQuery && overrideQuery.trim() !== '') (0, $1SV4e.addRecentSearch)(overrideQuery, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
            else if (previousQuery.current !== query && query.trim() !== '') {
                (0, $1SV4e.addRecentSearch)(query, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
                previousQuery.current = query;
            }
        }
    }, [
        product?.id,
        query,
        user.id,
        overrideQuery
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        persistRecentSearch();
    }, [
        persistRecentSearch
    ]);
    const onEnter = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') persistRecentSearch();
    }, [
        persistRecentSearch
    ]);
    return [
        onClick,
        onEnter
    ];
};
const $6c6cdd0bab182993$export$c8074e5d4e733c21 = ({ children: children, overrideQuery: overrideQuery })=>{
    const [onClick, onEnter] = $6c6cdd0bab182993$export$3adda20dc7f5408f(overrideQuery);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        onClick: onClick,
        onKeyDown: onEnter,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: '100%'
        },
        "data-testid": "persist-recent-search",
        children: children
    }));
};
module.exports["usePersistRecentSearches"] = $6c6cdd0bab182993$export$3adda20dc7f5408f;
module.exports["PersistRecentSearch"] = $6c6cdd0bab182993$export$c8074e5d4e733c21;

});

parcelRegister("2GmtI", function(module, exports) {
const $4178462f01553fa5$var$packageName = "platform-pkg";
const $4178462f01553fa5$var$packageVersion = "0.0.0-use.local";
const $4178462f01553fa5$export$2db401a6b81eceee = `${$4178462f01553fa5$var$packageName}@${$4178462f01553fa5$var$packageVersion}`;
module.exports["BUILD_VERSION"] = $4178462f01553fa5$export$2db401a6b81eceee;

});

parcelRegister("lnXRc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");


var $5dFS9 = parcelRequire("5dFS9");

function $64f03dc1bbdc8c07$export$af9baadf0e4f6e13(analytics) {
    return (Component)=>{
        class WrappedComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
            render() {
                const { createAnalyticsEvent: createAnalyticsEvent, ...rest } = this.props;
                // There is NOT typesafety for the next line as typescript cannot infer types correctly with spread operators.
                // This is just going to have to go without type safety for the next line.
                return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...rest,
                    ...this.wrappedAnalyticsCallback
                });
            }
            constructor(..._args){
                super(..._args);
                this.wrappedAnalyticsCallback = Object.keys(analytics).reduce((acc, key)=>({
                        ...acc,
                        // We forward all args to the corresponding callback regardless of type
                        [key]: (...args)=>{
                            this.props.createAnalyticsEvent && this.props.createAnalyticsEvent(analytics[key](...args)).fire((0, $5dFS9.DEFAULT_GAS_CHANNEL));
                        }
                    }), {});
            }
        }
        return (0, $1DWH0.default)()(WrappedComponent);
    };
}
module.exports["withAnalytics"] = $64f03dc1bbdc8c07$export$af9baadf0e4f6e13;

});

parcelRegister("dDSTM", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $383eef3932fe8448$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /**
   * Quick Find
   */ quick_find_search_input_placeholder: {
        id: "product_search_dialog.quick_find_search_input_rovo_placeholder",
        defaultMessage: "Search or ask Rovo"
    },
    quick_find_recent_search_text_dialog: {
        id: "product_search_dialog.quick_find_recent_search_text_dialog",
        defaultMessage: "From your recent searches"
    },
    quick_find_show_organization_results: {
        id: "product_search_dialog.quick_find_show_organization_results",
        defaultMessage: "Search your organization"
    },
    quick_find_show_filtered_results: {
        id: "product_search_dialog.quick_find_show_filtered_confluence_results",
        defaultMessage: "Filter by Confluence spaces, contributors and more"
    },
    quick_find_show_filtered_results_with_icon: {
        id: "product_search_dialog.quick_find_show_filtered_confluence_results_with_icon",
        defaultMessage: "Filter by {confluenceIcon} Confluence spaces, contributors and more"
    },
    quick_find_ask_atlassian_intelligence: {
        id: "product_search_dialog.quick_find_ask_atlassian_intelligence",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    quick_find_recently_viewed: {
        id: "product_search_dialog.quick_find_recently_viewed",
        defaultMessage: "Recently Viewed"
    },
    quick_find_recent_draft_label: {
        id: "product_search_dialog.quick_find_recent_draft_label",
        defaultMessage: "DRAFT"
    },
    quick_find_recent_spaces_additional_meta: {
        id: "product_search_dialog.quick_find_recent_spaces_additional_meta",
        defaultMessage: "You recently visited"
    },
    quick_find_footer_text: {
        id: "product_search_dialog.quick_find_footer_help_text",
        defaultMessage: "Help us improve search"
    },
    quick_find_footer_full_page_search_link: {
        id: "product_search_dialog.quick_find_footer_full_page_search_products_link",
        defaultMessage: "Search across products"
    },
    quick_find_no_content_header: {
        id: "product_search_dialog.quick_find_no_content_header",
        defaultMessage: "Seek and you shall find"
    },
    quick_find_no_content_body: {
        id: "product_search_dialog.quick_find_no_content_body_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated apps"
    },
    quick_find_post_query_no_results_header: {
        id: "product_search_dialog.quick_find_post_query_no_results_header",
        defaultMessage: "We couldn't find any results with that title"
    },
    quick_find_post_query_no_results_body: {
        id: "product_search_dialog.quick_find_post_query_no_results_body",
        defaultMessage: "<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term."
    },
    quick_find_search_results: {
        id: "product_search_dialog.quick_find_search_results",
        defaultMessage: "Search Results"
    },
    quick_find_confluence_space: {
        id: "product_search_dialog.quick_find_confluence_space",
        defaultMessage: "Confluence Space"
    },
    quick_find_results_section: {
        id: "product_search_dialog.quick_find_results_section",
        defaultMessage: "Search Results"
    },
    quick_find_results_team: {
        id: "product_search_dialog.quick_find_result_item_team",
        defaultMessage: "Team"
    },
    quick_find_recent_search: {
        id: "product_search_dialog.quick_find_recent_search",
        defaultMessage: "Recent search"
    },
    remove_button_label: {
        id: "product_search_dialog.results.remove_button_label",
        defaultMessage: "Remove this."
    },
    quick_find_rovo_tip: {
        id: "product_search_dialog.quick_find_rovo_tip",
        defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer."
    },
    quick_find_footer_full_page_search_link_appify: {
        id: "product_search_dialog.quick_find_footer_full_page_search_products_link-appify",
        defaultMessage: "Search across apps"
    }
});
module.exports["messages"] = $383eef3932fe8448$export$defe85febe8b728c;

});

parcelRegister("21MH9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $8a39f80e5c1cc577$var$LoadedAutocorrection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("beGYg")).then(({ LoadedAutocorrection: LoadedAutocorrection })=>({
            default: LoadedAutocorrection
        })));
const $8a39f80e5c1cc577$export$5e9f08d9cf554737 = ({ container: container, fallback: fallback })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($8a39f80e5c1cc577$var$LoadedAutocorrection, {
            container: container,
            fallback: fallback
        })
    });
};
module.exports["AutocorrectAsyncWrapper"] = $8a39f80e5c1cc577$export$5e9f08d9cf554737;

});

parcelRegister("3q90y", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $k1wrx = parcelRequire("k1wrx");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dDSTM = parcelRequire("dDSTM");


var $fJRVo = parcelRequire("fJRVo");


var $2ZIpG = parcelRequire("2ZIpG");


var $9Janh = parcelRequire("9Janh");


var $eYinl = parcelRequire("eYinl");


var $O4eEI = parcelRequire("O4eEI");


var $20N1w = parcelRequire("20N1w");


var $aDRXf = parcelRequire("aDRXf");

const $b9ad121c89489744$export$6c90641783086ccb = 'recent-searches';
const $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY = 3;
const $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY = 1;
const $b9ad121c89489744$export$e5468815b4eb37d = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { focusInput: focusInput } = (0, $aDRXf.useInputContext)();
    const { recentSearchItems: recentSearchItems, removeRecentSearch: removeRecentSearch } = (0, $9Janh.useRecentSearches)({
        Icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $eYinl.QuickFindIcon), {})
    });
    const recentSearches = recentSearchItems.map((result)=>({
            id: result.id,
            title: result.title,
            icon: result.icon,
            url: getActiveProduct()?.generateAdvancedSearchUrl?.(result.title) || '',
            meta: '',
            additionalMeta: query !== '' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $dDSTM.messages).quick_find_recent_search_text_dialog
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $dDSTM.messages).quick_find_recent_search
            })
        }));
    const recentSearchesSection = (0, $42omo.useMemo)(()=>{
        return {
            id: $b9ad121c89489744$export$6c90641783086ccb,
            title: '',
            searchResults: recentSearches,
            resultRenderer: ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted, isCollapsed: isCollapsed })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $20N1w.PersistRecentSearch), {
                    overrideQuery: searchResult.title,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $k1wrx.EnlargedSearchResultContent), {
                        ...searchResult,
                        icon: searchResult.icon,
                        isKeyboardHighlighted: isKeyboardHighlighted,
                        isCollapsed: isCollapsed,
                        isRecentSearch: true,
                        onRemove: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            removeRecentSearch(searchResult.title);
                            focusInput && focusInput();
                        },
                        displayAdditionalMetaWhenHighlightedOnly: query === ''
                    })
                });
            },
            resultLimit: query ? $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY : $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY,
            useAnalyticsOverride: ({ screen: screen })=>(0, $O4eEI.useSearchResultAnalyticsCallbacks)({
                    screen: screen,
                    actionSubject: 'recentSearch'
                })
        };
    }, [
        query,
        recentSearches,
        removeRecentSearch,
        focusInput
    ]);
    return recentSearchesSection;
};
module.exports["RECENT_SEARCHES_SECTION_ID"] = $b9ad121c89489744$export$6c90641783086ccb;
module.exports["useRecentSearchesSection"] = $b9ad121c89489744$export$e5468815b4eb37d;

});

parcelRegister("kzbg7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $169DF = parcelRequire("169DF");


var $jnLgC = parcelRequire("jnLgC");


var $80L9g = parcelRequire("80L9g");

const $8488ca61c8c92e6d$export$875b296eac126ec2 = (defaultFilters = [], productId, filterType)=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(undefined);
    const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters } = (0, $80L9g.useSessionUserInput)();
    const storedFilters = readFilters(productId) ? readFilters(productId)[filterType] : [];
    const defaultFiltersRef = (0, $42omo.useRef)(stickySearchEnabled && storedFilters && storedFilters.length > 0 ? storedFilters : defaultFilters);
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFiltersRef.current);
    const addFilters = (0, $42omo.useCallback)((newFilters)=>dispatch((0, $jnLgC.addFilters)(newFilters, (a, b)=>{
            if (a.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER) return -1;
            if (a.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER) return 1;
            return 0;
        })), [
        dispatch
    ]);
    const loadDefaultFilters = (load)=>{
        setIsLoading(true);
        load.then((result)=>setDefaultFilters(result)).finally(()=>setIsLoading(false));
    };
    const updateFilter = (0, $42omo.useCallback)((id, isChecked, isVisible = true)=>dispatch((0, $jnLgC.updateFilterState)(id, isChecked, isVisible)), [
        dispatch
    ]);
    const updateSingleValueFilter = (0, $42omo.useCallback)((id)=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, f.id === id)));
    }, [
        filters,
        dispatch
    ]);
    const clearFilter = (0, $42omo.useCallback)(()=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, false)));
    }, [
        filters,
        dispatch
    ]);
    const resetFilter = (0, $42omo.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters.length ? defaultFilters : defaultFiltersRef.current));
    }, [
        defaultFilters,
        dispatch
    ]);
    const setDefaultFilters = (0, $42omo.useCallback)((filters)=>{
        defaultFiltersRef.current = filters;
        resetFilter();
    }, [
        defaultFiltersRef,
        resetFilter
    ]);
    (0, $42omo.useEffect)(()=>{
        if (stickySearchEnabled) {
            const stickyFilter = readFilters(productId);
            stickyFilter[filterType] = filters;
            storeFilters(productId, stickyFilter);
        }
    }, [
        stickySearchEnabled,
        readFilters,
        storeFilters,
        productId,
        filterType,
        filters
    ]);
    return {
        availableFilters: filters,
        isLoading: isLoading && defaultFilters.length === 0,
        loadDefaultFilters: loadDefaultFilters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        updateSingleValueFilter: updateSingleValueFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch,
        setDefaultFilters: setDefaultFilters
    };
};
module.exports["useFilterStore"] = $8488ca61c8c92e6d$export$875b296eac126ec2;

});

parcelRegister("4mZlP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $epvHH = parcelRequire("epvHH");

var $icqFF = parcelRequire("icqFF");


var $jluld = parcelRequire("jluld");


var $4AkKf = parcelRequire("4AkKf");


var $4TXTZ = parcelRequire("4TXTZ");


var $l3UB9 = parcelRequire("l3UB9");


var $eKv3Q = parcelRequire("eKv3Q");


var $ingNj = parcelRequire("ingNj");


var $2ZIpG = parcelRequire("2ZIpG");


var $2OcMi = parcelRequire("2OcMi");


var $3S0fp = parcelRequire("3S0fp");


var $5dFS9 = parcelRequire("5dFS9");


var $6dP89 = parcelRequire("6dP89");


var $8C5kA = parcelRequire("8C5kA");


var $e1ib8 = parcelRequire("e1ib8");


var $fJRVo = parcelRequire("fJRVo");


var $ju7KJ = parcelRequire("ju7KJ");


var $80L9g = parcelRequire("80L9g");


var $gF7Az = parcelRequire("gF7Az");


var $4ldrV = parcelRequire("4ldrV");


var $f0f3d = parcelRequire("f0f3d");


var $6kOEz = parcelRequire("6kOEz");


var $hFUff = parcelRequire("hFUff");


var $5uL5H = parcelRequire("5uL5H");

const $53e1ecb0ab1cac21$var$onKeyDown = (e, target)=>{
    if (e.key === 'Enter') {
        e.preventDefault();
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $53e1ecb0ab1cac21$var$onKeyDownWithShift = (e, target)=>{
    if (e.key === 'Enter' && e.shiftKey) {
        e.preventDefault();
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $53e1ecb0ab1cac21$export$74f31472c4e66c81 = ({ showModifierKey: showModifierKey })=>{
    const ModifierKeyIcon = window.navigator.userAgent.includes('Mac') ? (0, $6kOEz.CommandIcon) : (0, $hFUff.ControlIcon);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ju7KJ.SearchFooterLabelWrapper), {
        children: [
            showModifierKey && /*#__PURE__*/ (0, $l998X.jsx)(ModifierKeyIcon, {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5uL5H.SquareReturnIcon), {})
        ]
    });
};
const $53e1ecb0ab1cac21$export$ec11565276b0198d = ({ isKeyboardHighlighted: isKeyboardHighlighted, showSearchOnEnter: showSearchOnEnter, filterByProductFooter: filterByProductFooter, squareReturnIcon: squareReturnIcon })=>{
    if (showSearchOnEnter) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ju7KJ.SearchFooterLabelWrapper), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ju7KJ.SearchFooterLabel), {
                children: "Shift"
            }),
            "+",
            /*#__PURE__*/ (0, $l998X.jsx)((0, $epvHH.ReturnIcon), {
                inverted: isKeyboardHighlighted
            })
        ]
    });
    if (squareReturnIcon) return /*#__PURE__*/ (0, $l998X.jsx)($53e1ecb0ab1cac21$export$74f31472c4e66c81, {
        showModifierKey: filterByProductFooter
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $epvHH.ReturnIcon), {
        inverted: isKeyboardHighlighted
    });
};
const $53e1ecb0ab1cac21$export$3bd10e9d8677419f = ({ href: href, searchIconLabel: searchIconLabel = '', contentLabel: contentLabel, onClick: onClick, filterByProductFooter: filterByProductFooter, showSearchOnEnter: showSearchOnEnter, squareReturnIcon: squareReturnIcon, linkComponent: linkComponent, returnKeyIconComponent: ReturnKeyIconComponent = $53e1ecb0ab1cac21$export$ec11565276b0198d })=>{
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: showSearchOnEnter ? $53e1ecb0ab1cac21$var$onKeyDownWithShift : $53e1ecb0ab1cac21$var$onKeyDown
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: ref,
        onClick: onClick,
        role: "none",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'flex',
            height: '100%',
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l3UB9.AdvancedSearchLink), {
            href: href,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ju7KJ.ContentWrapper), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eKv3Q.CenteredAdvancedSearchGroup), {
                        children: [
                            filterByProductFooter ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
                                color: "currentColor",
                                label: searchIconLabel
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                                color: "currentColor",
                                label: searchIconLabel
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $eKv3Q.AdvancedSearchContent), {
                                children: contentLabel
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(ReturnKeyIconComponent, {
                    isKeyboardHighlighted: isKeyboardHighlighted,
                    showSearchOnEnter: showSearchOnEnter,
                    filterByProductFooter: filterByProductFooter,
                    squareReturnIcon: squareReturnIcon
                })
            ]
        })
    }));
};
const $53e1ecb0ab1cac21$export$de2cb7be8250c972 = ({ query: query, isLoading: isLoading, activeProduct: activeProduct, closeDialog: closeDialog, searchFooterLabel: searchFooterLabel, searchFooterLabelWithIcon: searchFooterLabelWithIcon, linkComponent: linkComponent, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', squareReturnIcon: squareReturnIcon = false, filterByProductFooter: filterByProductFooter = false, returnKeyIconComponent: returnKeyIconComponent })=>{
    const intl = (0, $8C5kA.default)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const productName = activeProduct?.title;
    const productId = activeProduct?.id;
    const urlGenerator = activeProduct?.generateAdvancedSearchUrl || urlGeneratorForNoResultsScreen;
    const baseSearchUrl = filterByProductFooter ? `${urlGenerator(query)}&product=confluence` : urlGenerator(query);
    const advancedSearchUrl = query && productId === (0, $f0f3d.ProductKeys).Confluence ? (0, $2OcMi.addQuery)(baseSearchUrl, 'search_id', searchSessionId) : baseSearchUrl;
    const workspaces = activeProduct?.workspaces;
    const showSearchOnEnter = !!activeProduct?.showSearchOnEnter;
    const actionSubjectId = `${productName}AdvancedSearchLink`;
    const { resetSearchSession: resetSearchSession } = (0, $80L9g.useSessionUserInput)();
    const searchLabel = searchFooterLabel || intl.formatMessage((0, $e1ib8.messages).extensible_advanced_search_footer);
    const advancedSearchContentLabel = searchFooterLabelWithIcon || searchLabel;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onAdvancedSearchClicked = (0, $42omo.useCallback)((e)=>{
        if (!(0, $3S0fp.isNewTab)(e)) resetSearchSession();
        if (filterByProductFooter) {
            (0, $4TXTZ.default)('quick-search-close', performance.now());
            closeDialog();
        }
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        actionSubjectId,
        resetSearchSession,
        closeDialog,
        filterByProductFooter
    ]);
    if (workspaces && workspaces?.length > 1) {
        const workspacesWithAdvancedSearchLinks = workspaces.map((workspace)=>({
                product: productName || '',
                content: workspace.name,
                key: workspace.name,
                advancedSearchUrl: activeProduct?.generateAdvancedSearchUrl?.(query, workspace.baseUrl) || ''
            }));
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $ingNj.default), {
            workspaces: workspacesWithAdvancedSearchLinks,
            linkComponent: linkComponent,
            isLoading: isLoading,
            onClick: (_, e)=>{
                (0, $5dFS9.onAdvancedSearchSelected)({
                    actionSubjectId: actionSubjectId,
                    trigger: (0, $3S0fp.getTrigger)(e),
                    isLoading: isLoading,
                    newTab: (0, $3S0fp.isNewTab)(e)
                });
            }
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($53e1ecb0ab1cac21$export$3bd10e9d8677419f, {
        href: advancedSearchUrl,
        searchIconLabel: searchLabel,
        contentLabel: advancedSearchContentLabel,
        onClick: onAdvancedSearchClicked,
        filterByProductFooter: filterByProductFooter,
        showSearchOnEnter: showSearchOnEnter,
        squareReturnIcon: squareReturnIcon,
        linkComponent: linkComponent,
        returnKeyIconComponent: returnKeyIconComponent
    });
};
const $53e1ecb0ab1cac21$export$ad56be906d54f7e2 = ({ ...rest })=>{
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const closeDialog = (0, $42omo.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($53e1ecb0ab1cac21$export$de2cb7be8250c972, {
        ...rest,
        query: query,
        isLoading: isLoading,
        activeProduct: activeProduct,
        closeDialog: closeDialog
    });
};
module.exports["ReturnIconWithModifier"] = $53e1ecb0ab1cac21$export$74f31472c4e66c81;
module.exports["AdvancedSearchFooterLink"] = $53e1ecb0ab1cac21$export$3bd10e9d8677419f;
module.exports["AdvancedSearchFooter"] = $53e1ecb0ab1cac21$export$ad56be906d54f7e2;

});

parcelRegister("crAJ1", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

const $307b1644cf276a47$export$64ded8b71dfcba9e = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1jzvw2y0"
})({
    width: '100%',
    height: `${"var(--ds-space-600, 48px)"}`,
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`
});
module.exports["SearchFooter"] = $307b1644cf276a47$export$64ded8b71dfcba9e;

});

parcelRegister("2wQTl", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable */ // @ts-ignore
const $da2d6e1979a6c520$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;
module.exports["script"] = $da2d6e1979a6c520$export$bc237d627614fc48;

});

parcelRegister("9Nzn7", function(module, exports) {
const $f0a7768b8895b419$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $f0a7768b8895b419$export$d35186a762cd39c8;

});

parcelRegister("kfImN", function(module, exports) {
const $1e46ba23978c04a9$export$c9a345fa92182d1c = ({ siteUrl: siteUrl, sites: sites })=>{
    if (siteUrl) return siteUrl;
    if (sites && sites.length > 0) return sites[0].siteUrl;
    return '';
};
const $1e46ba23978c04a9$export$fdb149c8c29e67a2 = (siteId, sites)=>{
    const matchingSite = sites.find((site)=>site.cloudId === siteId);
    return matchingSite ? matchingSite.siteUrl : '';
};
const $1e46ba23978c04a9$export$4be99cb40bcf5aef = (absSiteUrl, sites = [])=>{
    const baseUrlRegex = /^(http(s)?:\/\/[^\/]+)/;
    const urlRegexMatches = absSiteUrl.match(baseUrlRegex);
    if (!urlRegexMatches) return '';
    const baseUrl = urlRegexMatches[0];
    const matchingSite = sites.find((site)=>site.siteUrl === baseUrl);
    return matchingSite ? matchingSite.cloudId : '';
};
const $1e46ba23978c04a9$export$ca98b3a6d1ea77f3 = (isMultiSite, absoluteUrl = '', accountId, contextPath = '')=>{
    if (isMultiSite && absoluteUrl) return absoluteUrl;
    return contextPath ? `/${contextPath}/people/${accountId}` : `/people/${accountId}`;
};
const $1e46ba23978c04a9$var$MAX_SITES_INITIAL_QUERY = 3;
const $1e46ba23978c04a9$export$ba81234f3ab84a86 = (sites = [])=>{
    return sites.slice(0, $1e46ba23978c04a9$var$MAX_SITES_INITIAL_QUERY);
};
module.exports["extractSiteUrl"] = $1e46ba23978c04a9$export$c9a345fa92182d1c;
module.exports["mapTenantIdToSiteUrl"] = $1e46ba23978c04a9$export$fdb149c8c29e67a2;
module.exports["extractSiteIdBySiteUrl"] = $1e46ba23978c04a9$export$4be99cb40bcf5aef;
module.exports["generatePeopleProfileUrl"] = $1e46ba23978c04a9$export$ca98b3a6d1ea77f3;
module.exports["limitToMaxSiteUsage"] = $1e46ba23978c04a9$export$ba81234f3ab84a86;

});

parcelRegister("dxrRk", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");

const $0d4ef05ab28cb343$export$198da76335167312 = (argumentResolver, finalFn, successfulResponseMapper, debounceTime = 100)=>{
    const batchMap = {};
    const timedFn = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        const inFlightRequestsMap = {
            ...batchMap
        };
        const keys = Object.keys(inFlightRequestsMap);
        const args = keys.map((key)=>inFlightRequestsMap[key].arg);
        finalFn(argumentResolver(args)).then((response)=>{
            keys.forEach((key)=>{
                inFlightRequestsMap[key].resolve(successfulResponseMapper(response, key));
            });
        }).catch(()=>{
            keys.forEach((product)=>{
                inFlightRequestsMap[product].reject();
            });
        }).finally(()=>keys.forEach((key)=>delete batchMap[key]));
    }, debounceTime);
    return (id, arg)=>{
        const promise = new Promise((resolve, reject)=>{
            batchMap[id] = {
                resolve: resolve,
                reject: reject,
                arg: arg
            };
        });
        timedFn();
        return promise;
    };
};
module.exports["batchMethod"] = $0d4ef05ab28cb343$export$198da76335167312;

});

parcelRegister("bKLey", function(module, exports) {
const $73ef07e649cb3d00$var$SCOPES_API_URL = 'scopes/v1';
const $73ef07e649cb3d00$export$b756f4e692ecc8f = (makeRequest)=>async (productIds, cloudId, experience)=>{
        if (productIds.length === 0) return Promise.resolve(new Map());
        try {
            const productParams = productIds.map((productId)=>[
                    'productId',
                    productId
                ]);
            const params = new URLSearchParams([
                [
                    'experience',
                    experience
                ],
                ...productParams
            ]);
            const path = `${$73ef07e649cb3d00$var$SCOPES_API_URL}/${cloudId}?${params.toString()}`;
            const response = await makeRequest(path);
            return new Map(Object.keys(response.products).map((product)=>[
                    product,
                    response.products[product]
                ]));
        } catch (e) {
            return new Map();
        }
    };
module.exports["getFetchProductPermissions"] = $73ef07e649cb3d00$export$b756f4e692ecc8f;

});

parcelRegister("gnG2x", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $epvHH = parcelRequire("epvHH");


var $5tPRL = parcelRequire("5tPRL");

const $9f2dcb84dea7d967$export$595b9d59c3d65270 = '@@@hl@@@';
const $9f2dcb84dea7d967$export$eea8f6b95460c3c3 = '@@@endhl@@@';
const $9f2dcb84dea7d967$var$getResultLabel = (label)=>{
    if (typeof label === 'string') return /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.ResultLabel), {
        title: typeof label === 'string' ? label : undefined,
        children: label
    });
    return label;
};
const $9f2dcb84dea7d967$var$getResultTitle = (title)=>{
    if (typeof title === 'string') return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            title: title,
            className: "SearchDialogResultTitle",
            children: title
        })
    });
    return title;
};
const $9f2dcb84dea7d967$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    const getResultContent = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: isCollapsed ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.ResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            $9f2dcb84dea7d967$var$getResultLabel(label),
                            $9f2dcb84dea7d967$var$getResultTitle(title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.CollapsedResultDetailWrapper), {
                        children: [
                            meta && /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.CollapsedResultDetail), {
                                title: typeof meta === 'string' ? meta : undefined,
                                children: meta
                            }),
                            additionalMeta && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.DetailsSeparator), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.CollapsedResultDetail), {
                                        children: additionalMeta
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.ResultTitleContainer), {
                        children: [
                            $9f2dcb84dea7d967$var$getResultLabel(label),
                            $9f2dcb84dea7d967$var$getResultTitle(title)
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.ResultDetail), {
                        title: typeof meta === 'string' ? meta : undefined,
                        children: meta
                    }),
                    additionalMeta ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.ResultDetail), {
                        title: typeof additionalMeta === 'string' ? additionalMeta : undefined,
                        children: additionalMeta
                    }) : null
                ]
            })
        });
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    (0, $42omo.useEffect)(()=>{
        if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.ResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.IconContainer), {
                children: icon
            }),
            getResultContent(),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.ReturnIconContainer), {
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $epvHH.ReturnIcon), {
                    inverted: true
                })
            })
        ]
    });
};
module.exports["SearchResultContent"] = $9f2dcb84dea7d967$export$b5fd7d6305bfbd3e;

});

parcelRegister("9Qum6", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $cStGJ = parcelRequire("cStGJ");

function $97dd1a753677152a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $97dd1a753677152a$var$NegativeMargin = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "ez36xyc0"
})({
    name: "l8jj6j",
    styles: "margin:var(--ds-space-negative-025, -2px);display:flex"
});
const $97dd1a753677152a$export$d2397285980ae833 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($97dd1a753677152a$var$NegativeMargin, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            ...props
        })
    });
module.exports["ResultAvatar"] = $97dd1a753677152a$export$d2397285980ae833;

});

parcelRegister("k1wrx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dfZ5P = parcelRequire("dfZ5P");


var $jqsW9 = parcelRequire("jqsW9");


var $68Mwd = parcelRequire("68Mwd");


var $gtD4K = parcelRequire("gtD4K");


var $9lW6K = parcelRequire("9lW6K");


var $1qfLF = parcelRequire("1qfLF");


var $5tPRL = parcelRequire("5tPRL");

const $136b05df76cfe49d$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [isHover, setIsHover] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const isActive = isKeyboardHighlighted || isHover;
    const showReturnIcon = (0, $42omo.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
        isKeyboardHighlighted,
        returnIcon,
        isRecentSearch
    ]);
    const showRemoveIcon = (0, $42omo.useMemo)(()=>isRecentSearch && isActive, [
        isRecentSearch,
        isActive
    ]);
    const showAdditionalMeta = (0, $42omo.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
        displayAdditionalMetaWhenHighlightedOnly,
        isActive,
        additionalMeta
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.EnlargedResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedIconContainer), {
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.EnlargedResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            typeof title === 'string' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                    title: title,
                                    className: "SearchDialogResultTitle",
                                    children: highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title
                                })
                            }) : title,
                            typeof label === 'string' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.ResultLabel), {
                                title: label,
                                children: label
                            }) : label
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedCollapsedResultDetailWrapper), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedCollapsedResultDetail), {
                            children: meta
                        })
                    })
                ]
            }),
            showAdditionalMeta && /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedResultDetail), {
                children: additionalMeta
            }),
            showReturnIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jqsW9.SquareReturnIcon), {})
            }),
            showRemoveIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    icon: (0, $dfZ5P.RemoveIcon),
                    spacing: 'compact',
                    onClick: onRemove,
                    label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $68Mwd.messages).remove_button_label
                    }),
                    appearance: 'subtle'
                })
            })
        ]
    });
};
module.exports["EnlargedSearchResultContent"] = $136b05df76cfe49d$export$171a2a7e5a778acc;

});

parcelRegister("9Janh", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iEwUU = parcelRequire("iEwUU");


var $1SV4e = parcelRequire("1SV4e");


var $fJRVo = parcelRequire("fJRVo");


var $dJB5H = parcelRequire("dJB5H");


var $3S0fp = parcelRequire("3S0fp");

const $82a68bc4ee5a3cdf$export$e0495117e49f394c = 50; // It can be different from the number of records in local storage
const $82a68bc4ee5a3cdf$export$d349a1b1b7874c14 = ({ Icon: Icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $dJB5H.DefaultIcon), {}), limit: limit = $82a68bc4ee5a3cdf$export$e0495117e49f394c })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const [recentSearchItems, setRecentSearchItems] = (0, $42omo.useState)([]);
    const memoizedIcon = (0, $42omo.useMemo)(()=>Icon, [
        Icon
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!product || !user.id) return;
        const recentSearches = (0, $1SV4e.getRecentSearches)(user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
        const searchResults = recentSearches.map((value)=>({
                id: (0, $3S0fp.sha256Hash)(value),
                title: value,
                icon: memoizedIcon
            }));
        if (recentSearchItems.length === 0 && searchResults.length > 0) setRecentSearchItems(searchResults);
    }, [
        product,
        user.id,
        memoizedIcon,
        recentSearchItems.length
    ]);
    const removeRecentSearch = (0, $42omo.useCallback)((query)=>{
        if (user?.id && product?.id) {
            const recentSearches = (0, $1SV4e.removeRecentSearch)(query, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
            if (recentSearches) {
                const searchResults = recentSearches.map((value)=>({
                        id: (0, $3S0fp.sha256Hash)(value),
                        title: value,
                        icon: memoizedIcon
                    }));
                setRecentSearchItems(searchResults);
            }
        }
    }, [
        product,
        user.id,
        memoizedIcon
    ]);
    return {
        recentSearchItems: recentSearchItems.slice(0, limit),
        removeRecentSearch: removeRecentSearch
    };
};
module.exports["useRecentSearches"] = $82a68bc4ee5a3cdf$export$d349a1b1b7874c14;

});

parcelRegister("eYinl", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $kevJM = parcelRequire("kevJM");


var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e314a008b56330d$var$IconContainer = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e10r90tl0"
})({
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`,
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-radius-small, 4px)",
    border: "'1px solid transparent'"
});
const $4e314a008b56330d$export$f5db5b3314f27023 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($4e314a008b56330d$var$IconContainer, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            color: `var(--ds-icon-accent-gray, ${(0, $6fnsQ.N600)})`,
            spacing: "spacious",
            label: "recent-search"
        })
    });
module.exports["QuickFindIcon"] = $4e314a008b56330d$export$f5db5b3314f27023;

});

parcelRegister("aDRXf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $0bc222710141dc7b$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    focusInput: undefined
});
const $0bc222710141dc7b$export$37fb8590cf2c088c = ({ children: children, forwardRef: forwardRef })=>{
    const focusInput = (0, $42omo.useCallback)(()=>{
        if (typeof forwardRef === 'object') forwardRef?.current?.focus();
    }, [
        forwardRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($0bc222710141dc7b$var$Context.Provider, {
        value: {
            focusInput: focusInput
        },
        children: children
    });
};
const $0bc222710141dc7b$export$25c2004aac4f3cc = ()=>{
    return (0, $42omo.useContext)($0bc222710141dc7b$var$Context);
};
module.exports["InputContext"] = $0bc222710141dc7b$export$37fb8590cf2c088c;
module.exports["useInputContext"] = $0bc222710141dc7b$export$25c2004aac4f3cc;

});

parcelRegister("jnLgC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5fb8761f8962dfc8$export$60c1905c6f855529 = (filters, sortFunction)=>({
        type: 'ADD_FILTERS',
        newFilters: filters,
        sortFunction: sortFunction
    });
const $5fb8761f8962dfc8$export$3be5fe9f09d6965 = (id)=>({
        type: 'REMOVE_FILTER',
        id: id
    });
const $5fb8761f8962dfc8$export$4dce09b3092bd5e8 = (newFilters)=>({
        type: 'REPLACE_ALL_FILTERS',
        newFilters: newFilters
    });
const $5fb8761f8962dfc8$export$e4269d58720a0c2c = (filterId, isChecked, isVisible)=>({
        type: 'UPDATE_FILTER_STATE',
        filterId: filterId,
        isChecked: isChecked,
        isVisible: isVisible
    });
const $5fb8761f8962dfc8$export$234bf2a76076d85a = (newFilters)=>({
        type: 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED',
        newFilters: newFilters
    });
function $5fb8761f8962dfc8$var$reducer(state, action) {
    switch(action.type){
        case 'ADD_FILTERS':
            {
                if (action.newFilters.length === 0) return state;
                let newState = [
                    ...state
                ];
                action.newFilters.forEach((f)=>{
                    const index = state.findIndex((filter)=>filter.id === f.id);
                    if (index === -1) newState.push(f);
                    else {
                        newState[index] = f;
                        return newState;
                    }
                });
                action.sortFunction && newState.sort(action.sortFunction);
                return newState;
            }
        case 'UPDATE_FILTER_STATE':
            {
                const index = state.findIndex((filter)=>filter.id === action.filterId);
                if (index === -1) return state;
                const newState = [
                    ...state
                ];
                newState[index] = {
                    ...newState[index],
                    isChecked: action.isChecked,
                    isVisible: action.isVisible === undefined || action.isVisible === null ? newState[index].isVisible : action.isVisible
                };
                return newState;
            }
        case 'REMOVE_FILTER':
            return [
                ...state.filter((filter)=>filter.id !== action.id)
            ];
        case 'REPLACE_ALL_FILTERS':
            return [
                ...action.newFilters
            ];
        case 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED':
            {
                const newState = action.newFilters.map((newFilter)=>{
                    const existingFilter = state.find((f)=>f.id === newFilter.id);
                    if (existingFilter && newFilter.isVisible) newFilter.isChecked = existingFilter.isChecked;
                    return newFilter;
                });
                return newState;
            }
        default:
            // exhaustive check
            const _ = action;
            throw new Error(_);
    }
}
const $5fb8761f8962dfc8$export$3274cf84b703fff = (initialValues)=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useReducer($5fb8761f8962dfc8$var$reducer, initialValues ? initialValues : []);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            filters: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return value;
};
module.exports["addFilters"] = $5fb8761f8962dfc8$export$60c1905c6f855529;
module.exports["replaceAllFilters"] = $5fb8761f8962dfc8$export$4dce09b3092bd5e8;
module.exports["updateFilterState"] = $5fb8761f8962dfc8$export$e4269d58720a0c2c;
module.exports["useFilter"] = $5fb8761f8962dfc8$export$3274cf84b703fff;

});

parcelRegister("epvHH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $abe9af1675ab5b46$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    width: "24",
                    height: "16",
                    fill: inverted ? `var(--ds-background-neutral-bold, ${0, $6fnsQ.N80})` : `var(--ds-background-neutral, ${0, $6fnsQ.N30})`,
                    rx: "3"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fill: inverted ? `var(--ds-icon-inverse, ${0, $6fnsQ.N30})` : `var(--ds-icon-subtle, ${0, $6fnsQ.N80})`,
                    fillRule: "nonzero",
                    d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
                })
            ]
        })
    });
module.exports["ReturnIcon"] = $abe9af1675ab5b46$export$d6c38c54dfb7c9d5;

});

parcelRegister("l3UB9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eKv3Q = parcelRequire("eKv3Q");

const $2b4af01aea146af3$export$3f63855034354a21 = ({ href: href, linkComponent: linkComponent, ...rest })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eKv3Q.StyledAdvancedSearch), {
        linkComponent: linkComponent,
        "data-test-id": "search-dialog-advanced-search-link",
        href: href,
        ...rest
    });
module.exports["AdvancedSearchLink"] = $2b4af01aea146af3$export$3f63855034354a21;

});

parcelRegister("eKv3Q", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $2hEyf = parcelRequire("2hEyf");


var $kPBHE = parcelRequire("kPBHE");


var $cStGJ = parcelRequire("cStGJ");

function $73c221919444c9a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $73c221919444c9a0$export$5d708f1c4bba7ac3 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1fpfwrr2"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const $73c221919444c9a0$var$outlineWidth = 2;
const $73c221919444c9a0$export$ffb3e5c7f83e1d2f = /*#__PURE__*/ (0, $cStGJ.default)((0, $kPBHE.Link), {
    target: "e1fpfwrr1"
})((props)=>({
        alignItems: 'center',
        color: `var(--ds-text, ${0, $6fnsQ.N900})`,
        cursor: 'pointer',
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        padding: `${"var(--ds-space-075, 6px)"} ${16 - $73c221919444c9a0$var$outlineWidth}px`,
        border: `${$73c221919444c9a0$var$outlineWidth}px solid transparent`,
        '&:hover': {
            color: `var(--ds-text, ${0, $6fnsQ.N900})`,
            backgroundColor: `var(--ds-background-neutral, ${0, $6fnsQ.N20})`,
            textDecoration: 'none'
        },
        '&:visited': {
            color: `var(--ds-text, ${0, $6fnsQ.N900})`
        },
        '&:focus': {
            outline: 'none',
            border: `${$73c221919444c9a0$var$outlineWidth}px solid ${`var(--ds-border-focused, ${0, $6fnsQ.B100})`}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? `var(--ds-background-neutral, ${0, $6fnsQ.N20})` : `var(--ds-background-neutral-subtle, ${0, $6fnsQ.N0})`
    }));
const $73c221919444c9a0$export$aa7c31826bbddc7b = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1fpfwrr0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $2hEyf.fontFallback).body.medium})`,
    paddingLeft: "var(--ds-space-200, 16px)",
    display: 'flex',
    alignItems: 'center'
});
module.exports["CenteredAdvancedSearchGroup"] = $73c221919444c9a0$export$5d708f1c4bba7ac3;
module.exports["StyledAdvancedSearch"] = $73c221919444c9a0$export$ffb3e5c7f83e1d2f;
module.exports["AdvancedSearchContent"] = $73c221919444c9a0$export$aa7c31826bbddc7b;

});

parcelRegister("ingNj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1e55472238d050e$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $jiwai = parcelRequire("jiwai");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $3S0fp = parcelRequire("3S0fp");


var $5dFS9 = parcelRequire("5dFS9");


var $6dP89 = parcelRequire("6dP89");


var $bF0iL = parcelRequire("bF0iL");

const $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES = 5;
const $a1e55472238d050e$var$getActionSubjectIdForProduct = (product)=>{
    return `${product.toLowerCase()}AdvancedSearchLink`;
};
const $a1e55472238d050e$export$c1abbe883cc8875 = ({ workspaces: workspaces, linkComponent: linkComponent, onClick: onClick, isLoading: isLoading, intl: intl })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const links = workspaces.map((workspace)=>({
            content: workspace.content,
            key: workspace.key,
            href: workspace.advancedSearchUrl
        }));
    const label = intl.formatMessage((0, $bF0iL.messages).multi_site_advanced_search_label);
    const dropdownLabel = intl.formatMessage((0, $bF0iL.messages).multi_site_advanced_search_more_dropdown, {
        count: links.length - $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES
    });
    const onAdvancedSearchClicked = (0, $42omo.useCallback)(({ key: key }, e)=>{
        const workspace = workspaces.filter((w)=>w.key === key)[0];
        if (!workspace) return;
        fireAnalyticsEvent((0, $5dFS9.onMultiSiteAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: $a1e55472238d050e$var$getActionSubjectIdForProduct(workspace.product),
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e),
            destinationId: key,
            index: workspaces.map((w)=>w.key).indexOf(key)
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        workspaces
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jiwai.SearchFooterLinks), {
        linkComponent: linkComponent,
        onClick: (link, e)=>{
            onAdvancedSearchClicked(link, e);
            onClick && onClick(link.href, e);
        },
        label: label,
        dropdownTriggerLabel: dropdownLabel,
        links: links,
        maxPrimaryLinks: $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES
    });
};
var $a1e55472238d050e$export$2e2bcd8739ae039 = (0, $gmMgo.default)($a1e55472238d050e$export$c1abbe883cc8875);

});

parcelRegister("e1ib8", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $f92b14cfe6710408$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    /**
   * Extensible
   */ extensible_advanced_search_footer: {
        id: "extensible_search_dialog.advanced_search",
        defaultMessage: "Advanced search"
    },
    extensible_advanced_search_cross_product_footer: {
        id: "extensible_search_dialog.advanced_search_all_apps",
        defaultMessage: "Search all apps"
    },
    extensible_connect_to: {
        id: "extensible_search_dialog.connect_to",
        defaultMessage: "Connect to"
    },
    extensible_connect: {
        id: "extensible_search_dialog.connect",
        defaultMessage: "Connect"
    },
    more: {
        id: "extensible_search_dialog.more",
        defaultMessage: "+ more"
    }
});
module.exports["messages"] = $f92b14cfe6710408$export$defe85febe8b728c;

});

parcelRegister("ju7KJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

function $27d3f42c4140793d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $27d3f42c4140793d$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "er9v89y2"
})({
    name: "15currb",
    styles: "display:flex;height:100%"
});
const $27d3f42c4140793d$export$85cc5ece3620f7ef = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "er9v89y1"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    gap: "var(--ds-space-025, 2px)",
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N90)})`
});
const $27d3f42c4140793d$export$db59656b68ced4b = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "er9v89y0"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`,
    padding: `0px ${"var(--ds-space-025, 2px)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
module.exports["ContentWrapper"] = $27d3f42c4140793d$export$6ce170286acaa8d3;
module.exports["SearchFooterLabelWrapper"] = $27d3f42c4140793d$export$85cc5ece3620f7ef;
module.exports["SearchFooterLabel"] = $27d3f42c4140793d$export$db59656b68ced4b;

});

parcelRegister("f0f3d", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $iBckn = parcelRequire("iBckn");


var $k1wrx = parcelRequire("k1wrx");


var $a5cba = parcelRequire("a5cba");


var $bF0iL = parcelRequire("bF0iL");


var $dDSTM = parcelRequire("dDSTM");


var $8ioQN = parcelRequire("8ioQN");


var $1WJaw = parcelRequire("1WJaw");


var $cnoUz = parcelRequire("cnoUz");


var $20N1w = parcelRequire("20N1w");


var $1OS8u = parcelRequire("1OS8u");


var $axxOe = parcelRequire("axxOe");


var $clOud = parcelRequire("clOud");


var $1x1dO = parcelRequire("1x1dO");


var $ktwn8 = parcelRequire("ktwn8");


var $iEwUU = parcelRequire("iEwUU");


var $5yZy1 = parcelRequire("5yZy1");


var $91yhh = parcelRequire("91yhh");


var $bK7ak = parcelRequire("bK7ak");


var $amrMu = parcelRequire("amrMu");

const $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c = {
    Confluence: 'confluence',
    Atlas: 'townsquare'
};
const $5393c5baf4aba6f7$export$a55448378aa900a7 = ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $k1wrx.EnlargedSearchResultContent), {
            ...searchResult,
            isKeyboardHighlighted: isKeyboardHighlighted,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(searchResult.icon) ? searchResult.icon : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {})
        })
    });
};
const $5393c5baf4aba6f7$export$1763eeb490def9b = ({ onRetry: onRetry, linkComponent: linkComponent, confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, onPreQueryErrorCallback: onPreQueryErrorCallback, cloudId: cloudId, orgId: orgId, primaryProduct: primaryProduct })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const features = (0, $amrMu.useFeaturesContext)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const appendAnalyticsQueryParams = (0, $bK7ak.useQueryParams)();
    const appendQueryParams = primaryProduct === 'confluence' ? appendAnalyticsQueryParams : undefined;
    const preQueryItemSupplier = (0, $iBckn.useQuickFindItemSupplier)({
        confCloudClient: confCloudClient,
        aggAbsoluteUrl: aggAbsoluteUrl,
        markErrorAsHandled: onPreQueryErrorCallback,
        itemRenderer: $5393c5baf4aba6f7$export$a55448378aa900a7,
        recentContentResultMapper: (0, $1OS8u.quickFindRecentItemResultMapper),
        recentSpaceResultMapper: (0, $axxOe.quickFindRecentSpaceResultMapper),
        userId: user.id,
        cloudId: cloudId
    });
    // This currently isn't being used for results fetching or rendering. It is
    // only being used to create an array of sections which are then used for
    // product registration. After product registration, these scopes are then
    // used to call the experiment endpoint, for this reason they need to be
    // valid scopes for each product.
    const defaultSections = (0, $42omo.useMemo)(()=>{
        switch(primaryProduct){
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence:
                return [
                    {
                        id: 'confluence.page',
                        title: ''
                    }
                ];
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas:
                return [
                    {
                        id: 'townsquare.goal',
                        title: ''
                    }
                ];
            default:
                return [];
        }
    }, [
        primaryProduct
    ]);
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const quickFindPeopleAndTeamsResultMapper = (0, $clOud.getQuickFindPeopleAndTeamsResultMapper)(primaryProduct, orgId || '', cloudId);
    const quickFindPostQueryItemSupplier = (0, $iBckn.useQuickFindPostQueryItemSupplier)({
        cloudId: cloudId,
        resultRenderer: $5393c5baf4aba6f7$export$a55448378aa900a7,
        confluenceResultMapper: (0, $ktwn8.quickFindConfluenceContentMapper),
        atlasResultMapper: (0, $5yZy1.quickFindAtlasContentMapper),
        spaceResultMapper: (0, $1x1dO.quickFindConfluenceSpaceMapper),
        peopleAndTeamsResultMapper: quickFindPeopleAndTeamsResultMapper,
        sectionTitle: formatMessage((0, $dDSTM.messages).quick_find_results_section),
        userId: user.id,
        orgId: orgId,
        aggAbsoluteUrl: aggAbsoluteUrl,
        primaryProduct: primaryProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId
            }))
    });
    const noResultsPostQueryItemSupplier = (0, $42omo.useCallback)(()=>Promise.resolve((0, $8ioQN.EMPTY_SEARCH_ITEMS)), []);
    const postQueryItemSupplier = features?.quickFind?.postQueryDisabled ? noResultsPostQueryItemSupplier : quickFindPostQueryItemSupplier;
    // TODO: baseUrl is a holdover from QS and not needed in QF
    const generateAdvancedSearchUrl = (0, $42omo.useCallback)((query, baseUrl, usage)=>{
        let url = '';
        const params = new URLSearchParams();
        const trimmedQuery = query.trim();
        if (trimmedQuery) params.append('text', trimmedQuery);
        if (primaryProduct === $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence) {
            url = '/wiki/search/';
            if (usage === 'onInputEnterModified') params.append('product', 'confluence');
        } else if (orgId && primaryProduct === $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas) {
            url = `/o/${orgId}/search/`;
            params.append('cloudId', cloudId);
        }
        // URLSearchParams's toString will do encode special characters, however spaces
        // are encoded as +. We need to replace them with %20 to match existing behaviour.
        url += `?${params.toString()}`;
        url = url.replace(/\+/g, '%20');
        return url;
    }, [
        cloudId,
        orgId,
        primaryProduct
    ]);
    const title = (0, $42omo.useMemo)(()=>{
        switch(primaryProduct){
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence:
                return formatMessage((0, $bF0iL.messages).confluence_tab_label);
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas:
                return formatMessage((0, $bF0iL.messages).atlas_tab_label);
            default:
                return '';
        }
    }, [
        formatMessage,
        primaryProduct
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5cba.SearchDialogProduct), {
        permissionSupplier: ()=>Promise.resolve(defaultSections.map((s)=>s.id)),
        sections: defaultSections,
        id: primaryProduct,
        title: title,
        order: 0,
        expandedStateInputPlaceholder: formatMessage((0, $dDSTM.messages).quick_find_search_input_placeholder),
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier,
        onRetry: onRetry,
        ResultRenderer: (0, $1WJaw.QuickFindResultRenderer),
        SearchItemsTransformer: (0, $cnoUz.QuickFindConfluenceTransformer),
        isPrefetchingEnabled: true,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        searchFooterLabel: 'Search your organization',
        linkComponent: linkComponent,
        appendQueryParams: appendQueryParams
    });
};
module.exports["ProductKeys"] = $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c;

});

parcelRegister("6kOEz", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $7193e24f5ddd050a$export$76bfbab5e3f9a6a3 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });
module.exports["CommandIcon"] = $7193e24f5ddd050a$export$76bfbab5e3f9a6a3;

});

parcelRegister("hFUff", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $d8b813963b40dde9$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    height: '20px',
    borderRadius: 'radius.xsmall',
    border: `${"var(--ds-border-width, 1px)"} solid transparent`,
    color: 'color.text.subtle',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.050',
    paddingBlock: '0'
});
const $d8b813963b40dde9$export$1de95e9d7dda5112 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $d8b813963b40dde9$var$iconStyles,
        children: "Ctrl"
    });
module.exports["ControlIcon"] = $d8b813963b40dde9$export$1de95e9d7dda5112;

});

parcelRegister("5uL5H", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $d6b1539a23a3e88d$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });
module.exports["SquareReturnIcon"] = $d6b1539a23a3e88d$export$4501fc029b186da8;

});

parcelRegister("dfZ5P", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $89d26229a3844411$export$6382847193091a26 = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.185 7.4 12 10.585 8.815 7.399a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.7-.7a.496.496 0 0 0 .004-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.507.507 0 0 0-.36-.153.5.5 0 0 0-.353.15h-.001Z",
            fill: "var(--ds-icon, #44546F)"
        })
    });
module.exports["RemoveIcon"] = $89d26229a3844411$export$6382847193091a26;

});

parcelRegister("jqsW9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $247b5da4c2bbf48f$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });
module.exports["SquareReturnIcon"] = $247b5da4c2bbf48f$export$4501fc029b186da8;

});

parcelRegister("68Mwd", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $23def8654352e503$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    remove_button_label: {
        id: "search_dialog.results.remove_button_label",
        defaultMessage: "Remove this."
    }
});
module.exports["messages"] = $23def8654352e503$export$defe85febe8b728c;

});

parcelRegister("dJB5H", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $kevJM = parcelRequire("kevJM");


var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

function $54104dff0de2abd7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $54104dff0de2abd7$var$IconContainer = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "eao5nkl0"
})({
    name: "1kyddlo",
    styles: "margin-left:var(--ds-space-negative-025, -2px);margin-top:var(--ds-space-025, 2px)"
});
const $54104dff0de2abd7$export$d206ce4c12e8ddf6 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($54104dff0de2abd7$var$IconContainer, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            color: `var(--ds-icon-accent-gray, ${(0, $6fnsQ.N600)})`,
            spacing: "spacious",
            label: "recent-search"
        })
    });
module.exports["DefaultIcon"] = $54104dff0de2abd7$export$d206ce4c12e8ddf6;

});

parcelRegister("jiwai", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $42omo = parcelRequire("42omo");


var $7ujO6 = parcelRequire("7ujO6");


var $DXuE9 = parcelRequire("DXuE9");


const $aa4a78fb49270be5$var$DropDownLinks = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("92OBo")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS = 5;
const $aa4a78fb49270be5$export$697ca8c8f8bb38fc = ({ label: label, links: links, dropdownTriggerLabel: dropdownTriggerLabel, onClick: onClick, linkComponent: linkComponent, maxPrimaryLinks: maxPrimaryLinks })=>{
    const primaryLinks = links.slice(0, maxPrimaryLinks || $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS);
    const dropdownLinks = links.slice(maxPrimaryLinks || $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS, links.length);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $DXuE9.SearchFooterLinksContainer), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $DXuE9.LabelContainer), {
                children: label
            }),
            primaryLinks.map((link)=>{
                const { key: key, href: href, content: content } = link;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $DXuE9.PrimaryButtonWrapper), {
                    onClick: (e)=>onClick && onClick(link, e),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $DXuE9.PrimaryButtonStyledLink), {
                        href: href,
                        linkComponent: linkComponent,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                            content: content,
                            tag: (0, $7ujO6.ForwardedRefToolTipTag),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                spacing: "compact",
                                tabIndex: -1,
                                children: content
                            })
                        })
                    })
                }, key);
            }),
            dropdownLinks && dropdownLinks.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)($aa4a78fb49270be5$var$DropDownLinks, {
                    dropdownLinks: dropdownLinks,
                    dropdownTriggerLabel: dropdownTriggerLabel,
                    onClick: onClick,
                    linkComponent: linkComponent
                })
            }) : null
        ]
    });
};
module.exports["SearchFooterLinks"] = $aa4a78fb49270be5$export$697ca8c8f8bb38fc;

});

parcelRegister("a5cba", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $5UXzK = parcelRequire("5UXzK");


var $dByQx = parcelRequire("dByQx");


var $gF7Az = parcelRequire("gF7Az");


var $7a9pa = parcelRequire("7a9pa");


var $1e3Dw = parcelRequire("1e3Dw");


var $7qNFx = parcelRequire("7qNFx");

const $37edf39650c77c6a$var$Wrapper = ({ children: children, order: order })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        id: `${(0, $7qNFx.TAB_ID)}-${order}-tab`,
        children: children
    });
const $37edf39650c77c6a$export$bea8d7c130bb15c8 = ({ generateAdvancedSearchUrl: genUrl, ...rest })=>{
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const generateAdvancedSearchUrl = (0, $1e3Dw.useGenerateAdvancedSearchUrl)(genUrl);
    const props = {
        ...rest,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl
    };
    return(// wrap it in a container to add panel ID corresponding to the tab header
    /*#__PURE__*/ (0, $l998X.jsx)($37edf39650c77c6a$var$Wrapper, {
        order: props.order,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dByQx.default), {
            ...props,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5UXzK.AsyncProduct), {
                ...props,
                fallback: !isExpanded ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}) : undefined,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7a9pa.AsyncProvider), {
                    ...props
                })
            })
        })
    }));
};
module.exports["SearchDialogProduct"] = $37edf39650c77c6a$export$bea8d7c130bb15c8;

});

parcelRegister("1WJaw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $exgPf = parcelRequire("exgPf");

var $bO2XA = parcelRequire("bO2XA");

var $2LczZ = parcelRequire("2LczZ");


var $42omo = parcelRequire("42omo");


var $jFPud = parcelRequire("jFPud");


var $kPY5t = parcelRequire("kPY5t");


var $kUZlH = parcelRequire("kUZlH");


var $iN7gh = parcelRequire("iN7gh");


var $kf2EW = parcelRequire("kf2EW");


var $kTE07 = parcelRequire("kTE07");


var $gtD4K = parcelRequire("gtD4K");


var $dDSTM = parcelRequire("dDSTM");


var $4Lm6U = parcelRequire("4Lm6U");


var $2hOQY = parcelRequire("2hOQY");


var $fJRVo = parcelRequire("fJRVo");


var $hyKIh = parcelRequire("hyKIh");


var $cGCOz = parcelRequire("cGCOz");


var $f0f3d = parcelRequire("f0f3d");


var $7OZuO = parcelRequire("7OZuO");


var $4ldrV = parcelRequire("4ldrV");


var $2OcMi = parcelRequire("2OcMi");

const $1eb9e7406142d7a1$export$6e27f80792772bd6 = ({ productState: productState, preQueryItems: preQueryItems, postQueryItems: postQueryItems, linkComponent: linkComponent, appendQueryParams: appendQueryParams, onRetryPreQuery: onRetryPreQuery, onRetryPostQuery: onRetryPostQuery })=>{
    const isMobileView = (0, $kPY5t.useIsMobileView)();
    const { isRovoEnabled: isRovoEnabled } = (0, $cGCOz.useRovoContext)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const productId = activeProduct?.id;
    const renderResults = (0, $42omo.useCallback)(()=>{
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
            case (0, $jFPud.ProductStates).PreQueryLoading:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: preQueryItems,
                    linkComponent: linkComponent,
                    screen: "preQuerySearchResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
            case (0, $jFPud.ProductStates).PreQueryNoResult:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $kTE07.PreQueryEmptyScreen), {});
            case (0, $jFPud.ProductStates).PreQueryError:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $4Lm6U.SearchErrorScreen), {
                    onRetry: onRetryPreQuery
                });
            case (0, $jFPud.ProductStates).PostQueryTyping:
            case (0, $jFPud.ProductStates).PostQueryLoading:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    linkComponent: linkComponent,
                    screen: "cachedResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bO2XA.EnlargedSearchResultSection), {
                        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $dDSTM.messages).quick_find_search_results
                        }),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {})
                        ]
                    })
                });
            case (0, $jFPud.ProductStates).PostQueryError:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $4Lm6U.SearchErrorScreen), {
                    onRetry: onRetryPostQuery
                });
            case (0, $jFPud.ProductStates).PostQueryNoResult:
                const urlGeneratorForNoResultsScreen = (query)=>{
                    const generateUrl = activeProduct?.generateAdvancedSearchUrl || (()=>'');
                    const advancedSearchUrl = generateUrl(query);
                    return (0, $2OcMi.addQuery)(advancedSearchUrl, 'search_id', searchSessionId);
                };
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $7OZuO.default), {
                    urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
                    fromQuickFindPostQueryNoResults: true
                });
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    linkComponent: linkComponent,
                    screen: "postQuerySearchResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
        }
    }, [
        productState,
        preQueryItems,
        linkComponent,
        isMobileView,
        appendQueryParams,
        postQueryItems,
        onRetryPreQuery,
        onRetryPostQuery,
        activeProduct?.generateAdvancedSearchUrl,
        searchSessionId
    ]);
    const showSearchFooter = productState === (0, $jFPud.ProductStates).PreQuerySuccess || productState === (0, $jFPud.ProductStates).PreQueryLoading || productState === (0, $jFPud.ProductStates).PreQueryNoResult || productId === (0, $f0f3d.ProductKeys).Confluence && (productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult);
    const showFilterFooter = productId === (0, $f0f3d.ProductKeys).Confluence && (productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult);
    const showFeedbackFooter = productState === (0, $jFPud.ProductStates).PreQuerySuccess || productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            isRovoEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $hyKIh.QuickFindRovoTip), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.SearchDialogContent), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.ResultContainerOuter), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.ResultContainer), {
                        "aria-live": "polite",
                        children: renderResults()
                    })
                })
            }),
            showSearchFooter && productId === (0, $f0f3d.ProductKeys).Confluence ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2hOQY.SearchFooterPersistRecentSearch), {
                linkComponent: linkComponent
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $2hOQY.SearchFooter), {
                linkComponent: linkComponent
            }),
            showFilterFooter && /*#__PURE__*/ (0, $l998X.jsx)((0, $iN7gh.FilterFooter), {}),
            showFeedbackFooter && /*#__PURE__*/ (0, $l998X.jsx)((0, $kf2EW.FeedbackFooter), {})
        ]
    });
};
module.exports["QuickFindResultRenderer"] = $1eb9e7406142d7a1$export$6e27f80792772bd6;

});

parcelRegister("cnoUz", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bySHO = parcelRequire("bySHO");


var $lqMdf = parcelRequire("lqMdf");


var $7mejp = parcelRequire("7mejp");


var $791Lz = parcelRequire("791Lz");


var $2IGSl = parcelRequire("2IGSl");


var $a57V3 = parcelRequire("a57V3");

const $704a874b96428859$export$d1cc89207db04ec4 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bySHO.PreQueryFilterTransformer), {
        ...rest,
        children: (args)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lqMdf.PreQueryRecentlyViewedTransformer), {
                ...args,
                children: (args)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7mejp.RecentSearchesTransformer), {
                        ...args,
                        children: (args)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $791Lz.QueryFilterTransformer), {
                                ...args,
                                children: (args)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2IGSl.PostQueryRecentlyViewedTransformer), {
                                        ...args,
                                        children: (args)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a57V3.DeduplicateRecentlyViewedAndResultsTransformer), {
                                                ...args,
                                                children: (args)=>children(args)
                                            })
                                    })
                            })
                    })
            })
    });
};
module.exports["QuickFindConfluenceTransformer"] = $704a874b96428859$export$d1cc89207db04ec4;

});

parcelRegister("1OS8u", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $hWR4v = parcelRequire("hWR4v");


var $5nBzc = parcelRequire("5nBzc");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $DuEDb = parcelRequire("DuEDb");


var $dDSTM = parcelRequire("dDSTM");


var $8PrAH = parcelRequire("8PrAH");


var $kOyOy = parcelRequire("kOyOy");


var $j7mwp = parcelRequire("j7mwp");

const $47e0642ad89da657$var$CONTEXT_PATH = '/wiki';
const $47e0642ad89da657$var$labelStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.050'
});
const $47e0642ad89da657$export$1aadfab314f9e7ce = (edge)=>{
    const item = edge.node;
    const data = item.object.data;
    const productType = item.object.product;
    switch(productType){
        case (0, $hWR4v.ActivityProduct).JIRA:
            return {
                id: item.object.id,
                title: `${data?.key}: ${(data?.fieldsById?.edges || [
                    {}
                ])[0].node?.text}` || '',
                url: data?.webUrl || '',
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: 'jira',
                    title: data?.title
                }),
                meta: /*#__PURE__*/ (0, $l998X.jsx)((0, $j7mwp.QuickFindResultMeta), {
                    meta: [
                        'Jira',
                        (0, $j7mwp.capitalizeFirstLetter)(item.object.type)
                    ]
                }),
                additionalMeta: /*#__PURE__*/ (0, $l998X.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`
            };
        case (0, $hWR4v.ActivityProduct).CONFLUENCE:
            // Do NOT show drafts for live-edit pages since they're not drafts from a user perspective
            const isDraft = (data?.pageStatus === 'DRAFT' || data?.blogStatus === 'DRAFT') && data?.subtype !== 'LIVE';
            return {
                ari: item.object.id,
                id: item.object.id,
                title: data?.title || '',
                url: `${data?.links?.base || $47e0642ad89da657$var$CONTEXT_PATH}${data?.links?.webUi}`,
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: item.object.type,
                    title: data?.title,
                    isDraft: isDraft
                }),
                label: isDraft ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $47e0642ad89da657$var$labelStyles,
                    as: "span",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $dDSTM.messages).quick_find_recent_draft_label
                        })
                    })
                }) : '',
                meta: /*#__PURE__*/ (0, $l998X.jsx)((0, $kOyOy.ConfluenceResultMeta), {
                    resultContentType: item.object.type,
                    resultAncestors: data?.ancestors,
                    resultSpace: data?.space
                }),
                additionalMeta: /*#__PURE__*/ (0, $l998X.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`,
                containerId: data?.space?.id || undefined
            };
        case (0, $hWR4v.ActivityProduct).ATLAS:
            return {
                id: item.object.id,
                title: `${data?.name}` || '',
                url: data?.url || '',
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: 'atlas',
                    imageSrc: data?.iconData || '',
                    title: data?.title
                }),
                meta: /*#__PURE__*/ (0, $l998X.jsx)((0, $j7mwp.QuickFindResultMeta), {
                    meta: [
                        (0, $j7mwp.capitalizeFirstLetter)(item.object.type),
                        data?.key
                    ]
                }),
                additionalMeta: /*#__PURE__*/ (0, $l998X.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`
            };
        default:
            return {
                id: '',
                title: '',
                url: '',
                icon: '',
                meta: ''
            };
    }
};
module.exports["quickFindRecentItemResultMapper"] = $47e0642ad89da657$export$1aadfab314f9e7ce;

});

parcelRegister("axxOe", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $dDSTM = parcelRequire("dDSTM");

const $c38d98a6d1a1036a$var$negativeMarginStyles = (0, $ecnYn.xcss)({
    margin: 'space.negative.025'
});
const $c38d98a6d1a1036a$var$CONTEXT_PATH = '/wiki';
const $c38d98a6d1a1036a$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
        xcss: $c38d98a6d1a1036a$var$negativeMarginStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        })
    });
const $c38d98a6d1a1036a$export$d04e5b6d01e34c3 = (item)=>({
        id: item?.id || '',
        title: item?.name || '',
        meta: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $dDSTM.messages).quick_find_confluence_space
        }),
        additionalMeta: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $dDSTM.messages).quick_find_recent_spaces_additional_meta
        }),
        url: `${$c38d98a6d1a1036a$var$CONTEXT_PATH}${item?.links?.webui || ''}`,
        containerId: item?.id || undefined,
        icon: $c38d98a6d1a1036a$export$e5d849fb708254a9({
            iconUrl: `${$c38d98a6d1a1036a$var$CONTEXT_PATH}${item?.icon?.path || ''}`,
            size: 'small'
        }),
        isRecentResult: true,
        type: 'confluence space'
    });
module.exports["quickFindRecentSpaceResultMapper"] = $c38d98a6d1a1036a$export$d04e5b6d01e34c3;

});

parcelRegister("clOud", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $8PrAH = parcelRequire("8PrAH");


var $dDSTM = parcelRequire("dDSTM");


var $aU479 = parcelRequire("aU479");

const $9ebe45aba70c0c63$export$dbdea3e42644cff8 = (primaryProduct, orgId, cloudId)=>{
    return (result)=>{
        if (result.type === 'team') return {
            title: result.name,
            id: result.id,
            type: result.type,
            meta: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $dDSTM.messages).quick_find_results_team
            }),
            url: `${window.location.origin}${(0, $aU479.getTeamPath)(result.id, primaryProduct, orgId, cloudId)}`,
            icon: (0, $8PrAH.GenericIconRenderer)({
                iconUrl: result.avatarUrl
            })
        };
        else return {
            title: result.name,
            id: result.id,
            type: result.type,
            meta: result.title || '',
            url: `${window.location.origin}${(0, $aU479.getUserPath)(result.id, primaryProduct, orgId, cloudId)}`,
            icon: (0, $8PrAH.GenericIconRenderer)({
                iconUrl: result.avatarUrl,
                appearance: 'circle'
            })
        };
    };
};
module.exports["getQuickFindPeopleAndTeamsResultMapper"] = $9ebe45aba70c0c63$export$dbdea3e42644cff8;

});

parcelRegister("1x1dO", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dDSTM = parcelRequire("dDSTM");


var $lNtmT = parcelRequire("lNtmT");


var $8PrAH = parcelRequire("8PrAH");

const $8bf0db52976a1541$export$831f92f4f63a8807 = ({ node: item })=>{
    return {
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: item?.title || '',
        meta: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $dDSTM.messages).quick_find_confluence_space
        }),
        url: item?.url || '',
        type: 'confluence space',
        containerId: item?.id,
        icon: (0, $8PrAH.GenericIconRenderer)({
            iconUrl: `/wiki${item?.iconPath || ''}`,
            size: 'small'
        })
    };
};
module.exports["quickFindConfluenceSpaceMapper"] = $8bf0db52976a1541$export$831f92f4f63a8807;

});

parcelRegister("ktwn8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8PrAH = parcelRequire("8PrAH");


var $lNtmT = parcelRequire("lNtmT");


var $kOyOy = parcelRequire("kOyOy");


var $DuEDb = parcelRequire("DuEDb");

const $df95e20809de4e37$export$6a180a233e580286 = ({ node: item })=>{
    return {
        ari: item?.id,
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: item?.title || '',
        url: item?.url || '',
        meta: /*#__PURE__*/ (0, $l998X.jsx)((0, $kOyOy.ConfluenceResultMeta), {
            resultContentType: item?.type || '',
            resultAncestors: item?.confluenceEntity?.ancestors,
            resultSpace: item?.space
        }),
        additionalMeta: item?.lastModified ? /*#__PURE__*/ (0, $l998X.jsx)((0, $DuEDb.EventTypeMessage), {
            timestamp: item.lastModified,
            eventType: (0, $DuEDb.WORKED_EVENT).UPDATED,
            isMyActivityData: false
        }) : '',
        containerId: (0, $lNtmT.transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
        type: `confluence ${item?.type}` || '',
        icon: (0, $8PrAH.ContentIconRenderer)({
            type: item?.type || '',
            title: item?.title
        })
    };
};
module.exports["quickFindConfluenceContentMapper"] = $df95e20809de4e37$export$6a180a233e580286;

});

parcelRegister("5yZy1", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7jIfa = parcelRequire("7jIfa");


var $lNtmT = parcelRequire("lNtmT");


var $gj7hi = parcelRequire("gj7hi");


var $j7mwp = parcelRequire("j7mwp");

const $d6ae9f5288c13a0d$var$getIcon = (result)=>{
    return result?.iconUrl ? // eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details
    /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
        height: 24,
        width: 24,
        title: result.type,
        src: result.iconUrl
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
};
const $d6ae9f5288c13a0d$var$getKey = (item)=>{
    if ((0, $7jIfa.isSearchResultAtlasProjectPartial)(item)) return item.project?.key;
    else if ((0, $7jIfa.isSearchResultAtlasGoalPartial)(item)) return item.goal?.key;
    else return null;
};
const $d6ae9f5288c13a0d$var$getTitle = (item)=>{
    if (!item) return '';
    let entityKey = $d6ae9f5288c13a0d$var$getKey(item);
    if (entityKey) return `${entityKey}: ${item.title || ''}`;
    return item.title || '';
};
const $d6ae9f5288c13a0d$export$92506b66b43d2a63 = ({ node: item })=>{
    return {
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: $d6ae9f5288c13a0d$var$getTitle(item),
        url: item?.url || '',
        meta: (0, $j7mwp.capitalizeFirstLetter)(item?.type || ''),
        additionalMeta: '',
        containerId: '',
        type: `atlas ${item?.type}` || '',
        icon: $d6ae9f5288c13a0d$var$getIcon(item)
    };
};
module.exports["quickFindAtlasContentMapper"] = $d6ae9f5288c13a0d$export$92506b66b43d2a63;

});

parcelRegister("bK7ak", function(module, exports) {

var $UNGcJ = parcelRequire("UNGcJ");


var $2OcMi = parcelRequire("2OcMi");


var $2ZIpG = parcelRequire("2ZIpG");

const $493c216466d2aa05$export$b37ee0d76c6d2fbc = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    return (url, searchSessionId, type, resultId, additionalAnalytics)=>{
        // legacy QF/QS have different types/have confluence prefixed or not
        return (0, $UNGcJ.transformAnalyticsToQueryParam)({
            query: query,
            url: url,
            searchSessionId: searchSessionId,
            additionalAnalytics: additionalAnalytics,
            resultId: resultId,
            type: type,
            addQueryParams: $2OcMi.addQueryParams,
            addQuery: $2OcMi.addQuery
        });
    };
};
module.exports["useQueryParams"] = $493c216466d2aa05$export$b37ee0d76c6d2fbc;

});

parcelRegister("5UXzK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7prbm = parcelRequire("7prbm");


var $2jYn8 = parcelRequire("2jYn8");


var $fJRVo = parcelRequire("fJRVo");


var $cpIJW = parcelRequire("cpIJW");


var $bBxPo = parcelRequire("bBxPo");

class $b2233dbfbf7baa26$export$6bc62c4e30aa3c0a extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentWillUnmount() {
        const { removeProduct: removeProduct, id: id } = this.props;
        removeProduct(id);
    }
    render() {
        const { fallback: FallbackComponent, id: id, children: children } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $bBxPo.ActiveProduct), {
                id: id,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7prbm.TimeLazyLoad), {
                    product: id,
                    children: FallbackComponent ? /*#__PURE__*/ (0, $l998X.jsx)(FallbackComponent, {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $2jYn8.LoadingSpinner), {})
                })
            }),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $cpIJW.InitialisationExperienceSuccess), {
                    ...this.props
                }),
                children
            ]
        });
    }
}
const $b2233dbfbf7baa26$export$ea887de8bd536d84 = (0, $fJRVo.withProductContext)($b2233dbfbf7baa26$export$6bc62c4e30aa3c0a);
module.exports["AsyncProduct"] = $b2233dbfbf7baa26$export$ea887de8bd536d84;

});

parcelRegister("dByQx", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ab33f74cad490ac$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gJKpQ = parcelRequire("gJKpQ");


var $kmpep = parcelRequire("kmpep");


var $fJRVo = parcelRequire("fJRVo");


var $e0qNw = parcelRequire("e0qNw");

const $0ab33f74cad490ac$export$8e8702b7c6f58328 = ({ children: children, permissionSupplier: permissionSupplier, id: id, title: title, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter })=>{
    const invokePostQuerySearchRef = (0, $42omo.useRef)(()=>{});
    const [allowedSections, setAllowedSections] = (0, $42omo.useState)([]);
    const searchClient = (0, $kmpep.useAggregatorClient)();
    (0, $42omo.useEffect)(()=>{
        if (allowedSections.length === 0) {
            // For Jira we need to improve performance by not rendering all the search dialog tabs before the
            // dialog is expanded. However, in order to ensure that the search component is interactive there needs
            // to be at least one allowed section. This test is a workaround to ensure that when there is only this
            // single dummy section that it is included without a permission check. This hook will be called again
            // when the search dialog is expanded and the real sections are provided.
            if (sections.length === 1 && sections[0].id === $0ab33f74cad490ac$export$d56c05d9b1186628) {
                setAllowedSections([
                    $0ab33f74cad490ac$export$d56c05d9b1186628
                ]);
                return;
            } else {
                const promise = permissionSupplier ? permissionSupplier() : searchClient ? searchClient.batchedGetExtensibleProductPermission(id, {
                    productIds: [
                        id
                    ],
                    experience: (0, $gJKpQ.PLACEHOLDER_EXPERIENCE)
                }) : Promise.resolve([]);
                promise.then((response)=>{
                    setAllowedSections(response);
                });
            }
        }
    /**
		 * We want to replicate componentDidMount behaviour to avoid invoking the API multiple times and we don't care if any other deps changed.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return allowedSections.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0qNw.default), {
            allowedSections: allowedSections,
            sections: sections,
            id: id,
            title: title,
            order: order,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            expandedStateInputPlaceholder: expandedStateInputPlaceholder,
            workspaces: workspaces,
            autocorrectEnabled: autocorrectEnabled,
            showViewAllFiltersLink: showViewAllFiltersLink,
            tabRenderer: tabRenderer,
            aiSearchConfig: aiSearchConfig,
            showSearchOnEnter: showSearchOnEnter,
            invokePostQuerySearchRef: invokePostQuerySearchRef,
            children: children
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
};
const $0ab33f74cad490ac$export$d56c05d9b1186628 = '__PERFORMANCE_IMPROVEMENT_DUMMY_SECTION__';
var $0ab33f74cad490ac$export$2e2bcd8739ae039 = (0, $fJRVo.withProductContext)($0ab33f74cad490ac$export$8e8702b7c6f58328);

});

parcelRegister("7a9pa", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $298df496b78eadc8$var$AsyncResultProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("jTYcx")).then(({ ResultProvider: ResultProvider })=>({
            default: ResultProvider
        })));
const $298df496b78eadc8$export$2f9c5c9733d48598 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($298df496b78eadc8$var$AsyncResultProvider, {
        ...props,
        children: props.children
    });
module.exports["AsyncProvider"] = $298df496b78eadc8$export$2f9c5c9733d48598;

});

parcelRegister("1e3Dw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $amrMu = parcelRequire("amrMu");


var $4wMwH = parcelRequire("4wMwH");

const $d3fd384d52c00b18$export$25a2b20022e2a01a = (genUrl)=>{
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    return (0, $42omo.useCallback)((query, baseUrl, usage)=>{
        const advancedSearchUrl = genUrl?.(query, baseUrl, usage) || '';
        if (isGriffinNavEnabled) {
            const urlParts = advancedSearchUrl.split('?');
            // Omit text and originalQuery from the query params
            // originalQuery is used to support AutoCorrection in FPS and we don't want it
            // to persist between search queries
            const { text: text, originalQuery: originalQuery, ...rest } = queryParams || {};
            return `${urlParts[0]}?${new URLSearchParams({
                ...rest,
                ...query !== '' && {
                    text: query
                }
            }).toString()}`;
        }
        return advancedSearchUrl;
    }, [
        genUrl,
        isGriffinNavEnabled,
        queryParams
    ]);
};
module.exports["useGenerateAdvancedSearchUrl"] = $d3fd384d52c00b18$export$25a2b20022e2a01a;

});

parcelRegister("7qNFx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4A7Gn = parcelRequire("4A7Gn");

var $gCbPZ = parcelRequire("gCbPZ");

var $0DTaW = parcelRequire("0DTaW");

parcelRequire("42omo");


var $5dFS9 = parcelRequire("5dFS9");


var $6dP89 = parcelRequire("6dP89");


var $gRazf = parcelRequire("gRazf");


var $aQmDW = parcelRequire("aQmDW");


var $gF7Az = parcelRequire("gF7Az");


var $fJRVo = parcelRequire("fJRVo");


var $5EVbL = parcelRequire("5EVbL");

const $f90153b55c207314$var$CustomTab = ({ index: index, title: title, tabRenderer: tabRenderer })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
        testId: `search-dialog-product-tab-${index}`,
        children: tabRenderer ? tabRenderer({
            title: title
        }) : title
    }, index);
};
const $f90153b55c207314$export$17cd11209ea2ef3e = 'tab-controls';
const $f90153b55c207314$export$bd4c4b880e23a953 = (props)=>{
    const { products: products, showProduct: showProduct, getActiveProduct: getActiveProduct, isExpanded: isExpanded, abTest: abTest } = props;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onTabClicked = (index)=>{
        const id = products[index].id;
        showProduct(products[index].id);
        fireAnalyticsEvent((0, $5dFS9.onTabSelected)({
            tabName: id
        }));
    };
    const activeProductId = getActiveProduct()?.id;
    const activeProductIndex = products.findIndex((product)=>product.id === activeProductId);
    const primaryProduct = products.find((product)=>product.order === 0);
    if (activeProductIndex === -1 && isExpanded && primaryProduct && abTest) {
        showProduct(primaryProduct.id);
        return null;
    }
    if (!isExpanded || products.length === 1 || !abTest || !primaryProduct) return null;
    // Tabs has unwanted flex-basis: 100% set, div wrapper gets around this
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aQmDW.DisableXPSAB), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5EVbL.TabControlsWrapper), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4A7Gn.default), {
                selected: activeProductIndex,
                onChange: onTabClicked,
                id: $f90153b55c207314$export$17cd11209ea2ef3e,
                shouldUnmountTabPanelOnChange: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0DTaW.default), {
                    children: products.map((product, index)=>/*#__PURE__*/ (0, $l998X.jsx)($f90153b55c207314$var$CustomTab, {
                            index: index,
                            title: product.title,
                            tabRenderer: product.tabRenderer
                        }, product.id))
                })
            })
        })
    });
};
const $f90153b55c207314$export$f698db24bc555eee = (0, $gRazf.withABTestContext)((0, $fJRVo.withProductContext)((0, $gF7Az.withDialogExpansionContext)($f90153b55c207314$export$bd4c4b880e23a953)));
module.exports["TAB_ID"] = $f90153b55c207314$export$17cd11209ea2ef3e;
module.exports["ProductTabs"] = $f90153b55c207314$export$f698db24bc555eee;

});

parcelRegister("exgPf", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5tPRL = parcelRequire("5tPRL");

const $f5c3065a125d2f4b$export$958cb3907bb9ede = ({})=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.EnlargedResultContentWrapper), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedIconContainer), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedSkeletonIcon), {})
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedResultTitleContainerSkeleton), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedResultDetailSkeleton), {})
                ]
            })
        ]
    });
};
module.exports["EnlargedSearchResultContentSkeleton"] = $f5c3065a125d2f4b$export$958cb3907bb9ede;

});

parcelRegister("iN7gh", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $lAFHW = parcelRequire("lAFHW");


var $4mZlP = parcelRequire("4mZlP");


var $dDSTM = parcelRequire("dDSTM");


var $8fCWV = parcelRequire("8fCWV");


var $20N1w = parcelRequire("20N1w");

const $abeef2063379c8b4$export$b4bfb1c3ed0cdeca = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const confluenceIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
        appearance: "brand",
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8fCWV.QuickFindAdvancedSearchLink), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                squareReturnIcon: true,
                searchFooterLabel: formatMessage((0, $dDSTM.messages).quick_find_show_filtered_results),
                searchFooterLabelWithIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $dDSTM.messages).quick_find_show_filtered_results_with_icon,
                    values: {
                        confluenceIcon: confluenceIcon
                    }
                }),
                filterByProductFooter: true
            })
        })
    });
};
module.exports["FilterFooter"] = $abeef2063379c8b4$export$b4bfb1c3ed0cdeca;

});

parcelRegister("kf2EW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dDSTM = parcelRequire("dDSTM");


var $kiEGX = parcelRequire("kiEGX");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $8UOsA = parcelRequire("8UOsA");

const $9f20ae4c2debb5df$var$footerContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderColor: 'color.border',
    display: 'flex',
    alignItems: 'center',
    color: 'color.text',
    gap: 'space.150'
});
const $9f20ae4c2debb5df$export$e7b87342306a8337 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $9f20ae4c2debb5df$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $dDSTM.messages).quick_find_footer_text
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kiEGX.default), {
                TriggerComponent: ({ onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $8UOsA.FeedbackButton), {
                        onClick: onClick
                    })
            })
        ]
    });
};
module.exports["FeedbackFooter"] = $9f20ae4c2debb5df$export$e7b87342306a8337;

});

parcelRegister("kTE07", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $a7YLG = parcelRequire("a7YLG");


var $dDSTM = parcelRequire("dDSTM");


var $gtD4K = parcelRequire("gtD4K");


const $25501d5677c22b5e$export$f76aab36aa9d8077 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("iCHOT")));
const $25501d5677c22b5e$export$f16a7ed214a332fa = ({})=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7YLG.EmptyState), {
        Image: $25501d5677c22b5e$export$f76aab36aa9d8077,
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $dDSTM.messages).quick_find_no_content_header
        }),
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $dDSTM.messages).quick_find_no_content_body
        })
    });
};
module.exports["PreQueryEmptyScreen"] = $25501d5677c22b5e$export$f16a7ed214a332fa;

});

parcelRegister("2hOQY", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $dh538 = parcelRequire("dh538");


var $4mZlP = parcelRequire("4mZlP");


var $dDSTM = parcelRequire("dDSTM");


var $8fCWV = parcelRequire("8fCWV");


var $20N1w = parcelRequire("20N1w");

const $7b3b7f54929a6bc9$export$64ded8b71dfcba9e = ({ linkComponent: linkComponent })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8fCWV.QuickFindAdvancedSearchLink), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4mZlP.AdvancedSearchFooter), {
            linkComponent: linkComponent,
            squareReturnIcon: true,
            searchFooterLabel: formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $dDSTM.messages).quick_find_footer_full_page_search_link_appify : (0, $dDSTM.messages).quick_find_footer_full_page_search_link)
        })
    });
};
const $7b3b7f54929a6bc9$export$8784f9fd2cdbbd0a = ({ linkComponent: linkComponent })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($7b3b7f54929a6bc9$export$64ded8b71dfcba9e, {
            linkComponent: linkComponent
        })
    });
};
module.exports["SearchFooter"] = $7b3b7f54929a6bc9$export$64ded8b71dfcba9e;
module.exports["SearchFooterPersistRecentSearch"] = $7b3b7f54929a6bc9$export$8784f9fd2cdbbd0a;

});

parcelRegister("hyKIh", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $3HOqx = parcelRequire("3HOqx");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $5tPRL = parcelRequire("5tPRL");


var $1qfLF = parcelRequire("1qfLF");


var $dDSTM = parcelRequire("dDSTM");


var $hAh3S = parcelRequire("hAh3S");


var $aDRXf = parcelRequire("aDRXf");


var $hmuev = parcelRequire("hmuev");

const $d0c603ac0340e923$var$RovoTipMessageStyle = (0, $ecnYn.xcss)({
    width: '95%',
    marginLeft: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050'
});
const $d0c603ac0340e923$var$RovoTipContainerStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $d0c603ac0340e923$var$RovoTipStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: '40px',
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    borderRadius: "var(--ds-radius-small, 4px)",
    backgroundColor: 'color.background.accent.purple.subtlest',
    color: 'color.text.accent.purple'
});
const $d0c603ac0340e923$export$719e67cc0251dc18 = ()=>{
    const { showRovoTip: showRovoTip, dismissRovoTip: dismissRovoTip } = (0, $hAh3S.useQuickFindRovoTip)();
    const { focusInput: focusInput } = (0, $aDRXf.useInputContext)();
    if (!showRovoTip) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $d0c603ac0340e923$var$RovoTipContainerStyle,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $d0c603ac0340e923$var$RovoTipStyle,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                    label: "blank",
                    color: "var(--ds-text-accent-purple, #5E4DB2)"
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                    xcss: $d0c603ac0340e923$var$RovoTipMessageStyle,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("b", {
                            children: "Rovo tip:"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $dDSTM.messages).quick_find_rovo_tip
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                        spacing: 'compact',
                        onClick: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            dismissRovoTip();
                            focusInput && focusInput();
                        },
                        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $dDSTM.messages).remove_button_label
                        }),
                        appearance: 'subtle'
                    })
                })
            ]
        })
    });
};
module.exports["QuickFindRovoTip"] = $d0c603ac0340e923$export$719e67cc0251dc18;

});

parcelRegister("bySHO", function(module, exports) {

var $iBckn = parcelRequire("iBckn");


var $2ZIpG = parcelRequire("2ZIpG");

const $e72227bd0175ccc2$export$eb528a71db3ec636 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const filteredPreQuerySections = query ? preQueryItems.sections : preQueryItems.sections.filter((section)=>section.id !== (0, $iBckn.RECENT_SPACES_SECTION_ID));
    const filteredPreQueryItems = {
        sections: filteredPreQuerySections,
        size: filteredPreQuerySections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0)
    };
    return children({
        preQueryItems: filteredPreQueryItems,
        postQueryItems: postQueryItems,
        productState: productState
    });
};
module.exports["PreQueryFilterTransformer"] = $e72227bd0175ccc2$export$eb528a71db3ec636;

});

parcelRegister("lqMdf", function(module, exports) {

var $gmMgo = parcelRequire("gmMgo");


var $dDSTM = parcelRequire("dDSTM");


var $3q90y = parcelRequire("3q90y");

const $8c058a58127c6526$export$8d431b8c84c2735b = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const newPreQueryItemsSections = preQueryItems.sections.map((section, i)=>{
        if (section.id === (0, $3q90y.RECENT_SEARCHES_SECTION_ID) || section.searchResults.length === 0) return section;
        else {
            const newSection = {
                ...section,
                title: intl.formatMessage((0, $dDSTM.messages).quick_find_recently_viewed)
            };
            return newSection;
        }
    });
    preQueryItems.sections = newPreQueryItemsSections;
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItems,
        productState: productState
    });
};
const $8c058a58127c6526$export$4cf1eef5109c47c9 = (0, $gmMgo.default)($8c058a58127c6526$export$8d431b8c84c2735b);
module.exports["PreQueryRecentlyViewedTransformer"] = $8c058a58127c6526$export$4cf1eef5109c47c9;

});

parcelRegister("7mejp", function(module, exports) {

var $3q90y = parcelRequire("3q90y");

const $217415c35164e8dc$export$2142bc2fa441a5b0 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const recentSearchesSection = (0, $3q90y.useRecentSearchesSection)();
    const preQueryItemsWithRecentSearches = {
        sections: [
            recentSearchesSection,
            ...preQueryItems.sections
        ],
        size: preQueryItems.size
    };
    return children({
        preQueryItems: preQueryItemsWithRecentSearches,
        postQueryItems: postQueryItems,
        productState: productState
    });
};
module.exports["RecentSearchesTransformer"] = $217415c35164e8dc$export$2142bc2fa441a5b0;

});

parcelRegister("791Lz", function(module, exports) {

var $2ZIpG = parcelRequire("2ZIpG");


var $74Udv = parcelRequire("74Udv");

const $a2f4de094cafd3d0$var$RECENTLY_VIEWED_ITEMS_SHOWN = 10;
const $a2f4de094cafd3d0$export$308bb2328bfeb2be = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const filteredPreQueryItems = (0, $74Udv.filterAllSectionItems)({
        sections: preQueryItems.sections,
        size: preQueryItems.size
    }, query, $a2f4de094cafd3d0$var$RECENTLY_VIEWED_ITEMS_SHOWN);
    const highlightedPostQueryItems = (0, $74Udv.highlightPostQueryResultTitles)(postQueryItems, query);
    return children({
        preQueryItems: filteredPreQueryItems,
        postQueryItems: highlightedPostQueryItems,
        productState: productState
    });
};
module.exports["QueryFilterTransformer"] = $a2f4de094cafd3d0$export$308bb2328bfeb2be;

});

parcelRegister("2IGSl", function(module, exports) {

var $gmMgo = parcelRequire("gmMgo");


var $jFPud = parcelRequire("jFPud");


var $dDSTM = parcelRequire("dDSTM");


var $3q90y = parcelRequire("3q90y");

const $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN = 5;
/**
 * This transformer assumes that preQueryItems contains recently viewed search
 * results and adds them to the postQueryItems.
 */ const $9788089c1dc93380$var$PostQueryRecentlyViewedTransformerWithIntl = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    // Create an array of recently viewed sections. These sections exclude recent
    // searches and have a combined result limit of 10.
    let recentlyViewedCount = 0;
    const recentlyViewedSections = preQueryItems.sections.filter((section)=>section.id !== (0, $3q90y.RECENT_SEARCHES_SECTION_ID)).filter((section)=>section.searchResults.length > 0).map((section, i)=>{
        const newSection = {
            ...section,
            resultLimit: Math.min(section.searchResults.length, $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN - recentlyViewedCount),
            title: i === 0 ? intl.formatMessage((0, $dDSTM.messages).quick_find_recently_viewed) : ''
        };
        recentlyViewedCount = Math.min(recentlyViewedCount + section.searchResults.length, $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN);
        return newSection;
    });
    // Add recent searches to the end of postQueryItems after post query returns
    const recentSearchesSection = preQueryItems.sections.find((section)=>section.id === (0, $3q90y.RECENT_SEARCHES_SECTION_ID));
    const postQueryItemsSectionsWithRecentSearches = recentSearchesSection && productState === (0, $jFPud.ProductStates).PostQuerySuccess ? [
        ...postQueryItems.sections,
        recentSearchesSection
    ] : [
        ...postQueryItems.sections
    ];
    // Create the new postQueryItems object
    const postQueryItemsWithRecentlyViewed = {
        size: [
            ...recentlyViewedSections,
            ...postQueryItems.sections
        ].map((section)=>section.searchResults.length).reduce((a, b)=>a + b, 0),
        sections: [
            ...recentlyViewedSections,
            ...postQueryItemsSectionsWithRecentSearches
        ]
    };
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItemsWithRecentlyViewed,
        productState: productState
    });
};
const $9788089c1dc93380$export$1607c6754b1f6fc5 = (0, $gmMgo.default)($9788089c1dc93380$var$PostQueryRecentlyViewedTransformerWithIntl);
module.exports["PostQueryRecentlyViewedTransformer"] = $9788089c1dc93380$export$1607c6754b1f6fc5;

});

parcelRegister("a57V3", function(module, exports) {

var $iBckn = parcelRequire("iBckn");

const $3a919f723ec8ca9b$var$MAX_RENDERED_SEARCH_RESULTS = 5;
const $3a919f723ec8ca9b$export$91b234728c3a1640 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const searchResults = postQueryItems.sections.find((section)=>section.id === (0, $iBckn.CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID))?.searchResults || [];
    const recentlyViewedResults = postQueryItems.sections.find((section)=>section.id === (0, $iBckn.RECENT_ITEMS_SECTION_ID))?.searchResults || [];
    const dedupedSearchResults = searchResults.filter((searchResult)=>{
        // Check for duplicates using ARIs
        const isDuplicate = recentlyViewedResults.some((recentlyViewedResult)=>recentlyViewedResult.ari === searchResult.ari);
        return searchResult.ari && !isDuplicate;
    });
    const postDeduplication = {
        ...postQueryItems,
        sections: postQueryItems.sections.map((section)=>{
            if (section.id === (0, $iBckn.CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID)) return {
                ...section,
                searchResults: dedupedSearchResults.slice(0, $3a919f723ec8ca9b$var$MAX_RENDERED_SEARCH_RESULTS)
            };
            return section;
        })
    };
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postDeduplication,
        productState: productState
    });
};
module.exports["DeduplicateRecentlyViewedAndResultsTransformer"] = $3a919f723ec8ca9b$export$91b234728c3a1640;

});

parcelRegister("DuEDb", function(module, exports) {
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $a2dru = parcelRequire("a2dru");


var $dlSEv = parcelRequire("dlSEv");


var $dhNqt = parcelRequire("dhNqt");


var $6gF1I = parcelRequire("6gF1I");


var $5mJ0F = parcelRequire("5mJ0F");

var $Lyrmh = parcelRequire("Lyrmh");

var $4c50cd29395d06d1$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $4c50cd29395d06d1$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
function $4c50cd29395d06d1$export$e873c799b137eec4(date) {
    return (0, $dlSEv.default)(new Date(date), $4c50cd29395d06d1$var$startOfOneWeekAgo());
}
function $4c50cd29395d06d1$var$startOfOneWeekAgo() {
    return (0, $dhNqt.default)((0, $6gF1I.default)(new Date(), 1));
}
const $4c50cd29395d06d1$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData = true })=>{
    const isAbsolute = $4c50cd29395d06d1$export$e873c799b137eec4(timestamp);
    const message = (0, $Lyrmh.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...message,
        values: values
    });
};
module.exports["WORKED_EVENT"] = $4c50cd29395d06d1$export$eb4e9f525aef1cc3;
module.exports["EventTypeMessage"] = $4c50cd29395d06d1$export$9e4fb3fb50a3c754;

});

parcelRegister("8PrAH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $2qVkt = parcelRequire("2qVkt");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $5tmwS = parcelRequire("5tmwS");


var $1yB28 = parcelRequire("1yB28");


var $6B0jU = parcelRequire("6B0jU");


var $8jHAi = parcelRequire("8jHAi");


var $jfyuR = parcelRequire("jfyuR");


var $lE8sM = parcelRequire("lE8sM");

const $3b53752b63a8cd2e$var$negativeMarginStyles = (0, $ecnYn.xcss)({
    margin: 'space.negative.025',
    display: 'flex'
});
const $3b53752b63a8cd2e$var$iconTypes = {
    ATLAS: 'atlas',
    ATTACHMENT: 'attachment',
    BLOGPOST: 'blogpost',
    COMMENT: 'comment',
    CONTENT: 'content',
    CONFLUENCEBLOGPOST: 'confluence-blogpost',
    CONFLUENCEPAGE: 'confluence-page',
    DATABASE: 'database',
    FOLDER: 'folder',
    JIRA: 'jira',
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $3b53752b63a8cd2e$var$iconStyles = {
    BLUE: 'blue',
    GRAY: 'gray',
    PURPLE: 'purple',
    SHAPE: 'square',
    SIZE: '24',
    TEAL: 'teal',
    YELLOW: 'yellow'
};
const $3b53752b63a8cd2e$export$bf56fa242f0fc37d = ({ type: type, imageSrc: imageSrc, title: title, isDraft: isDraft = false })=>{
    // CONFLUENCE
    if (type === $3b53752b63a8cd2e$var$iconTypes.PAGE || type === $3b53752b63a8cd2e$var$iconTypes.CONFLUENCEPAGE || type === $3b53752b63a8cd2e$var$iconTypes.CONTENT) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: type,
        appearance: isDraft ? $3b53752b63a8cd2e$var$iconStyles.GRAY : $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.BLOGPOST || type === $3b53752b63a8cd2e$var$iconTypes.CONFLUENCEBLOGPOST) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.DATABASE) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.PURPLE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.FOLDER) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.WHITEBOARD) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.TEAL,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.COMMENT) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.YELLOW,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.ATTACHMENT) // TODO: Clarify if the attachment icon should be changed
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jfyuR.AttachmentIcon), {
        title: title || '',
        size: "medium",
        label: type
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.ATLAS) return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        width: "24px",
        height: "24px",
        src: imageSrc || '',
        "aria-label": type,
        alt: type
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.JIRA) // TODO: Clarify the decision made for jira icons
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {});
};
const $3b53752b63a8cd2e$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $3b53752b63a8cd2e$var$negativeMarginStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        })
    });
module.exports["ContentIconRenderer"] = $3b53752b63a8cd2e$export$bf56fa242f0fc37d;
module.exports["GenericIconRenderer"] = $3b53752b63a8cd2e$export$e5d849fb708254a9;

});

parcelRegister("kOyOy", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $j7mwp = parcelRequire("j7mwp");


var $cStGJ = parcelRequire("cStGJ");

function $a454b160acdd3a63$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a454b160acdd3a63$var$ConfluenceResultMetaWrapper = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e10xva5d1"
})({
    name: "fhxb3m",
    styles: "display:flex;flex-direction:row;align-items:center"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a454b160acdd3a63$var$ConfluenceTypeWrapper = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e10xva5d0"
})({
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`
});
const $a454b160acdd3a63$var$BreadCrumbs = ({ breadCrumbs: breadCrumbs = [] })=>{
    if (breadCrumbs.length === 0) return null;
    // only allow 2 breadcrumbs
    // take the first and the last (if different)
    let twoBreadcrumbs = [];
    if (breadCrumbs.length > 2) twoBreadcrumbs = [
        breadCrumbs[0],
        breadCrumbs[breadCrumbs.length - 1]
    ];
    else twoBreadcrumbs = breadCrumbs;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        separator: "/",
        space: "space.100",
        children: twoBreadcrumbs.map(({ id: id, title: title }, i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtle",
                size: "small",
                children: title
            }, id))
    });
};
const $a454b160acdd3a63$export$9138e703d4b4585b = ({ resultContentType: resultContentType, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
    const breadcrumbs = $a454b160acdd3a63$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
    return /*#__PURE__*/ (0, $l998X.jsxs)($a454b160acdd3a63$var$ConfluenceResultMetaWrapper, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($a454b160acdd3a63$var$ConfluenceTypeWrapper, {
                children: "Confluence"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j7mwp.SpacerWrapper), {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($a454b160acdd3a63$var$ConfluenceTypeWrapper, {
                children: `${(0, $j7mwp.capitalizeFirstLetter)(resultContentType)}`
            }),
            breadcrumbs?.length && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $j7mwp.SpacerWrapper), {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($a454b160acdd3a63$var$BreadCrumbs, {
                        breadCrumbs: breadcrumbs
                    })
                ]
            })
        ]
    });
};
const $a454b160acdd3a63$export$ed9f69ac7e699c53 = (ancestors, space)=>{
    let breadcrumbs = [];
    if (space) {
        const spaceBreadcrumb = {
            id: space?.id,
            title: space?.name
        };
        if (!ancestors || ancestors.length === 0) breadcrumbs = [
            spaceBreadcrumb
        ];
        else if (ancestors.length >= 1) // The first ancestor is a root node that shouldn't be rendered
        breadcrumbs = [
            spaceBreadcrumb,
            ...ancestors.slice(1)
        ];
    }
    // Filter out invalid breadcrumbs
    return breadcrumbs.filter((breadCrumb)=>breadCrumb.id && breadCrumb.title);
};
module.exports["ConfluenceResultMeta"] = $a454b160acdd3a63$export$9138e703d4b4585b;

});

parcelRegister("j7mwp", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $68686fedcc1e2524$var$ResultMetaWrapper = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "eflzzry1"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`
});
const $68686fedcc1e2524$export$b05a2e78ddf8915e = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "eflzzry0"
})({
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`,
    margin: `0px ${"var(--ds-space-100, 8px)"}`
});
function $68686fedcc1e2524$export$d07f57595c356899(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
const $68686fedcc1e2524$export$73e5ecb29f7bf6e9 = ({ meta: meta })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($68686fedcc1e2524$var$ResultMetaWrapper, {
        children: meta.filter((metaItem)=>metaItem !== null && metaItem !== undefined).map((metaItem, index)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    metaItem,
                    index !== meta.length - 1 && /*#__PURE__*/ (0, $l998X.jsx)($68686fedcc1e2524$export$b05a2e78ddf8915e, {
                        children: "\u2022"
                    })
                ]
            }))
    });
};
module.exports["SpacerWrapper"] = $68686fedcc1e2524$export$b05a2e78ddf8915e;
module.exports["capitalizeFirstLetter"] = $68686fedcc1e2524$export$d07f57595c356899;
module.exports["QuickFindResultMeta"] = $68686fedcc1e2524$export$73e5ecb29f7bf6e9;

});

parcelRegister("lNtmT", function(module, exports) {
const $35f4e8be421d896f$export$6d8886e8d5cdbeec = (id, type)=>{
    switch(type){
        case 'page':
            return id.split(':page/')[1];
        case 'blogpost':
            return id.split(':blogpost/')[1];
        case 'attachment':
            return id.split(':attachment/')[1];
        case 'space':
            return id.split(':space/')[1];
        case 'whiteboard':
            return id.split(':whiteboard/')[1];
        case 'embed':
            // embed ari url contains activation id so we split it differently here
            const embedAri = id.split('/');
            return embedAri[embedAri.length - 1];
        case 'database':
            // Databases ari url contains activation id so we split it differently here
            const databaseAri = id.split('/');
            return databaseAri[databaseAri.length - 1];
        default:
            return id;
    }
};
module.exports["transformAriToId"] = $35f4e8be421d896f$export$6d8886e8d5cdbeec;

});

parcelRegister("UNGcJ", function(module, exports) {

var $aU479 = parcelRequire("aU479");


var $7H6GR = parcelRequire("7H6GR");

const $bced069a163eb3f4$export$f9c120c22694d7aa = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics, resultId: resultId, addQueryParams: addQueryParams, addQuery: addQuery, type: type })=>{
    const isConfluenceContent = typeof resultId === 'string' && resultId.includes('confluence') || typeof type === 'string' && [
        'confluence page',
        'confluence blogpost',
        'confluence space',
        'confluence attachment',
        'confluence whiteboard'
    ].some((contentType)=>contentType.includes(type));
    const hasAdditionalAnalytics = typeof additionalAnalytics === 'object' && Object.keys(additionalAnalytics).length > 0;
    if (!isConfluenceContent || !(query || hasAdditionalAnalytics)) return addQuery(url, 'search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${(0, $7H6GR.valueSeparator)}${(0, $aU479.hashData)(query)}`);
    if (hasAdditionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${(0, $7H6GR.valueSeparator)}${value}`);
    });
    if (events.length === 0) return addQuery(url, 'search_id', searchSessionId);
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join((0, $7H6GR.attributeSeparator)));
    return addQueryParams(url, {
        search_id: searchSessionId,
        additional_analytics: analyticsFormattedForUrlParsing
    });
};
module.exports["transformAnalyticsToQueryParam"] = $bced069a163eb3f4$export$f9c120c22694d7aa;

});

parcelRegister("7prbm", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6dP89 = parcelRequire("6dP89");


var $5dFS9 = parcelRequire("5dFS9");

const $cd5e177fbad53fb4$export$5a31ea5680c95894 = ({ children: children, product: product })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        const start = Date.now();
        return ()=>{
            fireAnalyticsEvent((0, $5dFS9.onPaneLoadComplete)(product, Date.now() - start));
        };
    }, [
        fireAnalyticsEvent,
        product
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["TimeLazyLoad"] = $cd5e177fbad53fb4$export$5a31ea5680c95894;

});

parcelRegister("cpIJW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gRazf = parcelRequire("gRazf");


var $fJRVo = parcelRequire("fJRVo");


var $jAnRi = parcelRequire("jAnRi");

const $fe5a5ea44cc052c2$export$7f8c86254a9e879c = ({ id: id, abTest: abTest, getPrimaryProduct: getPrimaryProduct })=>{
    const [successCalled, setSuccessCalled] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (successCalled) return;
        const primaryProduct = getPrimaryProduct();
        if (abTest && primaryProduct && primaryProduct.id === id) {
            (0, $jAnRi.initialisationExperience).success();
            setSuccessCalled(true);
        }
    }, [
        abTest,
        getPrimaryProduct,
        id,
        successCalled
    ]);
    return null;
};
const $fe5a5ea44cc052c2$export$12ba87fc0c8ef4e3 = (0, $gRazf.withABTestContext)((0, $fJRVo.withProductContext)($fe5a5ea44cc052c2$export$7f8c86254a9e879c));
module.exports["InitialisationExperienceSuccess"] = $fe5a5ea44cc052c2$export$12ba87fc0c8ef4e3;

});

parcelRegister("gJKpQ", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
const $79cbd4001c087560$export$2bde439437c11152 = 'product-search-dialog';
module.exports["PLACEHOLDER_EXPERIENCE"] = $79cbd4001c087560$export$2bde439437c11152;

});

parcelRegister("e0qNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e48ac6f5e264642a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fJRVo = parcelRequire("fJRVo");

const $e48ac6f5e264642a$export$90be722c085777fe = ({ addProduct: addProduct, showProduct: showProduct, updateProduct: updateProduct, id: id, title: title, children: children, allowedSections: allowedSections, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter, invokePostQuerySearchRef: invokePostQuerySearchRef })=>{
    const [originalId] = (0, $42omo.useState)(id);
    const [registeredProduct, setRegisteredProduct] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (allowedSections.length > 0) {
            const allowedSectionString = allowedSections.join(' ');
            const allowedRegisteredSections = sections.map((sec)=>sec.id).filter((sectionId)=>{
                const sectionIds = sectionId.replace(id, '').replace('.', '').split(',');
                let allowed = true;
                sectionIds.forEach((section)=>{
                    if (allowedSectionString.indexOf(section) === -1) allowed = false;
                });
                return allowed;
            });
            if (allowedRegisteredSections.length > 0) {
                addProduct({
                    id: id,
                    title: title,
                    sectionIds: sections.map((sec)=>sec.id),
                    order: order,
                    generateAdvancedSearchUrl: generateAdvancedSearchUrl,
                    expandedStateInputPlaceholder: expandedStateInputPlaceholder,
                    workspaces: workspaces,
                    autocorrectEnabled: autocorrectEnabled,
                    showViewAllFiltersLink: showViewAllFiltersLink,
                    tabRenderer: tabRenderer,
                    aiSearchConfig: aiSearchConfig,
                    showSearchOnEnter: showSearchOnEnter,
                    invokePostQuerySearchRef: invokePostQuerySearchRef
                });
                setRegisteredProduct(true);
            }
        }
    /**
		 * Updating of state is a side effect. We want it to happen in component did mount stage. Hence replicating this behaviour.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!registeredProduct) return;
        if (id !== originalId) {
            // eslint-disable-next-line no-console
            console.error("product-search-dialog: Cannot update a different product's properties. Did you change accidentally change a product's id?");
            return;
        }
        updateProduct({
            id: id,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            tabRenderer: tabRenderer
        });
    }, [
        registeredProduct,
        id,
        originalId,
        updateProduct,
        generateAdvancedSearchUrl,
        tabRenderer
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
var $e48ac6f5e264642a$export$2e2bcd8739ae039 = (0, $fJRVo.withProductContext)($e48ac6f5e264642a$export$90be722c085777fe);

});

parcelRegister("gRazf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hpDfc = parcelRequire("hpDfc");


var $91yhh = parcelRequire("91yhh");

const $64a4585da9ac3d3b$export$22966a5ebf51ce99 = {
    abTestId: 'default',
    controlId: 'default',
    experimentId: 'default'
};
const $64a4585da9ac3d3b$var$ABTestContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    abTest: null
});
const $64a4585da9ac3d3b$var$ABTestContextProviderStateless = ({ children: children })=>{
    const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, $91yhh.useExperiments)();
    const [abTest] = (0, $42omo.useState)(()=>{
        return backendExperiment || $64a4585da9ac3d3b$export$22966a5ebf51ce99;
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($64a4585da9ac3d3b$var$ABTestContext.Provider, {
        value: {
            abTest: abTest
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {
                abTest: abTest || undefined,
                frontendExperiments: {
                    activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                    ...frontendExperiments
                }
            },
            nonPrivacySafeAnalyticContext: {},
            children: children
        })
    });
};
const $64a4585da9ac3d3b$export$e7d53dc13567ec0e = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($64a4585da9ac3d3b$var$ABTestContextProviderStateless, {
        ...props
    });
const $64a4585da9ac3d3b$export$14279a3fbdb52451 = ()=>{
    const { abTest: abTest } = (0, $42omo.useContext)($64a4585da9ac3d3b$var$ABTestContext);
    return abTest;
};
const $64a4585da9ac3d3b$export$5124bc23083a567d = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            ...(0, $42omo.useContext)($64a4585da9ac3d3b$var$ABTestContext)
        });
};
module.exports["ABTestContextProvider"] = $64a4585da9ac3d3b$export$e7d53dc13567ec0e;
module.exports["useABTest"] = $64a4585da9ac3d3b$export$14279a3fbdb52451;
module.exports["withABTestContext"] = $64a4585da9ac3d3b$export$5124bc23083a567d;

});

parcelRegister("aQmDW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gRazf = parcelRequire("gRazf");

const $fdf090eb866a7114$export$67fbd6b459867ac2 = ({ children: children })=>{
    const abTest = (0, $gRazf.useABTest)();
    if (abTest?.experimentId === 'xps-hidden') // This experiment is a permanent FE experiment inside aggregator.
    return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["DisableXPSAB"] = $fdf090eb866a7114$export$67fbd6b459867ac2;

});

parcelRegister("5EVbL", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $cStGJ = parcelRequire("cStGJ");

const $d8c356d6f37fe7d8$export$f26b9facc67e59ba = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "et5m3c0"
})({
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"}`
});
module.exports["TabControlsWrapper"] = $d8c356d6f37fe7d8$export$f26b9facc67e59ba;

});

parcelRegister("8fCWV", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");


var $cStGJ = parcelRequire("cStGJ");

const $d9eaece468643009$export$a10ba81e8e8d140 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e58cvu60"
})({
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`,
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span > a': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    }
});
module.exports["QuickFindAdvancedSearchLink"] = $d9eaece468643009$export$a10ba81e8e8d140;

});

parcelRegister("hAh3S", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4SPhZ = parcelRequire("4SPhZ");


var $iEwUU = parcelRequire("iEwUU");


var $fJRVo = parcelRequire("fJRVo");

const $de41115665781d7f$export$ccc3a6663aee8d48 = ()=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const [showRovoTip, setShowRovoTip] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        if (!product) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.getRovoTip)(product.id, user?.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        user.id,
        product
    ]);
    const dismissRovoTip = (0, $42omo.useCallback)(()=>{
        if (product?.id) {
            const rovoTipFromLocalStorage = (0, $4SPhZ.setRovoTip)(product.id, user?.id);
            setShowRovoTip(rovoTipFromLocalStorage);
        }
    }, [
        user.id,
        product
    ]);
    return {
        showRovoTip: showRovoTip,
        dismissRovoTip: dismissRovoTip
    };
};
module.exports["useQuickFindRovoTip"] = $de41115665781d7f$export$ccc3a6663aee8d48;

});

parcelRegister("jfyuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dlbUV = parcelRequire("dlbUV");


var $fX9Sa = parcelRequire("fX9Sa");


var $d4cCP = parcelRequire("d4cCP");


var $gguok = parcelRequire("gguok");


var $d8Kpd = parcelRequire("d8Kpd");


var $gH8Rx = parcelRequire("gH8Rx");


var $8DZd1 = parcelRequire("8DZd1");


var $djgQ6 = parcelRequire("djgQ6");


var $d5BUD = parcelRequire("d5BUD");


var $b4DX7 = parcelRequire("b4DX7");


var $41GKb = parcelRequire("41GKb");


var $20uDq = parcelRequire("20uDq");


var $11LZV = parcelRequire("11LZV");


var $lzyQK = parcelRequire("lzyQK");


var $hY1Uy = parcelRequire("hY1Uy");


var $dfQbH = parcelRequire("dfQbH");


var $1iV2p = parcelRequire("1iV2p");


var $7t8Pn = parcelRequire("7t8Pn");


var $ayTrS = parcelRequire("ayTrS");


var $hXc8o = parcelRequire("hXc8o");


var $90Icb = parcelRequire("90Icb");


var $lkBga = parcelRequire("lkBga");

const $6488faa431f4e155$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d5BUD))),
            (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
            (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
            (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
        ]
    }
];
const $6488faa431f4e155$var$getIconArray = (title)=>{
    const extension = $6488faa431f4e155$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
        const matches = extensionMatcher.regexp.exec(title);
        return matches && matches.length > 0;
    });
    if (extension) return extension.icon;
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ];
};
const $6488faa431f4e155$export$ebe2a8421106a1ee = {
    small: 0,
    medium: 1
};
const $6488faa431f4e155$export$edc04f92718bbea4 = ({ title: title, label: label, size: size })=>{
    const iconArray = $6488faa431f4e155$var$getIconArray(title);
    const sizeIndex = $6488faa431f4e155$export$ebe2a8421106a1ee[size];
    const icon = iconArray[sizeIndex];
    return /*#__PURE__*/ (0, $42omo.createElement)(icon, {
        label: label,
        testId: icon.name
    });
};
module.exports["AttachmentIcon"] = $6488faa431f4e155$export$edc04f92718bbea4;

});


//# sourceMappingURL=PageLayout.59a02820.js.map
